var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// src/actions/index.ts
import { makeActionCreator } from "@lls/utils";
var actionTypes, deleteEntity, updateEntity, setEntity, setEntities, setAuth, resetAuth, setLoadingScreen, setModal, addNotification, removeNotification, setShownContextualActions, setIsDrawerOpen, setIsViewerReady, setDrawerExpandedId, setIsOpenSaveModal, setCurrentTourId, setCurrentTourStep, resetTour, setIsTourPanelOpen, setTourPanelMode, setScenarioId, setIsStudentViewActivated, setSsrFakePageId;
var init_actions = __esm({
  "src/actions/index.ts"() {
    "use strict";
    actionTypes = {
      DELETE_ENTITY: "DELETE_ENTITY",
      UPDATE_ENTITY: "UPDATE_ENTITY",
      SET_ENTITY: "SET_ENTITY",
      SET_ENTITIES: "SET_ENTITIES",
      RESET_AUTH: "RESET_AUTH",
      SET_AUTH: "SET_AUTH",
      SET_LOADING_SCREEN: "SET_LOADING_SCREEN",
      SET_MODAL: "SET_MODAL",
      ADD_NOTIFICATION: "ADD_NOTIFICATION",
      REMOVE_NOTIFICATION: "REMOVE_NOTIFICATION",
      SET_SHOWN_CONTEXTUAL_ACTIONS: "SET_SHOW_CONTEXTUAL_ACTIONS",
      SET_IS_DRAWER_OPEN: "SET_IS_DRAWER_OPEN",
      SET_DRAWER_EXPANDED_ID: "SET_DRAWER_EXPANDED_ID",
      SET_IS_OPEN_SAVE_MODAL: "SET_IS_OPEN_SAVE_MODAL",
      SET_IS_VIEWER_READY: "SET_IS_VIEWER_READY",
      SET_CURRENT_TOUR_ID: "SET_CURRENT_TOUR_ID",
      SET_CURRENT_TOUR_STEP: "SET_CURRENT_TOUR_STEP",
      RESET_TOUR: "RESET_TOUR",
      SET_IS_TOUR_PANEL_OPEN: "SET_IS_TOUR_PANEL_OPEN",
      SET_TOUR_PANEL_MODE: "SET_TOUR_PANEL_MODE",
      SET_IS_STUDENT_VIEW_ACTIVATED: "SET_IS_STUDENT_VIEW_ACTIVATED",
      SET_SCENARIO_ID: "SET_SCENARIO_ID",
      SET_SSR_FAKE_PAGE_ID: "SET_SSR_FAKE_PAGE_ID"
    };
    deleteEntity = makeActionCreator(actionTypes.DELETE_ENTITY);
    updateEntity = makeActionCreator(actionTypes.UPDATE_ENTITY);
    setEntity = makeActionCreator(actionTypes.SET_ENTITY);
    setEntities = makeActionCreator(actionTypes.SET_ENTITIES);
    setAuth = makeActionCreator(actionTypes.SET_AUTH);
    resetAuth = makeActionCreator(actionTypes.RESET_AUTH);
    setLoadingScreen = makeActionCreator(actionTypes.SET_LOADING_SCREEN);
    setModal = makeActionCreator(actionTypes.SET_MODAL);
    addNotification = makeActionCreator(actionTypes.ADD_NOTIFICATION);
    removeNotification = makeActionCreator(actionTypes.REMOVE_NOTIFICATION);
    setShownContextualActions = makeActionCreator(actionTypes.SET_SHOWN_CONTEXTUAL_ACTIONS);
    setIsDrawerOpen = makeActionCreator(actionTypes.SET_IS_DRAWER_OPEN);
    setIsViewerReady = makeActionCreator(actionTypes.SET_IS_VIEWER_READY);
    setDrawerExpandedId = makeActionCreator(actionTypes.SET_DRAWER_EXPANDED_ID);
    setIsOpenSaveModal = makeActionCreator(actionTypes.SET_IS_OPEN_SAVE_MODAL);
    setCurrentTourId = makeActionCreator(actionTypes.SET_CURRENT_TOUR_ID);
    setCurrentTourStep = makeActionCreator(actionTypes.SET_CURRENT_TOUR_STEP);
    resetTour = makeActionCreator(actionTypes.RESET_TOUR);
    setIsTourPanelOpen = makeActionCreator(actionTypes.SET_IS_TOUR_PANEL_OPEN);
    setTourPanelMode = makeActionCreator(actionTypes.SET_TOUR_PANEL_MODE);
    setScenarioId = makeActionCreator(actionTypes.SET_SCENARIO_ID);
    setIsStudentViewActivated = makeActionCreator(actionTypes.SET_IS_STUDENT_VIEW_ACTIVATED);
    setSsrFakePageId = makeActionCreator(actionTypes.SET_SSR_FAKE_PAGE_ID);
  }
});

// src/store/loading.ts
import { makeReducer } from "@lls/utils";
import _ from "lodash/fp.js";
var setLoadingReducer, loading, loading_default;
var init_loading = __esm({
  "src/store/loading.ts"() {
    "use strict";
    init_actions();
    setLoadingReducer = _.assign;
    loading = makeReducer(
      {},
      {
        [actionTypes.SET_LOADING_SCREEN]: setLoadingReducer
      }
    );
    loading_default = loading;
  }
});

// src/store/modals.js
import { makeReducer as makeReducer2 } from "@lls/utils";
var setModalReducer, modals, modals_default;
var init_modals = __esm({
  "src/store/modals.js"() {
    "use strict";
    init_actions();
    setModalReducer = (_state, { name, open, data, fullScreen, preventClosing } = {}) => ({
      [name]: { name, open, data, fullScreen, preventClosing }
    });
    modals = makeReducer2(
      {},
      {
        [actionTypes.SET_MODAL]: setModalReducer
      }
    );
    modals_default = modals;
  }
});

// src/store/notifications.js
import { makeReducer as makeReducer3 } from "@lls/utils";
import _2 from "lodash/fp.js";
var initialState, addNotificationReducer, removeNotificationReducer, notifications, notifications_default;
var init_notifications = __esm({
  "src/store/notifications.js"() {
    "use strict";
    init_actions();
    initialState = [];
    addNotificationReducer = (state, notification) => [...state, notification];
    removeNotificationReducer = (state, notification = {}) => _2.reject({ name: _2.get("name", notification) }, state);
    notifications = makeReducer3(initialState, {
      [actionTypes.ADD_NOTIFICATION]: addNotificationReducer,
      [actionTypes.REMOVE_NOTIFICATION]: removeNotificationReducer
    });
    notifications_default = notifications;
  }
});

// src/store/ssr.js
import _3 from "lodash/fp.js";
import { makeReducer as makeReducer4 } from "@lls/utils";
var initialState2, setSsrFakePageIdReducer, ui, ssr_default;
var init_ssr = __esm({
  "src/store/ssr.js"() {
    "use strict";
    init_actions();
    initialState2 = {
      fakePageId: false
    };
    setSsrFakePageIdReducer = (state, value) => _3.set("fakePageId", value, state);
    ui = makeReducer4(initialState2, {
      [actionTypes.SET_SSR_FAKE_PAGE_ID]: setSsrFakePageIdReducer
    });
    ssr_default = ui;
  }
});

// src/store/tour.ts
import { makeReducer as makeReducer5 } from "@lls/utils";
var initialState3, setCurrentTourIdReducer, setCurrentTourStepReducer, resetTourReducer, setIsTourPanelOpenReducer, setTourPanelModeReducer, setScenarioIdReducer, tour, tour_default;
var init_tour = __esm({
  "src/store/tour.ts"() {
    "use strict";
    init_actions();
    initialState3 = {
      tourId: null,
      tourStep: 0,
      isTourPanelOpen: true,
      tourPanelMode: "classic",
      scenarioId: null
    };
    setCurrentTourIdReducer = (state, tourId) => ({ ...state, tourId });
    setCurrentTourStepReducer = (state, tourStep) => ({ ...state, tourStep });
    resetTourReducer = ({ scenarioId }) => ({ ...initialState3, scenarioId });
    setIsTourPanelOpenReducer = (state, isTourPanelOpen) => ({
      ...state,
      isTourPanelOpen
    });
    setTourPanelModeReducer = (state, tourPanelMode) => ({ ...state, tourPanelMode });
    setScenarioIdReducer = (state, scenarioId) => ({ ...state, scenarioId });
    tour = makeReducer5(initialState3, {
      [actionTypes.SET_CURRENT_TOUR_ID]: setCurrentTourIdReducer,
      [actionTypes.SET_CURRENT_TOUR_STEP]: setCurrentTourStepReducer,
      [actionTypes.RESET_TOUR]: resetTourReducer,
      [actionTypes.SET_IS_TOUR_PANEL_OPEN]: setIsTourPanelOpenReducer,
      [actionTypes.SET_TOUR_PANEL_MODE]: setTourPanelModeReducer,
      [actionTypes.SET_SCENARIO_ID]: setScenarioIdReducer
    });
    tour_default = tour;
  }
});

// src/constants/index.ts
var ASSETS_HOST, ASSETS_HOST_DEV, SCREEN_GLOBAL, SCREEN_MULTIFETCH_PANORAMA, SCREEN_PARTIAL_PANORAMA_DATA, SCREEN_PARTIAL_PANORAMA_DRAWER, SCREEN_MULTIFETCH_PAGE, SCREEN_PARTIAL_PAGE_CUSTOM_CACHE, SCREEN_PARTIAL_PAGE_CUSTOM_NOCACHE, SCREEN_PARTIAL_PAGE_MAIN, SCREEN_PARTIAL_PAGE_DRAWER, SCREEN_READONLY, SCREEN_PARTIAL_BOOK_PAGES, SCREEN_CREATE_PAGE, SCREEN_GROUPS_SETTINGS, SCREEN_COPIES, SCREEN_COPY, SCREEN_SHARE_CORRECTIONS, SCREEN_SHARE_CORRECTIONS_STUDENTS, SCREEN_MARKETING_VIEWER, NAVBAR_MODAL, SCREEN_MULTIFETCH_BOOK, SCREEN_PARTIAL_BOOK_DRAWER, SCREEN_PARTIAL_BOOK_MAIN, SCREEN_BOOK_REDIRECT, SCREEN_MULTIFETCH_HOME, SCREEN_PARTIAL_HOME_USER, SCREEN_PARTIAL_HOME_BOOKS, SCREEN_MULTIFETCH_MY_BOOKS, SCREEN_PARTIAL_MY_BOOKS_USER, SCREEN_PARTIAL_MY_BOOKS, SCREEN_USER, SCREEN_REVISION, SCREEN_REVISION_BOOK, SCREEN_LEARNING_ASSESSMENT, SCREEN_PROFILE, SCREEN_BOOK_BROWSING_MODAL, MODAL_TEACHER_BOOK_DETAIL, MODAL_ONE_CLICK, MODAL_AVAILABLE_SOON, MODAL_NOT_TEASER, MODAL_OPEN_ANSWERS, MODAL_NPS, MODAL_BOOK_RESOURCES, MODAL_PANORAMA, MODAL_CONTACT, MODAL_NEWS, MODAL_TIP, MODAL_WARNING_SAVE_PAGE, MODAL_TRIAL_TIP, MODAL_ONBOARDING_CHOOSE_PROFILE, MODAL_ONBOARDING_CHOOSE_TOUR, MODAL_TOURS_COMPLETED, MODAL_ONBOARDING_END, MODAL_ONBOARDING_EXPERT, MODAL_ONBOARDING_ASK_FOR_TRAINING, MODAL_ONBOARDING_TRAINING_CONFIRMATION, MODAL_ONBOARDING_TRAINING_BOOKING, MODAL_TRIAL_FEATURE_BLOCKED, MODAL_OFFLINE, COOKIE_TRIAL_JOURNEY, COOKIE_DONE_TOURS, COOKIE_DATA_COOKIE, COOKIE_PANORAMA_LIKE, COOKIE_PANORAMA_DISLIKE, COOKIE_NPS, COOKIE_NPS_DURATION, COOKIE_JWT_TOKEN, COOKIE_FIRST_OPEN_BOOK, COOKIE_ACCESSIBILITY_STATE, COOKIE_LIGHTEDITOR_WARNING, COOKIE_ALLOW_COPY_DOC_BUTTON, COOKIE_RENEWAL_ORIGINAl_WARNING_DISABLED, META_CANONICAL_PREFIX, META_IMAGE, URL_SCHEME_LOGIN, URL_SCHEME_RESOURCE_OPEN, TOOL_PYTHON, TOOL_RECORDER, TOOL_ORAL, TOOL_ARDUINO, TOOL_LABO_ORAL, TOOL_MAP, TOOL_LABO_ELECTRIC, TOOL_WHO_SCIENCE, TOOL_WHO_FRENCH, TOOL_WHO_SPANISH, TOOL_WHO_HG, TOOL_WHO_ENGLISH, MODAL_NOTIFICATION, SNACKBAR_NOTIFICATION, TEACHER_BOOK_ACCORDION_FETCH, STATS_FETCH, TOOLS_TO_SLUG, GQL_CANOPE_PUBLISHER, GQL_COMMUNITY_PUBLISHER, GQL_LLS_PUBLISHER, GQL_PUBLISHERS, LLS_PUBLISHER, PREMIUM_CLASSNAME_DARK_THEME, PREMIUM_CLASSNAME_LIGHT_THEME, VIEWER_BOOK_BROWSING_MODAL, VIEWER_CREATE_PAGE, VIEWER_DEFAULT, IS_WARNING_MODAL_ENABLED, UNINITIALIZED_EXPANDED_ID;
var init_constants = __esm({
  "src/constants/index.ts"() {
    "use strict";
    ASSETS_HOST = "https://assets.lls.fr";
    ASSETS_HOST_DEV = "https://assets-dev.lls.fr";
    SCREEN_GLOBAL = "screen_global";
    SCREEN_MULTIFETCH_PANORAMA = "screen_panorama";
    SCREEN_PARTIAL_PANORAMA_DATA = "screen_partial_panorama_data";
    SCREEN_PARTIAL_PANORAMA_DRAWER = "screen_partial_panorama_drawer";
    SCREEN_MULTIFETCH_PAGE = "screen_multifetch_page";
    SCREEN_PARTIAL_PAGE_CUSTOM_CACHE = "screen_partial_page_custom_cache";
    SCREEN_PARTIAL_PAGE_CUSTOM_NOCACHE = "screen_partial_page_custom_nocache";
    SCREEN_PARTIAL_PAGE_MAIN = "screen_partial_page_main";
    SCREEN_PARTIAL_PAGE_DRAWER = "screen_partial_page_drawer";
    SCREEN_READONLY = "screen_readonly";
    SCREEN_PARTIAL_BOOK_PAGES = "screen_partial_book_pages";
    SCREEN_CREATE_PAGE = "screen_create_page";
    SCREEN_GROUPS_SETTINGS = "screen_groups_settings";
    SCREEN_COPIES = "screen_copies";
    SCREEN_COPY = "screen_copy";
    SCREEN_SHARE_CORRECTIONS = "screen_share_corrections";
    SCREEN_SHARE_CORRECTIONS_STUDENTS = "screen_share_corrections_students";
    SCREEN_MARKETING_VIEWER = "screen_marketing_viewer";
    NAVBAR_MODAL = "navbar_modal";
    SCREEN_MULTIFETCH_BOOK = "screen_multifetch_book";
    SCREEN_PARTIAL_BOOK_DRAWER = "screen_partial_book_drawer";
    SCREEN_PARTIAL_BOOK_MAIN = "screen_partial_book_main";
    SCREEN_BOOK_REDIRECT = "screen_book_redirect";
    SCREEN_MULTIFETCH_HOME = "screen_multifetch_home";
    SCREEN_PARTIAL_HOME_USER = "screen_partial_home_user";
    SCREEN_PARTIAL_HOME_BOOKS = "screen_partial_home_books";
    SCREEN_MULTIFETCH_MY_BOOKS = "screen_multifetch_my_books";
    SCREEN_PARTIAL_MY_BOOKS_USER = "screen_partial_my_books_user";
    SCREEN_PARTIAL_MY_BOOKS = "screen_partial_my_books";
    SCREEN_USER = "screen_user";
    SCREEN_REVISION = "screen_revision";
    SCREEN_REVISION_BOOK = "screen_revision_book";
    SCREEN_LEARNING_ASSESSMENT = "screen_revision_learning_assessment";
    SCREEN_PROFILE = "screen_profile";
    SCREEN_BOOK_BROWSING_MODAL = "screen_book_browsing_modal";
    MODAL_TEACHER_BOOK_DETAIL = "modal_teacher_book_detail";
    MODAL_ONE_CLICK = "modal_install_instructions";
    MODAL_AVAILABLE_SOON = "modal_available_soon";
    MODAL_NOT_TEASER = "modal_not_teaser";
    MODAL_OPEN_ANSWERS = "modal_open_answers";
    MODAL_NPS = "modal_nps";
    MODAL_BOOK_RESOURCES = "modal_book_resources";
    MODAL_PANORAMA = "modal_panorama";
    MODAL_CONTACT = "modal_contact";
    MODAL_NEWS = "modal_news";
    MODAL_TIP = "modal_tip";
    MODAL_WARNING_SAVE_PAGE = "modal_warning_save_page";
    MODAL_TRIAL_TIP = "modal_trial_tip";
    MODAL_ONBOARDING_CHOOSE_PROFILE = "modal_onboarding_choose_profile";
    MODAL_ONBOARDING_CHOOSE_TOUR = "modal_onboarding_choose_tour";
    MODAL_TOURS_COMPLETED = "modal_tours_completed";
    MODAL_ONBOARDING_END = "modal_onboarding_end";
    MODAL_ONBOARDING_EXPERT = "modal_onboarding_expert";
    MODAL_ONBOARDING_ASK_FOR_TRAINING = "modal_onboarding_ask_for_training";
    MODAL_ONBOARDING_TRAINING_CONFIRMATION = "modal_onboarding_training_confirmation";
    MODAL_ONBOARDING_TRAINING_BOOKING = "modal_onboarding_training_booking";
    MODAL_TRIAL_FEATURE_BLOCKED = "modal_trial_feature_blocked";
    MODAL_OFFLINE = "modal_offline";
    COOKIE_TRIAL_JOURNEY = "cookie_trial_journey";
    COOKIE_DONE_TOURS = "cookie_done_tours";
    COOKIE_DATA_COOKIE = "cookie_data_cookie";
    COOKIE_PANORAMA_LIKE = "cookie_panorama_like";
    COOKIE_PANORAMA_DISLIKE = "cookie_panorama_dislike";
    COOKIE_NPS = "nps";
    COOKIE_NPS_DURATION = 90;
    COOKIE_JWT_TOKEN = "jwt_token";
    COOKIE_FIRST_OPEN_BOOK = "first_open_book";
    COOKIE_ACCESSIBILITY_STATE = "accessibility_state";
    COOKIE_LIGHTEDITOR_WARNING = "lighteditor_warning";
    COOKIE_ALLOW_COPY_DOC_BUTTON = "display_copy_doc_button";
    COOKIE_RENEWAL_ORIGINAl_WARNING_DISABLED = "cookie_renewal_original_warning_disabled";
    META_CANONICAL_PREFIX = "https://premium.lelivrescolaire.fr";
    META_IMAGE = `${META_CANONICAL_PREFIX}/assets/img/home/meta.png`;
    URL_SCHEME_LOGIN = "user-login";
    URL_SCHEME_RESOURCE_OPEN = "resource-open";
    TOOL_PYTHON = "console-python";
    TOOL_RECORDER = "labo-langues";
    TOOL_ORAL = "labo-grand-oral";
    TOOL_ARDUINO = "labo-arduino";
    TOOL_LABO_ORAL = "labo-oral";
    TOOL_MAP = "fondsdecarte";
    TOOL_LABO_ELECTRIC = "labo-electricite";
    TOOL_WHO_SCIENCE = "sciences-qui-est-ce";
    TOOL_WHO_FRENCH = "francais-qui-est-ce";
    TOOL_WHO_SPANISH = "espagnol-qui-est-ce";
    TOOL_WHO_HG = "histoire-geographie-qui-est-ce";
    TOOL_WHO_ENGLISH = "anglais-qui-est-ce";
    MODAL_NOTIFICATION = "modal_notification";
    SNACKBAR_NOTIFICATION = "snackbar_notification";
    TEACHER_BOOK_ACCORDION_FETCH = "teacher_book_accordion_fetch";
    STATS_FETCH = "stats_fetch";
    TOOLS_TO_SLUG = {
      [TOOL_PYTHON]: "page/16957247",
      [TOOL_RECORDER]: "page/16955303",
      [TOOL_ORAL]: "page/17152221",
      [TOOL_ARDUINO]: "page/17078738",
      [TOOL_LABO_ELECTRIC]: "page/35652765",
      // no mapping yet
      [TOOL_LABO_ORAL]: 32238966,
      [TOOL_MAP]: 33577913,
      [TOOL_WHO_SCIENCE]: 43938090,
      [TOOL_WHO_FRENCH]: 43938206,
      [TOOL_WHO_SPANISH]: 43938208,
      [TOOL_WHO_HG]: 43938365,
      [TOOL_WHO_ENGLISH]: 43938506
    };
    GQL_CANOPE_PUBLISHER = "CANOPE";
    GQL_COMMUNITY_PUBLISHER = "COMMUNITY";
    GQL_LLS_PUBLISHER = "LLS";
    GQL_PUBLISHERS = [GQL_LLS_PUBLISHER, GQL_CANOPE_PUBLISHER];
    LLS_PUBLISHER = "Lelivrescolaire.fr";
    PREMIUM_CLASSNAME_DARK_THEME = "premium-dark";
    PREMIUM_CLASSNAME_LIGHT_THEME = "premium-light";
    VIEWER_BOOK_BROWSING_MODAL = "viewer_book_browsing_modal";
    VIEWER_CREATE_PAGE = "viewer_create_page";
    VIEWER_DEFAULT = "viewer_default";
    IS_WARNING_MODAL_ENABLED = process.env.CORE_WARNING_SAVE_PAGE !== "0";
    UNINITIALIZED_EXPANDED_ID = -1;
  }
});

// src/utils/style.js
import { KIT_CLASSNAME_DARK_THEME, KIT_CLASSNAME_LIGHT_THEME } from "@lls/lls-kit";
import { SUPERKIT_CLASSNAME_DARK_THEME, SUPERKIT_CLASSNAME_LIGHT_THEME } from "@lls/superkit";
import { cx } from "@lls/utils";
var getFluidSize, mediaMax, BREAKPOINT_PHABLET, BREAKPOINT_XXS, BREAKPOINT_MD, mediaMobile, COLOR_GREY_1, getDarkClassNames, getLightClassNames;
var init_style = __esm({
  "src/utils/style.js"() {
    "use strict";
    init_constants();
    getFluidSize = ({ minViewport = BREAKPOINT_XXS, maxViewport = BREAKPOINT_MD, minSize, maxSize }) => `min(${maxSize}px, max(${minSize}px, calc(${minSize}px + (${maxSize} - ${minSize}) * ((100vw - ${minViewport}px) / (${maxViewport} - ${minViewport})))))`;
    mediaMax = (max2) => `@media handheld, only screen and (max-width: ${max2}px), only screen and (max-device-width: ${max2}px)`;
    BREAKPOINT_PHABLET = 650;
    BREAKPOINT_XXS = 320;
    BREAKPOINT_MD = 1280;
    mediaMobile = mediaMax(BREAKPOINT_PHABLET);
    COLOR_GREY_1 = "#878DA7";
    getDarkClassNames = () => cx(KIT_CLASSNAME_DARK_THEME, PREMIUM_CLASSNAME_DARK_THEME, SUPERKIT_CLASSNAME_DARK_THEME);
    getLightClassNames = () => cx(KIT_CLASSNAME_LIGHT_THEME, PREMIUM_CLASSNAME_LIGHT_THEME, SUPERKIT_CLASSNAME_LIGHT_THEME);
  }
});

// src/store/ui.js
import _4 from "lodash/fp.js";
import { getBrowserWidth, hasWindowObject, makeReducer as makeReducer6 } from "@lls/utils";
var initialState4, setIsStudentViewActivated2, setIsOpenSaveModalReducer, setShowedContextualActionsReducer, setIsShownSidePanelReducer, setIsDrawerOpenReducer, setDrawerExpandedId2, setIsViewerReadyReducer, ui2, ui_default;
var init_ui = __esm({
  "src/store/ui.js"() {
    "use strict";
    init_actions();
    init_style();
    init_constants();
    initialState4 = {
      areShownContextualActions: false,
      isShownSidePanel: false,
      isDrawerOpen: !hasWindowObject() ? true : getBrowserWidth() >= BREAKPOINT_PHABLET,
      // no hydration pblm since ssr populates store. However when client rendered avoid double render
      drawerExpandedId: UNINITIALIZED_EXPANDED_ID,
      isOpenSaveModal: void 0,
      isViewerReady: {},
      isStudentViewActivated: false
    };
    setIsStudentViewActivated2 = (state, isStudentViewActivated) => ({
      ...state,
      isStudentViewActivated
    });
    setIsOpenSaveModalReducer = (state, isOpenSaveModal) => ({
      ...state,
      isOpenSaveModal
    });
    setShowedContextualActionsReducer = (state, areShownContextualActions) => ({
      ...state,
      areShownContextualActions
    });
    setIsShownSidePanelReducer = (state, isShownSidePanel) => ({
      ...state,
      isShownSidePanel
    });
    setIsDrawerOpenReducer = (state, isDrawerOpen) => ({
      ...state,
      isDrawerOpen
    });
    setDrawerExpandedId2 = (state, drawerExpandedId) => ({
      ...state,
      drawerExpandedId
    });
    setIsViewerReadyReducer = (state, { viewerName, value }) => _4.set(["isViewerReady", viewerName], value, state);
    ui2 = makeReducer6(initialState4, {
      [actionTypes.SET_SHOWN_CONTEXTUAL_ACTIONS]: setShowedContextualActionsReducer,
      [actionTypes.SHOW_SIDE_PANEL]: setIsShownSidePanelReducer,
      [actionTypes.SET_IS_DRAWER_OPEN]: setIsDrawerOpenReducer,
      [actionTypes.SET_DRAWER_EXPANDED_ID]: setDrawerExpandedId2,
      [actionTypes.SET_IS_OPEN_SAVE_MODAL]: setIsOpenSaveModalReducer,
      [actionTypes.SET_IS_VIEWER_READY]: setIsViewerReadyReducer,
      [actionTypes.SET_IS_STUDENT_VIEW_ACTIVATED]: setIsStudentViewActivated2
    });
    ui_default = ui2;
  }
});

// src/store/rootReducer.ts
var rootReducer_exports = {};
__export(rootReducer_exports, {
  auth: () => auth,
  entities: () => entities,
  loading: () => loading_default,
  modals: () => modals_default,
  notifications: () => notifications_default,
  ssr: () => ssr_default,
  tour: () => tour_default,
  ui: () => ui_default
});
import { authReducer as auth, entitiesReducer as entities } from "@lls/store";
var init_rootReducer = __esm({
  "src/store/rootReducer.ts"() {
    "use strict";
    init_loading();
    init_modals();
    init_notifications();
    init_ssr();
    init_tour();
    init_ui();
  }
});

// ../../node_modules/.pnpm/cookie@0.4.2/node_modules/cookie/index.js
var require_cookie = __commonJS({
  "../../node_modules/.pnpm/cookie@0.4.2/node_modules/cookie/index.js"(exports) {
    "use strict";
    exports.parse = parse3;
    exports.serialize = serialize2;
    var decode = decodeURIComponent;
    var encode = encodeURIComponent;
    var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
    function parse3(str, options) {
      if (typeof str !== "string") {
        throw new TypeError("argument str must be a string");
      }
      var obj = {};
      var opt = options || {};
      var pairs = str.split(";");
      var dec = opt.decode || decode;
      for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i];
        var index3 = pair.indexOf("=");
        if (index3 < 0) {
          continue;
        }
        var key = pair.substring(0, index3).trim();
        if (void 0 == obj[key]) {
          var val = pair.substring(index3 + 1, pair.length).trim();
          if (val[0] === '"') {
            val = val.slice(1, -1);
          }
          obj[key] = tryDecode(val, dec);
        }
      }
      return obj;
    }
    function serialize2(name, val, options) {
      var opt = options || {};
      var enc = opt.encode || encode;
      if (typeof enc !== "function") {
        throw new TypeError("option encode is invalid");
      }
      if (!fieldContentRegExp.test(name)) {
        throw new TypeError("argument name is invalid");
      }
      var value = enc(val);
      if (value && !fieldContentRegExp.test(value)) {
        throw new TypeError("argument val is invalid");
      }
      var str = name + "=" + value;
      if (null != opt.maxAge) {
        var maxAge = opt.maxAge - 0;
        if (isNaN(maxAge) || !isFinite(maxAge)) {
          throw new TypeError("option maxAge is invalid");
        }
        str += "; Max-Age=" + Math.floor(maxAge);
      }
      if (opt.domain) {
        if (!fieldContentRegExp.test(opt.domain)) {
          throw new TypeError("option domain is invalid");
        }
        str += "; Domain=" + opt.domain;
      }
      if (opt.path) {
        if (!fieldContentRegExp.test(opt.path)) {
          throw new TypeError("option path is invalid");
        }
        str += "; Path=" + opt.path;
      }
      if (opt.expires) {
        if (typeof opt.expires.toUTCString !== "function") {
          throw new TypeError("option expires is invalid");
        }
        str += "; Expires=" + opt.expires.toUTCString();
      }
      if (opt.httpOnly) {
        str += "; HttpOnly";
      }
      if (opt.secure) {
        str += "; Secure";
      }
      if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch (sameSite) {
          case true:
            str += "; SameSite=Strict";
            break;
          case "lax":
            str += "; SameSite=Lax";
            break;
          case "strict":
            str += "; SameSite=Strict";
            break;
          case "none":
            str += "; SameSite=None";
            break;
          default:
            throw new TypeError("option sameSite is invalid");
        }
      }
      return str;
    }
    function tryDecode(str, decode2) {
      try {
        return decode2(str);
      } catch (e) {
        return str;
      }
    }
  }
});

// ../../node_modules/.pnpm/universal-cookie@4.0.4/node_modules/universal-cookie/es6/utils.js
function hasDocumentCookie() {
  return typeof document === "object" && typeof document.cookie === "string";
}
function parseCookies(cookies, options) {
  if (typeof cookies === "string") {
    return cookie.parse(cookies, options);
  } else if (typeof cookies === "object" && cookies !== null) {
    return cookies;
  } else {
    return {};
  }
}
function isParsingCookie(value, doNotParse) {
  if (typeof doNotParse === "undefined") {
    doNotParse = !value || value[0] !== "{" && value[0] !== "[" && value[0] !== '"';
  }
  return !doNotParse;
}
function readCookie(value, options) {
  if (options === void 0) {
    options = {};
  }
  var cleanValue = cleanupCookieValue(value);
  if (isParsingCookie(cleanValue, options.doNotParse)) {
    try {
      return JSON.parse(cleanValue);
    } catch (e) {
    }
  }
  return value;
}
function cleanupCookieValue(value) {
  if (value && value[0] === "j" && value[1] === ":") {
    return value.substr(2);
  }
  return value;
}
var cookie;
var init_utils = __esm({
  "../../node_modules/.pnpm/universal-cookie@4.0.4/node_modules/universal-cookie/es6/utils.js"() {
    "use strict";
    cookie = __toESM(require_cookie());
  }
});

// ../../node_modules/.pnpm/universal-cookie@4.0.4/node_modules/universal-cookie/es6/Cookies.js
var cookie2, __assign, Cookies, Cookies_default;
var init_Cookies = __esm({
  "../../node_modules/.pnpm/universal-cookie@4.0.4/node_modules/universal-cookie/es6/Cookies.js"() {
    "use strict";
    cookie2 = __toESM(require_cookie());
    init_utils();
    __assign = function() {
      __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
        }
        return t;
      };
      return __assign.apply(this, arguments);
    };
    Cookies = /** @class */
    function() {
      function Cookies3(cookies, options) {
        var _this = this;
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.cookies = parseCookies(cookies, options);
        new Promise(function() {
          _this.HAS_DOCUMENT_COOKIE = hasDocumentCookie();
        }).catch(function() {
        });
      }
      Cookies3.prototype._updateBrowserValues = function(parseOptions) {
        if (!this.HAS_DOCUMENT_COOKIE) {
          return;
        }
        this.cookies = cookie2.parse(document.cookie, parseOptions);
      };
      Cookies3.prototype._emitChange = function(params) {
        for (var i = 0; i < this.changeListeners.length; ++i) {
          this.changeListeners[i](params);
        }
      };
      Cookies3.prototype.get = function(name, options, parseOptions) {
        if (options === void 0) {
          options = {};
        }
        this._updateBrowserValues(parseOptions);
        return readCookie(this.cookies[name], options);
      };
      Cookies3.prototype.getAll = function(options, parseOptions) {
        if (options === void 0) {
          options = {};
        }
        this._updateBrowserValues(parseOptions);
        var result = {};
        for (var name_1 in this.cookies) {
          result[name_1] = readCookie(this.cookies[name_1], options);
        }
        return result;
      };
      Cookies3.prototype.set = function(name, value, options) {
        var _a2;
        if (typeof value === "object") {
          value = JSON.stringify(value);
        }
        this.cookies = __assign(__assign({}, this.cookies), (_a2 = {}, _a2[name] = value, _a2));
        if (this.HAS_DOCUMENT_COOKIE) {
          document.cookie = cookie2.serialize(name, value, options);
        }
        this._emitChange({ name, value, options });
      };
      Cookies3.prototype.remove = function(name, options) {
        var finalOptions = options = __assign(__assign({}, options), { expires: new Date(1970, 1, 1, 0, 0, 1), maxAge: 0 });
        this.cookies = __assign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) {
          document.cookie = cookie2.serialize(name, "", finalOptions);
        }
        this._emitChange({ name, value: void 0, options });
      };
      Cookies3.prototype.addChangeListener = function(callback) {
        this.changeListeners.push(callback);
      };
      Cookies3.prototype.removeChangeListener = function(callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) {
          this.changeListeners.splice(idx, 1);
        }
      };
      return Cookies3;
    }();
    Cookies_default = Cookies;
  }
});

// ../../node_modules/.pnpm/universal-cookie@4.0.4/node_modules/universal-cookie/es6/index.js
var es6_default;
var init_es6 = __esm({
  "../../node_modules/.pnpm/universal-cookie@4.0.4/node_modules/universal-cookie/es6/index.js"() {
    "use strict";
    init_Cookies();
    es6_default = Cookies_default;
  }
});

// ../../node_modules/.pnpm/react-cookie@4.1.1_react@18.3.1/node_modules/react-cookie/es6/Cookies.js
var Cookies_default2;
var init_Cookies2 = __esm({
  "../../node_modules/.pnpm/react-cookie@4.1.1_react@18.3.1/node_modules/react-cookie/es6/Cookies.js"() {
    "use strict";
    init_es6();
    Cookies_default2 = es6_default;
  }
});

// ../../node_modules/.pnpm/react-cookie@4.1.1_react@18.3.1/node_modules/react-cookie/es6/CookiesContext.js
import * as React from "react";
var CookiesContext, Provider, Consumer, CookiesContext_default;
var init_CookiesContext = __esm({
  "../../node_modules/.pnpm/react-cookie@4.1.1_react@18.3.1/node_modules/react-cookie/es6/CookiesContext.js"() {
    "use strict";
    init_Cookies2();
    CookiesContext = React.createContext(new Cookies_default2());
    Provider = CookiesContext.Provider;
    Consumer = CookiesContext.Consumer;
    CookiesContext_default = CookiesContext;
  }
});

// ../../node_modules/.pnpm/react-cookie@4.1.1_react@18.3.1/node_modules/react-cookie/es6/CookiesProvider.js
import * as React2 from "react";
var __extends, CookiesProvider, CookiesProvider_default;
var init_CookiesProvider = __esm({
  "../../node_modules/.pnpm/react-cookie@4.1.1_react@18.3.1/node_modules/react-cookie/es6/CookiesProvider.js"() {
    "use strict";
    init_es6();
    init_CookiesContext();
    __extends = /* @__PURE__ */ function() {
      var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2) if (b2.hasOwnProperty(p)) d2[p] = b2[p];
        };
        return extendStatics(d, b);
      };
      return function(d, b) {
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    CookiesProvider = /** @class */
    function(_super) {
      __extends(CookiesProvider2, _super);
      function CookiesProvider2(props) {
        var _this = _super.call(this, props) || this;
        if (props.cookies) {
          _this.cookies = props.cookies;
        } else {
          _this.cookies = new es6_default();
        }
        return _this;
      }
      CookiesProvider2.prototype.render = function() {
        return React2.createElement(Provider, { value: this.cookies }, this.props.children);
      };
      return CookiesProvider2;
    }(React2.Component);
    CookiesProvider_default = CookiesProvider;
  }
});

// ../../node_modules/.pnpm/react-cookie@4.1.1_react@18.3.1/node_modules/react-cookie/es6/utils.js
function isInBrowser() {
  return typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
}
var init_utils2 = __esm({
  "../../node_modules/.pnpm/react-cookie@4.1.1_react@18.3.1/node_modules/react-cookie/es6/utils.js"() {
    "use strict";
  }
});

// ../../node_modules/.pnpm/react-cookie@4.1.1_react@18.3.1/node_modules/react-cookie/es6/useCookies.js
import { useContext, useLayoutEffect, useState, useRef, useMemo } from "react";
function useCookies(dependencies) {
  var cookies = useContext(CookiesContext_default);
  if (!cookies) {
    throw new Error("Missing <CookiesProvider>");
  }
  var initialCookies = cookies.getAll();
  var _a2 = useState(initialCookies), allCookies = _a2[0], setCookies = _a2[1];
  var previousCookiesRef = useRef(allCookies);
  if (isInBrowser()) {
    useLayoutEffect(function() {
      function onChange() {
        var newCookies = cookies.getAll();
        if (shouldUpdate(dependencies || null, newCookies, previousCookiesRef.current)) {
          setCookies(newCookies);
        }
        previousCookiesRef.current = newCookies;
      }
      cookies.addChangeListener(onChange);
      return function() {
        cookies.removeChangeListener(onChange);
      };
    }, [cookies]);
  }
  var setCookie = useMemo(function() {
    return cookies.set.bind(cookies);
  }, [cookies]);
  var removeCookie = useMemo(function() {
    return cookies.remove.bind(cookies);
  }, [cookies]);
  return [allCookies, setCookie, removeCookie];
}
function shouldUpdate(dependencies, newCookies, oldCookies) {
  if (!dependencies) {
    return true;
  }
  for (var _i = 0, dependencies_1 = dependencies; _i < dependencies_1.length; _i++) {
    var dependency = dependencies_1[_i];
    if (newCookies[dependency] !== oldCookies[dependency]) {
      return true;
    }
  }
  return false;
}
var init_useCookies = __esm({
  "../../node_modules/.pnpm/react-cookie@4.1.1_react@18.3.1/node_modules/react-cookie/es6/useCookies.js"() {
    "use strict";
    init_CookiesContext();
    init_utils2();
  }
});

// ../../node_modules/.pnpm/react-cookie@4.1.1_react@18.3.1/node_modules/react-cookie/es6/types.js
var init_types = __esm({
  "../../node_modules/.pnpm/react-cookie@4.1.1_react@18.3.1/node_modules/react-cookie/es6/types.js"() {
    "use strict";
  }
});

// ../../node_modules/.pnpm/react-cookie@4.1.1_react@18.3.1/node_modules/react-cookie/es6/index.js
var init_es62 = __esm({
  "../../node_modules/.pnpm/react-cookie@4.1.1_react@18.3.1/node_modules/react-cookie/es6/index.js"() {
    "use strict";
    init_Cookies2();
    init_CookiesProvider();
    init_useCookies();
    init_types();
  }
});

// src/config/index.ts
var isBrowser, config, config_default;
var init_config = __esm({
  "src/config/index.ts"() {
    "use strict";
    isBrowser = typeof window !== "undefined";
    config = {
      env: "",
      api_url: "",
      connect_url: "",
      epub_url: "",
      crisp_website_id: "",
      embed_url: "",
      front_url: "",
      premium_url: "",
      quiz_url: "",
      afterclasse_url: "",
      beta_redirection_url: "",
      resource_url: "",
      clarity_project_id: "",
      feature_exploration: false,
      feature_skynet: false,
      is_trial_open: false,
      feature_is_christmas: false
    };
    if (isBrowser && window.__CONFIG__) {
      config = window.__CONFIG__ || {};
    } else {
      const globalConfig = {
        is_trial_open: false,
        feature_is_christmas: false
      };
      if (process.env.CONF_ENV === "development") {
        config = {
          env: "development",
          api_url: "https://api-dev.lelivrescolaire.fr",
          connect_url: "https://connect-dev.lelivrescolaire.fr",
          epub_url: "https://epub-dev.lelivrescolaire.fr/epub",
          crisp_website_id: "debe7ba1-8995-46ad-a86e-06a6095fb752",
          embed_url: "https://embed-dev.lls.fr",
          front_url: "https://dev.lelivrescolaire.fr",
          premium_url: "https://premium-dev.lelivrescolaire.fr",
          quiz_url: "https://quiz-dev.lls.fr",
          afterclasse_url: "https://dev2.afterclasse.fr",
          beta_redirection_url: "https://dev.lelivrescolaire.fr/manuel-numerique",
          resource_url: "https://ressources-dev.lelivrescolaire.fr",
          clarity_project_id: "o99a8jzosi",
          feature_exploration: true,
          feature_skynet: true,
          ...globalConfig
        };
      }
      if (process.env.CONF_ENV === "local") {
        config = {
          env: "local",
          api_url: "https://api-dev.lelivrescolaire.fr",
          connect_url: "https://connect-dev.lelivrescolaire.fr",
          epub_url: "https://epub-dev.lelivrescolaire.fr/epub",
          crisp_website_id: "debe7ba1-8995-46ad-a86e-06a6095fb752",
          embed_url: "https://embed-dev.lls.fr",
          front_url: "https://dev.lelivrescolaire.fr",
          premium_url: "http://localhost:6014",
          quiz_url: "https://quiz-dev.lls.fr",
          afterclasse_url: "https://dev2.afterclasse.fr",
          beta_redirection_url: "https://dev.lelivrescolaire.fr/manuel-numerique",
          resource_url: "https://ressources-dev.lelivrescolaire.fr",
          clarity_project_id: "o99a8jzosi",
          feature_exploration: true,
          feature_skynet: true,
          ...globalConfig
        };
      }
      if (process.env.CONF_ENV === "test") {
        config = {
          env: "test",
          api_url: "https://api-dev.lelivrescolaire.fr",
          connect_url: "https://connect-dev.lelivrescolaire.fr",
          epub_url: "https://epub-dev.lelivrescolaire.fr/epub",
          crisp_website_id: "debe7ba1-8995-46ad-a86e-06a6095fb752",
          embed_url: "https://embed-dev.lls.fr",
          front_url: "https://dev.lelivrescolaire.fr",
          premium_url: "https://premium-dev.lelivrescolaire.fr",
          quiz_url: "https://quiz-dev.lls.fr",
          afterclasse_url: "https://dev2.afterclasse.fr",
          beta_redirection_url: "https://dev.lelivrescolaire.fr/manuel-numerique",
          resource_url: "https://ressources-dev.lelivrescolaire.fr",
          clarity_project_id: "o99a8jzosi",
          feature_exploration: true,
          feature_skynet: true,
          ...globalConfig
        };
      }
      if (process.env.CONF_ENV === "preprod") {
        config = {
          env: "preprod",
          api_url: "https://api-preprod.lelivrescolaire.fr",
          connect_url: "https://connect-preprod.lelivrescolaire.fr",
          epub_url: "https://epub.lelivrescolaire.fr/epub",
          crisp_website_id: "debe7ba1-8995-46ad-a86e-06a6095fb752",
          embed_url: "https://embed-preprod.lls.fr",
          front_url: "https://preprod.lelivrescolaire.fr",
          premium_url: "https://premium-preprod.lelivrescolaire.fr",
          quiz_url: "https://quiz-dev.lls.fr",
          afterclasse_url: "https://dev2.afterclasse.fr",
          beta_redirection_url: "https://preprod.lelivrescolaire.fr/manuel-numerique",
          resource_url: "https://ressources-preprod.lelivrescolaire.fr",
          clarity_project_id: "eu5ggwy07m",
          feature_skynet: false,
          feature_exploration: false,
          ...globalConfig
        };
      }
      if (process.env.CONF_ENV === "production") {
        config = {
          env: "production",
          api_url: "https://api.lelivrescolaire.fr",
          connect_url: "https://connect.lelivrescolaire.fr",
          epub_url: "https://epub.lelivrescolaire.fr/epub",
          crisp_website_id: "debe7ba1-8995-46ad-a86e-06a6095fb752",
          embed_url: "https://embed.lls.fr",
          front_url: "https://www.lelivrescolaire.fr",
          premium_url: "https://premium.lelivrescolaire.fr",
          quiz_url: "https://quiz.lls.fr",
          afterclasse_url: "https://www.afterclasse.fr",
          beta_redirection_url: "https://www.lelivrescolaire.fr/manuel-numerique",
          resource_url: "https://ressources.lelivrescolaire.fr",
          clarity_project_id: "eu5ggwy07m",
          feature_exploration: false,
          feature_skynet: false,
          ...globalConfig
        };
      }
      const vars = {
        SSR_git: "SSR_git",
        SSR_viewer: "SSR_viewer"
      };
      config = new Proxy(config, {
        get(target, prop, _receiver) {
          if (prop in vars) {
            return process.env[vars[prop]] || `injected at runtime on process.env.${vars[prop]}`;
          }
          return Reflect.get(target, prop);
        }
      });
    }
    config.premium_url = process.env.PREMIUM_URL || config.premium_url;
    config_default = config;
  }
});

// src/api/axios.js
import { getWindow } from "@lls/utils";
import axios from "axios";
import _5 from "lodash/fp.js";
var _a, _b, _c, qaFlags, axios_default;
var init_axios = __esm({
  "src/api/axios.js"() {
    "use strict";
    init_config();
    qaFlags = (_c = new URLSearchParams((_b = (_a = getWindow()) == null ? void 0 : _a.location) == null ? void 0 : _b.search)) == null ? void 0 : _c.get("qaFlags");
    axios.interceptors.request.use((aConfig) => {
      aConfig.headers["x-lls-agent"] = `Lelivrescolaire/premium (web; app: ${config_default.SSR_git}; viewer: ${config_default.SSR_viewer})`;
      if (!_5.isEmpty(qaFlags)) aConfig.headers["x-lls-qaflags"] = qaFlags;
      return aConfig;
    });
    axios_default = axios;
  }
});

// src/api/graphql.js
import { getUniversalVar } from "@lls/utils";
import _6 from "lodash/fp.js";
var handleResponse, compressQuery, gqlCached, gqlNoCache, gql;
var init_graphql = __esm({
  "src/api/graphql.js"() {
    "use strict";
    init_axios();
    init_config();
    handleResponse = ({ data }) => {
      if (data.errors) {
        throw data.errors[0];
      }
      return data.data;
    };
    compressQuery = _6.replace(/\s+/g, " ");
    gqlCached = ({ query, variables }) => {
      const condensedQuery = compressQuery(query);
      const stringifiedVariables = JSON.stringify(variables);
      return axios_default.get(
        `${config_default.api_url}/graph-cached?query=${condensedQuery}${stringifiedVariables ? `&variables=${stringifiedVariables}` : ""}`
      ).then(handleResponse);
    };
    gqlNoCache = (body) => axios_default.post(`${config_default.api_url}/graph`, body).then(handleResponse);
    gql = (body, opts = { cache: true }) => {
      const cache = getUniversalVar("NO_CACHE") ? false : _6.get("cache", opts);
      const api = cache ? gqlCached : gqlNoCache;
      return api(body);
    };
  }
});

// src/api/analytics.js
import { normalizeData } from "@lls/store";
var sendCustomLogApi;
var init_analytics = __esm({
  "src/api/analytics.js"() {
    "use strict";
    init_graphql();
    sendCustomLogApi = ({ event, token, analyticsParams }) => gqlNoCache({
      query: `mutation coreSendCustomLogApi ($event: AnalyticsEvents!, $token: String, $analyticsParams: JSONObject) {
      marketing (token: $token) {
        createAnalytics(event: $event , analyticsParams: $analyticsParams) {
          status
        }
      }
    }`,
      variables: {
        token,
        event,
        analyticsParams
      }
    }).then(normalizeData);
  }
});

// src/constants/redirect.ts
var BOOK_IDS_TO_URIS_REDIRECTION, OLD_BOOKS_REDIRECTION, OLD_PAGES_REDIRECTION;
var init_redirect = __esm({
  "src/constants/redirect.ts"() {
    "use strict";
    BOOK_IDS_TO_URIS_REDIRECTION = {
      53726502: "/manuels/histoire-geographie-emc-6eme-2022-cahier",
      53725861: "/manuels/francais-4eme-2022-cahier",
      53726504: "/manuels/mathematiques-4eme-2022-cahier",
      57261845: "/manuels/mathematiques-1re-2022",
      53726443: "/manuels/francais-4eme-2022",
      53726037: "/manuels/histoire-geographie-emc-6eme-2022",
      53726362: "/manuels/mathematiques-4eme-2022",
      57868437: "/manuels/sciences-economiques-et-sociales-2de-2022",
      31602697: "/manuels/mathematiques-3eme-2021-cahier",
      31602371: "/manuels/histoire-geographie-emc-3eme-2021-cahier",
      33568877: "/manuels/sciences-numeriques-et-technologie-2de-2021-cahier",
      31602054: "/manuels/francais-3eme-2021-cahier",
      33569628: "/manuels/olympe-de-gouges-declaration-des-droits-de-la-femme-et-de-la-citoyenne",
      20133433: "/manuels/francais-1re-2021",
      24945104: "/manuels/francais-1re-bac-pro-2021",
      15957177: "/manuels/francais-3eme-2021",
      24945353: "/manuels/francais-terminale-bac-pro-2021",
      31603471: "/manuels/histoire-geographie-emc-1re-bac-pro-2021-cahier",
      24878930: "/manuels/histoire-geographie-emc-1re-bac-pro-2021",
      20129643: "/manuels/histoire-geographie-emc-1re-techno-2021",
      20135283: "/manuels/histoire-geographie-emc-3eme-2021",
      31397229: "/manuels/histoire-geographie-emc-terminale-bac-pro-2021-cahier",
      24879044: "/manuels/histoire-geographie-emc-terminale-bac-pro-2021",
      20137482: "/manuels/mathematiques-1re-techno-2021",
      31788353: "/manuels/mathematiques-3eme-2021",
      31143503: "/manuels/mathematiques-terminale-bac-pro-2021-cahier",
      25736693: "/manuels/mathematiques-terminale-bac-pro-2021",
      20133323: "/manuels/prevention-sante-environnement-terminale-bac-pro-2021",
      20133020: "/manuels/sciences-numeriques-et-technologie-2de-2021",
      4636780: "/manuels/anglais-terminale-2020",
      6648021: "/manuels/anglais-terminale-2020-cahier",
      6627668: "/manuels/espagnol-terminale-2020-cahier",
      4634576: "/manuels/enseignement-scientifique-terminale-2020",
      4632920: "/manuels/espagnol-terminale-2020",
      4634594: "/manuels/geographie-terminale-2020",
      4266164: "/manuels/histoire-terminale-2020",
      4633969: "/manuels/histoire-geographie-emc-terminale-2020",
      4636086: "/manuels/mathematiques-experte-terminale-2020",
      4634715: "/manuels/mathematiques-specialite-terminale-2020",
      4634754: "/manuels/philosophie-terminale-2020",
      4634068: "/manuels/physique-chimie-terminale-2020",
      6067351: "/manuels/anglais-1re-2019",
      6067284: "/manuels/anglais-2de-2019",
      6167248: "/manuels/anglais-1re-2019-cahier",
      6167242: "/manuels/anglais-2de-2019-cahier",
      6167254: "/manuels/espagnol-1re-2019-cahier",
      6167251: "/manuels/espagnol-2de-2019-cahier",
      6067877: "/manuels/enseignement-scientifique-1re-2019",
      6067365: "/manuels/espagnol-1re-2019",
      6067361: "/manuels/espagnol-2de-2019",
      6344422: "/manuels/sciences_economiques_et_sociales-2de-2019-activites",
      6067663: "/manuels/francais-2de-2019",
      6067870: "/manuels/geographie-1re-2019",
      6067866: "/manuels/geographie-2de-2019",
      6067695: "/manuels/histoire-1re-2019",
      6067674: "/manuels/histoire-2de-2019",
      6167258: "/manuels/histoire-geographie-emc-1re-2019",
      6167261: "/manuels/histoire-geographie-emc-2de-2019",
      6067403: "/manuels/mathematiques-1re-2019",
      6067399: "/manuels/mathematiques-2de-2019",
      6067376: "/manuels/physique-chimie-1re-2019",
      6067370: "/manuels/physique-chimie-2de-2019",
      6067646: "/manuels/sciences-economiques-et-sociales-1re-2019",
      6067652: "/manuels/sciences-economiques-et-sociales-2de-2019",
      6067633: "/manuels/sciences-de-la-vie-et-de-la-terre-2de-2019",
      14529595: "/manuels/anglais-3eme-2017",
      14267895: "/manuels/anglais-4eme-2017",
      14543382: "/manuels/anglais-5eme-2017",
      16105456: "/manuels/anglais-6eme-2017",
      16871441: "/manuels/anglais-cycle4-2017",
      16875274: "/manuels/anglais-3eme-2017-cahier",
      16875339: "/manuels/anglais-4eme-2017-cahier",
      16875349: "/manuels/anglais-5eme-2017-cahier",
      16875534: "/manuels/anglais-6eme-2017-cahier",
      16875620: "/manuels/espagnol-3eme-2017-cahier",
      16875641: "/manuels/espagnol-4eme-2017-cahier",
      16875637: "/manuels/espagnol-5eme-2017-cahier",
      16106284: "/manuels/espagnol-3eme-2017",
      16106150: "/manuels/espagnol-4eme-2017",
      16106035: "/manuels/espagnol-5eme-2017",
      16876546: "/manuels/espagnol-cycle4-2017",
      16234832: "/manuels/physique-chimie-3eme-2017",
      16235256: "/manuels/physique-chimie-4eme-2017",
      16235323: "/manuels/physique-chimie-5eme-2017",
      16876650: "/manuels/physique-chimie-cycle4-2017",
      16876824: "/manuels/sciences-de-la-vie-et-de-la-terre-3eme-2017",
      16876899: "/manuels/sciences-de-la-vie-et-de-la-terre-4eme-2017",
      16877252: "/manuels/sciences-de-la-vie-et-de-la-terre-5eme-2017",
      16121266: "/manuels/sciences-de-la-vie-et-de-la-terre-cycle4-2017",
      16875721: "/manuels/francais-3eme-2016-cahier",
      16875905: "/manuels/francais-4eme-2016-cahier",
      16875788: "/manuels/francais-5eme-2016-cahier",
      16875807: "/manuels/francais-3eme-2016-cyclade",
      15570461: "/manuels/francais-3eme-2016",
      15762568: "/manuels/francais-4eme-2016",
      15110005: "/manuels/francais-5eme-2016",
      15762152: "/manuels/francais-6eme-2016",
      16857729: "/manuels/histoire-geographie-emc-3eme-2016",
      16858483: "/manuels/histoire-geographie-emc-4eme-2016",
      15110093: "/manuels/histoire-geographie-emc-5eme-2016",
      16858702: "/manuels/histoire-geographie-emc-6eme-2016",
      16869976: "/manuels/mathematiques-6eme-2016",
      16870158: "/manuels/mathematiques-cycle4-2016",
      65250189: "/manuels/histoire-geographie-emc-1re-2023-plan-de-travail",
      64541294: "/manuels/histoire-geographie-emc-2de-2023-plan-de-travail",
      65250254: "/manuels/histoire-geographie-emc-terminale-2023-plan-de-travail",
      64159211: "/manuels/francais-1re-2023-plan-de-travail",
      65250459: "/manuels/francais-2de-2023-plan-de-travail",
      65250528: "/manuels/mathematiques-1re-2023-plan-de-travail",
      65250452: "/manuels/mathematiques-2de-2023-plan-de-travail",
      65250453: "/manuels/mathematiques-terminale-2023-plan-de-travail",
      65817822: "/manuels/histoire-geographie-emc-1re-techno-2023-plan-de-travail",
      66365994: "/manuels/histoire-geographie-emc-terminale-techno-2023-plan-de-travail",
      65301423: "/manuels/francais-1re-techno-2023-plan-de-travail",
      65965577: "/manuels/mathematiques-1re-techno-2023-plan-de-travail",
      66196625: "/manuels/mathematiques-terminale-techno-2023-plan-de-travail"
    };
    OLD_BOOKS_REDIRECTION = {
      /* OLD BOOKS */
      2902751: "/book/6067663",
      2902851: "/books/6067674",
      2902856: "/books/6067866",
      2902864: "/books/6067370",
      2903140: "/books/6067877",
      2903159: "/books/6067361",
      2903204: "/books/6067399",
      2917289: "/accueil/matiere/lycee/262/francais",
      2917307: "/accueil/matiere/lycee/262/francais",
      2918015: "/books/6067365",
      2918091: "/books/6067695",
      2918148: "/books/6067695",
      2918202: "/books/6067646",
      2918562: "/books/6067870",
      2918907: "/books/6067870",
      2919240: "/books/6067403",
      2919300: "/books/6067403",
      2925837: "/books/6067877",
      2925904: "/books/6067376",
      2930176: "/books/4634754",
      2930210: "/books/4632920",
      2932442: "/books/4636780",
      3078433: "/books/4634068",
      3087981: "/accueil/matiere/lycee/275/sciences-economiques-et-sociales",
      3089963: "/books/4634715",
      3089973: "/books/4634715",
      3089983: "/books/4634594",
      3089994: "/books/4634594",
      3090006: "/books/4266164",
      3090018: "/books/4266164",
      2925856: "/books/6067877",
      3089039: "/books/4634576",
      38: "/books/15762568",
      41: "/books/16858483",
      46: "/books/16105456",
      50: "/books/15110093",
      54: "/books/15110005",
      58: "/books/15570461",
      62: "/books/16857729",
      66: "/books/14543382",
      70: "/books/15762152",
      74: "/books/16870158",
      78: "/books/16858702",
      82: "/books/14267895",
      86: "/books/14529595",
      90: "/books/16870158",
      94: "/books/16870158",
      98: "/books/16869976",
      /* OLD URLS OF COLLEGE BOOKS */
      1315552: "/books/14267895",
      1311799: "/books/14529595",
      1322066: "/books/14543382",
      1164660: "/books/15110005",
      1170224: "/books/15110093",
      1171759: "/books/15570461",
      1176315: "/books/15762152",
      1174067: "/books/15762568",
      1329481: "/books/16105456",
      1339017: "/books/16106035",
      1336479: "/books/16106150",
      1336167: "/books/16106284",
      1331015: "/books/16121266",
      1673386: "/books/16234832",
      1628476: "/books/16235256",
      1687479: "/books/16235323",
      1189304: "/books/16857729",
      1188895: "/books/16858483",
      1163154: "/books/16858702",
      1740433: "/books/16869976",
      1598176: "/books/16870158",
      1352277: "/books/16871441",
      1890125: "/books/16875274",
      1891886: "/books/16875339",
      1989562: "/books/16875349",
      1989659: "/books/16875534",
      1989901: "/books/16875620",
      1989759: "/books/16875637",
      1989832: "/books/16875641",
      1374088: "/books/16875721",
      1374082: "/books/16875788",
      1335887: "/books/16875807",
      1374085: "/books/16875905",
      1781868: "/books/16876546",
      1343273: "/books/16876650",
      1339497: "/books/16876824",
      1888652: "/books/16876899",
      1887234: "/books/16877252"
    };
    OLD_PAGES_REDIRECTION = {
      1346144: 8465816,
      1163273: 8716898,
      1316432: 13578242,
      1315448: 13578243,
      1315295: 13578244,
      4580013: 13963069,
      1170586: 13963070,
      1170563: 13963071,
      1170534: 13963072,
      1170510: 13963073,
      1170501: 13963074,
      1170469: 13963075,
      1170411: 13963076,
      1170385: 13963077,
      1170367: 13963078,
      1166667: 14018455,
      1166647: 14018456,
      1166639: 14018457,
      1166598: 14018458,
      1166564: 14018459,
      1166552: 14018460,
      1166534: 14018461,
      1165413: 14018462,
      1165306: 14018463,
      1321979: 14192781,
      1315337: 14192783,
      1315125: 14192784,
      1315055: 14192785,
      1314833: 14192786,
      1314474: 14192787,
      1314198: 14192788,
      1313715: 14192789,
      1316258: 14192790,
      1316577: 14192791,
      1322013: 14192792,
      1321970: 14192793,
      1172320: 14216381,
      1173811: 14216384,
      1173699: 14216385,
      1173544: 14216386,
      1173406: 14216387,
      1173360: 14216388,
      1173117: 14216389,
      1173059: 14216390,
      1172790: 14216391,
      1172548: 14216392,
      1166661: 14239943,
      1166643: 14239944,
      1166618: 14239945,
      1166558: 14239947,
      1166543: 14239948,
      1166539: 14239949,
      1166492: 14239950,
      1166455: 14239951,
      1166385: 14239952,
      1166268: 14239953,
      1316303: 14267882,
      1315368: 14267885,
      1315350: 14267886,
      1315156: 14267887,
      1315040: 14267888,
      1314869: 14267889,
      1314769: 14267890,
      1314691: 14267891,
      1314233: 14267892,
      1313991: 14267893,
      1313599: 14267894,
      1316749: 14267897,
      1166506: 14288288,
      1363177: 14288291,
      1314480: 14520356,
      1315502: 14520358,
      1315331: 14520359,
      1315274: 14520360,
      1314934: 14520361,
      1314732: 14520362,
      1314706: 14520363,
      1314946: 14529597,
      1315249: 14529598,
      1314922: 14529599,
      1314846: 14529600,
      1314352: 14529601,
      1315162: 14543381,
      1315442: 14543385,
      1315326: 14543386,
      1315057: 14543387,
      1314936: 14543388,
      1314753: 14543389,
      1314405: 14619917,
      1314220: 14619918,
      1313709: 14619919,
      1313394: 14619920,
      1319250: 14619921,
      1322030: 14619924,
      1321525: 14619925,
      1318237: 14619926,
      1316851: 14619927,
      1316679: 14619928,
      1316667: 14619929,
      1316527: 14619930,
      1316508: 14619931,
      1315308: 14621679,
      1315216: 14621681,
      1165295: 15109495,
      1166383: 15109654,
      1166669: 15109656,
      1166641: 15109657,
      1166624: 15109658,
      1166611: 15109659,
      1166587: 15109660,
      1166576: 15109661,
      1166560: 15109662,
      1166550: 15109663,
      1166526: 15109664,
      1166517: 15109665,
      1166502: 15109666,
      1166484: 15109667,
      1166621: 15109699,
      1166464: 15109700,
      1363193: 15109703,
      1166651: 15109704,
      1166635: 15109705,
      1166613: 15109706,
      1166490: 15109796,
      1166663: 15109798,
      1166633: 15109799,
      1166609: 15109800,
      1166592: 15109801,
      1166574: 15109802,
      1166530: 15109803,
      1166521: 15109804,
      1166504: 15109805,
      1166541: 15109900,
      1165528: 15109901,
      1166629: 15109903,
      1166578: 15109910,
      1166214: 15109911,
      1166084: 15109959,
      1166515: 15110007,
      1165650: 15110008,
      1363189: 15110011,
      1166645: 15110012,
      1332446: 15110013,
      1166524: 15110014,
      1166511: 15110015,
      1166498: 15110016,
      1166657: 15110017,
      1166570: 15110019,
      1166562: 15110020,
      1166532: 15110021,
      1166466: 15110022,
      1166446: 15110023,
      1166173: 15110024,
      1165889: 15110025,
      1165827: 15110026,
      1165749: 15110027,
      1165539: 15110028,
      1165532: 15110029,
      1165283: 15110030,
      1165249: 15110031,
      1165059: 15110032,
      1164880: 15110033,
      1170551: 15110034,
      1166600: 15110040,
      1165948: 15110041,
      1166655: 15110044,
      1166626: 15110045,
      1166604: 15110046,
      1166594: 15110047,
      1166546: 15110049,
      1166471: 15110050,
      1166460: 15110051,
      1166379: 15110052,
      1166177: 15110053,
      1166175: 15110054,
      1166659: 15110056,
      1166637: 15110057,
      1166606: 15110058,
      1166596: 15110059,
      1166568: 15110060,
      1166566: 15110061,
      1166536: 15110062,
      1166486: 15110063,
      1166488: 15110064,
      1166469: 15110065,
      1166431: 15110066,
      1166342: 15110067,
      1166418: 15110068,
      1166138: 15110069,
      1165700: 15110070,
      1165534: 15110071,
      1165310: 15110072,
      1165218: 15110073,
      1363184: 15110075,
      1166665: 15110076,
      1166653: 15110077,
      1166572: 15110078,
      1166556: 15110079,
      1166554: 15110080,
      1166500: 15110081,
      1166509: 15110082,
      1166494: 15110083,
      1166448: 15110084,
      1165877: 15110085,
      1165825: 15110086,
      1165706: 15110087,
      1165680: 15110088,
      1165590: 15110089,
      1165479: 15110090,
      1165114: 15110091,
      1164662: 15110092,
      1165186: 15110094,
      1165125: 15110095,
      1164840: 15110096,
      1170576: 15110097,
      1166602: 15110099,
      1166528: 15110100,
      1166513: 15110101,
      1166496: 15110102,
      1166474: 15110103,
      1166120: 15110104,
      1165893: 15110105,
      1165852: 15110106,
      1165829: 15110107,
      1165751: 15110108,
      1165666: 15110109,
      1165620: 15110110,
      1165516: 15110111,
      1165347: 15110112,
      1165308: 15110113,
      1165253: 15110114,
      1165251: 15110115,
      1165097: 15110116,
      1170267: 15110117,
      1166479: 15110119,
      1166462: 15110120,
      1166400: 15110121,
      1166312: 15110122,
      1166149: 15110123,
      1165991: 15110124,
      1165702: 15110125,
      1165648: 15110126,
      1165312: 15110127,
      1165061: 15110128,
      1165057: 15110129,
      1164869: 15110130,
      1170432: 15110131,
      1170314: 15110132,
      1170580: 15110134,
      1170569: 15110135,
      1170555: 15110136,
      1170526: 15110137,
      1170497: 15110138,
      1166476: 15110139,
      1166444: 15110140,
      1166171: 15110141,
      1166014: 15110142,
      1165646: 15110143,
      1165496: 15110144,
      1165383: 15110145,
      1165444: 15110146,
      1165120: 15110147,
      1164947: 15110148,
      1164912: 15110149,
      1164777: 15110150,
      1170294: 15110152,
      1170522: 15110153,
      1170332: 15110154,
      1170247: 15110155,
      1170549: 15110158,
      1166381: 15110159,
      1166182: 15110160,
      1166050: 15110161,
      1165891: 15110162,
      1165833: 15110163,
      1165788: 15110164,
      1165690: 15110165,
      1165507: 15110166,
      1165116: 15110167,
      1164983: 15110168,
      1164871: 15110169,
      1164809: 15110170,
      1164743: 15110171,
      1166086: 15110179,
      1165898: 15110180,
      1165865: 15110181,
      1165823: 15110182,
      1165710: 15110183,
      1165568: 15110184,
      1165080: 15110185,
      1164826: 15110186,
      1164807: 15110187,
      1170450: 15110188,
      1170590: 15110192,
      1170561: 15110193,
      1170557: 15110194,
      1170536: 15110195,
      1170524: 15110196,
      1170503: 15110197,
      1170493: 15110198,
      1165887: 15110199,
      1165704: 15110200,
      1165530: 15110201,
      1165477: 15110202,
      1165316: 15110203,
      1164876: 15110204,
      1164874: 15110205,
      1164667: 15110206,
      1170407: 15110207,
      1170233: 15110208,
      1170582: 15110211,
      1170565: 15110212,
      1170532: 15110213,
      1170520: 15110214,
      1170473: 15110215,
      1170467: 15110216,
      1170452: 15110217,
      1170401: 15110218,
      1165153: 15110219,
      1165106: 15110220,
      1164812: 15110221,
      1170365: 15110222,
      1170592: 15110223,
      1170572: 15110224,
      1170545: 15110225,
      1170483: 15110226,
      1170391: 15110227,
      1170347: 15110228,
      1170326: 15110229,
      1170282: 15110230,
      1170269: 15110231,
      1170255: 15110232,
      1165269: 15110239,
      1165118: 15110240,
      1165020: 15110241,
      1164853: 15110242,
      1164705: 15110243,
      1170485: 15110244,
      1170241: 15110245,
      1170278: 15110246,
      1170578: 15110247,
      1170553: 15110248,
      1170512: 15110249,
      1170489: 15110250,
      1170465: 15110251,
      1170454: 15110252,
      1170444: 15110253,
      1170425: 15110254,
      1170405: 15110255,
      1170389: 15110256,
      1170351: 15110257,
      1170308: 15110258,
      1170477: 15110260,
      1170559: 15110263,
      1170547: 15110264,
      1170540: 15110265,
      1170530: 15110266,
      1170518: 15110267,
      1170442: 15110268,
      1170434: 15110269,
      1170415: 15110270,
      1170381: 15110271,
      1170355: 15110272,
      1170302: 15110273,
      1170259: 15110274,
      1170222: 15110275,
      1170584: 15110281,
      1170574: 15110282,
      1170538: 15110283,
      1170514: 15110284,
      1170491: 15110285,
      1170463: 15110286,
      1170446: 15110287,
      1170428: 15110288,
      1170395: 15110289,
      1170341: 15110290,
      1170320: 15110291,
      1170306: 15110292,
      1170588: 15110299,
      1170567: 15110300,
      1170505: 15110301,
      1170499: 15110302,
      1170479: 15110303,
      1170456: 15110304,
      1170436: 15110305,
      1170421: 15110306,
      1170399: 15110307,
      1170371: 15110308,
      1170328: 15110309,
      1170316: 15110310,
      1170310: 15110311,
      1170290: 15110312,
      1170273: 15110313,
      1170265: 15110314,
      1170257: 15110315,
      1170251: 15110316,
      1170516: 15110321,
      1170495: 15110322,
      1170481: 15110323,
      1170475: 15110324,
      1170458: 15110325,
      1170438: 15110326,
      1170430: 15110327,
      1170397: 15110328,
      1170383: 15110329,
      1170363: 15110330,
      1170357: 15110331,
      1170349: 15110332,
      1170330: 15110333,
      1170312: 15110334,
      1170300: 15110335,
      1170292: 15110336,
      1170263: 15110337,
      1170245: 15110338,
      1170229: 15110339,
      1170471: 15110341,
      1170448: 15110342,
      1170377: 15110343,
      1170373: 15110344,
      1170336: 15110345,
      1170334: 15110346,
      1170296: 15110347,
      1170280: 15110348,
      1170261: 15110349,
      1170237: 15110350,
      1170423: 15110361,
      1170409: 15110362,
      1170403: 15110363,
      1170379: 15110364,
      1170359: 15110365,
      1170343: 15110366,
      1170284: 15110367,
      1170271: 15110368,
      1170231: 15110369,
      1170387: 15110381,
      1170375: 15110382,
      1170369: 15110383,
      1170324: 15110384,
      1170304: 15110385,
      1170286: 15110386,
      1170239: 15110387,
      1170353: 15110401,
      1170345: 15110402,
      1170322: 15110403,
      1170288: 15110404,
      1170253: 15110405,
      1170235: 15110406,
      1170243: 15110421,
      1172253: 15123969,
      1172163: 15123970,
      1173865: 15123972,
      1173629: 15123973,
      1173540: 15123974,
      1173374: 15123975,
      1173324: 15123976,
      1173251: 15123977,
      1173061: 15123978,
      1172202: 15124315,
      1171995: 15570012,
      1171988: 15570013,
      1171874: 15570014,
      1174045: 15570015,
      1174029: 15570016,
      1174019: 15570017,
      1173871: 15570123,
      1173542: 15570124,
      1173364: 15570125,
      1173318: 15570126,
      1173123: 15570127,
      1172644: 15570128,
      1172523: 15570129,
      1172204: 15570130,
      1172123: 15570131,
      1171991: 15570132,
      1171943: 15570133,
      1171904: 15570134,
      1364542: 15570135,
      1174049: 15570202,
      1174001: 15570203,
      1173973: 15570205,
      1173895: 15570206,
      1173929: 15570207,
      1173919: 15570208,
      1173813: 15570209,
      1173633: 15570210,
      1173504: 15570211,
      1172727: 15570242,
      1173346: 15570243,
      1173216: 15570244,
      1173121: 15570245,
      1172784: 15570246,
      1172731: 15570247,
      1172556: 15570248,
      1172502: 15570249,
      1172373: 15570304,
      1172257: 15570305,
      1171984: 15570306,
      1174041: 15570401,
      1174012: 15570402,
      1173997: 15570404,
      1332635: 15570405,
      1173963: 15570406,
      1173953: 15570407,
      1173941: 15570408,
      1173362: 15570409,
      1172931: 15570450,
      1172753: 15570451,
      1172500: 15570452,
      1172494: 15570453,
      1172198: 15570454,
      1174053: 15570455,
      1174035: 15570456,
      1174023: 15570460,
      1173993: 15570462,
      1173979: 15570463,
      1173949: 15570464,
      1173937: 15570465,
      1173923: 15570466,
      1173911: 15570467,
      1173897: 15570468,
      1171986: 15570534,
      1173869: 15570537,
      1173625: 15570538,
      1171761: 15570553,
      1171935: 15570555,
      1173849: 15570558,
      1172550: 15570568,
      1173817: 15570571,
      1173669: 15570572,
      1173627: 15570573,
      1173130: 15570574,
      1173115: 15570575,
      1173057: 15570576,
      1172882: 15570577,
      1172735: 15570578,
      1174039: 15570592,
      1174037: 15570593,
      1173776: 15570594,
      1173635: 15570595,
      1173370: 15570596,
      1173366: 15570597,
      1173283: 15570598,
      1173863: 15570605,
      1173640: 15570606,
      1173631: 15570607,
      1173368: 15570608,
      1173119: 15570609,
      1172794: 15570610,
      1172834: 15570611,
      1172786: 15570612,
      1172546: 15570613,
      1172259: 15570615,
      1171999: 15570616,
      1171993: 15570617,
      1171799: 15570618,
      1171933: 15570637,
      1172085: 15570638,
      1172733: 15570640,
      1172561: 15570642,
      1174065: 15570643,
      1172263: 15570644,
      1173815: 15570646,
      1173546: 15570647,
      1173438: 15570648,
      1173320: 15570649,
      1173125: 15570650,
      1173063: 15570651,
      1173041: 15570652,
      1172788: 15570653,
      1172552: 15570654,
      1172227: 15570655,
      1171938: 15570656,
      1174063: 15570657,
      1174047: 15570658,
      1172419: 15570748,
      1173819: 15570751,
      1173735: 15570752,
      1173589: 15570753,
      1173468: 15570754,
      1172969: 15570755,
      1172782: 15570756,
      1172600: 15570757,
      1172498: 15570758,
      1173867: 15570759,
      1173322: 15570760,
      1173172: 15570761,
      1364474: 15570762,
      1173089: 15570763,
      1172780: 15570764,
      1172684: 15570765,
      1172554: 15570766,
      1172496: 15570767,
      1172268: 15570768,
      1172255: 15570769,
      1172200: 15570770,
      1364524: 15570771,
      1174057: 15570772,
      1174025: 15570773,
      1174007: 15570774,
      1173989: 15570775,
      1173971: 15570776,
      1174051: 15570777,
      1174031: 15570778,
      1174015: 15570779,
      1174003: 15570780,
      1173969: 15570781,
      1343480: 15570782,
      1173951: 15570783,
      1173943: 15570784,
      1173927: 15570785,
      1173915: 15570786,
      1173901: 15570787,
      1173893: 15570788,
      1172729: 15570789,
      1172046: 15570790,
      1171941: 15570791,
      1171766: 15570792,
      1174061: 15570793,
      1174043: 15570794,
      1174033: 15570795,
      1173999: 15570797,
      1173955: 15570798,
      1173881: 15570799,
      1172457: 15570809,
      1172261: 15570810,
      1171965: 15570811,
      1171837: 15570812,
      1174059: 15570813,
      1174009: 15570814,
      1173983: 15570815,
      1173965: 15570816,
      1173885: 15570817,
      1174055: 15570829,
      1174005: 15570830,
      1173981: 15570831,
      1173957: 15570832,
      1173945: 15570833,
      1173931: 15570834,
      1173913: 15570835,
      1173899: 15570836,
      1173887: 15570837,
      1174027: 15570849,
      1173987: 15570850,
      1173975: 15570851,
      1173939: 15570852,
      1173933: 15570853,
      1173917: 15570854,
      1173905: 15570855,
      1173991: 15570870,
      1173985: 15570871,
      1173961: 15570872,
      1173947: 15570873,
      1173935: 15570874,
      1173921: 15570875,
      1173909: 15570876,
      1173883: 15570877,
      1173995: 15570889,
      1173977: 15570890,
      1173967: 15570891,
      1332571: 15570892,
      1173879: 15570893,
      1173959: 15570909,
      1173877: 15570910,
      1173925: 15570929,
      1173907: 15570930,
      1173891: 15570932,
      1173875: 15570933,
      1173903: 15570949,
      1173889: 15570950,
      1178263: 15761832,
      1178439: 15761833,
      1178417: 15761834,
      1178368: 15761835,
      1178362: 15761836,
      1178338: 15761837,
      1178326: 15761838,
      1178320: 15761839,
      1178419: 15762078,
      1178396: 15762079,
      1178388: 15762080,
      1178376: 15762081,
      1178336: 15762082,
      1177215: 15762091,
      1178382: 15762093,
      1177510: 15762094,
      1178433: 15762097,
      1178426: 15762098,
      1178296: 15762099,
      1178280: 15762100,
      1178122: 15762101,
      1329701: 15762154,
      1178435: 15762156,
      1178431: 15762157,
      1178410: 15762158,
      1178437: 15762192,
      1178290: 15762193,
      1177008: 15762194,
      1178340: 15762223,
      1177219: 15762224,
      1177826: 15762225,
      1178428: 15762228,
      1178413: 15762229,
      1178384: 15762230,
      1178392: 15762231,
      1177894: 15762232,
      1177892: 15762233,
      1177652: 15762295,
      1178390: 15762296,
      1178415: 15762298,
      1178398: 15762299,
      1178350: 15762300,
      1178346: 15762301,
      1178330: 15762302,
      1178318: 15762303,
      1178308: 15762304,
      1178282: 15762305,
      1178230: 15762306,
      1177890: 15762307,
      1177056: 15762308,
      1177006: 15762309,
      1176802: 15762310,
      1178423: 15762337,
      1178406: 15762338,
      1178352: 15762339,
      1178344: 15762340,
      1178332: 15762341,
      1178324: 15762342,
      1178322: 15762343,
      1178306: 15762344,
      1178300: 15762345,
      1178286: 15762346,
      1178234: 15762347,
      1178165: 15762348,
      1178441: 15762352,
      1178408: 15762353,
      1178380: 15762354,
      1178374: 15762355,
      1178366: 15762356,
      1178358: 15762357,
      1178302: 15762358,
      1178288: 15762359,
      1178232: 15762360,
      1178074: 15762361,
      1178070: 15762362,
      1177868: 15762363,
      1177536: 15762364,
      1177221: 15762365,
      1177196: 15762366,
      1176961: 15762367,
      1178421: 15762369,
      1178120: 15762370,
      1178370: 15762371,
      1178400: 15762372,
      1178386: 15762373,
      1178372: 15762374,
      1178334: 15762375,
      1178212: 15762376,
      1178078: 15762377,
      1177824: 15762378,
      1177562: 15762379,
      1177558: 15762380,
      1177012: 15762381,
      1176924: 15762382,
      1176762: 15762383,
      1176548: 15762384,
      1176498: 15762385,
      1178394: 15762388,
      1178402: 15762389,
      1178364: 15762390,
      1178360: 15762391,
      1178342: 15762392,
      1178310: 15762393,
      1178328: 15762394,
      1178298: 15762395,
      1178294: 15762396,
      1178238: 15762397,
      1178128: 15762398,
      1178118: 15762399,
      1178076: 15762400,
      1176807: 15762401,
      1176524: 15762402,
      1176357: 15762403,
      1178404: 15762405,
      1178378: 15762406,
      1178356: 15762407,
      1178354: 15762408,
      1178348: 15762409,
      1178314: 15762410,
      1178316: 15762411,
      1178292: 15762412,
      1177556: 15762413,
      1177270: 15762414,
      1177142: 15762415,
      1176725: 15762416,
      1176690: 15762417,
      1176506: 15762418,
      1176430: 15762419,
      1176307: 15762420,
      1176241: 15762421,
      1176237: 15762422,
      1176227: 15762423,
      1176202: 15762424,
      1178312: 15762425,
      1178284: 15762426,
      1178196: 15762427,
      1178124: 15762428,
      1178039: 15762429,
      1177969: 15762430,
      1177705: 15762431,
      1177275: 15762432,
      1177223: 15762433,
      1177211: 15762434,
      1177062: 15762435,
      1177054: 15762436,
      1176463: 15762437,
      1176172: 15762438,
      1176021: 15762439,
      1175770: 15762440,
      1176271: 15762441,
      1176263: 15762442,
      1363775: 15762443,
      1176251: 15762444,
      1178304: 15762445,
      1178236: 15762446,
      1178228: 15762447,
      1178096: 15762448,
      1178072: 15762449,
      1178005: 15762450,
      1177506: 15762451,
      1177266: 15762452,
      1177099: 15762453,
      1177207: 15762454,
      1177004: 15762455,
      1176883: 15762456,
      1176542: 15762457,
      1176387: 15762458,
      1176164: 15762459,
      1175845: 15762460,
      1176112: 15762461,
      1176265: 15762464,
      1177935: 15762465,
      1177899: 15762466,
      1177832: 15762467,
      1177512: 15762468,
      1177339: 15762469,
      1176552: 15762470,
      1176500: 15762471,
      1341832: 15762472,
      1175752: 15762473,
      1176261: 15762476,
      1363780: 15762477,
      1176305: 15762478,
      1176186: 15762479,
      1176126: 15762480,
      1176293: 15762481,
      1176071: 15762482,
      1175794: 15762483,
      1175473: 15762484,
      1177888: 15762485,
      1177611: 15762486,
      1177491: 15762487,
      1177268: 15762488,
      1177213: 15762489,
      1177177: 15762490,
      1177010: 15762491,
      1176842: 15762492,
      1176796: 15762493,
      1176621: 15762494,
      1176544: 15762495,
      1176317: 15762496,
      1176273: 15762499,
      1363787: 15762500,
      1176235: 15762501,
      1176218: 15762502,
      1176194: 15762503,
      1176176: 15762504,
      1177828: 15762505,
      1177769: 15762506,
      1177560: 15762507,
      1177508: 15762508,
      1177426: 15762509,
      1177238: 15762510,
      1177217: 15762511,
      1177031: 15762512,
      1176760: 15762513,
      1176764: 15762514,
      1176502: 15762515,
      1176309: 15762516,
      1176275: 15762519,
      1176311: 15762520,
      1176229: 15762521,
      1176224: 15762522,
      1176204: 15762523,
      1176166: 15762524,
      1177830: 15762525,
      1177566: 15762526,
      1177378: 15762527,
      1177264: 15762528,
      1177058: 15762529,
      1177052: 15762530,
      1176798: 15762531,
      1176758: 15762532,
      1176652: 15762533,
      1176546: 15762534,
      1176146: 15762535,
      1176283: 15762536,
      1176267: 15762538,
      1363768: 15762539,
      1254577: 15762540,
      1176245: 15762541,
      1176243: 15762542,
      1176220: 15762543,
      1176208: 15762544,
      1176800: 15762545,
      1176504: 15762546,
      1176247: 15762548,
      1175502: 15762549,
      1176269: 15762551,
      1363761: 15762552,
      1254581: 15762553,
      1176239: 15762554,
      1176212: 15762555,
      1176196: 15762556,
      1176192: 15762557,
      1176120: 15762558,
      1176285: 15762559,
      1176029: 15762560,
      1175630: 15762561,
      1175695: 15762562,
      1175530: 15762563,
      1175312: 15762564,
      1176782: 15762565,
      1176588: 15762566,
      1176322: 15762567,
      1176184: 15762570,
      1176291: 15762571,
      1176313: 15762574,
      1176249: 15762575,
      1176222: 15762576,
      1176178: 15762577,
      1176124: 15762578,
      1176295: 15762579,
      1176277: 15762580,
      1175964: 15762581,
      1175803: 15762582,
      1175750: 15762583,
      1175744: 15762584,
      1176255: 15762585,
      1176231: 15762586,
      1176216: 15762587,
      1176206: 15762588,
      1176170: 15762589,
      1176118: 15762590,
      1176301: 15762591,
      1176025: 15762592,
      1176023: 15762593,
      1175740: 15762594,
      1175532: 15762595,
      1175471: 15762596,
      1175398: 15762597,
      1175113: 15762598,
      1175263: 15762599,
      1174822: 15762600,
      1174330: 15762601,
      1174164: 15762602,
      1175109: 15762604,
      1175057: 15762605,
      1174947: 15762606,
      1174834: 15762607,
      1174824: 15762608,
      1176253: 15762609,
      1176233: 15762610,
      1176210: 15762611,
      1176200: 15762612,
      1176190: 15762613,
      1176174: 15762614,
      1176160: 15762615,
      1176142: 15762616,
      1176303: 15762617,
      1176289: 15762618,
      1175798: 15762619,
      1175796: 15762620,
      1175528: 15762621,
      1175467: 15762622,
      1175320: 15762623,
      1175265: 15762624,
      1175158: 15762625,
      1174791: 15762626,
      1174632: 15762627,
      1174251: 15762628,
      1176214: 15762629,
      1176198: 15762630,
      1342344: 15762631,
      1176180: 15762632,
      1176162: 15762633,
      1176154: 15762634,
      1176138: 15762635,
      1176116: 15762636,
      1176299: 15762637,
      1175912: 15762638,
      1175748: 15762639,
      1175475: 15762640,
      1175362: 15762641,
      1174832: 15762642,
      1174433: 15762643,
      1174074: 15762644,
      1176188: 15762649,
      1176140: 15762650,
      1176150: 15762651,
      1176134: 15762652,
      1176128: 15762653,
      1176287: 15762654,
      1176114: 15762655,
      1175792: 15762656,
      1175746: 15762657,
      1175433: 15762658,
      1175314: 15762659,
      1175267: 15762660,
      1175229: 15762661,
      1175107: 15762662,
      1175059: 15762663,
      1174876: 15762664,
      1174870: 15762665,
      1174682: 15762666,
      1174291: 15762667,
      1174069: 15762668,
      1176182: 15762669,
      1176168: 15762670,
      1176158: 15762671,
      1176136: 15762672,
      1176122: 15762673,
      1174659: 15762674,
      1174552: 15762675,
      1174125: 15762676,
      1176148: 15762689,
      1176152: 15762690,
      1176132: 15762691,
      1176297: 15762692,
      1176110: 15762693,
      1346846: 15762694,
      1175292: 15762695,
      1175261: 15762696,
      1175194: 15762697,
      1174874: 15762698,
      1174691: 15762699,
      1174680: 15762700,
      1174328: 15762701,
      1176156: 15762709,
      1176144: 15762710,
      1176130: 15762711,
      1176281: 15762712,
      1176027: 15762713,
      1175881: 15762714,
      1175582: 15762715,
      1175537: 15762716,
      1175322: 15762717,
      1175269: 15762718,
      1175118: 15762719,
      1175061: 15762720,
      1174911: 15762721,
      1174872: 15762722,
      1174634: 15762723,
      1174285: 15762724,
      1175526: 15762729,
      1175259: 15762730,
      1175087: 15762731,
      1174830: 15762732,
      1174686: 15762733,
      1174313: 15762734,
      1175316: 15762749,
      1175310: 15762750,
      1175111: 15762751,
      1175019: 15762752,
      1175055: 15762753,
      1174727: 15762754,
      1174566: 15762755,
      1174338: 15762756,
      1174880: 15762769,
      1174979: 15762770,
      1174852: 15762771,
      1174759: 15762772,
      1174684: 15762773,
      1174501: 15762774,
      1174332: 15762775,
      1174289: 15762776,
      1174636: 15762789,
      1174334: 15762790,
      1174287: 15762791,
      1174213: 15762792,
      1887879: 15821127,
      1887855: 15821128,
      1887563: 15821129,
      2005944: 15920666,
      1342286: 15920667,
      1341882: 15920668,
      1341558: 15920669,
      1340625: 15920670,
      1340318: 15920671,
      1554086: 15998823,
      1352268: 15998825,
      1782095: 15998827,
      2484187: 15998828,
      2484182: 15998829,
      1782076: 15998830,
      1782015: 15998831,
      1781952: 15998832,
      1604143: 15998833,
      1320445: 16104733,
      1315106: 16104734,
      1314912: 16104735,
      1314837: 16104736,
      1314487: 16104737,
      1314398: 16104738,
      1314236: 16104739,
      1313608: 16104740,
      1316902: 16104741,
      1321985: 16104744,
      1321517: 16104745,
      1318245: 16104746,
      1321505: 16104750,
      1315422: 16104752,
      1315083: 16104753,
      1314822: 16104754,
      1314803: 16104755,
      1314742: 16104756,
      1314357: 16104757,
      1313989: 16104758,
      2214194: 16104759,
      1319176: 16104760,
      1316490: 16104761,
      1321995: 16104764,
      1319174: 16104765,
      1317326: 16104766,
      1314729: 16104770,
      1316585: 16104771,
      1315346: 16104774,
      1315280: 16104775,
      1315102: 16104776,
      1315069: 16104777,
      1314907: 16104778,
      1314857: 16104779,
      1314343: 16104780,
      1314208: 16104781,
      1313922: 16104782,
      1313392: 16104783,
      1316345: 16104784,
      2457470: 16104805,
      1315032: 16104806,
      1314241: 16104807,
      1313909: 16104808,
      1313404: 16104809,
      1316811: 16104810,
      1320438: 16104813,
      1316868: 16104814,
      1316727: 16104815,
      1316632: 16104816,
      1316405: 16104817,
      1316283: 16104818,
      1329352: 16104820,
      1324508: 16104821,
      1324350: 16104822,
      1324287: 16104823,
      1324301: 16104825,
      1322963: 16104826,
      1328835: 16104827,
      1324364: 16104828,
      1324205: 16104829,
      1323192: 16104830,
      1323101: 16104831,
      1315146: 16104832,
      1315063: 16104833,
      1315048: 16104834,
      1314925: 16104835,
      1314864: 16104836,
      1314766: 16104837,
      1314696: 16104838,
      1314685: 16104852,
      1314364: 16104853,
      1313916: 16104854,
      1313565: 16104855,
      1322021: 16104856,
      1321191: 16104857,
      1316648: 16104858,
      1322019: 16104859,
      2451631: 16104860,
      1317602: 16104861,
      1317329: 16104862,
      1316816: 16104863,
      1316396: 16104864,
      1316264: 16104865,
      1323272: 16104867,
      1324260: 16104868,
      1328881: 16104869,
      1328567: 16104870,
      1324595: 16104871,
      1314370: 16104872,
      1314216: 16104873,
      1313382: 16104874,
      1322001: 16104877,
      1321183: 16104878,
      1318232: 16104879,
      1316877: 16104880,
      1316777: 16104882,
      1316587: 16104883,
      1316501: 16104884,
      1316268: 16104885,
      1328614: 16104887,
      1328845: 16104888,
      1326524: 16104889,
      1324599: 16104890,
      1324217: 16104891,
      1328785: 16104895,
      1326476: 16104896,
      1324521: 16104897,
      1324358: 16104898,
      1322003: 16104899,
      1321973: 16104900,
      1316717: 16104901,
      1316479: 16104902,
      1316389: 16104903,
      1316305: 16104904,
      1316234: 16104905,
      1326175: 16104907,
      1324565: 16104908,
      1324343: 16104909,
      1323204: 16104910,
      1323172: 16104911,
      1323014: 16104912,
      1322956: 16104913,
      1321654: 16104919,
      1320459: 16104920,
      1316857: 16104921,
      1316795: 16104922,
      1316697: 16104923,
      1316326: 16104924,
      1316250: 16104925,
      1328576: 16104927,
      1324355: 16104928,
      1324251: 16104929,
      1323266: 16104930,
      1323149: 16104931,
      1323070: 16104932,
      1323036: 16104933,
      1320450: 16104939,
      1320370: 16104940,
      1319246: 16104941,
      1316887: 16104942,
      1316724: 16104943,
      1316415: 16104944,
      2214887: 16104945,
      1328656: 16104948,
      1326526: 16104949,
      1324376: 16104950,
      1324240: 16104951,
      1324225: 16104952,
      1323282: 16104953,
      1323155: 16104954,
      1323009: 16104955,
      1322924: 16104956,
      2214273: 16104957,
      1322865: 16104958,
      1316895: 16104959,
      1316641: 16104960,
      1316517: 16104961,
      1316441: 16104962,
      1316334: 16104963,
      1316247: 16104964,
      1323048: 16104965,
      1328662: 16104970,
      1324485: 16104971,
      1323077: 16104972,
      1322802: 16104973,
      1316801: 16104979,
      1316741: 16104980,
      1316525: 16104981,
      1316449: 16104982,
      1316296: 16104983,
      1316225: 16104984,
      1328778: 16104990,
      2484163: 16104991,
      1324538: 16104992,
      1324266: 16104993,
      1323323: 16104994,
      1323143: 16104995,
      1322936: 16104996,
      1328609: 16104999,
      1324330: 16105e3,
      1324211: 16105001,
      1323206: 16105002,
      1323163: 16105003,
      1323089: 16105004,
      1323027: 16105005,
      1322950: 16105006,
      1322880: 16105007,
      1324295: 16105026,
      1324223: 16105027,
      1323303: 16105028,
      1323175: 16105029,
      1323095: 16105030,
      1322987: 16105031,
      1322941: 16105032,
      1322795: 16105034,
      1324195: 16105046,
      1323084: 16105047,
      1322877: 16105048,
      1323261: 16105066,
      1323117: 16105067,
      1322948: 16105068,
      1322785: 16105069,
      1323043: 16105086,
      1322867: 16105087,
      1330051: 16105396,
      1330859: 16105549,
      1330868: 16105559,
      1330764: 16105560,
      1330665: 16105561,
      1330309: 16105562,
      1330269: 16105563,
      1330189: 16105564,
      1330096: 16105577,
      1330861: 16105579,
      1330844: 16105580,
      1330782: 16105581,
      1330736: 16105582,
      1330509: 16105583,
      1330460: 16105584,
      1330828: 16105594,
      1330804: 16105595,
      1330712: 16105596,
      1330660: 16105597,
      1330548: 16105598,
      1330260: 16105599,
      1330113: 16105600,
      1330071: 16105601,
      1330018: 16105602,
      1330772: 16105612,
      1330882: 16105613,
      1330894: 16105614,
      1330837: 16105615,
      1330721: 16105616,
      1330472: 16105617,
      1330253: 16105618,
      1330027: 16105619,
      1329928: 16105620,
      1330578: 16105628,
      1330728: 16105630,
      1330591: 16105631,
      1330515: 16105632,
      1330467: 16105633,
      1330195: 16105634,
      1330151: 16105635,
      1330082: 16105636,
      1329980: 16105647,
      1330901: 16105649,
      1330811: 16105650,
      1329886: 16105651,
      1330183: 16105666,
      2484156: 16105668,
      1330554: 16105669,
      1330497: 16105670,
      1330331: 16105671,
      1330128: 16105672,
      2212922: 16105673,
      1330679: 16105686,
      1330139: 16105687,
      1329907: 16105690,
      1330876: 16105706,
      1330798: 16105707,
      1330743: 16105708,
      1330710: 16105709,
      1330599: 16105710,
      1330541: 16105711,
      1330466: 16105712,
      1330155: 16105713,
      1330099: 16105714,
      1330014: 16105715,
      1329888: 16105716,
      1330888: 16105725,
      1330855: 16105726,
      1330789: 16105727,
      1330693: 16105728,
      1330587: 16105729,
      1330517: 16105730,
      1330486: 16105731,
      1330127: 16105732,
      1329964: 16105733,
      1330201: 16105752,
      1330065: 16105753,
      1330001: 16105754,
      1329881: 16105755,
      1330130: 16105772,
      1330055: 16105773,
      1330029: 16105774,
      1329921: 16105775,
      1329937: 16105776,
      1341126: 16105821,
      1341198: 16105838,
      1341690: 16105907,
      1341009: 16105941,
      1340612: 16105964,
      1338119: 16106001,
      1341772: 16106003,
      1341801: 16106012,
      1340872: 16106013,
      1340799: 16106014,
      1340594: 16106015,
      1340281: 16106016,
      1340205: 16106017,
      1337801: 16106018,
      1336447: 16106019,
      1338494: 16106021,
      1338256: 16106022,
      1338143: 16106023,
      1341496: 16106037,
      1341805: 16106038,
      1341803: 16106039,
      1341673: 16106040,
      1341461: 16106041,
      1341443: 16106042,
      1341169: 16106043,
      2026608: 16106049,
      1984644: 16106055,
      1341685: 16106056,
      1341563: 16106057,
      1341080: 16106058,
      1341027: 16106059,
      1340553: 16106060,
      1340215: 16106061,
      1340102: 16106062,
      1341542: 16106073,
      1336467: 16106074,
      1341071: 16106076,
      1341006: 16106077,
      1340743: 16106078,
      2215611: 16106079,
      1338522: 16106080,
      1336383: 16106081,
      1338731: 16106082,
      1338595: 16106083,
      1341662: 16106089,
      1340859: 16106090,
      1341607: 16106092,
      1341483: 16106093,
      1341132: 16106094,
      1340852: 16106095,
      1340804: 16106096,
      1340747: 16106097,
      1340542: 16106098,
      1340072: 16106099,
      1340068: 16106100,
      1338646: 16106102,
      1338515: 16106103,
      1341390: 16106108,
      1341079: 16106109,
      1341747: 16106112,
      1341392: 16106113,
      1340857: 16106114,
      1340559: 16106115,
      1340133: 16106116,
      1340074: 16106117,
      1336427: 16106118,
      2000497: 16106119,
      1338773: 16106120,
      1338377: 16106121,
      1338360: 16106122,
      1338353: 16106123,
      1341786: 16106127,
      1341754: 16106128,
      1341539: 16106129,
      1341187: 16106130,
      1341104: 16106131,
      1341025: 16106132,
      1340327: 16106133,
      1336391: 16106134,
      1338794: 16106137,
      1338637: 16106138,
      1338418: 16106139,
      1338384: 16106140,
      1338229: 16106141,
      1338106: 16106142,
      1338032: 16106143,
      1341668: 16106144,
      1341204: 16106145,
      1341149: 16106146,
      1341018: 16106147,
      1340536: 16106148,
      1340050: 16106149,
      1338868: 16106154,
      1338661: 16106155,
      1338426: 16106156,
      1338391: 16106157,
      1338233: 16106158,
      1337893: 16106159,
      1337726: 16106160,
      1337502: 16106161,
      1336627: 16106162,
      1341741: 16106164,
      1341695: 16106165,
      1341534: 16106166,
      1341431: 16106167,
      1340782: 16106168,
      1340755: 16106169,
      1340618: 16106170,
      1340561: 16106171,
      1338708: 16106173,
      1338507: 16106174,
      1338374: 16106175,
      1338327: 16106176,
      1337521: 16106177,
      2215730: 16106178,
      1336373: 16106179,
      1336455: 16106182,
      1338815: 16106183,
      1338666: 16106184,
      1338387: 16106185,
      1337966: 16106186,
      1337567: 16106187,
      1336629: 16106188,
      1336453: 16106190,
      1336409: 16106191,
      1336387: 16106192,
      1341138: 16106193,
      1340788: 16106194,
      1340757: 16106195,
      1336413: 16106196,
      1338712: 16106199,
      1338565: 16106200,
      1338273: 16106201,
      1338133: 16106202,
      1338048: 16106203,
      1337831: 16106204,
      1336407: 16106206,
      1336389: 16106207,
      2215858: 16106208,
      1341020: 16106213,
      1340870: 16106214,
      1340847: 16106215,
      1340627: 16106216,
      1340272: 16106217,
      1338652: 16106219,
      1338410: 16106220,
      1338389: 16106221,
      1338351: 16106222,
      1338103: 16106223,
      1337890: 16106224,
      1337661: 16106225,
      1337436: 16106226,
      1336591: 16106227,
      2000465: 16106231,
      1336451: 16106232,
      1338810: 16106233,
      1338763: 16106234,
      1338137: 16106235,
      1337896: 16106236,
      1337738: 16106237,
      1337713: 16106238,
      1336623: 16106239,
      1336333: 16106240,
      1336459: 16106242,
      1336445: 16106243,
      1336433: 16106244,
      1336385: 16106245,
      1336367: 16106246,
      1336343: 16106247,
      1336327: 16106248,
      1336309: 16106249,
      1336369: 16106252,
      1336353: 16106253,
      1336331: 16106254,
      1336311: 16106255,
      1336287: 16106256,
      1338365: 16106262,
      1338262: 16106263,
      1338094: 16106264,
      1337979: 16106265,
      1337826: 16106266,
      1337664: 16106267,
      1337463: 16106268,
      1336425: 16106271,
      1336405: 16106272,
      1336371: 16106273,
      1336349: 16106274,
      1336325: 16106275,
      1336303: 16106276,
      1336299: 16106277,
      1338211: 16106282,
      1336631: 16106283,
      1336463: 16106287,
      1336423: 16106288,
      1336393: 16106289,
      1336355: 16106290,
      1336305: 16106291,
      1336289: 16106292,
      1337935: 16106302,
      1337839: 16106303,
      1337733: 16106304,
      1337510: 16106305,
      1336429: 16106306,
      1336457: 16106309,
      1336441: 16106310,
      1336403: 16106311,
      1336395: 16106312,
      1336361: 16106313,
      1336357: 16106314,
      1336337: 16106315,
      1336323: 16106316,
      1336319: 16106317,
      1336283: 16106318,
      1337821: 16106322,
      1337512: 16106323,
      1336625: 16106324,
      1336291: 16106325,
      1336461: 16106327,
      1336443: 16106328,
      1336419: 16106329,
      1336411: 16106330,
      1336401: 16106331,
      1336397: 16106332,
      1336347: 16106333,
      1336297: 16106334,
      1336449: 16106342,
      1336465: 16106344,
      1336439: 16106345,
      1336421: 16106346,
      1336415: 16106347,
      1336375: 16106348,
      1336363: 16106349,
      1336339: 16106350,
      1336307: 16106351,
      1336431: 16106371,
      1336351: 16106372,
      1336315: 16106373,
      1336285: 16106374,
      1336379: 16106391,
      1336345: 16106392,
      1336335: 16106393,
      1336317: 16106394,
      1336293: 16106395,
      1334211: 16120770,
      1335728: 16120771,
      1335587: 16120772,
      1336025: 16120773,
      1336029: 16120775,
      1335943: 16120776,
      1333759: 16120777,
      1335895: 16120778,
      1335564: 16120779,
      1335204: 16120780,
      1336013: 16120849,
      1334385: 16120850,
      1336043: 16120851,
      1335925: 16120853,
      1335347: 16120858,
      1336061: 16120859,
      1334983: 16120860,
      1336151: 16120867,
      1336019: 16120876,
      1335924: 16120877,
      1336123: 16120878,
      1334244: 16120879,
      1336153: 16120880,
      1336041: 16120882,
      1335999: 16120883,
      1336095: 16120884,
      1335410: 16120886,
      1336087: 16120887,
      1335941: 16120888,
      1334996: 16120894,
      1334645: 16120895,
      1335893: 16120896,
      1335394: 16120898,
      1334787: 16120899,
      1334507: 16120900,
      1336077: 16120905,
      1336055: 16120910,
      1334910: 16120911,
      1336103: 16120912,
      1335605: 16120913,
      1334471: 16120918,
      1334072: 16120919,
      1335995: 16120920,
      1336065: 16120931,
      1335935: 16120987,
      1336017: 16120988,
      1335973: 16120989,
      1336057: 16120990,
      1333943: 16120995,
      1333802: 16120996,
      1334670: 16120997,
      1335888: 16121e3,
      1334319: 16121001,
      1333992: 16121003,
      1333800: 16121004,
      1333614: 16121005,
      1335987: 16121006,
      1335953: 16121010,
      1335983: 16121011,
      1336021: 16121012,
      1336053: 16121013,
      1335989: 16121018,
      1335967: 16121019,
      1335945: 16121020,
      1336125: 16121021,
      1333299: 16121022,
      1336091: 16121023,
      1332636: 16121024,
      1336137: 16121049,
      1335951: 16121050,
      1333598: 16121053,
      1333482: 16121054,
      1336119: 16121055,
      1336049: 16121063,
      1336045: 16121064,
      1336023: 16121065,
      1335915: 16121066,
      1335937: 16121069,
      1335922: 16121070,
      1336135: 16121076,
      1336107: 16121077,
      1336083: 16121078,
      1336005: 16121079,
      1335985: 16121080,
      1335975: 16121081,
      1335947: 16121082,
      1335914: 16121083,
      1335899: 16121084,
      1335751: 16121086,
      1336035: 16121087,
      1335907: 16121092,
      1335892: 16121093,
      1333315: 16121094,
      1336117: 16121095,
      1334753: 16121096,
      1334659: 16121097,
      1336011: 16121098,
      1336067: 16121099,
      1336003: 16121100,
      1335981: 16121101,
      1335977: 16121103,
      1335963: 16121104,
      1335939: 16121105,
      1335929: 16121106,
      1335761: 16121107,
      1335609: 16121108,
      1334694: 16121109,
      1335911: 16121111,
      1335794: 16121112,
      1335719: 16121113,
      1335573: 16121114,
      1335241: 16121115,
      1334225: 16121116,
      1333977: 16121117,
      1336007: 16121118,
      1335993: 16121119,
      1335971: 16121120,
      1335955: 16121121,
      1335931: 16121122,
      1335905: 16121123,
      1335897: 16121124,
      1335735: 16121125,
      1335126: 16121126,
      1335639: 16121141,
      1335227: 16121142,
      1334993: 16121143,
      1334740: 16121144,
      1336051: 16121145,
      1333897: 16121146,
      1333580: 16121148,
      1333495: 16121149,
      1333348: 16121150,
      1336101: 16121151,
      1332706: 16121152,
      1332590: 16121153,
      1335909: 16121157,
      1335447: 16121158,
      1334965: 16121159,
      1334843: 16121160,
      1334445: 16121161,
      1334275: 16121162,
      1334257: 16121163,
      1334020: 16121164,
      1333743: 16121165,
      1333499: 16121166,
      1333040: 16121167,
      1332646: 16121168,
      1335597: 16121178,
      1335423: 16121179,
      1335250: 16121180,
      1334792: 16121181,
      1334488: 16121182,
      1334287: 16121183,
      1334240: 16121184,
      1333969: 16121185,
      1333594: 16121186,
      1333416: 16121187,
      1333324: 16121188,
      1333086: 16121191,
      1332683: 16121192,
      1332558: 16121193,
      1335428: 16121200,
      1335141: 16121201,
      1334903: 16121202,
      1334617: 16121203,
      1334374: 16121204,
      1333505: 16121205,
      1333342: 16121206,
      1333318: 16121207,
      1332666: 16121208,
      1332604: 16121209,
      1332563: 16121210,
      1334661: 16121220,
      1334331: 16121221,
      1333909: 16121222,
      1333303: 16121223,
      1332703: 16121224,
      1332614: 16121225,
      1332586: 16121226,
      1336111: 16121246,
      1336079: 16121247,
      1336039: 16121249,
      1336027: 16121250,
      1333745: 16121255,
      1333360: 16121256,
      1332584: 16121257,
      1336143: 16121270,
      1333604: 16121280,
      1332688: 16121281,
      1332611: 16121282,
      1332572: 16121283,
      1333517: 16121338,
      1333322: 16121339,
      1333116: 16121340,
      1332661: 16121345,
      1333283: 16121386,
      1336149: 16121398,
      1332711: 16121399,
      1336141: 16121412,
      1336127: 16121413,
      1336115: 16121414,
      1336109: 16121415,
      1336093: 16121416,
      1336071: 16121417,
      1336147: 16121450,
      1336133: 16121451,
      1336038: 16121452,
      1335991: 16121453,
      1335965: 16121454,
      1335957: 16121455,
      1335927: 16121456,
      1335903: 16121457,
      1335742: 16121458,
      1336139: 16121466,
      1336121: 16121467,
      1336105: 16121468,
      1336085: 16121469,
      1336069: 16121470,
      1336059: 16121471,
      1336009: 16121472,
      1335920: 16121473,
      1335615: 16121474,
      1335340: 16121475,
      1335129: 16121476,
      1334973: 16121496,
      1334872: 16121497,
      1336089: 16231786,
      1336131: 16231964,
      1336099: 16232139,
      1336075: 16232140,
      1336033: 16232141,
      1334012: 16232142,
      1685455: 16234723,
      1685976: 16234725,
      1685914: 16234726,
      1685803: 16234875,
      1685690: 16234876,
      1684570: 16234877,
      1682896: 16234878,
      1681132: 16234879,
      1681021: 16234880,
      1680981: 16234881,
      1675785: 16234882,
      1675414: 16234883,
      1675216: 16234884,
      1675061: 16234885,
      1632921: 16234886,
      1633519: 16234889,
      1633442: 16234890,
      1680973: 16234941,
      1685696: 16234944,
      1685677: 16234972,
      1685850: 16234976,
      1685659: 16234977,
      1685640: 16234978,
      1681164: 16234979,
      1681126: 16234980,
      1684549: 16234985,
      1681659: 16234986,
      1681183: 16234987,
      1680991: 16234988,
      1675791: 16234989,
      1675354: 16234990,
      1675182: 16234991,
      1689989: 16234992,
      1633554: 16234994,
      1633402: 16234995,
      1632849: 16234996,
      1632562: 16234997,
      1631942: 16234998,
      1631317: 16234999,
      1684183: 16235008,
      1675913: 16235009,
      1685769: 16235010,
      1684584: 16235011,
      1684562: 16235012,
      1681650: 16235013,
      1681006: 16235014,
      1680860: 16235015,
      1675989: 16235016,
      1675868: 16235017,
      1675506: 16235018,
      1681511: 16235048,
      1675423: 16235049,
      1685990: 16235052,
      1682552: 16235053,
      1685685: 16235071,
      1681138: 16235081,
      1685920: 16235083,
      1685653: 16235084,
      1685645: 16235085,
      1683688: 16235086,
      1681012: 16235087,
      1680845: 16235088,
      1632720: 16235108,
      1675010: 16235109,
      1685831: 16235110,
      1685763: 16235111,
      1684578: 16235112,
      1684512: 16235113,
      1681028: 16235114,
      1680852: 16235115,
      1680815: 16235116,
      1675882: 16235117,
      1675820: 16235118,
      1675432: 16235119,
      1675255: 16235120,
      1675089: 16235121,
      1674950: 16235122,
      1633405: 16235124,
      1632588: 16235125,
      1632295: 16235126,
      1685931: 16235128,
      1685782: 16235129,
      1685707: 16235130,
      1685591: 16235131,
      1681171: 16235132,
      1681e3: 16235133,
      1680890: 16235134,
      1680824: 16235135,
      1675770: 16235136,
      1675500: 16235137,
      1675211: 16235138,
      1690143: 16235139,
      1633499: 16235141,
      1633414: 16235142,
      1633255: 16235143,
      1633172: 16235144,
      1633487: 16235145,
      1633243: 16235146,
      1633074: 16235147,
      1632322: 16235148,
      1631415: 16235149,
      1631286: 16235150,
      1630176: 16235151,
      1629547: 16235152,
      1685605: 16235153,
      1681945: 16235154,
      1681120: 16235155,
      1680883: 16235156,
      1680709: 16235157,
      1675862: 16235158,
      1675379: 16235159,
      1675095: 16235160,
      1674897: 16235161,
      1629912: 16235162,
      1689568: 16235163,
      1633463: 16235165,
      1632872: 16235166,
      1632577: 16235167,
      1632344: 16235168,
      1631933: 16235169,
      1631461: 16235170,
      1630084: 16235171,
      1629905: 16235172,
      1685231: 16235173,
      1684188: 16235174,
      1681177: 16235175,
      1681034: 16235176,
      1680717: 16235177,
      1675764: 16235178,
      1675407: 16235179,
      1632277: 16235180,
      1633491: 16235183,
      1633411: 16235184,
      1633202: 16235185,
      1632327: 16235186,
      1631868: 16235187,
      1631320: 16235188,
      1630181: 16235189,
      1629647: 16235190,
      1690128: 16235191,
      1688246: 16235192,
      1680926: 16235193,
      1680703: 16235194,
      1675420: 16235195,
      1675223: 16235196,
      1675081: 16235197,
      1633515: 16235198,
      1633421: 16235199,
      1633175: 16235200,
      1632927: 16235201,
      1632635: 16235202,
      1632286: 16235203,
      1631829: 16235204,
      1630081: 16235205,
      1629726: 16235206,
      1629364: 16235207,
      1690093: 16235209,
      1690044: 16235210,
      1689783: 16235211,
      1689686: 16235212,
      1680837: 16235213,
      1675826: 16235214,
      1675387: 16235215,
      1675295: 16235216,
      1633199: 16235217,
      1632252: 16235218,
      1633474: 16235219,
      1633178: 16235220,
      1632824: 16235221,
      1632738: 16235222,
      1632585: 16235223,
      1632247: 16235224,
      1631734: 16235225,
      1631303: 16235226,
      1629921: 16235227,
      1690088: 16235228,
      1690116: 16235230,
      1689751: 16235231,
      1689737: 16235232,
      1677218: 16235233,
      1675779: 16235234,
      1675261: 16235235,
      1674956: 16235236,
      1631710: 16235237,
      1633557: 16235239,
      1633506: 16235240,
      1633484: 16235241,
      1633427: 16235242,
      1633194: 16235243,
      1632629: 16235244,
      1632271: 16235245,
      1631300: 16235246,
      1631280: 16235247,
      1629607: 16235248,
      1629539: 16235249,
      1629287: 16235250,
      1689890: 16235251,
      1675248: 16235253,
      1675196: 16235254,
      1674963: 16235255,
      1631069: 16235258,
      1633214: 16235260,
      1632941: 16235261,
      1632479: 16235262,
      1631838: 16235263,
      1630197: 16235264,
      1629589: 16235265,
      1629234: 16235266,
      1690234: 16235267,
      1689997: 16235268,
      1689457: 16235269,
      1689346: 16235270,
      1688287: 16235271,
      1688134: 16235272,
      1689663: 16235273,
      1689524: 16235274,
      1689378: 16235275,
      1688370: 16235276,
      1687983: 16235277,
      1633167: 16235281,
      1632866: 16235282,
      1632632: 16235283,
      1632482: 16235284,
      1631731: 16235285,
      1629524: 16235286,
      1629350: 16235287,
      1690033: 16235288,
      1689444: 16235289,
      1690122: 16235291,
      1690082: 16235292,
      1689935: 16235293,
      1689675: 16235294,
      1689639: 16235295,
      1689543: 16235296,
      1689475: 16235297,
      1689430: 16235298,
      1689358: 16235299,
      1688253: 16235300,
      1631922: 16235301,
      1631487: 16235302,
      1629628: 16235303,
      1688382: 16235305,
      1690104: 16235307,
      1690004: 16235308,
      1689657: 16235309,
      1689482: 16235310,
      1688391: 16235311,
      1688241: 16235312,
      1688217: 16235313,
      1687996: 16235314,
      1629622: 16235321,
      1629312: 16235322,
      1689668: 16235325,
      1690018: 16235326,
      1689772: 16235327,
      1689680: 16235328,
      1689535: 16235329,
      1689462: 16235330,
      1689435: 16235331,
      1688281: 16235332,
      1688147: 16235333,
      1688048: 16235334,
      1687973: 16235335,
      1629479: 16235341,
      1689835: 16235343,
      1689698: 16235344,
      1688294: 16235345,
      1688187: 16235346,
      1688002: 16235347,
      1687977: 16235348,
      1629407: 16235361,
      1689743: 16235362,
      1690109: 16235364,
      1689800: 16235365,
      1689517: 16235366,
      1688422: 16235367,
      1688180: 16235368,
      1687967: 16235369,
      1690228: 16235382,
      1690039: 16235383,
      1689942: 16235384,
      1689793: 16235385,
      1689641: 16235386,
      1689608: 16235387,
      1688234: 16235388,
      1688153: 16235389,
      1688129: 16235400,
      1689554: 16235410,
      1689549: 16235411,
      1689469: 16235412,
      1689384: 16235413,
      1688140: 16235414,
      1688042: 16235415,
      1689601: 16235430,
      1689450: 16235431,
      1689351: 16235432,
      1687990: 16235433,
      1688223: 16235450,
      1342582: 16855008,
      1189782: 16855009,
      1189609: 16857674,
      1189335: 16857675,
      1342586: 16857676,
      1189766: 16857677,
      1189748: 16857678,
      1189708: 16857679,
      1189702: 16857680,
      1331159: 16857681,
      1189664: 16857682,
      1189656: 16857683,
      1189641: 16857684,
      1189615: 16857685,
      1189565: 16857686,
      1189553: 16857687,
      1189508: 16857688,
      1330850: 16857726,
      1189728: 16857731,
      1189786: 16857734,
      1189770: 16857735,
      1189738: 16857736,
      1331249: 16857737,
      1189724: 16857738,
      1189696: 16857739,
      1189670: 16857740,
      1189658: 16857741,
      1189623: 16857742,
      1189613: 16857743,
      1189333: 16857971,
      1189631: 16857972,
      1189371: 16857973,
      1189706: 16857974,
      1189710: 16858033,
      1189349: 16858034,
      1189321: 16858035,
      1340541: 16858036,
      1189776: 16858037,
      1189762: 16858038,
      1189734: 16858039,
      1189718: 16858040,
      1189686: 16858041,
      1189672: 16858042,
      1189662: 16858043,
      1189637: 16858044,
      1189607: 16858045,
      1189587: 16858046,
      1331007: 16858175,
      1189571: 16858176,
      1189539: 16858177,
      1342589: 16858180,
      1189768: 16858181,
      1189754: 16858182,
      1189740: 16858183,
      1189726: 16858184,
      1189591: 16858188,
      4579694: 16858192,
      1189772: 16858193,
      1189750: 16858194,
      1189742: 16858195,
      1189722: 16858196,
      1189676: 16858197,
      1189668: 16858198,
      1331125: 16858199,
      1189643: 16858200,
      1331080: 16858201,
      1189619: 16858202,
      1189595: 16858203,
      1189381: 16858231,
      1189426: 16858232,
      1189521: 16858233,
      1189778: 16858237,
      1189756: 16858238,
      1189712: 16858239,
      1189704: 16858240,
      1189682: 16858241,
      1189313: 16858258,
      1189652: 16858259,
      1189452: 16858260,
      1342575: 16858273,
      1189774: 16858274,
      1331207: 16858275,
      1189678: 16858276,
      1189648: 16858277,
      1189635: 16858278,
      1189578: 16858279,
      4579793: 16858280,
      1189780: 16858281,
      1189764: 16858282,
      1189752: 16858283,
      1189698: 16858284,
      1189674: 16858285,
      1189660: 16858286,
      1189650: 16858287,
      1189627: 16858288,
      1189621: 16858289,
      1189582: 16858290,
      1189569: 16858291,
      1330875: 16858292,
      1189551: 16858293,
      1189519: 16858294,
      1189504: 16858295,
      1189496: 16858296,
      1189476: 16858297,
      1189694: 16858298,
      1189784: 16858302,
      1189758: 16858303,
      1189746: 16858304,
      1189730: 16858305,
      1189716: 16858306,
      1189700: 16858307,
      1189639: 16858308,
      1189605: 16858309,
      1189593: 16858310,
      1189529: 16858311,
      1189513: 16858312,
      1189494: 16858313,
      1189482: 16858314,
      1189462: 16858315,
      1189456: 16858316,
      1330692: 16858317,
      1342594: 16858320,
      1189760: 16858321,
      1189744: 16858322,
      1189732: 16858323,
      1189720: 16858324,
      1189684: 16858325,
      1189654: 16858326,
      1189617: 16858327,
      1189597: 16858328,
      1189547: 16858329,
      1189517: 16858330,
      1330810: 16858331,
      1189492: 16858332,
      1189480: 16858333,
      1189464: 16858334,
      1189454: 16858335,
      1189415: 16858336,
      1189389: 16858337,
      1189680: 16858338,
      1189633: 16858339,
      1189629: 16858354,
      1189611: 16858355,
      1331038: 16858356,
      1189601: 16858357,
      1330915: 16858358,
      1189555: 16858359,
      1189541: 16858360,
      1189470: 16858361,
      1330735: 16858362,
      1189442: 16858363,
      1189428: 16858364,
      1189413: 16858365,
      1189393: 16858366,
      1189373: 16858367,
      1189359: 16858368,
      1330459: 16858369,
      1189309: 16858370,
      1189148: 16858371,
      1188938: 16858372,
      1189599: 16858375,
      1189567: 16858376,
      1189543: 16858377,
      1189523: 16858378,
      1189498: 16858379,
      1189468: 16858380,
      1189458: 16858381,
      1189446: 16858382,
      1189422: 16858383,
      1330598: 16858384,
      1189399: 16858385,
      1330566: 16858386,
      1189347: 16858387,
      1189176: 16858388,
      1189028: 16858389,
      1189294: 16858390,
      1189280: 16858391,
      1189266: 16858392,
      1189260: 16858393,
      1189220: 16858394,
      1189589: 16858395,
      1189561: 16858396,
      1189549: 16858397,
      1189537: 16858398,
      1189527: 16858399,
      1189515: 16858400,
      1189506: 16858401,
      1189486: 16858402,
      1189436: 16858403,
      1189432: 16858404,
      1189409: 16858405,
      1189387: 16858406,
      1330508: 16858407,
      1189302: 16858408,
      1189284: 16858409,
      1189274: 16858412,
      1189254: 16858413,
      1189242: 16858414,
      1189576: 16858415,
      1189545: 16858416,
      1189525: 16858417,
      1189502: 16858418,
      1189500: 16858419,
      1189472: 16858420,
      1189460: 16858421,
      1189444: 16858422,
      1189434: 16858423,
      1189405: 16858424,
      1189385: 16858425,
      1189363: 16858426,
      1189361: 16858427,
      1189329: 16858428,
      1189136: 16858429,
      1189264: 16858431,
      1189252: 16858432,
      1189230: 16858433,
      1189199: 16858434,
      1189574: 16858435,
      1189563: 16858436,
      1189533: 16858437,
      1189490: 16858438,
      1330781: 16858439,
      1189424: 16858440,
      1189351: 16858441,
      1189317: 16858442,
      1189311: 16858443,
      1237653: 16858445,
      1189298: 16858449,
      1189282: 16858450,
      1189268: 16858451,
      1189256: 16858452,
      1189248: 16858453,
      1189224: 16858454,
      1189557: 16858455,
      1189531: 16858456,
      1189484: 16858457,
      1189474: 16858458,
      1189450: 16858459,
      1189411: 16858460,
      1189397: 16858461,
      1189391: 16858462,
      1189353: 16858463,
      1189343: 16858464,
      1189051: 16858465,
      1189240: 16858466,
      1189288: 16858470,
      1189270: 16858471,
      1189250: 16858472,
      1189234: 16858473,
      1189216: 16858474,
      1189478: 16858475,
      1189430: 16858476,
      1189407: 16858477,
      1189379: 16858478,
      1189375: 16858479,
      1189355: 16858480,
      1189345: 16858481,
      1189325: 16858482,
      1189095: 16858485,
      1189126: 16858486,
      1189286: 16858488,
      1189276: 16858489,
      1189236: 16858490,
      1189158: 16858491,
      1189150: 16858492,
      1331869: 16858493,
      1189122: 16858494,
      1189448: 16858495,
      1189440: 16858496,
      1189403: 16858497,
      1189383: 16858498,
      1189369: 16858499,
      1189357: 16858500,
      1189327: 16858501,
      1189319: 16858502,
      1189214: 16858503,
      1189292: 16858506,
      1189262: 16858507,
      1189258: 16858508,
      1189210: 16858509,
      1189201: 16858510,
      1189178: 16858511,
      1189164: 16858512,
      1189128: 16858513,
      1189083: 16858514,
      1189420: 16858515,
      1189401: 16858516,
      1189367: 16858517,
      1189341: 16858518,
      1189323: 16858519,
      1189315: 16858520,
      1189002: 16858521,
      1189290: 16858524,
      1189272: 16858525,
      1189246: 16858526,
      1189238: 16858527,
      1189212: 16858528,
      1189203: 16858529,
      1189197: 16858530,
      1189170: 16858531,
      1189156: 16858532,
      1189114: 16858533,
      1331769: 16858534,
      1189377: 16858535,
      1189339: 16858536,
      1189331: 16858537,
      1189059: 16858538,
      1188971: 16858539,
      1189232: 16858541,
      1189222: 16858542,
      1189218: 16858543,
      1189174: 16858544,
      1189160: 16858545,
      1189124: 16858546,
      1189104: 16858547,
      1189065: 16858548,
      1189026: 16858549,
      1189004: 16858550,
      1188990: 16858551,
      1188947: 16858552,
      1188940: 16858553,
      1188924: 16858554,
      4579887: 16858558,
      1189296: 16858559,
      1189278: 16858560,
      1189226: 16858561,
      1189191: 16858562,
      1189172: 16858563,
      1331958: 16858564,
      1189132: 16858565,
      1189112: 16858566,
      1189087: 16858567,
      1331627: 16858568,
      1189041: 16858569,
      1189022: 16858570,
      1188986: 16858571,
      1188982: 16858572,
      1188965: 16858573,
      1237740: 16858574,
      1237704: 16858575,
      1189205: 16858576,
      1189195: 16858577,
      1189180: 16858578,
      1189141: 16858579,
      1189134: 16858580,
      1189110: 16858581,
      1189093: 16858582,
      1189073: 16858583,
      1189039: 16858584,
      1331528: 16858585,
      1188934: 16858586,
      1188912: 16858587,
      1188893: 16858588,
      1163277: 16858589,
      1163378: 16858590,
      1237766: 16858592,
      1163501: 16858593,
      1163472: 16858594,
      1163462: 16858595,
      1350920: 16858596,
      1189189: 16858597,
      1189154: 16858598,
      1189130: 16858599,
      1189106: 16858600,
      1189091: 16858601,
      1189049: 16858602,
      1189043: 16858603,
      1189024: 16858604,
      1331532: 16858605,
      1189006: 16858606,
      1188992: 16858607,
      1188969: 16858608,
      1188953: 16858609,
      1188926: 16858610,
      1188902: 16858611,
      1163306: 16858612,
      1237757: 16858615,
      1189193: 16858616,
      1189187: 16858617,
      1189168: 16858618,
      1189139: 16858619,
      1189081: 16858620,
      1189063: 16858621,
      1189e3: 16858622,
      1188988: 16858623,
      1188961: 16858624,
      1188955: 16858625,
      1188908: 16858626,
      1163241: 16858628,
      1163487: 16858632,
      1163468: 16858633,
      1163447: 16858634,
      1163427: 16858635,
      1189182: 16858636,
      1189152: 16858637,
      1189118: 16858638,
      1189116: 16858639,
      1189099: 16858640,
      1189085: 16858641,
      1189069: 16858642,
      1189053: 16858643,
      1189045: 16858644,
      1189032: 16858645,
      1189012: 16858646,
      1188957: 16858647,
      1188949: 16858648,
      1188928: 16858649,
      1188914: 16858650,
      1163398: 16858651,
      1163509: 16858652,
      1189162: 16858656,
      1189146: 16858657,
      1189089: 16858658,
      1189067: 16858659,
      1189047: 16858660,
      1189008: 16858661,
      1188998: 16858662,
      1188984: 16858663,
      1331446: 16858664,
      1188936: 16858665,
      1188904: 16858666,
      1237718: 16858667,
      1163222: 16858668,
      1237768: 16858672,
      1163489: 16858673,
      1163478: 16858674,
      1163449: 16858675,
      1189108: 16858676,
      1189077: 16858677,
      1189071: 16858678,
      1189057: 16858679,
      1189030: 16858680,
      1189014: 16858681,
      1188977: 16858682,
      1188973: 16858683,
      1188963: 16858684,
      1188942: 16858685,
      1188930: 16858686,
      1188910: 16858687,
      1163170: 16858688,
      1237728: 16858690,
      1237667: 16858691,
      1163507: 16858692,
      1163483: 16858693,
      1163441: 16858694,
      1163423: 16858695,
      1189061: 16858696,
      1189020: 16858697,
      1188994: 16858698,
      1188996: 16858699,
      1331452: 16858700,
      1188920: 16858701,
      1163187: 16858704,
      1237624: 16858708,
      1163458: 16858709,
      1163437: 16858710,
      1163402: 16858711,
      1163386: 16858712,
      1163376: 16858713,
      1163338: 16858714,
      1163304: 16858715,
      1189034: 16858716,
      1189018: 16858717,
      1188967: 16858718,
      1188959: 16858719,
      1188916: 16858720,
      1188906: 16858721,
      1163354: 16858722,
      4580044: 16858723,
      1237770: 16858724,
      1237692: 16858725,
      1237651: 16858726,
      1163511: 16858727,
      1163497: 16858728,
      1163464: 16858729,
      1163439: 16858730,
      1163421: 16858731,
      1163407: 16858732,
      1163390: 16858733,
      1163370: 16858734,
      1163352: 16858735,
      1188951: 16858736,
      1188932: 16858737,
      1188918: 16858738,
      1188900: 16858739,
      1237711: 16858743,
      1163503: 16858744,
      1163495: 16858745,
      1163476: 16858746,
      1163454: 16858747,
      1163435: 16858748,
      1163425: 16858754,
      1163413: 16858755,
      1237764: 16858757,
      1163513: 16858758,
      1163493: 16858759,
      1163470: 16858760,
      1163419: 16858761,
      1163368: 16858762,
      1163342: 16858763,
      1163330: 16858764,
      1163312: 16858765,
      1163292: 16858766,
      1163285: 16858767,
      1163257: 16858768,
      1163239: 16858769,
      1163163: 16858770,
      1237665: 16858777,
      1163515: 16858778,
      1163491: 16858779,
      1163466: 16858780,
      1163443: 16858781,
      1163429: 16858782,
      1163415: 16858783,
      1163396: 16858784,
      1163326: 16858785,
      1163298: 16858786,
      1163255: 16858787,
      1163249: 16858788,
      1163220: 16858789,
      1163201: 16858790,
      1163195: 16858791,
      1163174: 16858792,
      1163499: 16858797,
      1163474: 16858798,
      1163460: 16858799,
      1163431: 16858800,
      1163392: 16858801,
      1163382: 16858802,
      1163372: 16858803,
      1163332: 16858804,
      1163283: 16858805,
      1163261: 16858806,
      1163237: 16858807,
      1163212: 16858808,
      1163185: 16858809,
      1163445: 16858817,
      1163350: 16858818,
      1163324: 16858819,
      1163302: 16858820,
      1163267: 16858821,
      1163251: 16858822,
      1163218: 16858823,
      1163189: 16858824,
      1163168: 16858825,
      1163417: 16858837,
      1163380: 16858838,
      1163346: 16858839,
      1163328: 16858840,
      1163287: 16858841,
      1163243: 16858843,
      1163227: 16858844,
      1163210: 16858845,
      1163193: 16858846,
      1163172: 16858847,
      1163411: 16858856,
      1163374: 16858857,
      1163336: 16858858,
      1163322: 16858859,
      1163314: 16858860,
      1163296: 16858861,
      1163279: 16858862,
      1163400: 16858876,
      1163384: 16858877,
      1163363: 16858878,
      1163356: 16858879,
      1163344: 16858880,
      1163310: 16858881,
      1163281: 16858882,
      1163259: 16858883,
      1163205: 16858884,
      1163166: 16858885,
      1163394: 16858896,
      1163348: 16858897,
      1163318: 16858898,
      1163308: 16858899,
      1163269: 16858900,
      1163265: 16858901,
      1163263: 16858902,
      1163247: 16858903,
      1163208: 16858904,
      1163197: 16858905,
      1163179: 16858906,
      1163334: 16858916,
      1163316: 16858917,
      1163300: 16858918,
      1163275: 16858919,
      1163235: 16858920,
      1163216: 16858921,
      1163191: 16858922,
      1163158: 16858923,
      1163233: 16858936,
      1163214: 16858937,
      1163199: 16858938,
      1163177: 16858939,
      1163245: 16858966,
      1163231: 16858967,
      1163181: 16858968,
      1740519: 16869204,
      1741109: 16869205,
      1740559: 16869206,
      1740527: 16869207,
      1740507: 16869208,
      1740511: 16869209,
      1740552: 16869581,
      1740512: 16869582,
      1740493: 16869583,
      1740469: 16869584,
      1740529: 16869605,
      1740545: 16869606,
      1740487: 16869609,
      1740472: 16869610,
      1740466: 16869611,
      1740448: 16869612,
      1598344: 16869613,
      1598248: 16869614,
      1739373: 16869616,
      1598425: 16869617,
      1598418: 16869618,
      1598409: 16869619,
      1740501: 16869790,
      1741115: 16869791,
      1740561: 16869903,
      1740482: 16869904,
      1741119: 16869907,
      1740548: 16869908,
      1740521: 16869978,
      1740557: 16869981,
      1740563: 16869982,
      1740541: 16869983,
      1740538: 16869984,
      1740489: 16870050,
      1740560: 16870052,
      1740551: 16870053,
      1740533: 16870054,
      1740535: 16870055,
      1740517: 16870056,
      1740498: 16870057,
      1598396: 16870059,
      1740562: 16870062,
      1740537: 16870063,
      1740516: 16870064,
      1740497: 16870065,
      1740502: 16870066,
      1740461: 16870067,
      1740452: 16870068,
      1598218: 16870069,
      1598451: 16870073,
      1598438: 16870074,
      1730909: 16870075,
      1740525: 16870077,
      1740526: 16870078,
      1740477: 16870079,
      1740464: 16870080,
      1740455: 16870081,
      1598288: 16870082,
      1598457: 16870086,
      1598452: 16870087,
      1598442: 16870088,
      1730917: 16870089,
      1740536: 16870121,
      1740550: 16870122,
      1740549: 16870124,
      1740544: 16870125,
      1740520: 16870126,
      1740558: 16870129,
      1740553: 16870130,
      1740543: 16870131,
      1740534: 16870132,
      1740522: 16870133,
      1740509: 16870134,
      1740480: 16870135,
      1740473: 16870136,
      1740465: 16870137,
      1598318: 16870138,
      1598222: 16870139,
      1598455: 16870140,
      1598448: 16870141,
      1598444: 16870142,
      1598431: 16870143,
      1598421: 16870144,
      1598447: 16870145,
      1598436: 16870146,
      1730933: 16870147,
      1598430: 16870148,
      1598415: 16870149,
      1598408: 16870150,
      1740542: 16870151,
      1740528: 16870152,
      1740510: 16870153,
      1740503: 16870154,
      1740488: 16870155,
      1740478: 16870156,
      1740470: 16870157,
      1598206: 16870160,
      1598443: 16870162,
      1598437: 16870163,
      1598435: 16870164,
      1598427: 16870165,
      1598423: 16870166,
      1598405: 16870167,
      1598375: 16870168,
      1598370: 16870169,
      1598361: 16870170,
      1740518: 16870171,
      1740513: 16870172,
      1740499: 16870173,
      1740491: 16870174,
      1740490: 16870175,
      1740483: 16870176,
      1740462: 16870177,
      1740456: 16870178,
      1598386: 16870179,
      1598295: 16870180,
      1598456: 16870184,
      1598450: 16870185,
      1598439: 16870186,
      1598411: 16870187,
      1598410: 16870188,
      1598400: 16870189,
      1598397: 16870190,
      1740508: 16870191,
      1740500: 16870192,
      1598434: 16870193,
      1598351: 16870194,
      1598241: 16870195,
      1598232: 16870196,
      1598458: 16870200,
      1598454: 16870201,
      1598441: 16870202,
      1598433: 16870203,
      1598406: 16870204,
      1598399: 16870205,
      1598387: 16870206,
      1598381: 16870207,
      1598358: 16870208,
      1598349: 16870209,
      1730872: 16870210,
      1740492: 16870211,
      1740479: 16870212,
      1740457: 16870213,
      1598374: 16870214,
      1730856: 16870215,
      1598413: 16870216,
      1598459: 16870219,
      1598453: 16870220,
      1598446: 16870221,
      1598390: 16870222,
      1730893: 16870223,
      1598380: 16870224,
      1598331: 16870225,
      1598302: 16870226,
      1598292: 16870227,
      1598282: 16870228,
      1598275: 16870229,
      1598263: 16870230,
      1740481: 16870231,
      1740471: 16870232,
      1740463: 16870233,
      1740454: 16870234,
      1598412: 16870235,
      1730765: 16870236,
      1739357: 16870238,
      1598440: 16870239,
      1598426: 16870240,
      1598417: 16870241,
      1598402: 16870242,
      1598393: 16870243,
      1598385: 16870244,
      1598368: 16870245,
      1598360: 16870246,
      1598357: 16870247,
      1598347: 16870248,
      1598330: 16870249,
      1598315: 16870250,
      1740453: 16870251,
      1598366: 16870252,
      1598460: 16870256,
      1598449: 16870257,
      1598445: 16870258,
      1598424: 16870259,
      1598422: 16870260,
      1598383: 16870261,
      1598372: 16870262,
      1598345: 16870263,
      1598326: 16870264,
      1598309: 16870265,
      1598299: 16870266,
      1598285: 16870267,
      1598271: 16870268,
      1598257: 16870269,
      1598245: 16870270,
      1598373: 16870271,
      1730885: 16870272,
      1598354: 16870273,
      1598340: 16870274,
      1598319: 16870275,
      1730952: 16870276,
      1598311: 16870277,
      1598291: 16870278,
      1598289: 16870279,
      1598278: 16870280,
      1730742: 16870281,
      1598244: 16870282,
      1598223: 16870283,
      1598220: 16870284,
      1598202: 16870285,
      1598398: 16870289,
      1598395: 16870290,
      1598371: 16870291,
      1598334: 16870292,
      1598316: 16870293,
      1598306: 16870294,
      1598304: 16870295,
      1598286: 16870296,
      1598265: 16870297,
      1598255: 16870298,
      1598221: 16870299,
      1598200: 16870300,
      1730903: 16870309,
      1598388: 16870310,
      1598377: 16870311,
      1598362: 16870312,
      1730879: 16870313,
      1598346: 16870314,
      1598339: 16870315,
      1598325: 16870316,
      1730838: 16870317,
      1598303: 16870318,
      1598290: 16870319,
      1598276: 16870320,
      1598251: 16870321,
      1598249: 16870322,
      1598238: 16870323,
      1598235: 16870324,
      1598214: 16870325,
      1598207: 16870326,
      1598198: 16870327,
      1598392: 16870329,
      1598384: 16870330,
      1598367: 16870331,
      1598333: 16870332,
      1598307: 16870333,
      1598293: 16870334,
      1598279: 16870335,
      1598272: 16870336,
      1598252: 16870337,
      1730675: 16870338,
      1598230: 16870339,
      1598212: 16870340,
      1598364: 16870349,
      1598359: 16870350,
      1598348: 16870351,
      1598336: 16870352,
      1598322: 16870353,
      1598312: 16870354,
      1598266: 16870355,
      1598258: 16870356,
      1598237: 16870357,
      1598236: 16870358,
      1598224: 16870359,
      1730664: 16870360,
      1730653: 16870361,
      1598355: 16870369,
      1598320: 16870370,
      1598313: 16870371,
      1598298: 16870372,
      1598280: 16870373,
      1598268: 16870374,
      1598262: 16870375,
      1598253: 16870376,
      1598332: 16870389,
      1598329: 16870390,
      1598317: 16870391,
      1598305: 16870392,
      1730822: 16870393,
      1598277: 16870394,
      1598250: 16870395,
      1598231: 16870396,
      1598217: 16870397,
      1598199: 16870398,
      1598264: 16870409,
      1598261: 16870410,
      1730718: 16870411,
      1598246: 16870412,
      1598234: 16870413,
      1598208: 16870414,
      1598227: 16870432,
      1598210: 16870433,
      1598243: 16870449,
      1598239: 16870450,
      1598225: 16870451,
      1598205: 16870452,
      1598211: 16870468,
      1598209: 16870469,
      2022051: 16871055,
      1802228: 16871060,
      2484189: 16871061,
      1782094: 16871062,
      1782061: 16871063,
      1781819: 16871064,
      1583223: 16871065,
      1554417: 16871066,
      1554368: 16871067,
      1989875: 16871068,
      1989946: 16871069,
      1989965: 16871071,
      1989939: 16871072,
      1989932: 16871073,
      2022021: 16871645,
      1338734: 16871646,
      2484184: 16871647,
      1782092: 16871648,
      1781955: 16871649,
      1781884: 16871650,
      1781825: 16871651,
      1781753: 16871652,
      1555321: 16871653,
      1554274: 16871654,
      1554085: 16871655,
      1782055: 16871656,
      1367060: 16871657,
      1400779: 16871658,
      1389774: 16871659,
      1356423: 16871660,
      1350722: 16871661,
      1892534: 16872537,
      1892324: 16872538,
      1989632: 16872539,
      1989645: 16872542,
      1989637: 16872543,
      1989629: 16872544,
      1989616: 16872545,
      1989600: 16872546,
      1890431: 16874068,
      1890364: 16874069,
      1782113: 16874073,
      2484199: 16874074,
      1782040: 16874075,
      1782038: 16874076,
      1781994: 16874077,
      1781822: 16874078,
      1554429: 16874079,
      1554382: 16874080,
      1387802: 16874784,
      1890333: 16874785,
      1554371: 16874786,
      1782112: 16874790,
      2484200: 16874791,
      2484180: 16874792,
      1782074: 16874793,
      1554381: 16874823,
      1781866: 16874824,
      2484186: 16874828,
      1583330: 16874873,
      1802460: 16874877,
      2484183: 16874878,
      1782013: 16874879,
      1781864: 16874880,
      1554332: 16874881,
      1371575: 16874957,
      1554266: 16874964,
      1350708: 16874965,
      1366770: 16874966,
      2484193: 16874968,
      1781976: 16874969,
      1781956: 16874970,
      1781776: 16874971,
      1583367: 16874972,
      1583310: 16874973,
      1604315: 16874992,
      1554073: 16874996,
      1989608: 16874997,
      1781755: 16874998,
      1781895: 16874999,
      1825848: 16875001,
      1360978: 16875002,
      2484185: 16875003,
      2484179: 16875004,
      1782057: 16875005,
      1781901: 16875006,
      1781848: 16875007,
      1781796: 16875008,
      1583323: 16875009,
      1781970: 16875051,
      1367908: 16875052,
      1827157: 16875053,
      1389894: 16875054,
      1387070: 16875055,
      1890778: 16875056,
      1890597: 16875057,
      1890467: 16875058,
      1890317: 16875059,
      1892768: 16875062,
      1892651: 16875063,
      2022081: 16875064,
      1350497: 16875069,
      1350579: 16875070,
      1350713: 16875071,
      1346370: 16875072,
      1351208: 16875074,
      1351099: 16875075,
      1351057: 16875076,
      1351027: 16875077,
      1350858: 16875078,
      1350773: 16875079,
      1350712: 16875080,
      1350691: 16875081,
      1350632: 16875082,
      1350487: 16875083,
      1554403: 16875093,
      1781992: 16875104,
      1890888: 16875105,
      1554230: 16875106,
      2484197: 16875111,
      1781899: 16875112,
      1781881: 16875113,
      1781751: 16875114,
      1583123: 16875115,
      1554236: 16875116,
      1373988: 16875117,
      1782072: 16875118,
      1781859: 16875119,
      1782116: 16875121,
      2484198: 16875122,
      2484181: 16875123,
      1782078: 16875124,
      1781996: 16875125,
      1781972: 16875126,
      1781879: 16875127,
      1781774: 16875128,
      1583314: 16875129,
      1554331: 16875130,
      1530462: 16875131,
      1782110: 16875132,
      1403527: 16875133,
      1389768: 16875134,
      1387800: 16875135,
      1449441: 16875136,
      1387132: 16875137,
      1351481: 16875138,
      1350626: 16875139,
      1350556: 16875140,
      1890889: 16875141,
      2022083: 16875142,
      1891042: 16875144,
      1890994: 16875145,
      1890937: 16875146,
      1890876: 16875147,
      1890826: 16875148,
      1890737: 16875149,
      1583322: 16875150,
      1554330: 16875151,
      1554197: 16875152,
      1554079: 16875153,
      1782089: 16875154,
      1781770: 16875155,
      1367200: 16875156,
      1352283: 16875157,
      1350732: 16875158,
      1350703: 16875159,
      1350573: 16875160,
      1890344: 16875161,
      2022059: 16875163,
      1890979: 16875164,
      1890925: 16875165,
      1890767: 16875166,
      2022047: 16875167,
      1890552: 16875168,
      1890480: 16875169,
      1583161: 16875170,
      1554397: 16875171,
      1554291: 16875172,
      1554264: 16875173,
      1554084: 16875174,
      1364844: 16875175,
      1782034: 16875176,
      1781842: 16875177,
      1372108: 16875178,
      1367322: 16875179,
      1636961: 16875180,
      1400627: 16875181,
      1398135: 16875182,
      1387111: 16875183,
      1357797: 16875184,
      1350736: 16875185,
      1350629: 16875186,
      1350499: 16875187,
      1891055: 16875189,
      1554334: 16875190,
      1554309: 16875191,
      1554273: 16875192,
      1554184: 16875193,
      1355690: 16875194,
      1781950: 16875195,
      1367585: 16875196,
      1351494: 16875197,
      1350574: 16875198,
      1890375: 16875199,
      1890319: 16875200,
      1892804: 16875201,
      1890976: 16875204,
      1890859: 16875205,
      1890839: 16875206,
      1890691: 16875207,
      1890505: 16875208,
      1554298: 16875210,
      1781877: 16875211,
      1781749: 16875212,
      1389928: 16875213,
      1350584: 16875214,
      1891045: 16875216,
      1891022: 16875219,
      1890999: 16875220,
      1890930: 16875221,
      2022052: 16875222,
      1890753: 16875223,
      2022022: 16875224,
      1890494: 16875225,
      1890422: 16875226,
      1892590: 16875227,
      1554092: 16875230,
      1782011: 16875231,
      1372321: 16875232,
      1367125: 16875233,
      1366713: 16875234,
      1399853: 16875235,
      1387061: 16875236,
      2218604: 16875237,
      1891017: 16875239,
      1891009: 16875240,
      1890954: 16875241,
      1890789: 16875242,
      1890734: 16875243,
      1890390: 16875244,
      1890318: 16875245,
      1892544: 16875246,
      1884435: 16875247,
      1892563: 16875249,
      1781787: 16875250,
      1367176: 16875251,
      1366964: 16875252,
      1408464: 16875253,
      1395959: 16875254,
      1387740: 16875255,
      1352193: 16875256,
      1890587: 16875257,
      1891032: 16875259,
      1890947: 16875260,
      1890866: 16875261,
      1890744: 16875262,
      1890452: 16875263,
      1890350: 16875264,
      1890326: 16875265,
      1892402: 16875266,
      1892822: 16875268,
      1892817: 16875269,
      1384354: 16875270,
      1351487: 16875271,
      1350715: 16875272,
      1350293: 16875273,
      1891035: 16875277,
      1890955: 16875278,
      1890628: 16875279,
      1890381: 16875280,
      1890359: 16875281,
      2021953: 16875282,
      1892140: 16875283,
      1892787: 16875284,
      1892591: 16875285,
      2022072: 16875286,
      1892431: 16875287,
      1892403: 16875288,
      1892286: 16875289,
      1891004: 16875291,
      2022054: 16875292,
      1890899: 16875293,
      1890807: 16875294,
      1890711: 16875295,
      1890645: 16875296,
      1890525: 16875297,
      1890323: 16875298,
      1989647: 16875299,
      1892739: 16875300,
      1892700: 16875301,
      1892603: 16875302,
      1892554: 16875303,
      1892424: 16875304,
      1892389: 16875305,
      1892248: 16875306,
      1892180: 16875307,
      1892069: 16875308,
      1892707: 16875309,
      1892667: 16875310,
      1892614: 16875311,
      2022067: 16875312,
      1892337: 16875313,
      1892242: 16875314,
      1892061: 16875315,
      1989652: 16875316,
      1890610: 16875317,
      2022020: 16875318,
      2021984: 16875319,
      1890322: 16875320,
      2022082: 16875321,
      1892809: 16875322,
      1892795: 16875325,
      742838: 16875326,
      1403528: 16875329,
      1349524: 16875330,
      1347160: 16875331,
      741984: 16875332,
      1405623: 16875333,
      1405406: 16875334,
      737778: 16875335,
      738254: 16875336,
      1890410: 16875337,
      1890338: 16875338,
      1892257: 16875341,
      1892801: 16875343,
      1892788: 16875344,
      1892730: 16875345,
      1892594: 16875346,
      1892099: 16875347,
      1892095: 16875348,
      1989631: 16875353,
      1989620: 16875354,
      1989609: 16875355,
      1989603: 16875356,
      1989650: 16875357,
      1892792: 16875360,
      1892699: 16875361,
      1892462: 16875362,
      1892376: 16875363,
      1892311: 16875364,
      1892196: 16875365,
      1892104: 16875366,
      1989628: 16875367,
      1989615: 16875368,
      1989651: 16875370,
      1989649: 16875371,
      1989639: 16875372,
      1989633: 16875373,
      1989624: 16875374,
      1989617: 16875375,
      1989642: 16875376,
      1989635: 16875377,
      1989626: 16875378,
      1989604: 16875379,
      1989592: 16875380,
      1989580: 16875381,
      1989949: 16875382,
      1989743: 16875383,
      1892755: 16875384,
      1884111: 16875385,
      1892454: 16875386,
      1336485: 16875387,
      1989638: 16875388,
      1989585: 16875389,
      1989648: 16875391,
      1989634: 16875392,
      1989618: 16875393,
      1989613: 16875394,
      1989599: 16875395,
      1989590: 16875396,
      1989749: 16875397,
      1989709: 16875400,
      1989701: 16875401,
      1989693: 16875402,
      1989688: 16875403,
      1892683: 16875404,
      1892527: 16875405,
      1892444: 16875406,
      1892363: 16875407,
      1892277: 16875408,
      1892249: 16875409,
      1892081: 16875410,
      1989942: 16875411,
      1989654: 16875413,
      1989641: 16875414,
      1989627: 16875415,
      1989619: 16875416,
      1989595: 16875417,
      1989587: 16875418,
      1989581: 16875419,
      1989750: 16875421,
      1989732: 16875422,
      1989725: 16875423,
      1892581: 16875424,
      2022071: 16875425,
      1892409: 16875426,
      2022066: 16875427,
      1892077: 16875428,
      1989598: 16875429,
      1989653: 16875431,
      1989640: 16875432,
      1989630: 16875433,
      1989625: 16875434,
      1989611: 16875435,
      1989605: 16875436,
      1989597: 16875437,
      1989589: 16875438,
      1989738: 16875439,
      1989746: 16875441,
      1989735: 16875442,
      1989726: 16875443,
      1892300: 16875444,
      2022065: 16875445,
      1892195: 16875446,
      1892168: 16875447,
      1892089: 16875448,
      1989719: 16875449,
      1989656: 16875451,
      1989655: 16875452,
      1989643: 16875453,
      1989622: 16875454,
      1989612: 16875455,
      1989601: 16875456,
      1989594: 16875457,
      1989591: 16875458,
      1989710: 16875459,
      1989748: 16875462,
      1989730: 16875463,
      2022061: 16875464,
      2022060: 16875465,
      1989644: 16875466,
      1989606: 16875467,
      1989646: 16875470,
      1989621: 16875471,
      1989583: 16875472,
      1989696: 16875473,
      1989752: 16875475,
      1989751: 16875476,
      1989745: 16875477,
      1989731: 16875478,
      1989722: 16875479,
      1989714: 16875480,
      1989708: 16875481,
      1989684: 16875482,
      1989682: 16875483,
      1989698: 16875484,
      1989636: 16875485,
      1989623: 16875486,
      1989614: 16875487,
      1989602: 16875488,
      1989584: 16875489,
      1989744: 16875490,
      1989747: 16875493,
      1989740: 16875494,
      1989729: 16875495,
      1989720: 16875496,
      1989713: 16875497,
      1989699: 16875498,
      1989695: 16875499,
      1989677: 16875500,
      1989963: 16875502,
      1989739: 16875504,
      1989736: 16875505,
      1989728: 16875506,
      1989711: 16875507,
      1989706: 16875508,
      1989700: 16875509,
      1989691: 16875510,
      1989610: 16875511,
      1989607: 16875512,
      1989588: 16875513,
      1989582: 16875514,
      1989716: 16875515,
      1989956: 16875516,
      1989742: 16875519,
      1989737: 16875520,
      1989727: 16875521,
      1989723: 16875522,
      1989692: 16875523,
      1989683: 16875524,
      1989679: 16875525,
      1374448: 16875526,
      1375367: 16875527,
      1374494: 16875528,
      1374476: 16875529,
      1374460: 16875530,
      1989596: 16875531,
      1989593: 16875532,
      1989586: 16875533,
      1989741: 16875536,
      1989733: 16875537,
      1989721: 16875538,
      1989703: 16875539,
      1989694: 16875540,
      1989687: 16875541,
      1989681: 16875542,
      1989961: 16875544,
      1989957: 16875545,
      1989933: 16875546,
      1989930: 16875547,
      1989921: 16875548,
      1989856: 16875549,
      1989885: 16875550,
      1989897: 16875551,
      1989882: 16875552,
      1989874: 16875553,
      1989873: 16875554,
      1989859: 16875555,
      1374512: 16875556,
      1989734: 16875558,
      1989715: 16875559,
      1989707: 16875560,
      1989702: 16875561,
      1989690: 16875562,
      1989686: 16875563,
      1989678: 16875564,
      1989959: 16875565,
      1989962: 16875567,
      1989958: 16875568,
      1989951: 16875569,
      1989947: 16875570,
      1989928: 16875571,
      1989889: 16875573,
      1989879: 16875574,
      1989871: 16875575,
      1989863: 16875576,
      1989724: 16875578,
      1989717: 16875579,
      1989705: 16875580,
      1989689: 16875581,
      1989868: 16875582,
      1989943: 16875584,
      1989940: 16875585,
      1989924: 16875586,
      1989788: 16875587,
      1989892: 16875589,
      1989891: 16875590,
      1989883: 16875591,
      1989872: 16875592,
      1989860: 16875593,
      1989852: 16875594,
      1989821: 16875596,
      1989801: 16875597,
      1989718: 16875598,
      1989712: 16875599,
      1989704: 16875600,
      1989697: 16875601,
      1989854: 16875602,
      1989966: 16875603,
      1989952: 16875604,
      1989944: 16875605,
      1989941: 16875606,
      1989934: 16875607,
      1989799: 16875608,
      1989893: 16875610,
      1989865: 16875611,
      1989819: 16875612,
      1374518: 16875613,
      1374498: 16875614,
      1989820: 16875616,
      1989814: 16875617,
      1989685: 16875618,
      1989676: 16875619,
      1989936: 16875622,
      1989955: 16875623,
      1989945: 16875624,
      1989938: 16875625,
      1989931: 16875626,
      1989927: 16875627,
      1989920: 16875628,
      1989870: 16875629,
      1374444: 16875630,
      1989894: 16875632,
      1989880: 16875633,
      1989876: 16875634,
      1989869: 16875635,
      1989855: 16875636,
      1989680: 16875638,
      1989937: 16875639,
      1989950: 16875640,
      1374528: 16875643,
      1989895: 16875644,
      1989888: 16875645,
      1989881: 16875646,
      1989878: 16875647,
      1989862: 16875648,
      1989857: 16875649,
      1989851: 16875650,
      1989808: 16875652,
      1989804: 16875653,
      1989795: 16875654,
      1989778: 16875655,
      1374526: 16875657,
      1989960: 16875659,
      1989954: 16875660,
      1989935: 16875661,
      1989925: 16875662,
      1989923: 16875663,
      1989864: 16875664,
      1989896: 16875666,
      1989887: 16875667,
      1989866: 16875668,
      1989782: 16875669,
      1989812: 16875671,
      1989797: 16875672,
      1989783: 16875673,
      1374534: 16875675,
      1374524: 16875676,
      1989886: 16875677,
      1989964: 16875679,
      1989953: 16875680,
      1989948: 16875681,
      1989929: 16875682,
      1989926: 16875683,
      1989919: 16875684,
      1989813: 16875685,
      1989884: 16875687,
      1989877: 16875688,
      1989853: 16875689,
      1989823: 16875691,
      1989807: 16875692,
      1989798: 16875693,
      1989790: 16875694,
      1989789: 16875695,
      1374508: 16875696,
      1989861: 16875697,
      1989802: 16875698,
      1989825: 16875699,
      1989816: 16875700,
      1989810: 16875701,
      1989803: 16875702,
      1989794: 16875703,
      1989784: 16875704,
      1989779: 16875705,
      1989922: 16875709,
      1989890: 16875711,
      1989867: 16875712,
      1989858: 16875713,
      1989850: 16875714,
      1989824: 16875715,
      1374482: 16875716,
      1989815: 16875718,
      1989806: 16875719,
      1989793: 16875720,
      1374536: 16875724,
      1374486: 16875725,
      1374474: 16875726,
      1374454: 16875727,
      1374442: 16875728,
      1374514: 16875729,
      1374500: 16875730,
      1375259: 16875731,
      1374466: 16875732,
      1374436: 16875733,
      1374422: 16875735,
      1374404: 16875736,
      1374388: 16875737,
      1374374: 16875738,
      1374362: 16875739,
      1989822: 16875742,
      1989817: 16875743,
      1989809: 16875744,
      1989786: 16875745,
      1989780: 16875746,
      1374532: 16875748,
      1374492: 16875749,
      1374484: 16875750,
      1374468: 16875751,
      1374452: 16875752,
      1375350: 16875753,
      1374324: 16875754,
      1374426: 16875755,
      1374392: 16875756,
      1374368: 16875757,
      1374348: 16875758,
      1374336: 16875759,
      1374472: 16875760,
      1374456: 16875761,
      1374342: 16875762,
      1374428: 16875763,
      1374418: 16875764,
      1374382: 16875765,
      1374971: 16875766,
      1374352: 16875767,
      1374338: 16875768,
      1374332: 16875769,
      1374252: 16875770,
      1989818: 16875771,
      1989800: 16875772,
      1989791: 16875773,
      1989785: 16875774,
      1374464: 16875775,
      1375388: 16875776,
      1374510: 16875777,
      1374496: 16875778,
      1374450: 16875779,
      1374434: 16875780,
      1350193: 16875781,
      1374396: 16875782,
      1375039: 16875783,
      1374376: 16875784,
      1374360: 16875785,
      1374340: 16875786,
      1374312: 16875787,
      1374290: 16875790,
      1989811: 16875791,
      1989805: 16875792,
      1989796: 16875793,
      1989781: 16875794,
      1375283: 16875795,
      1375340: 16875796,
      1374522: 16875797,
      1374506: 16875798,
      1374502: 16875799,
      1375303: 16875800,
      1375063: 16875802,
      1374390: 16875803,
      1374380: 16875804,
      1374366: 16875805,
      1374320: 16875806,
      1374306: 16875808,
      1374286: 16875809,
      1374266: 16875810,
      1989792: 16875811,
      1989787: 16875812,
      1374538: 16875813,
      1374530: 16875814,
      1374520: 16875815,
      1375362: 16875816,
      1375245: 16875817,
      1374470: 16875818,
      1374438: 16875819,
      1374316: 16875820,
      1374400: 16875821,
      1374394: 16875822,
      1374358: 16875823,
      1374328: 16875824,
      1374906: 16875826,
      1374240: 16875827,
      1374224: 16875828,
      1374208: 16875829,
      1374190: 16875830,
      1374430: 16875831,
      1374424: 16875832,
      1374412: 16875833,
      1374402: 16875834,
      1374370: 16875835,
      1374344: 16875836,
      1374326: 16875837,
      1374310: 16875838,
      1374294: 16875839,
      1374883: 16875840,
      1374262: 16875841,
      1374254: 16875842,
      1374238: 16875843,
      1374220: 16875844,
      1374516: 16875845,
      1375383: 16875846,
      1374504: 16875847,
      1375252: 16875848,
      1374478: 16875849,
      1374462: 16875850,
      1374458: 16875851,
      1374446: 16875852,
      1374408: 16875853,
      1374372: 16875854,
      1374960: 16875855,
      1374346: 16875856,
      1374322: 16875857,
      1374292: 16875859,
      1374282: 16875860,
      1374278: 16875861,
      1374264: 16875862,
      1374228: 16875863,
      1374218: 16875864,
      1374490: 16875865,
      1374480: 16875866,
      1374432: 16875867,
      1374416: 16875869,
      1374406: 16875870,
      1374386: 16875871,
      1374364: 16875872,
      1374350: 16875873,
      1374334: 16875874,
      1374308: 16875876,
      1374300: 16875877,
      1374284: 16875878,
      1374272: 16875879,
      1374206: 16875880,
      1374216: 16875881,
      1374204: 16875882,
      1353894: 16875883,
      1353804: 16875884,
      1374440: 16875885,
      1374302: 16875886,
      1374420: 16875887,
      1374410: 16875888,
      1374398: 16875889,
      1374384: 16875890,
      1374995: 16875891,
      1374356: 16875892,
      1374330: 16875893,
      1374314: 16875894,
      1374296: 16875896,
      1374270: 16875897,
      1374248: 16875898,
      1374236: 16875899,
      1374222: 16875900,
      1353774: 16875901,
      1336430: 16875902,
      1353870: 16875903,
      1353836: 16875904,
      1375070: 16875908,
      1374414: 16875909,
      1375023: 16875910,
      1374378: 16875911,
      1374988: 16875912,
      1374354: 16875913,
      1374280: 16875914,
      1374866: 16875915,
      1374822: 16875916,
      1374242: 16875917,
      1374234: 16875918,
      1374214: 16875919,
      1374196: 16875920,
      1336552: 16875921,
      1358707: 16875922,
      1358695: 16875923,
      1358675: 16875924,
      1374268: 16875925,
      1374256: 16875926,
      1374200: 16875927,
      1353792: 16875928,
      1358713: 16875934,
      1358689: 16875935,
      1358679: 16875936,
      1350209: 16875937,
      1350195: 16875938,
      1350448: 16875939,
      1374318: 16875940,
      1374298: 16875942,
      1374288: 16875943,
      1374276: 16875944,
      1374260: 16875945,
      1374815: 16875946,
      1374244: 16875947,
      1374230: 16875948,
      1374212: 16875949,
      1374232: 16875950,
      1374192: 16875951,
      1358685: 16875952,
      1336452: 16875953,
      1358709: 16875959,
      1374304: 16875960,
      1374274: 16875961,
      1374258: 16875962,
      1374250: 16875963,
      1350183: 16875964,
      1336334: 16875965,
      1358719: 16875966,
      1358701: 16875967,
      1358693: 16875968,
      1350217: 16875969,
      1350462: 16875970,
      1350438: 16875971,
      1350185: 16875972,
      1350173: 16875973,
      1353874: 16875974,
      1353844: 16875975,
      1353826: 16875976,
      1353824: 16875977,
      1353802: 16875978,
      1353748: 16875979,
      1350454: 16875980,
      1358717: 16875985,
      1358703: 16875986,
      1358687: 16875987,
      1350205: 16875988,
      1358623: 16875989,
      1353888: 16875990,
      1353858: 16875991,
      1353838: 16875992,
      1353756: 16875993,
      1353740: 16875994,
      1374246: 16875995,
      1374202: 16875996,
      1350169: 16875997,
      1336544: 16875998,
      1353864: 16875999,
      1350213: 16876e3,
      1358691: 16876002,
      1350219: 16876003,
      1353796: 16876004,
      1353786: 16876005,
      1353772: 16876006,
      1353750: 16876007,
      1336470: 16876008,
      1336448: 16876009,
      1336462: 16876010,
      1336412: 16876011,
      1336420: 16876012,
      1336386: 16876013,
      1336500: 16876014,
      1374210: 16876015,
      1374194: 16876016,
      1350199: 16876017,
      1353816: 16876018,
      1336578: 16876019,
      1358627: 16876020,
      1350203: 16876021,
      1358715: 16876025,
      1350211: 16876026,
      1350201: 16876027,
      1350460: 16876028,
      1350458: 16876029,
      1350434: 16876030,
      1353902: 16876031,
      1353880: 16876032,
      1353860: 16876033,
      1353852: 16876034,
      1374198: 16876035,
      1336400: 16876036,
      1350177: 16876037,
      1353890: 16876038,
      1358705: 16876043,
      1358699: 16876044,
      1350456: 16876045,
      1350444: 16876046,
      1353898: 16876047,
      1353876: 16876048,
      1353840: 16876049,
      1353820: 16876050,
      1353806: 16876051,
      1353794: 16876052,
      1353764: 16876053,
      1353738: 16876054,
      1358721: 16876058,
      1358683: 16876059,
      1358681: 16876060,
      1350215: 16876061,
      1350464: 16876062,
      1350450: 16876063,
      1350440: 16876064,
      1358625: 16876065,
      1350175: 16876066,
      1353892: 16876067,
      1353878: 16876068,
      1353868: 16876069,
      1353854: 16876070,
      1353832: 16876071,
      1353810: 16876072,
      1353766: 16876073,
      1336572: 16876074,
      1350221: 16876075,
      1353850: 16876076,
      1358677: 16876078,
      1350207: 16876079,
      1350452: 16876080,
      1350436: 16876081,
      1350189: 16876082,
      1350181: 16876083,
      1353896: 16876084,
      1353866: 16876085,
      1353828: 16876086,
      1353784: 16876087,
      1353754: 16876088,
      1336436: 16876089,
      1336404: 16876090,
      1336454: 16876091,
      1336406: 16876092,
      1340280: 16876093,
      1358711: 16876098,
      1358697: 16876099,
      1350197: 16876100,
      1350446: 16876101,
      1350432: 16876102,
      1350187: 16876103,
      1350171: 16876104,
      1353900: 16876105,
      1353884: 16876106,
      1353872: 16876107,
      1353856: 16876108,
      1353834: 16876109,
      1353906: 16876110,
      1353808: 16876111,
      1353798: 16876112,
      1353780: 16876113,
      1353812: 16876114,
      1353746: 16876115,
      1336396: 16876116,
      1336446: 16876117,
      1336408: 16876118,
      1336556: 16876119,
      1336584: 16876120,
      1336550: 16876121,
      1336484: 16876122,
      1336478: 16876123,
      1350442: 16876124,
      1752828: 16876125,
      1350167: 16876126,
      1350179: 16876127,
      1353862: 16876128,
      1353848: 16876129,
      1353822: 16876130,
      1353818: 16876131,
      1353790: 16876132,
      1353776: 16876133,
      1353770: 16876134,
      1353904: 16876135,
      1353742: 16876136,
      1336458: 16876137,
      1336450: 16876138,
      1336438: 16876139,
      1336428: 16876140,
      1336410: 16876141,
      1336568: 16876142,
      1336526: 16876143,
      1353814: 16876144,
      1353800: 16876145,
      1353782: 16876146,
      1353768: 16876147,
      1336468: 16876148,
      1336442: 16876149,
      1336538: 16876150,
      1336590: 16876151,
      1336486: 16876152,
      1336476: 16876153,
      1336528: 16876154,
      1336510: 16876155,
      1336306: 16876156,
      1336346: 16876157,
      1336254: 16876158,
      1336356: 16876159,
      1336278: 16876160,
      1336276: 16876161,
      1336208: 16876162,
      1336264: 16876163,
      1353788: 16876164,
      1353778: 16876165,
      1353758: 16876166,
      1353744: 16876167,
      1336416: 16876168,
      1336460: 16876169,
      1336414: 16876170,
      1336456: 16876171,
      1336574: 16876172,
      1336564: 16876173,
      1336570: 16876174,
      1336482: 16876175,
      1336322: 16876176,
      1336304: 16876177,
      1336286: 16876178,
      1336246: 16876179,
      1336270: 16876180,
      1336268: 16876181,
      1336176: 16876182,
      1336080: 16876183,
      1353762: 16876184,
      1353752: 16876185,
      1336434: 16876186,
      1336392: 16876187,
      1336426: 16876188,
      1336390: 16876189,
      1336540: 16876190,
      1336512: 16876191,
      1336352: 16876192,
      1336338: 16876193,
      1336354: 16876194,
      1336232: 16876195,
      1336214: 16876196,
      1336244: 16876197,
      1336184: 16876198,
      1336224: 16876199,
      1336164: 16876200,
      1336026: 16876201,
      1336248: 16876202,
      1336018: 16876203,
      1336464: 16876204,
      1336432: 16876205,
      1336474: 16876206,
      1336418: 16876207,
      1336534: 16876208,
      1336554: 16876209,
      1336546: 16876210,
      1336490: 16876211,
      1336532: 16876212,
      1336514: 16876213,
      1336360: 16876214,
      1336316: 16876215,
      1336374: 16876216,
      1336240: 16876217,
      1336342: 16876218,
      1336265: 16876219,
      1336202: 16876220,
      1336274: 16876221,
      1336186: 16876222,
      1336182: 16876223,
      1336444: 16876224,
      1336422: 16876225,
      1336388: 16876226,
      1336466: 16876227,
      1336326: 16876228,
      1336588: 16876229,
      1336582: 16876230,
      1336548: 16876231,
      1336506: 16876232,
      1336492: 16876233,
      1336522: 16876234,
      1336340: 16876235,
      1336318: 16876236,
      1336290: 16876237,
      1336314: 16876238,
      1336288: 16876239,
      1340798: 16876240,
      1336178: 16876241,
      1336188: 16876242,
      1336082: 16876243,
      1336402: 16876244,
      1336424: 16876245,
      1336398: 16876246,
      1336440: 16876247,
      1336370: 16876248,
      1336560: 16876249,
      1336536: 16876250,
      1336580: 16876251,
      1336566: 16876252,
      1336332: 16876253,
      1336530: 16876254,
      1336496: 16876255,
      1336382: 16876256,
      1336330: 16876257,
      1336308: 16876258,
      1336368: 16876259,
      1336384: 16876260,
      1336324: 16876261,
      1336218: 16876262,
      1336198: 16876263,
      1336558: 16876264,
      1336520: 16876265,
      1336586: 16876266,
      1336488: 16876267,
      1336504: 16876268,
      1336366: 16876269,
      1336358: 16876270,
      1336344: 16876271,
      1336228: 16876272,
      1336242: 16876273,
      1336300: 16876274,
      1336158: 16876275,
      1336040: 16876276,
      1336238: 16876277,
      1336028: 16876278,
      1336004: 16876279,
      1335990: 16876280,
      1336114: 16876281,
      1336108: 16876282,
      1336070: 16876283,
      1336576: 16876284,
      1336561: 16876285,
      1336542: 16876286,
      1336472: 16876287,
      1336524: 16876288,
      1336378: 16876289,
      1336310: 16876290,
      1336336: 16876291,
      1336258: 16876292,
      1336296: 16876293,
      1336220: 16876294,
      1336204: 16876295,
      1336084: 16876296,
      1336044: 16876297,
      1336212: 16876298,
      1336014: 16876299,
      1335998: 16876300,
      1336140: 16876301,
      1336112: 16876302,
      1336058: 16876303,
      1336494: 16876304,
      1336350: 16876305,
      1336518: 16876306,
      1336508: 16876307,
      1336394: 16876308,
      1336380: 16876309,
      1336292: 16876310,
      1336372: 16876311,
      1336320: 16876312,
      1336210: 16876313,
      1336280: 16876314,
      1336194: 16876315,
      1336284: 16876316,
      1336222: 16876317,
      1336034: 16876318,
      1336036: 16876319,
      1336074: 16876320,
      1336052: 16876321,
      1335952: 16876322,
      1335936: 16876323,
      1336516: 16876324,
      1336498: 16876325,
      1336362: 16876326,
      1336200: 16876327,
      1336298: 16876328,
      1336180: 16876329,
      1336160: 16876330,
      1336090: 16876331,
      1336048: 16876332,
      1336272: 16876333,
      1336190: 16876334,
      1336037: 16876335,
      1336010: 16876336,
      1336104: 16876337,
      1336086: 16876338,
      1336056: 16876339,
      1336166: 16876340,
      1336138: 16876341,
      1335950: 16876342,
      1335938: 16876343,
      1336302: 16876344,
      1336348: 16876345,
      1336256: 16876346,
      1336282: 16876347,
      1336216: 16876348,
      1336250: 16876349,
      1336230: 16876350,
      1336078: 16876351,
      1336032: 16876352,
      1336234: 16876353,
      1336170: 16876354,
      1335988: 16876355,
      1336120: 16876356,
      1336116: 16876357,
      1336096: 16876358,
      1336076: 16876359,
      1336060: 16876360,
      1336148: 16876361,
      1336129: 16876362,
      1335942: 16876363,
      1336236: 16876364,
      1336196: 16876365,
      1336262: 16876366,
      1340803: 16876367,
      1336192: 16876368,
      1336016: 16876369,
      1335996: 16876370,
      1336118: 16876371,
      1336098: 16876372,
      1336102: 16876373,
      1336064: 16876374,
      1336172: 16876375,
      1336150: 16876376,
      1336136: 16876377,
      1335956: 16876378,
      1335932: 16876379,
      1335986: 16876380,
      731646: 16876381,
      1350710: 16876382,
      1336168: 16876384,
      1336174: 16876385,
      1336094: 16876386,
      1336162: 16876387,
      1340742: 16876388,
      1336012: 16876389,
      1336126: 16876390,
      1336068: 16876391,
      1336144: 16876392,
      1335946: 16876393,
      1335974: 16876394,
      1405416: 16876395,
      2486972: 16876396,
      1400725: 16876397,
      1400704: 16876398,
      742021: 16876399,
      1405577: 16876400,
      741840: 16876401,
      736515: 16876402,
      1405305: 16876403,
      1336100: 16876404,
      1336088: 16876405,
      1336030: 16876406,
      1336252: 16876407,
      1336206: 16876408,
      1336022: 16876409,
      1336008: 16876410,
      1336124: 16876411,
      1336054: 16876412,
      1336152: 16876413,
      1336132: 16876414,
      1335978: 16876415,
      737973: 16876416,
      1394803: 16876419,
      1350517: 16876420,
      2219287: 16876421,
      1346532: 16876422,
      1765525: 16876423,
      1336042: 16876424,
      1336260: 16876425,
      1336020: 16876426,
      1336128: 16876427,
      1336092: 16876428,
      1336050: 16876429,
      1336146: 16876430,
      1336142: 16876431,
      1335960: 16876432,
      1335958: 16876433,
      1335984: 16876434,
      741857: 16876435,
      1350638: 16876436,
      1400750: 16876440,
      1373804: 16876441,
      741926: 16876442,
      741883: 16876443,
      1336066: 16876444,
      1336226: 16876445,
      1336024: 16876446,
      1336110: 16876447,
      1336046: 16876448,
      1336156: 16876449,
      1336134: 16876450,
      1335976: 16876451,
      1350714: 16876452,
      1812182: 16876456,
      1347239: 16876457,
      1405686: 16876458,
      1405600: 16876459,
      738303: 16876460,
      1730301: 16876461,
      1405304: 16876462,
      735602: 16876463,
      1336006: 16876464,
      1336122: 16876465,
      1336106: 16876466,
      1336062: 16876467,
      1335940: 16876468,
      1335994: 16876469,
      738309: 16876470,
      2486888: 16876471,
      1400711: 16876474,
      1380952: 16876475,
      1373139: 16876476,
      1765527: 16876477,
      1405687: 16876478,
      741981: 16876479,
      1405616: 16876480,
      1405414: 16876481,
      738288: 16876482,
      738166: 16876483,
      1336154: 16876484,
      1335962: 16876485,
      1335948: 16876486,
      1336002: 16876487,
      1335982: 16876488,
      1335966: 16876489,
      1350681: 16876490,
      1349473: 16876491,
      1351086: 16876496,
      1350959: 16876497,
      1350857: 16876498,
      1350696: 16876499,
      1350667: 16876500,
      1350583: 16876501,
      1350489: 16876502,
      1349968: 16876503,
      1335944: 16876504,
      1335972: 16876505,
      735647: 16876507,
      1394520: 16876508,
      1442813: 16876509,
      1347304: 16876510,
      1490797: 16876511,
      741967: 16876512,
      1405423: 16876513,
      738263: 16876514,
      738120: 16876515,
      736509: 16876516,
      735624: 16876517,
      1405264: 16876518,
      743092: 16876519,
      742714: 16876520,
      2486893: 16876521,
      742485: 16876522,
      1349926: 16876523,
      1335933: 16876524,
      1335992: 16876525,
      741964: 16876526,
      1394077: 16876527,
      1380979: 16876529,
      1405640: 16876530,
      1405604: 16876531,
      738296: 16876532,
      738228: 16876533,
      736600: 16876534,
      736048: 16876535,
      1405278: 16876536,
      742900: 16876538,
      2486958: 16876539,
      742657: 16876540,
      1360114: 16876541,
      1339132: 16876542,
      1350776: 16876543,
      1335980: 16876544,
      1335964: 16876545,
      1351396: 16876548,
      1352297: 16876552,
      1346780: 16876553,
      705024: 16876554,
      741929: 16876555,
      1405387: 16876556,
      737782: 16876557,
      738179: 16876558,
      729431: 16876559,
      736057: 16876560,
      735605: 16876561,
      1405238: 16876562,
      742777: 16876563,
      1335954: 16876564,
      1405271: 16876565,
      742225: 16876566,
      1350622: 16876567,
      842234: 16876570,
      1352252: 16876571,
      1349468: 16876572,
      1346914: 16876573,
      1793250: 16876574,
      1405594: 16876575,
      1405413: 16876576,
      741837: 16876577,
      738237: 16876578,
      735651: 16876579,
      1405253: 16876580,
      743104: 16876581,
      1347690: 16876582,
      1345872: 16876583,
      1394800: 16876585,
      1347378: 16876586,
      1373018: 16876587,
      1449396: 16876588,
      1405378: 16876589,
      737780: 16876590,
      738219: 16876591,
      736228: 16876592,
      1405311: 16876593,
      1405231: 16876594,
      743075: 16876595,
      2486951: 16876596,
      742483: 16876597,
      1360075: 16876598,
      1338954: 16876599,
      738138: 16876603,
      729324: 16876604,
      735883: 16876605,
      1405327: 16876606,
      735627: 16876607,
      1405192: 16876608,
      742780: 16876609,
      2486957: 16876610,
      842252: 16876611,
      1350480: 16876612,
      1346512: 16876613,
      1350653: 16876614,
      1347229: 16876615,
      1351078: 16876616,
      1350979: 16876617,
      1350963: 16876618,
      1350935: 16876619,
      1350775: 16876620,
      1350666: 16876621,
      1350634: 16876622,
      731925: 16876623,
      736527: 16876624,
      1405306: 16876625,
      2486967: 16876626,
      1360030: 16876627,
      1335521: 16876628,
      1346173: 16876629,
      1350281: 16876630,
      1346762: 16876631,
      1351466: 16876636,
      1351065: 16876637,
      1350941: 16876638,
      1350853: 16876639,
      1350786: 16876640,
      1350720: 16876641,
      1350690: 16876642,
      736553: 16876643,
      736022: 16876644,
      1405191: 16876645,
      743115: 16876646,
      742098: 16876647,
      742221: 16876648,
      861420: 16876649,
      1346765: 16876652,
      1345842: 16876653,
      1345839: 16876654,
      1349529: 16876655,
      1351218: 16876660,
      1351173: 16876661,
      1351044: 16876662,
      1405187: 16876663,
      743e3: 16876664,
      742036: 16876665,
      742095: 16876666,
      1395950: 16876667,
      1262771: 16876668,
      1350658: 16876669,
      1347637: 16876670,
      1350645: 16876671,
      1350855: 16876672,
      1350761: 16876673,
      1350711: 16876674,
      1350644: 16876675,
      1350585: 16876676,
      1350488: 16876677,
      1350251: 16876678,
      1348585: 16876679,
      1348512: 16876680,
      1347633: 16876681,
      1347291: 16876682,
      742742: 16876683,
      2486962: 16876684,
      2486956: 16876703,
      742609: 16876704,
      1359989: 16876705,
      861405: 16876706,
      1344450: 16876708,
      1349523: 16876709,
      1351415: 16876715,
      1351066: 16876716,
      1350952: 16876717,
      1350830: 16876718,
      1350735: 16876719,
      1350734: 16876720,
      1350651: 16876721,
      1350498: 16876722,
      1351372: 16876724,
      1350945: 16876725,
      1350848: 16876726,
      1350760: 16876727,
      1350716: 16876728,
      1350695: 16876729,
      1350652: 16876730,
      1350650: 16876731,
      1350565: 16876732,
      1350485: 16876733,
      1350405: 16876734,
      1347608: 16876735,
      1347231: 16876736,
      1347090: 16876737,
      1346996: 16876738,
      1347327: 16876739,
      1346802: 16876740,
      1344451: 16876741,
      1351436: 16876746,
      1350948: 16876747,
      1350869: 16876748,
      1350727: 16876749,
      1350688: 16876750,
      1350678: 16876751,
      1350642: 16876752,
      1350495: 16876753,
      1350400: 16876754,
      1349477: 16876755,
      1348584: 16876756,
      1347927: 16876757,
      1347226: 16876758,
      1350481: 16876759,
      1351386: 16876765,
      1350766: 16876766,
      1350689: 16876767,
      1350656: 16876768,
      1350639: 16876769,
      1349900: 16876770,
      1348578: 16876771,
      1347933: 16876772,
      1347687: 16876773,
      1347274: 16876774,
      1347273: 16876775,
      1347123: 16876776,
      1346799: 16876777,
      1346203: 16876778,
      1344249: 16876779,
      1344121: 16876780,
      1340801: 16876781,
      1889977: 16876782,
      2006052: 16876784,
      1342268: 16876785,
      1341478: 16876786,
      1350496: 16876787,
      1349574: 16876788,
      1347720: 16876789,
      1347613: 16876790,
      1347306: 16876791,
      1347220: 16876792,
      1346985: 16876793,
      1346817: 16876794,
      1346545: 16876795,
      1346115: 16876796,
      1345873: 16876797,
      1345734: 16876798,
      1344456: 16876799,
      1344369: 16876800,
      1344327: 16876801,
      1344238: 16876802,
      1344027: 16876803,
      1350490: 16876807,
      1350239: 16876808,
      1349422: 16876809,
      1347596: 16876810,
      1346903: 16876811,
      1346798: 16876812,
      1346406: 16876813,
      1346189: 16876814,
      1346133: 16876815,
      1346094: 16876816,
      1346010: 16876817,
      1345767: 16876818,
      1345142: 16876819,
      1344402: 16876820,
      1344374: 16876821,
      1344123: 16876822,
      1344006: 16876823,
      1341420: 16876826,
      1350486: 16876827,
      1349869: 16876828,
      1349464: 16876829,
      1348574: 16876830,
      1347630: 16876831,
      1347340: 16876832,
      1347227: 16876833,
      1347026: 16876834,
      1346972: 16876835,
      1346172: 16876836,
      1345733: 16876837,
      1344380: 16876838,
      1344132: 16876839,
      1344040: 16876840,
      2006188: 16876844,
      1342288: 16876845,
      1342177: 16876846,
      1350404: 16876847,
      1349571: 16876848,
      1349520: 16876849,
      1348575: 16876850,
      1347695: 16876851,
      1347686: 16876852,
      1347294: 16876853,
      1347e3: 16876854,
      1346758: 16876855,
      1346500: 16876856,
      1346245: 16876857,
      1346073: 16876858,
      1344441: 16876859,
      1344411: 16876860,
      1344398: 16876861,
      1344370: 16876862,
      1344244: 16876863,
      1344122: 16876864,
      1344109: 16876865,
      1344005: 16876866,
      1349530: 16876867,
      1347772: 16876868,
      1347587: 16876869,
      1347578: 16876870,
      1347288: 16876871,
      1347157: 16876872,
      1347018: 16876873,
      1346898: 16876874,
      1346730: 16876875,
      1346541: 16876876,
      1346329: 16876877,
      1346116: 16876878,
      1346068: 16876879,
      1345861: 16876880,
      1345731: 16876881,
      1344406: 16876882,
      1344381: 16876883,
      1344293: 16876884,
      1340149: 16876885,
      1347027: 16876887,
      1346813: 16876888,
      1346733: 16876889,
      1346403: 16876890,
      1346206: 16876891,
      1345844: 16876892,
      1345704: 16876893,
      1344458: 16876894,
      1344431: 16876895,
      1344390: 16876896,
      1344141: 16876897,
      1344041: 16876898,
      1341481: 16876900,
      2006017: 16876902,
      1342212: 16876903,
      1341963: 16876904,
      1341555: 16876905,
      1341421: 16876906,
      1346999: 16876907,
      1346844: 16876908,
      1346507: 16876909,
      1346184: 16876910,
      1345710: 16876911,
      1345460: 16876912,
      1344394: 16876913,
      1344377: 16876914,
      1344331: 16876915,
      1344124: 16876916,
      2006120: 16876917,
      2005942: 16876919,
      1342205: 16876920,
      1342064: 16876921,
      1341090: 16876922,
      1340805: 16876923,
      1340320: 16876924,
      1340141: 16876925,
      1339922: 16876926,
      1346823: 16876927,
      1346570: 16876928,
      1346482: 16876929,
      1346209: 16876930,
      1345858: 16876931,
      1345508: 16876932,
      1344410: 16876933,
      1344364: 16876934,
      1344120: 16876935,
      1344048: 16876936,
      2006154: 16876937,
      2005951: 16876938,
      1341518: 16876939,
      1341514: 16876940,
      1341084: 16876941,
      1339987: 16876942,
      1339923: 16876943,
      1339817: 16876944,
      1889933: 16876945,
      1345848: 16876947,
      1344449: 16876948,
      1344404: 16876949,
      1344379: 16876950,
      1344335: 16876951,
      1340328: 16876952,
      2006086: 16876956,
      1341648: 16876957,
      1341403: 16876958,
      1341399: 16876959,
      1341040: 16876960,
      1339906: 16876961,
      1339819: 16876962,
      1889837: 16876963,
      1889600: 16876964,
      1344294: 16876967,
      1344013: 16876968,
      1341647: 16876969,
      1889883: 16876970,
      2005907: 16876971,
      1342239: 16876972,
      1342060: 16876973,
      1341398: 16876974,
      1341077: 16876975,
      1340557: 16876976,
      1340062: 16876977,
      1339936: 16876978,
      1339901: 16876979,
      1889755: 16876980,
      1889956: 16876982,
      1889945: 16876983,
      1889811: 16876984,
      1889531: 16876985,
      1889159: 16876986,
      2005952: 16876989,
      1342235: 16876990,
      1341559: 16876991,
      1341473: 16876992,
      1341068: 16876993,
      1340544: 16876994,
      1339976: 16876995,
      1339890: 16876996,
      2006866: 16876997,
      1889537: 16876998,
      1889955: 16877001,
      1889938: 16877002,
      1889850: 16877003,
      1889818: 16877004,
      1889597: 16877005,
      1889771: 16877006,
      1889573: 16877007,
      1889443: 16877008,
      1889089: 16877009,
      1887815: 16877010,
      1887473: 16877011,
      1887467: 16877012,
      2005949: 16877014,
      1342204: 16877015,
      1341557: 16877016,
      1341476: 16877017,
      1341402: 16877018,
      1341195: 16877019,
      1341396: 16877020,
      1339840: 16877021,
      1889568: 16877022,
      1888945: 16877023,
      1889960: 16877024,
      1889921: 16877025,
      1889905: 16877026,
      1889892: 16877027,
      1889866: 16877028,
      1889781: 16877029,
      1889594: 16877030,
      1889577: 16877031,
      1889489: 16877032,
      1888977: 16877033,
      1341671: 16877034,
      1341560: 16877035,
      1341517: 16877036,
      1341474: 16877037,
      1341083: 16877038,
      1340284: 16877039,
      1340270: 16877040,
      1339924: 16877041,
      1339830: 16877042,
      1889895: 16877043,
      1889898: 16877045,
      1889612: 16877046,
      1889588: 16877047,
      1889569: 16877048,
      1889509: 16877049,
      1889464: 16877050,
      1888916: 16877051,
      1888429: 16877052,
      1341410: 16877054,
      1341401: 16877055,
      1340778: 16877056,
      1340540: 16877057,
      1339937: 16877058,
      1889971: 16877060,
      1889870: 16877061,
      1889732: 16877062,
      1889606: 16877063,
      1889503: 16877064,
      1889155: 16877065,
      1889129: 16877066,
      1341400: 16877074,
      1341148: 16877075,
      1340998: 16877076,
      1339965: 16877077,
      1339938: 16877078,
      1890012: 16877080,
      1889961: 16877081,
      1889941: 16877082,
      1889906: 16877083,
      1889743: 16877084,
      1889603: 16877085,
      1889561: 16877086,
      1889525: 16877087,
      1889461: 16877088,
      1889052: 16877089,
      1887551: 16877090,
      1340266: 16877094,
      1339940: 16877095,
      1889439: 16877096,
      1889997: 16877098,
      1889949: 16877099,
      1889915: 16877100,
      1889901: 16877101,
      1889877: 16877102,
      1889545: 16877103,
      1889113: 16877104,
      1888584: 16877111,
      1887875: 16877112,
      1887647: 16877113,
      1339874: 16877114,
      1889100: 16877115,
      1889833: 16877117,
      1889591: 16877118,
      1889519: 16877119,
      1889449: 16877120,
      1889121: 16877121,
      1889086: 16877122,
      1887843: 16877123,
      1888506: 16877132,
      1888378: 16877133,
      1887787: 16877135,
      1888548: 16877139,
      1888491: 16877140,
      1887871: 16877141,
      1889988: 16877142,
      1889615: 16877143,
      1889515: 16877144,
      1889095: 16877145,
      1887707: 16877146,
      1887720: 16877147,
      1887674: 16877148,
      1887547: 16877149,
      1887531: 16877150,
      1887496: 16877151,
      1888516: 16877155,
      1888423: 16877156,
      1888391: 16877157,
      1887829: 16877158,
      1887700: 16877159,
      1887623: 16877160,
      1887571: 16877161,
      1889554: 16877162,
      1889473: 16877163,
      1889139: 16877164,
      1889015: 16877165,
      1887446: 16877166,
      1888505: 16877167,
      1888612: 16877178,
      1888522: 16877179,
      1887883: 16877180,
      1887692: 16877181,
      1889105: 16877182,
      1888590: 16877183,
      1888573: 16877207,
      1888510: 16877208,
      1888481: 16877209,
      1888445: 16877210,
      1888381: 16877211,
      1887859: 16877212,
      1887773: 16877213,
      1887751: 16877214,
      1887530: 16877215,
      1887528: 16877221,
      1887452: 16877222,
      1887433: 16877223,
      1887690: 16877231,
      1888577: 16877235,
      1888544: 16877236,
      1887727: 16877237,
      1887611: 16877238,
      1887555: 16877239,
      1887456: 16877240,
      1887406: 16877241,
      1888630: 16877255,
      1888560: 16877256,
      1888471: 16877257,
      1887801: 16877258,
      1887635: 16877259,
      1887474: 16877260,
      1888622: 16877272,
      1888602: 16877273,
      1888467: 16877274,
      1887847: 16877275,
      1887696: 16877276,
      1887662: 16877277,
      1887579: 16877278,
      1887497: 16877279,
      1887448: 16877280,
      1887409: 16877281,
      1887587: 16877293,
      1887537: 16877294,
      1887485: 16877295,
      1887471: 16877296,
      1887440: 16877297,
      1887514: 16877313,
      1887460: 16877314,
      1887403: 16877315
    };
  }
});

// src/utils/route.ts
import { getPagePath, handleQuerystring, openWindow, parseQueryString, pipe } from "@lls/utils";
import _7 from "lodash/fp.js";
import { matchPath } from "react-router";
var getConnectUrl, getPath, getWorkplanStudentPagePath, shouldHideNavbar, routeHasViewer, shouldHideFooter, shouldScrollToTop, matchSubjectPath, matchPagePath, matchBookPath, matchLandingPagePath, matchCopiesPath, goBack, serverRedirectUser, redirectOldBooks, redirectBookIdToUri, redirectFrontApplications, isOnBookPath, redirectToConnect, shouldRedirectToConnect, isAlreadyOnDraftPage, isLLSLink;
var init_route = __esm({
  "src/utils/route.ts"() {
    "use strict";
    init_config();
    init_constants();
    init_redirect();
    getConnectUrl = (path = "") => {
      const premiumUrl = new URL(path, config_default.premium_url);
      const connectUrl = new URL(config_default.connect_url);
      if (premiumUrl.searchParams.get("token") === "{token}") throw new Error("no redirection loop plz");
      if (config_default.env === "local") premiumUrl.searchParams.set("token", "{token}");
      if (path) connectUrl.searchParams.set("redirect", decodeURIComponent(premiumUrl == null ? void 0 : premiumUrl.toString()));
      return `${connectUrl.origin}${connectUrl.search}`;
    };
    getPath = (routeName, params = {}) => {
      switch (routeName) {
        case "home":
          return `/${handleQuerystring(params.query)}`;
        case "my-books":
          return `/mesmanuels${handleQuerystring(params.query)}`;
        /* VIEWER PART */
        case "page": {
          const { slug, pageId, ...queryParams } = params;
          return getPagePath({ slug, pageId }, queryParams);
        }
        case "readonly":
          return `/readonly/${params.slug}${handleQuerystring(params.query)}`;
        case "workplan_student_page": {
          const qParams = _7.flow(
            _7.pick(["groupId", "taskId", "docId"]),
            _7.pickBy(_7.negate(_7.isNil)),
            handleQuerystring
          )(params);
          return `/${params.slug}/student/${params.studentId}${qParams}`;
        }
        case "page-creation": {
          const qParams = pipe(
            params,
            _7.pick(["originSlug", "originType", "originThematicName", "draftId"]),
            _7.get("isDraft", params) ? _7.set("isDraft", true) : _7.identity,
            _7.pickBy(_7.negate(_7.isNil)),
            handleQuerystring
          );
          return `/manuels/${params.uri}/page-creation${qParams}`;
        }
        case "book": {
          const qParams = _7.flow(_7.pick(["groupId", "item"]), _7.pickBy(_7.negate(_7.isNil)), handleQuerystring)(params);
          return `/manuels/${params.uri}${qParams}`;
        }
        case "panorama":
          return params.slug ? `/${params.slug}` : `/panorama/${params.bookId}/${params.chapterId}`;
        case "copies":
          return `/reponses/${params.parentId}${handleQuerystring(params.query)}`;
        case "copy":
          return `/reponses/${params.parentId}/reponse/${params.copyId}${handleQuerystring(params.query)}`;
        case "corrections":
          return `/reponses/${params.parentId}/groupe/${params.groupId}`;
        case "corrections_students":
          return `/reponses/${params.parentId}/students${handleQuerystring(params.query)}`;
        case "learning_assessment":
          return "/suivi-des-acquis";
        case "classroom_settings":
          return "/mesclasses";
        case "revision":
          return `/revision${handleQuerystring(params.query)}`;
        case "revision_book":
          return `/revision/${params.bookUri}${handleQuerystring(params.query)}`;
        case "revision_page": {
          const { slug, ...queryParams } = params;
          return `/page-revision/${params.slug}${handleQuerystring(queryParams)}`;
        }
        case "picker":
          return `/picker/${params.pageId}`;
        case "external_redirect":
          return `/lien-externe${handleQuerystring(params)}`;
        case "profile":
          return "/profil";
        // EXTERNAL
        case "explorer":
          return `${config_default.front_url}/explorer`;
        case "teacher_book":
          return `${config_default.front_url}/le-livre-du-professeur${params.bookUri ? `/${params.bookUri}` : ""}`;
        case "external_ent_logout":
          return "https://static.lelivrescolaire.fr/ent-logout";
        case "lls_applications":
          return `${config_default.front_url}/applications`;
        case "join_community":
          return `${config_default.front_url}/rejoindre-communaute${handleQuerystring(params.query)}`;
        case "lls_connect":
          return getConnectUrl(params.path);
        case "external_epub":
          return `${config_default.epub_url}/${params.uri}`;
        case "static_legal_notice":
          return `${config_default.front_url}/informations/mentions-legales`;
        case "static_personal_data":
          return `${config_default.front_url}/informations/donnees-personnelles`;
        case "static_cookie":
          return `${config_default.front_url}/informations/cookies`;
        case "classics":
          return `${config_default.front_url}/classiques`;
        case "classic-ressources":
          return `${config_default.resource_url}/classiques/${params.uri}${handleQuerystring(params.query)}`;
        // URL schemes
        case "url_scheme":
          return `lls://commands/${_7.join("/", params.commands)}${handleQuerystring(params.query)}`;
        case "marketing_viewer":
          return `/outils/${params.tool}`;
        default:
          return routeName;
      }
    };
    getWorkplanStudentPagePath = ({ slug }, queryParams = {}) => getPath("workplan_student_page", { slug, ...queryParams });
    shouldHideNavbar = _7.overSome([_7.startsWith("/mesclasses/add"), _7.startsWith("/suivi-des-acquis")]);
    routeHasViewer = _7.overSome([_7.startsWith("/page"), _7.startsWith("/outils"), _7.startsWith("/reponses")]);
    shouldHideFooter = _7.overSome([
      _7.startsWith("/page"),
      _7.startsWith("/groupes"),
      _7.startsWith("/reponse"),
      _7.startsWith("/outils"),
      _7.startsWith("/panorama")
    ]);
    shouldScrollToTop = (location) => !_7.includes(location, ["/gratuit"]);
    matchSubjectPath = _7.startsWith("/matiere/");
    matchPagePath = _7.startsWith("/page/");
    matchBookPath = _7.overSome([_7.startsWith("/book"), _7.startsWith("/manuel")]);
    matchLandingPagePath = _7.isEqual("/");
    matchCopiesPath = _7.startsWith("/reponses/");
    goBack = ({ history }) => {
      return history.length >= 2 ? () => history.goBack() : () => history.push(getPath("home"));
    };
    serverRedirectUser = (user, path = "") => {
      if (_7.isEmpty(user)) {
        if (_7.includes("/readonly", path)) return null;
        if (_7.includes("/page/", path)) return `/readonly${path}`;
        return getConnectUrl(path);
      }
      if ((user == null ? void 0 : user.isTrial) && !config_default.is_trial_open) return getConnectUrl(path);
      if (!_7.isEmpty(user) && !(user == null ? void 0 : user.isPremium) && !(user == null ? void 0 : user.isAdmin) && !(user == null ? void 0 : user.isEditorLLS) && !(user == null ? void 0 : user.isTrial)) {
        const pagePath = _7.replace("readonly/page", "page", path);
        return `${config_default.front_url}${pagePath}`;
      }
      if (_7.includes("/readonly/page", path)) {
        return _7.replace("/readonly", "", path);
      }
      return null;
    };
    redirectOldBooks = ({ params }) => {
      const bookId = Number.parseInt(params == null ? void 0 : params.bookId);
      const pageId = Number.parseInt(params == null ? void 0 : params.pageId);
      return {
        location: OLD_PAGES_REDIRECTION[pageId] !== void 0 ? `/page/${OLD_PAGES_REDIRECTION[pageId]}` : OLD_BOOKS_REDIRECTION[bookId]
      };
    };
    redirectBookIdToUri = ({ params }) => {
      const bookId = _7.flow(_7.get("bookId"), Number.parseInt)(params);
      return {
        location: BOOK_IDS_TO_URIS_REDIRECTION[bookId]
      };
    };
    redirectFrontApplications = () => ({ location: `${config_default.front_url}/applications` });
    isOnBookPath = _7.flow(_7.get("pathname"), matchBookPath);
    redirectToConnect = () => {
      openWindow(getPath("lls_connect", { path: window.location.href }), "_self");
    };
    shouldRedirectToConnect = ({ page, match }) => !_7.overSome([_7.isEqual("/readonly/page/:pageId"), _7.isEqual("/page/:pageId")])(match) || !!(page == null ? void 0 : page.premium);
    isAlreadyOnDraftPage = (history, template) => (_7.get("location.pathname", history) === `/${_7.get("slug", template)}` || _7.get("id", template) < 0) && _7.flow(_7.get("location.search"), parseQueryString, _7.matches({ isDraft: "true" }))(history);
    isLLSLink = (link) => {
      try {
        const redirectUrl = new URL(link);
        return _7.some(
          _7.identity,
          _7.map(
            (url) => {
              const allowedUrl = new URL(url);
              return redirectUrl.host === allowedUrl.host;
            },
            [config_default.front_url, config_default.premium_url, config_default.quiz_url, ASSETS_HOST, ASSETS_HOST_DEV]
          )
        );
      } catch (_e) {
        console.error(`Invalid url: ${link}`);
        return false;
      }
    };
  }
});

// src/utils/analytics.js
import _8 from "lodash/fp.js";
var getScreenDisplayName, getFiltersParamValue;
var init_analytics2 = __esm({
  "src/utils/analytics.js"() {
    "use strict";
    init_route();
    getScreenDisplayName = (pathname) => {
      switch (true) {
        case matchLandingPagePath(pathname):
          return "landing_page";
        case matchPagePath(pathname):
          return "textbook";
        case matchSubjectPath(pathname):
        case matchBookPath(pathname):
          return "book";
        case matchCopiesPath(pathname):
          return "copies";
        default:
          return "";
      }
    };
    getFiltersParamValue = (filter) => {
      if (_8.isEmpty(filter)) return "none";
      return filter.type === "CUSTOM" ? filter.title : filter.type;
    };
  }
});

// src/components/analytics.jsx
import _9 from "lodash/fp.js";
import React3, { useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Button as KitButton, getFontSizeValue } from "@lls/lls-kit";
import {
  dispatchAnalyticsEvent,
  getQueryParams,
  getWindow as getWindow2,
  sendEvent as sendEventUtils,
  useAnalyticsEvent,
  useTestSigmaAnalytics
} from "@lls/utils";
import { getAuth, useSearchUsers } from "@lls/store";
import { jsx } from "react/jsx-runtime";
function Analytics() {
  var _a2;
  const { pathname } = useLocation();
  const auth2 = useSelector(getAuth);
  const llsUserId = _9.get("llsUserId", auth2);
  const user = (_a2 = useSearchUsers({ ids: [llsUserId] })) == null ? void 0 : _a2[0];
  const isPremium = user == null ? void 0 : user.isPremium;
  const isTeacher = user == null ? void 0 : user.isTeacher;
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const data = {
        page: pathname
      };
      sendScreenDisplayEvent(
        _9.isNil(llsUserId) ? data : _9.assign(
          {
            user_id: llsUserId,
            user_category: isTeacher ? "teacher" : "student",
            lls_user_subscription: isPremium ? "premium" : "free"
          },
          data
        )
      );
    }, 100);
    return () => clearTimeout(timeoutId);
  }, [pathname, isTeacher, llsUserId, isPremium]);
  return null;
}
var LlsAnalytics, sendEvent, sendScreenDisplayEvent, Button;
var init_analytics3 = __esm({
  "src/components/analytics.jsx"() {
    "use strict";
    init_es62();
    init_analytics();
    init_graphql();
    init_constants();
    init_analytics2();
    LlsAnalytics = () => {
      var _a2;
      const [cookies] = useCookies();
      const token = _9.get(COOKIE_JWT_TOKEN, cookies);
      const piano = (_a2 = getWindow2()) == null ? void 0 : _a2.pa;
      const anonymousId = piano == null ? void 0 : piano.getVisitorId();
      const userId = _9.flow(useSelector, _9.get("id"))(getAuth);
      const { sizeIndex, fontFamily, isDarkMode, isDysMode } = _9.getOr({}, [COOKIE_ACCESSIBILITY_STATE, userId], cookies);
      const { qa, qaToken } = _9.flow(useLocation, getQueryParams, _9.pick(["qa", "qaToken"]))();
      const { element, onSent } = useTestSigmaAnalytics({ gqlNoCache, qaToken });
      useAnalyticsEvent({
        token,
        anonymousId,
        getFontSizeValue,
        send: sendCustomLogApi,
        onSent,
        qaFlags: qa,
        sizeIndex,
        fontFamily,
        isDarkMode,
        isDysMode
      });
      return element;
    };
    sendEvent = sendEventUtils;
    sendScreenDisplayEvent = (opts = {}) => {
      sendEvent({
        name: "page.display",
        opts: { ...opts, lls_screen_type: getScreenDisplayName(opts.page) }
      });
    };
    Button = React3.forwardRef(({ children, analytics: analyticsEventName, onClick, ...props }, ref) => {
      const onButtonClick = useCallback(
        (e) => {
          dispatchAnalyticsEvent(analyticsEventName);
          onClick(e);
        },
        [onClick, analyticsEventName]
      );
      return /* @__PURE__ */ jsx(KitButton, { ...props, ref, onClick: onButtonClick, children });
    });
  }
});

// ../../node_modules/.pnpm/dayjs@1.11.13/node_modules/dayjs/dayjs.min.js
var require_dayjs_min = __commonJS({
  "../../node_modules/.pnpm/dayjs@1.11.13/node_modules/dayjs/dayjs.min.js"(exports, module) {
    "use strict";
    !function(t, e) {
      "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = "undefined" != typeof globalThis ? globalThis : t || self).dayjs = e();
    }(exports, function() {
      "use strict";
      var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(t2) {
        var e2 = ["th", "st", "nd", "rd"], n2 = t2 % 100;
        return "[" + t2 + (e2[(n2 - 20) % 10] || e2[n2] || e2[0]) + "]";
      } }, m = function(t2, e2, n2) {
        var r2 = String(t2);
        return !r2 || r2.length >= e2 ? t2 : "" + Array(e2 + 1 - r2.length).join(n2) + t2;
      }, v = { s: m, z: function(t2) {
        var e2 = -t2.utcOffset(), n2 = Math.abs(e2), r2 = Math.floor(n2 / 60), i2 = n2 % 60;
        return (e2 <= 0 ? "+" : "-") + m(r2, 2, "0") + ":" + m(i2, 2, "0");
      }, m: function t2(e2, n2) {
        if (e2.date() < n2.date()) return -t2(n2, e2);
        var r2 = 12 * (n2.year() - e2.year()) + (n2.month() - e2.month()), i2 = e2.clone().add(r2, c), s2 = n2 - i2 < 0, u2 = e2.clone().add(r2 + (s2 ? -1 : 1), c);
        return +(-(r2 + (n2 - i2) / (s2 ? i2 - u2 : u2 - i2)) || 0);
      }, a: function(t2) {
        return t2 < 0 ? Math.ceil(t2) || 0 : Math.floor(t2);
      }, p: function(t2) {
        return { M: c, y: h, w: o, d: a, D: d, h: u, m: s, s: i, ms: r, Q: f }[t2] || String(t2 || "").toLowerCase().replace(/s$/, "");
      }, u: function(t2) {
        return void 0 === t2;
      } }, g = "en", D = {};
      D[g] = M;
      var p = "$isDayjsObject", S = function(t2) {
        return t2 instanceof _167 || !(!t2 || !t2[p]);
      }, w = function t2(e2, n2, r2) {
        var i2;
        if (!e2) return g;
        if ("string" == typeof e2) {
          var s2 = e2.toLowerCase();
          D[s2] && (i2 = s2), n2 && (D[s2] = n2, i2 = s2);
          var u2 = e2.split("-");
          if (!i2 && u2.length > 1) return t2(u2[0]);
        } else {
          var a2 = e2.name;
          D[a2] = e2, i2 = a2;
        }
        return !r2 && i2 && (g = i2), i2 || !r2 && g;
      }, O = function(t2, e2) {
        if (S(t2)) return t2.clone();
        var n2 = "object" == typeof e2 ? e2 : {};
        return n2.date = t2, n2.args = arguments, new _167(n2);
      }, b = v;
      b.l = w, b.i = S, b.w = function(t2, e2) {
        return O(t2, { locale: e2.$L, utc: e2.$u, x: e2.$x, $offset: e2.$offset });
      };
      var _167 = function() {
        function M2(t2) {
          this.$L = w(t2.locale, null, true), this.parse(t2), this.$x = this.$x || t2.x || {}, this[p] = true;
        }
        var m2 = M2.prototype;
        return m2.parse = function(t2) {
          this.$d = function(t3) {
            var e2 = t3.date, n2 = t3.utc;
            if (null === e2) return /* @__PURE__ */ new Date(NaN);
            if (b.u(e2)) return /* @__PURE__ */ new Date();
            if (e2 instanceof Date) return new Date(e2);
            if ("string" == typeof e2 && !/Z$/i.test(e2)) {
              var r2 = e2.match($);
              if (r2) {
                var i2 = r2[2] - 1 || 0, s2 = (r2[7] || "0").substring(0, 3);
                return n2 ? new Date(Date.UTC(r2[1], i2, r2[3] || 1, r2[4] || 0, r2[5] || 0, r2[6] || 0, s2)) : new Date(r2[1], i2, r2[3] || 1, r2[4] || 0, r2[5] || 0, r2[6] || 0, s2);
              }
            }
            return new Date(e2);
          }(t2), this.init();
        }, m2.init = function() {
          var t2 = this.$d;
          this.$y = t2.getFullYear(), this.$M = t2.getMonth(), this.$D = t2.getDate(), this.$W = t2.getDay(), this.$H = t2.getHours(), this.$m = t2.getMinutes(), this.$s = t2.getSeconds(), this.$ms = t2.getMilliseconds();
        }, m2.$utils = function() {
          return b;
        }, m2.isValid = function() {
          return !(this.$d.toString() === l);
        }, m2.isSame = function(t2, e2) {
          var n2 = O(t2);
          return this.startOf(e2) <= n2 && n2 <= this.endOf(e2);
        }, m2.isAfter = function(t2, e2) {
          return O(t2) < this.startOf(e2);
        }, m2.isBefore = function(t2, e2) {
          return this.endOf(e2) < O(t2);
        }, m2.$g = function(t2, e2, n2) {
          return b.u(t2) ? this[e2] : this.set(n2, t2);
        }, m2.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, m2.valueOf = function() {
          return this.$d.getTime();
        }, m2.startOf = function(t2, e2) {
          var n2 = this, r2 = !!b.u(e2) || e2, f2 = b.p(t2), l2 = function(t3, e3) {
            var i2 = b.w(n2.$u ? Date.UTC(n2.$y, e3, t3) : new Date(n2.$y, e3, t3), n2);
            return r2 ? i2 : i2.endOf(a);
          }, $2 = function(t3, e3) {
            return b.w(n2.toDate()[t3].apply(n2.toDate("s"), (r2 ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e3)), n2);
          }, y2 = this.$W, M3 = this.$M, m3 = this.$D, v2 = "set" + (this.$u ? "UTC" : "");
          switch (f2) {
            case h:
              return r2 ? l2(1, 0) : l2(31, 11);
            case c:
              return r2 ? l2(1, M3) : l2(0, M3 + 1);
            case o:
              var g2 = this.$locale().weekStart || 0, D2 = (y2 < g2 ? y2 + 7 : y2) - g2;
              return l2(r2 ? m3 - D2 : m3 + (6 - D2), M3);
            case a:
            case d:
              return $2(v2 + "Hours", 0);
            case u:
              return $2(v2 + "Minutes", 1);
            case s:
              return $2(v2 + "Seconds", 2);
            case i:
              return $2(v2 + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, m2.endOf = function(t2) {
          return this.startOf(t2, false);
        }, m2.$set = function(t2, e2) {
          var n2, o2 = b.p(t2), f2 = "set" + (this.$u ? "UTC" : ""), l2 = (n2 = {}, n2[a] = f2 + "Date", n2[d] = f2 + "Date", n2[c] = f2 + "Month", n2[h] = f2 + "FullYear", n2[u] = f2 + "Hours", n2[s] = f2 + "Minutes", n2[i] = f2 + "Seconds", n2[r] = f2 + "Milliseconds", n2)[o2], $2 = o2 === a ? this.$D + (e2 - this.$W) : e2;
          if (o2 === c || o2 === h) {
            var y2 = this.clone().set(d, 1);
            y2.$d[l2]($2), y2.init(), this.$d = y2.set(d, Math.min(this.$D, y2.daysInMonth())).$d;
          } else l2 && this.$d[l2]($2);
          return this.init(), this;
        }, m2.set = function(t2, e2) {
          return this.clone().$set(t2, e2);
        }, m2.get = function(t2) {
          return this[b.p(t2)]();
        }, m2.add = function(r2, f2) {
          var d2, l2 = this;
          r2 = Number(r2);
          var $2 = b.p(f2), y2 = function(t2) {
            var e2 = O(l2);
            return b.w(e2.date(e2.date() + Math.round(t2 * r2)), l2);
          };
          if ($2 === c) return this.set(c, this.$M + r2);
          if ($2 === h) return this.set(h, this.$y + r2);
          if ($2 === a) return y2(1);
          if ($2 === o) return y2(7);
          var M3 = (d2 = {}, d2[s] = e, d2[u] = n, d2[i] = t, d2)[$2] || 1, m3 = this.$d.getTime() + r2 * M3;
          return b.w(m3, this);
        }, m2.subtract = function(t2, e2) {
          return this.add(-1 * t2, e2);
        }, m2.format = function(t2) {
          var e2 = this, n2 = this.$locale();
          if (!this.isValid()) return n2.invalidDate || l;
          var r2 = t2 || "YYYY-MM-DDTHH:mm:ssZ", i2 = b.z(this), s2 = this.$H, u2 = this.$m, a2 = this.$M, o2 = n2.weekdays, c2 = n2.months, f2 = n2.meridiem, h2 = function(t3, n3, i3, s3) {
            return t3 && (t3[n3] || t3(e2, r2)) || i3[n3].slice(0, s3);
          }, d2 = function(t3) {
            return b.s(s2 % 12 || 12, t3, "0");
          }, $2 = f2 || function(t3, e3, n3) {
            var r3 = t3 < 12 ? "AM" : "PM";
            return n3 ? r3.toLowerCase() : r3;
          };
          return r2.replace(y, function(t3, r3) {
            return r3 || function(t4) {
              switch (t4) {
                case "YY":
                  return String(e2.$y).slice(-2);
                case "YYYY":
                  return b.s(e2.$y, 4, "0");
                case "M":
                  return a2 + 1;
                case "MM":
                  return b.s(a2 + 1, 2, "0");
                case "MMM":
                  return h2(n2.monthsShort, a2, c2, 3);
                case "MMMM":
                  return h2(c2, a2);
                case "D":
                  return e2.$D;
                case "DD":
                  return b.s(e2.$D, 2, "0");
                case "d":
                  return String(e2.$W);
                case "dd":
                  return h2(n2.weekdaysMin, e2.$W, o2, 2);
                case "ddd":
                  return h2(n2.weekdaysShort, e2.$W, o2, 3);
                case "dddd":
                  return o2[e2.$W];
                case "H":
                  return String(s2);
                case "HH":
                  return b.s(s2, 2, "0");
                case "h":
                  return d2(1);
                case "hh":
                  return d2(2);
                case "a":
                  return $2(s2, u2, true);
                case "A":
                  return $2(s2, u2, false);
                case "m":
                  return String(u2);
                case "mm":
                  return b.s(u2, 2, "0");
                case "s":
                  return String(e2.$s);
                case "ss":
                  return b.s(e2.$s, 2, "0");
                case "SSS":
                  return b.s(e2.$ms, 3, "0");
                case "Z":
                  return i2;
              }
              return null;
            }(t3) || i2.replace(":", "");
          });
        }, m2.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m2.diff = function(r2, d2, l2) {
          var $2, y2 = this, M3 = b.p(d2), m3 = O(r2), v2 = (m3.utcOffset() - this.utcOffset()) * e, g2 = this - m3, D2 = function() {
            return b.m(y2, m3);
          };
          switch (M3) {
            case h:
              $2 = D2() / 12;
              break;
            case c:
              $2 = D2();
              break;
            case f:
              $2 = D2() / 3;
              break;
            case o:
              $2 = (g2 - v2) / 6048e5;
              break;
            case a:
              $2 = (g2 - v2) / 864e5;
              break;
            case u:
              $2 = g2 / n;
              break;
            case s:
              $2 = g2 / e;
              break;
            case i:
              $2 = g2 / t;
              break;
            default:
              $2 = g2;
          }
          return l2 ? $2 : b.a($2);
        }, m2.daysInMonth = function() {
          return this.endOf(c).$D;
        }, m2.$locale = function() {
          return D[this.$L];
        }, m2.locale = function(t2, e2) {
          if (!t2) return this.$L;
          var n2 = this.clone(), r2 = w(t2, e2, true);
          return r2 && (n2.$L = r2), n2;
        }, m2.clone = function() {
          return b.w(this.$d, this);
        }, m2.toDate = function() {
          return new Date(this.valueOf());
        }, m2.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, m2.toISOString = function() {
          return this.$d.toISOString();
        }, m2.toString = function() {
          return this.$d.toUTCString();
        }, M2;
      }(), k = _167.prototype;
      return O.prototype = k, [["$ms", r], ["$s", i], ["$m", s], ["$H", u], ["$W", a], ["$M", c], ["$y", h], ["$D", d]].forEach(function(t2) {
        k[t2[1]] = function(e2) {
          return this.$g(e2, t2[0], t2[1]);
        };
      }), O.extend = function(t2, e2) {
        return t2.$i || (t2(e2, _167, O), t2.$i = true), O;
      }, O.locale = w, O.isDayjs = S, O.unix = function(t2) {
        return O(1e3 * t2);
      }, O.en = D[g], O.Ls = D, O.p = {}, O;
    });
  }
});

// src/utils/cookie.ts
import _10 from "lodash/fp.js";
var import_dayjs, getCookieOptions;
var init_cookie = __esm({
  "src/utils/cookie.ts"() {
    "use strict";
    import_dayjs = __toESM(require_dayjs_min(), 1);
    getCookieOptions = (durationDays = 7, iHost = void 0) => {
      const host = iHost ?? window.location.host;
      return {
        path: "/",
        expires: new Date(
          (0, import_dayjs.default)().add(durationDays * 24 * 60 * 60, "second").valueOf()
        ),
        maxAge: durationDays * 24 * 60 * 60,
        sameSite: "lax",
        secure: !_10.includes("localhost", host),
        ...host.match(/localhost|127\.0\.0\.1/) ? {} : { domain: ".lelivrescolaire.fr" }
      };
    };
  }
});

// src/utils/marketing.js
import _12 from "lodash/fp.js";
var getVariousStats, isShownCrispComponent;
var init_marketing = __esm({
  "src/utils/marketing.js"() {
    "use strict";
    getVariousStats = _12.flow(
      _12.toPairs,
      _12.map(([key, value]) => {
        return `${key}:${value};`;
      }),
      _12.join("")
    );
    isShownCrispComponent = ({ user, query = {}, isPresentationMode = false }) => !!_12.get("isTeacher", user) && !(user == null ? void 0 : user.isGarUser) && !(user == null ? void 0 : user.isTrial) && !isPresentationMode && !_12.get("docId", query);
  }
});

// src/constants/loading.ts
var LOADING_STATUS, LOADED_STATUS;
var init_loading2 = __esm({
  "src/constants/loading.ts"() {
    "use strict";
    LOADING_STATUS = "loading_status";
    LOADED_STATUS = "loaded_status";
  }
});

// src/selectors/loading.ts
import _14 from "lodash/fp.js";
import { getScreenLoadingEventName } from "@lls/utils";
var getLoadingStatus, getIsAppLoading, getIsLoading, getIsLoaded;
var init_loading3 = __esm({
  "src/selectors/loading.ts"() {
    "use strict";
    init_loading2();
    getLoadingStatus = (state, screen, params) => {
      const loadingState = _14.get("loading", state);
      return _14.flow(
        (screen2) => getScreenLoadingEventName(screen2, params),
        (screenLoadingEventName) => _14.get(screenLoadingEventName, loadingState)
      )(screen);
    };
    getIsAppLoading = _14.flow(_14.get("loading"), _14.omitBy(_14.isNil), _14.negate(_14.every(_14.isEqual(LOADED_STATUS))));
    getIsLoading = _14.flow(getLoadingStatus, _14.isEqual(LOADING_STATUS));
    getIsLoaded = _14.flow(getLoadingStatus, _14.isEqual(LOADED_STATUS));
  }
});

// src/components/loading.jsx
import { Loader } from "@lls/lls-kit";
import { useSelector as useSelector5 } from "react-redux";
import { jsx as jsx5 } from "react/jsx-runtime";
var Loading, loading_default2;
var init_loading4 = __esm({
  "src/components/loading.jsx"() {
    "use strict";
    init_loading3();
    Loading = ({ screen, params }) => {
      const isLoading = useSelector5((state) => getIsLoading(state, screen, params));
      return isLoading && /* @__PURE__ */ jsx5(Loader, {});
    };
    loading_default2 = Loading;
  }
});

// src/utils/notificationUi.js
var DEFAULT_ERROR_TITLE, makeNotification;
var init_notificationUi = __esm({
  "src/utils/notificationUi.js"() {
    "use strict";
    DEFAULT_ERROR_TITLE = "A\xEFe une erreur s'est produite...";
    makeNotification = ({ name, status, message, type, params }) => {
      switch (true) {
        case name === "login_success":
          return { name, severity: "success", type, params: { title: "Connexion r\xE9ussie !" } };
        case (name === "login_error" && status === 401):
          return {
            name,
            message: "Identifiants incorrects",
            severity: "error",
            type,
            params: { title: DEFAULT_ERROR_TITLE }
          };
        case name === "login_error":
          return {
            name,
            message: "Connexion impossible",
            severity: "error",
            type,
            params: { title: DEFAULT_ERROR_TITLE }
          };
        case name === "logout_success":
          return { name, severity: "success", type, params: { title: "D\xE9connexion r\xE9ussie !" } };
        case name === "registration_error":
          return {
            name,
            message: `Inscription impossible : ${message}`,
            severity: "error",
            type,
            params: { title: DEFAULT_ERROR_TITLE }
          };
        case name === "fetch_error":
          return {
            name,
            message: "Erreur lors de la r\xE9cup\xE9ration des donn\xE9es",
            severity: "error",
            type,
            params
          };
        case name === "update_user_success":
          return { name, message: "Mise \xE0 jour effectu\xE9e !", severity: "success", type, params };
        case name === "quote_success":
          return { name, severity: "success", type, params: { title: "Votre devis est pr\xEAt !" } };
        case name === "quote_ask_success":
          return { name, message: "Demande envoy\xE9e !", severity: "success", type, params };
        case name === "success":
          return { name, message, severity: "success", type, params };
        case name === "error":
          return { name, message, severity: "error", type, params };
        case name === "warning":
          return { name, message, severity: "warning", type, params };
        case name === "copy_doc_error":
          return {
            name,
            severity: "error",
            type,
            message: `Nous avons rencontr\xE9 un probl\xE8me lors de l'ajout de la ressource. Veuillez r\xE9essayer ou nous contacter si le probl\xE8me persiste.`,
            params: { title: "Ressource non ajout\xE9e" }
          };
        case name === "suggestion_email_error":
          return {
            name,
            severity: "error",
            type,
            message: "Nous avons rencontr\xE9 un probl\xE8me technique lors de l'envoi du message \xE0 nos \xE9quipes. N'h\xE9sitez pas \xE0 nous contacter directement via le chat pour nous partager votre retour.",
            params: {
              title: "Message non envoy\xE9",
              autoHide: 8e3
            }
          };
        case name === "change_view":
          return {
            name,
            severity: "success",
            type,
            message: (params == null ? void 0 : params.isRedirect) ? `Nous vous avons redirig\xE9 sur la premi\xE8re page du manuel car la fonctionnalit\xE9 \xE0 laquelle vous tentez d'acc\xE9der n'est disponible qu\u2019en vue "Professeur". Pour continuer les parcours de d\xE9couverte, repassez en vue "Professeur".` : `Pour continuer les parcours de d\xE9couverte, repassez en vue "Professeur". Votre manuel est identique \xE0 celui de vos \xE9l\xE8ves \xE0 quelques fonctionnalit\xE9s pr\xE8s.`,
            params: {
              title: 'Vous \xEAtes maintenant en vue "\xC9l\xE8ve" \u{1F642}',
              autoHide: 7e3
            }
          };
        case name === "trial_disabled_feature":
          return {
            name,
            severity: "info",
            type,
            message: "Dans le cadre de cet essai Premium, la fonctionnalit\xE9 est d\xE9sactiv\xE9e."
          };
        case name === "preferences_updated":
          return {
            name,
            type,
            severity: "success",
            message: "Vos pr\xE9f\xE9rences de communication ont \xE9t\xE9 mises \xE0 jour !"
          };
        case name === "is_offline":
          return {
            name,
            type,
            severity: "error",
            message: "Vous devez \xEAtre connect\xE9(e) \xE0 Internet pour acc\xE9der \xE0 cette fonctionnalit\xE9"
          };
        case name === "password_updated":
          return {
            name,
            type,
            severity: "success",
            message: "Votre mot de passe a bien \xE9t\xE9 mis \xE0 jour"
          };
        case name === "wrong_password":
          return {
            name,
            type,
            severity: "error",
            message: "Le mot de passe fourni est incorrect"
          };
        default:
          return { name, message, type, params };
      }
    };
  }
});

// src/effects/utils.ts
import _15 from "lodash/fp.js";
import { getScreenLoadingEventName as getScreenLoadingEventName2 } from "@lls/utils";
var triggerNotification, tryCatch;
var init_utils3 = __esm({
  "src/effects/utils.ts"() {
    "use strict";
    init_actions();
    init_constants();
    init_loading2();
    init_notificationUi();
    triggerNotification = ({
      name,
      status,
      message,
      params,
      type = SNACKBAR_NOTIFICATION,
      dispatch
    }) => dispatch && _15.flow(makeNotification, addNotification, dispatch)({ name, status, type, message, params });
    tryCatch = async ({
      dispatch,
      loadingName,
      effect = _15.noop,
      params = {},
      silent = false,
      errorName = "error",
      notificationType = SNACKBAR_NOTIFICATION,
      ...rest
    }) => {
      const screenEvent = loadingName ? getScreenLoadingEventName2(loadingName, params) : SCREEN_GLOBAL;
      try {
        !silent && (dispatch == null ? void 0 : dispatch(setLoadingScreen({ [screenEvent]: LOADING_STATUS })));
        return await effect({ params, dispatch, silent, ...rest });
      } catch (e) {
        console.error("effect error : ", e);
        !silent && triggerNotification({
          name: errorName,
          type: notificationType,
          message: _15.getOr(_15.get("message", e), "response.data", e),
          status: _15.get("statusCode", e),
          dispatch
        });
      } finally {
        !silent && (dispatch == null ? void 0 : dispatch(setLoadingScreen({ [screenEvent]: loadingName ? LOADED_STATUS : null })));
      }
    };
  }
});

// src/hooks/useCustomEffect.js
import { useCallback as useCallback4 } from "react";
import { useDispatch as useDispatch2 } from "react-redux";
import { useHistory } from "react-router-dom";
var useCustomEffect, useCustomEffect_default;
var init_useCustomEffect = __esm({
  "src/hooks/useCustomEffect.js"() {
    "use strict";
    init_es62();
    useCustomEffect = (customEffect) => {
      const history = useHistory();
      const dispatch = useDispatch2();
      const [cookies, setCookie, removeCookie] = useCookies();
      return useCallback4(
        (params) => {
          return customEffect({ history, dispatch, cookies, setCookie, removeCookie, params });
        },
        // biome-ignore lint/correctness/useExhaustiveDependencies: customEffect changes on every re-render and should not be used as a hook dependency
        [customEffect, history, dispatch, cookies, setCookie, removeCookie]
      );
    };
    useCustomEffect_default = useCustomEffect;
  }
});

// src/selectors/modal.ts
import _16 from "lodash/fp.js";
var getOpenModal;
var init_modal = __esm({
  "src/selectors/modal.ts"() {
    "use strict";
    getOpenModal = _16.flow(_16.get("modals"), _16.values, _16.find({ open: true }));
  }
});

// src/hocs/withRouterProvider.jsx
import { usePrevious as usePrevious2 } from "@lls/utils";
import React4, { useContext as useContext2 } from "react";
import { useLocation as useLocation4 } from "react-router-dom";
import { jsx as jsx12 } from "react/jsx-runtime";
var RouterContext, RouterProvider, withPreviousLocation, useAppData, withAppData;
var init_withRouterProvider = __esm({
  "src/hocs/withRouterProvider.jsx"() {
    "use strict";
    RouterContext = React4.createContext();
    RouterProvider = ({ children, appData }) => {
      const oldLocation = usePrevious2(useLocation4());
      return /* @__PURE__ */ jsx12(RouterContext.Provider, { value: { oldLocation, appData }, children });
    };
    withPreviousLocation = (ScreenComponent) => (props) => {
      const { oldLocation } = useContext2(RouterContext);
      return /* @__PURE__ */ jsx12(ScreenComponent, { ...props, previousLocation: oldLocation });
    };
    useAppData = () => {
      var _a2;
      return (_a2 = useContext2(RouterContext)) == null ? void 0 : _a2.appData;
    };
    withAppData = (ScreenComponent) => (props) => {
      const appData = useAppData();
      return /* @__PURE__ */ jsx12(ScreenComponent, { ...props, appData });
    };
  }
});

// src/api/rest.js
import _20 from "lodash/fp.js";
var post, getStream, getPdf;
var init_rest = __esm({
  "src/api/rest.js"() {
    "use strict";
    init_axios();
    init_config();
    post = (path, body, { query, token, responseType, cancelToken, onUploadProgress } = {}) => {
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      return axios_default.post(`${config_default.api_url}/${path}`, body, {
        headers,
        responseType,
        cancelToken,
        onUploadProgress,
        params: query
      }).then(_20.get("data"));
    };
    getStream = (path, { params, token, onChunk = _20.noop } = {}) => fetch(`${config_default.api_url}/${path}?${new URLSearchParams(params).toString()}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then((response) => {
      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");
      function processStream({ done, value }) {
        if (done) {
          return;
        }
        const chunk = decoder.decode(value);
        onChunk(chunk);
        return reader.read().then(processStream);
      }
      return reader.read().then(processStream);
    });
    getPdf = (link) => axios_default.get(link, { responseType: "blob" });
  }
});

// src/api/marketing.js
import _21 from "lodash/fp.js";
var sendNps, sendAskForTrainingEmail, subscribeToNewsletter;
var init_marketing2 = __esm({
  "src/api/marketing.js"() {
    "use strict";
    init_rest();
    sendNps = (data) => post("marketing/survey", data).then(_21.get("data"));
    sendAskForTrainingEmail = ({ token, ...props }) => post("marketing/send-ask-for-training-email", props, { token });
    subscribeToNewsletter = (props) => post("marketing/send-email", props);
  }
});

// src/api/school.js
import _22 from "lodash/fp.js";
var searchSchools;
var init_school = __esm({
  "src/api/school.js"() {
    "use strict";
    init_graphql();
    searchSchools = ({ ids, rne, academyId, department, schoolTypes }) => gql({
      query: `
      query coreSearchSchools ($ids: [Int], $rnes: [String], $academyIds: [Int], $departments: [String]){
        viewer {
          schools(ids: $ids, rnes: $rnes, academyIds: $academyIds, departments: $departments, isConfirmed: true){
            hits {
              id
              academy {
                name
                id
              }
              name
              city
              zipcode
              address
              confirmed
              id
              country
              connectors
              rne
              prefix
              department
              schoolTypes
            }
          }
        }
      }
    `,
      variables: {
        ids,
        rnes: rne ? [rne] : null,
        academyIds: academyId ? [academyId] : null,
        departments: department ? [department] : null,
        schoolTypes
      }
    }).then(_22.get("viewer.schools.hits"));
  }
});

// src/utils/notificationEntity.js
import _24 from "lodash/fp.js";
var import_dayjs2, getNotificationUpdatedAfterDate, getNotificationByPageId;
var init_notificationEntity = __esm({
  "src/utils/notificationEntity.js"() {
    "use strict";
    import_dayjs2 = __toESM(require_dayjs_min(), 1);
    getNotificationUpdatedAfterDate = () => (0, import_dayjs2.default)().subtract(30, "day").toISOString();
    getNotificationByPageId = (notifications2, pageId) => _24.find({ page: pageId }, notifications2);
  }
});

// src/api/book.ts
import { normalizeData as normalizeData2 } from "@lls/store";
var bookBaseFragment, fetchTeacherBookChaptersApi;
var init_book = __esm({
  "src/api/book.ts"() {
    "use strict";
    init_graphql();
    bookBaseFragment = `
  id
  slug
  displayTitle
  hasNewDesign
  valid
  url
  uri
  isWorkbook
  isWorkplan
  teacherBook
  oldBook {
    id
    slug
    displayTitle
    hasNewDesign
    valid
  }
`;
    fetchTeacherBookChaptersApi = ({
      bookId,
      token
    }) => gql({
      query: `query coreFetchTeacherBookChaptersApi ($ids: [Int]!, $token: String) {
      viewer(token: $token) {
        books (ids: $ids) {
          hits {
            id
            chapters {
              id
              title
              url
              teaser
              number
              numShow
              valid
              hasNewDesign
              teacherBook
              teacherDoc
              downloadResource
              audios
              hasNoTeacherBook
              book {
                id
              }
            }
          }
        }
      }
    }`,
      variables: {
        ids: [bookId],
        token
      }
    }).then(normalizeData2);
  }
});

// src/api/user.ts
import { userData } from "@lls/utils";
import { normalizeData as normalizeData3 } from "@lls/store";
var userFragment, userPageFragment, fetchUser, fetchMobileUser, fetchUserWithGroups, updateUser, updateLastActivitySeenAt, sendSuggestionEmail, updatePassword;
var init_user = __esm({
  "src/api/user.ts"() {
    "use strict";
    init_graphql();
    init_rest();
    init_notificationEntity();
    init_book();
    userFragment = `
  id
  confirmed
  entId
  academicEmail
  academicConfirmationToken
  academicEnabled
  booksV2 {
    id
    valid
    slug
    uri
    hasNewDesign
    publisher
    displayTitle
    subjects {
      id
    }
  }
  username
  email
  functions
  firstname
  lastname
  picture
  gender
  roleCalc
  isTrial
  trialStats
  onboardingData
  isPremium
  isStudent
  isTeacher
  isAdmin
  isEditorLLS
  isReviewer
  isReferent
  isGarUser
  needParentConsent
  hasToUpdateInfos
  schoolTypes
  shouldOnboard
  mainNotifications(updatedAfter: "${getNotificationUpdatedAfterDate()}") {
    id
    content {
      title
      subtitle
      pageInterval
      thumbnail
      url
    }
    page {
      id
      book {
        id
        displayTitle
      }
      chapter {
        id
        numShow
      }
    }
    type
    read
    createdAt
    updatedAt
  }
  levels {
    id
    name
    slug
    isMiddleSchool
    isHighSchool
    isElementarySchool
    order
  }
  subjects {
    id
    name
    url
    slug
  }
  schools {
    id
    prefix
    name
    rne
    isMiddleSchool
    isHighSchool
    department
    validLicenses {
      isEnabledForLearningAssessment
    }
  }
  lastActivitySeenAt
 
  lastPagesViewed (hasNewDesign:true) {
    id
    seenAt
    slug
    title
    displayTitle
    page
    nbPages
    valid
    chapter{
      id
      numShow
    }
    book {
      id
    }
  }
  lastBooksViewed {
    ${bookBaseFragment}
  }
  contacts {
    id
    firstname
    lastname
    email
    phone
    gender
    url
    departments
    calendarUrl
  }
`;
    userPageFragment = `
  id
  slug
  title
  displayTitle
  isOriginal
  createdAt
  updatedAt
  sharedAt
  seenAt
  isLearningAssessment
  isCreatedFromScratch
  thematicName
  parent {
    id
  }
  originalPage {
    id
    valid
    numericOrder
    isCreatedFromScratch
    nbPages
    page
  }
  book {
    id
    displayTitle
  }
  chapter {
    id
    numShow
  }
  user {
    id
  }
  sharedTeacher {
    id
    lastname
    gender
  }
  sharedGroups {
    id
  }
`;
    fetchUser = ({ token }) => gqlNoCache({
      query: `query coreFetchUser ($token: String!) {
      viewer(token: $token) {
        me {
          ${userFragment}
        }
      }
    }
`,
      variables: {
        token
      }
    }).then(normalizeData3);
    fetchMobileUser = ({ token }) => gqlNoCache({
      query: `query coreFetchUser ($token: String!) {
      viewer(token: $token) {
        me {
          ${userFragment}
          userPages: pages (hasNewDesign: true) {
            ${userPageFragment}
          }
        }
      }
    }
`,
      variables: {
        token
      }
    }).then(normalizeData3);
    fetchUserWithGroups = ({
      token,
      isTeacher = false,
      sharedAfter,
      maxUserPages
    }) => gqlNoCache({
      query: `query coreFetchUserWithGroups ($token: String!, $isTeacher: Boolean!, $sharedAfter: String, $maxUserPages: Int! ) {
      viewer(token: $token) {
        me {
          ${userFragment}
          userPages: pages (hasNewDesign: true, first: $maxUserPages) {
            ${userPageFragment}
          }
          userBookPages: lastPagesViewed (firstBooksViewed: 3) {
            ${userPageFragment}
          }
          sharedPages @include(if: $isTeacher){
            id
            isOriginal
            updatedAt
            isLearningAssessment
            user {
              id
              firstname
              lastname
              gender
              isStudent
              isTeacher
              username
              email
            }
            parent {
              id
            }
            sharedUsers {
              id
            }
          }
          groups @include(if: $isTeacher){
            id
            name
            owner {
              id
            }
            students {
              id
            }
            sharedPages(sharedAfter: $sharedAfter) {
              id
              slug
              valid
              isCreatedFromScratch
              page
              numericOrder
              title
              displayTitle
              createdAt
              updatedAt
              sharedAt
              isLearningAssessment
              isPartOfSession
              isWorkplan
              hasRightResponses
              nbSessionAnswersByGroups
              chapter {
                id
                numShow
              }
              book {
                id
                uri
              }
            }
          }
        }
      }
    }
`,
      variables: {
        token,
        isTeacher,
        sharedAfter,
        maxUserPages
      }
    }).then(normalizeData3);
    updateUser = ({ user, token }) => gqlNoCache({
      query: `
      mutation ($user: UserInput, $token: String!) {
        viewer(token: $token) {
          updateUser(user: $user) {
            ${userFragment}
            hasContentNewsletter
          }
        }
      }
      `,
      variables: {
        user: userData(user),
        token
      }
    }).then(normalizeData3);
    updateLastActivitySeenAt = ({ token }) => gqlNoCache({
      query: `mutation ($token: String!) {
      viewer (token: $token) {
        updateUserLastActivitySeenAt {
          id
          lastActivitySeenAt
        }
      }
    }`,
      variables: {
        token
      }
    }).then(normalizeData3);
    sendSuggestionEmail = ({
      token,
      pageId,
      schoolRne,
      bookId,
      suggestionType,
      details,
      email
    }) => post(`mail/suggestion?access_token=${token}`, {
      pageId,
      schoolRne,
      bookId,
      suggestionType,
      details,
      email
    });
    updatePassword = ({
      oldPassword,
      password,
      token
    }) => gqlNoCache({
      query: `
      mutation ($token: String!, $oldPassword: String!, $password: String!) {
        viewer(token: $token) {
          updateUserPassword(oldPassword: $oldPassword, password: $password) {
            id
          } 
        }
      }
      `,
      variables: {
        oldPassword,
        password,
        token
      }
    }).then(normalizeData3);
  }
});

// src/constants/onboarding.ts
var BEGINNER_PROFILE, INTERMEDIATE_PROFILE, EXPERT_PROFILE, PROFILES;
var init_onboarding = __esm({
  "src/constants/onboarding.ts"() {
    "use strict";
    BEGINNER_PROFILE = "beginner";
    INTERMEDIATE_PROFILE = "intermediate";
    EXPERT_PROFILE = "expert";
    PROFILES = [
      { id: BEGINNER_PROFILE, wording: "Je suis un nouvel utilisateur" },
      { id: INTERMEDIATE_PROFILE, wording: "J'ai d\xE9j\xE0 utilis\xE9 le manuel" },
      { id: EXPERT_PROFILE, wording: "Je connais tr\xE8s bien le manuel" }
    ];
  }
});

// css-modules:css-modules://ccelnFQCivsRvgekID1nXLxlfpAmwPUYKjXj0U5c9C8.css
var init_ccelnFQCivsRvgekID1nXLxlfpAmwPUYKjXj0U5c9C8 = __esm({
  "css-modules:css-modules://ccelnFQCivsRvgekID1nXLxlfpAmwPUYKjXj0U5c9C8.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_modal_onboarding_common.module.css
var src_components_modal_onboarding_common_default;
var init_src_components_modal_onboarding_common = __esm({
  "tmp_esbuild1736180049684/_src_components_modal_onboarding_common.module.css"() {
    "use strict";
    init_ccelnFQCivsRvgekID1nXLxlfpAmwPUYKjXj0U5c9C8();
    src_components_modal_onboarding_common_default = { "modal": "core-Ya68TW-modal", "modalImgContent": "core-Ya68TW-modalImgContent", "modalBody": "core-Ya68TW-modalBody", "modalContent": "core-Ya68TW-modalContent", "gif": "core-Ya68TW-gif", "modalHeader": "core-Ya68TW-modalHeader" };
  }
});

// src/components/modal/onboarding/common.module.css
var init_common = __esm({
  "src/components/modal/onboarding/common.module.css"() {
    "use strict";
    init_src_components_modal_onboarding_common();
  }
});

// src/components/modal/onboarding/common.jsx
import { Modal as Modal6 } from "@lls/lls-kit";
import { makeComponent } from "@lls/utils";
var StyledModalHeader, StyledModalBody, StyledModal, StyledModalContent, StyledModalImgContent, StyledGif;
var init_common2 = __esm({
  "src/components/modal/onboarding/common.jsx"() {
    "use strict";
    init_common();
    StyledModalHeader = makeComponent("div", src_components_modal_onboarding_common_default.modalHeader);
    StyledModalBody = makeComponent("div", src_components_modal_onboarding_common_default.modalBody);
    StyledModal = makeComponent(Modal6, src_components_modal_onboarding_common_default.modal);
    StyledModalContent = makeComponent("div", src_components_modal_onboarding_common_default.modalContent);
    StyledModalImgContent = makeComponent(StyledModalContent, src_components_modal_onboarding_common_default.modalImgContent);
    StyledGif = makeComponent("img", src_components_modal_onboarding_common_default.gif);
  }
});

// css-modules:css-modules://nsBA4KGQln624DI4w4qTozrjwN1mf0ZbNEjvNm5axHg.css
var init_nsBA4KGQln624DI4w4qTozrjwN1mf0ZbNEjvNm5axHg = __esm({
  "css-modules:css-modules://nsBA4KGQln624DI4w4qTozrjwN1mf0ZbNEjvNm5axHg.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_tour_common.module.css
var src_components_tour_common_default;
var init_src_components_tour_common = __esm({
  "tmp_esbuild1736180049684/_src_components_tour_common.module.css"() {
    "use strict";
    init_nsBA4KGQln624DI4w4qTozrjwN1mf0ZbNEjvNm5axHg();
    src_components_tour_common_default = { "renewed": "core-KzpPXq-renewed", "stepContent": "core-KzpPXq-stepContent", "gifMargin": "core-KzpPXq-gifMargin" };
  }
});

// src/components/tour/common.module.css
var init_common3 = __esm({
  "src/components/tour/common.module.css"() {
    "use strict";
    init_src_components_tour_common();
  }
});

// src/components/tour/common.tsx
import { Icon as Icon2 } from "@lls/lls-kit";
import { makeComponent as makeComponent2 } from "@lls/utils";
import { jsx as jsx17, jsxs as jsxs6 } from "react/jsx-runtime";
var StyledRenewed, TourIcon, exerciseWording, adaptationWording, ModifiedPageStepWithIllustration, AdaptationStepWithIllustration, RevisionStepWithIllustration;
var init_common4 = __esm({
  "src/components/tour/common.tsx"() {
    "use strict";
    init_common2();
    init_constants();
    init_common3();
    StyledRenewed = makeComponent2("span", src_components_tour_common_default.renewed);
    TourIcon = (props) => /* @__PURE__ */ jsx17(Icon2, { width: 24, height: 24, ...props });
    exerciseWording = "Vous retrouverez votre page d'exercices dans le sommaire apr\xE8s lui avoir donn\xE9 un nom !";
    adaptationWording = "Retrouvez votre page personnalis\xE9e dans le sommaire, en dessous de la page d'origine.";
    ModifiedPageStepWithIllustration = ({ isExercise }) => /* @__PURE__ */ jsxs6("div", { className: src_components_tour_common_default.stepContent, children: [
      /* @__PURE__ */ jsx17(StyledGif, { className: src_components_tour_common_default.gifMargin, src: `${ASSETS_HOST}/onboarding/gif${isExercise ? "3" : "5"}.gif` }),
      /* @__PURE__ */ jsx17("div", { children: isExercise ? exerciseWording : adaptationWording })
    ] });
    AdaptationStepWithIllustration = () => /* @__PURE__ */ jsxs6("div", { className: src_components_tour_common_default.stepContent, children: [
      /* @__PURE__ */ jsx17(StyledGif, { className: src_components_tour_common_default.gifMargin, src: `${ASSETS_HOST}/onboarding/gif4.gif` }),
      /* @__PURE__ */ jsx17("div", { children: "Placez le curseur \xE0 l'emplacement de votre choix, s\xE9lectionnez du texte et mettez-le en valeur avec les options de mise en forme." })
    ] });
    RevisionStepWithIllustration = () => /* @__PURE__ */ jsxs6("div", { className: src_components_tour_common_default.stepContent, children: [
      /* @__PURE__ */ jsx17(StyledGif, { className: src_components_tour_common_default.gifMargin, src: `${ASSETS_HOST}/onboarding/gif2.gif` }),
      /* @__PURE__ */ jsx17("div", { children: "Retrouvez ici toutes les ressources pour pr\xE9parer les \xE9l\xE8ves \xE0 une \xE9valuation : fiches synth\xE8se, quizz, et bien plus encore !" })
    ] });
  }
});

// css-modules:css-modules://iC_pY5TAB6FsEkekSty-LaN--oCQx6ox4lHEOeXw2fw.css
var init_iC_pY5TAB6FsEkekSty_LaN_oCQx6ox4lHEOeXw2fw = __esm({
  "css-modules:css-modules://iC_pY5TAB6FsEkekSty-LaN--oCQx6ox4lHEOeXw2fw.css"() {
  }
});

// tmp_esbuild1736180049684/_src_constants_trial.module.css
var src_constants_trial_default;
var init_src_constants_trial = __esm({
  "tmp_esbuild1736180049684/_src_constants_trial.module.css"() {
    "use strict";
    init_iC_pY5TAB6FsEkekSty_LaN_oCQx6ox4lHEOeXw2fw();
    src_constants_trial_default = { "bold": "core-cuT5yG-bold", "premium": "core-cuT5yG-premium" };
  }
});

// src/constants/trial.module.css
var init_trial = __esm({
  "src/constants/trial.module.css"() {
    "use strict";
    init_src_constants_trial();
  }
});

// src/constants/trial.jsx
import { Fragment as Fragment2, jsx as jsx18, jsxs as jsxs7 } from "react/jsx-runtime";
var SHARE_TRIAL_TIP, OFFLINE_TRIAL_TIP, STUDENT_VIEW_FORBIDDEN_ROUTES, JOURNEY_AUTONOMOUS, JOURNEY_GUIDED, JOURNEY_ACCOMPANIED, JOURNEYS, Premium, MODAL_CORRECTION, MODAL_PROJECTION, MODAL_SAVE_PAGE, MODAL_EXPORT, MODAL_CLASSROOM, MODAL_FEATURES, CALENDLY_LINK;
var init_trial2 = __esm({
  "src/constants/trial.jsx"() {
    "use strict";
    init_constants();
    init_route();
    init_trial();
    SHARE_TRIAL_TIP = {
      videoUrl: `${ASSETS_HOST}/marketing/tips/3_Partager+des+pages+500-400.mp4`,
      title: "Partagez vos contenus \xE0 vos \xE9l\xE8ves !",
      text: "D\xE9couvrez comment partager vos contenus gr\xE2ce \xE0 cette vid\xE9o !",
      subtext: "Dans le cadre de cet essai Premium, la fonctionnalit\xE9 de partage est d\xE9sactiv\xE9e."
    };
    OFFLINE_TRIAL_TIP = {
      videoUrl: `${ASSETS_HOST}/marketing/tips/2_Te\u0301le\u0301charger+ses+manuels+500-400.mp4`,
      title: "Pas de connexion internet dans votre classe ?",
      text: /* @__PURE__ */ jsxs7(Fragment2, { children: [
        "Pas de panique ! Votre manuel est aussi disponible ",
        /* @__PURE__ */ jsx18("span", { className: src_constants_trial_default.bold, children: "hors-connexion" }),
        " depuis notre ",
        /* @__PURE__ */ jsx18("span", { className: src_constants_trial_default.bold, children: "application sur ordinateur, tablette et smartphone !" })
      ] })
    };
    STUDENT_VIEW_FORBIDDEN_ROUTES = ["/groups", "/mesclasses"];
    JOURNEY_AUTONOMOUS = "journey_autonomous";
    JOURNEY_GUIDED = "journey_guided";
    JOURNEY_ACCOMPANIED = "journey_accompanied";
    JOURNEYS = [
      {
        id: JOURNEY_AUTONOMOUS,
        title: "Le parcours autonome",
        description: "S\xE9lectionnez un manuel num\xE9rique et, testez le Premium par vous-m\xEAme !"
      },
      {
        id: JOURNEY_GUIDED,
        title: "Le parcours guid\xE9",
        description: "S\xE9lectionnez un manuel num\xE9rique et, d\xE9couvrez pas-\xE0-pas les fonctionnalit\xE9s du Premium."
      },
      {
        id: JOURNEY_ACCOMPANIED,
        title: "Le parcours accompagn\xE9",
        description: "Profitez d'une d\xE9monstration assist\xE9e, en visioconf\xE9rence !"
      }
    ];
    Premium = () => /* @__PURE__ */ jsx18("span", { className: src_constants_trial_default.premium, children: "Premium" });
    MODAL_CORRECTION = "modal_correction";
    MODAL_PROJECTION = "modal_projection";
    MODAL_SAVE_PAGE = "modal_save_page";
    MODAL_EXPORT = "modal_export";
    MODAL_CLASSROOM = "modal_classroom";
    MODAL_FEATURES = {
      [MODAL_CORRECTION]: {
        title: "Les corrections sont int\xE9gr\xE9es dans la version Premium !",
        content: /* @__PURE__ */ jsxs7("p", { children: [
          "Nous ne pouvons pas afficher les corrections sur la plateforme de d\xE9monstration. Cependant, les corrections des exercices sont disponibles",
          " ",
          /* @__PURE__ */ jsx18("a", { href: getPath("teacher_book"), target: "blank", children: "sur cette page" }),
          "."
        ] })
      },
      [MODAL_PROJECTION]: {
        title: "La projection de contenus c\xF4te-\xE0-c\xF4te est disponible dans la version Premium !",
        content: /* @__PURE__ */ jsxs7(Fragment2, { children: [
          /* @__PURE__ */ jsxs7("p", { children: [
            "Le mode pr\xE9sentation qui vous permet de diviser votre \xE9cran pour projeter plusieurs contenus c\xF4te-\xE0-c\xF4te est disponible dans la version ",
            /* @__PURE__ */ jsx18(Premium, {}),
            "."
          ] }),
          /* @__PURE__ */ jsxs7("p", { children: [
            "Si vous souhaitez tester plus amplement la projection au sein du Manuel Num\xE9rique ",
            /* @__PURE__ */ jsx18(Premium, {}),
            " nous vous invitons \xE0 prendre rendez-vous avec notre \xE9quipe."
          ] })
        ] })
      },
      [MODAL_SAVE_PAGE]: {
        title: `L'enregistrement est disponible dans la version Premium !`,
        content: /* @__PURE__ */ jsxs7(Fragment2, { children: [
          /* @__PURE__ */ jsxs7("p", { children: [
            "L'enregistrement des pages personnalis\xE9es n'est pas possible sur la plateforme de d\xE9monstration. Cependant, cette fonctionnalit\xE9 est disponible dans le Manuel Num\xE9rique ",
            /* @__PURE__ */ jsx18(Premium, {}),
            "."
          ] }),
          /* @__PURE__ */ jsxs7("p", { children: [
            "Si vous souhaitez tester plus amplement la personnalisation au sein du Manuel Num\xE9rique ",
            /* @__PURE__ */ jsx18(Premium, {}),
            " nous vous invitons \xE0 prendre rendez-vous avec notre \xE9quipe."
          ] })
        ] })
      },
      [MODAL_EXPORT]: {
        title: "Le t\xE9l\xE9chargement est disponible dans la version Premium !",
        content: /* @__PURE__ */ jsxs7(Fragment2, { children: [
          /* @__PURE__ */ jsxs7("p", { children: [
            "Le t\xE9l\xE9chargement des pages au format PDF, Word et l'export Moodle n'est pas disponible sur la plateforme de d\xE9monstration. Cependant, l'export est enti\xE8rement int\xE9gr\xE9 au Manuel Num\xE9rique ",
            /* @__PURE__ */ jsx18(Premium, {}),
            "."
          ] }),
          /* @__PURE__ */ jsxs7("p", { children: [
            "Si vous souhaitez tester plus amplement cette fonctionnalit\xE9 au sein du Manuel Num\xE9rique ",
            /* @__PURE__ */ jsx18(Premium, {}),
            " nous vous invitons \xE0 prendre rendez-vous avec notre \xE9quipe."
          ] })
        ] })
      },
      [MODAL_CLASSROOM]: {
        title: `L'import des classes est disponible dans la version Premium !`,
        content: /* @__PURE__ */ jsxs7(Fragment2, { children: [
          /* @__PURE__ */ jsxs7("p", { children: [
            "La gestion des classes n'est pas possible sur la plateforme de d\xE9monstration. Cependant, l'import et la gestion de vos classes sont disponibles dans le Manuel Num\xE9rique ",
            /* @__PURE__ */ jsx18(Premium, {}),
            "."
          ] }),
          /* @__PURE__ */ jsx18("p", { children: "Bonus pour les utilisateurs du GAR/Mediacentre : vous pourrez importer les classes cr\xE9\xE9es dans votre ENT, et les \xE9l\xE8ves associ\xE9s !" }),
          /* @__PURE__ */ jsxs7("p", { children: [
            "Si vous souhaitez tester le Manuel Num\xE9rique ",
            /* @__PURE__ */ jsx18(Premium, {}),
            " avec votre classe nous vous invitons \xE0 prendre rendez-vous avec notre \xE9quipe."
          ] })
        ] })
      }
    };
    CALENDLY_LINK = "http://lls.fr/rdv";
  }
});

// src/constants/tour.tsx
import _25 from "lodash/fp.js";
import { DRAWER_MY_PAGES_ID } from "@lls/superkit";
import { hasTemplateRightResponses } from "@lls/viewer/staticImports";
import { Fragment as Fragment3, jsx as jsx19, jsxs as jsxs8 } from "react/jsx-runtime";
var PROJECTION_TOUR, ACTUALISATION_TOUR, CREATE_PAGE_TOUR, OFFLINE_TOUR, SHOW_CORRECTION_TOUR, SESSION_TOUR, DISCOVERY_TOUR, SHARE_TOUR, PAGE_ADAPTATION_TOUR, REVISION_TOUR, TRIAL_SCENARIO, ONBOARDING_SCENARIO, TOUR_EVENTS, TOUR_ACTIONS, TOURS, SCENARIOS;
var init_tour2 = __esm({
  "src/constants/tour.tsx"() {
    "use strict";
    init_actions();
    init_common4();
    init_constants();
    init_onboarding();
    init_route();
    init_trial2();
    PROJECTION_TOUR = "projection_tour";
    ACTUALISATION_TOUR = "actualisation_tour";
    CREATE_PAGE_TOUR = "create_page_tour";
    OFFLINE_TOUR = "offline_tour";
    SHOW_CORRECTION_TOUR = "show_correction_tour";
    SESSION_TOUR = "session_tour";
    DISCOVERY_TOUR = "discovery_tour";
    SHARE_TOUR = "share_tour";
    PAGE_ADAPTATION_TOUR = "page_adaptation_tour";
    REVISION_TOUR = "revision_tour";
    TRIAL_SCENARIO = "trial_scenario";
    ONBOARDING_SCENARIO = "onboarding_scenario";
    TOUR_EVENTS = {
      CREATE_PAGE_BUTTON_CLICK: "create_page_button_click",
      CREATION_HELPER_CLICK: "creation_helper_click",
      ADD_RESOURCE_BUTTON_CLICK: "add_resource_button_click",
      OPEN_SAVE_MODAL: "open_save_modal",
      SESSION_TEACHER_TAB_LOADED: "session_teacher_tab_loaded",
      SESSION_PAGE_CLICKED: "session_page_clicked",
      TEACHER_STUDENT_SWITCH: "teacher_student_switch",
      TIP_MODAL_CLOSED: "tip_modal_closed",
      OPEN_RENEWAL_CATEGORY: "open_renewal_category",
      OPEN_ANSWERS: "open_answers",
      OPEN_FULLSCREEN_CARD: "open_fullscreen_card",
      OPEN_SPLIT_VIEW: "open_split_view",
      CLOSE_PROJECTOR_VIEW: "close_projector_view",
      OPEN_SHARE_MODAL: "open_share_modal",
      SET_SHARE_LINK_TAB: "set_share_link_tab",
      OPEN_MORE_BUTTON: "open_more_button",
      PICK_CREATE_PAGE_DOCUMENT: "pick_create_page_document"
    };
    TOUR_ACTIONS = {
      navigateToRightResponses: ({ currentPage, firstPageWithRightResponses, history }) => {
        if (!hasTemplateRightResponses(currentPage) || (currentPage == null ? void 0 : currentPage.isPartOfSession)) {
          history.push(getPath("page", { slug: firstPageWithRightResponses == null ? void 0 : firstPageWithRightResponses.slug }));
        }
      },
      navigateToFirstPage: ({ currentPage, firstPage, history }) => {
        if (!currentPage || (currentPage == null ? void 0 : currentPage.isPartOfSession)) {
          history.push(getPath("page", { slug: firstPage == null ? void 0 : firstPage.slug }));
        }
      },
      navigateToFirstExercisePage: ({
        currentPage,
        firstExercisePage,
        setIsDrawerOpen: setIsDrawerOpen2,
        setExpandedId,
        history
      }) => {
        !(currentPage == null ? void 0 : currentPage.isExercise) && (history == null ? void 0 : history.push(getPath("page", { slug: firstExercisePage == null ? void 0 : firstExercisePage.slug })));
        setIsDrawerOpen2(true);
        setExpandedId(DRAWER_MY_PAGES_ID);
      }
    };
    TOURS = [
      {
        id: PROJECTION_TOUR,
        profile: INTERMEDIATE_PROFILE,
        title: /* @__PURE__ */ jsxs8(Fragment3, { children: [
          /* @__PURE__ */ jsx19("b", { children: "Projetez les contenus" }),
          " en un clic"
        ] }),
        onTourStart: TOUR_ACTIONS.navigateToFirstPage,
        steps: [
          {
            dataTour: "viewer-fullscreen-card-button",
            content: /* @__PURE__ */ jsxs8(Fragment3, { children: [
              "Pour agrandir une ressource en particulier, cliquez sur le bouton ",
              /* @__PURE__ */ jsx19(TourIcon, { name: "fitscreen" }),
              "."
            ] }),
            nextEvent: TOUR_EVENTS.OPEN_FULLSCREEN_CARD,
            shouldListen: true,
            withSpotlight: true,
            spotlightType: "round",
            spotlightMargin: 4
          },
          {
            dataTour: "viewer-split-button",
            content: /* @__PURE__ */ jsxs8(Fragment3, { children: [
              "Vous pouvez parcourir la page tout en gardant votre ressource sur le c\xF4t\xE9, pour afficher les questions associ\xE9es par exemple. Cliquez sur ce bouton ",
              /* @__PURE__ */ jsx19(TourIcon, { name: "viewcolumn" }),
              "."
            ] }),
            nextEvent: TOUR_EVENTS.OPEN_SPLIT_VIEW,
            withSpotlight: true,
            spotlightType: "round",
            spotlightMargin: 4
          },
          {
            content: /* @__PURE__ */ jsx19(Fragment3, { children: "F\xE9licitations ! Vous ma\xEEtrisez parfaitement la projection ! Nous esp\xE9rons que vous en ferez bon usage en classe \u{1F973}" }),
            placement: "center",
            fixed: true,
            disableFlip: true,
            distance: 100,
            disableBeacon: true,
            disableArrow: true,
            withMask: true,
            visibleMask: true
          }
        ]
      },
      {
        id: ACTUALISATION_TOUR,
        title: /* @__PURE__ */ jsx19(Fragment3, { children: "Explorez nos nouveaux contenus actualis\xE9s" }),
        onTourStart: ({ history, currentBook }) => {
          history == null ? void 0 : history.push(getPath("book", { uri: currentBook == null ? void 0 : currentBook.uri }));
        },
        steps: [
          {
            dataTour: "superkit-renewal",
            withSpotlight: true,
            spotlightType: "rectangle",
            spotlightMargin: 10,
            preventOverflow: false,
            disableBeacon: true,
            distance: 20,
            content: /* @__PURE__ */ jsxs8(Fragment3, { children: [
              "Retrouvez tous les contenus actualis\xE9s de votre manuel gr\xE2ce au label",
              " ",
              /* @__PURE__ */ jsx19(StyledRenewed, { children: "Actualis\xE9 2023" }),
              "."
            ] }),
            nextEvent: TOUR_EVENTS.OPEN_RENEWAL_CATEGORY
          }
        ]
      },
      {
        id: CREATE_PAGE_TOUR,
        profile: INTERMEDIATE_PROFILE,
        title: /* @__PURE__ */ jsxs8(Fragment3, { children: [
          "Cr\xE9ez vos ",
          /* @__PURE__ */ jsx19("b", { children: "propres pages d'exercices" })
        ] }),
        onTourStart: TOUR_ACTIONS.navigateToFirstExercisePage,
        steps: [
          {
            dataTour: "core-create-exercises-button",
            needsDrawer: true,
            content: /* @__PURE__ */ jsx19(Fragment3, { children: `Pour cr\xE9er vos pages personnalis\xE9es \xE0 partir de vos manuels, cliquez sur le bouton "Cr\xE9er ma fiche d'exercices".` }),
            nextEvent: TOUR_EVENTS.CREATE_PAGE_BUTTON_CLICK,
            placement: "bottom",
            withSpotlight: true,
            spotlightMargin: 8,
            spotlightType: "rectangle"
          },
          {
            dataTour: "viewer-create-from-resource-button",
            neededViewer: VIEWER_CREATE_PAGE,
            content: /* @__PURE__ */ jsx19(Fragment3, { children: "Partons d'une page vierge, ajoutons ensemble le premier contenu. Nous allons en s\xE9lectionner un d\xE9j\xE0 existant." }),
            nextEvent: TOUR_EVENTS.CREATION_HELPER_CLICK,
            withSpotlight: true,
            spotlightMargin: 8,
            spotlightType: "rectangle"
          },
          {
            dataTour: "viewer-picker-checkbox",
            neededViewer: VIEWER_BOOK_BROWSING_MODAL,
            noScroll: true,
            title: "S\xE9lectionnez les ressources \xE0 ajouter \xE0 vos propres pages d'exercice",
            content: /* @__PURE__ */ jsxs8(Fragment3, { children: [
              "S\xE9lectionnez les contenus qui vous int\xE9ressent en cochant la case ",
              /* @__PURE__ */ jsx19(TourIcon, { name: "checkbox" }),
              " ci-dessous."
            ] }),
            nextEvent: TOUR_EVENTS.PICK_CREATE_PAGE_DOCUMENT
          },
          {
            dataTour: "premium-add-selected-resources",
            neededViewer: VIEWER_BOOK_BROWSING_MODAL,
            noScroll: true,
            title: "Validez les ressources \xE0 ajouter \xE0 votre page",
            content: /* @__PURE__ */ jsx19(Fragment3, { children: `Cliquez sur le bouton "ajouter des ressources" en bas de l'\xE9cran pour ajouter les ressources s\xE9lectionn\xE9es \xE0 votre page.` }),
            nextEvent: TOUR_EVENTS.ADD_RESOURCE_BUTTON_CLICK
          },
          {
            dataTour: "superkit-save-button",
            neededViewer: VIEWER_CREATE_PAGE,
            content: /* @__PURE__ */ jsx19(Fragment3, { children: "Votre page d'exercices est bient\xF4t pr\xEAte. Vous pouvez l'enregistrer en cliquant sur ce bouton." }),
            withNextButton: true,
            withSpotlight: true,
            spotlightMargin: 8,
            spotlightType: "rectangle",
            clickInside: false,
            noScroll: true,
            onCompleted: ({ firstExercisePage, history }) => {
              history.push(getPath("page", { slug: firstExercisePage == null ? void 0 : firstExercisePage.slug }));
            }
          },
          {
            dataTour: "core-my-pages",
            content: /* @__PURE__ */ jsx19(ModifiedPageStepWithIllustration, { isExercise: true }),
            placement: "right",
            disableBeacon: true,
            withSpotlight: true,
            spotlightMargin: 8,
            spotlightType: "rectangle",
            clickInside: false,
            needsDrawer: true,
            onlyForScenario: ONBOARDING_SCENARIO
          },
          {
            dataTour: "core-my-pages",
            content: /* @__PURE__ */ jsx19(Fragment3, { children: "Vos pages personnalis\xE9es sont accessibles depuis le sommaire. Modifiez le contenu \xE0 la vol\xE9e et cr\xE9ez maintenant le manuel qui VOUS ressemble \u{1F929}" }),
            disableBeacon: true,
            withSpotlight: true,
            spotlightMargin: 8,
            spotlightType: "rectangle",
            clickInside: false,
            needsDrawer: true,
            onlyForScenario: TRIAL_SCENARIO,
            isContactStep: true
          }
        ]
      },
      {
        id: OFFLINE_TOUR,
        title: /* @__PURE__ */ jsx19(Fragment3, { children: "Consultez les contenus hors-connexion" }),
        onTourStart: ({ openOfflineTipModal }) => {
          openOfflineTipModal();
        },
        steps: [{ nextEvent: TOUR_EVENTS.TIP_MODAL_CLOSED }]
      },
      {
        id: SHOW_CORRECTION_TOUR,
        title: /* @__PURE__ */ jsxs8(Fragment3, { children: [
          "Affichez la ",
          /* @__PURE__ */ jsx19("b", { children: "correction des exercices" })
        ] }),
        onTourStart: TOUR_ACTIONS.navigateToRightResponses,
        steps: [
          {
            dataTour: "viewer-answers-button",
            content: /* @__PURE__ */ jsxs8(Fragment3, { children: [
              "Affichez la correction des exercices en cliquant sur le bouton",
              " ",
              /* @__PURE__ */ jsx19("img", { src: "/assets/img/tour/show-corrections-button.svg", alt: "Afficher la correction" }),
              "."
            ] }),
            withSpotlight: true,
            spotlightType: "round",
            distance: 95,
            spotlightMargin: 8,
            disableBeacon: true,
            nextEvent: TOUR_EVENTS.OPEN_ANSWERS,
            clickOutside: true,
            withNextButton: true
          },
          {
            content: /* @__PURE__ */ jsxs8(Fragment3, { children: [
              "Dans le cadre de cette D\xE9mo, les corrections ne sont pas disponibles. Pour les afficher enti\xE8rement, abonnez-vous \xE0 notre offre ",
              /* @__PURE__ */ jsx19(Premium, {}),
              "."
            ] }),
            fixed: true,
            disableFlip: true,
            distance: 100,
            disableBeacon: true,
            disableArrow: true,
            withMask: true,
            visibleMask: true,
            placement: "center",
            isContactStep: true,
            onlyForScenario: TRIAL_SCENARIO,
            noScroll: true
          }
        ]
      },
      {
        id: SESSION_TOUR,
        title: /* @__PURE__ */ jsxs8(Fragment3, { children: [
          "Faites ",
          /* @__PURE__ */ jsx19("b", { children: "r\xE9viser vos \xE9l\xE8ves" })
        ] }),
        onTourStart: ({ setExpandedId, firstSessionPage, setIsDrawerOpen: setIsDrawerOpen2 }) => {
          setIsDrawerOpen2(true);
          setExpandedId(firstSessionPage == null ? void 0 : firstSessionPage.chapter);
        },
        steps: [
          {
            dataTour: "superkit-summary-page",
            params: "firstSessionPage.id",
            needsDrawer: true,
            nextEvent: TOUR_EVENTS.SESSION_PAGE_CLICKED,
            content: /* @__PURE__ */ jsx19(Fragment3, { children: "Cliquez sur cette page pour acc\xE9der aux exercices de r\xE9vision autocorrig\xE9s." }),
            withSpotlight: true,
            spotlightType: "rectangle",
            spotlightMargin: 0
          },
          {
            dataTour: "superkit-tabs-session-stats-teacher-tab",
            neededViewer: VIEWER_DEFAULT,
            placement: "top",
            nextEvent: TOUR_EVENTS.SESSION_TEACHER_TAB_LOADED,
            content: /* @__PURE__ */ jsx19(Fragment3, { children: `Vos \xE9l\xE8ves ont acc\xE8s \xE0 une centaine d'exercices autocorrig\xE9s ! Consultez leurs r\xE9sultats en cliquant sur le bouton "Statistiques de mes \xE9l\xE8ves".` })
          },
          {
            dataTour: "premium-switch-student-teacher",
            placement: "bottom",
            content: /* @__PURE__ */ jsx19(Fragment3, { children: 'Bravo ! Et si on d\xE9couvrait ce que voient vos \xE9l\xE8ves ? \u{1F575} Pour ce faire, cliquez sur le bouton "\xC9l\xE8ve"' }),
            nextEvent: TOUR_EVENTS.TEACHER_STUDENT_SWITCH,
            onlyForScenario: ONBOARDING_SCENARIO
          },
          {
            dataTour: "premium-switch-student-teacher",
            placement: "left",
            content: /* @__PURE__ */ jsxs8(Fragment3, { children: [
              'Bravo ! Et si on d\xE9couvrait ce que voient vos \xE9l\xE8ves ? \u{1F575} Pour ce faire, cliquez sur le bouton "Professeur" puis "\xC9l\xE8ve"',
              /* @__PURE__ */ jsx19("br", {}),
              /* @__PURE__ */ jsx19("br", {})
            ] }),
            nextEvent: TOUR_EVENTS.TEACHER_STUDENT_SWITCH,
            isContactStep: true,
            onlyForScenario: TRIAL_SCENARIO
          }
        ]
      },
      {
        id: DISCOVERY_TOUR,
        profile: BEGINNER_PROFILE,
        title: /* @__PURE__ */ jsx19(Fragment3, { children: "Naviguez au sein du manuel" }),
        onTourStart: ({ history, currentBook }) => {
          history.push(getPath("book", { uri: currentBook == null ? void 0 : currentBook.uri }));
        },
        steps: [
          {
            title: "Allez directement \xE0 la page souhait\xE9e",
            dataTour: "superkit-search-container",
            content: "Saisissez le num\xE9ro de la page sans passer par le sommaire et retrouvez-la directement.",
            withSpotlight: true,
            spotlightType: "rectangle",
            spotlightMargin: 0,
            disableBeacon: true,
            withNextButton: true,
            clickInside: false
          },
          {
            title: "Un filtre pour parcourir plus rapidement le manuel",
            dataTour: "superkit-filter-button",
            content: "Vous trouverez directement les pages d'exercices ou encore les contenus exclusifs r\xE9serv\xE9s aux abonn\xE9s.",
            withSpotlight: true,
            spotlightType: "rectangle",
            spotlightMargin: 0,
            disableBeacon: true,
            withNextButton: true,
            clickInside: false
          },
          {
            title: "Des outils num\xE9riques compl\xE9mentaires",
            dataTour: "superkit-toolbox",
            content: "Enrichissez et diversifiez vos pratiques p\xE9dagogiques gr\xE2ce aux outils num\xE9riques et dossiers d'actualit\xE9 sp\xE9cialement con\xE7us pour votre mati\xE8re.",
            withSpotlight: true,
            spotlightType: "rectangle",
            spotlightMargin: 0,
            disableBeacon: true,
            withNextButton: true,
            onCompleted: TOUR_ACTIONS.navigateToRightResponses,
            clickInside: false
          },
          {
            title: "Un t\xE9l\xE9chargement des pages en un clic",
            dataTour: "superkit-export-button",
            content: "T\xE9l\xE9chargez vos pages en un clic avec une mise en page revue pour une meilleure lisibilit\xE9 et des options de param\xE9trage ont \xE9t\xE9 ajout\xE9es.",
            withSpotlight: true,
            spotlightType: "round",
            spotlightMargin: 4,
            disableBeacon: true,
            withNextButton: true,
            clickInside: false
          },
          {
            title: "Une projection adapt\xE9e \xE0 votre salle de classe",
            dataTour: "viewer-fullscreen-card-button",
            content: "Naviguez facilement entre les ressources, annotez-les et profitez du mode c\xF4te \xE0 c\xF4te. Id\xE9al pour mettre un document et ses questions en regard !",
            withSpotlight: true,
            spotlightType: "round",
            spotlightMargin: 4,
            disableBeacon: true,
            withNextButton: true,
            clickInside: false
          },
          {
            title: "Des options d'affichage accessibles",
            dataTour: "superkit-accessibility-button",
            content: "Changez la typographie d'affichage, augmentez ou r\xE9duisez la taille de la police. Vous pouvez aussi adapter l'affichage aux \xE9l\xE8ves dys.",
            withSpotlight: true,
            spotlightType: "round",
            spotlightMargin: 4,
            disableBeacon: true,
            onCompleted: TOUR_ACTIONS.navigateToRightResponses,
            withNextButton: true,
            clickInside: false
          },
          {
            title: "Des corrections accessibles en un clic",
            dataTour: "viewer-answers-button",
            content: "Rassurez-vous, vos \xE9l\xE8ves n'ont pas acc\xE8s \xE0 la correction !",
            withSpotlight: true,
            spotlightType: "round",
            spotlightMargin: 8,
            disableBeacon: true,
            withNextButton: true,
            clickInside: false
          }
        ]
      },
      {
        id: SHARE_TOUR,
        profile: INTERMEDIATE_PROFILE,
        title: "Interagissez avec vos \xE9l\xE8ves",
        onTourStart: TOUR_ACTIONS.navigateToFirstPage,
        steps: [
          {
            dataTour: "superkit-share-button",
            content: "En partageant directement le contenu avec vos classes, gagnez un temps important dans le suivi des activit\xE9s.",
            withSpotlight: true,
            spotlightType: "round",
            spotlightMargin: 2,
            nextEvent: TOUR_EVENTS.OPEN_SHARE_MODAL
          },
          {
            dataTour: "superkit-share-group-tab",
            title: "Une gestion de classe facilit\xE9e",
            disableFlip: true,
            distance: -20,
            disableBeacon: true,
            content: "Cette ann\xE9e, r\xE9cup\xE9rez les classes depuis votre ENT ou appuyez-vous sur celles d\xE9j\xE0 cr\xE9\xE9es par vos coll\xE8gues. Plus besoin de les configurer vous-m\xEAme.",
            withNextButton: true,
            withMask: true,
            onCompleted: () => {
              document.dispatchEvent(new Event("superkit-set-share-link-tab"));
            },
            noScroll: true
          },
          {
            dataTour: "superkit-share-link-tab",
            disableFlip: true,
            distance: -20,
            disableBeacon: true,
            content: "Vous pouvez aussi copier le lien de la page et le partager dans le cahier de texte de l'ENT.",
            withNextButton: true,
            withMask: true,
            onCompleted: () => {
              document.dispatchEvent(new Event("superkit-set-share-resource-tab"));
            },
            noScroll: true
          },
          {
            dataTour: "superkit-share-resource-tab",
            disableFlip: true,
            distance: -20,
            disableBeacon: true,
            content: "Vous n'avez pas besoin de partager toute la page ? Pas de probl\xE8me, s\xE9lectionnez les ressources que vous souhaitez !",
            withNextButton: true,
            withMask: true,
            onCompleted: () => {
              document.dispatchEvent(new Event("superkit-close-share-modal"));
            },
            noScroll: true
          },
          {
            dataTour: "superkit-notification-menu",
            placement: "bottom",
            disableBeacon: true,
            content: /* @__PURE__ */ jsxs8(Fragment3, { children: [
              "Vos \xE9l\xE8ves seront pr\xE9venus du partage de contenu en recevant une notification qui s'affichera ici",
              " ",
              /* @__PURE__ */ jsx19(TourIcon, { name: "bell" }),
              "."
            ] }),
            withSpotlight: true,
            spotlightType: "round",
            spotlightMargin: 2,
            clickInside: false,
            noScroll: true
          }
        ]
      },
      {
        id: PAGE_ADAPTATION_TOUR,
        profile: INTERMEDIATE_PROFILE,
        onTourStart: TOUR_ACTIONS.navigateToFirstPage,
        title: "Concevez des s\xE9quences p\xE9dagogiques diff\xE9renci\xE9es",
        steps: [
          {
            dataTour: "viewer-document-toolbar-more-button",
            content: /* @__PURE__ */ jsxs8(Fragment3, { children: [
              "En cliquant sur ",
              /* @__PURE__ */ jsx19(TourIcon, { name: "verticaldots" }),
              ", acc\xE9dez aux options de modification de contenu."
            ] }),
            withSpotlight: true,
            spotlightType: "round",
            spotlightMargin: 2,
            nextEvent: TOUR_EVENTS.OPEN_MORE_BUTTON
          },
          {
            dataTour: "viewer-delete-resource-button",
            disableBeacon: true,
            content: "Vous pouvez all\xE9ger la page en supprimant certains contenus. Ne vous inqui\xE9tez pas, vous conservez toujours acc\xE8s \xE0 la page d'origine.",
            withSpotlight: true,
            spotlightType: "rectangle",
            spotlightMargin: 8,
            clickInside: false,
            withNextButton: true,
            onCompleted: () => {
              document.dispatchEvent(new Event("viewer-close-more-button"));
              document.dispatchEvent(new Event("viewer-open-add-toolbar"));
            }
          },
          {
            dataTour: "viewer-add-card",
            disableBeacon: true,
            content: "Enrichissez la page avec du texte, des images, mais aussi des audios, des vid\xE9os ou des quiz.",
            withSpotlight: true,
            spotlightType: "rectangle",
            spotlightMargin: 8,
            clickInside: false,
            withNextButton: true,
            onCompleted: () => {
              document.dispatchEvent(new Event("viewer-close-add-toolbar"));
            }
          },
          {
            fixed: true,
            disableFlip: true,
            placement: "center",
            disableBeacon: true,
            content: /* @__PURE__ */ jsx19(AdaptationStepWithIllustration, {}),
            withMask: true,
            visibleMask: true,
            clickInside: false,
            disableArrow: true,
            withNextButton: true,
            onCompleted: ({ dispatch, currentPage }) => {
              dispatch == null ? void 0 : dispatch(setEntities({ pages: { [currentPage == null ? void 0 : currentPage.id]: { ...currentPage, isDraft: true } } }));
            }
          },
          {
            dataTour: "superkit-save-button",
            disableBeacon: true,
            content: "Une fois toutes vos modifications effectu\xE9es, n'oubliez pas d'enregistrer !",
            withSpotlight: true,
            spotlightType: "rectangle",
            spotlightMargin: 8,
            clickInside: false,
            withNextButton: true,
            onCompleted: ({ dispatch, currentPage }) => {
              dispatch == null ? void 0 : dispatch(setEntities({ pages: { [currentPage == null ? void 0 : currentPage.id]: { ...currentPage, isDraft: false } } }));
            }
          },
          {
            dataTour: "superkit-summary-page",
            content: /* @__PURE__ */ jsx19(ModifiedPageStepWithIllustration, {}),
            placement: "right",
            disableBeacon: true,
            withSpotlight: true,
            spotlightMargin: 8,
            spotlightType: "rectangle",
            clickInside: false,
            params: "currentPage.id",
            needsDrawer: true
          }
        ]
      },
      {
        id: REVISION_TOUR,
        profile: INTERMEDIATE_PROFILE,
        title: "Faites r\xE9viser vos \xE9l\xE8ves",
        steps: [
          {
            dataTour: "core-revision-button",
            disableBeacon: true,
            content: /* @__PURE__ */ jsx19(RevisionStepWithIllustration, {}),
            withSpotlight: true,
            spotlightType: "rectangle",
            spotlightMargin: 8,
            clickInside: false
          }
        ]
      }
    ];
    SCENARIOS = {
      [TRIAL_SCENARIO]: {
        tours: [PROJECTION_TOUR, CREATE_PAGE_TOUR, SHOW_CORRECTION_TOUR, SESSION_TOUR]
      },
      [ONBOARDING_SCENARIO]: {
        tours: _25.compact([
          DISCOVERY_TOUR,
          PAGE_ADAPTATION_TOUR,
          CREATE_PAGE_TOUR,
          PROJECTION_TOUR,
          SHARE_TOUR,
          REVISION_TOUR
        ])
      }
    };
  }
});

// src/utils/tour.ts
import { hasWindowObject as hasWindowObject2, pipe as pipe2 } from "@lls/utils";
import _26 from "lodash/fp.js";
var shouldDisplayTours, getTours, getTour, formatTourElementSelector, filterTours, shouldUpdateUserTourData, formatUserWithNewTourData, extractCompletedToursFromUser, extractCompletedToursFromCookies, getCompletedTours, hasUserCompletedTour, hasUserCompletedAllTours, getNbDoneTours, getToursFromScenario;
var init_tour3 = __esm({
  "src/utils/tour.ts"() {
    "use strict";
    init_constants();
    init_tour2();
    init_trial2();
    init_route();
    shouldDisplayTours = ({
      user,
      pathname,
      isStudentViewActivated,
      journeyCookie,
      scenarioId,
      isModalOpen
    }) => {
      const isAccompanied = journeyCookie === JOURNEY_ACCOMPANIED;
      if (!(user == null ? void 0 : user.isTeacher) || !hasWindowObject2()) return false;
      if (!_26.overSome([matchPagePath, matchBookPath])(pathname)) {
        return isAccompanied;
      }
      if (user == null ? void 0 : user.isTrial) {
        return Boolean(!isStudentViewActivated && !_26.isUndefined(journeyCookie) || isAccompanied);
      }
      return !!scenarioId && !isModalOpen;
    };
    getTours = (tours, scenario) => pipe2(
      tours,
      _26.map((tour2) => ({
        ...tour2,
        steps: _26.flow(
          () => tour2.steps,
          _26.map((step) => ({
            ...step,
            title: step.title || tour2.title
          })),
          _26.filter(({ onlyForScenario }) => !onlyForScenario || onlyForScenario === scenario)
        )()
      })),
      _26.keyBy("id")
    );
    getTour = (tourId, scenario) => tourId ? getTours(TOURS, scenario)[tourId] : void 0;
    formatTourElementSelector = (target, id) => target ? `[data-tour="${target}${id ? `-${id}` : ""}"]` : null;
    filterTours = ({ excludeSessionTour = false, excludeRenewalTour = false }, tours) => _26.reject(
      (tour2) => [excludeSessionTour && SESSION_TOUR, excludeRenewalTour && ACTUALISATION_TOUR].includes(tour2.id),
      tours
    );
    shouldUpdateUserTourData = ({
      user,
      tourId,
      tourStep
    }) => {
      var _a2, _b2, _c2;
      if ((user == null ? void 0 : user.id) && tourId && _26.isNumber(tourStep)) {
        const currentTourStep = (_c2 = (_b2 = (_a2 = user == null ? void 0 : user.onboardingData) == null ? void 0 : _a2.tourData) == null ? void 0 : _b2[tourId]) == null ? void 0 : _c2.step;
        return _26.isNil(currentTourStep) || currentTourStep < tourStep;
      }
      return false;
    };
    formatUserWithNewTourData = ({
      tourId,
      tourStep,
      isLastStep
    }) => tourId ? {
      tourData: { [tourId]: { step: tourStep, isCompleted: isLastStep } }
    } : {};
    extractCompletedToursFromUser = _26.flow(
      _26.get("onboardingData.tourData"),
      _26.pickBy({ isCompleted: true }),
      _26.keys
    );
    extractCompletedToursFromCookies = (cookies) => _26.getOr([], COOKIE_DONE_TOURS, cookies);
    getCompletedTours = (user, cookies) => (user == null ? void 0 : user.isTrial) ? extractCompletedToursFromCookies(cookies) : extractCompletedToursFromUser(user);
    hasUserCompletedTour = (tourId, completedTours) => _26.includes(tourId, completedTours);
    hasUserCompletedAllTours = (tours, doneTours) => _26.flow(_26.difference(tours), _26.isEmpty)(doneTours);
    getNbDoneTours = (availableTours, completedTours) => _26.flow(_26.intersection(completedTours), _26.size)(availableTours);
    getToursFromScenario = (scenarios, scenarioId) => {
      var _a2;
      return scenarioId ? _26.map((tourId) => getTour(tourId, scenarioId), (_a2 = scenarios == null ? void 0 : scenarios[scenarioId]) == null ? void 0 : _a2.tours) : [];
    };
  }
});

// src/effects/onboarding.js
import { ANALYTICS_ONBOARDING_ABORTED, ANALYTICS_ONBOARDING_DELAYED, dispatchAnalyticsEvent as dispatchAnalyticsEvent2 } from "@lls/utils";
import _27 from "lodash/fp.js";
var updateUserOnboardingData, chooseOnboardingProfile, dismissModal, endOnboarding, registerLogin, sendAskForTrainingEmail2, chooseOnboardingProfileEffect, dismissModalEffect, registerLoginEffect, updateUserOnboardingDataEffect, endOnboardingEffect, sendAskForTrainingEmailEffect;
var init_onboarding2 = __esm({
  "src/effects/onboarding.js"() {
    "use strict";
    init_actions();
    init_marketing2();
    init_user();
    init_constants();
    init_onboarding();
    init_tour2();
    init_utils3();
    init_tour3();
    updateUserOnboardingData = async ({ dispatch, params: { token, onboardingData, userId } = {} }) => {
      const { entities: entities2 } = await updateUser({
        token,
        user: {
          id: userId,
          onboardingData: {
            ..._27.pick(
              [
                "tourData",
                "firstDismissalDate",
                "secondDismissalDate",
                "lastBookScreenView",
                "profile",
                "hasSeenLearningAssessment"
              ],
              onboardingData
            )
          }
        }
      });
      dispatch(setEntities(entities2));
    };
    chooseOnboardingProfile = async ({ dispatch, params: { user, token, profile, startTour = _27.noop, close } }) => {
      switch (profile) {
        case BEGINNER_PROFILE:
          await updateUserOnboardingData({
            dispatch,
            params: {
              token,
              userId: user == null ? void 0 : user.id,
              onboardingData: { profile: BEGINNER_PROFILE }
            }
          });
          dispatch(setScenarioId(ONBOARDING_SCENARIO));
          startTour(DISCOVERY_TOUR);
          close();
          break;
        case INTERMEDIATE_PROFILE:
          await updateUserOnboardingData({
            dispatch,
            params: {
              token,
              userId: user == null ? void 0 : user.id,
              onboardingData: {
                profile: INTERMEDIATE_PROFILE,
                ...formatUserWithNewTourData({ tourId: DISCOVERY_TOUR, tourStep: 6, isLastStep: true })
              }
            }
          });
          dispatch(setScenarioId(ONBOARDING_SCENARIO));
          dispatch(setModal({ name: MODAL_ONBOARDING_CHOOSE_TOUR, open: true }));
          break;
        case EXPERT_PROFILE:
          await updateUserOnboardingData({
            dispatch,
            params: {
              token,
              userId: user == null ? void 0 : user.id,
              onboardingData: { profile: EXPERT_PROFILE }
            }
          });
          dispatch(setModal({ name: MODAL_ONBOARDING_EXPERT, open: true }));
      }
    };
    dismissModal = async ({ dispatch, params: { user, token } }) => {
      var _a2, _b2, _c2;
      dispatch(setScenarioId(null));
      const hasFirstDismissal = !!((_a2 = user == null ? void 0 : user.onboardingData) == null ? void 0 : _a2.firstDismissalDate);
      !((_b2 = user == null ? void 0 : user.onboardingData) == null ? void 0 : _b2.secondDismissalDate) && dispatchAnalyticsEvent2(hasFirstDismissal ? ANALYTICS_ONBOARDING_ABORTED : ANALYTICS_ONBOARDING_DELAYED, {
        extraData: `profile:${(_c2 = user == null ? void 0 : user.onboardingData) == null ? void 0 : _c2.profile}`
      });
      const { entities: entities2 } = await updateUser({
        user: {
          id: user == null ? void 0 : user.id,
          onboardingData: { [hasFirstDismissal ? "secondDismissalDate" : "firstDismissalDate"]: Date.now() }
        },
        token
      });
      dispatch(setEntities(entities2));
    };
    endOnboarding = async ({ dispatch, params: { user, token } }) => {
      dispatch(setScenarioId(null));
      const { entities: entities2 } = await updateUser({
        user: { id: user == null ? void 0 : user.id, onboardingData: { onboardingEndDate: Date.now() } },
        token
      });
      dispatch(setEntities(entities2));
    };
    registerLogin = async ({ dispatch, params: { user, token } }) => {
      const { entities: entities2 } = await updateUser({
        user: { id: user == null ? void 0 : user.id, onboardingData: { lastBookScreenView: Date.now() } },
        token
      });
      dispatch(setEntities(entities2));
    };
    sendAskForTrainingEmail2 = async ({
      dispatch,
      params: { email, bookId, nbInterestedPersons, participationMode, token, calendarUrl }
    }) => {
      if (calendarUrl) {
        dispatch(setModal({ name: MODAL_ONBOARDING_TRAINING_BOOKING, open: true, data: { calendarUrl } }));
      } else {
        await sendAskForTrainingEmail({
          email,
          bookId,
          nbInterestedPersons,
          participationMode,
          token
        });
        dispatch(setModal({ name: MODAL_ONBOARDING_TRAINING_CONFIRMATION, open: true }));
      }
    };
    chooseOnboardingProfileEffect = ({ dispatch, params }) => tryCatch({ dispatch, effect: chooseOnboardingProfile, params });
    dismissModalEffect = ({ dispatch, params }) => tryCatch({ dispatch, effect: dismissModal, params });
    registerLoginEffect = ({ dispatch, params }) => tryCatch({ dispatch, effect: registerLogin, params });
    updateUserOnboardingDataEffect = ({ dispatch, params }) => tryCatch({ dispatch, params, effect: updateUserOnboardingData, silent: true });
    endOnboardingEffect = ({ dispatch, params }) => tryCatch({ dispatch, params, effect: endOnboarding, silent: true });
    sendAskForTrainingEmailEffect = ({ dispatch, params }) => tryCatch({ dispatch, params, effect: sendAskForTrainingEmail2 });
  }
});

// src/constants/analytics.js
var ANALYTICS_EVENTS;
var init_analytics4 = __esm({
  "src/constants/analytics.js"() {
    "use strict";
    ANALYTICS_EVENTS = {
      ACCOUNT_CREATED: "account_created",
      ACCOUNT_ACTIVATED: "account_activated",
      USER_LOGGED_IN: "user_logged_in",
      USER_LOGGED_OUT: "user_logged_out",
      BOOK_DOWNLOAD_STARTED: "book_download_started",
      BOOK_DOWNLOAD_FAILED: "book_download_failed",
      BOOK_DOWNLOAD_SUCCEED: "book_download_succeed",
      BOOK_UPDATED: "book_updated",
      PAGE_VIEWED: "page_viewed",
      SCREEN_VIEWED: "screen_viewed",
      APP_OPENED: "app_opened",
      APP_ACTIVATED: "app_activated",
      APP_INSTALLED: "app_installed",
      APP_UPDATED: "app_updated",
      APP_REINITIALISED: "app_reinitialised",
      APP_BACKGROUNDED: "app_backgrounded",
      APP_CRASHED: "app_crashed",
      APP_UNINSTALLED: "app_uninstalled",
      GROUP_DUPLICATED: "group_duplicated",
      GROUP_CREATED: "group_created",
      GROUP_DELETED: "group_deleted",
      APPRECIATION_ADDED: "appreciation_added",
      APPRECIATION_EDITED: "appreciation_edited",
      CORRECTION_STARTED: "correction_started",
      CORRECTION_SEND: "correction_send",
      SHARED_CORRECTIONS_CREATED: "shared_corrections_created",
      CUSTOM_PAGE_CREATED: "custom_page_created",
      CUSTOM_PAGE_SAVED: "custom_page_saved",
      PAGE_SHARE_STARTED: "page_share_started",
      PAGE_SHARED: "page_shared",
      PAGE_EXPORT_STARTED: "page_export_started",
      PAGE_EXPORTED: "page_exported",
      REPORT_STARTED: "report_started",
      REPORT_SENT: "report_sent",
      FILTER_USED: "filter_used",
      CONTENT_VIEW_CHANGED: "content_view_changed",
      TOOLBOX_USED: "toolbox_used",
      EXERCICES_STARTED: "exercises_started",
      STUDENT_ANSWER_VIEWED: "student_answer_viewed",
      STUDENT_ANSWER_CREATED: "student_answer_created",
      STUDENT_ANSWER_SAVED: "student_answer_saved",
      LINK_CLICKED: "link_clicked",
      DOCUMENT_INSERTED: "document_inserted",
      DOCUMENT_CHOICE_STARTED: "document_choice_started",
      PAGE_CHOICE_STARTED: "page_choice_started",
      TASK_INSERTED: "task_inserted",
      TOUR_EXPLORED: "tour_explored",
      TOUR_FINISHED: "tour_finished",
      TRIAL_FINISHED: "trial_finished",
      FAKE_PROFILE_CHANGED: "fake_profile_changed",
      TRIAL_STARTED: "trial_started"
    };
  }
});

// src/api/summary.js
var summaryElementFragment, summaryFragment;
var init_summary = __esm({
  "src/api/summary.js"() {
    "use strict";
    summaryElementFragment = `
  id
  type
  title
  element {
    ... on Chapter {
      numShow
      isVisible
      valid
      teaser
    }

    ... on Page {
      id
      slug
      numericOrder
      page
      nbPages
      valid
      premium
      thematicName
      isWorkplan
      isPartOfSession
      renewedAt
      teaser
      printUrls{
        blurred
        url
      }
    }
  }
`;
    summaryFragment = `
  summary {
    elements (isVisible: true) {
      ${summaryElementFragment}
      elements (isVisible: true) {
        ${summaryElementFragment}
        elements (isVisible: true) {
          ${summaryElementFragment}
        }
      }
    }
  }
`;
  }
});

// src/api/tour.js
import { normalizeData as normalizeData4 } from "@lls/store";
var fetchDataToLaunchTour;
var init_tour4 = __esm({
  "src/api/tour.js"() {
    "use strict";
    init_constants();
    init_graphql();
    init_summary();
    fetchDataToLaunchTour = ({ slugs, token }) => gql({
      query: `query coreFetchDataToLaunchTour ($slugs: [String], $publishers: [Publishers], $hasNewDesign: Boolean!, $token: String) {
    viewer (token: $token) {
      books (slugs: $slugs, publishers: $publishers, hasNewDesign: $hasNewDesign, ) {
        hits {
          id
          valid
          isRenewed
          slug
          uri
          hasNewDesign
          chapters {
            id
            pages {
              id
              isWorkplan
              isPartOfSession
              isOriginal
              slug
              isExercise
              hasRightResponses
              chapter {
                id
              }
              book {
                id
              }
            }
          }
          ${summaryFragment}
        }
      }
    }
  }`,
      variables: {
        slugs,
        hasNewDesign: true,
        publishers: GQL_PUBLISHERS,
        token
      }
    }).then(normalizeData4);
  }
});

// src/effects/tour.js
var fetchDataToLaunchTour2, fetchDataToLaunchTourEffect;
var init_tour5 = __esm({
  "src/effects/tour.js"() {
    "use strict";
    init_actions();
    init_tour4();
    init_utils3();
    fetchDataToLaunchTour2 = async ({ dispatch, params = {} }) => {
      const { token, bookSlug, onComplete } = params;
      const result = await fetchDataToLaunchTour({ slugs: [bookSlug], token });
      dispatch(setEntities(result == null ? void 0 : result.entities));
      onComplete();
    };
    fetchDataToLaunchTourEffect = ({ dispatch, history, params }) => tryCatch({
      dispatch,
      history,
      params,
      effect: fetchDataToLaunchTour2,
      silent: false
    });
  }
});

// src/effects/user.ts
import _28 from "lodash/fp.js";
import { displayUser, openWindow as openWindow3 } from "@lls/utils";
var logout, updateUser2, updateLastActivitySeenAt2, suggestionEmail, updateTrialUserStats, updatePreferences, subscribeContact, updatePassword2, suggestionEmailEffect, updateLastActivitySeenAtEffect, logoutEffect, updateTrialUserStatsEffect, updatePreferencesEffect, subscribeContactEffect, updatePasswordEffect;
var init_user2 = __esm({
  "src/effects/user.ts"() {
    "use strict";
    init_actions();
    init_user();
    init_config();
    init_constants();
    init_cookie();
    init_route();
    init_tour3();
    init_utils3();
    logout = ({ dispatch, removeCookie, params: { user = {} } = {} }) => {
      removeCookie(COOKIE_JWT_TOKEN, getCookieOptions());
      if (!(user == null ? void 0 : user.isTrial)) {
        dispatch == null ? void 0 : dispatch(resetAuth());
      }
      triggerNotification({ name: "logout_success", dispatch });
      openWindow3(
        (user == null ? void 0 : user.isTrial) ? config_default.front_url : (user == null ? void 0 : user.isGarUser) ? getPath("external_ent_logout") : getPath("lls_connect"),
        "_self"
      );
    };
    updateUser2 = async ({ dispatch, params = {}, silent }) => {
      const { user, token, afterUpdate = _28.noop } = params;
      const entities2 = _28.get("entities", await updateUser({ user, token }));
      dispatch == null ? void 0 : dispatch(setEntities(entities2));
      !silent && triggerNotification({
        name: "success",
        message: "Modification enregistr\xE9e !",
        dispatch
      });
      afterUpdate(user);
    };
    updateLastActivitySeenAt2 = async ({ dispatch, params }) => {
      const entities2 = _28.get("entities", await updateLastActivitySeenAt({ token: _28.get("token", params) }));
      dispatch == null ? void 0 : dispatch(setEntities(entities2));
    };
    suggestionEmail = async ({
      dispatch,
      params: { user, ...params } = {}
    }) => {
      await sendSuggestionEmail({ ...params });
      triggerNotification({
        name: "success",
        params: { title: "Message envoy\xE9 !", autoHide: 8e3, clarityHidden: true },
        message: `Merci ${displayUser(
          user
        )}, votre suggestion a \xE9t\xE9 transmise \xE0 nos \xE9quipes et nous vous tiendrons inform\xE9(e) rapidement de son traitement.`,
        dispatch
      });
    };
    updateTrialUserStats = async ({ params: { tourId, isLastStep } = {}, cookies, setCookie }) => {
      if (isLastStep) {
        const doneTours = extractCompletedToursFromCookies(cookies);
        const newDoneTours = _28.flow(_28.concat(tourId), _28.uniq, _28.sortBy(_28.identity))(doneTours);
        setCookie == null ? void 0 : setCookie(COOKIE_DONE_TOURS, newDoneTours);
      }
    };
    updatePreferences = async ({ dispatch, params: { form = {}, token = "" } = {} }) => {
      const data = {
        id: form.id,
        schools: [form.school],
        subjects: form.subjects,
        schoolTypes: form.schoolTypes,
        email: form.email,
        firstname: form.firstname,
        lastname: form.lastname,
        functions: form.functions,
        levels: form.levels
      };
      const entities2 = await updateUser({ user: data, token }).then(_28.get("entities"));
      dispatch == null ? void 0 : dispatch(setEntities(entities2));
      triggerNotification({ name: "preferences_updated", dispatch });
    };
    subscribeContact = async ({
      dispatch,
      params: { token = "", user = {}, subscribeValue } = {}
    }) => {
      await updateUser2({
        dispatch,
        params: { token, user: { id: user.id, hasContentNewsletter: subscribeValue } },
        silent: true
      });
      triggerNotification({ name: "preferences_updated", dispatch });
    };
    updatePassword2 = async ({ dispatch, params: { oldPassword, password, token } = {} }) => {
      try {
        await updatePassword({ token, oldPassword, password });
        triggerNotification({
          name: "password_updated",
          dispatch
        });
      } catch (e) {
        if (e && e.statusCode === 401) {
          triggerNotification({
            name: "wrong_password",
            dispatch
          });
        }
      }
    };
    suggestionEmailEffect = ({ dispatch, params }) => tryCatch({
      dispatch,
      params,
      effect: suggestionEmail,
      errorName: "suggestion_email_error"
    });
    updateLastActivitySeenAtEffect = ({ dispatch, params }) => tryCatch({ dispatch, silent: true, effect: updateLastActivitySeenAt2, params });
    logoutEffect = ({ dispatch, removeCookie, params }) => tryCatch({ dispatch, removeCookie, params, effect: logout, silent: true });
    updateTrialUserStatsEffect = ({ params, cookies, setCookie }) => tryCatch({ params, effect: updateTrialUserStats, cookies, setCookie, silent: true });
    updatePreferencesEffect = ({ dispatch, params }) => tryCatch({ dispatch, params, effect: updatePreferences });
    subscribeContactEffect = ({ dispatch, params }) => tryCatch({ dispatch, params, effect: subscribeContact });
    updatePasswordEffect = ({ dispatch, params }) => tryCatch({ dispatch, effect: updatePassword2, params });
  }
});

// src/selectors/ui.ts
import _29 from "lodash/fp.js";
var getUiAreShownContextualActions, getUiIsShownSidePanel, getUiIsDrawerOpen, getDrawerExpandedId, getUiIsOpenSaveModal, getUiIsViewerReady, getUiIsStudentViewActivated;
var init_ui2 = __esm({
  "src/selectors/ui.ts"() {
    "use strict";
    getUiAreShownContextualActions = _29.get("ui.areShownContextualActions");
    getUiIsShownSidePanel = _29.get("ui.isShownSidePanel");
    getUiIsDrawerOpen = _29.get("ui.isDrawerOpen");
    getDrawerExpandedId = _29.get("ui.drawerExpandedId");
    getUiIsOpenSaveModal = _29.get("ui.isOpenSaveModal");
    getUiIsViewerReady = (state, viewerName) => _29.getOr(false, `ui.isViewerReady.${viewerName}`, state);
    getUiIsStudentViewActivated = _29.get("ui.isStudentViewActivated");
  }
});

// src/hooks/useViewerReady.js
import { useCallback as useCallback8, useEffect as useEffect6, useRef as useRef4 } from "react";
import { useDispatch as useDispatch4, useSelector as useSelector9 } from "react-redux";
var useViewerReady, useViewerReady_default;
var init_useViewerReady = __esm({
  "src/hooks/useViewerReady.js"() {
    "use strict";
    init_actions();
    init_constants();
    init_ui2();
    useViewerReady = ({ consumer = VIEWER_DEFAULT, notifyOnUnmount = false } = {}) => {
      const dispatch = useDispatch4();
      const viewerReady = useSelector9((state) => getUiIsViewerReady(state, consumer));
      const viewerReadyRef = useRef4(false);
      const setViewerReady = useCallback8(
        (value) => {
          dispatch(setIsViewerReady({ viewerName: consumer, value }));
        },
        [dispatch, consumer]
      );
      useEffect6(() => {
        if (notifyOnUnmount) {
          return () => setViewerReady(false);
        }
      }, [notifyOnUnmount, setViewerReady]);
      const viewerRef = useCallback8(
        (node) => {
          if (viewerReadyRef.current) {
            return;
          }
          if (node) {
            viewerReadyRef.current = true;
            setViewerReady(true);
          }
        },
        [setViewerReady]
      );
      return { viewerRef, viewerReady };
    };
    useViewerReady_default = useViewerReady;
  }
});

// src/hooks/useDrawer.js
import { useCallback as useCallback9, useEffect as useEffect7, useMemo as useMemo3, useRef as useRef5, useState as useState6 } from "react";
import { useDispatch as useDispatch5, useSelector as useSelector10 } from "react-redux";
import { useLocation as useLocation6 } from "react-router-dom";
var NOOP_VALUE, useDrawer, useDrawer_default;
var init_useDrawer = __esm({
  "src/hooks/useDrawer.js"() {
    "use strict";
    init_actions();
    init_constants();
    init_useViewerReady();
    init_ui2();
    init_route();
    NOOP_VALUE = -1;
    useDrawer = (page) => {
      var _a2;
      const { viewerReady } = useViewerReady_default();
      const isDrawerOpen = useSelector10(getUiIsDrawerOpen);
      const expandedId = useSelector10(getDrawerExpandedId);
      const [delayedOpen, setDelayedOpen] = useState6(NOOP_VALUE);
      const [delayedExpanded, setDelayedExpanded] = useState6(NOOP_VALUE);
      const readyRef = useRef5();
      const isPageInvalid = page && !page.valid;
      readyRef.current = routeHasViewer((_a2 = useLocation6()) == null ? void 0 : _a2.pathname) ? viewerReady : true;
      const dispatch = useDispatch5();
      const setIsDrawerOpenCb = useCallback9(
        (value) => {
          readyRef.current ? dispatch(setIsDrawerOpen(value)) : setDelayedOpen(value);
        },
        [dispatch]
      );
      const setDrawerExpandedIdCb = useCallback9(
        (value) => {
          readyRef.current ? dispatch(setDrawerExpandedId(value)) : setDelayedExpanded(value);
        },
        [dispatch]
      );
      useEffect7(() => {
        if (viewerReady && delayedOpen !== NOOP_VALUE) {
          dispatch(setIsDrawerOpen(delayedOpen));
        }
      }, [dispatch, delayedOpen, viewerReady]);
      useEffect7(() => {
        if ((viewerReady || isPageInvalid) && expandedId === UNINITIALIZED_EXPANDED_ID && delayedExpanded !== NOOP_VALUE) {
          dispatch(setDrawerExpandedId(delayedExpanded));
        }
      }, [dispatch, delayedExpanded, expandedId, viewerReady, isPageInvalid]);
      const onDrawerButtonClick = useCallback9((_event, defaultCb) => defaultCb(), []);
      return useMemo3(
        () => ({
          isDrawerOpen,
          setIsDrawerOpen: setIsDrawerOpenCb,
          onDrawerButtonClick,
          setExpandedId: setDrawerExpandedIdCb,
          expandedId
        }),
        [isDrawerOpen, setIsDrawerOpenCb, onDrawerButtonClick, expandedId, setDrawerExpandedIdCb]
      );
    };
    useDrawer_default = useDrawer;
  }
});

// src/utils/book.js
import _30 from "lodash/fp.js";
var getLastVisitedBooks;
var init_book2 = __esm({
  "src/utils/book.js"() {
    "use strict";
    getLastVisitedBooks = ({ lastVisitedBookIds, books, nbSelectedBooks = 3 }) => {
      const getBookById = _30.flow(_30.keyBy("id"), (bag) => (id) => _30.get(id, bag))(books);
      return _30.flow(_30.map(getBookById), _30.compact, _30.slice(0, nbSelectedBooks))(lastVisitedBookIds);
    };
  }
});

// ../../node_modules/.pnpm/reselect@4.1.8/node_modules/reselect/es/defaultMemoize.js
function createSingletonCache(equals) {
  var entry;
  return {
    get: function get2(key) {
      if (entry && equals(entry.key, key)) {
        return entry.value;
      }
      return NOT_FOUND;
    },
    put: function put(key, value) {
      entry = {
        key,
        value
      };
    },
    getEntries: function getEntries() {
      return entry ? [entry] : [];
    },
    clear: function clear() {
      entry = void 0;
    }
  };
}
function createLruCache(maxSize, equals) {
  var entries = [];
  function get2(key) {
    var cacheIndex = entries.findIndex(function(entry2) {
      return equals(key, entry2.key);
    });
    if (cacheIndex > -1) {
      var entry = entries[cacheIndex];
      if (cacheIndex > 0) {
        entries.splice(cacheIndex, 1);
        entries.unshift(entry);
      }
      return entry.value;
    }
    return NOT_FOUND;
  }
  function put(key, value) {
    if (get2(key) === NOT_FOUND) {
      entries.unshift({
        key,
        value
      });
      if (entries.length > maxSize) {
        entries.pop();
      }
    }
  }
  function getEntries() {
    return entries;
  }
  function clear() {
    entries = [];
  }
  return {
    get: get2,
    put,
    getEntries,
    clear
  };
}
function createCacheKeyComparator(equalityCheck) {
  return function areArgumentsShallowlyEqual(prev, next) {
    if (prev === null || next === null || prev.length !== next.length) {
      return false;
    }
    var length = prev.length;
    for (var i = 0; i < length; i++) {
      if (!equalityCheck(prev[i], next[i])) {
        return false;
      }
    }
    return true;
  };
}
function defaultMemoize(func, equalityCheckOrOptions) {
  var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
    equalityCheck: equalityCheckOrOptions
  };
  var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? defaultEqualityCheck : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
  var comparator = createCacheKeyComparator(equalityCheck);
  var cache = maxSize === 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator);
  function memoized() {
    var value = cache.get(arguments);
    if (value === NOT_FOUND) {
      value = func.apply(null, arguments);
      if (resultEqualityCheck) {
        var entries = cache.getEntries();
        var matchingEntry = entries.find(function(entry) {
          return resultEqualityCheck(entry.value, value);
        });
        if (matchingEntry) {
          value = matchingEntry.value;
        }
      }
      cache.put(arguments, value);
    }
    return value;
  }
  memoized.clearCache = function() {
    return cache.clear();
  };
  return memoized;
}
var NOT_FOUND, defaultEqualityCheck;
var init_defaultMemoize = __esm({
  "../../node_modules/.pnpm/reselect@4.1.8/node_modules/reselect/es/defaultMemoize.js"() {
    "use strict";
    NOT_FOUND = "NOT_FOUND";
    defaultEqualityCheck = function defaultEqualityCheck2(a, b) {
      return a === b;
    };
  }
});

// ../../node_modules/.pnpm/reselect@4.1.8/node_modules/reselect/es/index.js
function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
  if (!dependencies.every(function(dep) {
    return typeof dep === "function";
  })) {
    var dependencyTypes = dependencies.map(function(dep) {
      return typeof dep === "function" ? "function " + (dep.name || "unnamed") + "()" : typeof dep;
    }).join(", ");
    throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
  }
  return dependencies;
}
function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptionsFromArgs[_key - 1] = arguments[_key];
  }
  var createSelector2 = function createSelector3() {
    for (var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }
    var _recomputations = 0;
    var _lastResult;
    var directlyPassedOptions = {
      memoizeOptions: void 0
    };
    var resultFunc = funcs.pop();
    if (typeof resultFunc === "object") {
      directlyPassedOptions = resultFunc;
      resultFunc = funcs.pop();
    }
    if (typeof resultFunc !== "function") {
      throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
    }
    var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2;
    var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [memoizeOptions];
    var dependencies = getDependencies(funcs);
    var memoizedResultFunc = memoize.apply(void 0, [function recomputationWrapper() {
      _recomputations++;
      return resultFunc.apply(null, arguments);
    }].concat(finalMemoizeOptions));
    var selector = memoize(function dependenciesChecker() {
      var params = [];
      var length = dependencies.length;
      for (var i = 0; i < length; i++) {
        params.push(dependencies[i].apply(null, arguments));
      }
      _lastResult = memoizedResultFunc.apply(null, params);
      return _lastResult;
    });
    Object.assign(selector, {
      resultFunc,
      memoizedResultFunc,
      dependencies,
      lastResult: function lastResult() {
        return _lastResult;
      },
      recomputations: function recomputations() {
        return _recomputations;
      },
      resetRecomputations: function resetRecomputations() {
        return _recomputations = 0;
      }
    });
    return selector;
  };
  return createSelector2;
}
var createSelector;
var init_es = __esm({
  "../../node_modules/.pnpm/reselect@4.1.8/node_modules/reselect/es/index.js"() {
    "use strict";
    init_defaultMemoize();
    createSelector = /* @__PURE__ */ createSelectorCreator(defaultMemoize);
  }
});

// src/selectors/book.ts
import { filterBooks, getCurrentUser as getCurrentUser6, makeSearchBooks } from "@lls/store";
import _31 from "lodash/fp.js";
var hasTourBookSearchBooks, getHasTourBook, bestMatchingSearchBooks, getBestMatchingBooksForUser;
var init_book3 = __esm({
  "src/selectors/book.ts"() {
    "use strict";
    init_book2();
    init_es();
    hasTourBookSearchBooks = makeSearchBooks();
    getHasTourBook = createSelector(
      (state) => {
        const currentUser = getCurrentUser6(state);
        const licenseBookIds = _31.get("booksV2", currentUser);
        return hasTourBookSearchBooks(state, {
          ids: licenseBookIds,
          isWorkbook: false,
          isWorkplan: false
        });
      },
      (licenseBooks) => !_31.isEmpty(licenseBooks)
    );
    bestMatchingSearchBooks = makeSearchBooks();
    getBestMatchingBooksForUser = createSelector(
      [
        getCurrentUser6,
        (state) => {
          const currentUser = getCurrentUser6(state);
          const licenseBookIds = currentUser == null ? void 0 : currentUser.booksV2;
          return bestMatchingSearchBooks(state, {
            ids: licenseBookIds,
            isWorkbook: false
          });
        }
      ],
      (currentUser, licenseBooks) => {
        const lastVisitedBooks = getLastVisitedBooks({
          lastVisitedBookIds: _31.get("lastBooksViewed", currentUser),
          books: licenseBooks
        });
        const { levels, subjects, isTeacher, isTrial } = currentUser || {};
        if (lastVisitedBooks.length >= 3 && !isTrial) return _31.take(3, lastVisitedBooks);
        const randomBooks = _31.flow(
          () => licenseBooks,
          (books) => isTrial ? books : _31.reject((book) => _31.includes(book.id, _31.map("id", lastVisitedBooks)), books),
          isTeacher ? _31.flow(
            // make sure we always get books, but match by level first
            (books) => _31.concat(
              filterBooks({ subjectIds: subjects, levelIds: levels })(books),
              filterBooks({ subjectIds: subjects })(books)
            ),
            _31.uniqBy("id")
          ) : (books) => filterBooks({ levelIds: levels })(books)
        )();
        return isTrial ? _31.take(3, randomBooks) : _31.take(3, [...lastVisitedBooks, ...randomBooks]);
      }
    );
  }
});

// src/selectors/tour.ts
var getCurrentTourId, getCurrentTourStep, getIsTourPanelOpen, getTourPanelMode, getCurrentScenarioId;
var init_tour6 = __esm({
  "src/selectors/tour.ts"() {
    "use strict";
    getCurrentTourId = (state) => {
      var _a2;
      return (_a2 = state == null ? void 0 : state.tour) == null ? void 0 : _a2.tourId;
    };
    getCurrentTourStep = (state) => {
      var _a2;
      return (_a2 = state == null ? void 0 : state.tour) == null ? void 0 : _a2.tourStep;
    };
    getIsTourPanelOpen = (state) => {
      var _a2;
      return (_a2 = state == null ? void 0 : state.tour) == null ? void 0 : _a2.isTourPanelOpen;
    };
    getTourPanelMode = (state) => {
      var _a2;
      return (_a2 = state == null ? void 0 : state.tour) == null ? void 0 : _a2.tourPanelMode;
    };
    getCurrentScenarioId = (state) => {
      var _a2;
      return (_a2 = state == null ? void 0 : state.tour) == null ? void 0 : _a2.scenarioId;
    };
  }
});

// src/store/index.ts
import { hasWindowObject as hasWindowObject3 } from "@lls/utils";
import { useSelector as useSelector11 } from "react-redux";
import { applyMiddleware, combineReducers, legacy_createStore } from "redux";
var HMR_GLOBAL, useMySelector;
var init_store = __esm({
  "src/store/index.ts"() {
    "use strict";
    init_rootReducer();
    HMR_GLOBAL = {};
    if (import.meta.hot && /dev/.test("production")) {
      import.meta.hot.accept(() => {
        const { store } = import.meta.hot.data;
        Object.assign(HMR_GLOBAL, { store });
        const nextReducer = combineReducers(rootReducer_exports);
        store.replaceReducer(nextReducer);
      });
      import.meta.hot.dispose(() => {
        Object.assign(import.meta.hot.data, HMR_GLOBAL);
      });
    }
    useMySelector = (fn) => useSelector11(fn);
  }
});

// src/hooks/useTour.tsx
import { useConfetti } from "@lls/lls-kit";
import _32 from "lodash/fp.js";
import { useCallback as useCallback10, useEffect as useEffect8, useMemo as useMemo4, useState as useState7 } from "react";
import { useDispatch as useDispatch6 } from "react-redux";
import { matchPath as matchPath4, useHistory as useHistory4, useLocation as useLocation7 } from "react-router-dom";
import { getToken as getToken2, useSearchBooks as useSearchBooks2 } from "@lls/store";
import { getPage, useSearchPages as useSearchPages2 } from "@lls/store";
import { makeGetBook } from "@lls/store";
import { getCurrentUser as getCurrentUser7 } from "@lls/store";
import { getPagesFromSummary } from "@lls/superkit";
import {
  ANALYTICS_TOUR_EXPLORED,
  ANALYTICS_TOUR_FINISHED,
  ANALYTICS_TRIAL_FINISHED,
  dispatchAnalyticsEvent as dispatchAnalyticsEvent3
} from "@lls/utils";
var useTour, useTour_default;
var init_useTour = __esm({
  "src/hooks/useTour.tsx"() {
    "use strict";
    init_es62();
    init_actions();
    init_analytics4();
    init_constants();
    init_tour2();
    init_trial2();
    init_onboarding2();
    init_tour5();
    init_user2();
    init_useCustomEffect();
    init_useDrawer();
    init_book3();
    init_tour6();
    init_store();
    init_tour3();
    useTour = () => {
      var _a2, _b2, _c2, _d, _e, _f, _g;
      const dispatch = useDispatch6();
      const updateTrialUserStats2 = useCustomEffect_default(updateTrialUserStatsEffect);
      const updateUserOnboardingData2 = useCustomEffect_default(updateUserOnboardingDataEffect);
      const fetchDataToLaunchTourEffectFn = useCustomEffect_default(fetchDataToLaunchTourEffect);
      const history = useHistory4();
      const { pathname } = useLocation7();
      const { setExpandedId, setIsDrawerOpen: setIsDrawerOpen2 } = useDrawer_default();
      const currentUser = useMySelector(getCurrentUser7);
      const [cookies] = useCookies([COOKIE_DONE_TOURS]);
      const [tourIdReadyToLaunch, setTourIdReadyToLaunch] = useState7(null);
      const initScenarioId = useMySelector(getCurrentScenarioId);
      const scenarioId = (currentUser == null ? void 0 : currentUser.isTrial) ? TRIAL_SCENARIO : initScenarioId;
      const isOnboarding = scenarioId === ONBOARDING_SCENARIO;
      const tourId = useMySelector(getCurrentTourId);
      const tourStep = useMySelector(getCurrentTourStep);
      const tour2 = useMemo4(() => getTour(tourId, scenarioId), [tourId, scenarioId]);
      const currentStep = (_a2 = tour2 == null ? void 0 : tour2.steps) == null ? void 0 : _a2[tourStep];
      const slug = pathname.slice(1);
      const bookUri = (_c2 = (_b2 = matchPath4(pathname, { path: "/manuels/:bookUri" })) == null ? void 0 : _b2.params) == null ? void 0 : _c2.bookUri;
      const getBook8 = useMemo4(makeGetBook, []);
      const token = useMySelector(getToken2);
      const currentPage = (_d = useSearchPages2({ slugs: [slug] })) == null ? void 0 : _d[0];
      const currentBookFromUri = (_e = useSearchBooks2({ uris: [bookUri], hasNewDesign: true })) == null ? void 0 : _e[0];
      const currentBookFromPage = useMySelector((state) => getBook8(state, currentPage == null ? void 0 : currentPage.book));
      const bestMatchingBookForUser = (_f = useMySelector(getBestMatchingBooksForUser)) == null ? void 0 : _f[0];
      const currentBook = (bookUri ? currentBookFromUri : currentBookFromPage) || bestMatchingBookForUser;
      const currentPagesFromSummary = _32.filter({ valid: true }, getPagesFromSummary(currentBook == null ? void 0 : currentBook.summary));
      const currentPages = useSearchPages2({ ids: _32.map("id", currentPagesFromSummary) });
      const firstSessionPageId = (_g = currentPagesFromSummary == null ? void 0 : currentPagesFromSummary.find((page) => page.isPartOfSession)) == null ? void 0 : _g.id;
      const firstSessionPage = useMySelector((state) => getPage(state, firstSessionPageId));
      const firstPage = currentPagesFromSummary == null ? void 0 : currentPagesFromSummary[0];
      const firstPageWithRightResponses = _32.find({ hasRightResponses: true, isPartOfSession: false }, currentPages);
      const firstExercisePage = _32.find({ isExercise: true }, currentPages);
      const availableTours = useMemo4(
        () => filterTours(
          {
            excludeSessionTour: !firstSessionPage,
            excludeRenewalTour: !(currentBook == null ? void 0 : currentBook.isRenewed)
          },
          _32.compact(getToursFromScenario(SCENARIOS, scenarioId))
        ),
        [currentBook == null ? void 0 : currentBook.isRenewed, firstSessionPage, scenarioId]
      );
      const analyticParams = useMemo4(
        () => ({
          pageId: currentPage == null ? void 0 : currentPage.id,
          bookId: currentBook == null ? void 0 : currentBook.id,
          extraData: `profile:${tour2 == null ? void 0 : tour2.profile}`
        }),
        [currentBook == null ? void 0 : currentBook.id, currentPage == null ? void 0 : currentPage.id, tour2 == null ? void 0 : tour2.profile]
      );
      const setTourId = useCallback10(
        (tourId2) => {
          dispatch(setCurrentTourId(tourId2));
        },
        [dispatch]
      );
      const setTourStep = useCallback10(
        (step) => {
          dispatch(setCurrentTourStep(step));
        },
        [dispatch]
      );
      const setIsTourPanelOpenCb = useCallback10((value) => dispatch(setIsTourPanelOpen(value)), [dispatch]);
      const setTourPanelModeCb = useCallback10((value) => dispatch(setTourPanelMode(value)), [dispatch]);
      const openOfflineTipModal = useCallback10(() => {
        dispatch(setModal({ name: MODAL_TRIAL_TIP, open: true, data: { tip: OFFLINE_TRIAL_TIP } }));
      }, [dispatch]);
      const startTour = useCallback10(
        (tourId2) => {
          var _a3, _b3;
          dispatchAnalyticsEvent3(ANALYTICS_EVENTS.LINK_CLICKED, { featureName: tourId2 });
          document.dispatchEvent(new Event("viewer-close-projector-view"));
          (_b3 = (_a3 = getTour(tourId2)) == null ? void 0 : _a3.onTourStart) == null ? void 0 : _b3.call(_a3, {
            setExpandedId,
            setIsDrawerOpen: setIsDrawerOpen2,
            history,
            currentPage,
            firstSessionPage,
            openOfflineTipModal,
            currentBook,
            firstPageWithRightResponses,
            firstPage,
            firstExercisePage
          });
          setTourId(tourId2);
          setTourStep(0);
          setIsTourPanelOpenCb(false);
          setTourPanelModeCb("classic");
        },
        [
          setExpandedId,
          setIsDrawerOpen2,
          setTourId,
          setTourStep,
          history,
          currentPage,
          setIsTourPanelOpenCb,
          setTourPanelModeCb,
          firstSessionPage,
          currentBook,
          openOfflineTipModal,
          firstPageWithRightResponses,
          firstPage,
          firstExercisePage
        ]
      );
      const preStartTour = useCallback10(
        async (tourId2) => {
          if (!firstPage || !firstPageWithRightResponses) {
            await fetchDataToLaunchTourEffectFn({
              token,
              bookSlug: currentBook == null ? void 0 : currentBook.slug,
              onComplete: () => setTourIdReadyToLaunch(tourId2)
            });
            return;
          }
          startTour(tourId2);
        },
        [startTour, currentBook == null ? void 0 : currentBook.slug, fetchDataToLaunchTourEffectFn, firstPage, token, firstPageWithRightResponses]
      );
      useEffect8(() => {
        if (tourIdReadyToLaunch) {
          startTour(tourIdReadyToLaunch);
          setTourIdReadyToLaunch(null);
        }
      }, [tourIdReadyToLaunch, startTour]);
      const resetTourCb = useCallback10(() => {
        dispatch(resetTour());
      }, [dispatch]);
      const updateTourData = useCallback10(
        async (currentStep2, isLastStep) => {
          dispatchAnalyticsEvent3(ANALYTICS_TOUR_EXPLORED, {
            ...analyticParams,
            featureName: `${tourId}_step${currentStep2}`
          });
          isLastStep && dispatchAnalyticsEvent3(ANALYTICS_TOUR_FINISHED, { ...analyticParams, featureName: tourId });
          if (currentUser == null ? void 0 : currentUser.isTrial) {
            updateTrialUserStats2({
              tourId,
              isLastStep
            });
          } else if (shouldUpdateUserTourData({ user: currentUser, tourId, tourStep: currentStep2 })) {
            const stats = formatUserWithNewTourData({ tourId, tourStep: currentStep2, isLastStep });
            const promise = updateUserOnboardingData2({
              userId: currentUser == null ? void 0 : currentUser.id,
              onboardingData: stats,
              token
            });
            if (isLastStep) return promise;
          }
        },
        [updateTrialUserStats2, updateUserOnboardingData2, currentUser, tourId, token, analyticParams]
      );
      const { startConfetti } = useConfetti("stars");
      const onTrialUserCompletedAllTours = useCallback10(() => {
        startConfetti();
        dispatch(setTourPanelMode("completed"));
      }, [dispatch, startConfetti]);
      const completedTours = useMemo4(() => getCompletedTours(currentUser, cookies), [cookies, currentUser]);
      const endTour = useCallback10(
        (tourId2) => {
          if ((document == null ? void 0 : document.fullscreenElement) || (document == null ? void 0 : document.webkitCurrentFullScreenElement))
            document.dispatchEvent(new Event("viewer-close-projector-view"));
          resetTourCb();
          setIsTourPanelOpenCb(true);
          const availableTourIds = _32.map("id", availableTours);
          const hadPreviouslyCompletedAllTours = hasUserCompletedAllTours(availableTourIds, completedTours);
          const hasCompletedAllTours = hasUserCompletedAllTours(availableTourIds, _32.uniq(_32.concat(completedTours, tourId2)));
          const hasFinishedTrial = !hadPreviouslyCompletedAllTours && hasCompletedAllTours;
          if ((currentUser == null ? void 0 : currentUser.isTrial) && hasFinishedTrial) {
            dispatchAnalyticsEvent3(ANALYTICS_TRIAL_FINISHED, analyticParams);
            onTrialUserCompletedAllTours();
          } else if (isOnboarding) {
            dispatch(
              setModal({
                name: hasCompletedAllTours ? MODAL_TOURS_COMPLETED : MODAL_ONBOARDING_CHOOSE_TOUR,
                open: true,
                data: { hasFinishedTour: true }
              })
            );
          }
        },
        [
          resetTourCb,
          setIsTourPanelOpenCb,
          availableTours,
          completedTours,
          currentUser,
          isOnboarding,
          analyticParams,
          onTrialUserCompletedAllTours,
          dispatch
        ]
      );
      const goToNextStep = useCallback10(async () => {
        var _a3, _b3, _c3;
        const nextStep = tourStep + 1;
        const isLastStep = nextStep === ((_a3 = tour2 == null ? void 0 : tour2.steps) == null ? void 0 : _a3.length);
        await updateTourData(tourStep, isLastStep);
        (_b3 = currentStep == null ? void 0 : currentStep.onCompleted) == null ? void 0 : _b3.call(currentStep, {
          firstPage,
          history,
          currentPage,
          firstPageWithRightResponses,
          firstExercisePage,
          dispatch
        });
        if (nextStep === ((_c3 = tour2 == null ? void 0 : tour2.steps) == null ? void 0 : _c3.length)) {
          return endTour(tour2 == null ? void 0 : tour2.id);
        }
        setTourStep(nextStep);
      }, [
        setTourStep,
        tourStep,
        tour2,
        endTour,
        updateTourData,
        firstPage,
        history,
        currentStep,
        currentPage,
        firstPageWithRightResponses,
        firstExercisePage,
        dispatch
      ]);
      const sendEvent2 = useCallback10(
        (event) => {
          const toursToStart = _32.filter({ startEvent: event }, TOURS);
          for (const tour3 of toursToStart) {
            if (_32.isNil(tourId) && !hasUserCompletedTour(tour3 == null ? void 0 : tour3.id, completedTours)) {
              preStartTour(tour3 == null ? void 0 : tour3.id);
              return { tourStarted: tour3 == null ? void 0 : tour3.id };
            }
          }
          if ((currentStep == null ? void 0 : currentStep.nextEvent) === event) {
            goToNextStep();
          }
        },
        [goToNextStep, currentStep == null ? void 0 : currentStep.nextEvent, tourId, preStartTour, completedTours]
      );
      const tourParams = useMemo4(
        () => ({
          firstSessionPage,
          firstExercisePage,
          currentPage
        }),
        [firstSessionPage, firstExercisePage, currentPage]
      );
      return {
        tourId,
        setTourId,
        tourStep,
        setTourStep,
        startTour: preStartTour,
        sendEvent: sendEvent2,
        setIsTourPanelOpen: setIsTourPanelOpenCb,
        tourParams,
        goToNextStep,
        resetTour: resetTourCb,
        availableTours,
        scenarioId
      };
    };
    useTour_default = useTour;
  }
});

// ../../node_modules/.pnpm/bowser@2.11.0/node_modules/bowser/es5.js
var require_es5 = __commonJS({
  "../../node_modules/.pnpm/bowser@2.11.0/node_modules/bowser/es5.js"(exports, module) {
    "use strict";
    !function(e, t) {
      "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.bowser = t() : e.bowser = t();
    }(exports, function() {
      return function(e) {
        var t = {};
        function r(n) {
          if (t[n]) return t[n].exports;
          var i = t[n] = { i: n, l: false, exports: {} };
          return e[n].call(i.exports, i, i.exports, r), i.l = true, i.exports;
        }
        return r.m = e, r.c = t, r.d = function(e2, t2, n) {
          r.o(e2, t2) || Object.defineProperty(e2, t2, { enumerable: true, get: n });
        }, r.r = function(e2) {
          "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e2, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e2, "__esModule", { value: true });
        }, r.t = function(e2, t2) {
          if (1 & t2 && (e2 = r(e2)), 8 & t2) return e2;
          if (4 & t2 && "object" == typeof e2 && e2 && e2.__esModule) return e2;
          var n = /* @__PURE__ */ Object.create(null);
          if (r.r(n), Object.defineProperty(n, "default", { enumerable: true, value: e2 }), 2 & t2 && "string" != typeof e2) for (var i in e2) r.d(n, i, function(t3) {
            return e2[t3];
          }.bind(null, i));
          return n;
        }, r.n = function(e2) {
          var t2 = e2 && e2.__esModule ? function() {
            return e2.default;
          } : function() {
            return e2;
          };
          return r.d(t2, "a", t2), t2;
        }, r.o = function(e2, t2) {
          return Object.prototype.hasOwnProperty.call(e2, t2);
        }, r.p = "", r(r.s = 90);
      }({ 17: function(e, t, r) {
        "use strict";
        t.__esModule = true, t.default = void 0;
        var n = r(18), i = function() {
          function e2() {
          }
          return e2.getFirstMatch = function(e3, t2) {
            var r2 = t2.match(e3);
            return r2 && r2.length > 0 && r2[1] || "";
          }, e2.getSecondMatch = function(e3, t2) {
            var r2 = t2.match(e3);
            return r2 && r2.length > 1 && r2[2] || "";
          }, e2.matchAndReturnConst = function(e3, t2, r2) {
            if (e3.test(t2)) return r2;
          }, e2.getWindowsVersionName = function(e3) {
            switch (e3) {
              case "NT":
                return "NT";
              case "XP":
                return "XP";
              case "NT 5.0":
                return "2000";
              case "NT 5.1":
                return "XP";
              case "NT 5.2":
                return "2003";
              case "NT 6.0":
                return "Vista";
              case "NT 6.1":
                return "7";
              case "NT 6.2":
                return "8";
              case "NT 6.3":
                return "8.1";
              case "NT 10.0":
                return "10";
              default:
                return;
            }
          }, e2.getMacOSVersionName = function(e3) {
            var t2 = e3.split(".").splice(0, 2).map(function(e4) {
              return parseInt(e4, 10) || 0;
            });
            if (t2.push(0), 10 === t2[0]) switch (t2[1]) {
              case 5:
                return "Leopard";
              case 6:
                return "Snow Leopard";
              case 7:
                return "Lion";
              case 8:
                return "Mountain Lion";
              case 9:
                return "Mavericks";
              case 10:
                return "Yosemite";
              case 11:
                return "El Capitan";
              case 12:
                return "Sierra";
              case 13:
                return "High Sierra";
              case 14:
                return "Mojave";
              case 15:
                return "Catalina";
              default:
                return;
            }
          }, e2.getAndroidVersionName = function(e3) {
            var t2 = e3.split(".").splice(0, 2).map(function(e4) {
              return parseInt(e4, 10) || 0;
            });
            if (t2.push(0), !(1 === t2[0] && t2[1] < 5)) return 1 === t2[0] && t2[1] < 6 ? "Cupcake" : 1 === t2[0] && t2[1] >= 6 ? "Donut" : 2 === t2[0] && t2[1] < 2 ? "Eclair" : 2 === t2[0] && 2 === t2[1] ? "Froyo" : 2 === t2[0] && t2[1] > 2 ? "Gingerbread" : 3 === t2[0] ? "Honeycomb" : 4 === t2[0] && t2[1] < 1 ? "Ice Cream Sandwich" : 4 === t2[0] && t2[1] < 4 ? "Jelly Bean" : 4 === t2[0] && t2[1] >= 4 ? "KitKat" : 5 === t2[0] ? "Lollipop" : 6 === t2[0] ? "Marshmallow" : 7 === t2[0] ? "Nougat" : 8 === t2[0] ? "Oreo" : 9 === t2[0] ? "Pie" : void 0;
          }, e2.getVersionPrecision = function(e3) {
            return e3.split(".").length;
          }, e2.compareVersions = function(t2, r2, n2) {
            void 0 === n2 && (n2 = false);
            var i2 = e2.getVersionPrecision(t2), s = e2.getVersionPrecision(r2), a = Math.max(i2, s), o = 0, u = e2.map([t2, r2], function(t3) {
              var r3 = a - e2.getVersionPrecision(t3), n3 = t3 + new Array(r3 + 1).join(".0");
              return e2.map(n3.split("."), function(e3) {
                return new Array(20 - e3.length).join("0") + e3;
              }).reverse();
            });
            for (n2 && (o = a - Math.min(i2, s)), a -= 1; a >= o; ) {
              if (u[0][a] > u[1][a]) return 1;
              if (u[0][a] === u[1][a]) {
                if (a === o) return 0;
                a -= 1;
              } else if (u[0][a] < u[1][a]) return -1;
            }
          }, e2.map = function(e3, t2) {
            var r2, n2 = [];
            if (Array.prototype.map) return Array.prototype.map.call(e3, t2);
            for (r2 = 0; r2 < e3.length; r2 += 1) n2.push(t2(e3[r2]));
            return n2;
          }, e2.find = function(e3, t2) {
            var r2, n2;
            if (Array.prototype.find) return Array.prototype.find.call(e3, t2);
            for (r2 = 0, n2 = e3.length; r2 < n2; r2 += 1) {
              var i2 = e3[r2];
              if (t2(i2, r2)) return i2;
            }
          }, e2.assign = function(e3) {
            for (var t2, r2, n2 = e3, i2 = arguments.length, s = new Array(i2 > 1 ? i2 - 1 : 0), a = 1; a < i2; a++) s[a - 1] = arguments[a];
            if (Object.assign) return Object.assign.apply(Object, [e3].concat(s));
            var o = function() {
              var e4 = s[t2];
              "object" == typeof e4 && null !== e4 && Object.keys(e4).forEach(function(t3) {
                n2[t3] = e4[t3];
              });
            };
            for (t2 = 0, r2 = s.length; t2 < r2; t2 += 1) o();
            return e3;
          }, e2.getBrowserAlias = function(e3) {
            return n.BROWSER_ALIASES_MAP[e3];
          }, e2.getBrowserTypeByAlias = function(e3) {
            return n.BROWSER_MAP[e3] || "";
          }, e2;
        }();
        t.default = i, e.exports = t.default;
      }, 18: function(e, t, r) {
        "use strict";
        t.__esModule = true, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0;
        t.BROWSER_ALIASES_MAP = { "Amazon Silk": "amazon_silk", "Android Browser": "android", Bada: "bada", BlackBerry: "blackberry", Chrome: "chrome", Chromium: "chromium", Electron: "electron", Epiphany: "epiphany", Firefox: "firefox", Focus: "focus", Generic: "generic", "Google Search": "google_search", Googlebot: "googlebot", "Internet Explorer": "ie", "K-Meleon": "k_meleon", Maxthon: "maxthon", "Microsoft Edge": "edge", "MZ Browser": "mz", "NAVER Whale Browser": "naver", Opera: "opera", "Opera Coast": "opera_coast", PhantomJS: "phantomjs", Puffin: "puffin", QupZilla: "qupzilla", QQ: "qq", QQLite: "qqlite", Safari: "safari", Sailfish: "sailfish", "Samsung Internet for Android": "samsung_internet", SeaMonkey: "seamonkey", Sleipnir: "sleipnir", Swing: "swing", Tizen: "tizen", "UC Browser": "uc", Vivaldi: "vivaldi", "WebOS Browser": "webos", WeChat: "wechat", "Yandex Browser": "yandex", Roku: "roku" };
        t.BROWSER_MAP = { amazon_silk: "Amazon Silk", android: "Android Browser", bada: "Bada", blackberry: "BlackBerry", chrome: "Chrome", chromium: "Chromium", electron: "Electron", epiphany: "Epiphany", firefox: "Firefox", focus: "Focus", generic: "Generic", googlebot: "Googlebot", google_search: "Google Search", ie: "Internet Explorer", k_meleon: "K-Meleon", maxthon: "Maxthon", edge: "Microsoft Edge", mz: "MZ Browser", naver: "NAVER Whale Browser", opera: "Opera", opera_coast: "Opera Coast", phantomjs: "PhantomJS", puffin: "Puffin", qupzilla: "QupZilla", qq: "QQ Browser", qqlite: "QQ Browser Lite", safari: "Safari", sailfish: "Sailfish", samsung_internet: "Samsung Internet for Android", seamonkey: "SeaMonkey", sleipnir: "Sleipnir", swing: "Swing", tizen: "Tizen", uc: "UC Browser", vivaldi: "Vivaldi", webos: "WebOS Browser", wechat: "WeChat", yandex: "Yandex Browser" };
        t.PLATFORMS_MAP = { tablet: "tablet", mobile: "mobile", desktop: "desktop", tv: "tv" };
        t.OS_MAP = { WindowsPhone: "Windows Phone", Windows: "Windows", MacOS: "macOS", iOS: "iOS", Android: "Android", WebOS: "WebOS", BlackBerry: "BlackBerry", Bada: "Bada", Tizen: "Tizen", Linux: "Linux", ChromeOS: "Chrome OS", PlayStation4: "PlayStation 4", Roku: "Roku" };
        t.ENGINE_MAP = { EdgeHTML: "EdgeHTML", Blink: "Blink", Trident: "Trident", Presto: "Presto", Gecko: "Gecko", WebKit: "WebKit" };
      }, 90: function(e, t, r) {
        "use strict";
        t.__esModule = true, t.default = void 0;
        var n, i = (n = r(91)) && n.__esModule ? n : { default: n }, s = r(18);
        function a(e2, t2) {
          for (var r2 = 0; r2 < t2.length; r2++) {
            var n2 = t2[r2];
            n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(e2, n2.key, n2);
          }
        }
        var o = function() {
          function e2() {
          }
          var t2, r2, n2;
          return e2.getParser = function(e3, t3) {
            if (void 0 === t3 && (t3 = false), "string" != typeof e3) throw new Error("UserAgent should be a string");
            return new i.default(e3, t3);
          }, e2.parse = function(e3) {
            return new i.default(e3).getResult();
          }, t2 = e2, n2 = [{ key: "BROWSER_MAP", get: function() {
            return s.BROWSER_MAP;
          } }, { key: "ENGINE_MAP", get: function() {
            return s.ENGINE_MAP;
          } }, { key: "OS_MAP", get: function() {
            return s.OS_MAP;
          } }, { key: "PLATFORMS_MAP", get: function() {
            return s.PLATFORMS_MAP;
          } }], (r2 = null) && a(t2.prototype, r2), n2 && a(t2, n2), e2;
        }();
        t.default = o, e.exports = t.default;
      }, 91: function(e, t, r) {
        "use strict";
        t.__esModule = true, t.default = void 0;
        var n = u(r(92)), i = u(r(93)), s = u(r(94)), a = u(r(95)), o = u(r(17));
        function u(e2) {
          return e2 && e2.__esModule ? e2 : { default: e2 };
        }
        var d = function() {
          function e2(e3, t3) {
            if (void 0 === t3 && (t3 = false), null == e3 || "" === e3) throw new Error("UserAgent parameter can't be empty");
            this._ua = e3, this.parsedResult = {}, true !== t3 && this.parse();
          }
          var t2 = e2.prototype;
          return t2.getUA = function() {
            return this._ua;
          }, t2.test = function(e3) {
            return e3.test(this._ua);
          }, t2.parseBrowser = function() {
            var e3 = this;
            this.parsedResult.browser = {};
            var t3 = o.default.find(n.default, function(t4) {
              if ("function" == typeof t4.test) return t4.test(e3);
              if (t4.test instanceof Array) return t4.test.some(function(t5) {
                return e3.test(t5);
              });
              throw new Error("Browser's test function is not valid");
            });
            return t3 && (this.parsedResult.browser = t3.describe(this.getUA())), this.parsedResult.browser;
          }, t2.getBrowser = function() {
            return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
          }, t2.getBrowserName = function(e3) {
            return e3 ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
          }, t2.getBrowserVersion = function() {
            return this.getBrowser().version;
          }, t2.getOS = function() {
            return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
          }, t2.parseOS = function() {
            var e3 = this;
            this.parsedResult.os = {};
            var t3 = o.default.find(i.default, function(t4) {
              if ("function" == typeof t4.test) return t4.test(e3);
              if (t4.test instanceof Array) return t4.test.some(function(t5) {
                return e3.test(t5);
              });
              throw new Error("Browser's test function is not valid");
            });
            return t3 && (this.parsedResult.os = t3.describe(this.getUA())), this.parsedResult.os;
          }, t2.getOSName = function(e3) {
            var t3 = this.getOS().name;
            return e3 ? String(t3).toLowerCase() || "" : t3 || "";
          }, t2.getOSVersion = function() {
            return this.getOS().version;
          }, t2.getPlatform = function() {
            return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
          }, t2.getPlatformType = function(e3) {
            void 0 === e3 && (e3 = false);
            var t3 = this.getPlatform().type;
            return e3 ? String(t3).toLowerCase() || "" : t3 || "";
          }, t2.parsePlatform = function() {
            var e3 = this;
            this.parsedResult.platform = {};
            var t3 = o.default.find(s.default, function(t4) {
              if ("function" == typeof t4.test) return t4.test(e3);
              if (t4.test instanceof Array) return t4.test.some(function(t5) {
                return e3.test(t5);
              });
              throw new Error("Browser's test function is not valid");
            });
            return t3 && (this.parsedResult.platform = t3.describe(this.getUA())), this.parsedResult.platform;
          }, t2.getEngine = function() {
            return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
          }, t2.getEngineName = function(e3) {
            return e3 ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
          }, t2.parseEngine = function() {
            var e3 = this;
            this.parsedResult.engine = {};
            var t3 = o.default.find(a.default, function(t4) {
              if ("function" == typeof t4.test) return t4.test(e3);
              if (t4.test instanceof Array) return t4.test.some(function(t5) {
                return e3.test(t5);
              });
              throw new Error("Browser's test function is not valid");
            });
            return t3 && (this.parsedResult.engine = t3.describe(this.getUA())), this.parsedResult.engine;
          }, t2.parse = function() {
            return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
          }, t2.getResult = function() {
            return o.default.assign({}, this.parsedResult);
          }, t2.satisfies = function(e3) {
            var t3 = this, r2 = {}, n2 = 0, i2 = {}, s2 = 0;
            if (Object.keys(e3).forEach(function(t4) {
              var a3 = e3[t4];
              "string" == typeof a3 ? (i2[t4] = a3, s2 += 1) : "object" == typeof a3 && (r2[t4] = a3, n2 += 1);
            }), n2 > 0) {
              var a2 = Object.keys(r2), u2 = o.default.find(a2, function(e4) {
                return t3.isOS(e4);
              });
              if (u2) {
                var d2 = this.satisfies(r2[u2]);
                if (void 0 !== d2) return d2;
              }
              var c = o.default.find(a2, function(e4) {
                return t3.isPlatform(e4);
              });
              if (c) {
                var f = this.satisfies(r2[c]);
                if (void 0 !== f) return f;
              }
            }
            if (s2 > 0) {
              var l = Object.keys(i2), h = o.default.find(l, function(e4) {
                return t3.isBrowser(e4, true);
              });
              if (void 0 !== h) return this.compareVersion(i2[h]);
            }
          }, t2.isBrowser = function(e3, t3) {
            void 0 === t3 && (t3 = false);
            var r2 = this.getBrowserName().toLowerCase(), n2 = e3.toLowerCase(), i2 = o.default.getBrowserTypeByAlias(n2);
            return t3 && i2 && (n2 = i2.toLowerCase()), n2 === r2;
          }, t2.compareVersion = function(e3) {
            var t3 = [0], r2 = e3, n2 = false, i2 = this.getBrowserVersion();
            if ("string" == typeof i2) return ">" === e3[0] || "<" === e3[0] ? (r2 = e3.substr(1), "=" === e3[1] ? (n2 = true, r2 = e3.substr(2)) : t3 = [], ">" === e3[0] ? t3.push(1) : t3.push(-1)) : "=" === e3[0] ? r2 = e3.substr(1) : "~" === e3[0] && (n2 = true, r2 = e3.substr(1)), t3.indexOf(o.default.compareVersions(i2, r2, n2)) > -1;
          }, t2.isOS = function(e3) {
            return this.getOSName(true) === String(e3).toLowerCase();
          }, t2.isPlatform = function(e3) {
            return this.getPlatformType(true) === String(e3).toLowerCase();
          }, t2.isEngine = function(e3) {
            return this.getEngineName(true) === String(e3).toLowerCase();
          }, t2.is = function(e3, t3) {
            return void 0 === t3 && (t3 = false), this.isBrowser(e3, t3) || this.isOS(e3) || this.isPlatform(e3);
          }, t2.some = function(e3) {
            var t3 = this;
            return void 0 === e3 && (e3 = []), e3.some(function(e4) {
              return t3.is(e4);
            });
          }, e2;
        }();
        t.default = d, e.exports = t.default;
      }, 92: function(e, t, r) {
        "use strict";
        t.__esModule = true, t.default = void 0;
        var n, i = (n = r(17)) && n.__esModule ? n : { default: n };
        var s = /version\/(\d+(\.?_?\d+)+)/i, a = [{ test: [/googlebot/i], describe: function(e2) {
          var t2 = { name: "Googlebot" }, r2 = i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e2) || i.default.getFirstMatch(s, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/opera/i], describe: function(e2) {
          var t2 = { name: "Opera" }, r2 = i.default.getFirstMatch(s, e2) || i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/opr\/|opios/i], describe: function(e2) {
          var t2 = { name: "Opera" }, r2 = i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e2) || i.default.getFirstMatch(s, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/SamsungBrowser/i], describe: function(e2) {
          var t2 = { name: "Samsung Internet for Android" }, r2 = i.default.getFirstMatch(s, e2) || i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/Whale/i], describe: function(e2) {
          var t2 = { name: "NAVER Whale Browser" }, r2 = i.default.getFirstMatch(s, e2) || i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/MZBrowser/i], describe: function(e2) {
          var t2 = { name: "MZ Browser" }, r2 = i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e2) || i.default.getFirstMatch(s, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/focus/i], describe: function(e2) {
          var t2 = { name: "Focus" }, r2 = i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e2) || i.default.getFirstMatch(s, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/swing/i], describe: function(e2) {
          var t2 = { name: "Swing" }, r2 = i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e2) || i.default.getFirstMatch(s, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/coast/i], describe: function(e2) {
          var t2 = { name: "Opera Coast" }, r2 = i.default.getFirstMatch(s, e2) || i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/opt\/\d+(?:.?_?\d+)+/i], describe: function(e2) {
          var t2 = { name: "Opera Touch" }, r2 = i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e2) || i.default.getFirstMatch(s, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/yabrowser/i], describe: function(e2) {
          var t2 = { name: "Yandex Browser" }, r2 = i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e2) || i.default.getFirstMatch(s, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/ucbrowser/i], describe: function(e2) {
          var t2 = { name: "UC Browser" }, r2 = i.default.getFirstMatch(s, e2) || i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/Maxthon|mxios/i], describe: function(e2) {
          var t2 = { name: "Maxthon" }, r2 = i.default.getFirstMatch(s, e2) || i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/epiphany/i], describe: function(e2) {
          var t2 = { name: "Epiphany" }, r2 = i.default.getFirstMatch(s, e2) || i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/puffin/i], describe: function(e2) {
          var t2 = { name: "Puffin" }, r2 = i.default.getFirstMatch(s, e2) || i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/sleipnir/i], describe: function(e2) {
          var t2 = { name: "Sleipnir" }, r2 = i.default.getFirstMatch(s, e2) || i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/k-meleon/i], describe: function(e2) {
          var t2 = { name: "K-Meleon" }, r2 = i.default.getFirstMatch(s, e2) || i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/micromessenger/i], describe: function(e2) {
          var t2 = { name: "WeChat" }, r2 = i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e2) || i.default.getFirstMatch(s, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/qqbrowser/i], describe: function(e2) {
          var t2 = { name: /qqbrowserlite/i.test(e2) ? "QQ Browser Lite" : "QQ Browser" }, r2 = i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e2) || i.default.getFirstMatch(s, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/msie|trident/i], describe: function(e2) {
          var t2 = { name: "Internet Explorer" }, r2 = i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/\sedg\//i], describe: function(e2) {
          var t2 = { name: "Microsoft Edge" }, r2 = i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/edg([ea]|ios)/i], describe: function(e2) {
          var t2 = { name: "Microsoft Edge" }, r2 = i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/vivaldi/i], describe: function(e2) {
          var t2 = { name: "Vivaldi" }, r2 = i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/seamonkey/i], describe: function(e2) {
          var t2 = { name: "SeaMonkey" }, r2 = i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/sailfish/i], describe: function(e2) {
          var t2 = { name: "Sailfish" }, r2 = i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/silk/i], describe: function(e2) {
          var t2 = { name: "Amazon Silk" }, r2 = i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/phantom/i], describe: function(e2) {
          var t2 = { name: "PhantomJS" }, r2 = i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/slimerjs/i], describe: function(e2) {
          var t2 = { name: "SlimerJS" }, r2 = i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/blackberry|\bbb\d+/i, /rim\stablet/i], describe: function(e2) {
          var t2 = { name: "BlackBerry" }, r2 = i.default.getFirstMatch(s, e2) || i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/(web|hpw)[o0]s/i], describe: function(e2) {
          var t2 = { name: "WebOS Browser" }, r2 = i.default.getFirstMatch(s, e2) || i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/bada/i], describe: function(e2) {
          var t2 = { name: "Bada" }, r2 = i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/tizen/i], describe: function(e2) {
          var t2 = { name: "Tizen" }, r2 = i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e2) || i.default.getFirstMatch(s, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/qupzilla/i], describe: function(e2) {
          var t2 = { name: "QupZilla" }, r2 = i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e2) || i.default.getFirstMatch(s, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/firefox|iceweasel|fxios/i], describe: function(e2) {
          var t2 = { name: "Firefox" }, r2 = i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/electron/i], describe: function(e2) {
          var t2 = { name: "Electron" }, r2 = i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/MiuiBrowser/i], describe: function(e2) {
          var t2 = { name: "Miui" }, r2 = i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/chromium/i], describe: function(e2) {
          var t2 = { name: "Chromium" }, r2 = i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e2) || i.default.getFirstMatch(s, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/chrome|crios|crmo/i], describe: function(e2) {
          var t2 = { name: "Chrome" }, r2 = i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/GSA/i], describe: function(e2) {
          var t2 = { name: "Google Search" }, r2 = i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: function(e2) {
          var t2 = !e2.test(/like android/i), r2 = e2.test(/android/i);
          return t2 && r2;
        }, describe: function(e2) {
          var t2 = { name: "Android Browser" }, r2 = i.default.getFirstMatch(s, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/playstation 4/i], describe: function(e2) {
          var t2 = { name: "PlayStation 4" }, r2 = i.default.getFirstMatch(s, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/safari|applewebkit/i], describe: function(e2) {
          var t2 = { name: "Safari" }, r2 = i.default.getFirstMatch(s, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/.*/i], describe: function(e2) {
          var t2 = -1 !== e2.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
          return { name: i.default.getFirstMatch(t2, e2), version: i.default.getSecondMatch(t2, e2) };
        } }];
        t.default = a, e.exports = t.default;
      }, 93: function(e, t, r) {
        "use strict";
        t.__esModule = true, t.default = void 0;
        var n, i = (n = r(17)) && n.__esModule ? n : { default: n }, s = r(18);
        var a = [{ test: [/Roku\/DVP/], describe: function(e2) {
          var t2 = i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e2);
          return { name: s.OS_MAP.Roku, version: t2 };
        } }, { test: [/windows phone/i], describe: function(e2) {
          var t2 = i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e2);
          return { name: s.OS_MAP.WindowsPhone, version: t2 };
        } }, { test: [/windows /i], describe: function(e2) {
          var t2 = i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e2), r2 = i.default.getWindowsVersionName(t2);
          return { name: s.OS_MAP.Windows, version: t2, versionName: r2 };
        } }, { test: [/Macintosh(.*?) FxiOS(.*?)\//], describe: function(e2) {
          var t2 = { name: s.OS_MAP.iOS }, r2 = i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/macintosh/i], describe: function(e2) {
          var t2 = i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e2).replace(/[_\s]/g, "."), r2 = i.default.getMacOSVersionName(t2), n2 = { name: s.OS_MAP.MacOS, version: t2 };
          return r2 && (n2.versionName = r2), n2;
        } }, { test: [/(ipod|iphone|ipad)/i], describe: function(e2) {
          var t2 = i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e2).replace(/[_\s]/g, ".");
          return { name: s.OS_MAP.iOS, version: t2 };
        } }, { test: function(e2) {
          var t2 = !e2.test(/like android/i), r2 = e2.test(/android/i);
          return t2 && r2;
        }, describe: function(e2) {
          var t2 = i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e2), r2 = i.default.getAndroidVersionName(t2), n2 = { name: s.OS_MAP.Android, version: t2 };
          return r2 && (n2.versionName = r2), n2;
        } }, { test: [/(web|hpw)[o0]s/i], describe: function(e2) {
          var t2 = i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e2), r2 = { name: s.OS_MAP.WebOS };
          return t2 && t2.length && (r2.version = t2), r2;
        } }, { test: [/blackberry|\bbb\d+/i, /rim\stablet/i], describe: function(e2) {
          var t2 = i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e2) || i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e2) || i.default.getFirstMatch(/\bbb(\d+)/i, e2);
          return { name: s.OS_MAP.BlackBerry, version: t2 };
        } }, { test: [/bada/i], describe: function(e2) {
          var t2 = i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e2);
          return { name: s.OS_MAP.Bada, version: t2 };
        } }, { test: [/tizen/i], describe: function(e2) {
          var t2 = i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e2);
          return { name: s.OS_MAP.Tizen, version: t2 };
        } }, { test: [/linux/i], describe: function() {
          return { name: s.OS_MAP.Linux };
        } }, { test: [/CrOS/], describe: function() {
          return { name: s.OS_MAP.ChromeOS };
        } }, { test: [/PlayStation 4/], describe: function(e2) {
          var t2 = i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e2);
          return { name: s.OS_MAP.PlayStation4, version: t2 };
        } }];
        t.default = a, e.exports = t.default;
      }, 94: function(e, t, r) {
        "use strict";
        t.__esModule = true, t.default = void 0;
        var n, i = (n = r(17)) && n.__esModule ? n : { default: n }, s = r(18);
        var a = [{ test: [/googlebot/i], describe: function() {
          return { type: "bot", vendor: "Google" };
        } }, { test: [/huawei/i], describe: function(e2) {
          var t2 = i.default.getFirstMatch(/(can-l01)/i, e2) && "Nova", r2 = { type: s.PLATFORMS_MAP.mobile, vendor: "Huawei" };
          return t2 && (r2.model = t2), r2;
        } }, { test: [/nexus\s*(?:7|8|9|10).*/i], describe: function() {
          return { type: s.PLATFORMS_MAP.tablet, vendor: "Nexus" };
        } }, { test: [/ipad/i], describe: function() {
          return { type: s.PLATFORMS_MAP.tablet, vendor: "Apple", model: "iPad" };
        } }, { test: [/Macintosh(.*?) FxiOS(.*?)\//], describe: function() {
          return { type: s.PLATFORMS_MAP.tablet, vendor: "Apple", model: "iPad" };
        } }, { test: [/kftt build/i], describe: function() {
          return { type: s.PLATFORMS_MAP.tablet, vendor: "Amazon", model: "Kindle Fire HD 7" };
        } }, { test: [/silk/i], describe: function() {
          return { type: s.PLATFORMS_MAP.tablet, vendor: "Amazon" };
        } }, { test: [/tablet(?! pc)/i], describe: function() {
          return { type: s.PLATFORMS_MAP.tablet };
        } }, { test: function(e2) {
          var t2 = e2.test(/ipod|iphone/i), r2 = e2.test(/like (ipod|iphone)/i);
          return t2 && !r2;
        }, describe: function(e2) {
          var t2 = i.default.getFirstMatch(/(ipod|iphone)/i, e2);
          return { type: s.PLATFORMS_MAP.mobile, vendor: "Apple", model: t2 };
        } }, { test: [/nexus\s*[0-6].*/i, /galaxy nexus/i], describe: function() {
          return { type: s.PLATFORMS_MAP.mobile, vendor: "Nexus" };
        } }, { test: [/[^-]mobi/i], describe: function() {
          return { type: s.PLATFORMS_MAP.mobile };
        } }, { test: function(e2) {
          return "blackberry" === e2.getBrowserName(true);
        }, describe: function() {
          return { type: s.PLATFORMS_MAP.mobile, vendor: "BlackBerry" };
        } }, { test: function(e2) {
          return "bada" === e2.getBrowserName(true);
        }, describe: function() {
          return { type: s.PLATFORMS_MAP.mobile };
        } }, { test: function(e2) {
          return "windows phone" === e2.getBrowserName();
        }, describe: function() {
          return { type: s.PLATFORMS_MAP.mobile, vendor: "Microsoft" };
        } }, { test: function(e2) {
          var t2 = Number(String(e2.getOSVersion()).split(".")[0]);
          return "android" === e2.getOSName(true) && t2 >= 3;
        }, describe: function() {
          return { type: s.PLATFORMS_MAP.tablet };
        } }, { test: function(e2) {
          return "android" === e2.getOSName(true);
        }, describe: function() {
          return { type: s.PLATFORMS_MAP.mobile };
        } }, { test: function(e2) {
          return "macos" === e2.getOSName(true);
        }, describe: function() {
          return { type: s.PLATFORMS_MAP.desktop, vendor: "Apple" };
        } }, { test: function(e2) {
          return "windows" === e2.getOSName(true);
        }, describe: function() {
          return { type: s.PLATFORMS_MAP.desktop };
        } }, { test: function(e2) {
          return "linux" === e2.getOSName(true);
        }, describe: function() {
          return { type: s.PLATFORMS_MAP.desktop };
        } }, { test: function(e2) {
          return "playstation 4" === e2.getOSName(true);
        }, describe: function() {
          return { type: s.PLATFORMS_MAP.tv };
        } }, { test: function(e2) {
          return "roku" === e2.getOSName(true);
        }, describe: function() {
          return { type: s.PLATFORMS_MAP.tv };
        } }];
        t.default = a, e.exports = t.default;
      }, 95: function(e, t, r) {
        "use strict";
        t.__esModule = true, t.default = void 0;
        var n, i = (n = r(17)) && n.__esModule ? n : { default: n }, s = r(18);
        var a = [{ test: function(e2) {
          return "microsoft edge" === e2.getBrowserName(true);
        }, describe: function(e2) {
          if (/\sedg\//i.test(e2)) return { name: s.ENGINE_MAP.Blink };
          var t2 = i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e2);
          return { name: s.ENGINE_MAP.EdgeHTML, version: t2 };
        } }, { test: [/trident/i], describe: function(e2) {
          var t2 = { name: s.ENGINE_MAP.Trident }, r2 = i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: function(e2) {
          return e2.test(/presto/i);
        }, describe: function(e2) {
          var t2 = { name: s.ENGINE_MAP.Presto }, r2 = i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: function(e2) {
          var t2 = e2.test(/gecko/i), r2 = e2.test(/like gecko/i);
          return t2 && !r2;
        }, describe: function(e2) {
          var t2 = { name: s.ENGINE_MAP.Gecko }, r2 = i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e2);
          return r2 && (t2.version = r2), t2;
        } }, { test: [/(apple)?webkit\/537\.36/i], describe: function() {
          return { name: s.ENGINE_MAP.Blink };
        } }, { test: [/(apple)?webkit/i], describe: function(e2) {
          var t2 = { name: s.ENGINE_MAP.WebKit }, r2 = i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e2);
          return r2 && (t2.version = r2), t2;
        } }];
        t.default = a, e.exports = t.default;
      } });
    });
  }
});

// src/components/common/link.jsx
import { Link as RouterLink } from "react-router-dom";
import { jsx as jsx29 } from "react/jsx-runtime";
var Link, link_default;
var init_link = __esm({
  "src/components/common/link.jsx"() {
    "use strict";
    Link = ({ children, ...props }) => (props == null ? void 0 : props.href) ? /* @__PURE__ */ jsx29("a", { ...props, children }) : /* @__PURE__ */ jsx29(RouterLink, { ...props, children });
    link_default = Link;
  }
});

// src/constants/panorama.js
var WORDING_MARKETING, PANORAMA_CHAPTERS, PANORAMA_PAGE_PREFIX, GENIALLY_INFOS, PADLET_INFOS, RESOURCE_GOALS, RESOURCE_FORMAT, WORDING_GOALS, WORDING_LINKS;
var init_panorama = __esm({
  "src/constants/panorama.js"() {
    "use strict";
    WORDING_MARKETING = {
      drawerTitle: "Nouveaut\xE9 Premium",
      drawerStickyPremiumLabel: "Votre manuel s'enrichit !"
    };
    PANORAMA_CHAPTERS = {
      46838421: {
        title: WORDING_MARKETING.drawerTitle,
        thematic: "Pr\xE9parer le chapitre 1",
        metas: {
          title: "Histoire 2de - Pr\xE9parer le chapitre 1",
          image: "https://assets.lls.fr/pages/55674209/his2de1bandeau.jpg"
        },
        dataId: 0
      },
      53512281: {
        title: WORDING_MARKETING.drawerTitle,
        thematic: "Pr\xE9parer le chapitre 1",
        metas: {
          title: "Histoire-G\xE9ographie 2de - Pr\xE9parer le chapitre 1",
          image: "https://assets.lls.fr/pages/55674209/his2de1bandeau.jpg"
        },
        dataId: 0
      },
      46838853: {
        title: WORDING_MARKETING.drawerTitle,
        thematic: "Pr\xE9parer le chapitre 2",
        metas: {
          title: "Histoire 2de - Pr\xE9parer le chapitre 2",
          image: "https://assets.lls.fr/pages/57409137/his2de2pdp2carte-venise-remplacement-retouche.jpg"
        },
        dataId: 1
      },
      53512358: {
        title: WORDING_MARKETING.drawerTitle,
        thematic: "Pr\xE9parer le chapitre 2",
        metas: {
          title: "Histoire-G\xE9ographie 2de - Pr\xE9parer le chapitre 2",
          image: "https://assets.lls.fr/pages/57409137/his2de2pdp2carte-venise-remplacement-retouche.jpg"
        },
        dataId: 1
      },
      46838873: {
        title: WORDING_MARKETING.drawerTitle,
        thematic: "Pr\xE9parer le chapitre 3",
        metas: {
          title: "Histoire 2de - Pr\xE9parer le chapitre 3",
          image: "https://assets.lls.fr/pages/54036965/bandeau-header-chapitre-3.jpg"
        },
        dataId: 2
      },
      53512416: {
        title: WORDING_MARKETING.drawerTitle,
        thematic: "Pr\xE9parer le chapitre 3",
        metas: {
          title: "Histoire-G\xE9ographie 2de - Pr\xE9parer le chapitre 3",
          image: "https://assets.lls.fr/pages/54036965/bandeau-header-chapitre-3.jpg"
        },
        dataId: 2
      },
      46838642: {
        title: WORDING_MARKETING.drawerTitle,
        thematic: "Pr\xE9parer le chapitre 4",
        metas: {
          title: "Histoire 2de - Pr\xE9parer le chapitre 4",
          image: "/assets/img/panorama/metas/his2ch4.jpeg"
        },
        dataId: 3
      },
      53512302: {
        title: WORDING_MARKETING.drawerTitle,
        thematic: "Pr\xE9parer le chapitre 4",
        metas: {
          title: "Histoire-G\xE9ographie 2de - Pr\xE9parer le chapitre 4",
          image: "/assets/img/panorama/metas/his2ch4.jpeg"
        },
        dataId: 3
      },
      46838526: {
        title: WORDING_MARKETING.drawerTitle,
        thematic: "Pr\xE9parer le chapitre 5",
        metas: {
          title: "Histoire 2de - Pr\xE9parer le chapitre 5",
          image: "https://assets.lls.fr/pages/47777754/bandeau-header-chapitre-5.JPG"
        },
        dataId: 4
      },
      53512268: {
        title: WORDING_MARKETING.drawerTitle,
        thematic: "Pr\xE9parer le chapitre 5",
        metas: {
          title: "Histoire-G\xE9ographie 2de - Pr\xE9parer le chapitre 5",
          image: "https://assets.lls.fr/pages/47777754/bandeau-header-chapitre-5.JPG"
        },
        dataId: 4
      },
      46838661: {
        title: WORDING_MARKETING.drawerTitle,
        thematic: "Pr\xE9parer le chapitre 6",
        metas: {
          title: "Histoire 2de - Pr\xE9parer le chapitre 6",
          image: "https://assets.lls.fr/pages/51799143/his2de6ouvplassey-elephant.jpg"
        },
        dataId: 5
      },
      53512099: {
        title: WORDING_MARKETING.drawerTitle,
        thematic: "Pr\xE9parer le chapitre 6",
        metas: {
          title: "Histoire-G\xE9ographie 2de - Pr\xE9parer le chapitre 6",
          image: "https://assets.lls.fr/pages/51799143/his2de6ouvplassey-elephant.jpg"
        },
        dataId: 5
      },
      46838799: {
        title: WORDING_MARKETING.drawerTitle,
        thematic: "Pr\xE9parer le chapitre 7",
        metas: {
          title: "Histoire 2de - Pr\xE9parer le chapitre 7",
          image: "https://assets.lls.fr/pages/51799365/lls-his2-ch7-icono10-1.jpg"
        },
        dataId: 6
      },
      53512167: {
        title: WORDING_MARKETING.drawerTitle,
        thematic: "Pr\xE9parer le chapitre 7",
        metas: {
          title: "Histoire-G\xE9ographie 2de - Pr\xE9parer le chapitre 7",
          image: "https://assets.lls.fr/pages/51799365/lls-his2-ch7-icono10-1.jpg"
        },
        dataId: 6
      },
      46838777: {
        title: WORDING_MARKETING.drawerTitle,
        thematic: "Pr\xE9parer le chapitre 8",
        metas: {
          title: "Histoire 2de - Pr\xE9parer le chapitre 8",
          image: "https://assets.lls.fr/pages/55675997/his2de08repca-ne-durera-pas-toujours.jpg"
        },
        dataId: 7
      },
      53512341: {
        title: WORDING_MARKETING.drawerTitle,
        thematic: "Pr\xE9parer le chapitre 8",
        metas: {
          title: "Histoire-G\xE9ographie 2de - Pr\xE9parer le chapitre 8",
          image: "https://assets.lls.fr/pages/55675997/his2de08repca-ne-durera-pas-toujours.jpg"
        },
        dataId: 7
      }
    };
    PANORAMA_PAGE_PREFIX = "pano-";
    GENIALLY_INFOS = {
      title: "Genially",
      url: "https://view.genial.ly/",
      LOGO_PATH: "/assets/img/panorama/embedded/genially-logo.svg"
    };
    PADLET_INFOS = {
      title: "Padlet",
      url: "https://padlet.com/Lelivrescolaire/",
      LOGO_PATH: "/assets/img/panorama/embedded/padlet-logo.svg"
    };
    RESOURCE_GOALS = {
      INSPIRER: 0,
      COMMENCER: 1,
      ETUDIER: 2,
      EXPLORER: 3,
      DIVERSIFIER: 4,
      MEMORISER: 5,
      ENTRAINER: 6
    };
    RESOURCE_FORMAT = {
      Padlet: 0,
      Genially: 1,
      Video: 2,
      Gallery: 3,
      DownloadPdf: 4,
      DownloadOther: 5,
      InternalLink: 6,
      ExternalLink: 7
    };
    WORDING_GOALS = {
      [RESOURCE_GOALS.INSPIRER]: {
        title: "Se documenter",
        description: "Des ressources pour pr\xE9parer votre s\xE9quence sur le chapitre \xAB Renaissance, humanisme et r\xE9formes religieuses : les mutations de l'Europe\xBB."
      },
      [RESOURCE_GOALS.COMMENCER]: {
        title: "Introduire le chapitre",
        description: "Des ressources pour amorcer la s\xE9quence."
      },
      [RESOURCE_GOALS.ETUDIER]: {
        title: "\xC9tudier les points de passage",
        description: "Proposez un autre regard sur les points de passage."
      },
      [RESOURCE_GOALS.EXPLORER]: {
        title: "Explorer",
        description: "Mettez vos \xE9l\xE8ves en activit\xE9 avec des dossiers originaux."
      },
      [RESOURCE_GOALS.DIVERSIFIER]: {
        title: "Diversifier les approches",
        description: "D\xE9veloppez la curiosit\xE9 des \xE9l\xE8ves en leur proposant des activit\xE9s originales et des ressources ludiques."
      },
      [RESOURCE_GOALS.MEMORISER]: {
        title: "M\xE9moriser",
        description: "Variez les supports pour mieux ancrer les connaissances des \xE9l\xE8ves."
      },
      [RESOURCE_GOALS.ENTRAINER]: {
        title: "S'entra\xEEner",
        description: "Impliquez vos \xE9l\xE8ves en testant leurs connaissances."
      }
    };
    WORDING_LINKS = {
      [RESOURCE_FORMAT.InternalLink]: {
        label: "Consultez la ressource en ligne",
        button: "Consulter",
        icon: "doctext"
      },
      [RESOURCE_FORMAT.ExternalLink]: {
        label: "Acc\xE9dez \xE0 la ressource en ligne",
        button: "Acc\xE9der",
        icon: "earth"
      },
      [RESOURCE_FORMAT.DownloadPdf]: {
        label: "T\xE9l\xE9chargez la ressource en format PDF",
        button: "T\xE9l\xE9charger",
        icon: "arrowdowntoline"
      },
      [RESOURCE_FORMAT.DownloadOther]: {
        label: "T\xE9l\xE9chargez la ressource en format modifiable",
        button: "T\xE9l\xE9charger",
        icon: "arrowdowntoline"
      }
    };
  }
});

// src/utils/panorama.js
import _36 from "lodash/fp.js";
var getPanoramaPageIfExists, getResourceVignette, getTypeResources, getResourcePackWithType, getPanoramaLikesCookieItems, addNewPanoramaLikesCookieItem, removePanoramaLikesCookieItem, goalToSlug, getResourcePackWithTypeFromScroll;
var init_panorama2 = __esm({
  "src/utils/panorama.js"() {
    "use strict";
    init_panorama();
    getPanoramaPageIfExists = ({ withPanorama = false, bookId, chapterId, isSearching = false, scrollTo }) => {
      if (!withPanorama || isSearching || !_36.has(chapterId, PANORAMA_CHAPTERS)) return;
      return {
        id: `${PANORAMA_PAGE_PREFIX}${chapterId}`,
        numericOrder: 0,
        page: 0,
        thematicName: _36.getOr("", [chapterId, "thematic"], PANORAMA_CHAPTERS),
        isPanorama: true,
        title: _36.getOr("", [chapterId, "title"], PANORAMA_CHAPTERS),
        valid: true,
        premium: true,
        slug: `panorama/${bookId}/${chapterId}${scrollTo ? `?scrollto=${scrollTo}` : ""}`,
        chapter: chapterId
      };
    };
    getResourceVignette = ({ vignette, type }) => {
      return vignette || (type === RESOURCE_FORMAT.Genially ? GENIALLY_INFOS.LOGO_PATH : type === RESOURCE_FORMAT.Padlet ? PADLET_INFOS.LOGO_PATH : "");
    };
    getTypeResources = _36.curry(
      (types, resourcePack) => _36.flow(
        _36.getOr([], "resources"),
        _36.filter((resource) => _36.includes(resource.format, types))
      )(resourcePack)
    );
    getResourcePackWithType = (resourcePack) => {
      if (_36.isUndefined(resourcePack)) return {};
      const type = _36.flow(
        getTypeResources([RESOURCE_FORMAT.Padlet, RESOURCE_FORMAT.Genially, RESOURCE_FORMAT.Video]),
        _36.get("0.format")
      )(resourcePack);
      return {
        ...resourcePack,
        type,
        vignette: getResourceVignette({
          type,
          vignette: resourcePack.vignette
        })
      };
    };
    getPanoramaLikesCookieItems = _36.flow(_36.split("|"), _36.compact);
    addNewPanoramaLikesCookieItem = (newItem, likesItems) => _36.flow(_36.union([newItem]), _36.join("|"))(likesItems);
    removePanoramaLikesCookieItem = (itemToRemove, likesItems) => _36.flow(_36.pull(itemToRemove), _36.join("|"))(likesItems);
    goalToSlug = (goal) => {
      return _36.flow(_36.toPairs, _36.find({ 1: goal }), _36.get(0), _36.kebabCase)(RESOURCE_GOALS);
    };
    getResourcePackWithTypeFromScroll = (scrollTo, resourcesPacks) => {
      if (!_36.isString(scrollTo)) return;
      const id = _36.get(1, scrollTo.match(/-(\d+)/));
      if (_36.isNaN(id)) return;
      return _36.find({ id: _36.parseInt(10, id) }, resourcesPacks);
    };
  }
});

// src/api/revision.js
var saveTest, saveTestWorkplan, saveWorkplanCardsOptions;
var init_revision = __esm({
  "src/api/revision.js"() {
    "use strict";
    init_graphql();
    saveTest = ({ token, pageId, testContext, answeredUuids }) => gqlNoCache({
      query: `mutation ($pageId: Int!, $testContext: JSON!, $token: String!, $answeredUuids: [String]) {
      viewer (token: $token) {
        createTest (pageId: $pageId, testContext: $testContext, answeredUuids: $answeredUuids) {
          id
        }
      }
    }`,
      variables: {
        token,
        pageId,
        testContext,
        answeredUuids
      }
    });
    saveTestWorkplan = ({ token, pageId, testContext }) => gqlNoCache({
      query: `mutation ($pageId: Int!, $testContext: JSON!, $token: String!) {
      viewer (token: $token) {
        createWorkplanTest (pageId: $pageId, testContext: $testContext) {
          id
        }
      }
    }`,
      variables: {
        token,
        pageId,
        testContext
      }
    });
    saveWorkplanCardsOptions = ({ token, pageId, options }) => gqlNoCache({
      query: `mutation ($pageId: Int!, $options: [WorkplanTaskOptionsInputType]!, $token: String!) {
      viewer (token: $token) {
        createWorkplanTaskOptions(pageId: $pageId, options: $options){
          uuid
          time
          difficulty
          publishedAt
          modalities{
            type
            value
          }
          page{
            id
          }
        }
      }
    }`,
      variables: {
        token,
        pageId,
        options
      }
    });
  }
});

// src/effects/viewer.js
import {
  dispatchAnalyticsEvent as dispatchAnalyticsEvent7,
  getDraftFromTemplate,
  getPagePath as getPagePath2,
  getQuizPath,
  hasAccessToInvalidPage,
  isPageOwner,
  openWindow as openWindow7,
  shouldSaveTest,
  shouldSaveWorkplanCardsOptions,
  shouldSaveWorkplanTest
} from "@lls/utils";
import { updateWorkplanOptionsInPage } from "@lls/viewer/staticImports";
import _38 from "lodash/fp.js";
var shouldDisplayAvailableSoonModal, onGoTo, onSessionTemplateChange, onCreatedFromScratchTemplateChange, onWorkplanTemplateChange, onDefaultTemplateChange, onReadonlyTemplateChange, onTemplateChange, onGoToEffect, onTemplateChangeEffect;
var init_viewer = __esm({
  "src/effects/viewer.js"() {
    "use strict";
    init_config();
    init_actions();
    init_revision();
    init_analytics4();
    init_constants();
    init_route();
    init_utils3();
    shouldDisplayAvailableSoonModal = ({ href, page, data, pageIndex, user }) => {
      switch (true) {
        case !!href:
          return false;
        case hasAccessToInvalidPage(user):
          return false;
        case (!_38.get("page", data) && !_38.get("indexOffset", data)):
          return true;
        case _38.get("valid", page) === false:
          return true;
        case (_38.get("indexOffset", data) && pageIndex < 0):
          return true;
        default:
          return false;
      }
    };
    onGoTo = ({
      dispatch,
      history,
      params: {
        data,
        pages,
        user,
        currentPage,
        token,
        makePath = getPagePath2,
        presentationProps = {},
        isPrintMode = false
      } = {}
    } = {}) => {
      var _a2;
      const filteredBookPages = _38.flow(
        _38.reject("isPartOfSession"),
        isPrintMode ? _38.reject((page2) => _38.isEmpty(page2 == null ? void 0 : page2.printUrls)) : _38.identity
      )(pages);
      const currentPageId = (currentPage == null ? void 0 : currentPage.originalPage) || (currentPage == null ? void 0 : currentPage.id);
      const pageIndex = _38.findIndex({ id: currentPageId }, filteredBookPages);
      const indexOffset = _38.get("indexOffset", data);
      const pageId = _38.flow(_38.get("page"), _38.parseInt(10))(data);
      const docId = _38.get("doc", data);
      const href = _38.get("href", data);
      const target = _38.get("target", data);
      const quizId = _38.get("quiz", data);
      const clampedIndex = _38.clamp(0, _38.size(filteredBookPages) - 1, pageIndex + indexOffset);
      const slug = _38.isUndefined(indexOffset) ? `page/${pageId}` : (_a2 = filteredBookPages[clampedIndex]) == null ? void 0 : _a2.slug;
      const page = _38.find({ slug }, pages);
      if (quizId) return openWindow7(getQuizPath({ baseUrl: config_default.quiz_url, quizId, user, token }), "_blank");
      if (shouldDisplayAvailableSoonModal({ href, page, data, pageIndex, user }))
        return dispatch(setModal({ name: MODAL_AVAILABLE_SOON, open: true }));
      const url = href || makePath({ slug: _38.get("slug", page), pageId }, { goTo: docId, ..._38.pick(["isDraft"], page) });
      if (href && (user == null ? void 0 : user.isGarUser) && !isLLSLink(href)) return history.push(getPath("external_redirect", { redirect: url }));
      if (href || target === "_blank") return openWindow7(url, target);
      if (presentationProps.isPresentationMode) presentationProps.closeFullscreenCard();
      history.push(url);
    };
    onSessionTemplateChange = ({ dispatch, template, ctx, currentUser, token, learningAssessmentStatsUuids }) => {
      const isLearningAssessment = template == null ? void 0 : template.isLearningAssessment;
      if (shouldSaveTest(template, ctx))
        saveTest({
          pageId: _38.get("id", template),
          testContext: ctx,
          token,
          answeredUuids: isLearningAssessment ? learningAssessmentStatsUuids : []
        });
      const isStudent = currentUser == null ? void 0 : currentUser.isStudent;
      const templateId = template == null ? void 0 : template.id;
      dispatch(
        setEntity({
          path: `pages.${templateId}`,
          entity: template
        })
      );
      if (isLearningAssessment && isStudent)
        dispatch(
          setEntity({
            path: `sharedPages.${templateId}`,
            entity: template
          })
        );
    };
    onCreatedFromScratchTemplateChange = ({ dispatch, template, history, currentUser, hasExistingDraft }) => {
      const pageToUpdate = getDraftFromTemplate(template, currentUser);
      if (!hasExistingDraft) {
        dispatchAnalyticsEvent7(ANALYTICS_EVENTS.CUSTOM_PAGE_CREATED, { pageId: _38.get("id", pageToUpdate) });
      }
      dispatch(setEntities({ drafts: { [_38.get("id", pageToUpdate)]: pageToUpdate } }));
      const { pathname, search } = _38.getOr({}, "location", history);
      return !isAlreadyOnDraftPage(history, pageToUpdate) && history.push(`${pathname}${search ? `${search}&isDraft=true` : "?isDraft=true"}`);
    };
    onWorkplanTemplateChange = ({ dispatch, template, ctx, token, workplanCardsOptions }) => {
      const pageToUpdate = updateWorkplanOptionsInPage({ template, options: _38.values(workplanCardsOptions) });
      switch (true) {
        case shouldSaveWorkplanTest(template, ctx):
          saveTestWorkplan({ pageId: _38.get("id", template), testContext: ctx, token });
          break;
        case shouldSaveWorkplanCardsOptions(template, ctx):
          saveWorkplanCardsOptions({
            pageId: _38.get("id", template),
            options: _38.values(workplanCardsOptions),
            token
          });
          break;
      }
      dispatch(
        setEntity({
          path: `pages.${_38.get("id", pageToUpdate)}`,
          entity: pageToUpdate
        })
      );
    };
    onDefaultTemplateChange = ({ dispatch, template, currentUser, history }) => {
      const isUpdating = !(template == null ? void 0 : template.isOriginal) && isPageOwner(template, currentUser);
      const pageToUpdate = getDraftFromTemplate(template, currentUser);
      isUpdating ? dispatch(
        setEntity({
          path: `pages.${_38.get("id", pageToUpdate)}`,
          entity: pageToUpdate
        })
      ) : dispatch(setEntities({ drafts: { [_38.get("id", pageToUpdate)]: pageToUpdate } }));
      return !isAlreadyOnDraftPage(history, pageToUpdate) && history.push(getPagePath2(_38.pick("slug", pageToUpdate), _38.pick("isDraft", pageToUpdate)));
    };
    onReadonlyTemplateChange = ({ dispatch, template, ctx }) => {
      if (_38.get("source", ctx) === "exercise") {
        dispatch(
          setEntity({
            path: `pages.${_38.get("id", template)}`,
            entity: template
          })
        );
      }
    };
    onTemplateChange = ({ dispatch, params = {}, history }) => {
      const {
        template,
        ctx,
        token,
        currentUser,
        workplanCardsOptions,
        readonly,
        hasExistingDraft,
        learningAssessmentStatsUuids
      } = params;
      if (!_38.has("id", template)) return;
      switch (true) {
        case template.id < 0:
          return onCreatedFromScratchTemplateChange({ dispatch, history, template, currentUser, hasExistingDraft });
        case (template == null ? void 0 : template.isPartOfSession):
          return onSessionTemplateChange({ dispatch, template, ctx, token, currentUser, learningAssessmentStatsUuids });
        case (template == null ? void 0 : template.isWorkplan):
          return onWorkplanTemplateChange({ dispatch, template, ctx, token, workplanCardsOptions });
        case readonly:
          return onReadonlyTemplateChange({ dispatch, template, ctx });
        default:
          return onDefaultTemplateChange({ dispatch, template, currentUser, history });
      }
    };
    onGoToEffect = ({ dispatch, history, params }) => tryCatch({ dispatch, history, params, effect: onGoTo, silent: true });
    onTemplateChangeEffect = ({ dispatch, params, history }) => tryCatch({ dispatch, params, effect: onTemplateChange, history, silent: true });
  }
});

// src/api/notification.js
import { normalizeData as normalizeData5 } from "@lls/store";
var updateMainNotification, updateDrawerNotification, updateCopyNotification;
var init_notification = __esm({
  "src/api/notification.js"() {
    "use strict";
    init_graphql();
    updateMainNotification = ({ token, notification }) => gqlNoCache({
      query: `mutation ($token: String!, $notification: NotificationInput) {
      viewer (token: $token) {
        updateMainNotification: updateNotification(notification: $notification) {
          id
          read
        }
      }
    }`,
      variables: {
        token,
        notification
      }
    }).then(normalizeData5);
    updateDrawerNotification = ({ token, notification }) => gqlNoCache({
      query: `mutation ($token: String!, $notification: NotificationInput) {
      viewer (token: $token) {
        updateDrawerNotification: updateNotification(notification: $notification) {
          id
          read
        }
      }
    }`,
      variables: {
        token,
        notification
      }
    }).then(normalizeData5);
    updateCopyNotification = ({ token, notification }) => gqlNoCache({
      query: `mutation ($token: String!, $notification: NotificationInput) {
      viewer (token: $token) {
        updateCopyNotification: updateNotification(notification: $notification) {
          id
          read
        }
      }
    }`,
      variables: {
        token,
        notification
      }
    }).then(normalizeData5);
  }
});

// src/constants/notification.js
var NOTIFICATION_TYPES;
var init_notification2 = __esm({
  "src/constants/notification.js"() {
    "use strict";
    NOTIFICATION_TYPES = {
      SHARED_PAGE_TYPE: "sharedPageType",
      CORRECTED_PAGE_TYPE: "correctedPageType",
      SHARED_CORRECTIONS_PAGE_TYPE: "sharedCorrectionsPageType",
      DRAWER_TYPE: "drawerType",
      COPY_TYPE: "copyType"
    };
  }
});

// src/effects/notification.js
var getMethodApiToUse, changeReadStatus, markNotificationAsRead, markNotificationAsNotRead, markNotificationAsReadEffect, markNotificationAsNotReadEffect;
var init_notification3 = __esm({
  "src/effects/notification.js"() {
    "use strict";
    init_actions();
    init_notification();
    init_notification2();
    init_utils3();
    getMethodApiToUse = (notification = {}) => {
      switch (notification.type) {
        case NOTIFICATION_TYPES.DRAWER_TYPE:
          return updateDrawerNotification;
        case NOTIFICATION_TYPES.COPY_TYPE:
          return updateCopyNotification;
        default:
          return updateMainNotification;
      }
    };
    changeReadStatus = async ({ readValue, notification = {}, token, dispatch }) => {
      const apiMethodToUse = getMethodApiToUse(notification);
      const { entities: entities2 } = await apiMethodToUse({
        token,
        notification: { id: notification.id, read: readValue }
      });
      dispatch(setEntities(entities2));
    };
    markNotificationAsRead = async ({ dispatch, params }) => changeReadStatus({ readValue: true, dispatch, ...params });
    markNotificationAsNotRead = async ({ dispatch, params }) => changeReadStatus({ readValue: false, dispatch, ...params });
    markNotificationAsReadEffect = ({ dispatch, params }) => tryCatch({ dispatch, silent: true, effect: markNotificationAsRead, params });
    markNotificationAsNotReadEffect = ({ dispatch, params }) => tryCatch({ dispatch, silent: true, effect: markNotificationAsNotRead, params });
  }
});

// src/constants/ui.js
var NAVBAR_HEIGHT, PRESENTATION_TOOLBAR_HEIGHT, READONLY_BANNER_HEIGHT;
var init_ui3 = __esm({
  "src/constants/ui.js"() {
    "use strict";
    NAVBAR_HEIGHT = typeof process.env.CORE_NAVBAR_HEIGHT === "undefined" ? 64 : Number.parseInt(process.env.CORE_NAVBAR_HEIGHT);
    PRESENTATION_TOOLBAR_HEIGHT = 64;
    READONLY_BANNER_HEIGHT = 126;
  }
});

// src/effects/trial.js
var openDisabledModal, subscribeToNewsletter2, openDisabledModalEffect, subscribeToNewsletterEffect;
var init_trial3 = __esm({
  "src/effects/trial.js"() {
    "use strict";
    init_actions();
    init_marketing2();
    init_constants();
    init_utils3();
    openDisabledModal = async ({ dispatch, params = {} }) => {
      dispatch(setModal({ name: MODAL_TRIAL_FEATURE_BLOCKED, open: true, data: { featureName: params.featureName } }));
    };
    subscribeToNewsletter2 = async ({ params: form }) => {
      const data = {
        email: form.email,
        firstname: form.firstname,
        lastname: form.lastname,
        source: form.source ?? "newsletter"
      };
      await subscribeToNewsletter(data);
    };
    openDisabledModalEffect = ({ dispatch, params }) => tryCatch({
      dispatch,
      params,
      effect: openDisabledModal,
      silent: true
    });
    subscribeToNewsletterEffect = ({ dispatch, params }) => tryCatch({ dispatch, params, effect: subscribeToNewsletter2 });
  }
});

// src/components/panorama/fixtures.js
var fixtures_exports = {};
__export(fixtures_exports, {
  PANORAMAS_DATA: () => PANORAMAS_DATA
});
var PANORAMAS_DATA;
var init_fixtures = __esm({
  "src/components/panorama/fixtures.js"() {
    "use strict";
    init_panorama();
    PANORAMAS_DATA = {
      // Chapitre 1
      0: {
        title: "Pr\xE9parer le chapitre 1",
        subtitle: `Le Manuel Premium s'enrichit de contenus num\xE9riques exclusifs, cr\xE9\xE9s avec les professeurs de la communaut\xE9, pour vous permettre de concevoir votre s\xE9quence id\xE9ale !`,
        stamp: "Nouveaut\xE9 : les ressources Premium",
        header: "https://assets.lls.fr/pages/55674209/his2de1bandeau.jpg",
        category: [
          {
            goal: RESOURCE_GOALS.COMMENCER,
            resourcesPack: [
              {
                id: 1,
                title: `Des id\xE9es pour s'inspirer`,
                shortDesc: "Le meilleur des ressources issues du web !",
                fullDesc: "Le meilleur des ressources issues du web : une s\xE9lection de vid\xE9os, articles, publications universitaires, romans, bandes dessin\xE9es\u2026",
                tags: ["Padlet enseignant"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Padlet,
                    id: "vne5ocxnsfqdi4xh"
                  }
                ]
              },
              {
                id: 2,
                title: "\xC0 la d\xE9couverte du chapitre 1",
                vignette: "https://assets.lls.fr/pages/57409137/ch01-vignette-intro.jpg",
                shortDesc: "Une vid\xE9o immersive pour introduire le chapitre.",
                fullDesc: "Une vid\xE9o immersive pour poser le contexte historique et introduire les grandes probl\xE9matiques du chapitre.",
                tags: ["Vid\xE9o"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/55674209/intro-ch1-v3.mp4"
                  }
                ]
              },
              {
                id: 3,
                title: `Galerie d'images pour ouvrir le chapitre`,
                vignette: "https://assets.lls.fr/pages/55674209/his2de1banque-icono.JPG",
                shortDesc: `Une s\xE9lection d'iconographies alternatives pour ouvrir le chapitre.`,
                fullDesc: `Une s\xE9lection d'iconographies alternatives pour ouvrir le chapitre. Pratique pour personnaliser votre manuel et varier les entr\xE9es d'une ann\xE9e \xE0 l'autre !`,
                tags: ["Images d\u2019ouverture"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Gallery,
                    items: [
                      {
                        legend: `Amphore d\u2019Ex\xE9kias, Combat entre Achille et Penth\xE9sil\xE9e, V\u1D49 si\xE8cle av. J.-C., British Museum, Londres.

                    Dans le r\xE9cit hom\xE9rique de la guerre de Troie, Penth\xE9sil\xE9e est la reine des amazones qui vient secourir Priam. Au moment de la tuer, Achille serait tomb\xE9 amoureux de Penth\xE9sil\xE9e, s\u2019effondrant finalement en larmes.`,
                        credit: "\xA9 NPL - DeA Picture Library / Bridgeman",
                        url: "https://assets.lls.fr/pages/55674209/lls-his2-ch1-icono1.JPG"
                      },
                      {
                        legend: `D\xE9tail d\u2019un vase, V\u1D49 si\xE8cle av. J.-C., British Museum, Londres.

                    Les sir\xE8nes, mi-femmes mi-oiseaux, attirent les marins par leur chant pour qu\u2019ils s\u2019\xE9chouent sur les c\xF4tes. Elles symbolisent les dangers bien r\xE9els de la navigation. Pour leur r\xE9sister, Ulysse demande \xE0 ses marins de l\u2019attacher au m\xE2t, pendant qu\u2019eux se bouchent les oreilles avec de la cire.`,
                        credit: "\xA9 AKG / Werner Forman",
                        url: "https://assets.lls.fr/pages/55674209/lls-his2-ch1-icono2.jpg"
                      },
                      {
                        legend: `Vue sur la colline de l\u2019Acropole.

                    Colline de 56 m de haut dominant la cit\xE9 d\u2019Ath\xE8nes. Le mot \xAB acropole \xBB deviendra commun, finissant par d\xE9signer toute citadelle construite sur le point le plus haut d\u2019une cit\xE9 grecque antique.`,
                        credit: "Christophe Meneboeuf / CC BY-SA 3.0 / Wikimedia",
                        url: "https://assets.lls.fr/pages/55674209/lls-his2-ch1-icono3.jpg"
                      },
                      {
                        legend: `Un peuple de navigateurs : le temple de Pos\xE9idon au cap Sounion (sud d\u2019Ath\xE8nes), Gr\xE8ce.

                    Pos\xE9idon est un dieu grec de la mer. Les Grecs fondent de nouvelles cit\xE9s tout autour de la M\xE9diterran\xE9e.`,
                        credit: "rawf8/Shutterstock",
                        url: "https://assets.lls.fr/pages/55674209/lls-his2-ch1-icono4.jpg"
                      },
                      {
                        legend: `Luisa Ricciarini, Ostraca retrouv\xE9s sur l\u2019Acropole en 482 av. J.-C., photographie, mus\xE9e de l\u2019Agora, Ath\xE8nes.

                    Ces tessons de poterie servaient d\u2019instruments pour la proc\xE9dure de l\u2019ostracisme durant la Gr\xE8ce antique. Si la gravure est utilis\xE9e dans l\u2019exemple ci-dessus, les ostraca peuvent \xEAtre aussi recouverts d\u2019encre. Le nom de Th\xE9mistocle, h\xE9ros de la bataille de Salamine, y figure.`,
                        credit: "Luisa Ricciarini / Bridgeman",
                        url: "https://assets.lls.fr/pages/55674209/lls-his2-ch1-icono5.JPG"
                      },
                      {
                        legend: `Le Forum romain, le c\u0153ur de la vie politique.

                    Le Forum est une grande place au centre de Rome. On y trouve la Curie, o\xF9 se r\xE9unit le S\xE9nat, une tribune pour prononcer des discours adress\xE9s aux citoyens, des arcs de triomphe qui c\xE9l\xE8brent les victoires de Rome et plusieurs temples, o\xF9 sont v\xE9n\xE9r\xE9s les dieux et les d\xE9esses.`,
                        credit: "EyeEm / Alamy",
                        url: "https://assets.lls.fr/pages/55674209/lls-his2-ch1-icono6.jpg"
                      },
                      {
                        legend: `Cam\xE9e en pierre d\u2019onyx, v. 19 apr. J.-C., mus\xE9e d\u2019Histoire de l\u2019art, Vienne.

                    Ce cam\xE9e ou pierre fine cisel\xE9e repr\xE9sente l\u2019un des triomphes germaniques de Tib\xE8re. Le divin Auguste, avec la couronne de laurier sur la t\xEAte, y appara\xEEt au centre sous les traits de Jupiter, un aigle est pos\xE9 \xE0 ses pieds. \xC0 ses c\xF4t\xE9s figure la personnification de Rome, qu\u2019il a sauv\xE9e de la guerre civile, portant le casque de l\u2019Ath\xE9na Parth\xE9nos. Tib\xE8re se situe tout en haut \xE0 gauche avec un b\xE2ton d\u2019augure dans sa main, ce qui annoncerait ses victoires \xE0 venir.`,
                        credit: "James Steakley / CC BY-SA 3.0 / Wikimedia",
                        url: "https://assets.lls.fr/pages/55674209/lls-his2-ch1-icono7.jpg"
                      },
                      {
                        legend: `L\u2019empereur Marc-Aur\xE8le proc\xE9dant \xE0 un sacrifice devant le temple de Jupiter \xE0 Rome, v. 161-180 apr. J.-C., bas-relief en marbre.

                    L\u2019empereur, accompagn\xE9 de la famille imp\xE9rial, proc\xE8de \xE0 un sacrifice en tenu de grand pontife (charge la plus \xE9lev\xE9e dans la religion romaine). C\u2019est apr\xE8s la mort d\u2019Auguste que tous les empereurs romains acqui\xE8rent ce titre.`,
                        credit: "Luisa Ricciarini / Bridgeman",
                        url: "https://assets.lls.fr/pages/55674209/lls-his2-ch1-icono8.JPG"
                      },
                      {
                        legend: `Le th\xE9\xE2tre de Sabratha, cit\xE9 romaine d\u2019Afrique.

                    Situ\xE9 en Afrique proconsulaire, c\u2019est-\xE0-dire la Libye actuelle, il est l\u2019un des plus grands th\xE9\xE2tres de l\u2019Afrique romaine. Il a \xE9t\xE9 d\xE9gag\xE9 et en partie restaur\xE9 entre 1927 et 1937.`,
                        credit: "Robert Preston Photography / Alamy",
                        url: "https://assets.lls.fr/pages/55674209/lls-his2-ch1-icono9.jpg"
                      },
                      {
                        legend: `Fresque de l\u2019<em>Isis Giminiana</em> trouv\xE9e \xE0 Ostie, II\u1D49 si\xE8cle apr. J.-C., biblioth\xE8que du Vatican.

                    Fresque montrant le chargement de grains par des esclaves. Arascantus est le r\xE9ceptionnaire de l\u2019annone (administration des greniers publics). Farnaces est le patron du navire. Le cadre dor\xE9 rappelle que cette fresque a \xE9t\xE9 d\xE9couverte en 1865 dans la n\xE9cropole de la via Laurentina \xE0 Ostie.`,
                        credit: "The Picture Art Collection / Alamy",
                        url: "https://assets.lls.fr/pages/55674209/lls-his2-ch1-icono10.jpg"
                      },
                      {
                        legend: `Combat entre des gladiateurs et des animaux sauvages, 320 apr. J.-C., mosa\xEFque, Galerie Borghese, Rome.

                    Lorsque des animaux sauvages affrontaient des gladiateurs, un syst\xE8me sp\xE9cial de protection des spectateurs \xE9tait install\xE9. La barricade form\xE9e de d\xE9fenses d\u2019\xE9l\xE9phants, les pointes dirig\xE9es vers le centre, \xE9tait compl\xE9t\xE9e par la surveillance d\u2019archers charg\xE9s de tirer sur les animaux qui menaceraient la foule.`,
                        credit: "Alinari / Bridgeman",
                        url: "https://assets.lls.fr/pages/55674209/lls-his2-ch1-icono11.JPG"
                      }
                    ]
                  }
                ]
              },
              {
                id: 4,
                title: "Des ressources pour amorcer votre s\xE9quence",
                vignette: "https://assets.lls.fr/pages/55674209/his2de1quiz-diagnostique.jpg",
                shortDesc: "Que savez-vous d\xE9j\xE0 sur... le chapitre 1 ?",
                fullDesc: "Un quiz diagnostique pour faire le point sur les connaissances des \xE9l\xE8ves et ouvrir le chapitre 1.",
                tags: ["Quiz diagnostique"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/55674209/lls-histoire-2nde-chapitre1-quiz-diagnostique-v3.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/55674209/lls-histoire-chapitre1-quiz-diagnostique.zip"
                  },
                  {
                    format: RESOURCE_FORMAT.ExternalLink,
                    url: "https://create.kahoot.it/share/que-savez-vous-deja-sur-la-mediterranee-antique-les-empreintes-grecques-et-romaines/58aebcc9-2589-49b5-9a52-a806b387219d"
                  }
                ]
              }
            ]
          },
          {
            goal: RESOURCE_GOALS.ETUDIER,
            resourcesPack: [
              {
                id: 5,
                title: `P\xE9ricl\xE8s et l'apog\xE9e de la d\xE9mocratie ath\xE9nienne`,
                vignette: "https://assets.lls.fr/pages/55674209/ch01-vignette-pericles.jpg",
                shortDesc: `Quelle est l'influence de P\xE9ricl\xE8s sur la d\xE9mocratie ath\xE9nienne ?`,
                fullDesc: "Une vid\xE9o pour retracer le parcours politique de P\xE9ricl\xE8s, figure politique qui a domin\xE9 la vie politique ath\xE9nienne pendant plus de 30 ans.",
                tags: ["Vid\xE9o"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/55674209/pericles-v3.mp4"
                  }
                ]
              },
              {
                id: 6,
                title: `Auguste et la naissance d'un nouveau r\xE9gime politique`,
                vignette: "https://assets.lls.fr/pages/55674209/ch08-vignette-auguste.jpg",
                shortDesc: `Comment Auguste contribue-t-il \xE0 la naissance d'un nouveau r\xE9gime politique ?`,
                fullDesc: `Une vid\xE9o pour d\xE9couvrir le parcours d'Auguste et la mise en place d'un nouveau r\xE9gime politique : l'Empire romain.`,
                tags: ["Vid\xE9o"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/55674209/auguste-v4.mp4"
                  }
                ]
              },
              {
                id: 7,
                title: `Constantin et la christianisation de l'Empire romain`,
                vignette: "https://assets.lls.fr/pages/55674209/ch01-vignette-constantin.jpg",
                shortDesc: `Comment Constantin parvient-il \xE0 assurer la stabilit\xE9 de l'Empire romain ?`,
                fullDesc: `Une vid\xE9o pour explorer les r\xE9formes entreprises par l'empereur Constantin, converti au christianisme, dans l'Empire romain. `,
                tags: ["Vid\xE9o"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/55674209/constantin-v2.mp4"
                  }
                ]
              }
            ]
          },
          {
            goal: RESOURCE_GOALS.EXPLORER,
            resourcesPack: [
              {
                id: 8,
                title: "Guerre et citoyennet\xE9 \xE0 Ath\xE8nes",
                vignette: "https://assets.lls.fr/pages/55674209/his2de1dossierpouvoir.jpg",
                shortDesc: "Pourquoi peut-on parler de \xAB citoyens-soldats \xBB \xE0 Ath\xE8nes ?",
                fullDesc: "Un dossier pour comprendre pourquoi guerre et citoyennet\xE9 sont deux \xE9l\xE9ments indissociables dans la soci\xE9t\xE9 ath\xE9nienne.",
                tags: ["Dossier exclusif"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/55674209/lls-histoire-2nde-chapitre1-dossier-guerrier.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "51594987"
                  }
                ]
              },
              {
                id: 9,
                title: "\xCAtre femme \xE0 Ath\xE8nes : le proc\xE8s de N\xE9\xE9ra",
                vignette: "https://assets.lls.fr/pages/55674209/his2de1dossierneera-2.jpg",
                shortDesc: "Quel danger repr\xE9sente N\xE9\xE9ra pour la soci\xE9t\xE9 et la d\xE9mocratie ath\xE9niennes ?",
                fullDesc: "Proposez \xE0 vos \xE9l\xE8ves de revivre le proc\xE8s intent\xE9 par deux Ath\xE9niens contre N\xE9\xE9ra, une ancienne esclave n\xE9e \xE0 Corinthe.",
                tags: ["Dossier exclusif"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/55674209/lls-histoire-2nde-chapitre1-dossier-femme.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "7454720"
                  }
                ]
              }
            ]
          },
          {
            goal: RESOURCE_GOALS.DIVERSIFIER,
            resourcesPack: [
              {
                id: 10,
                title: "Des ressources pour approfondir",
                shortDesc: "Pour les \xE9l\xE8ves, le meilleur des ressources issues du web !",
                fullDesc: "Pour les \xE9l\xE8ves, le meilleur des ressources issues du web : une s\xE9lection d\u2019articles, romans, podcasts, films, jeux vid\xE9o, BDs, photos\u2026",
                tags: ["Padlet \xE9l\xE8ve"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Padlet,
                    id: "7ciwwz6kdk5fxhqd"
                  }
                ]
              },
              {
                id: 11,
                title: "Choisir un dieu tut\xE9laire pour le futur empereur",
                vignette: "https://assets.lls.fr/pages/55674209/his2de1apprendre-autrementdieu.jpg",
                shortDesc: "D\xE9fendez votre divinit\xE9 aupr\xE8s de Caius C\xE9sar !",
                fullDesc: `Proposez \xE0 vos \xE9l\xE8ves de choisir une divinit\xE9, qu'ils auront \xE0 d\xE9fendre aupr\xE8s de Caius C\xE9sar... et de leurs concurrents !`,
                tags: ["Apprendre autrement"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/55674209/lls-histoire-2nde-chapitre1-apprendre-autrement-dieu.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "6359332"
                  }
                ]
              },
              {
                id: 12,
                title: "Le Parth\xE9non, une empreinte \xE9ternelle",
                vignette: "https://assets.lls.fr/pages/55674209/his2de1apprendre-autrementparthenon.JPG",
                shortDesc: `Faites d\xE9couvrir \xE0 vos \xE9l\xE8ves le caract\xE8re exceptionnel d'un monument c\xE9l\xE8bre, le Parth\xE9non.`,
                fullDesc: `Le Parth\xE9non domine l'Acropole d'Ath\xE8nes depuis plus de 2 000 ans. Pour saisir le caract\xE8re exceptionnel de cette long\xE9vit\xE9, embarquez vos \xE9l\xE8ves pour un voyage dans le temps...`,
                tags: ["Apprendre autrement"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/55674209/lls-histoire-2nde-chapitre1-apprendre-autrement-parthenon.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "51596247"
                  }
                ]
              },
              {
                id: 13,
                title: "Guerre civile et course au pouvoir",
                vignette: "https://assets.lls.fr/pages/55674209/his2de1apprendre-autrementguerre.JPG",
                shortDesc: "Jeux de pouvoir : qui deviendra le premier empereur romain ?",
                fullDesc: `\xAB C\xE9sar vient d'\xEAtre assassin\xE9 ! \xBB. Alors que ce cri r\xE9sonne dans tout Rome et que la R\xE9publique vacille, il va falloir s'imposer. En 44 av. J.-C., la course au pouvoir est lanc\xE9e...`,
                tags: ["Apprendre autrement"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/55674209/lls-histoire-2nde-chapitre1-apprendre-autrement-pouvoir.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "51596659"
                  }
                ]
              },
              {
                id: 14,
                title: "\xAB Ave C\xE9sar ! \xBB",
                shortDesc: "Retracez le parcours du premier empereur romain. ",
                fullDesc: `\xC0 partir des diff\xE9rentes statues d'Auguste, invitez vos \xE9l\xE8ves \xE0 retracer le parcours du premier empereur romain.`,
                tags: ["Activit\xE9 num\xE9rique"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "5df502430072300f62713b47"
                  }
                ]
              }
            ]
          },
          {
            goal: RESOURCE_GOALS.MEMORISER,
            resourcesPack: [
              {
                id: 15,
                title: "3 minutes pour r\xE9viser le chapitre 1",
                vignette: "https://assets.lls.fr/pages/6359335/histoire_2de_chap_1.png",
                shortDesc: "Une vid\xE9o pour r\xE9viser les points cl\xE9s du chapitre.",
                fullDesc: "Une vid\xE9o bilan pour r\xE9viser et m\xE9moriser les points cl\xE9s du chapitre 1.",
                tags: ["Vid\xE9o"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/6359335/histoire_2de_chap_1.mp4"
                  }
                ]
              },
              {
                id: 16,
                title: `L'essentiel du chapitre 1`,
                vignette: "https://assets.lls.fr/pages/55674209/his2de1memo-2.jpg",
                shortDesc: "Les notions cl\xE9s r\xE9unies dans le m\xE9mo du chapitre.",
                fullDesc: "Les notions cl\xE9s du chapitre 1 sont pr\xE9sent\xE9es visuellement pour faciliter la m\xE9morisation : carte mentale, frise, mots cl\xE9s...",
                tags: ["Le m\xE9mo"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/55674209/lls-histoire-2nde-chapitre1-memo.pdf"
                  }
                ]
              },
              {
                id: 17,
                title: `L'Eccl\xE9sia, socle de la d\xE9mocratie ath\xE9nienne`,
                vignette: "https://assets.lls.fr/pages/55674209/his2de1bd.png",
                shortDesc: "Une courte BD pour m\xE9moriser autrement.",
                fullDesc: "Une illustration retrace une notion cl\xE9 du chapitre pour permettre aux \xE9l\xE8ves de la m\xE9moriser autrement.",
                tags: ["Le chapitre en BD"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/55674209/lls-histoire-2nde-chapitre1-bd.pdf"
                  }
                ]
              }
            ]
          },
          {
            goal: RESOURCE_GOALS.ENTRAINER,
            resourcesPack: [
              {
                id: 18,
                title: `Qu'avez-vous appris sur... P\xE9ricl\xE8s ?`,
                vignette: "https://assets.lls.fr/pages/55674209/his2de1quizppo1-2.jpg",
                shortDesc: "Un quiz pour tester les \xE9l\xE8ves sur le point de passage n\xB0 1.",
                fullDesc: "Un quiz de r\xE9vision pour revenir sur le point de passage n\xB0 1 et tester les connaissances des \xE9l\xE8ves en vue de l\u2019\xE9valuation.",
                tags: ["Quiz - Point de passage"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/55674209/lls-histoire-2nde-chapitre1-quiz-ppo1.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "62542b71f034ad001115a0ff"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/55674209/lls-histoire-2nde-chapitre1-quiz-ppo1.zip"
                  },
                  {
                    format: RESOURCE_FORMAT.ExternalLink,
                    url: "https://create.kahoot.it/share/qu-avez-vous-appris-sur-pericles/f885a364-3930-4e4c-a862-a4daa875cfb8"
                  }
                ]
              },
              {
                id: 19,
                title: `Qu'avez-vous appris sur... Auguste ?`,
                vignette: "https://assets.lls.fr/pages/55674209/his2de1quizppo2-2.jpg",
                shortDesc: "Un quiz pour tester les \xE9l\xE8ves sur le point de passage n\xB0 2.",
                fullDesc: "Un quiz de r\xE9vision pour revenir sur le point de passage n\xB0 2 et tester les connaissances des \xE9l\xE8ves en vue de l\u2019\xE9valuation.",
                tags: ["Quiz - Point de passage"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/55674209/lls-histoire-2nde-chapitre1-quiz-ppo2.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "6256e727e6e0ac001163fe3d"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/55674209/lls-histoire-2nde-chapitre1-quiz-ppo2.zip"
                  },
                  {
                    format: RESOURCE_FORMAT.ExternalLink,
                    url: "https://create.kahoot.it/share/qu-avez-vous-appris-sur-auguste/b81c9805-9056-40a0-b98d-7c6c31c97e11"
                  }
                ]
              },
              {
                id: 20,
                title: `Qu'avez-vous appris sur... Constantin ?`,
                vignette: "https://assets.lls.fr/pages/55674209/his2de1quizppo3.jpg",
                shortDesc: "Un quiz pour tester les \xE9l\xE8ves sur le point de passage n\xB0 3.",
                fullDesc: "Un quiz de r\xE9vision pour revenir sur le point de passage n\xB03 et tester les connaissances des \xE9l\xE8ves en vue de l\u2019\xE9valuation.",
                tags: ["Quiz - Point de passage"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/55674209/lls-histoire-2nde-chapitre1-quiz-ppo3.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "6257f70717af9f001151c782"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/55674209/lls-histoire-2nde-chapitre1-quiz-ppo3.zip"
                  },
                  {
                    format: RESOURCE_FORMAT.ExternalLink,
                    url: "https://create.kahoot.it/share/qu-avez-vous-appris-sur-constantin/db3f3f84-8720-484c-9a1b-519154d4d914"
                  }
                ]
              },
              {
                id: 21,
                title: `Qu'avez-vous appris sur... le chapitre 1 ?`,
                vignette: "https://assets.lls.fr/pages/55674209/his2de1quiz-challenge-2.jpg",
                shortDesc: `Un quiz pour r\xE9viser l'ensemble du chapitre.`,
                fullDesc: `Un quiz complet pour rebrasser et r\xE9viser l'ensemble des notions phares du chapitre 1.`,
                tags: ["Challenge de r\xE9vision"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/55674209/lls-histoire-2nde-chapitre1-quiz-challenge.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "625421e6950db300136b5645"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/55674209/lls-histoire-2nde-chapitre1-quiz-challenge.zip"
                  }
                ]
              },
              {
                id: 22,
                title: "Petits meurtres antiques",
                vignette: "https://assets.lls.fr/pages/55674209/his2de1jeu-2.jpg",
                shortDesc: "Un jeu pour r\xE9viser les personnages cl\xE9s du chapitre.",
                fullDesc: "Un Cluedo pour r\xE9viser les personnages cl\xE9s du chapitre 1 de fa\xE7on ludique.",
                tags: ["Jeu"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/55674209/lls-histoire-2nde-chapitre1-cluedo.pdf"
                  }
                ]
              }
            ]
          }
        ]
      },
      // Chapitre 2
      1: {
        title: "Pr\xE9parer le chapitre 2",
        subtitle: `Le Manuel Premium s'enrichit de contenus num\xE9riques exclusifs, cr\xE9\xE9s avec les professeurs de la communaut\xE9, pour vous permettre de concevoir votre s\xE9quence id\xE9ale !`,
        stamp: "Nouveaut\xE9 : les ressources Premium",
        header: "https://assets.lls.fr/pages/57409137/his2de2pdp2carte-venise-remplacement-retouche.jpg",
        category: [
          {
            goal: RESOURCE_GOALS.COMMENCER,
            resourcesPack: [
              {
                id: 1,
                title: `Des id\xE9es pour s'inspirer`,
                shortDesc: "Le meilleur des ressources issues du web !",
                fullDesc: "Le meilleur des ressources issues du web : une s\xE9lection de vid\xE9os, articles, publications universitaires, romans, bandes dessin\xE9es\u2026",
                tags: ["Padlet enseignant"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Padlet,
                    id: "nsaqwijmvfbzfw4w"
                  }
                ]
              },
              {
                id: 2,
                title: "\xC0 la d\xE9couverte du chapitre 2",
                vignette: "https://assets.lls.fr/pages/57409137/hg2-ch02-vignette-intro.jpg",
                shortDesc: "Une vid\xE9o immersive pour introduire le chapitre.",
                fullDesc: "Une vid\xE9o immersive pour poser le contexte historique et introduire les grandes probl\xE9matiques du chapitre.",
                tags: ["Vid\xE9o"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/57409137/intro-ch2-v5.mp4"
                  }
                ]
              },
              {
                id: 3,
                title: `Galerie d'images pour ouvrir le chapitre`,
                vignette: "https://assets.lls.fr/pages/57409137/his2de2banque-icono.jpeg",
                shortDesc: `Une s\xE9lection d'iconographies alternatives pour ouvrir le chapitre.`,
                fullDesc: `Une s\xE9lection d'iconographies alternatives pour ouvrir le chapitre. Pratique pour personnaliser votre manuel et varier les entr\xE9es d'une ann\xE9e \xE0 l'autre !`,
                tags: ["Images d\u2019ouverture"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Gallery,
                    items: [
                      {
                        legend: `Atlas catalan, 1375.

                    Un portulan est un sorte de carte de navigation utilis\xE9e du XII\u1D49 au XVII\u1D49 si\xE8cle, servant essentiellement \xE0 rep\xE9rer les ports et conna\xEEtre les dangers qui peuvent les entourer : courants, hauts-fonds, etc. L\u2019Atlas catalan est un portulan du XIV\u1D49 si\xE8cle, r\xE9alis\xE9 vers 1375 et attribu\xE9 \xE0 Abraham Cresques, un cartographe juif majorquin de Palma, et \xE0 son fils Jehuda Cresques. Consid\xE9r\xE9 comme le chef d\u2019\u0153uvre de la cartographie du XIV\u1D49 si\xE8cle, il est aujourd\u2019hui conserv\xE9 \xE0 la Biblioth\xE8que Nationale de France.`,
                        credit: "Qasid/Wikimedia",
                        url: "https://assets.lls.fr/pages/57409137/lls-his2-ch2-icono1.jpeg"
                      },
                      {
                        legend: `Dieu couronne l\u2019empereur Nic\xE9phore III et Marie d\u2019Alanie, enluminure d\u2019un manuscrit des <em>Hom\xE9lies</em> de Jean Chrysostome, 1079, BnF, Paris.

                    La partie orientale de l\u2019Empire romain, o\xF9 l\u2019on parle grec, est demeur\xE9e un ensemble politique coh\xE9rent et riche, men\xE9 par un empereur qui pr\xE9tend \xEAtre le repr\xE9sentant de Dieu sur Terre.`,
                        credit: "Eugene a/Wikimedia",
                        url: "https://assets.lls.fr/pages/57409137/lls-his2-ch2-icono2.jpeg"
                      },
                      {
                        legend: "Al-Hariri (1054-1122), <em>Une biblioth\xE8que \xE0 Bassora, Al-Maq\xE2m\xE2t</em> (Les S\xE9ances), copi\xE9 et peint par al-W\xE2sil\xEE \xE0 Bagdad, 1236, Paris, BnF.",
                        credit: "Science History Images/Alamy",
                        url: "https://assets.lls.fr/pages/57409137/lls-his2-ch2-icono3.jpg"
                      },
                      {
                        legend: `Navire byzantin faisant usage du feu gr\xE9geois (un m\xE9lange inflammable), enluminure dans un manuscrit de la <em>Chronique</em> de Jean Skylitz\xE8s, v. 1150, BNE, Madrid.

                    Le feu gr\xE9geois est le nom donn\xE9 par les Occidentaux au produit inflammable utilis\xE9 par les Byzantins. Ceux-ci recourent \xE0 divers noms descriptifs pour le nommer, dont le plus commun est le feu liquide. La m\xE9thode la plus courante d\u2019utilisation est de le r\xE9pandre par un large tuyau de bronze sur les navires ennemis.`,
                        credit: "Niday Picture Library / Alamy",
                        url: "https://assets.lls.fr/pages/57409137/lls-his2-ch2-icono4.jpg"
                      },
                      {
                        legend: `Clerc, chevalier et paysan, miniature histori\xE9e dans un manuscrit du <em>R\xE9gime du corps</em> d\u2019Aldebrandin de Sienne, 1275, British Library, Londres.

                    La population est encadr\xE9e par une aristocratie guerri\xE8re qui s\u2019approprie l\u2019essentiel du pouvoir politique.`,
                        credit: "Historiograph/Wikimedia",
                        url: "https://assets.lls.fr/pages/57409137/lls-his2-ch2-icono5.jpg"
                      },
                      {
                        legend: `Saint Bernard pr\xEAche la II\u1D49 croisade \xE0 V\xE9zelay, 1146.

                    Saint Bernard, abb\xE9 de Clairvaux et conseiller des souverains, lance le jour de P\xE2ques 1146 (31 mars), sur la colline de V\xE9zelay en Bourgogne, un appel aux chevaliers et souverains d\u2019Occident. C'est le signal de ce que les historiens consid\xE8rent comme la deuxi\xE8me croisade.`,
                        credit: "Groupir/Wikimedia",
                        url: "https://assets.lls.fr/pages/57409137/lls-his2-ch2-icono6.jpeg"
                      },
                      {
                        legend: `Templiers allant au combat, fresque de la chapelle de Cressac.

                    Fond\xE9 par quelques crois\xE9s en Terre Sainte, l\u2019ordre des Templiers, ou des moines combattants, est approuv\xE9 par le roi de J\xE9rusalem Baudouin II. Avec l\u2019appui de Bernard de Clairvaux, leur r\xE8gle cistercienne, tr\xE8s stricte, o\xF9 se m\xEAlent id\xE9al chevaleresque et id\xE9al monastique, est bient\xF4t approuv\xE9e et publi\xE9e par le Concile de Troyes (1128).`,
                        credit: "GRANGER - Historical Picture Archvie/Alamy",
                        url: "https://assets.lls.fr/pages/57409137/lls-his2-ch2-icono7.jpg"
                      },
                      {
                        legend: `Vue des douanes \xE0 Venise, <em>Codex Maggi (Voyage de Charles Magius)</em>, 1578, manuscrit \xE0 peinture, BnF, Estampes et Photographie.

                    Secr\xE9taire de la R\xE9publique s\xE9r\xE9nissime de Venise, Charles Magius (mort en 1587) accomplit diverses missions dans le bassin m\xE9diterran\xE9en oriental dans les ann\xE9es pr\xE9c\xE9dant la guerre contre l'Empire Ottoman. Ses tribulations sont relat\xE9es dans un manuscrit dat\xE9 de 1578 comprenant dix-huit pages de peinture.`,
                        credit: "Wikimedia",
                        url: "https://assets.lls.fr/pages/57409137/lls-his2-ch2-icono8.jpeg"
                      }
                    ]
                  }
                ]
              },
              {
                id: 4,
                title: "Que savez-vous d\xE9j\xE0 sur... le chapitre 2 ?",
                vignette: "https://assets.lls.fr/pages/57409137/his2de2quiz-diagnostique.jpg",
                shortDesc: "Un quiz diagnostique pour ouvrir le chapitre.",
                fullDesc: "Un quiz diagnostique pour faire le point sur les connaissances des \xE9l\xE8ves et ouvrir le chapitre 2.",
                tags: ["Quiz diagnostique"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/57409137/lls-histoire-2nde-chapitre2-quiz-diagnostique.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.ExternalLink,
                    url: "https://create.kahoot.it/share/que-savez-vous-deja-sur-la-mediterranee-medievale/d08b6e7c-2d5e-4c1a-8d94-6e096b347097"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/57409137/lls-histoire-2nde-chapitre2-quiz-diagnostique.zip"
                  }
                ]
              }
            ]
          },
          {
            goal: RESOURCE_GOALS.ETUDIER,
            resourcesPack: [
              {
                id: 5,
                title: "Bernard de Clairvaux et la deuxi\xE8me croisade (1146-1149)",
                vignette: "https://assets.lls.fr/pages/57409137/hg2-ch02-vignette-bernard.jpg",
                shortDesc: "Quel r\xF4le a jou\xE9 Bernard de Clairvaux lors de la deuxi\xE8me croisade ?",
                fullDesc: "Une vid\xE9o pour d\xE9couvrir ce que la deuxi\xE8me croisade nous apprend sur les relations entre les diff\xE9rentes soci\xE9t\xE9s m\xE9diterran\xE9ennes.",
                tags: ["Vid\xE9o"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/57409137/bernard-v3.mp4"
                  }
                ]
              },
              {
                id: 6,
                title: "Venise, grande puissance maritime et commerciale",
                vignette: "https://assets.lls.fr/pages/57409137/hg2-ch02-vignette-venise.jpg",
                shortDesc: "En quoi Venise est-elle une grande puissance maritime et commerciale ?",
                fullDesc: `Une vid\xE9o pour d\xE9couvrir la s\xE9r\xE9nissime r\xE9publique de Venise et comprendre comment son empire commercial met en contact une grande diversit\xE9 d'hommes et de marchandises dans la M\xE9diterran\xE9e m\xE9di\xE9vale.`,
                tags: ["Vid\xE9o"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/57409137/venise-v3.mp4"
                  }
                ]
              }
            ]
          },
          //     {
          //       id: 7,
          //       title: `1712 - Thomas Newcomen met au point une machine à vapeur`,
          //       vignette: `https://assets.lls.fr/pages/51799365/hg2-ch07-vignette-newcomen.jpg`,
          //       shortDesc: `En quoi la machine à vapeur de Thomas Newcomen est-elle une innovation technique ?`,
          //       fullDesc: `Une vidéo pour comprendre le fonctionnement de la machine à vapeur de Thomas Newcomen et son importance.`,
          //       tags: [`Vidéo`],
          //       resources: [
          //         {
          //           format: RESOURCE_FORMAT.Video,
          //           url: `https://assets.lls.fr/pages/51799365/thomas-newcomen-v3.mp4`
          //         }
          //       ]
          //     }
          //   ]
          // },
          {
            goal: RESOURCE_GOALS.EXPLORER,
            resourcesPack: [
              {
                id: 7,
                title: "Les communaut\xE9s juives en M\xE9diterran\xE9e",
                vignette: "https://assets.lls.fr/pages/57409137/his2de2communaute.png",
                shortDesc: "Comment vivent les communaut\xE9s juives en M\xE9diterran\xE9e ?",
                fullDesc: "Une plong\xE9e dans les communaut\xE9s juives m\xE9di\xE9vales.",
                tags: ["Dossier exclusif"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/57409137/lls-histoire-2nde-chapitre2-dossier-communaute.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "56790140"
                  }
                ]
              },
              {
                id: 8,
                title: "Les m\xE9decins en M\xE9diterran\xE9e m\xE9di\xE9vale",
                vignette: "https://assets.lls.fr/pages/57409137/his2de2medecin.png",
                shortDesc: "Pourquoi les m\xE9decins sont consid\xE9r\xE9s comme des acteurs importants en M\xE9diterran\xE9e m\xE9di\xE9vale ?",
                fullDesc: "Un dossier pour d\xE9couvrir et explorer la m\xE9decine m\xE9di\xE9vale et notamment le r\xF4le des m\xE9decins, acteurs importants des transferts culturels entre les diff\xE9rentes civilisations.",
                tags: ["Dossier exclusif"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/57409137/lls-histoire-2nde-chapitre2-dossier-medecin.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "56799819"
                  }
                ]
              },
              {
                id: 9,
                title: "Palerme, capitale multiculturelle",
                vignette: "https://assets.lls.fr/pages/57409137/his2de2palerme.jpg",
                shortDesc: "Comment les rois normands de Siciles promeuvent-ils une culture \xE0 la crois\xE9e de plusieurs mondes ?",
                fullDesc: `Ce dossier propose d'explorer Palerme, capitale multiculturelle o\xF9 les cultures occidentales et orientales se recontrent et s'influencent.`,
                tags: ["Dossier exclusif"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/57409137/lls-histoire-2nde-chapitre2-dossier-palerme.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "7703776"
                  }
                ]
              }
            ]
          },
          {
            goal: RESOURCE_GOALS.DIVERSIFIER,
            resourcesPack: [
              {
                id: 10,
                title: "Des ressources pour approfondir",
                shortDesc: "Pour les \xE9l\xE8ves, le meilleur des ressources issues du web !",
                fullDesc: "Pour les \xE9l\xE8ves, le meilleur des ressources issues du web : une s\xE9lection d\u2019articles, romans, podcasts, films, jeux vid\xE9o, BDs, photos\u2026",
                tags: ["Padlet \xE9l\xE8ve"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Padlet,
                    id: "94sffmdqpzfxuiyi"
                  }
                ]
              },
              {
                id: 11,
                title: "R\xE9aliser une carte de la M\xE9diterran\xE9e",
                vignette: "https://assets.lls.fr/pages/57409137/his2de2aa-carte.jpg",
                shortDesc: "R\xE9alisez une carte de la m\xE9diterran\xE9e pour le roi de Sicile !",
                fullDesc: `Donnez l'opportunit\xE9 \xE0 vos \xE9l\xE8ves de devenir g\xE9ographes en r\xE9alisant une carte de la M\xE9diterran\xE9e m\xE9di\xE9vale pour Roger II, roi de Sicile.`,
                tags: ["Apprendre autrement"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/57409137/lls-histoire-2nde-chapitre2-apprendre-autrement-carte.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "56800443"
                  }
                ]
              },
              {
                id: 12,
                title: "Les villes du monde m\xE9diterran\xE9en",
                vignette: "https://assets.lls.fr/pages/57409137/his2de2aa-ville.jpg",
                shortDesc: `Aidez le roi d'Aragon \xE0 cr\xE9er un nouveau port sur l'\xEEle de Malte !`,
                fullDesc: `Invitez vos \xE9l\xE8ves \xE0 se mettre dans la peau d'un fonctionnaire au service du roi d'Aragon, et \xE0 l'aider \xE0 cr\xE9er un nouveau port sur l'\xEEle de Malte.`,
                tags: ["Apprendre autrement"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/57409137/lls-histoire-2nde-chapitre2-apprendre-autrement-ville.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "56379555"
                  }
                ]
              },
              {
                id: 13,
                title: "Explorez la Venise m\xE9di\xE9vale !",
                shortDesc: `Explorez la Venise m\xE9di\xE9vale \xE0 travers le regard d'un marchand de l'\xE9poque.`,
                fullDesc: `Invitez vos \xE9l\xE8ves \xE0 se mettre dans la peau d'un fonctionnaire au service du roi d'Aragon, et \xE0 l'aider \xE0 cr\xE9er un nouveau port sur l'\xEEle de Malte.`,
                tags: ["Activit\xE9 num\xE9rique"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "5e1848589e64014072935256"
                  }
                ]
              },
              {
                id: 14,
                title: `Les apports de l'arch\xE9ologie`,
                vignette: "https://assets.lls.fr/pages/57409137/his2de2atelier-de-clio.jpg",
                shortDesc: `Quels sont les apports de l'arch\xE9ologie ?`,
                fullDesc: `Une activit\xE9 pour permettre \xE0 vos \xE9l\xE8ves d'en conna\xEEtre davantage sur l'arch\xE9ologie !`,
                tags: ["Atelier de Clio"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/57409137/lls-histoire-2nde-chapitre2-atelier-de-clio.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "6387996"
                  }
                ]
              }
            ]
          },
          {
            goal: RESOURCE_GOALS.MEMORISER,
            resourcesPack: [
              {
                id: 15,
                title: "3 minutes pour r\xE9viser le chapitre 2",
                vignette: "https://assets.lls.fr/pages/57409137/his2de2revision.png",
                shortDesc: "Une vid\xE9o pour r\xE9viser les points cl\xE9s du chapitre.",
                fullDesc: "Une vid\xE9o bilan pour r\xE9viser et m\xE9moriser les points cl\xE9s du chapitre 2.",
                tags: ["Vid\xE9o"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/6388001/histoire2dechap2final.mp4"
                  }
                ]
              },
              {
                id: 16,
                title: `L'essentiel du chapitre 2`,
                vignette: "https://assets.lls.fr/pages/57409137/his2de2memo.jpg",
                shortDesc: "Les notions cl\xE9s r\xE9unies dans le m\xE9mo du chapitre.",
                fullDesc: "Les notions cl\xE9s du chapitre 2 sont pr\xE9sent\xE9es visuellement pour faciliter la m\xE9morisation : carte mentale, frise, mots cl\xE9s...",
                tags: ["Le m\xE9mo"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/57409137/lls-histoire-2nde-chapitre2-memo.pdf"
                  }
                ]
              },
              {
                id: 17,
                title: `La M\xE9diterran\xE9e m\xE9di\xE9vale : carrefour de biens, d'id\xE9es, de personnes`,
                vignette: "https://assets.lls.fr/pages/57409137/his2de2bd.png",
                shortDesc: "Une courte bande dessin\xE9e pour m\xE9moriser autrement.",
                fullDesc: "Une illustration retrace une notion cl\xE9 du chapitre pour permettre aux \xE9l\xE8ves de la m\xE9moriser autrement.",
                tags: ["Le chapitre en BD"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/57409137/lls-histoire-2nde-chapitre2-bd.pdf"
                  }
                ]
              }
            ]
          },
          {
            goal: RESOURCE_GOALS.ENTRAINER,
            resourcesPack: [
              {
                id: 18,
                title: `Qu'avez-vous appris sur... Bernard de Clairvaux ?`,
                vignette: "https://assets.lls.fr/pages/57409137/his2de2quiz-pdp1.jpg",
                shortDesc: "Un quiz pour tester les \xE9l\xE8ves sur le point de passage n\xB0 1.",
                fullDesc: "Un quiz de r\xE9vision pour revenir sur le point de passage n\xB0 1 et tester les connaissances des \xE9l\xE8ves en vue de l\u2019\xE9valuation.",
                tags: ["Quiz - Point de passage"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/57409137/lls-histoire-2nde-chapitre2-quiz-ppo1.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "627e0669ea909b00182f4a8d"
                  },
                  {
                    format: RESOURCE_FORMAT.ExternalLink,
                    url: "https://create.kahoot.it/share/quavez-vous-appris-sur-bernard-de-clairvaux/60deccf4-3169-4ba7-abbb-308661b8bca2"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/57409137/lls-histoire-2nde-chapitre2-quiz-ppo1.zip"
                  }
                ]
              },
              {
                id: 19,
                title: `Qu'avez-vous appris sur... Venise ?`,
                vignette: "https://assets.lls.fr/pages/57409137/his2de2quiz-pdp2.jpg",
                shortDesc: "Un quiz pour tester les \xE9l\xE8ves sur le point de passage n\xB0 2.",
                fullDesc: "Un quiz de r\xE9vision pour revenir sur le point de passage n\xB0 2 et tester les connaissances des \xE9l\xE8ves en vue de l\u2019\xE9valuation.",
                tags: ["Quiz - Point de passage"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/57409137/lls-histoire-2nde-chapitre2-quiz-ppo2.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "627e0b21ea909b00182f6475"
                  },
                  {
                    format: RESOURCE_FORMAT.ExternalLink,
                    url: "https://create.kahoot.it/share/quavez-vous-appris-sur-venise/28344335-acd1-4a76-8da5-7d21380086c5"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/57409137/lls-histoire-2nde-chapitre2-quiz-ppo2.zip"
                  }
                ]
              },
              {
                id: 20,
                title: `Qu'avez-vous appris sur... le chapitre 2 ?`,
                vignette: "https://assets.lls.fr/pages/57409137/his2de2quiz-challenge.jpg",
                shortDesc: `Un quiz pour r\xE9viser l'ensemble du chapitre.`,
                fullDesc: `Un quiz complet pour rebrasser et r\xE9viser l'ensemble des notions phares du chapitre 2.`,
                tags: ["Challenge de r\xE9vision"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/57409137/lls-histoire-2nde-chapitre2-quiz-challenge.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "627bce306c5304001192c813"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/57409137/lls-histoire-2nde-chapitre2-quiz-challenge.zip"
                  }
                ]
              },
              {
                id: 21,
                title: "\xAB Trivial Pursuit \xBB",
                vignette: "https://assets.lls.fr/pages/57409137/his2de2jeu.jpg",
                shortDesc: "Un jeu pour r\xE9viser la totalit\xE9 du chapitre.",
                fullDesc: `Un jeu de \xAB Trivial Pursuit \xBB pour r\xE9viser l'ensemble du chapitre de fa\xE7on ludique.`,
                tags: ["Jeu"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/57409137/lls-histoire-2nde-chapitre2-jeu.pdf"
                  }
                ]
              }
            ]
          }
        ]
      },
      // Chapitre 3
      2: {
        title: "Pr\xE9parer le chapitre 3",
        subtitle: `Le Manuel Premium s'enrichit de contenus num\xE9riques exclusifs, cr\xE9\xE9s avec les professeurs de la communaut\xE9, pour vous permettre de concevoir votre s\xE9quence id\xE9ale !`,
        stamp: "Nouveaut\xE9 : les ressources Premium",
        header: "https://assets.lls.fr/pages/54036965/bandeau-header-chapitre-3.jpg",
        category: [
          {
            goal: RESOURCE_GOALS.COMMENCER,
            resourcesPack: [
              {
                id: 1,
                title: `Des id\xE9es pour s'inspirer`,
                shortDesc: "Le meilleur des ressources issues du web !",
                fullDesc: "Le meilleur des ressources issues du web : une s\xE9lection de vid\xE9os, articles, publications universitaires, romans, bandes dessin\xE9es\u2026",
                tags: ["Padlet enseignant"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Padlet,
                    id: "9ftlhh8ov1i96r0w"
                  }
                ]
              },
              {
                id: 2,
                title: "\xC0 la d\xE9couverte du chapitre 3",
                vignette: "https://assets.lls.fr/pages/54036965/vignette-introch3.jpg",
                shortDesc: "Une vid\xE9o immersive pour introduire le chapitre.",
                fullDesc: "Une vid\xE9o immersive pour poser le contexte historique et introduire les grandes probl\xE9matiques du chapitre.",
                tags: ["Vid\xE9o"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/54036965/intro-ch3-v3.mp4"
                  }
                ]
              },
              {
                id: 3,
                title: `Galerie d'images pour ouvrir le chapitre`,
                vignette: "https://assets.lls.fr/pages/54036965/lls-his2-ch3-icono10.jpg",
                shortDesc: `Une s\xE9lection d'iconographies alternatives pour ouvrir le chapitre.`,
                fullDesc: `Une s\xE9lection d'iconographies alternatives pour ouvrir le chapitre. Pratique pour personnaliser votre manuel et varier les entr\xE9es d'une ann\xE9e \xE0 l'autre !`,
                tags: ["Images d\u2019ouverture"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Gallery,
                    items: [
                      {
                        legend: "Convoi d\u2019argent quittant les mines de Potosi au P\xE9rou, gravure de Th\xE9odore de Bry, fin du XVI\u1D49 si\xE8cle.",
                        credit: "Alpha Stock/Alamy",
                        url: "https://assets.lls.fr/pages/54036965/lls-his2-ch3-icono1.jpg"
                      },
                      {
                        legend: "Magellan entre dans l\u2019oc\xE9an Pacifique, gravure de Th\xE9odore de Bry, fin du XVI\u1D49 si\xE8cle.",
                        credit: "The Granger Collection/Alamy",
                        url: "https://assets.lls.fr/pages/54036965/lls-his2-ch3-icono2.jpg"
                      },
                      {
                        legend: "L\u2019Am\xE9rique du Nord, d\xE9tail de la carte de Pierre Desceliers, 1544, British Library, Londres.",
                        credit: "World History Archive/Alamy",
                        url: "https://assets.lls.fr/pages/54036965/lls-his2-ch3-icono3.jpg"
                      },
                      {
                        legend: `Constantin Brumidi, 1876, huile sur pl\xE2tre, aile du S\xE9nat, Capitole des \xC9tats-Unis.

                    Bartolom\xE9 de Las Casas assis \xE0 son bureau en compagnie d'un Indien, regardant par la fen\xEAtre les peuples indig\xE8nes dont il d\xE9nonce l'asservissement.`,
                        credit: "Matanya/Wikimedia",
                        url: "https://assets.lls.fr/pages/54036965/lls-his2-ch3-icono4.jpg"
                      },
                      {
                        legend: "C\xE9r\xE9monie sacrificielle azt\xE8que, <em>Codex Magliabechiano</em>, milieu du XVI\u1D49 si\xE8cle.",
                        credit: "El Comandante/Wikimedia",
                        url: "https://assets.lls.fr/pages/54036965/lls-his2-ch3-icono5.jpg"
                      },
                      {
                        legend: "La conqu\xEAte de Tenochtitl\xE1n par Cort\xE8s, peintre anonyme, XVII\u1D49 si\xE8cle, Library of Congress, Washington.",
                        credit: "Art Collection 2/Alamy",
                        url: "https://assets.lls.fr/pages/54036965/lls-his2-ch3-icono6.jpg"
                      },
                      {
                        legend: "Arriv\xE9e de marchands portugais au Japon,  XVII\u1D49 si\xE8cle, paravent laqu\xE9 de style <em>nanban</em>, collection priv\xE9e.",
                        credit: `Christie's Images/Bridgeman`,
                        url: "https://assets.lls.fr/pages/54036965/lls-his2-ch3-icono7.jpg"
                      },
                      {
                        legend: `Johannes Blaeu, carte montrant une plantation sucri\xE8re au Br\xE9sil dans l'\xC9tat du Pernambouc, 1663.`,
                        credit: "OlafJanssen/Wikimedia",
                        url: "https://assets.lls.fr/pages/54036965/lls-his2-ch3-icono8.jpg"
                      },
                      {
                        legend: "Escarmouche \xE0 Bloody Point, aquarelle d\u2019apr\xE8s un dessin de John White, 1585-1593, British Museum, Londres.",
                        credit: "The Print Collector /Alamy",
                        url: "https://assets.lls.fr/pages/54036965/lls-his2-ch3-icono9.jpg"
                      },
                      {
                        legend: `Alonso S\xE1nchez Coello, <em>Vue de S\xE9ville</em>, v. 1576-1600, mus\xE9e des Am\xE9riques, Madrid, Espagne.

                    Le premier plan met en \xE9vidence la grande activit\xE9 du port s\xE9villan avec les chantiers navals o\xF9 les navires destin\xE9s \xE0 la navigation atlantique \xE9taient r\xE9par\xE9s et construits. En arri\xE8re-plan, la ville, o\xF9 se trouvait la <em>Casa de Contrataci\xF3n</em> depuis 1503.`,
                        credit: "WHPics/Alamy",
                        url: "https://assets.lls.fr/pages/54036965/lls-his2-ch3-icono10.jpg"
                      }
                    ]
                  }
                ]
              },
              {
                id: 4,
                title: "Que savez-vous d\xE9j\xE0 sur... le chapitre 3 ?",
                vignette: "https://assets.lls.fr/pages/54036965/his2de3quiz-diagnostic.jpg",
                shortDesc: "Un quiz diagnostique pour ouvrir le chapitre.",
                fullDesc: "Un quiz diagnostique pour faire le point sur les connaissances des \xE9l\xE8ves et ouvrir le chapitre 3.",
                tags: ["Quiz diagnostique"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/54036965/lls-histoire-2nde-chapitre3-quiz-diagnostique.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.ExternalLink,
                    url: "https://create.kahoot.it/share/que-savez-vous-deja-sur-louverture-atlantique-et-les-consequences-des-grandes-decouvertes/74d29523-706e-4616-a770-0b86188405e1"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/54036965/lls-histoire-chapitre3-quiz-diagnostique.zip"
                  }
                ]
              }
            ]
          },
          {
            goal: RESOURCE_GOALS.ETUDIER,
            resourcesPack: [
              {
                id: 5,
                title: "Bartolom\xE9 de Las Casas et la controverse de Valladolid (1550)",
                vignette: "https://assets.lls.fr/pages/54036965/vignette-bartolome.jpg",
                shortDesc: "Quelle est la position intellectuelle de Bartolom\xE9 de Las Casas sur le sort des Am\xE9rindiens ?",
                fullDesc: "Une vid\xE9o pour revivre le d\xE9bat entre Bartolom\xE9 de Las Casas et Gin\xE9s de Sep\xFAlveda qui se d\xE9roule \xE0 Valladolid en 1550.",
                tags: ["Vid\xE9o"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/54036965/bartolome-v3.mp4"
                  }
                ]
              },
              {
                id: 6,
                title: `Au Br\xE9sil et dans les \xEEles carib\xE9ennes, la naissance de l'\xE9conomie sucri\xE8re et de l'esclavage`,
                vignette: "https://assets.lls.fr/pages/54036965/vignette-bresil.jpg",
                shortDesc: `Comment le d\xE9veloppement d'une \xE9conomie sucri\xE8re entra\xEEne-t-il la syst\xE9matisation de l'esclavage africain ?`,
                fullDesc: "Une vid\xE9o pour comprendre en quoi les conditions de travail d\xE9sastreuses dans les plantations sucri\xE8res entra\xEEnent le d\xE9veloppement de la traite atlantique.",
                tags: ["Vid\xE9o"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/54036965/bresil-vf.mp4"
                  }
                ]
              },
              {
                id: 7,
                title: `L'or et l'argent des Am\xE9riques \xE0 l'Europe`,
                vignette: "https://assets.lls.fr/pages/54036965/vignette-orargent.jpg",
                shortDesc: "Quels sont les routes et les effets de la circulation des m\xE9taux am\xE9ricains au XVI\u1D49 si\xE8cle ?",
                fullDesc: `Une vid\xE9o pour retracer la route des m\xE9taux pr\xE9cieux, des mines d'or et d'argent de Potosi et de Saint-Domingue, aux gallions espagnols allant vers les Philippines, l'Europe ou l'Asie.`,
                tags: ["Vid\xE9o"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/54036965/or-et-argent-v3.mp4"
                  }
                ]
              }
            ]
          },
          {
            goal: RESOURCE_GOALS.EXPLORER,
            resourcesPack: [
              {
                id: 8,
                title: "Fran\xE7ais et Anglais en Am\xE9rique du Nord",
                vignette: "https://assets.lls.fr/pages/54036965/hist2de3dossier-francais.jpg",
                shortDesc: `En quoi les exp\xE9ditions en Am\xE9rique du Nord permettent-elles \xE0 la France et \xE0 l'Angleterre de devenir des puissances coloniales ?`,
                fullDesc: `Un dossier pour permettre \xE0 vos \xE9l\xE8ves de plonger au c\u0153ur des principales exp\xE9ditions fran\xE7aises et anglaises et de comprendre comment l'Angleterre et la France sont devenues des puissances coloniales.`,
                tags: ["Dossier exclusif"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/54036965/lls-histoire-2nde-chapitre-3-dossier-fr-anglais.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "57897077"
                  }
                ]
              },
              {
                id: 9,
                title: "La d\xE9couverte du Japon par les Europ\xE9ens",
                vignette: "https://assets.lls.fr/pages/54036965/hist2de3dossier-japon.jpg",
                shortDesc: "Dans quelle mesure le Japon du XVI\u1D49 si\xE8cle est-il int\xE9gr\xE9 \xE0 la premi\xE8re mondialisation ?",
                fullDesc: `Un dossier pour d\xE9couvrir un territoire inconnu des Europ\xE9ens jusqu'au milieu du XVI\u1D49 si\xE8cle : le Japon.`,
                tags: ["Dossier exclusif"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/54036965/lls-histoire-2nde-chapitre3-dossier-japon.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "57865393"
                  }
                ]
              }
            ]
          },
          {
            goal: RESOURCE_GOALS.DIVERSIFIER,
            resourcesPack: [
              {
                id: 10,
                title: "Des ressources pour approfondir",
                shortDesc: "Pour les \xE9l\xE8ves, le meilleur des ressources issues du web !",
                fullDesc: "Pour les \xE9l\xE8ves, le meilleur des ressources issues du web : une s\xE9lection d\u2019articles, romans, podcasts, films, jeux vid\xE9o, BDs, photos\u2026",
                tags: ["Padlet \xE9l\xE8ve"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Padlet,
                    id: "le74zk87zpw0hgb"
                  }
                ]
              },
              {
                id: 11,
                title: "Les m\xE9moires de la conqu\xEAte et de la colonisation des Am\xE9riques",
                vignette: "https://assets.lls.fr/pages/54036965/hist2de3app-autrementmonument-colon.jpg",
                shortDesc: "Analysez sous diff\xE9rents angles la m\xE9moire des \xAB grandes d\xE9couvertes \xBB.",
                fullDesc: `Le d\xE9barquement de Christophe Colomb est consid\xE9r\xE9 comme un jalon incontournable de l'humanit\xE9. Pourtant les cons\xE9quences de la conqu\xEAte et de la colonisation des Am\xE9riques suscitent de nombreuses critiques et des conflits. Faites d\xE9couvrir \xE0 vos \xE9l\xE8ves la mani\xE8re dont cette p\xE9riode est per\xE7ue en Europe, en Asie, en Am\xE9rique et en Afrique.`,
                tags: ["Apprendre autrement"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/54036965/lls-histoire-2nde-chapitre3-apprendre-autrement-decouvertes.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "57897110"
                  }
                ]
              },
              {
                id: 12,
                title: `Des grandes d\xE9couvertes \xE0 l'histoire globale`,
                vignette: "https://assets.lls.fr/pages/54036965/his2de3cliocarte-iles-aux-epices-retouche.jpg",
                shortDesc: `Qu'est-ce que l'histoire globale ?`,
                fullDesc: `Un dossier original pour \xE9tudier l'histoire globale avec l'historien Romain Bertrand.`,
                tags: ["Atelier de Clio"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/54036965/lls-histoire-2nde-chapitre3-atelier-de-clio.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "6450532"
                  }
                ]
              },
              {
                id: 13,
                title: `\xC0 la conqu\xEAte de l'Eldorado !`,
                shortDesc: `Partez \xE0 la recherche de la myst\xE9rieuse cit\xE9 d'or !`,
                fullDesc: `Partez \xE0 la recherche de la myst\xE9rieuse cit\xE9 d'or et racontez votre p\xE9riple.`,
                tags: ["Activit\xE9 num\xE9rique"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "5e189d63753abd1738f07aa3"
                  }
                ]
              }
            ]
          },
          {
            goal: RESOURCE_GOALS.MEMORISER,
            resourcesPack: [
              {
                id: 14,
                title: "3 minutes pour r\xE9viser le chapitre 3",
                vignette: "https://assets.lls.fr/pages/54036965/his2de3revision.png",
                shortDesc: "Une vid\xE9o pour r\xE9viser les points cl\xE9s du chapitre.",
                fullDesc: "Une vid\xE9o bilan pour r\xE9viser et m\xE9moriser les points cl\xE9s du chapitre 3.",
                tags: ["Vid\xE9o"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/6450906/REV_ch3.mp4"
                  }
                ]
              },
              {
                id: 15,
                title: `L'essentiel du chapitre 3`,
                vignette: "https://assets.lls.fr/pages/54036965/his2de3ouvcarte-atlas-miller.jpg",
                shortDesc: "Les notions cl\xE9s r\xE9unies dans le m\xE9mo du chapitre.",
                fullDesc: "Les notions cl\xE9s du chapitre 3 sont pr\xE9sent\xE9es visuellement pour faciliter la m\xE9morisation : carte mentale, frise, mots cl\xE9s...",
                tags: ["Le m\xE9mo"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/54036965/lls-histoire-2nde-chapitre3-memo.pdf"
                  }
                ]
              },
              {
                id: 16,
                title: "Les causes des \xAB grandes d\xE9couvertes \xBB",
                vignette: "https://assets.lls.fr/pages/54036965/his2ch3bd.png",
                shortDesc: "Une courte bande dessin\xE9e pour m\xE9moriser autrement.",
                fullDesc: "Une illustration retrace une notion cl\xE9 du chapitre pour permettre aux \xE9l\xE8ves de la m\xE9moriser autrement.",
                tags: ["Le chapitre en BD"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/54036965/bd-chap3-v3.pdf"
                  }
                ]
              }
            ]
          },
          {
            goal: RESOURCE_GOALS.ENTRAINER,
            resourcesPack: [
              {
                id: 17,
                title: `Qu'avez-vous appris sur... la controverse de Valladolid ?`,
                vignette: "https://assets.lls.fr/pages/54036965/his2de3pdp1quiz.jpg",
                shortDesc: "Un quiz pour tester les \xE9l\xE8ves sur le point de passage n\xB0 1.",
                fullDesc: "Un quiz de r\xE9vision pour revenir sur le point de passage n\xB0 1 et tester les connaissances des \xE9l\xE8ves en vue de l\u2019\xE9valuation.",
                tags: ["Quiz - Point de passage"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/54036965/lls-histoire-2nde-chapitre3-quiz-ppo1.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "62a7337352f9880011b58324"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/54036965/lls-histoire-2nde-chapitre3-quiz-ppo1.zip"
                  },
                  {
                    format: RESOURCE_FORMAT.ExternalLink,
                    url: "https://create.kahoot.it/share/quavez-vous-appris-sur-la-controverse-de-valladolid/c4a11601-17b3-479f-bee4-67b92e39f265"
                  }
                ]
              },
              {
                id: 18,
                title: `Qu'avez-vous appris sur... l'\xE9conomie sucri\xE8re et l'esclavage ?`,
                vignette: "https://assets.lls.fr/pages/54036965/his2de3pdp2quiz.jpg",
                shortDesc: "Un quiz pour tester les \xE9l\xE8ves sur le point de passage n\xB0 2.",
                fullDesc: "Un quiz de r\xE9vision pour revenir sur le point de passage n\xB0 2 et tester les connaissances des \xE9l\xE8ves en vue de l\u2019\xE9valuation.",
                tags: ["Quiz - Point de passage"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/54036965/lls-histoire-2nde-chapitre3-quiz-ppo2.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "62a8577e087201001144bb3e"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/54036965/lls-histoire-2nde-chapitre3-quiz-ppo2.zip"
                  },
                  {
                    format: RESOURCE_FORMAT.ExternalLink,
                    url: "https://create.kahoot.it/share/quavez-vous-appris-sur-leconomie-sucriere-et-lesclavage/49d0b9c3-2558-4ff4-93bc-dc5800d8d25a"
                  }
                ]
              },
              {
                id: 19,
                title: `Qu'avez-vous appris sur... l'or et l'argent des Am\xE9riques \xE0 l'Europe ?`,
                vignette: "https://assets.lls.fr/pages/54036965/his2de3pdp3quiz.jpg",
                shortDesc: "Un quiz pour tester les \xE9l\xE8ves sur le point de passage n\xB0 3.",
                fullDesc: "Un quiz de r\xE9vision pour revenir sur le point de passage n\xB0 3 et tester les connaissances des \xE9l\xE8ves en vue de l\u2019\xE9valuation.",
                tags: ["Quiz - Point de passage"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/54036965/lls-histoire-2nde-chapitre3-quiz-ppo3.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "62a9cd026f16bb00186d64a1"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/54036965/lls-histoire-2nde-chapitre3-quiz-ppo3.zip"
                  },
                  {
                    format: RESOURCE_FORMAT.ExternalLink,
                    url: "https://create.kahoot.it/share/quavez-vous-appris-sur-lor-et-largent-des-ameriques-a-leurope/633e55d0-8c6b-4075-8ddc-0bc5d9ca9d20"
                  }
                ]
              },
              {
                id: 20,
                title: `Qu'avez-vous appris sur... le chapitre 3 ?`,
                vignette: "https://assets.lls.fr/pages/54036965/pocahontas-saves-smith-ne-chromo-1870.jpeg",
                shortDesc: `Un quiz pour r\xE9viser l'ensemble du chapitre.`,
                fullDesc: `Un quiz complet pour rebrasser et r\xE9viser l'ensemble des notions phares du chapitre 3.`,
                tags: ["Challenge de r\xE9vision"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/54036965/lls-histoire-2nde-chapitre3-quiz-challenge.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "629f6a6ab2dc12001150a66f"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/54036965/lls-histoire-2nde-chapitre3-quiz-challenge.zip"
                  }
                ]
              },
              {
                id: 21,
                title: "Jeu des 7 familles",
                vignette: "https://assets.lls.fr/pages/54036965/hg2-pr-ch03-jeux-vignette.jpg",
                shortDesc: "Un jeu pour r\xE9viser la totalit\xE9 du chapitre.",
                fullDesc: `Un jeu des 7 familles pour r\xE9viser l'ensemble du chapitre de fa\xE7on ludique.`,
                tags: ["Jeu"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/54036965/lls-histoire-2nde-chapitre3-jeu.pdf"
                  }
                ]
              }
            ]
          }
        ]
      },
      // Chapitre 4
      3: {
        title: "Pr\xE9parer le chapitre 4",
        subtitle: `Le Manuel Premium s'enrichit de contenus num\xE9riques exclusifs, cr\xE9\xE9s avec les professeurs de la communaut\xE9, pour vous permettre de concevoir votre s\xE9quence id\xE9ale !`,
        stamp: "Nouveaut\xE9 : les ressources Premium",
        header: "https://assets.lls.fr/pages/47552662/his2de4quizchallengerenaissance.jpg",
        category: [
          {
            goal: RESOURCE_GOALS.INSPIRER,
            resourcesPack: [
              {
                id: 1,
                title: `Des id\xE9es pour s'inspirer`,
                shortDesc: "Le meilleur des ressources issues du web !",
                fullDesc: "Le meilleur des ressources issues du web : une s\xE9lection de vid\xE9os, articles, publications universitaires, romans, bandes dessin\xE9es\u2026",
                tags: ["Padlet enseignant"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Padlet,
                    id: "dx4m06msrg3tit1z"
                  }
                ]
              },
              {
                id: 2,
                title: `Faire l'histoire de la Saint-Barth\xE9lemy, avec l'historien J\xE9r\xE9mie Foa`,
                vignette: "https://assets.lls.fr/pages/47552662/his2de4dossiermassacrestbarthelemy1.jpg",
                shortDesc: "Une activit\xE9 sur le massacre de la Saint-Barth\xE9lemy. ",
                fullDesc: `Une activit\xE9 sur le massacre de la Saint-Barth\xE9lemy, autour de l'ouvrage de J\xE9r\xE9mie Foa \xAB Tous ceux qui tombent. Visages du massacre de la Saint-Barth\xE9lemy \xBB, paru en 2021 aux \xE9ditions La D\xE9couverte. `,
                tags: ["Une recherche \xE0 la loupe"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/47552662/lls-h2-ch4-recherche-foa-2.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "47317764"
                  }
                ]
              },
              {
                id: 3,
                title: "Rencontre avec J\xE9r\xE9mie Foa - \xC9pisode 1 : Comment est n\xE9 ce projet ?",
                vignette: "https://assets.lls.fr/pages/47552662/vignette-e1-jeremiefoa.jpg",
                shortDesc: "\xC9pisode 1/6",
                fullDesc: `Interview de J\xE9r\xE9mie Foa - \xC9pisode 1 - Comment est n\xE9 ce projet ? 
              J\xE9r\xE9mie Foa est ma\xEEtre de conf\xE9rences en histoire moderne \xE0 Aix-Marseille Universit\xE9 et auteur de l'ouvrage \xAB Tous ceux qui tombent. Visages du massacre de la Saint-Barth\xE9lemy \xBB, paru en 2021 aux \xE9ditions La D\xE9couverte.`,
                tags: ["Interview"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/47317764/jeremie-foa-p1-v1.mp4"
                  }
                ]
              },
              {
                id: 4,
                title: "Rencontre avec J\xE9r\xE9mie Foa - \xC9pisode 2 : Quelles ont \xE9t\xE9 vos sources ?",
                vignette: "https://assets.lls.fr/pages/47552662/vignette-e2-jeremiefoa.jpg",
                shortDesc: "\xC9pisode 2/6",
                fullDesc: `Interview de J\xE9r\xE9mie Foa - \xC9pisode 2 - Quelles ont \xE9t\xE9 les sources sur lesquelles vous vous \xEAtes appuy\xE9 ? 
            J\xE9r\xE9mie Foa est ma\xEEtre de conf\xE9rences en histoire moderne \xE0 Aix-Marseille Universit\xE9 et auteur de l'ouvrage \xAB Tous ceux qui tombent. Visages du massacre de la Saint-Barth\xE9lemy \xBB, paru en 2021 aux \xE9ditions La D\xE9couverte.`,
                tags: ["Interview"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/47317764/jeremie-foa-p2-v1.mp4"
                  }
                ]
              },
              {
                id: 5,
                title: `Rencontre avec J\xE9r\xE9mie Foa - \xC9pisode 3 : Qu'avez-vous d\xE9couvert ? `,
                vignette: "https://assets.lls.fr/pages/47552662/vignette-e3-jeremiefoa.jpg",
                shortDesc: "\xC9pisode 3/6",
                fullDesc: `Interview de J\xE9r\xE9mie Foa - \xC9pisode 3 - Qu'avez-vous d\xE9couvert ? 
            J\xE9r\xE9mie Foa est ma\xEEtre de conf\xE9rences en histoire moderne \xE0 Aix-Marseille Universit\xE9 et auteur de l'ouvrage \xAB Tous ceux qui tombent. Visages du massacre de la Saint-Barth\xE9lemy \xBB, paru en 2021 aux \xE9ditions La D\xE9couverte.`,
                tags: ["Interview"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/47317764/jeremie-foa-p3-v1.mp4"
                  }
                ]
              },
              {
                id: 6,
                title: "Rencontre avec J\xE9r\xE9mie Foa - \xC9pisode 4 : Que d\xE9duisez-vous de ces recherches ?",
                vignette: "https://assets.lls.fr/pages/47552662/vignette-e4-jeremiefoa.jpg",
                shortDesc: "\xC9pisode 4/6",
                fullDesc: `Interview de J\xE9r\xE9mie Foa - \xC9pisode 4 - Que d\xE9duisez-vous de ces recherches ? 
            J\xE9r\xE9mie Foa est ma\xEEtre de conf\xE9rences en histoire moderne \xE0 Aix-Marseille Universit\xE9 et auteur de l'ouvrage \xAB Tous ceux qui tombent. Visages du massacre de la Saint-Barth\xE9lemy \xBB, paru en 2021 aux \xE9ditions La D\xE9couverte. `,
                tags: ["Interview"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/47317764/jeremie-foa-p4-v1.mp4"
                  }
                ]
              },
              {
                id: 7,
                title: `Rencontre avec J\xE9r\xE9mie Foa - \xC9pisode 5 : L'historien face au sujet`,
                vignette: "https://assets.lls.fr/pages/47552662/vignette-e5-jeremiefoa.jpg",
                shortDesc: "\xC9pisode 5/6",
                fullDesc: `Interview de J\xE9r\xE9mie Foa - \xC9pisode 5 - Est-on affect\xE9 quand on travaille sur un sujet comme celui-ci ?
            J\xE9r\xE9mie Foa est ma\xEEtre de conf\xE9rences en histoire moderne \xE0 Aix-Marseille Universit\xE9 et auteur de l'ouvrage \xAB Tous ceux qui tombent. Visages du massacre de la Saint-Barth\xE9lemy \xBB, paru en 2021 aux \xE9ditions La D\xE9couverte. `,
                tags: ["Interview"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/47317764/jeremie-foa-p5-v1.mp4"
                  }
                ]
              },
              {
                id: 8,
                title: "Rencontre avec J\xE9r\xE9mie Foa - \xC9pisode 6 : Un parcours qui vous a touch\xE9 ?",
                vignette: "https://assets.lls.fr/pages/47552662/vignette-e6-jeremiefoa.jpg",
                shortDesc: "\xC9pisode 6/6",
                fullDesc: `Interview de J\xE9r\xE9mie Foa - \xC9pisode 6 - Un parcours qui vous a touch\xE9 ? 
            J\xE9r\xE9mie Foa est ma\xEEtre de conf\xE9rences en histoire moderne \xE0 Aix-Marseille Universit\xE9 et auteur de l'ouvrage \xAB Tous ceux qui tombent. Visages du massacre de la Saint-Barth\xE9lemy \xBB, paru en 2021 aux \xE9ditions La D\xE9couverte. `,
                tags: ["Interview"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/47317764/jeremie-foa-p6-v1.mp4"
                  }
                ]
              }
            ]
          },
          {
            goal: RESOURCE_GOALS.COMMENCER,
            resourcesPack: [
              {
                id: 9,
                title: "\xC0 la d\xE9couverte du chapitre 4",
                vignette: "https://assets.lls.fr/pages/47552662/his2de4video-intro.jpg",
                shortDesc: "Une vid\xE9o immersive pour introduire le chapitre.",
                fullDesc: "Une vid\xE9o immersive pour poser le contexte historique et introduire les grandes probl\xE9matiques du chapitre.",
                tags: ["Vid\xE9o"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/47552662/intro-ch4-v3.mp4"
                  }
                ]
              },
              {
                id: 10,
                title: `Galerie d'images pour ouvrir le chapitre`,
                vignette: "https://assets.lls.fr/pages/47552662/his2de4galeriebotticelliprintemps.jpg",
                shortDesc: `Une s\xE9lection d'iconographies alternatives pour ouvrir le chapitre.`,
                fullDesc: `Une s\xE9lection d'iconographies alternatives pour ouvrir le chapitre. Pratique pour  personnaliser votre manuel et varier les entr\xE9es d'une ann\xE9e \xE0 l'autre !`,
                tags: ["Images d\u2019ouverture"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Gallery,
                    items: [
                      {
                        legend: "Lucas Cranach le Jeune, <em>La vraie et la fausse \xC9glise</em>, 1546, gravure.",
                        credit: "AKG",
                        url: "https://assets.lls.fr/pages/47552662/1-hist2de4banque-iconovraifausse-eglise.png"
                      },
                      {
                        legend: "Caricature du clerg\xE9 catholique vendant des indulgences, XVI\u1D49 si\xE8cle.",
                        credit: "Packare / Wikimedia",
                        url: "https://assets.lls.fr/pages/47552662/2-hist2de4banque-iconocaricature-clerge.jpg"
                      },
                      {
                        legend: `All\xE9gorie montrant \xE0 droite l'\xE9glise catholique et \xE0 gauche l'\xE9glise protestante, 1591, gravure allemande.`,
                        credit: "Tallandier / Bridgeman Images",
                        url: "https://assets.lls.fr/pages/47552662/3-hist2de4banque-iconoallegorie-protestantisme.JPG"
                      },
                      {
                        legend: "Francesco Rosselli, <em>Pianta della Catena</em>, 1471-1482, mus\xE9e du Palazzo Vecchio, Florence.",
                        credit: "Nicol\xF2 Orsi Battaglini / Bridgeman",
                        url: "https://assets.lls.fr/pages/47552662/4-hist2de4banque-iconoflorence.jpg"
                      },
                      {
                        legend: `Invention de l'imprimerie de livres, <em>Nova Reperta</em>, XVIe si\xE8cle.`,
                        credit: "Science History Images / Alamy",
                        url: "https://assets.lls.fr/pages/47552662/5-hist2de4banque-iconoinvention-imprimerie.jpg"
                      },
                      {
                        legend: "L\u2019humaniste Guillaume Bud\xE9 \xE0 l\u2019\u0153uvre pour son roi, Fran\xE7ois I\u1D49, v. 1518, enluminure, BnF, Paris.",
                        credit: "BnF",
                        url: "https://assets.lls.fr/pages/47552662/6-hist2de4banque-iconoguillaume-bude.jpg"
                      },
                      {
                        legend: "Portrait d\u2019\xC9rasme et de son secr\xE9taire particulier, v. 1533, gravure sur bois.",
                        credit: "AKG",
                        url: "https://assets.lls.fr/pages/47552662/7-hist2de4banque-iconoerasme-secretaire.jpg"
                      },
                      {
                        legend: "Maximilian Sforza assistant \xE0 ses le\xE7ons, Lombardie, XVe si\xE8cle, Biblioteca Trivulziana, Milan.",
                        credit: "Jimlop collection / Alamy",
                        url: "https://assets.lls.fr/pages/47552662/8-hist2de4banque-iconomaximilian-sforza.jpg"
                      },
                      {
                        legend: "L\xE9onard de Vinci, <em>L\u2019Homme de Vitruve</em>, 1490.",
                        credit: "Gallerie dell\u2019Accademia  / Wikimedia",
                        url: "https://assets.lls.fr/pages/47552662/9-hist2de4banque-iconohomme-vitruve.jpg"
                      },
                      {
                        legend: `Michel-Ange, <em>La Cr\xE9ation d'Adam</em>, 1511-1512, fresque, 280 x 570 cm.`,
                        credit: "Sistine Chapel / Wikimedia",
                        url: "https://assets.lls.fr/pages/47552662/10-hist2de4banque-iconocreation-adam.jpg"
                      },
                      {
                        legend: "Rapha\xEBl, <em>L\u2019\xC9cole d\u2019Ath\xE8nes</em>, 1510, fresque, 440 x 770 cm, mus\xE9e du Vatican.",
                        credit: "Musei Vaticani / Wikimedia",
                        url: "https://assets.lls.fr/pages/47552662/11-hist2de4banque-iconoecole-athenes.jpg"
                      },
                      {
                        legend: "Vittore Carpaccio, <em>La Vierge lisant</em>, v. 1505, huile sur bois transf\xE9r\xE9e sur toile, 78 x 51 cm, National Gallery of Art, Washington",
                        credit: "National Gallery of Art / AKG",
                        url: "https://assets.lls.fr/pages/47552662/12-hist2de4banque-iconovierge-lisant.jpg"
                      },
                      {
                        legend: `Sofonisba Anguissola, <em>Autoportrait</em>, 1556, huile sur toile, 66 x 57 cm,
                    Muzeum-Zamek, \u0141a\u0144cut.`,
                        credit: "Zamek Lubomirskich i Potockich w \u0141a\u0144cucie / Wikimedia",
                        url: "https://assets.lls.fr/pages/47552662/13-hist2de4banque-iconosofonisba-autoportrait.jpg"
                      },
                      {
                        legend: "Paul V\xE9ron\xE8se, <em>Les Noces de Cana</em>, v. 1562-1563, huile sur toile, 6,66 x 9,90 m, mus\xE9e du Louvre, Paris.",
                        credit: "Paris 16 / Wikimedia",
                        url: "https://assets.lls.fr/pages/47552662/14-hist2de4banque-icononoces-cana.jpg"
                      },
                      {
                        legend: "Sofonisba Anguissola, <em>Jeu d\u2019\xE9checs</em>, 1555, huile sur toile, 72 x 97 cm, mus\xE9e Narodowe, Poznan.",
                        credit: "Bridgeman",
                        url: "https://assets.lls.fr/pages/47552662/15-hist2de4banque-iconosofonisba-echecs.jpg"
                      },
                      {
                        legend: "Photographie du Ch\xE2teau de Chambord",
                        credit: "W. Bulach / Wikimedia",
                        url: "https://assets.lls.fr/pages/47552662/16-hist2de4banque-iconochateau-chambord.jpg"
                      },
                      {
                        legend: `L\xE9onard de Vinci, <em>Dame \xE0 l\u2019hermine</em>, v. 1489-1490, peinture \xE0 l'huile sur bois, 40,3 x 54,8 cm, mus\xE9e Czartoryski, Cracovie.`,
                        credit: "Opencooper / Wikimedia",
                        url: "https://assets.lls.fr/pages/47552662/17-hist2de4banque-iconodame-hermine.jpg"
                      },
                      {
                        legend: "Mona Lisa, revisit\xE9e par l\u2019artiste espagnole Tatimoons, avril 2020.",
                        credit: "Tatimoons/DR",
                        url: "https://assets.lls.fr/pages/47552662/18-hist2de4banque-iconomona-lisa.jpg"
                      }
                    ]
                  }
                ]
              },
              {
                id: 11,
                title: "Que savez-vous d\xE9j\xE0 sur... le chapitre 4 ?",
                vignette: "https://assets.lls.fr/pages/47552662/his2de4quizhomme-de-vitruve.jpg",
                shortDesc: "Un quiz diagnostique pour ouvrir le chapitre.",
                fullDesc: "Un quiz diagnostique pour faire le point sur les connaissances des \xE9l\xE8ves et ouvrir le chapitre 4.",
                tags: ["Quiz diagnostique"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.ExternalLink,
                    url: "https://create.kahoot.it/share/que-savez-vous-deja-sur-le-chapitre-4/b103a9bf-b535-4858-a017-3563829d297d"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/47552662/lls-h2-ch4-quiz-diagnostique-2.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/47552662/lls-h2de-ch4-quizdianostique.zip"
                  }
                ]
              }
            ]
          },
          {
            goal: RESOURCE_GOALS.ETUDIER,
            resourcesPack: [
              {
                id: 12,
                title: "1508 - Michel-Ange peint la chapelle Sixtine",
                vignette: "https://assets.lls.fr/pages/47552662/vignette-michelange1.jpg",
                shortDesc: `Quelles sont les conditions de r\xE9alisation d'un chef-d'\u0153uvre artistique ?`,
                fullDesc: `Une vid\xE9o pour explorer les conditions de cr\xE9ation d'un chef-d'\u0153uvre artistique de la Renaissance : le plafond de la chapelle Sixtine par Michel-Ange.`,
                tags: ["Vid\xE9o"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/6400354/sixtine-v5.mp4"
                  }
                ]
              },
              {
                id: 13,
                title: "\xC9rasme, prince des humanistes",
                vignette: "https://assets.lls.fr/pages/47552662/vignette-erasme1.jpg",
                shortDesc: "Quelles valeurs humanistes \xC9rasme incarne-t-il ?",
                fullDesc: `Une vid\xE9o pour retracer les voyages d'\xC9rasme et la diffusion des id\xE9es humanistes \xE0 travers l'Europe.`,
                tags: ["Vid\xE9o"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/6403428/erasme-v3.mp4"
                  }
                ]
              },
              {
                id: 14,
                title: "1517 - Luther ouvre le temps des r\xE9formes",
                vignette: "https://assets.lls.fr/pages/47552662/vignette-luther1.jpg",
                shortDesc: `Quelles raisons poussent Luther \xE0 vouloir r\xE9former l'\xC9glise ?`,
                fullDesc: "Une vid\xE9o pour comprendre les raisons qui poussent Luther \xE0 initier une rupture fondatrice du protestantisme.",
                tags: ["Vid\xE9o"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/6408798/luther-v3.mp4"
                  }
                ]
              }
            ]
          },
          {
            goal: RESOURCE_GOALS.EXPLORER,
            resourcesPack: [
              {
                id: 15,
                title: "\xC0 la Renaissance, des femmes puissantes ?",
                vignette: "https://assets.lls.fr/pages/47552662/his2de4dossierfemmes2.jpg",
                shortDesc: "Quelle est la place des femmes \xE0 la Renaissance ?",
                fullDesc: "Un dossier pour explorer la place des femmes dans la soci\xE9t\xE9, \xE0 la Renaissance, en Europe.",
                tags: ["Dossier exclusif"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/47552662/lls-h2-ch4-dossier-femmes-1.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "47318058"
                  }
                ]
              },
              {
                id: 16,
                title: "Qui \xE9tait Sandro Botticelli ?",
                vignette: "https://assets.lls.fr/pages/47552662/his2de4dossiercalomnieapelle.jpg",
                shortDesc: `Pourquoi Botticelli a-t-il marqu\xE9 l'histoire de l'art ?`,
                fullDesc: `Pourquoi Botticelli a-t-il marqu\xE9 l'histoire de l'art ? Ce dossier propose de s'interroger sur la vie et l'\u0153uvre de cette figure majeure de la Renaissance.`,
                tags: ["Dossier exclusif"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/47552662/lls-h2-ch4-dossier-botticelli.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "47317763"
                  }
                ]
              },
              {
                id: 17,
                title: "La Renaissance flamande",
                vignette: "https://assets.lls.fr/pages/47552662/his2de4dossierbrueghelbethleem.jpg",
                shortDesc: "Quelles sont les sp\xE9cificit\xE9s de la Renaissance flamande ?",
                fullDesc: "Un dossier pour d\xE9couvrir le mouvement de la Renaissance flamande aux Pays-Bas dans la seconde moiti\xE9 du XVe si\xE8cle et au XVIe si\xE8cle.",
                tags: ["Dossier exclusif"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/47552662/lls-h2-ch4-dossier-flamande.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "7714350"
                  }
                ]
              }
            ]
          },
          {
            goal: RESOURCE_GOALS.DIVERSIFIER,
            resourcesPack: [
              {
                id: 18,
                title: "Des ressources pour approfondir ",
                shortDesc: "Pour les \xE9l\xE8ves, le meilleur des ressources issues du web !",
                fullDesc: "Pour les \xE9l\xE8ves, le meilleur des ressources issues du web : une s\xE9lection d\u2019articles, romans, podcasts, films, jeux vid\xE9o, BDs, photos\u2026",
                tags: ["Padlet \xE9l\xE8ve"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Padlet,
                    id: "9j88b1rc37th0ky0"
                  }
                ]
              },
              {
                id: 19,
                title: "Enqu\xEAte sur L\xE9onard de Vinci",
                vignette: "https://assets.lls.fr/pages/47552662/his2de4apprendreautrementvierge.jpg",
                shortDesc: "Quel myst\xE8re se cache derri\xE8re cette toile de L\xE9onard de Vinci ?",
                fullDesc: `Conservateurs au mus\xE9e du Louvre, \xE0 Paris, vos \xE9l\xE8ves doivent mener une palpitante enqu\xEAte pour tenter de percer le secret d'une toile de L\xE9onard de Vinci !`,
                tags: ["Apprendre autrement"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/47552662/lls-histoire-2nde-chapitre-4-aa-leonard-de-vinci.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "47316933"
                  }
                ]
              },
              {
                id: 20,
                title: `L'ascension d'un m\xE9decin \xE0 la Renaissance`,
                vignette: "https://assets.lls.fr/pages/47552662/his2de4apprendreautrementambroisepare.jpg",
                shortDesc: "Quelle est la place de la m\xE9decine \xE0 la Renaissance ?",
                fullDesc: "Vos \xE9l\xE8ves, qui ont \xE9tudi\xE9 la m\xE9decine dans la prestigieuse facult\xE9 de Montpellier, commencent \xE0 exercer ce m\xE9tier, qui est alors consid\xE9r\xE9 comme un art...",
                tags: ["Apprendre autrement"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/47552662/lls-h2-ch4-aa-medecine-1.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "47257643"
                  }
                ]
              },
              {
                id: 21,
                title: `R\xE9aliser un "placard" et diffuser ses id\xE9es !`,
                vignette: "https://assets.lls.fr/pages/47552662/his2de4apprendreautrementplacard.jpg",
                shortDesc: "R\xE9alisez un placard pour d\xE9fendre vos id\xE9es !",
                fullDesc: "Apr\xE8s avoir rassembl\xE9 des arguments en faveur du catholicisme ou du protestantisme, vos \xE9l\xE8ves r\xE9alisent, par petits groupes, un placard d\xE9fendant leur opinion.",
                tags: ["Apprendre autrement"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/47552662/lls-h2-ch4-aa-placard.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "6409822"
                  }
                ]
              },
              {
                id: 22,
                title: "Enqu\xEAte \xE0 Amboise",
                shortDesc: `D\xE9couvrez l'une des derni\xE8res \xE9nigmes de L\xE9onard de Vinci.`,
                fullDesc: `Un parcours num\xE9rique original pour r\xE9soudre l'une des derni\xE8res \xE9nigmes de L\xE9onard de Vinci.`,
                tags: ["Activit\xE9 num\xE9rique"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "5e18a1b73cf83c241e158402"
                  }
                ]
              }
            ]
          },
          {
            goal: RESOURCE_GOALS.MEMORISER,
            resourcesPack: [
              {
                id: 23,
                title: "3 minutes pour r\xE9viser le chapitre 4",
                vignette: "https://assets.lls.fr/pages/47552662/his2de4videorevision.png",
                shortDesc: "Une vid\xE9o pour r\xE9viser les points cl\xE9s du chapitre.",
                fullDesc: "Une vid\xE9o bilan pour r\xE9viser et m\xE9moriser les points cl\xE9s du chapitre 4.",
                tags: ["Vid\xE9o"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/6409862/chap4.mp4"
                  }
                ]
              },
              {
                id: 24,
                title: `L'essentiel du chapitre 4`,
                vignette: "https://assets.lls.fr/pages/47552662/his2de4memo.jpg",
                shortDesc: "Les notions cl\xE9s r\xE9unies dans le m\xE9mo du chapitre.",
                fullDesc: "Les notions cl\xE9s du chapitre 4 sont pr\xE9sent\xE9es visuellement pour faciliter la m\xE9morisation : carte mentale, frise, mots cl\xE9s...",
                tags: ["Le m\xE9mo"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/47552662/lls-histoire-2nde-chapitre-4-memo.pdf"
                  }
                ]
              },
              {
                id: 25,
                title: "La Renaissance, une bande dessin\xE9e originale",
                vignette: "https://assets.lls.fr/pages/47552662/his2de4bande-dessinee.jpg",
                shortDesc: "Une bande dessin\xE9e pour m\xE9moriser autrement.",
                fullDesc: "Une bande dessin\xE9e originale retrace les grands moments du chapitre pour permettre aux \xE9l\xE8ves de m\xE9moriser autrement.",
                tags: ["Le chapitre en BD"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Gallery,
                    items: [
                      {
                        legend: "Planche 1/7",
                        credit: "Lelivrescolaire.fr",
                        url: "https://assets.lls.fr/pages/47552662/lls-bd-renaissance-planche-01.jpg"
                      },
                      {
                        legend: "Planche 2/7",
                        credit: "Lelivrescolaire.fr",
                        url: "https://assets.lls.fr/pages/47552662/lls-bd-renaissance-planche-02.jpg"
                      },
                      {
                        legend: "Planche 3/7",
                        credit: "Lelivrescolaire.fr",
                        url: "https://assets.lls.fr/pages/47552662/lls-bd-renaissance-planche-03.jpg"
                      },
                      {
                        legend: "Planche 4/7",
                        credit: "Lelivrescolaire.fr",
                        url: "https://assets.lls.fr/pages/47552662/lls-bd-renaissance-planche-04.jpg"
                      },
                      {
                        legend: "Planche 5/7",
                        credit: "Lelivrescolaire.fr",
                        url: "https://assets.lls.fr/pages/47552662/lls-bd-renaissance-planche-05.jpg"
                      },
                      {
                        legend: "Planche 6/7",
                        credit: "Lelivrescolaire.fr",
                        url: "https://assets.lls.fr/pages/47552662/lls-bd-renaissance-planche-06.jpg"
                      },
                      {
                        legend: "Planche 7/7",
                        credit: "Lelivrescolaire.fr",
                        url: "https://assets.lls.fr/pages/47552662/lls-bd-renaissance-planche-07.jpg"
                      }
                    ]
                  }
                ]
              }
              // FICHE DE REVISIONS, INDISPO NON PREMIUM
              // {
              //   id: 26,
              //   title: `Fiche de révision du chapitre 4`,
              //   vignette: `https://assets.lls.fr/pages/47552662/his2de4fiche-de-revision.jpg`,
              //   shortDesc: `Des fiches pour réviser l'essentiel du chapitre.`,
              //   fullDesc: `Les fiches de révision présentent : un résumé du cours, les notions clés, les personnages importants et les dates essentielles du chapitre.`,
              //   tags: [`Fiches de révision`],
              //   resources: [
              //     {
              //       format: RESOURCE_FORMAT.InternalLink,
              //       page: '9218223'
              //     }
              //   ]
              // }
            ]
          },
          {
            goal: RESOURCE_GOALS.ENTRAINER,
            resourcesPack: [
              {
                id: 27,
                title: `Qu'avez-vous appris sur... Michel-Ange et la chapelle Sixtine ?`,
                vignette: "https://assets.lls.fr/pages/47552662/his2de4pdp1chapellesixtine.jpg",
                shortDesc: "Un quiz pour tester les \xE9l\xE8ves sur le point de passage n\xB0 1.",
                fullDesc: "Un quiz de r\xE9vision pour revenir sur le point de passage n\xB0 1 et tester les connaissances des \xE9l\xE8ves en vue de l\u2019\xE9valuation.",
                tags: ["Quiz - Point de passage"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "61e54fa40fc09f0cd1bd83b2"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/47552662/lls-h2-ch4-quiz-pdp1.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/47552662/lls-h2de-ch4-pointpassage1.zip"
                  },
                  {
                    format: RESOURCE_FORMAT.ExternalLink,
                    url: "https://create.kahoot.it/share/qu-avez-vous-appris-sur-michel-ange-et-la-chapelle-sixtine/f0389baa-f226-433e-9c8c-209d3b9d0db2"
                  }
                ]
              },
              {
                id: 28,
                title: `Qu'avez-vous appris sur... \xC9rasme et l'humanisme ?`,
                vignette: "https://assets.lls.fr/pages/47552662/his2de4pdp2erasme.jpg",
                shortDesc: "Un quiz pour tester les \xE9l\xE8ves sur le point de passage n\xB0 2.",
                fullDesc: "Un quiz de r\xE9vision pour revenir sur le point de passage n\xB0 2 et tester les connaissances des \xE9l\xE8ves en vue de l\u2019\xE9valuation.",
                tags: ["Quiz - Point de passage"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "61ee641d6b85b90013225398"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/47552662/lls-h2-ch4-quiz-pdp2.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/47552662/lls-h2de-ch4-pointpassage2.zip"
                  },
                  {
                    format: RESOURCE_FORMAT.ExternalLink,
                    url: "https://create.kahoot.it/share/qu-avez-vous-appris-sur-erasme-et-l-humanisme/4ebca586-b45b-48a4-ad8e-b3895576ac5c"
                  }
                ]
              },
              {
                id: 29,
                title: `Qu'avez-vous appris sur... Luther et les r\xE9formes protestantes ?`,
                vignette: "https://assets.lls.fr/pages/47552662/his2de4pdp3luther.jpg",
                shortDesc: "Un quiz pour tester les \xE9l\xE8ves sur le point de passage n\xB0 3.",
                fullDesc: "Un quiz de r\xE9vision pour revenir sur le point de passage n\xB0 3 et tester les connaissances des \xE9l\xE8ves en vue de l\u2019\xE9valuation.",
                tags: ["Quiz - Point de passage"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "61eeb442ab95a700133c820c"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/47552662/lls-h2-ch4-quiz-pdp3.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/47552662/lls-h2de-ch4-pointpassage3.zip"
                  },
                  {
                    format: RESOURCE_FORMAT.ExternalLink,
                    url: "https://create.kahoot.it/share/qu-avez-vous-appris-sur-luther-et-les-reformes-protestantes/26c870f1-52a8-4891-910f-a17705e37c25"
                  }
                ]
              },
              {
                id: 30,
                title: `Qu'avez-vous appris sur... le chapitre 4 ?`,
                vignette: "https://assets.lls.fr/pages/47552662/his2de4quizchallengerenaissance.jpg",
                shortDesc: `Un quiz pour r\xE9viser l'ensemble du chapitre.`,
                fullDesc: `Un quiz complet pour rebrasser et r\xE9viser l'ensemble des notions phares du chapitre 4.`,
                tags: ["Challenge de r\xE9vision"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "61e52e2d1cb3c70d26b56e6a"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/47552662/lls-histoire-2nde-chapitre-quiz-challenge.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/47552662/lls-h2de-ch4-quizchallenge.zip"
                  }
                ]
              },
              // EXERCICES DE REVISIONS, INDISPO NON PREMIUM
              // {
              //   id: 31,
              //   title: `Exercices de révision du chapitre 4`,
              //   vignette: `https://assets.lls.fr/pages/47552662/his2de4exo-de-revision.jpg`,
              //   shortDesc: `Une session d'exercices autoccorigés pour réviser.`,
              //   fullDesc: `Proposez à vos élèves une session d'exercices autoccorigés pour réviser le chapitre.`,
              //   tags: [`Exercices de révision`],
              //   resources: [
              //     {
              //       format: RESOURCE_FORMAT.InternalLink,
              //       page: '10085519'
              //     }
              //   ]
              // },
              {
                id: 32,
                title: "Mots-crois\xE9s",
                vignette: "https://assets.lls.fr/pages/47552662/his2de4jeuxmotscroises.jpg",
                shortDesc: "Un jeu pour r\xE9viser les notions-cl\xE9s du chapitre.",
                fullDesc: "Un jeu de mots-crois\xE9s pour r\xE9viser les notions-cl\xE9s du chapitre 4 de fa\xE7on ludique.",
                tags: ["Jeu"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/47552662/lls-h2-ch4-mots-croises.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.ExternalLink,
                    url: "https://view.genial.ly/61eacaed4ddc500013e91073"
                  }
                ]
              }
            ]
          }
        ]
      },
      // Chapitre 5
      4: {
        title: "Pr\xE9parer le chapitre 5",
        subtitle: `Le Manuel Premium s'enrichit de contenus num\xE9riques exclusifs, cr\xE9\xE9s avec les professeurs de la communaut\xE9, pour vous permettre de concevoir votre s\xE9quence id\xE9ale !`,
        stamp: "Nouveaut\xE9 : les ressources Premium",
        header: "https://assets.lls.fr/pages/47777754/bandeau-header-chapitre-5.JPG",
        category: [
          {
            goal: RESOURCE_GOALS.INSPIRER,
            resourcesPack: [
              {
                id: 1,
                title: `Des id\xE9es pour s'inspirer`,
                shortDesc: "Le meilleur des ressources issues du web !",
                fullDesc: "Le meilleur des ressources issues du web : une s\xE9lection de vid\xE9os, articles, publications universitaires, romans, bandes dessin\xE9es\u2026",
                tags: ["Padlet enseignant"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Padlet,
                    id: "rdcz3665ka22hcly"
                  }
                ]
              },
              {
                id: 2,
                title: "Comprendre le r\xF4le des ma\xEEtresses du roi",
                vignette: "https://assets.lls.fr/pages/47777754/hist2de5sedocumentermadame-montespan.jpeg",
                shortDesc: "Une activit\xE9 pour comprendre le r\xF4le des ma\xEEtresses de Henri IV \xE0 Louis XIV.",
                fullDesc: `Une activit\xE9 pour comprendre le r\xF4le des ma\xEEtresses de Henri IV \xE0 Louis XIV, avec l'historienne Flavie Leroux, autrice du livre <em>Les ma\xEEtresses du roi</em>.`,
                tags: ["Recherche \xE0 la loupe"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/47777754/lls-histoire-2nde-chapitre5-recherche-a-la-loupe-maitresse.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "57948911"
                  }
                ]
              },
              {
                id: 3,
                title: "Rencontre avec Flavie Leroux - \xC9pisode 1 : Pourquoi avoir choisi un tel sujet ?",
                vignette: "https://assets.lls.fr/pages/47777754/vignettes-flavieleroux-01.jpg",
                shortDesc: "\xC9pisode 1/7",
                fullDesc: `Interview de Flavie Leroux - \xC9pisode 1 - Pourquoi avoir choisi un tel sujet ?
            Docteure en histoire moderne, Flavie Leroux a consacr\xE9 sa th\xE8se aux ma\xEEtresses royales \xE0 l'\xE9poque moderne. L'objectif est de montrer que les ma\xEEtresses royales ont jou\xE9 un r\xF4le important dans le fonctionnement de la monarchie.`,
                tags: ["Interview"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/57948911/flavie-leroux-q1-v1.mp4"
                  }
                ]
              },
              {
                id: 4,
                title: "Rencontre avec Flavie Leroux - \xC9pisode 2 : Pourquoi un roi catholique a-t-il le droit de prendre des ma\xEEtresses ?",
                vignette: "https://assets.lls.fr/pages/47777754/vignettes-flavieleroux-02.jpg",
                shortDesc: "\xC9pisode 2/7",
                fullDesc: `Interview de Flavie Leroux - \xC9pisode 2 - Pourquoi un roi catholique a-t-il le droit de prendre des ma\xEEtresses ?
            Docteure en histoire moderne, Flavie Leroux a consacr\xE9 sa th\xE8se aux ma\xEEtresses royales \xE0 l'\xE9poque moderne. L'objectif est de montrer que les ma\xEEtresses royales ont jou\xE9 un r\xF4le important dans le fonctionnement de la monarchie.`,
                tags: ["Interview"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/57948911/flavie-leroux-q2-v1.mp4"
                  }
                ]
              },
              {
                id: 5,
                title: "Rencontre avec Flavie Leroux - \xC9pisode 3 : Quelles sources pour travailler sur les ma\xEEtresses royales ?",
                vignette: "https://assets.lls.fr/pages/47777754/vignettes-flavieleroux-03.jpg",
                shortDesc: "\xC9pisode 3/7",
                fullDesc: `Interview de Flavie Leroux - \xC9pisode 3 - Quelles sources pour travailler sur les ma\xEEtresses royales ?
            Docteure en histoire moderne, Flavie Leroux a consacr\xE9 sa th\xE8se aux ma\xEEtresses royales \xE0 l'\xE9poque moderne. L'objectif est de montrer que les ma\xEEtresses royales ont jou\xE9 un r\xF4le important dans le fonctionnement de la monarchie.`,
                tags: ["Interview"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/57948911/flavie-leroux-q3-v1.mp4"
                  }
                ]
              },
              {
                id: 6,
                title: "Rencontre avec Flavie Leroux - \xC9pisode 4 : Le roi doit-il choisir uniquement des ma\xEEtresses nobles ?",
                vignette: "https://assets.lls.fr/pages/47777754/vignettes-flavieleroux-04.jpg",
                shortDesc: "\xC9pisode 4/7",
                fullDesc: `Interview de Flavie Leroux - \xC9pisode 4 - Le roi doit-il choisir uniquement des ma\xEEtresses nobles ?
            Docteure en histoire moderne, Flavie Leroux a consacr\xE9 sa th\xE8se aux ma\xEEtresses royales \xE0 l'\xE9poque moderne. L'objectif est de montrer que les ma\xEEtresses royales ont jou\xE9 un r\xF4le important dans le fonctionnement de la monarchie.`,
                tags: ["Interview"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/57948911/flavie-leroux-q4-v1.mp4"
                  }
                ]
              },
              {
                id: 7,
                title: "Rencontre avec Flavie Leroux - \xC9pisode 5 : Comment le roi manifeste-t-il sa faveur envers ses ma\xEEtresses ?",
                vignette: "https://assets.lls.fr/pages/47777754/vignettes-flavieleroux-05.jpg",
                shortDesc: "\xC9pisode 5/7",
                fullDesc: `Interview de Flavie Leroux - \xC9pisode 5 - Comment le roi manifeste-t-il sa faveur envers ses ma\xEEtresses ?
            Docteure en histoire moderne, Flavie Leroux a consacr\xE9 sa th\xE8se aux ma\xEEtresses royales \xE0 l'\xE9poque moderne. L'objectif est de montrer que les ma\xEEtresses royales ont jou\xE9 un r\xF4le important dans le fonctionnement de la monarchie.`,
                tags: ["Interview"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/57948911/flavie-leroux-q5-v1.mp4"
                  }
                ]
              },
              {
                id: 8,
                title: "Rencontre avec Flavie Leroux - \xC9pisode 6 : Les ma\xEEtresses sont-elles des \xAB manipulatrices \xBB ?",
                vignette: "https://assets.lls.fr/pages/47777754/vignettes-flavieleroux-06.jpg",
                shortDesc: "\xC9pisode 6/7",
                fullDesc: `Interview de Flavie Leroux - \xC9pisode 6 - Les ma\xEEtresses sont-elles des \xAB manipulatrices \xBB, tirant les ficelles pour combler leur famille de richesses et d'honneurs ?
            Docteure en histoire moderne, Flavie Leroux a consacr\xE9 sa th\xE8se aux ma\xEEtresses royales \xE0 l'\xE9poque moderne. L'objectif est de montrer que les ma\xEEtresses royales ont jou\xE9 un r\xF4le important dans le fonctionnement de la monarchie.`,
                tags: ["Interview"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/57948911/flavie-leroux-q6-v1.mp4"
                  }
                ]
              },
              {
                id: 9,
                title: `Rencontre avec Flavie Leroux - \xC9pisode 7 : Les ma\xEEtresses participent-elles \xE0 l'\xE9ducation des b\xE2tards ?`,
                vignette: "https://assets.lls.fr/pages/47777754/vignettes-flavieleroux-07.jpg",
                shortDesc: "\xC9pisode 7/7",
                fullDesc: `Interview de Flavie Leroux - \xC9pisode 7 - Les ma\xEEtresses participent-elles \xE0 l'\xE9ducation des b\xE2tards ?
            Docteure en histoire moderne, Flavie Leroux a consacr\xE9 sa th\xE8se aux ma\xEEtresses royales \xE0 l'\xE9poque moderne. L'objectif est de montrer que les ma\xEEtresses royales ont jou\xE9 un r\xF4le important dans le fonctionnement de la monarchie.`,
                tags: ["Interview"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/57948911/flavie-leroux-q7-v1.mp4"
                  }
                ]
              },
              {
                id: 10,
                title: `L'histoire environnementale, une nouvelle cl\xE9 pour comprendre Versailles`,
                vignette: "https://assets.lls.fr/pages/47777754/his2de5cliohistoire-environnementale.jpg",
                shortDesc: `Pourquoi l'histoire environnementale est-elle une nouvelle cl\xE9 pour comprendre Versailles ?`,
                fullDesc: `Qu'est-ce que l'histoire environnementale ? Pourquoi cette approche historique est-elle particuli\xE8rement adapt\xE9e pour \xE9tudier Versailles ? Aidez vos \xE9l\xE8ves \xE0 r\xE9pondre \xE0 ces questions \xE0 l'aide de documents et de l'\u0153il de l'historien Gr\xE9gory Quenet.`,
                tags: ["Atelier de Clio"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/47777754/lls-histoire-2nde-chapitre5-atelier-de-clio.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "6451343"
                  }
                ]
              }
            ]
          },
          {
            goal: RESOURCE_GOALS.COMMENCER,
            resourcesPack: [
              {
                id: 12,
                title: `Galerie d'images pour ouvrir le chapitre`,
                vignette: "https://assets.lls.fr/pages/47777754/lls-his2-ch5-icono4.jpg",
                shortDesc: `Une s\xE9lection d'iconographies alternatives pour ouvrir le chapitre.`,
                fullDesc: `Une s\xE9lection d'iconographies alternatives pour ouvrir le chapitre. Pratique pour  personnaliser votre manuel et varier les entr\xE9es d'une ann\xE9e \xE0 l'autre !`,
                tags: ["Images d\u2019ouverture"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Gallery,
                    items: [
                      {
                        legend: `Charles  Beaubrun, <em>Anne d\u2019Autriche, reine de France</em>, v. 1650, mus\xE9e du ch\xE2teau de Versailles.

                    Anne d\u2019Autriche occupe seule le tableau. Sa robe fleurdelys\xE9e, bord\xE9e d\u2019une hermine, ses gants, ses perles servent \xE0 la mettre en valeur. Elle appara\xEEt sous un dais, symbole de la royaut\xE9 : mani\xE8re de rappeler qu\u2019en tant que r\xE9gente, Anne gouverne le royaume.`,
                        credit: "Kaho Mitsuki/Wikimedia",
                        url: "https://assets.lls.fr/pages/47777754/lls-his2-ch5-icono1.jpg"
                      },
                      {
                        legend: `Fran\xE7ois Dubois, <em>Massacre de la Saint Barthel\xE9my</em>, v. 1575, mus\xE9e cantonal des Beaux-Arts, Gen\xE8ve.

                    Ce tableau a \xE9t\xE9 peint par un protestant fran\xE7ais rescap\xE9 des massacres de la Saint Barth\xE9lemy. Le peintre essaye de repr\xE9senter tous les moments des massacres sur le m\xEAme tableau : de la d\xE9f\xE9nestration de Coligny (au centre) aux pogroms urbains (milieu et droite) en passant par les cadavres jet\xE9s dans la Seine (gauche). Au fond, on reconna\xEEt la reine Catherine de M\xE9dicis, pr\xE9sent\xE9e comme l\u2019instigatrice du massacre.`,
                        credit: "FDRMRZUSA/Wikimedia",
                        url: "https://assets.lls.fr/pages/47777754/lls-his2-ch5-icono2.jpg"
                      },
                      {
                        legend: `Pierre Mignard, <em>Louis XIV devant la ville de Maestricht</em>, 1673, mus\xE9e du ch\xE2teau de Versailles.

                    Louis XIV se lance dans une politique agressive et multiplie les guerres et les conqu\xEAtes. Il utilise ces batailles pour se mettre en sc\xE8ne dans le r\xF4le d\u2019un \xAB roi de guerre \xBB. Ici, il est v\xEAtu comme un empereur romain (armure, peau de l\xE9opard) et la Victoire le couronne de lauriers : le tableau c\xE9l\xE8bre la prise \xE9clair de Maestricht.`,
                        credit: "Ch\xE2teau de Versailles",
                        url: "https://assets.lls.fr/pages/47777754/lls-his2-ch5-icono3.jpg"
                      },
                      {
                        legend: `Jean-L\xE9on G\xE9r\xF4me, <em>R\xE9ception du Grand Cond\xE9</em> par Louis XIV, 1878, huile sur toile, mus\xE9e d\u2019Orsay, Paris.

                    Le faste de la cour de Louis XIV impressionne les contemporains et marque durablement les imaginaires collectifs. G\xE9r\xF4me, peintre du XIX\u1D49 si\xE8cle, propose ici une vision th\xE9\xE2tralis\xE9e d\u2019une c\xE9r\xE9monie de cour, dans laquelle le dispositif sc\xE9nique et architectural contribue \xE0 magnifier la puissance du Roi-Soleil.`,
                        credit: "Jan Arkesteijn/Wikimedia",
                        url: "https://assets.lls.fr/pages/47777754/lls-his2-ch5-icono4.jpg"
                      },
                      {
                        legend: `Fort de Vauban \xE0 Mont-Dauphin dans les Alpes.

                    Vauban fortifie les fronti\xE8res du royaume. Ses forts, construits selon de nouveaux principes architecturaux, font aujourd\u2019hui partie du patrimoine mondiale de l\u2019humanit\xE9.`,
                        credit: "Ville de Mont-Dauphin",
                        url: "https://assets.lls.fr/pages/47777754/lls-his2-ch5-icono5.jpg"
                      },
                      {
                        legend: `Louis-Michel Dumesnil, <em>Lit de justice tenu par Louis XV</em>, 1715, Grand Palais, Paris.

                    \xC0 la mort de Louis XIV, Philippe d\u2019Orl\xE9ans casse le testament du d\xE9funt roi et s\u2019impose comme r\xE9gent du royaume. La d\xE9cision est enregistr\xE9e au cours d\u2019un \xAB lit de justice \xBB : c\u2019est la sc\xE8ne qui est ici repr\xE9sent\xE9e. Le r\xF4le du Parlement est \xE0 la fois confirm\xE9 et minor\xE9.`,
                        credit: "The Picture Art Collection/Alamy",
                        url: "https://assets.lls.fr/pages/47777754/lls-his2-ch5-icono6.jpg"
                      },
                      {
                        legend: `D\xE9tail de Marseille, carte de Cassini.

                    La carte de Cassini, premi\xE8re carte topographique \xE0 l\u2019\xE9chelle du royaume de France, est une avanc\xE9e majeure dans le domaine de la cartographie ; elle exprime et mat\xE9rialise la nouvelle emprise du roi sur son royaume.`,
                        credit: "The Picture Art Collection/Alamy",
                        url: "https://assets.lls.fr/pages/47777754/lls-his2-ch5-icono7.jpg"
                      },
                      {
                        legend: `Pierre Paul Rubens, <em>Couronnement de Marie de M\xE9dicis</em>, v. 1625, mus\xE9e du Louvre, Paris.

                    Le couronnement du roi ou de la reine, en l\u2019occurrence de Marie de M\xE9dicis, est une c\xE9r\xE9monie soigneusement organis\xE9e afin de mettre en sc\xE8ne l\u2019autorit\xE9 du souverain.`,
                        credit: "Mbzt/Wikimedia",
                        url: "https://assets.lls.fr/pages/47777754/lls-his2-ch5-icono8.jpg"
                      },
                      {
                        legend: `Gaspar Bouttats, <em>Assassinat d\u2019Henri IV</em>, fin du XVII\u1D49 si\xE8cle, National Portrait Gallery, Londres.

                    Le 14 mai 1610, le roi de France Henri IV est assassin\xE9 par Ravaillac dans une rue de Paris. Son meurtrier est ex\xE9cut\xE9 et sa femme, Marie de M\xE9dicis, assure la r\xE9gence jusqu\u2019\xE0 la majorit\xE9 de leur fils Louis XIII. Sur cette gravure un peu post\xE9rieure, on voit Ravaillac se jeter sur le roi, poignard \xE0 la main.`,
                        credit: "Paris 16/Wikimedia",
                        url: "https://assets.lls.fr/pages/47777754/lls-his2-ch5-icono9.jpg"
                      }
                    ]
                  }
                ]
              },
              {
                id: 13,
                title: "Que savez-vous d\xE9j\xE0 sur... le chapitre 5 ?",
                vignette: "https://assets.lls.fr/pages/47777754/quiz-diagnostiquech5.jpg",
                shortDesc: "Un quiz diagnostique pour ouvrir le chapitre.",
                fullDesc: "Un quiz diagnostique pour faire le point sur les connaissances des \xE9l\xE8ves et ouvrir le chapitre 5.",
                tags: ["Quiz diagnostique"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/47777754/lls-histoire-chapitre5-quiz-diagnostique.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.ExternalLink,
                    url: "https://create.kahoot.it/share/que-savez-vous-deja-sur-laffirmation-de-letat-dans-le-royaume-de-france/a40fa7d0-ac21-4f10-938c-3ae63d85a65b"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/47777754/lls-histoire-chapitre5-quiz-diagnostique.zip"
                  }
                ]
              }
            ]
          },
          {
            goal: RESOURCE_GOALS.EXPLORER,
            resourcesPack: [
              {
                id: 18,
                title: "La Fronde",
                vignette: "https://assets.lls.fr/pages/47777754/hist2de5dossier-numrevoltes-mazarin.jpg",
                shortDesc: `Comment la Fronde montre-t-elle les r\xE9sistances au renforcement de l'autorit\xE9 royale ?`,
                fullDesc: `Plongez avec vos \xE9l\xE8ves au c\u0153ur de la Fronde : une p\xE9riode trouble dans laquelle les \xAB Frondeurs \xBB s'opposent au cardinal Mazarin et \xE0 l'absolutisme royal.`,
                tags: ["Dossier exclusif"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/47777754/lls-histoire-2nde-chapitre5-dossier-la-fronde.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "57933701"
                  }
                ]
              },
              {
                id: 19,
                title: `Faire l'histoire de la Saint-Barth\xE9lemy, avec l'historien J\xE9r\xE9mie Foa`,
                vignette: "https://assets.lls.fr/pages/47777754/his2de5dossiermassacrestbarthelemy.jpg",
                shortDesc: "Une activit\xE9 sur le massacre de la Saint-Barth\xE9lemy. ",
                fullDesc: `Une activit\xE9 sur le massacre de la Saint-Barth\xE9lemy, autour de l'ouvrage de J\xE9r\xE9mie Foa \xAB Tous ceux qui tombent. Visages du massacre de la Saint-Barth\xE9lemy \xBB, paru en 2021 aux \xE9ditions La D\xE9couverte.`,
                tags: ["Recherche \xE0 la loupe"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/47777754/lls-histoire-2nde-chapitre5-recherche-a-la-loupe-barthelemy.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "57933723"
                  }
                ]
              }
            ]
          },
          {
            goal: RESOURCE_GOALS.DIVERSIFIER,
            resourcesPack: [
              {
                id: 20,
                title: "Des ressources pour approfondir ",
                shortDesc: "Pour les \xE9l\xE8ves, le meilleur des ressources issues du web !",
                fullDesc: "Pour les \xE9l\xE8ves, le meilleur des ressources issues du web : une s\xE9lection d\u2019articles, romans, podcasts, films, jeux vid\xE9o, BDs, photos\u2026",
                tags: ["Padlet \xE9l\xE8ve"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Padlet,
                    id: "m639lz0o0iuzettr"
                  }
                ]
              },
              {
                id: 21,
                title: `\xC9crire un po\xE8me d'\xE9loge au roi`,
                vignette: "https://assets.lls.fr/pages/47777754/hist2de5app-autrementchevaliers-ordre.jpg",
                shortDesc: `Obtenez les faveurs du roi \xE0 l'aide d'un po\xE8me d'\xE9loge !`,
                fullDesc: `Invitez vos \xE9l\xE8ves \xE0 se mettre dans la peau d'un noble qui souhaite obtenir du roi un domaine foncier. Pour mettre le roi de bonne humeur, quoi de mieux que de lui \xE9crire un petit po\xE8me d'\xE9loge...`,
                tags: ["Apprendre autrement"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/47777754/lls-histoire-chapitre5-apprendre-autrement-eloge.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "57933532"
                  }
                ]
              },
              {
                id: 22,
                title: "Analyser le plafond de la Galerie des Glaces",
                vignette: "https://assets.lls.fr/pages/47777754/hist2de5app-autrementfranche-comte.jpg",
                shortDesc: "Analysez le plafond de la Galerie des Glaces au c\u0153ur du ch\xE2teau de Versailles !",
                fullDesc: `Proposez \xE0 vos \xE9l\xE8ves d'analyser le plafond de la Galerie des Glaces du ch\xE2teau de Versailles et ainsi de comprendre comment fonctionne la propagande royale.`,
                tags: ["Apprendre autrement"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/47777754/lls-histoire-chapitre5-apprendre-autrement-versailles.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "57907898 "
                  }
                ]
              },
              {
                id: 23,
                title: "Vivre \xE0 la cour",
                shortDesc: "D\xE9couvrez le ch\xE2teau de Versailles et le quotidien du Roi-Soleil",
                fullDesc: `D\xE9couvrez le ch\xE2teau de Versailles et suivez le Roi-Soleil le temps d'une journ\xE9e.`,
                tags: ["Activit\xE9 num\xE9rique"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "5e184dc53cf83c241e1446eb"
                  }
                ]
              }
            ]
          },
          {
            goal: RESOURCE_GOALS.MEMORISER,
            resourcesPack: [
              {
                id: 24,
                title: "3 minutes pour r\xE9viser le chapitre 5",
                vignette: "https://assets.lls.fr/pages/47777754/his2de5revision.png",
                shortDesc: "Une vid\xE9o pour r\xE9viser les points cl\xE9s du chapitre.",
                fullDesc: "Une vid\xE9o bilan pour r\xE9viser et m\xE9moriser les points cl\xE9s du chapitre 5.",
                tags: ["Vid\xE9o"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/6451347/histoire_2nde_chap_5.mp4"
                  }
                ]
              },
              {
                id: 25,
                title: `L'essentiel du chapitre 5`,
                vignette: "https://assets.lls.fr/pages/47777754/his2de5c4lit-justice-remplacement.jpg",
                shortDesc: "Les notions cl\xE9s r\xE9unies dans le m\xE9mo du chapitre.",
                fullDesc: "Les notions cl\xE9s du chapitre 5 sont pr\xE9sent\xE9es visuellement pour faciliter la m\xE9morisation : carte mentale, frise, mots cl\xE9s...",
                tags: ["Le m\xE9mo"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/47777754/lls-histoire-2nde-chapitre5-memo.pdf"
                  }
                ]
              }
            ]
          },
          {
            goal: RESOURCE_GOALS.ENTRAINER,
            resourcesPack: [
              {
                id: 27,
                title: `Qu'avez-vous appris sur...  l'\xE9dit de Nantes ?`,
                vignette: "https://assets.lls.fr/pages/47777754/his2de5pdp4henri-iv.jpg",
                shortDesc: "Un quiz pour tester les \xE9l\xE8ves sur le point de passage n\xB0 1.",
                fullDesc: "Un quiz de r\xE9vision pour revenir sur le point de passage n\xB0 1 et tester les connaissances des \xE9l\xE8ves en vue de l\u2019\xE9valuation.",
                tags: ["Quiz - Point de passage"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/47777754/lls-histoire-2nde-chapitre5-quiz-ppo1.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "62aae4523e740a001918f6aa"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/47777754/lls-histoire-2nde-chapitre5-quiz-ppo1.zip"
                  },
                  {
                    format: RESOURCE_FORMAT.ExternalLink,
                    url: "https://create.kahoot.it/share/quavez-vous-appris-sur-ledit-de-nantes/9f1a08a9-8a7d-4537-a468-5e5f7760d5f3"
                  }
                ]
              },
              {
                id: 28,
                title: `Qu'avez-vous appris sur...  l'ordonnance de Villers-Cotter\xEAts ?`,
                vignette: "https://assets.lls.fr/pages/47777754/his2de05pdp1timbre-villers-cotterets-retouche.jpg",
                shortDesc: "Un quiz pour tester les \xE9l\xE8ves sur le point de passage n\xB0 2.",
                fullDesc: "Un quiz de r\xE9vision pour revenir sur le point de passage n\xB0 2 et tester les connaissances des \xE9l\xE8ves en vue de l\u2019\xE9valuation.",
                tags: ["Quiz - Point de passage"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/47777754/lls-histoire-2nde-chapitre5-quiz-ppo2.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "62ac44923d89780018399a5e"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/47777754/lls-histoire-2nde-chapitre5-quiz-ppo2.zip"
                  },
                  {
                    format: RESOURCE_FORMAT.ExternalLink,
                    url: "https://create.kahoot.it/share/quavez-vous-appris-sur-lordonnance-de-villers-cotterets/ec25ebb9-cfce-4ce6-b0db-d2ba88cbe286"
                  }
                ]
              },
              {
                id: 29,
                title: `Qu'avez-vous appris sur...  la politique de Jean-Baptiste Colbert ?`,
                vignette: "https://assets.lls.fr/pages/47777754/his2de5pdp2vue-du-port-de-lorient-hue.jpg",
                shortDesc: "Un quiz pour tester les \xE9l\xE8ves sur le point de passage n\xB0 3.",
                fullDesc: "Un quiz de r\xE9vision pour revenir sur le point de passage n\xB0 3 et tester les connaissances des \xE9l\xE8ves en vue de l\u2019\xE9valuation.",
                tags: ["Quiz - Point de passage"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/47777754/lls-histoire-2nde-chapitre5-quiz-ppo3.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "62b0254548d49a0018e9ca1f"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/47777754/lls-histoire-2nde-chapitre5-quiz-ppo3.zip"
                  },
                  {
                    format: RESOURCE_FORMAT.ExternalLink,
                    url: "https://create.kahoot.it/share/quavez-vous-appris-sur-la-politique-de-jean-baptiste-colbert/a8fe80a6-4404-4a65-af0b-d03e751416ec"
                  }
                ]
              },
              {
                id: 30,
                title: `Qu'avez-vous appris sur...  Versailles ?`,
                vignette: "https://assets.lls.fr/pages/47777754/his2de5pdp3chateau-versailles-retouche.jpg",
                shortDesc: "Un quiz pour tester les \xE9l\xE8ves sur le point de passage n\xB0 4.",
                fullDesc: "Un quiz de r\xE9vision pour revenir sur le point de passage n\xB0 4 et tester les connaissances des \xE9l\xE8ves en vue de l\u2019\xE9valuation.",
                tags: ["Quiz - Point de passage"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/47777754/lls-histoire-2nde-chapitre5-quiz-ppo4.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "62b04b113239020011ede6ee"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/47777754/lls-histoire-2nde-chapitre5-quiz-ppo4.zip"
                  },
                  {
                    format: RESOURCE_FORMAT.ExternalLink,
                    url: "https://create.kahoot.it/share/quavez-vous-appris-sur-versailles/208a3018-a316-4b0d-bd62-54881539339a"
                  }
                ]
              },
              {
                id: 31,
                title: `Qu'avez-vous appris sur... le chapitre 5 ?`,
                vignette: "https://assets.lls.fr/pages/47777754/his2de5revlouis-xiv.jpg",
                shortDesc: `Un quiz pour r\xE9viser l'ensemble du chapitre.`,
                fullDesc: `Un quiz complet pour rebrasser et r\xE9viser l'ensemble des notions phares du chapitre 5.`,
                tags: ["Challenge de r\xE9vision"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/47777754/lls-histoire-2nde-chapitre5-quiz-challenge.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "62b07bc1b83105001142a951"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/47777754/lls-histoire-2nde-chapitre5-quiz-challenge.zip"
                  }
                ]
              },
              {
                id: 32,
                title: "Jeu des 7 familles",
                vignette: "https://assets.lls.fr/pages/47777754/his2ch5jeu.jpg",
                shortDesc: "Un jeu pour r\xE9viser la totalit\xE9 du chapitre.",
                fullDesc: `Un jeu des 7 familles pour r\xE9viser l'ensemble du chapitre de fa\xE7on ludique.`,
                tags: ["Jeu"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/47777754/lls-histoire-2nde-chapitre5-jeu.pdf"
                  }
                ]
              }
            ]
          }
        ]
      },
      // Chapitre 6
      5: {
        title: "Pr\xE9parer le chapitre 6",
        subtitle: `Le Manuel Premium s'enrichit de contenus num\xE9riques exclusifs, cr\xE9\xE9s avec les professeurs de la communaut\xE9, pour vous permettre de concevoir votre s\xE9quence id\xE9ale !`,
        stamp: "Nouveaut\xE9 : les ressources Premium",
        header: "https://assets.lls.fr/pages/51799143/his2de6ouvplassey-elephant.jpg",
        category: [
          {
            goal: RESOURCE_GOALS.COMMENCER,
            resourcesPack: [
              {
                id: 1,
                title: `Des id\xE9es pour s'inspirer`,
                shortDesc: "Le meilleur des ressources issues du web !",
                fullDesc: "Le meilleur des ressources issues du web : une s\xE9lection de vid\xE9os, articles, publications universitaires, romans, bandes dessin\xE9es\u2026",
                tags: ["Padlet enseignant"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Padlet,
                    id: "k9k0lu0h2p7026ch"
                  }
                ]
              },
              {
                id: 2,
                title: "\xC0 la d\xE9couverte du chapitre 6",
                vignette: "https://assets.lls.fr/pages/51799143/hg2-ch06-vignette-intro.jpg",
                shortDesc: "Une vid\xE9o immersive pour introduire le chapitre.",
                fullDesc: "Une vid\xE9o immersive pour poser le contexte historique et introduire les grandes probl\xE9matiques du chapitre.",
                tags: ["Vid\xE9o"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/51799143/intro-ch6-v3.mp4"
                  }
                ]
              },
              {
                id: 3,
                title: `Galerie d'images pour ouvrir le chapitre`,
                vignette: "https://assets.lls.fr/pages/51799143/his2de6banque-icono.jpeg",
                shortDesc: `Une s\xE9lection d'iconographies alternatives pour ouvrir le chapitre.`,
                fullDesc: `Une s\xE9lection d'iconographies alternatives pour ouvrir le chapitre. Pratique pour  personnaliser votre manuel et varier les entr\xE9es d'une ann\xE9e \xE0 l'autre !`,
                tags: ["Images d\u2019ouverture"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Gallery,
                    items: [
                      {
                        legend: `Willem van de Velde the Younger, The Battle of Texel, 1687, National Maritime Museum, Greenwich, Londres.

                    La puissance britannique s\u2019appuie, \xE0 partir de la fin du XVIe si\xE8cle, sur une flotte militaire bien organis\xE9e, qui redouble et prot\xE8ge une flotte marchande. Aux XVIIe et XVIIIe si\xE8cles, de grandes batailles navales opposent les royaumes europ\xE9ens, et la Grande-Bretagne s\u2019impose comme une puissance thalassocratique : <em>Britannia Rule the Sea</em>, selon le c\xE9l\xE8bre dicton.`,
                        credit: "Royal Museums Greenwich/Wikimedia",
                        url: "https://assets.lls.fr/pages/51799143/lls-his2-ch6-icono1.jpg"
                      },
                      {
                        legend: `Anonyme, <em>Ex\xE9cution de Charles 1er</em>, autour de 1649, gravure, Nationale Portrait Gallery, Londres.

                    Il est \xE9crit en haut de la gravure : La plus scandaleuse et odieuse mise \xE0 mort ex\xE9cut\xE9e sur le plus serein et le plus puissant roi de Grande-Bretagne, de France et d'Irlande, Carl Stuart, \xE0 Londres devant le palais de Whitehall, le mardi 30 janvier [calendrier julien] / 9 f\xE9vrier [calendrier gr\xE9gorien] de l'ann\xE9e 1649 , entre 14 h et 15 h.`,
                        credit: "National Portrait Gallery/Wikimedia",
                        url: "https://assets.lls.fr/pages/51799143/lls-his2-ch6-icono2.jpg"
                      },
                      {
                        legend: "Anton Hickel, <em>The House of Commons 1793-94</em>, XVIIIe si\xE8cle, huile sur toile, 322,6 x 449,6 cm, National Portrait Gallery, Londres.",
                        credit: "National Portrait Gallery/Wikimedia",
                        url: "https://assets.lls.fr/pages/51799143/lls-his2-ch6-icono3.jpg"
                      },
                      {
                        legend: `Richard Earlom, <em>The Exhibition at the Royal Academy in Pall Mall in 1771</em>, 1772, gravure, 47,2 x 55,6 cm, Royal Academy of Arts, Londres.

                    Le peintre repr\xE9sente ici la premi\xE8re exposition publique - quoique payante, afin de d\xE9courager les pauvres d\u2019y venir - de tableaux de la Royal Academy (depuis devenue une tradition annuelle). Il s\u2019agit en r\xE9alit\xE9 d\u2019une caricature, comme on le voit \xE0 travers plusieurs figures : la femme au centre observe le tableau de nu \xE0 travers son \xE9ventail, l\u2019homme au premier plan \xE0 droite semble basculer hors du cadre, etc.`,
                        credit: "\xA9Royal Academy of Arts, London; photographer: John Hammond",
                        url: "https://assets.lls.fr/pages/51799143/lls-his2-ch6-icono4.jpeg"
                      },
                      {
                        legend: `Giovanni Antonio Canal, dit Canaletto (1697\u20131768), <em>London, the Thames with View of the City and St. Paul\u2019s Cathedral</em>, 1747, huile sur toile, 118 \xD7 238 cm, National Gallery, Prague.


                    La cath\xE9drale Saint-Paul a \xE9t\xE9 construite apr\xE8s le grand incendie de 1666 qui d\xE9truisit enti\xE8rement l'ancienne cath\xE9drale. Elle se trouve au c\u0153ur de la City de Londres.
                    La Tamise, au premier plan, a une fonction primordiale pour la vie \xE9conomique de la capitale, comme en t\xE9moignent les nombreux navires qui la sillonnent.`,
                        credit: "Meisam/Wikimedia",
                        url: "https://assets.lls.fr/pages/51799143/lls-his2-ch6-icono5.jpg"
                      },
                      {
                        legend: `Johan Zoffany, <em>Le colonel Blair et sa famille</em>, 1786, Tate, Londres.

                    Ce genre de portraits, qui donnent \xE0 voir une famille britannique dans son int\xE9rieur, se multiplient dans les ann\xE9es 1780 ; ils contribuent \xE0 proposer une vision \xE9dulcor\xE9e de l\u2019empire britannique : la petite domestique indienne (\xE0 droite) semble presque int\xE9gr\xE9e \xE0 la famille, et rien n\u2019\xE9voque les r\xE9sistances \xE0 la colonisation anglaise de l\u2019Inde.`,
                        credit: "agefotostock/Alamy",
                        url: "https://assets.lls.fr/pages/51799143/lls-his2-ch6-icono6.jpg"
                      },
                      {
                        legend: `William Hogarth, <em>Triumph of the Deputy</em>, 1754-1755, huile sur toile, 101,5 x 127 cm, Sir John Soane\u2019s Museum, Londres.

                    Le c\xE9l\xE8bre peintre William Hogarth r\xE9alise une s\xE9rie de toiles humoristiques sur la vie politique britannique. Ici, le tableau s\u2019intitule <em>Le triomphe du d\xE9put\xE9</em> : le d\xE9put\xE9 nouvellement \xE9lu est port\xE9 en triomphe par ses partisans\u2026 non sans de nombreuses escarmouches sur le chemin, sans doute avec les partisans du candidat vaincu.`,
                        credit: `Sir John Soane's Museum/Wikimedia`,
                        url: "https://assets.lls.fr/pages/51799143/lls-his2-ch6-icono7.jpg"
                      },
                      {
                        legend: `William Hogarth, <em>The Polling</em>, 1754-1755, huile sur toile, 101,5 x 127 cm, Sir John Soanes\u2019s Museum, Londres.

                    Cette peinture repr\xE9sente les \xE9lections l\xE9gislatives au Parlement du royaume de Grande-Bretagne : le drapeau bleu repr\xE9sente les <em>Tories</em> et le drapeau orange les <em>Whigs</em>.`,
                        credit: `Sir John Soane's Museum/Wikimedia`,
                        url: "https://assets.lls.fr/pages/51799143/lls-his2-ch6-icono8.jpg"
                      },
                      {
                        legend: `Isaac Robert Cruikshank, <em>Suspension of the Habeas Corpus</em>, 1817, 18,4 x 11,6 cm, British Museum, Londres.

                    John Bull (personnage symbolisant le Royaume-Uni) est suspendu entre deux colonnes <em>Lords et Commons</em>. En 1817, l\u2019<em>Habeas Corpus</em> est momentan\xE9ment suspendu et cette caricature montre le choc devant cette perte de libert\xE9 pour les Britanniques.`,
                        credit: "Gibon Art/Alamy",
                        url: "https://assets.lls.fr/pages/51799143/lls-his2-ch6-icono9.jpg"
                      },
                      {
                        legend: `W.D Cooper, <em>Boston Tea Party, The History of North America</em>, 1789, gravure, Library of Congress, Washington.

                    Grand moment dans l\u2019histoire am\xE9ricaine, la <em>Boston Tea Party</em> marque une v\xE9ritable impulsion vers le processus d\u2019ind\xE9pendance.`,
                        credit: "Library of Congress/Wikimedia",
                        url: "https://assets.lls.fr/pages/51799143/lls-his2-ch6-icono10.jpg"
                      },
                      {
                        legend: `John Trumbull, <em>Surrender of General Burgoyne</em>, 1821, huile sur toile, 365,7 x 548,6 cm, United States Capitol, Washington.

                    Ce tableau reproduit la reddition du g\xE9n\xE9ral britannique John Burgoyne \xE0 Saratoga, le 17 octobre 1777 : v\xE9ritable tournant dans la Guerre d'ind\xE9pendance am\xE9ricaine qui emp\xEAcha les Britanniques de s\xE9parer la Nouvelle-Angleterre du reste des colonies. Le personnage central est le g\xE9n\xE9ral am\xE9ricain Horatio Gates, qui a refus\xE9 de prendre l'\xE9p\xE9e offerte par le g\xE9n\xE9ral Burgoyne et, le traitant en gentleman, l'a invit\xE9 dans sa tente. Tous les personnages de la sc\xE8ne sont des portraits d'officiers sp\xE9cifiques. John Trumbull a pr\xE9vu cette sc\xE8ne ext\xE9rieure pour contraster avec la D\xE9claration d'ind\xE9pendance \xE0 c\xF4t\xE9.`,
                        credit: "United States Capitol/Wikimedia",
                        url: "https://assets.lls.fr/pages/51799143/lls-his2-ch6-icono11.jpg"
                      },
                      {
                        legend: `Vue g\xE9n\xE9rale de la capitulation de Yorktown avec le blocus de la flotte fran\xE7aise, 1781, gravure sur cuivre.

                    Reddition, \xE0 Yorktown et Gloucester, de l'arm\xE9e britannique de Lord Cornwallis face aux arm\xE9es des \xC9tats-Unis d'Am\xE9rique et de la France command\xE9es par les g\xE9n\xE9raux George Washington et Rochambeau, le 19 octobre 1781. 
                    Cette sc\xE8ne offre une vue imaginaire de la reddition de Yorktown, avec des navires de guerre pr\xE8s du rivage \xE0 droite, de nombreuses troupes mass\xE9es et des officiers mont\xE9s sur la plaine \xE0 gauche. La coloration des uniformes est incorrecte. C'est l'un des rares documents mettant en sc\xE8ne le blocus naval fran\xE7ais et la victoire terrestre.`,
                        credit: "Brown University Library/Wikimedia",
                        url: "https://assets.lls.fr/pages/51799143/lls-his2-ch6-icono12.jpg"
                      },
                      {
                        legend: `Mather Brown, <em>Portrait d'Abigail Adam Smith</em>, 1785.

                    Abigail Adams fait partie de ces femmes oubli\xE9es de la r\xE9volution am\xE9ricaine. Elle joue un r\xF4le politique majeur aupr\xE8s de son mari, deuxi\xE8me pr\xE9sident des \xC9tats-Unis, allant jusqu\u2019\xE0 d\xE9battre avec lui de l\u2019esclavage, de l\u2019organisation du gouvernement et plaide en faveur des droits des femmes.`,
                        credit: "National Park Service/Wikimedia",
                        url: "https://assets.lls.fr/pages/51799143/lls-his2-ch6-icono13.jpg"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            goal: RESOURCE_GOALS.ETUDIER,
            resourcesPack: [
              {
                id: 4,
                title: `1679 - 1689 - L'<em>Habeas Corpus</em> et le <em>Bill of Rights</em>, le refus de l'arbitraire royal`,
                vignette: "https://assets.lls.fr/pages/51799143/hg2-ch06-vignette-habeascorpus.jpg",
                shortDesc: `Comment l\u2019<em>Habeas Corpus</em> et le <em>Bill of Rights</em> luttent-ils contre l'arbitraire royal ?`,
                fullDesc: `Une vid\xE9o pour comprendre le contexte dans lequel l'<em>Habeas Corpus</em> et le <em>Bill of Rights</em> ont \xE9t\xE9 adopt\xE9s et la mani\xE8re dont ils garantissent les libert\xE9s individuelles en Angleterre d\xE8s la fin du XVIIe si\xE8cle.`,
                tags: ["Vid\xE9o"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/51799143/habeas-corpus-v3.mp4"
                  }
                ]
              },
              {
                id: 5,
                title: "Voltaire et la publication des <em>Lettres anglaises</em> (1733)",
                vignette: "https://assets.lls.fr/pages/51799143/ch06-vignette-voltaire.jpg",
                shortDesc: "Comment le mod\xE8le britannique influence\u2011t\u2011il les \xE9crits de Voltaire ?",
                fullDesc: `Une vid\xE9o pour d\xE9couvrir l'influence qu'a eu le mod\xE8le britannique sur les \xE9crits de Voltaire, notamment sur un ouvrage fondateur de la philosophie des Lumi\xE8res : les <em>Lettres anglaises</em> ou <em>Lettres philosophiques</em>.`,
                tags: ["Vid\xE9o"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/51799143/voltaire-v4-1.mp4"
                  }
                ]
              },
              {
                id: 6,
                title: `George Washinghton, premier pr\xE9sident des \xC9tats-Unis d'Am\xE9rique`,
                vignette: "https://assets.lls.fr/pages/51799143/hg2-ch06-vignette-washington.jpg",
                shortDesc: "Comment George Washington fonde\u2011t\u2011il de nouvelles pratiques de gouvernement ?",
                fullDesc: `Une vid\xE9o pour retracer la vie et le parcours politique du premier pr\xE9sident des \xC9tats-Unis d'Am\xE9rique.`,
                tags: ["Vid\xE9o"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/51799143/george-washington-v3-1.mp4"
                  }
                ]
              }
            ]
          },
          {
            goal: RESOURCE_GOALS.EXPLORER,
            resourcesPack: [
              {
                id: 7,
                title: `L'\xE9ducation des filles vue par Mary Wollstonecraft`,
                vignette: "https://assets.lls.fr/pages/51799143/his2de6dossierwollstonecraft.jpg",
                shortDesc: `Comment Mary Wollstonecraft per\xE7oit-elle l'\xE9ducation des femmes ?`,
                fullDesc: `D\xE9couvrez, dans ce dossier, la pens\xE9e originale de la pionni\xE8re du f\xE9minisme sur l'\xE9ducation des femmes.`,
                tags: ["Dossier exclusif"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/51799143/lls-histoire-2nde-chapitre6-dossier-wollstonecraft.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "51579604"
                  }
                ]
              },
              {
                id: 8,
                title: "Les limites du mod\xE8le am\xE9ricain",
                vignette: "https://assets.lls.fr/pages/51799143/dossier-americain.png",
                shortDesc: "Quelles sont les limites du mod\xE8le am\xE9ricain ?",
                fullDesc: `Un dossier pour s'interroger sur les limites du nouveau mod\xE8le am\xE9ricain, notamment l'esclavagisme.`,
                tags: ["Dossier exclusif"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/51799143/lls-histoire-2nde-chapitre6-dossier-americain.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "51583735"
                  }
                ]
              },
              {
                id: 9,
                title: `Londres au XVIIIe si\xE8cle : l'essor d'une capitale europ\xE9enne`,
                vignette: "https://assets.lls.fr/pages/51799143/his2de6dossierlondres.jpg",
                shortDesc: "Comment Londres devient-elle une capitale europ\xE9enne au XVIIIe si\xE8cle ?",
                fullDesc: `Un dossier pour s'immerger au c\u0153ur de Londres au XVIIIe si\xE8cle.`,
                tags: ["Dossier exclusif"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/51799143/lls-histoire-2nde-chapitre6-dossier-londres.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "7745330"
                  }
                ]
              },
              {
                id: 10,
                title: `L'invention des symboles nationaux`,
                vignette: "https://assets.lls.fr/pages/51799143/his2de6dossiersymbole.jpg",
                shortDesc: "De quelles mani\xE8res les symboles nationaux sont-ils invent\xE9s ?",
                fullDesc: `Un dossier pour d\xE9couvrir le processus d'adoption des symboles nationaux \xE0 travers l'exemple de la jeune r\xE9publique des \xC9tats-Unis d\u2019Am\xE9rique en 1776.`,
                tags: ["Dossier exclusif"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/51799143/lls-histoire-2nde-chapitre6-dossier-symbole.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "7475747"
                  }
                ]
              }
            ]
          },
          {
            goal: RESOURCE_GOALS.DIVERSIFIER,
            resourcesPack: [
              {
                id: 11,
                title: "Des ressources pour approfondir ",
                shortDesc: "Pour les \xE9l\xE8ves, le meilleur des ressources issues du web !",
                fullDesc: "Pour les \xE9l\xE8ves, le meilleur des ressources issues du web : une s\xE9lection d\u2019articles, romans, podcasts, films, jeux vid\xE9o, BDs, photos\u2026",
                tags: ["Padlet \xE9l\xE8ve"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Padlet,
                    id: "66e5un5glrshy1sf"
                  }
                ]
              },
              {
                id: 12,
                title: `R\xE9diger un discours sur l'ind\xE9pendance des \xC9tats-Unis`,
                vignette: "https://assets.lls.fr/pages/51799143/his2de6aaindependance.jpg",
                shortDesc: `R\xE9digez un discours pour c\xE9l\xE9brer les trois ans de l'Ind\xE9pendance.`,
                fullDesc: `Les \xC9tats-Unis d'Am\xE9rique f\xEAtent les trois ans de leur ind\xE9pendance. Devenez George Washington le temps d'une activit\xE9, r\xE9digez un discours sur cet \xE9v\xE9nement et prononcez-le devant des journalistes et des philosophes.`,
                tags: ["Apprendre autrement"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/51799143/lls-histoire-2nde-chapitre6-apprendre-autrement-independance.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "51584032"
                  }
                ]
              },
              {
                id: 13,
                title: "Reconstituer un d\xE9bat parlementaire",
                vignette: "https://assets.lls.fr/pages/51799143/his2de6aaparlementaire.jpg",
                shortDesc: `D\xE9battez sur l'adoption de l'<em>Habeas Corpus</em> et du <em>Bill of Rights</em>.`,
                fullDesc: `Orateurs ! Il est temps d'enfiler vos tenues de membres du Parlement et de pr\xE9parer vos arguments pour un grand d\xE9bat, celui de l'adoption de deux textes fondateurs : l'<em>Habeas Corpus</em> et le <em>Bill of Rights</em>.`,
                tags: ["Apprendre autrement"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/51799143/lls-histoire-2nde-chapitre6-apprendre-autrement-debat.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "51587361"
                  }
                ]
              },
              {
                id: 14,
                title: "Inventer un nouveau r\xE9gime politique",
                vignette: "https://assets.lls.fr/pages/51799143/his2de6aapolitique.jpg",
                shortDesc: `Aidez les P\xE8res fondateurs \xE0 r\xE9diger la Constitution d'un nouveau r\xE9gime politique.`,
                fullDesc: "Les P\xE8res fondateurs sont r\xE9unis \xE0 Philadelphie, en mai 1787, pour r\xE9diger la Constitution du nouveau r\xE9gime. Ils vous demandent votre aide pour cette t\xE2che essentielle : \xE0 vous de trouver des id\xE9es de r\xE9gimes politiques possibles !",
                tags: ["Apprendre autrement"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/51799143/lls-histoire-2nde-chapitre6-apprendre-autrement-politique.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "6528858"
                  }
                ]
              },
              {
                id: 15,
                title: "\xC0 la Maison Blanche",
                shortDesc: "R\xE9alisez une frise sur les pr\xE9sidents am\xE9ricains.",
                fullDesc: "R\xE9alisez une frise sur les principaux pr\xE9sidents am\xE9ricains, de 1776 \xE0 nos jours.",
                tags: ["Activit\xE9 num\xE9rique"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "5e29a38eab06d104232be29d"
                  }
                ]
              }
            ]
          },
          {
            goal: RESOURCE_GOALS.MEMORISER,
            resourcesPack: [
              {
                id: 16,
                title: "3 minutes pour r\xE9viser le chapitre 6",
                vignette: "https://assets.lls.fr/pages/51799143/his2de6revision.png",
                shortDesc: "Une vid\xE9o pour r\xE9viser les points cl\xE9s du chapitre.",
                fullDesc: "Une vid\xE9o bilan pour r\xE9viser et m\xE9moriser les points cl\xE9s du chapitre 6.",
                tags: ["Vid\xE9o"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/6462288/histoire_2de_chap_6.mp4"
                  }
                ]
              },
              {
                id: 17,
                title: `L'essentiel du chapitre 6`,
                vignette: "https://assets.lls.fr/pages/51799143/his2de6memo.jpg",
                shortDesc: "Les notions cl\xE9s r\xE9unies dans le m\xE9mo du chapitre.",
                fullDesc: "Les notions cl\xE9s du chapitre 6 sont pr\xE9sent\xE9es visuellement pour faciliter la m\xE9morisation : carte mentale, frise, mots cl\xE9s...",
                tags: ["Le m\xE9mo"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/51799143/lls-histoire-2nde-chapitre6-memo.pdf"
                  }
                ]
              },
              {
                id: 18,
                title: "La monarchie parlementaire... en bulles !",
                vignette: "https://assets.lls.fr/pages/51799365/his2de6bd.png",
                shortDesc: "Une courte BD pour m\xE9moriser autrement.",
                fullDesc: "Une illustration retrace une notion cl\xE9 du chapitre pour permettre aux \xE9l\xE8ves de la m\xE9moriser autrement.",
                tags: ["Le chapitre en BD"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: " https://assets.lls.fr/pages/51799143/lls-histoire-chapitre6-bande-dessinee.pdf"
                  }
                ]
              }
            ]
          },
          {
            goal: RESOURCE_GOALS.ENTRAINER,
            resourcesPack: [
              {
                id: 19,
                title: `Qu'avez-vous appris sur... L'<em>Habeas Corpus</em> et le <em>Bill of Rights</em> ?`,
                vignette: "https://assets.lls.fr/pages/51799143/his2de6quizppo1.jpg",
                shortDesc: "Un quiz pour tester les \xE9l\xE8ves sur le point de passage n\xB0 1.",
                fullDesc: "Un quiz de r\xE9vision pour revenir sur le point de passage n\xB0 1 et tester les connaissances des \xE9l\xE8ves en vue de l\u2019\xE9valuation.",
                tags: ["Quiz - Point de passage"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/51799143/lls-histoire-2nde-chapitre6-quiz-ppo1.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "6231e9e2ac2ebd0014081ba7"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/51799143/lls-histoire-2nde-chapitre6-quiz-ppo1.zip"
                  },
                  {
                    format: RESOURCE_FORMAT.ExternalLink,
                    url: "https://create.kahoot.it/details/85506e97-2d74-4068-8fa0-cd10c288cf74"
                  }
                ]
              },
              {
                id: 20,
                title: `Qu'avez-vous appris sur... Voltaire et le mod\xE8le britannique ?`,
                vignette: "https://assets.lls.fr/pages/51799143/his2de6quizppo2.jpg",
                shortDesc: "Un quiz pour tester les \xE9l\xE8ves sur le point de passage n\xB0 2.",
                fullDesc: "Un quiz de r\xE9vision pour revenir sur le point de passage n\xB0 2 et tester les connaissances des \xE9l\xE8ves en vue de l\u2019\xE9valuation.",
                tags: ["Quiz - Point de passage"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/51799143/lls-histoire-2nde-chapitre6-quiz-ppo2.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "622f4bee7c4add0017d05642"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/51799143/lls-histoire-2nde-chapitre6-quiz-ppo2.zip"
                  },
                  {
                    format: RESOURCE_FORMAT.ExternalLink,
                    url: "https://create.kahoot.it/share/quavez-vous-appris-sur-voltaire-et-le-modele-britannique/82e28f97-2a41-4216-b708-767547c88bd0"
                  }
                ]
              },
              {
                id: 21,
                title: `Qu'avez-vous appris sur... George Washington ?`,
                vignette: "https://assets.lls.fr/pages/51799143/his2de6quizppo3.jpg",
                shortDesc: "Un quiz pour tester les \xE9l\xE8ves sur le point de passage n\xB0 3.",
                fullDesc: "Un quiz de r\xE9vision pour revenir sur le point de passage n\xB03 et tester les connaissances des \xE9l\xE8ves en vue de l\u2019\xE9valuation.",
                tags: ["Quiz - Point de passage"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/51799143/lls-histoire-2nde-chapitre6-quiz-ppo3-1.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "622f3e5e7c4add0017d05484"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/51799143/lls-histoire-2nde-chapitre6-quiz-ppo3.zip"
                  },
                  {
                    format: RESOURCE_FORMAT.ExternalLink,
                    url: "https://create.kahoot.it/share/quavez-vous-appris-sur-george-washington/10bfbddb-8ff9-4f5e-864a-277c40273eaf"
                  }
                ]
              },
              {
                id: 22,
                title: `Qu'avez-vous appris sur... le chapitre 6 ?`,
                vignette: "https://assets.lls.fr/pages/51799143/his2de6quizchallenge.jpg",
                shortDesc: `Un quiz pour r\xE9viser l'ensemble du chapitre.`,
                fullDesc: `Un quiz complet pour rebrasser et r\xE9viser l'ensemble des notions phares du chapitre 6.`,
                tags: ["Challenge de r\xE9vision"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/51799143/lls-histoire-2nde-chapitre6-quiz-challenge.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "62389788cb5973001a1a1e01"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/51799143/lls-histoire-2nde-chapitre6-quiz-challenge-1.zip"
                  }
                ]
              },
              {
                id: 23,
                title: `Jeu de l'oie`,
                vignette: "https://assets.lls.fr/pages/51799143/his2de6jeu.jpg",
                shortDesc: "Un jeu pour r\xE9viser la totalit\xE9 du chapitre.",
                fullDesc: `Un jeu de l'oie pour r\xE9viser les notions, les dates et les personnages du chapitre 6 de fa\xE7on ludique.`,
                tags: ["Jeu"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/51799143/lls-histoire-2nde-chapitre6-jeu.pdf"
                  }
                ]
              }
            ]
          }
        ]
      },
      // Chapitre 7
      6: {
        title: "Pr\xE9parer le chapitre 7",
        subtitle: `Le Manuel Premium s'enrichit de contenus num\xE9riques exclusifs, cr\xE9\xE9s avec les professeurs de la communaut\xE9, pour vous permettre de concevoir votre s\xE9quence id\xE9ale !`,
        stamp: "Nouveaut\xE9 : les ressources Premium",
        header: "https://assets.lls.fr/pages/51799365/lls-his2-ch7-icono10-1.jpg",
        category: [
          {
            goal: RESOURCE_GOALS.COMMENCER,
            resourcesPack: [
              {
                id: 1,
                title: `Des id\xE9es pour s'inspirer`,
                shortDesc: "Le meilleur des ressources issues du web !",
                fullDesc: "Le meilleur des ressources issues du web : une s\xE9lection de vid\xE9os, articles, publications universitaires, romans, bandes dessin\xE9es\u2026",
                tags: ["Padlet enseignant"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Padlet,
                    id: "ptax7kel1d1oisvl"
                  }
                ]
              },
              {
                id: 2,
                title: "\xC0 la d\xE9couverte du chapitre 7",
                vignette: "https://assets.lls.fr/pages/51799365/hg2-ch07-vignette-intro.jpg",
                shortDesc: "Une vid\xE9o immersive pour introduire le chapitre.",
                fullDesc: "Une vid\xE9o immersive pour poser le contexte historique et introduire les grandes probl\xE9matiques du chapitre.",
                tags: ["Vid\xE9o"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/51799365/intro-ch7-v3.mp4"
                  }
                ]
              },
              {
                id: 3,
                title: `Galerie d'images pour ouvrir le chapitre`,
                vignette: "https://assets.lls.fr/pages/51799365/his2de7banque-icono.jpg",
                shortDesc: `Une s\xE9lection d'iconographies alternatives pour ouvrir le chapitre.`,
                fullDesc: `Une s\xE9lection d'iconographies alternatives pour ouvrir le chapitre. Pratique pour personnaliser votre manuel et varier les entr\xE9es d'une ann\xE9e \xE0 l'autre !`,
                tags: ["Images d\u2019ouverture"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Gallery,
                    items: [
                      {
                        legend: `Henri Testelin, <em>\xC9tablissement de l'Acad\xE9mie des Sciences et fondation de l'observatoire, 1666</em>, XVIIe si\xE8cle, huile sur toile, 348 x 590 cm.

                    Colbert pr\xE9sente \xE0 Louis XIV les membres de l'Acad\xE9mie Royale des Sciences cr\xE9\xE9e en 1667.`,
                        credit: "Palace of Versailles/Wikimedia",
                        url: "https://assets.lls.fr/pages/51799365/lls-his2-ch7-icono1.png"
                      },
                      {
                        legend: `Felix Parra, <em>Galileo d\xE9montrant les nouvelles th\xE9ories d'astronomie \xE0 l'Universit\xE9 de Padoue</em>, 1876, Museo Nacional de Arte de Mexico, Mexique.

                    Les peintres du XIXe si\xE8cle transforment Galil\xE9e en l\xE9gende, et en font une incarnation du savoir contre l\u2019obscurantisme de la religion - quitte \xE0 d\xE9former la r\xE9alit\xE9, comme ici, o\xF9 l\u2019on a l\u2019impression que Galil\xE9e explique que la terre est ronde, ce qui, bien s\xFBr, \xE9tait d\xE9j\xE0 connu de tous depuis des mill\xE9naires.`,
                        credit: "Museo Nacional de Arte/Wikimedia",
                        url: "https://assets.lls.fr/pages/51799365/lls-his2-ch7-icono2.jpg"
                      },
                      {
                        legend: "William Harvey diss\xE8que le corps de Thomas Parr, vers 1900.",
                        credit: "Wellcome collection/Wikimedia",
                        url: "https://assets.lls.fr/pages/51799365/lls-his2-ch7-icono3.jpg"
                      },
                      {
                        legend: `E. Phillips Fox, <em>Arriv\xE9e de James Cook \xE0 Botany Bay, 1770</em>, 1902, huile sur toile, 192.2 x 265.4 cm, National Gallery of Victoria, Melbourne.

                    Les exp\xE9ditions scientifiques jouent un r\xF4le fondamental dans la d\xE9couverte du monde par les Lumi\xE8res. 
                    Ici, l\u2019explorateur britannique James Cook d\xE9barque sur les c\xF4tes australiennes, encore inconnues des Europ\xE9ens. Cette exploration lui permettra \xE9galement de cartographier Terre-Neuve et la Nouvelle-Z\xE9lande.`,
                        credit: "National Gallery of Victoria/Wikimedia",
                        url: "https://assets.lls.fr/pages/51799365/lls-his2-ch7-icono4.jpg"
                      },
                      {
                        legend: `Michel-Barth\xE9lemy Ollivier, <em>Le Th\xE9 \xE0 l\u2019anglaise dans le salon des quatre glaces au Temple</em>, 1766, huile sur toile, 53 x 68 cm, Ch\xE2teau de Versailles.

                    Les id\xE9es nouvelles circulent dans les salons. Les aristocrates, comme ici le prince de Conti, ou les grands bourgeois re\xE7oivent dans des h\xF4tels particuliers. Des musiciens \u2013 ici, Mozart au clavecin \u2013 se produisent, des auteurs lisent leurs romans et leurs essais philosophiques. On y joue des pi\xE8ces, parfois politiques. Les salons sont aussi des lieux o\xF9 des sciences nouvelles sont pr\xE9sent\xE9es.`,
                        credit: "Ch\xE2teau de Versailles/Wikimedia",
                        url: "https://assets.lls.fr/pages/51799365/lls-his2-ch7-icono5.jpg"
                      },
                      {
                        legend: `Jean-Baptiste Hilair, <em>Le Jardin du roi</em>, dessin \xE0 la plume et encre de Chine, 17,4 x 25 cm, BnF, 1794.

                    Au XVIIIe si\xE8cle, le Jardin du Roi, qui sera ensuite connu sous le nom de Jardin des Plantes, comprend une multitude de plantes m\xE9dicinales. De nombreuses esp\xE8ces exotiques sont pr\xE9sent\xE9es dans ce jardin.`,
                        credit: "BNF",
                        url: "https://assets.lls.fr/pages/51799365/lls-his2-ch7-icono6.jpeg"
                      },
                      {
                        legend: `Portrait anonyme de Claudine Picardet, XIXe si\xE8cle.

                    Claudine Picardet a eu un r\xF4le similaire \xE0 celui d\u2019Emilie du Ch\xE2telet dans la diffusion des savoirs des Lumi\xE8res : elle a traduit notamment un ouvrage de Lavoisier. Sur cette peinture, elle serait le personnage tenant un livre \xE0 la main.`,
                        credit: "Pour la science/Wikimedia",
                        url: "https://assets.lls.fr/pages/51799365/lls-his2-ch7-icono7.jpg"
                      },
                      {
                        legend: `Maria Sibylla Merian, <em>Metamorphosis insectorum Surinamensium</em>, 1705, dessin.

                    Voici l\u2019une des planches d\u2019observation d\u2019Anna Maria Sibylla Merian, une naturaliste, artiste peintre et grande exploratrice du XVIIIe si\xE8cle.`,
                        credit: "Hgrobe/Wikimedia",
                        url: "https://assets.lls.fr/pages/51799365/lls-his2-ch7-icono8.jpg"
                      },
                      {
                        legend: `Dessin anonyme repr\xE9sentant Lavoisier dans son laboratoire, 1790.

                    Le savant fran\xE7ais Lavoisier (1743-1794) proc\xE8de \xE0 une exp\xE9rience scientifique. Chimiste, il \xE9tudie l\u2019oxyg\xE8ne et met en \xE9vidence le lien entre l\u2019effort et la respiration.`,
                        credit: "Stefano Bianchetti/Bridgeman",
                        url: "https://assets.lls.fr/pages/51799365/lls-his2-ch7-icono9.jpg"
                      },
                      {
                        legend: `Claude Louis Desrais, La premi\xE8re montgolfi\xE8re habit\xE9e, con\xE7ue par les fr\xE8res Montgolfier, d\xE9colle du jardin de l'atelier R\xE9veillon \xE0 Paris, le 19 octobre 1783.`,
                        credit: "AKG",
                        url: "https://assets.lls.fr/pages/51799365/lls-his2-ch7-icono10.jpg"
                      },
                      {
                        legend: `Currier & Ives, <em>Franklin's Experiment, June 1752</em>, 1876, gravure, The Pennyslvania State University, Pennsylvanie.

                    Benjamin Franklin fait une exp\xE9rience, pour tester la nature de la foudre et de l'\xE9lectricit\xE9, \xE0 partir de laquelle il a invent\xE9 le paratonnerre.`,
                        credit: "The Pennsylvania State University/Wikimedia",
                        url: "https://assets.lls.fr/pages/51799365/lls-his2-ch7-icono11.jpg"
                      },
                      {
                        legend: `Nicolas de Fer, <em>Le Canal royal de Languedoc pour la jonction des deux mers, oc\xE9an et M\xE9diterran\xE9e</em>, 1716, 28.5 x 43 cm, National Library of Portugal, Lisbonne. 

                    Le Canal du Midi est l\u2019une des r\xE9alisations majeures du r\xE8gne de Louis XIV. La carte de Nicolas de Fer t\xE9moigne des prouesses techniques ainsi que des progr\xE8s faits dans le domaine de l'ing\xE9nierie.`,
                        credit: "National Library of Portugal/Wikimedia",
                        url: "https://assets.lls.fr/pages/51799365/lls-his2-ch7-icono12.jpg"
                      }
                    ]
                  }
                ]
              },
              {
                id: 4,
                title: "Que savez-vous d\xE9j\xE0 sur... le chapitre 7 ?",
                vignette: "https://assets.lls.fr/pages/51799365/his2de7quiz-diagnostique.jpg",
                shortDesc: "Un quiz diagnostique pour ouvrir le chapitre.",
                fullDesc: "Un quiz diagnostique pour faire le point sur les connaissances des \xE9l\xE8ves et ouvrir le chapitre 7.",
                tags: ["Quiz diagnostique"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/51799365/lls-histoire-2nde-chapitre7-quiz-diagnostique.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.ExternalLink,
                    url: "https://create.kahoot.it/share/que-savez-vous-deja-sur-les-lumieres-et-le-developpement-des-sciences/cd1bd49a-66c2-486d-8781-f5f034e6a725"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/51799365/lls-histoire-2nde-chapitre7-quiz-diagnostique.zip"
                  }
                ]
              }
            ]
          },
          {
            goal: RESOURCE_GOALS.ETUDIER,
            resourcesPack: [
              {
                id: 5,
                title: "Galil\xE9e, symbole de la rupture scientifique du XVIIe si\xE8cle",
                vignette: "https://assets.lls.fr/pages/51799365/hg2-ch07-vignette-galilee.jpg",
                shortDesc: "Pourquoi Galil\xE9e est-il un symbole de la rupture scientifique du XVIIe si\xE8cle ?",
                fullDesc: `Une vid\xE9o pour d\xE9couvrir l'h\xE9liocentrisme, la th\xE9orie d\xE9fendue par Galil\xE9e, un acteur majeur de la R\xE9volution scientifique.`,
                tags: ["Vid\xE9o"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/51799365/galilee-v3.mp4"
                  }
                ]
              },
              {
                id: 6,
                title: "\xC9milie du Ch\xE2telet, femme de science",
                vignette: "https://assets.lls.fr/pages/51799365/hg2-ch07-vignette-duchatelet-1.jpg",
                shortDesc: `Quelle est la place d'\xC9milie du Ch\xE2telet dans les sciences et la soci\xE9t\xE9 des Lumi\xE8res ?`,
                fullDesc: `Une vid\xE9o pour retracer le parcours et les \u0153uvres scientifiques d'une figure f\xE9minine essentielle des Lumi\xE8res.`,
                tags: ["Vid\xE9o"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/51799365/emilie-du-chatelet-v3.mp4"
                  }
                ]
              },
              {
                id: 7,
                title: "1712 - Thomas Newcomen met au point une machine \xE0 vapeur",
                vignette: "https://assets.lls.fr/pages/51799365/hg2-ch07-vignette-newcomen.jpg",
                shortDesc: "En quoi la machine \xE0 vapeur de Thomas Newcomen est-elle une innovation technique ?",
                fullDesc: "Une vid\xE9o pour comprendre le fonctionnement de la machine \xE0 vapeur de Thomas Newcomen et son importance.",
                tags: ["Vid\xE9o"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/51799365/thomas-newcomen-v3.mp4"
                  }
                ]
              }
            ]
          },
          {
            goal: RESOURCE_GOALS.EXPLORER,
            resourcesPack: [
              {
                id: 8,
                title: "Ang\xE9lique du Coudray, sage-femme du XVIIIe si\xE8cle",
                vignette: "https://assets.lls.fr/pages/51799365/his2de7dossiercoudray.jpg",
                shortDesc: "Comment Ang\xE9lique du Coudray a-t-elle r\xE9volutionn\xE9 le domaine de l\u2019obst\xE9trique ?",
                fullDesc: `Un dossier pour d\xE9couvrir l'invention imagin\xE9e et utilis\xE9e par Ang\xE9lique du Coudray pour former les sages-femmes du XVIIIe si\xE8cle.`,
                tags: ["Dossier exclusif"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/51799365/lls-histoire-2nde-chapitre7-dossier-du-coudray.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "51589081"
                  }
                ]
              },
              {
                id: 9,
                title: `L'anatomie au si\xE8cle des Lumi\xE8res`,
                vignette: "https://assets.lls.fr/pages/51799365/his2de7dossieranatomie.jpg",
                shortDesc: `Quels sont les progr\xE8s de l'anatomie au si\xE8cle des Lumi\xE8res ?`,
                fullDesc: `Ce dossier propose d'explorer les progr\xE8s d'une discipline en pleine expansion au si\xE8cle des Lumi\xE8res : l'anatomie.`,
                tags: ["Dossier exclusif"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/51799365/lls-histoire-2nde-chapitre7-dossier-anatomie.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "51591237"
                  }
                ]
              },
              {
                id: 10,
                title: `L'aventure de l'<em>Encyclop\xE9die</em>`,
                vignette: "https://assets.lls.fr/pages/51799365/his2de7dossierencyclopedie.jpg",
                shortDesc: `En quoi l'<em>Encyclop\xE9die</em> permet-elle de promouvoir les id\xE9es des Lumi\xE8res ?`,
                fullDesc: `Un dossier pour explorer l'<em>Encyclop\xE9die</em> de Diderot et d'Alembert, synth\xE8se in\xE9gal\xE9e de toutes les connaissances du XVIIIe si\xE8cle.`,
                tags: ["Dossier exclusif"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/51799365/lls-histoire-2nde-chapitre7-dossier-encyclopedie.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "7743051"
                  }
                ]
              }
            ]
          },
          {
            goal: RESOURCE_GOALS.DIVERSIFIER,
            resourcesPack: [
              {
                id: 11,
                title: "Des ressources pour approfondir",
                shortDesc: "Pour les \xE9l\xE8ves, le meilleur des ressources issues du web !",
                fullDesc: "Pour les \xE9l\xE8ves, le meilleur des ressources issues du web : une s\xE9lection d\u2019articles, romans, podcasts, films, jeux vid\xE9o, BDs, photos\u2026",
                tags: ["Padlet \xE9l\xE8ve"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Padlet,
                    id: "d42xe1c55kkb2q6h"
                  }
                ]
              },
              {
                id: 12,
                title: "Reconstituer un salon des Lumi\xE8res",
                vignette: "https://assets.lls.fr/pages/51799365/his2de7aasalon.jpg",
                shortDesc: "D\xE9couvrez un salon litt\xE9raire du XVIIIe si\xE8cle.",
                fullDesc: "Madame Geoffrin vous invite \xE0 son salon litt\xE9raire ! Choisissez votre personnage, enfilez votre plus belle tenue, et pr\xE9parez votre intervention !",
                tags: ["Apprendre autrement"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/51799365/lls-histoire-2nde-chapitre7-apprendre-autrement-salon.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "51591149"
                  }
                ]
              },
              {
                id: 13,
                title: "R\xE9aliser un article sur Galil\xE9e ou Newcomen",
                vignette: "https://assets.lls.fr/pages/51799365/his2de7aainterview.jpg",
                shortDesc: "Devenez journaliste et rencontrez Galil\xE9e ou Newcomen !",
                fullDesc: "Vos lecteurs veulent en savoir davantage sur Galil\xE9e, Thomas Newcomen et leurs d\xE9couvertes. R\xE9alisez une interview de ces deux c\xE9l\xE8bres savants du si\xE8cle des Lumi\xE8res !",
                tags: ["Apprendre autrement"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/51799365/lls-histoire-2nde-chapitre7-apprendre-autrement-interview.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "51591560"
                  }
                ]
              },
              {
                id: 14,
                title: "Inventeurs en herbe",
                shortDesc: "Cr\xE9ez une invention spectaculaire !",
                fullDesc: "\xC0 votre tour ! Cr\xE9ez une invention spectaculaire, puis pr\xE9sentez-la au public.",
                tags: ["Activit\xE9 num\xE9rique"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "5e60ba4a24b7570fe79fd1bd"
                  }
                ]
              },
              {
                id: 15,
                title: `Au si\xE8cle des Lumi\xE8res, l'histoire est-elle une science ?`,
                vignette: "https://assets.lls.fr/pages/51799365/his2de7cliohistoire.jpg",
                shortDesc: `Une activit\xE9 pour r\xE9fl\xE9chir \xE0 la naissance d'une nouvelle conception de la discipline historique au si\xE8cle des Lumi\xE8res.`,
                fullDesc: `Une activit\xE9 pour r\xE9fl\xE9chir \xE0 l'\xE9mergence d'une nouvelle fa\xE7on de penser le temps et l'histoire au si\xE8cle des Lumi\xE8res, \xE0 l'aide d'un extrait des \xAB Le\xE7ons d'histoire prononc\xE9es \xE0 l'\xC9cole normale \xBB de Constantin-Fran\xE7ois Volney et de l'\u0153il de l'historien Nicolas Offenstadt.`,
                tags: ["Atelier de Clio"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/51799365/lls-histoire-2nde-chapitre7-atelier-de-clio.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "6547535"
                  }
                ]
              }
            ]
          },
          {
            goal: RESOURCE_GOALS.MEMORISER,
            resourcesPack: [
              {
                id: 16,
                title: "3 minutes pour r\xE9viser le chapitre 7",
                vignette: "https://assets.lls.fr/pages/51799365/his2de7revision.png",
                shortDesc: "Une vid\xE9o pour r\xE9viser les points cl\xE9s du chapitre.",
                fullDesc: "Une vid\xE9o bilan pour r\xE9viser et m\xE9moriser les points cl\xE9s du chapitre 7.",
                tags: ["Vid\xE9o"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/6462599/REV_ch7.mp4"
                  }
                ]
              },
              {
                id: 17,
                title: `L'essentiel du chapitre 7`,
                vignette: "https://assets.lls.fr/pages/51799365/his2de7memo.jpg",
                shortDesc: "Les notions cl\xE9s r\xE9unies dans le m\xE9mo du chapitre.",
                fullDesc: "Les notions cl\xE9s du chapitre 7 sont pr\xE9sent\xE9es visuellement pour faciliter la m\xE9morisation : carte mentale, frise, mots cl\xE9s...",
                tags: ["Le m\xE9mo"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/51799365/lls-histoire-2nde-chapitre7-memo.pdf"
                  }
                ]
              },
              {
                id: 18,
                title: "La r\xE9volution scientifique... en bulles !",
                vignette: "https://assets.lls.fr/pages/51799365/his2de7bd.png",
                shortDesc: "Une courte BD pour m\xE9moriser autrement.",
                fullDesc: "Une illustration retrace une notion cl\xE9 du chapitre pour permettre aux \xE9l\xE8ves de la m\xE9moriser autrement.",
                tags: ["Le chapitre en BD"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/51799365/lls-histoire-2nde-chapitre-7-bande-dessinee.pdf"
                  }
                ]
              }
            ]
          },
          {
            goal: RESOURCE_GOALS.ENTRAINER,
            resourcesPack: [
              {
                id: 19,
                title: `Qu'avez-vous appris sur... Galil\xE9e ?`,
                vignette: "https://assets.lls.fr/pages/51799365/his2de7pdp1galilee.jpg",
                shortDesc: "Un quiz pour tester les \xE9l\xE8ves sur le point de passage n\xB0 1.",
                fullDesc: "Un quiz de r\xE9vision pour revenir sur le point de passage n\xB0 1 et tester les connaissances des \xE9l\xE8ves en vue de l\u2019\xE9valuation.",
                tags: ["Quiz - Point de passage"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/51799365/lls-histoire-2nde-chapitre7-quiz-ppo1.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "621e404ddf21310011780204"
                  },
                  {
                    format: RESOURCE_FORMAT.ExternalLink,
                    url: "https://create.kahoot.it/share/qu-avez-vous-appris-sur-galilee/b2662edf-0d5f-466c-9760-83985b6261b5"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/51799365/lls-histoire-2nde-chapitre7-quiz-ppo1.zip"
                  }
                ]
              },
              {
                id: 20,
                title: `Qu'avez-vous appris sur... \xC9milie du Ch\xE2telet ?`,
                vignette: "https://assets.lls.fr/pages/51799365/his2de7pdp2emilie.jpg",
                shortDesc: "Un quiz pour tester les \xE9l\xE8ves sur le point de passage n\xB0 2.",
                fullDesc: "Un quiz de r\xE9vision pour revenir sur le point de passage n\xB0 2 et tester les connaissances des \xE9l\xE8ves en vue de l\u2019\xE9valuation.",
                tags: ["Quiz - Point de passage"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/51799365/lls-histoire-2nde-chapitre7-quiz-ppo2.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "6221d36d9a6a220011e12d35"
                  },
                  {
                    format: RESOURCE_FORMAT.ExternalLink,
                    url: "https://create.kahoot.it/share/qu-avez-vous-appris-sur-emilie-du-chatelet/578435bd-12ff-4073-ab0e-422318095a8e"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/51799365/lls-histoire-2nde-chapitre7-quiz-ppo2.zip"
                  }
                ]
              },
              {
                id: 21,
                title: `Qu'avez-vous appris sur... Thomas Newcomen ?`,
                vignette: "https://assets.lls.fr/pages/51799365/his2de7pdp3newcomen.jpg",
                shortDesc: "Un quiz pour tester les \xE9l\xE8ves sur le point de passage n\xB0 3.",
                fullDesc: "Un quiz de r\xE9vision pour revenir sur le point de passage n\xB03 et tester les connaissances des \xE9l\xE8ves en vue de l\u2019\xE9valuation.",
                tags: ["Quiz - Point de passage"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/51799365/lls-histoire-2nde-chapitre7-quiz-ppo3-1.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "622b6c5a8c4c780013c4dfc6"
                  },
                  {
                    format: RESOURCE_FORMAT.ExternalLink,
                    url: "https://create.kahoot.it/share/qu-avez-vous-appris-sur-thomas-newcomen/057a1bed-8112-43fa-b81f-c933e8ead39b"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/51799365/lls-histoire-2nde-chapitre7-quiz-ppo3.zip"
                  }
                ]
              },
              {
                id: 22,
                title: `Qu'avez-vous appris sur... le chapitre 7 ?`,
                vignette: "https://assets.lls.fr/pages/51799365/his2de7quiz-challenge.jpg",
                shortDesc: `Un quiz pour r\xE9viser l'ensemble du chapitre.`,
                fullDesc: `Un quiz complet pour rebrasser et r\xE9viser l'ensemble des notions phares du chapitre 7.`,
                tags: ["Challenge de r\xE9vision"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/51799365/lls-histoire-2nde-chapitre7-quiz-challenge-1.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "62305558d9b0bf001099be42"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/51799365/lls-histoire-2nde-chapitre7-quiz-challenge.zip"
                  }
                ]
              },
              {
                id: 23,
                title: "Qui est-ce ?",
                vignette: "https://assets.lls.fr/pages/51799365/his2de7jeu.jpg",
                shortDesc: "Un jeu pour r\xE9viser les personnages cl\xE9s du chapitre.",
                fullDesc: "Un jeu de \xAB Qui est-ce ?\xBB pour r\xE9viser les personnages cl\xE9s du chapitre 7 de fa\xE7on ludique.",
                tags: ["Jeu"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/51799365/lls-histoire-2nde-chapitre7-jeu.pdf"
                  }
                ]
              }
            ]
          }
        ]
      },
      // Chapitre 8
      7: {
        title: "Pr\xE9parer le chapitre 8",
        subtitle: `Le Manuel Premium s'enrichit de contenus num\xE9riques exclusifs, cr\xE9\xE9s avec les professeurs de la communaut\xE9, pour vous permettre de concevoir votre s\xE9quence id\xE9ale !`,
        stamp: "Nouveaut\xE9 : les ressources Premium",
        header: "https://assets.lls.fr/pages/55675997/his2de08repca-ne-durera-pas-toujours.jpg",
        category: [
          {
            goal: RESOURCE_GOALS.COMMENCER,
            resourcesPack: [
              {
                id: 1,
                title: `Des id\xE9es pour s'inspirer`,
                shortDesc: "Le meilleur des ressources issues du web !",
                fullDesc: "Le meilleur des ressources issues du web : une s\xE9lection de vid\xE9os, articles, publications universitaires, romans, bandes dessin\xE9es\u2026",
                tags: ["Padlet enseignant"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Padlet,
                    id: "5jysb1hwfbx6pilg"
                  }
                ]
              },
              {
                id: 2,
                title: "\xC0 la d\xE9couverte du chapitre 8",
                vignette: "https://assets.lls.fr/pages/55675997/ch08-vignette-intro.jpg",
                shortDesc: "Une vid\xE9o immersive pour introduire le chapitre.",
                fullDesc: "Une vid\xE9o immersive pour poser le contexte historique et introduire les grandes probl\xE9matiques du chapitre.",
                tags: ["Vid\xE9o"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/55675997/intro-ch8-v3.mp4"
                  }
                ]
              },
              {
                id: 3,
                title: `Galerie d'images pour ouvrir le chapitre`,
                vignette: "https://assets.lls.fr/pages/55675997/his2de8banque-icono.jpeg",
                shortDesc: `Une s\xE9lection d'iconographies alternatives pour ouvrir le chapitre.`,
                fullDesc: `Une s\xE9lection d'iconographies alternatives pour ouvrir le chapitre. Pratique pour personnaliser votre manuel et varier les entr\xE9es d'une ann\xE9e \xE0 l'autre !`,
                tags: ["Images d\u2019ouverture"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Gallery,
                    items: [
                      {
                        legend: `Nicolas Bonnard, <em>Les demoiselles de Saint-Cyr</em>, entre 1680 et 1715, gravure.

                    Cette gravure permet d\u2019aborder de mani\xE8re crois\xE9e l\u2019\xE9ducation et la diversit\xE9 interne de l\u2019ordre nobiliaire. En effet, l\u2019image repr\xE9sente deux demoiselles appartenant \xE0 la Maison royale de Saint-Louis, pensionnat fond\xE9 en 1686 par Madame de Maintenon et destin\xE9 \xAB aux filles des gentilshommes tu\xE9s ou ayant ruin\xE9 leur sant\xE9 et leur fortune pour le service de l'\xC9tat \xBB. \xC0 ces jeunes filles d\u2019une famille noble en difficult\xE9 est propos\xE9 un cursus \xE9ducatif gratuit de plusieurs ann\xE9es, qui doit leur permettre de conclure les mariages les plus avantageux possibles ou d\u2019entrer dans les ordres religieux.`,
                        credit: "Vital Archive / Alamy",
                        url: "https://assets.lls.fr/pages/55675997/lls-his2-ch8-icono1.jpg"
                      },
                      {
                        legend: `Johann Tischbein, <em>La pomme de terre</em>, v. 1814.

                    Ce peintre allemand repr\xE9sente de nombreuses sc\xE8nes campagnardes et s\u2019int\xE9resse particuli\xE8rement aux symboles de la fertilit\xE9 de la terre. La pomme de terre, acclimat\xE9e aux sols europ\xE9ens \xE0 partir du XVIII\u1D49 si\xE8cle, est un bon exemple de modernisation agricole \xE0 pr\xE9senter aux \xE9l\xE8ves. En 1772, la facult\xE9 de m\xE9decine d\xE9clare, suite aux recherches d\u2019Antoine Parmentier, que la consommation de la pomme de terre est sans danger. Elle se r\xE9v\xE8le particuli\xE8rement pr\xE9cieuse durant les p\xE9riodes de s\xE9cheresse.`,
                        credit: "Samuel Austin / CC BY-SA 3.0 / Wikimedia",
                        url: "https://assets.lls.fr/pages/55675997/lls-his2-ch8-icono2.jpeg"
                      },
                      {
                        legend: `Abraham Bosse, <em>L'H\xF4pital de la Charit\xE9 de Paris</em>, eau-forte, v. 1639. 

                    Cette image permet de documenter les pratiques d\u2019assistance qui se d\xE9veloppent au XVII\u1D49 si\xE8cle, notamment pour compl\xE9ter le point de passage num\xE9ro 2. Elle illustre la coop\xE9ration du pouvoir politique et religieux : fond\xE9 par Marie de M\xE9dicis et Marguerite de Valois au tout d\xE9but du XVIIe si\xE8cle, sa gestion est confi\xE9e aux fr\xE8res hospitaliers de l\u2019ordre Saint-Jean-de-Dieu pour soigner les malades pauvres. Les hautes fen\xEAtres et les lits individuels, qui annoncent des soins personnalis\xE9s aux souffrants, sont des nouveaut\xE9s pour l\u2019\xE9poque.`,
                        credit: "Harris Brisbane Dick Fund, 1926 / Wikimedia",
                        url: "https://assets.lls.fr/pages/55675997/lls-his2-ch8-icono3.jpg"
                      },
                      {
                        legend: `Le grand th\xE9\xE2tre de Bordeaux et le cours du Chapeau Rouge en 1790, planche de l\u2019architecte Victor Louis, v. 1780.

                    L\u2019exemple du Grand Th\xE9\xE2tre de Bordeaux, inaugur\xE9 en 1780, illustre bien la mani\xE8re dont l\u2019architecture devient un moyen pour traduire sa r\xE9ussite sociale. En effet, la construction est impuls\xE9e par le mar\xE9chal-duc de Richelieu. Ce grand prince du royaume,  gouverneur de Guyenne, aur\xE9ol\xE9 de victoires militaires,  est tr\xE8s impliqu\xE9 dans la vie culturelle du royaume. En plus de participer financi\xE8rement \xE0 la construction de l\u2019\xE9difice, il impose le nom du prestigieux architecte Victor Louis pour \xEAtre aux commandes.`,
                        credit: "Robert.Allen / Wikimedia",
                        url: "https://assets.lls.fr/pages/55675997/lls-his2-ch8-icono4.jpeg"
                      },
                      {
                        legend: `Conversations galantes dans les galeries du Palais-Royal, v. 1800, dessin. 

                    Les jardins du Palais-Royal, bord\xE9s par ses galeries commerciales sous de vastes portiques, sont particuli\xE8rement repr\xE9sentatifs des processus de transformations urbaines et sociales que conna\xEEt Paris \xE0 la fin du XVIII\u1D49 si\xE8cle. Am\xE9nag\xE9s sous l\u2019impulsion du duc de Chartres, ils constituent un p\xF4le de loisirs fr\xE9quent\xE9 par une grande diversit\xE9 d\u2019individus : \xE9lites, marchands du quartier, oisifs en tout genres. C\u2019est \xE9galement le nouveau haut-lieu de la galanterie parisienne, avec la pr\xE9sence de nombreuses courtisanes et prostitu\xE9es.`,
                        credit: "Yogi Black / Alamy",
                        url: "https://assets.lls.fr/pages/55675997/lls-his2-ch8-icono5.jpg"
                      },
                      {
                        legend: `\xAB L\u2019afficheur \xBB dans Edm\xE9 Bouchardon, <em>\xC9tudes prises dans le bas peuple ou les Cris de Paris</em>,
                    Paris, chez Joullain Quay de la Megisserie, 1737-1746.
                    
                    Cette image permet d\u2019approfondir l\u2019essor des supports de communication, les transformations m\xE9diatiques \xE9tant notamment abord\xE9s dans le dossier sur la B\xEAte du G\xE9vaudan. Le m\xE9tier d\u2019afficheur se structure au cours du XVIII\u1D49 si\xE8cle et les murs des villes fran\xE7aises se couvrent d\u2019affiches (affiches commerciales, proclamations officielles, affiches de spectacle\u2026). Souvent lues de mani\xE8re collective (par des groupes de passants devant l\u2019affiche), elles contribuent \xE0 susciter les discussions et \xE0 fa\xE7onner l\u2019opinion publique des urbains.`,
                        credit: "Garitan / Wikimedia",
                        url: "https://assets.lls.fr/pages/55675997/lls-his2-ch8-icono6.jpeg"
                      },
                      {
                        legend: `Pierre-Antoine Demachy, <em>La foire Saint-Germain apr\xE8s l\u2019incendie de la nuit du 16 au 17 mars 1762</em>, v. 1762, huile sur toile.

                    Le tableau figure un des incendies marquants du XVIII\u1D49 si\xE8cle parisien, celui de la foire Saint-Germain en mars 1762. Les flammes ravagent les baraques en bois qui s'installent chaque ann\xE9e dans le quartier Saint-Germain, durant les mois de f\xE9vrier et mars. La foire constituaient un temps fort pour la vie \xE9conomique, mais aussi culturelle, car des spectacles tr\xE8s divers (acrobaties, jonglage, petites com\xE9dies) \xE9taient propos\xE9s aux passants pour un co\xFBt tr\xE8s modique, afin d\u2019attirer un maximum de visiteurs. Les b\xE2timents sont partiellement reconstruits l\u2019ann\xE9e suivante.`,
                        credit: "Pyb / CC0 1.0 / Wikimedia",
                        url: "https://assets.lls.fr/pages/55675997/lls-his2-ch8-icono7.jpeg"
                      },
                      {
                        legend: `Photographie du boudoir de l\u2019H\xF4tel d\u2019Aumont, am\xE9nag\xE9 vers 1775.

                    L\u2019am\xE9nagement de boudoirs au sein des demeures aristocratiques au cours du XVIII\u1D49 si\xE8cle est de plus en plus courant. Le boudoir peut aussi bien servir \xE0 recevoir quelques amis , qu\u2019\xE0 \xE9tudier ou se reposer. Souvent agr\xE9ment\xE9e d\u2019une chemin\xE9e et avec vue sur le jardin, la pi\xE8ce se veut la plus confortable possible. Le succ\xE8s du boudoir s\u2019explique par le d\xE9sir grandissant de pouvoir se ressourcer quand on le souhaite au sein de son logement. Dans un contexte o\xF9 une partie de la population ne vit que dans une ou deux pi\xE8ces, disposer d\u2019un espace \xE0 soi est le signe d\u2019une aisance \xE9conomique, possible pour de riches bourgeois ou des nobles en r\xE9ussite.`,
                        credit: "Gift of Susan Dwight Bliss, 1944 / Metropolitan Museum of Art",
                        url: "https://assets.lls.fr/pages/55675997/lls-his2-ch8-icono8.jpeg"
                      },
                      {
                        legend: `\xC9tienne Aubry, <em>Visite \xE0 la nourrice</em>, XVIII\u1D49 si\xE8cle.

                    La pratique de la mise en nourrice, tr\xE8s r\xE9pandue au XVIII\u1D49 si\xE8cle, permet d\u2019aborder la question de la diffusion sociale des modes de vie. Au XVI\u1D49 si\xE8cle, le fait de confier son enfant pour les deux premi\xE8res ann\xE9es de sa vie \xE0 une nourrice, qui habitait le plus souvent \xE0 la campagne, \xE9tait uniquement le fait de l\u2019\xE9lite. Au XVIII\u1D49 si\xE8cle, cela concerne pr\xE8s de la moiti\xE9 des familles du royaume, en raison notamment du jugement d\xE9favorable port\xE9 sur l\u2019allaitement et de la difficult\xE9 de le concilier avec la vie professionnelle et sociale. Sur ce tableau, une femme richement v\xEAtue fait montre de son affection envers son deuxi\xE8me enfant, \xE0 qui elle vient rendre visite chez une nourrice beaucoup plus modeste, vivant dans un habitat pauvrement meubl\xE9.`,
                        credit: "Garitan / CC BY-SA 3.0 / Wikimedia",
                        url: "https://assets.lls.fr/pages/55675997/lls-his2-ch8-icono9.jpeg"
                      },
                      {
                        legend: `\xAB \xC7a ne durera pas toujours ! \xBB, XVIII\u1D49 si\xE8cle, gravure.

                    En 1639, des paysans de Basse-Normandie se r\xE9voltent contre l'introduction d'un nouvel imp\xF4t. Ils sont bient\xF4t suivis par les grandes villes de la r\xE9gion. Le soul\xE8vement est r\xE9prim\xE9 quelques mois plus tard.`,
                        credit: "\xA9 Photo Josse/Bridgeman",
                        url: "https://assets.lls.fr/pages/55675997/lls-his2-ch8-icono10.jpg"
                      }
                    ]
                  }
                ]
              },
              {
                id: 4,
                title: "Que savez-vous d\xE9j\xE0 sur... le chapitre 8 ?",
                vignette: "https://assets.lls.fr/pages/55675997/his2de8quiz-diagnostique.jpg",
                shortDesc: "Un quiz diagnostique pour ouvrir le chapitre.",
                fullDesc: "Un quiz diagnostique pour faire le point sur les connaissances des \xE9l\xE8ves et ouvrir le chapitre 8.",
                tags: ["Quiz diagnostique"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/55675997/llshistoire2ndechapitre8quiz-diagnostique.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.ExternalLink,
                    url: "https://create.kahoot.it/share/que-savez-vous-deja-sur-le-chapitre-tensions-mutations-et-crispations-de-la-societe-dord/c6cef22e-f8fc-4b45-ad69-f0f6cc18a62d"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/55675997/lls-histoire-chapitre8-quiz-diagnostique.zip"
                  }
                ]
              }
            ]
          },
          {
            goal: RESOURCE_GOALS.ETUDIER,
            resourcesPack: [
              {
                id: 5,
                title: "1639 - La r\xE9volte des Va Nu-pieds",
                vignette: "https://assets.lls.fr/pages/55675997/ch08-vignette-vanupieds.jpg",
                shortDesc: "Comment se d\xE9roule une r\xE9volte paysanne au XVII\u1D49 si\xE8cle ?",
                fullDesc: `Une vid\xE9o pour comprendre une r\xE9volte paysanne \xE0 travers l'exemple de la r\xE9volte des Va Nu-pieds.`,
                tags: ["Vid\xE9o"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/55675997/va-nu-pieds-v3-2.mp4"
                  }
                ]
              },
              {
                id: 6,
                title: "Riches et pauvres \xE0 Paris",
                vignette: "https://assets.lls.fr/pages/55675997/his2de8vignette2.jpg",
                shortDesc: "En quoi les in\xE9galit\xE9s \xE0 Paris au XVIII\u1D49 si\xE8cle provoquent-elles des tensions ?",
                fullDesc: `Une vid\xE9o pour d\xE9couvrir Paris et ses habitants au XVIII\u1D49 si\xE8cle, et analyser les contrastes qui marquent l'espace urbain.`,
                tags: ["Vid\xE9o"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/55675997/paris-v3.mp4"
                  }
                ]
              },
              {
                id: 7,
                title: `Les ports fran\xE7ais et le d\xE9veloppement de l'\xE9conomie de plantation et de la traite`,
                vignette: "https://assets.lls.fr/pages/55675997/his2de8vignette3.jpg",
                shortDesc: "Comment les ports fran\xE7ais organisent-ils le commerce triangulaire ?",
                fullDesc: "Une vid\xE9o pour comprendre comment le commerce triangulaire a enrichi les ports fran\xE7ais.",
                tags: ["Vid\xE9o"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/55675997/ports-francais-v4.mp4"
                  }
                ]
              },
              {
                id: 8,
                title: "Le salon de Madame Geoffrin",
                vignette: "https://assets.lls.fr/pages/55675997/his2de8vignette4.png",
                shortDesc: `Comment s'organise un des lieux de sociabilit\xE9 majeurs du XVIII\u1D49 si\xE8cle ?`,
                fullDesc: `Une vid\xE9o pour s'immerger dans le salon de Madame Geoffrin, o\xF9 se cotoient la noblesse de cour, des bourgeois, des \xE9crivains et des artistes.`,
                tags: ["Vid\xE9o"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/55675997/mmegeoffrin-v4-1.mp4"
                  }
                ]
              }
            ]
          },
          {
            goal: RESOURCE_GOALS.EXPLORER,
            resourcesPack: [
              {
                id: 9,
                title: `La naissance d'un corps de m\xE9tier f\xE9minin : les couturi\xE8res`,
                vignette: "https://assets.lls.fr/pages/55675997/his2de8couturiere.JPG",
                shortDesc: "Quelles transformations conna\xEEt le m\xE9tier de couturi\xE8re au XVIII\u1D49 si\xE8cle ?",
                fullDesc: `Un dossier pour \xE9tudier l'\xE9mergence d'un nouveau m\xE9tier autour de l'art du v\xEAtement, celui de couturi\xE8re, qui \xE9tait jusqu'au XVII\u1D49 si\xE8cle r\xE9serv\xE9 aux hommes.`,
                tags: ["Dossier exclusif"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/55675997/llshistoire2ndechapitre8dossiercouturiere.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "51594318"
                  }
                ]
              },
              {
                id: 10,
                title: "Une premi\xE8re soci\xE9t\xE9 de consommation",
                vignette: "https://assets.lls.fr/pages/55675997/his2de8consommation.png",
                shortDesc: `Comment l'essor de la consommation au XVIII\u1D49 si\xE8cle transforme-t-il la soci\xE9t\xE9 ?`,
                fullDesc: "Ce dossier propose de revenir sur les pr\xE9mices de la soci\xE9t\xE9 de consommation et sur les tensions que cela fait na\xEEtre.",
                tags: ["Dossier exclusif"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/55675997/llshistoire2ndechapitre8dossierconsommation.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "51594496"
                  }
                ]
              }
            ]
          },
          {
            goal: RESOURCE_GOALS.DIVERSIFIER,
            resourcesPack: [
              {
                id: 11,
                title: "Des ressources pour approfondir",
                shortDesc: "Pour les \xE9l\xE8ves, le meilleur des ressources issues du web !",
                fullDesc: "Pour les \xE9l\xE8ves, le meilleur des ressources issues du web : une s\xE9lection d\u2019articles, romans, podcasts, films, jeux vid\xE9o, BDs, photos\u2026",
                tags: ["Padlet \xE9l\xE8ve"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Padlet,
                    id: "uqklbez0x5m2qs91"
                  }
                ]
              },
              {
                id: 12,
                title: "Des ordres et d\xE9sordre dans la soci\xE9t\xE9",
                vignette: "https://assets.lls.fr/pages/55675997/his2de8ordres.jpeg",
                shortDesc: `R\xE9alisez un jeu de l'oie sur les mobilit\xE9s sociales !`,
                fullDesc: `Vos \xE9l\xE8ves vont devoir concevoir un jeu de l'oie pour faire r\xE9viser des \xE9l\xE8ves de 4\u1D49 !`,
                tags: ["Apprendre autrement"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/55675997/llshistoire2ndechapitre8apprendre-autrementjeu.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "51593303"
                  }
                ]
              },
              {
                id: 13,
                title: "Dans la peau de paysans r\xE9volt\xE9s",
                vignette: "https://assets.lls.fr/pages/55675997/his2de8revolte.JPG",
                shortDesc: "Exprimez votre col\xE8re en recr\xE9ant une r\xE9volte paysanne !",
                fullDesc: `Invitez vos \xE9l\xE8ves \xE0 se mettre dans la peau de paysans r\xE9volt\xE9s et \xE0 exprimer leur col\xE8re pacifiquement. L'arme utilis\xE9e ? Une pr\xE9sentation des revendications sous le format de leur choix.`,
                tags: ["Apprendre autrement"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/55675997/llshistoire2ndechapitre8apprendre-autrementpaysan.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "51592869"
                  }
                ]
              },
              {
                id: 14,
                title: "Les historiens et leur travail avec des archives",
                vignette: "https://assets.lls.fr/pages/55675997/his2de08clio.jpg",
                shortDesc: "Comment les historiens travaillent-ils avec des archives ?",
                fullDesc: `Une activit\xE9 pour comprendre en l'importance des archives pour les historiennes et les historiens.`,
                tags: ["Atelier de Clio"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/55675997/llshistoire2ndechapitre8atelier-de-clio.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.InternalLink,
                    page: "6095544"
                  }
                ]
              },
              {
                id: 15,
                title: "Paris au XVIII\u1D49 si\xE8cle",
                shortDesc: `D\xE9couvrez le Paris de l'\xE9poque !`,
                fullDesc: `Participez \xE0 une balade virtuelle dans le Paris de l'\xE9poque !`,
                tags: ["Activit\xE9 num\xE9rique"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "5e1b400a3cf83c241e1a25bd"
                  }
                ]
              }
            ]
          },
          {
            goal: RESOURCE_GOALS.MEMORISER,
            resourcesPack: [
              {
                id: 16,
                title: "3 minutes pour r\xE9viser le chapitre 8",
                vignette: "https://assets.lls.fr/pages/55675997/his2de8revision.png",
                shortDesc: "Une vid\xE9o pour r\xE9viser les points cl\xE9s du chapitre.",
                fullDesc: "Une vid\xE9o bilan pour r\xE9viser et m\xE9moriser les points cl\xE9s du chapitre 8.",
                tags: ["Vid\xE9o"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.Video,
                    url: "https://assets.lls.fr/pages/6095559/chap8.mp4"
                  }
                ]
              },
              {
                id: 17,
                title: `L'essentiel du chapitre 8`,
                vignette: "https://assets.lls.fr/pages/55675997/his2de8memo.jpg",
                shortDesc: "Les notions cl\xE9s r\xE9unies dans le m\xE9mo du chapitre.",
                fullDesc: "Les notions cl\xE9s du chapitre 8 sont pr\xE9sent\xE9es visuellement pour faciliter la m\xE9morisation : carte mentale, frise, mots cl\xE9s...",
                tags: ["Le m\xE9mo"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/55675997/llshistoire2ndechapitre8memo.pdf"
                  }
                ]
              },
              {
                id: 18,
                title: `Mobilit\xE9s et crispations sociales sous l'Ancien R\xE9gime`,
                vignette: "https://assets.lls.fr/pages/55675997/his2de08bd.png",
                shortDesc: "Une courte BD pour m\xE9moriser autrement.",
                fullDesc: "Une illustration retrace une notion cl\xE9 du chapitre pour permettre aux \xE9l\xE8ves de la m\xE9moriser autrement.",
                tags: ["Le chapitre en BD"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/55675997/bd-chap8-v2.pdf"
                  }
                ]
              }
            ]
          },
          {
            goal: RESOURCE_GOALS.ENTRAINER,
            resourcesPack: [
              {
                id: 19,
                title: `Qu'avez-vous appris sur...  la r\xE9volte des Va Nu-pieds ?`,
                vignette: "https://assets.lls.fr/pages/55675997/his2de8ppo1.jpg",
                shortDesc: "Un quiz pour tester les \xE9l\xE8ves sur le point de passage n\xB0 1.",
                fullDesc: "Un quiz de r\xE9vision pour revenir sur le point de passage n\xB0 1 et tester les connaissances des \xE9l\xE8ves en vue de l\u2019\xE9valuation.",
                tags: ["Quiz - Point de passage"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/55675997/llshistoire2ndechapitre8quizppo1.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "62669bc4845fcf00153a6896"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/55675997/lls-histoire-2nde-chapitre8-quiz-ppo1.zip"
                  },
                  {
                    format: RESOURCE_FORMAT.ExternalLink,
                    url: "https://create.kahoot.it/share/qu-avez-vous-appris-sur-la-revolte-des-va-nu-pieds/47a21c7a-4b30-41e2-b902-4605ec4a16b4"
                  }
                ]
              },
              {
                id: 20,
                title: `Qu'avez-vous appris sur...  les riches et les pauvres \xE0 Paris ?`,
                vignette: "https://assets.lls.fr/pages/55675997/his2de8ppo2.jpg",
                shortDesc: "Un quiz pour tester les \xE9l\xE8ves sur le point de passage n\xB0 2.",
                fullDesc: "Un quiz de r\xE9vision pour revenir sur le point de passage n\xB0 2 et tester les connaissances des \xE9l\xE8ves en vue de l\u2019\xE9valuation.",
                tags: ["Quiz - Point de passage"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/55675997/llshistoire2ndechapitre8quizppo2.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "6261306261275c0019b23306"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/55675997/lls-histoire-2nde-chapitre8-quiz-ppo2.zip"
                  },
                  {
                    format: RESOURCE_FORMAT.ExternalLink,
                    url: "https://create.kahoot.it/share/qu-avez-vous-appris-sur-les-riches-et-les-pauvres-a-paris/65f192e6-46a9-4bdc-92bf-f6b6c85e5cf6"
                  }
                ]
              },
              {
                id: 21,
                title: `Qu'avez-vous appris sur...  la traite atlantique ?`,
                vignette: "https://assets.lls.fr/pages/55675997/his2de8ppo3.jpg",
                shortDesc: "Un quiz pour tester les \xE9l\xE8ves sur le point de passage n\xB0 3.",
                fullDesc: "Un quiz de r\xE9vision pour revenir sur le point de passage n\xB03 et tester les connaissances des \xE9l\xE8ves en vue de l\u2019\xE9valuation.",
                tags: ["Quiz - Point de passage"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/55675997/llshistoire2ndechapitre8quizppo3.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "6261115074e0eb0018b64bcd"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/55675997/lls-histoire-2nde-chapitre8-quiz-ppo3.zip"
                  },
                  {
                    format: RESOURCE_FORMAT.ExternalLink,
                    url: "https://create.kahoot.it/share/qu-avez-vous-appris-sur-la-traite-atlantique/5c7e91a7-30a0-4885-83be-b782d6b98b21"
                  }
                ]
              },
              {
                id: 22,
                title: `Qu'avez-vous appris sur...  le salon de Madame Geoffrin ?`,
                vignette: "https://assets.lls.fr/pages/55675997/his2de8ppo4.JPG",
                shortDesc: "Un quiz pour tester les \xE9l\xE8ves sur le point de passage n\xB0 4.",
                fullDesc: "Un quiz de r\xE9vision pour revenir sur le point de passage n\xB04 et tester les connaissances des \xE9l\xE8ves en vue de l\u2019\xE9valuation.",
                tags: ["Quiz - Point de passage"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/55675997/llshistoire2ndechapitre8quizppo4.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "62600c41ad18db001837eb4e"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/55675997/lls-histoire-2nde-chapitre8-quiz-ppo4.zip"
                  },
                  {
                    format: RESOURCE_FORMAT.ExternalLink,
                    url: "https://create.kahoot.it/share/qu-avez-vous-appris-sur-le-salon-de-madame-geoffrin/b2f02e47-6c8c-459e-afb6-d954cbabb9fc"
                  }
                ]
              },
              {
                id: 23,
                title: `Qu'avez-vous appris sur... le chapitre 8 ?`,
                vignette: "https://assets.lls.fr/pages/55675997/his2de08quiz-challenge.jpg",
                shortDesc: `Un quiz pour r\xE9viser l'ensemble du chapitre.`,
                fullDesc: `Un quiz complet pour rebrasser et r\xE9viser l'ensemble des notions phares du chapitre 8.`,
                tags: ["Challenge de r\xE9vision"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/55675997/llshistoire2ndechapitre8quiz-challenge.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "62665ded9d45c60011fc78bd"
                  },
                  {
                    format: RESOURCE_FORMAT.DownloadOther,
                    url: "https://assets.lls.fr/pages/55675997/lls-histoire-2nde-chapitre8-quiz-challenge.zip"
                  }
                ]
              },
              {
                id: 24,
                title: "Mots-crois\xE9s",
                vignette: "https://assets.lls.fr/pages/55675997/his2de08jeu.jpg",
                shortDesc: "Un jeu pour r\xE9viser les personnages cl\xE9s du chapitre.",
                fullDesc: "Un jeu de mots-crois\xE9s pour r\xE9viser les notions cl\xE9s du chapitre 8 de fa\xE7on ludique.",
                tags: ["Jeu"],
                resources: [
                  {
                    format: RESOURCE_FORMAT.DownloadPdf,
                    url: "https://assets.lls.fr/pages/55675997/llshistoire2ndechapitre8mots-croises.pdf"
                  },
                  {
                    format: RESOURCE_FORMAT.Genially,
                    id: "6268077d744a3d0011b9bcab"
                  }
                ]
              }
            ]
          }
        ]
      }
    };
  }
});

// src/api/panorama.js
import { normalizeData as normalizeData6 } from "@lls/store";
import _61 from "lodash/fp.js";
var fetchPanoramas;
var init_panorama3 = __esm({
  "src/api/panorama.js"() {
    "use strict";
    fetchPanoramas = async () => {
      const panoramas = await Promise.resolve().then(() => (init_fixtures(), fixtures_exports)).then((m) => m.PANORAMAS_DATA || m.default.PANORAMAS_DATA).then(
        _61.flow(
          _61.toPairs,
          _61.map(([k, v]) => ({ id: _61.parseInt(10, k), ...v }))
        )
      );
      return normalizeData6({ viewer: { panoramas } });
    };
  }
});

// src/api/page.js
import { normalizeData as normalizeData7 } from "@lls/store";
var childrenAttributes, pageAttributes, fetchPagesApi, createPageApi, updatePageApi, deletePageApi, sharePageToUserApi, sharePageToGroupApi, updatePageAppreciationApi, addCorrectionsToUsers;
var init_page = __esm({
  "src/api/page.js"() {
    "use strict";
    init_book();
    init_graphql();
    childrenAttributes = `
id
uuid
layouts
contentMd
annotations
metadata
rightResponses
responses
isLearningAssessment
renewalUpdatedAt
renewalAddedAt
premium
`;
    pageAttributes = `
id
layouts
contentMd
metadata
rightResponses
updatedAt
title
displayTitle
valid
page
nbPages
numericOrder
isOriginal
appreciations
slug
isLearningAssessment
premium
thematicName
printUrls {
  url
  blurred
}
isPartOfSession
isWorkplan
isCreatedFromScratch
renewalAddedAt
teaser
workplans {
  pageId
  schoolId
  options {
      teacher {
        id
        isTeacher
        lastname
        firstname
        gender
      }
      difficulty
      uuid
      time
      updatedAt
      publishedAt
      modalities {
          type
          value
      }
  }
}
user {
  id
  username
  email
  functions
  firstname
  lastname
  picture
  gender
  role
  isPremium
  isStudent
  isTeacher
  isAdmin
  isReferent
  schools {
    id
  }
}
parent {
  id
}
originalPage {
  id
  slug
  isCreatedFromScratch
  teaser
  chapter {
    id
    book {
      ${bookBaseFragment}
    }
  }
}
children {
  ${childrenAttributes}
}
chapter {
  id
  title
  valid
  book {
    id
  }
}
book {
  ${bookBaseFragment}
  subjects{
    id
  }
}
sharedUsers {
  id
}
layouts
`;
    fetchPagesApi = ({ slugs, token, useCache = true, isStudent = false }) => {
      const methodToUse = useCache ? gql : gqlNoCache;
      return methodToUse({
        query: `query coreFetchPagesApi ($slugs: [String]!,  $hasNewDesign: Boolean, $token: String, $isStudent: Boolean!) {
    viewer (token: $token) {
      pages (slugs: $slugs,  hasNewDesign: $hasNewDesign) {
        hits {
          ${pageAttributes}
          sharedTeacher {
            id
            lastname
            firstname
          }
          sharedCorrections @include(if: $isStudent){
            pageId
            userIds
            uuids
            correctedUuids
            updatedAt
          }
          sharedGroups {
            id
          }
        }
      }
    }
  }`,
        variables: {
          hasNewDesign: true,
          slugs,
          token,
          isStudent
        }
      });
    };
    createPageApi = ({ page, token }) => gqlNoCache({
      query: `mutation ($token: String!, $page: JSON!) {
      viewer (token: $token) {
        createPage (page: $page) {
          id
          slug
          title
          contentMd
          layouts
          thematicName
          displayTitle
          children {
            ${childrenAttributes}
          }
          book {
            ${bookBaseFragment}
          }
          hasNewDesign
          originalPage {
            ${pageAttributes}
          }
          user {
            id
          }
          chapter {
            id
          }
          isOriginal
          isCreatedFromScratch
          isLearningAssessment
          valid
          premium
          parent {
            id
          }
          workplans {
            pageId
            schoolId
            options {
                teacher {
                  id
                  isTeacher
                  lastname
                  firstname
                  gender
                }
                difficulty
                uuid
                time
                updatedAt
                publishedAt
                modalities {
                    type
                    value
                }
            }
          }
        }
      }
    }`,
      variables: {
        token,
        page
      }
    }).then(normalizeData7);
    updatePageApi = ({ page, token }) => gqlNoCache({
      query: `mutation ($token: String!, $page: JSON!) {
      viewer (token: $token) {
        updatePage (page: $page) {
          id
          title
          updatedAt
          chapter {
            id
          }
          displayTitle
          layouts
          children {
            ${childrenAttributes}
          }
        }
      }
    }`,
      variables: {
        token,
        page
      }
    }).then(normalizeData7);
    deletePageApi = ({ token, page }) => gqlNoCache({
      query: `mutation ($token: String!, $page: JSON) {
      viewer (token: $token) {
        deletePage (page: $page) {
          id
        }
      }
    }`,
      variables: {
        token,
        page
      }
    });
    sharePageToUserApi = ({ token, pageId, sharedUserId }) => gqlNoCache({
      query: `mutation ($token: String!, $pageId: Int!, $sharedUserId: Int!) {
      viewer(token: $token) {
        sharePageToUsers(pageId: $pageId, sharedUserIds: [$sharedUserId]) {
          id
          sharedUsers {
            id
          }
          sharedTeacher {
            id
          }
        }
      }
    }`,
      variables: {
        token,
        pageId,
        sharedUserId
      }
    }).then(normalizeData7);
    sharePageToGroupApi = ({ token, pageId, groupId }) => gqlNoCache({
      query: `mutation ($token: String!, $pageId: Int!, $groupId: Int!) {
      viewer(token: $token) {
        sharePageToGroup(pageId: $pageId, groupId: $groupId) {
          id
          sharedGroups {
            id
          }
        }
      }
    }`,
      variables: {
        token,
        pageId,
        groupId
      }
    }).then(normalizeData7);
    updatePageAppreciationApi = ({ token, pageId, appreciation }) => gqlNoCache({
      query: `mutation($token: String!, $pageId: Int!, $appreciation: PageAppreciationInput){
    viewer(token: $token){
     addPageAppreciation(pageId: $pageId, appreciation: $appreciation){
        id
        appreciations
      }
    }
  }`,
      variables: {
        token,
        pageId,
        appreciation
      }
    }).then(normalizeData7);
    addCorrectionsToUsers = ({ token, studentIds, corrections, studentPages }) => gqlNoCache({
      query: `mutation($token: String!, $studentIds: [Int]!, $corrections: [GroupCorrectionDocumentsInput]! $studentPages: [GroupCorrectionStudentPageInput]!){
      viewer(token: $token){
        addCorrectionsToStudents(studentIds: $studentIds, corrections: $corrections, studentPages: $studentPages){
          id
          sharedCorrections{
            pageId
            uuids
            correctedUuids
            updatedAt
          }
        }
      }
    }`,
      variables: {
        token,
        studentIds,
        corrections,
        studentPages
      }
    }).then(normalizeData7);
  }
});

// src/api/screen.js
import { initializePage, isCanopePublisher } from "@lls/utils";
import _62 from "lodash/fp.js";
import { normalizeData as normalizeData8 } from "@lls/store";
var import_dayjs3, toolsFragment, bookToolsFragment, pageFragment, filtersFragment, fetchHomeScreen, fetchMyBooksScreen, fetchBookRedirectScreen, fetchPanoramaScreen, fetchPageScreen, fetchCopiesScreen, fetchCopyScreen, fetchShareCorrectionsScreen, fetchShareCorrectionsStudentsScreen, fetchCustomPagesCacheScreen, fetchCustomPagesNoCacheScreen, fetchBookScreen, fetchCreatePageScreen, fetchBookDrawerScreen, fetchBookPages, fetchMarketingViewerScreen, fetchGroupsSettingsScreen, fetchUpdateUserInfosScreen, fetchRevisionScreen, fetchRevisionBookScreen, fetchLearningAssessmentScreen, fetchUserScreen, fetchProfileScreen, fetchBookBrowsingModal;
var init_screen = __esm({
  "src/api/screen.js"() {
    "use strict";
    import_dayjs3 = __toESM(require_dayjs_min(), 1);
    init_constants();
    init_book();
    init_graphql();
    init_page();
    init_summary();
    toolsFragment = `
  id
  title
  description
  url
  picture
  color
  locked
  profiles
  roles
  books {
    id
  }
`;
    bookToolsFragment = `
  order
  wording
`;
    pageFragment = `
  id
  slug
  valid
  displayTitle
  title
  page
  nbPages
  numericOrder
  isOriginal
  isCreatedFromScratch
  isWorkplan
  isLearningAssessment
  updatedAt
  createdAt
  premium
  corrections
  thematicName
  book {
    id
  }
  chapter {
    id
  }
  user {
    id
  }
  originalPage {
    id
  }
  parent {
    id
  }
`;
    filtersFragment = `
  filters {
    type
    title
    match {
      thematicNames
      premium
      isOriginal
    }
    displayConditions {
      isPremium
      isTeacher
    }
  }
`;
    fetchHomeScreen = () => gql({
      query: `query coreFetchHomeScreen ( $hasNewDesign: Boolean, $publishers: [Publishers]){
    viewer{
      books(publishers: $publishers, hasNewDesign: $hasNewDesign ){
        total
        hits{
          id
          hasNewDesign
          urlLite
          displayTitle
          slug
          uri
          valid
          year
          publisher
          renewalLabel
          isWorkplan
          isWorkbook
          firstValidPage{
            id
            slug
            book{
              id
            }
            chapter{
              id
              numShow
            }
            nbPages
            page
            title
            displayTitle
            valid
          }
          collection {
            id
            name
            publisher
          }
          levels {
            id
            name
            order
          }
          subjects {
            id
            name
          }
          textbooks {
            id
          }
          oldBook {
            id
          }
        }
      }

      subjects {
        hits {
          id
          name
          code
          schoolTypes
        }
      }
      levels {
        id
        name
        order
      }
    }
  }`,
      variables: {
        hasNewDesign: true,
        publishers: GQL_PUBLISHERS
      }
    }).then(normalizeData8);
    fetchMyBooksScreen = () => gql({
      query: `query coreFetchMyBooksScreen ( $hasNewDesign: Boolean,  $publishers: [Publishers]){
    viewer{
      books(publishers: $publishers, hasNewDesign: $hasNewDesign ){
        total
        hits{
          id
          hasNewDesign
          urlLite
          displayTitle
          slug
          uri
          valid
          year
          publisher
          renewalLabel
          firstValidPage{
            id
            slug
          }
          collection {
            id
            name
            publisher
          }
          levels {
            id
            name
            order
          }
          subjects {
            id
            name
          }
          textbooks {
            id
          }
          oldBook {
            id
          }
        }
      }

      subjects {
        hits {
          id
          name
          code
          schoolTypes
        }
      }
      levels {
        id
        name
        order
        schoolTypes {
          id
          slug
        }
      }
    }
  }`,
      variables: {
        hasNewDesign: true,
        publishers: GQL_PUBLISHERS
      }
    }).then(normalizeData8);
    fetchBookRedirectScreen = ({ slug }) => gql({
      query: `query coreFetchBookRedirectScreen ( $slugs: [String]!, $hasNewDesign: Boolean!) {
    viewer {
      books (slugs: $slugs, hasNewDesign: $hasNewDesign) {
        hits {
          id
          slug
          uri
          valid
          displayTitle
          url
          hasNewDesign
          firstValidPage{
            id
            slug
          }
        }
      }
    }
  }`,
      variables: {
        slugs: [slug],
        hasNewDesign: true
      }
    }).then(normalizeData8);
    fetchPanoramaScreen = ({ bookIds }) => gql({
      query: `query coreFetchPanoramaScreen ( $bookIds: [Int]!) {
    viewer {
      books (ids: $bookIds) {
        hits {
          id
          valid
          displayTitle
          uri
          url
          urlLite
          subjects {
            id
          }
          levels {
            id
          }
          chapters {
            id
            book {
              id
            }
          }
          ${summaryFragment}
          ${filtersFragment}
        }
      }
    }
  }`,
      variables: {
        bookIds
      }
    }).then(normalizeData8);
    fetchPageScreen = ({ slug, token, useCache, isStudent = false }) => slug && fetchPagesApi({
      slugs: slug ? [slug] : void 0,
      token,
      isStudent,
      useCache
    }).then(_62.update("viewer.pages.hits.0", initializePage)).then(normalizeData8);
    fetchCopiesScreen = ({ parentId, token }) => gqlNoCache({
      query: `query coreFetchCopiesScreen ($parentId: Int, $token: String!) {
      viewer(token: $token) {
        me {
          id
          students {
            id
            firstname
            lastname
            schools {
              id
            }
            isStudent
            isTeacher
          }
          copyNotifications(parentIds: [$parentId]) {
            id
            page {
              id
            }
            type
            read
          }
          groups {
            id
            name
            code
            owner {
              id
            }
            students {
              id
              firstname
              lastname
            }
          }
          sharedPages(parentIds: [$parentId]){
            id
            isOriginal
            updatedAt
            user {
              id
              firstname
              lastname
              gender
              isStudent
              isTeacher
              username
              email
            }
            parent {
              id
            }
            appreciations
            sharedCorrections{
              updatedAt
            }
          }
        }
        parents: pages(ids: [$parentId]) {
          hits {
            id
            title
            isOriginal
            layouts
            rightResponses
            slug
            numericOrder
            page
            nbPages
            valid
            children {
              id
              uuid
              layouts
              contentMd
              rightResponses
            }
            contentMd
            book {
              ${bookBaseFragment}
            }
          }
        }
      }
    }`,
      variables: {
        token,
        parentId
      }
    }).then(normalizeData8);
    fetchCopyScreen = ({ copyId, parentId, token }) => gqlNoCache({
      query: `query coreFetchCopyScreen ($copyId: Int!, $token: String!, $parentId: Int!) {
      viewer(token: $token) {
        me {
          id
          sharedPages(parentIds: [$parentId]){
            ${pageAttributes}
          }
        }
        pages(ids: [$copyId]) {
          hits {
            ${pageAttributes}
          }
        }
      }
    }`,
      variables: {
        token,
        copyId,
        parentId
      }
    }).then(normalizeData8);
    fetchShareCorrectionsScreen = ({ parentIds, groupIds, token }) => gqlNoCache({
      query: `query coreFetchShareCorrectionsScreen ($parentIds: [Int]!, $groupIds: [Int]!, $token: String!) {
          viewer(token: $token){
            me {
              groups (ids: $groupIds) {
                id
                name
                code
                owner {
                  id
                }
                students {
                  id
                  firstname
                  lastname
                }
                sharedCorrections{
                  pageId
                  userIds
                  uuids
                  correctedUuids
                  updatedAt
                }
                answeredExercises (parentIds: $parentIds) {
                  uuid
                }
              }
              sharedPages(parentIds: $parentIds){
                id
                isOriginal
                updatedAt
                user {
                  id
                  firstname
                  lastname
                  gender
                  isStudent
                  isTeacher
                  username
                  email
                }
                parent {
                  id title
                }
                appreciations
              }
            }
            parents: pages(ids: $parentIds) {
              hits {
                id
                title
                isOriginal
                layouts
                rightResponses
                slug
                page
                nbPages
                valid
                isPartOfSession
                children {
                  id
                  uuid
                  layouts
                  contentMd
                  rightResponses
                }
                contentMd
                book {
                  ${bookBaseFragment}
                }
              }
            }
          }
        }
    `,
      variables: {
        parentIds,
        groupIds,
        token
      }
    }).then(normalizeData8);
    fetchShareCorrectionsStudentsScreen = ({ parentIds, groupIds, token }) => gqlNoCache({
      query: `query coreFetchShareCorrectionsStudentsScreen ($parentIds: [Int]!, $token: String!) {
          viewer(token: $token){
            parents: pages(ids: $parentIds) {
              hits {
                id
                title
                isOriginal
                layouts
                rightResponses
                slug
                page
                nbPages
                valid
                isPartOfSession
                children {
                  id
                  uuid
                  layouts
                  contentMd
                  rightResponses
                }
                contentMd
                book {
                  ${bookBaseFragment}
                }
              }
            }
          }
        }
    `,
      variables: {
        parentIds,
        groupIds,
        token
      }
    }).then(normalizeData8);
    fetchCustomPagesCacheScreen = ({ bookIds }) => gql({
      query: `query coreFetchCustomPagesCacheScreen ($bookIds: [Int]!) {
        viewer {
          books (ids: $bookIds) {
            hits {
              id
              chapters {
                id
              }
            }
          }
        }
      }`,
      variables: {
        bookIds
      }
    }).then(normalizeData8);
    fetchCustomPagesNoCacheScreen = ({
      bookIds,
      token,
      appCustomPagesAfter = "",
      isStudent = false,
      subjectIds,
      pageId,
      isWorkplanStudentTask = false
    }) => gqlNoCache({
      query: `query coreFetchCustomPagesNoCacheScreen ($bookIds: [Int]!, $token: String, $isStudent: Boolean!, $subjectIds: [Int], $pageId: Int, $isWorkplanStudentTask: Boolean!) {
        viewer (token: $token) {
          me {
            students @include(if: $isWorkplanStudentTask) {
              id
              firstname
              lastname
            }
            id
            groups {
              id
              name
              code
              owner {
                id
              }
              students {
                id
                firstname
                lastname
              }
            }
            drawerNotifications(read: false, bookIds: $bookIds) {
              id
              page {
                id
                slug
              }
              type
              read
            }
            teachers (subjectIds: $subjectIds) @include(if: $isStudent) {
              id
              isTeacher
              lastname
              firstname
              gender
              subjects {
                id
                name
              }
              schools {
                id
              }
            }
            ${appCustomPagesAfter ? `pages (updatedAfter: "${appCustomPagesAfter}")` : "pages (bookIds: $bookIds)"} {
                id
                slug
                valid
                title
                page
                nbPages
                numericOrder
                isOriginal
                updatedAt
                premium
                corrections
                thematicName
                chapter {
                  id
                }
                user {
                  id
                }
                originalPage {
                  id
                }
                parent {
                  id
                }
                sharedGroups {
                  id
                }
                sharedTeacher {
                  id
                  lastname
                  firstname
                  gender
                }
                sharedCorrections @include(if: $isStudent){
                  pageId
                  userIds
                  uuids
                  correctedUuids
                  updatedAt
                }
            }
            copies(parentIds: [$pageId]) {
              id
              isOriginal
              parent {
                id
              }
              sharedUsers {
                id
              }
            }
            sharedPages{
              ${pageFragment}
              sharedAt
            }
          }
        }
      }`,
      variables: {
        bookIds,
        token,
        isStudent,
        subjectIds,
        pageId,
        isWorkplanStudentTask,
        appCustomPagesAfter
      }
    }).then(normalizeData8);
    fetchBookScreen = ({ bookId, token, collectionPublisher }) => {
      return gqlNoCache({
        query: `query coreFetchBookScreen ($bookIds: [Int]!, $token: String, $isCanopePublisher: Boolean!, $publishers:[Publishers]) {
      viewer (token: $token) {
        books (ids: $bookIds, publishers:$publishers) {
          hits{
            id
            publisher
            isClassic
            classicColor
            teacherBook
            isClassicTextDark
            premiumResources {
              id
              title
              subtitle
              type
              url
              order
              comingSoon
              book {
                id
              }
              category {
                title
                subtitle
                description
                imgUrl
                order
                comingSoon
              }
            }
            firstValidPage {
              id
              slug
            }
            workplanStudentsStats {
              id
              title
              chapter
              parent
              isOriginal
              tasks {
                uuid
                title
                isOptional
                slug
              }
            }
            chapters {
              id
              title
              book {
                id
              }
              resources {
                id
                title
                url
                categories
                page {
                  id
                }
                chapter {
                  id
                  numShow
                  title
                  number
                }
              }
            }
          }
        }
        me {
          id
          students @include(if: $isCanopePublisher){
            id
            firstname
            lastname
            schools {
              id
            }
          }
          groups{
            id
            name
            code
            owner {
              id
            }
            students {
              id
            }
          }
          tipOfTheDay {
            description
            event
            name
            title
            url
            videoUrl
          }
          drawerNotifications(read: false, bookIds: $bookIds) {
            id
            page {
              id
              slug
            }
            type
            read
          }
          pages (bookIds: $bookIds) {
            ${pageFragment}
          }
          sharedPages {
            ${pageFragment}
            sharedAt
          }
        }
      }
    }
    `,
        variables: {
          bookIds: [bookId],
          token,
          isCanopePublisher: isCanopePublisher(collectionPublisher),
          publishers: GQL_PUBLISHERS
        }
      }).then(normalizeData8);
    };
    fetchCreatePageScreen = ({ slugs, uris }) => {
      return gql({
        query: `query coreFetchCreatePageScreen ($slugs: [String], $uris: [String], $publishers: [Publishers], $hasNewDesign: Boolean!) {
      viewer {
        books (slugs: $slugs, uris: $uris, publishers: $publishers, hasNewDesign: $hasNewDesign, ) {
          hits{
            id
            title
            displayTitle
            urlLite
            slug
            uri
            firstValidPage {
              id
              slug
            }
            subjects {
              id
              slug
              name
            }
          }
        }
      }
    }
    `,
        variables: {
          slugs,
          uris,
          hasNewDesign: true,
          publishers: GQL_PUBLISHERS
        }
      }).then(normalizeData8);
    };
    fetchBookDrawerScreen = ({ slugs, uris, token }) => gql({
      query: `query coreFetchBookDrawerScreen ($slugs: [String], $uris: [String], $publishers: [Publishers], $hasNewDesign: Boolean!, $date: String!, $token: String) {
    viewer (token: $token) {
      books (slugs: $slugs, uris: $uris, publishers: $publishers, hasNewDesign: $hasNewDesign, ) {
        hits {
          id
          title
          displayTitle
          url
          urlLite
          renderer
          valid
          slug
          uri
          hasNewDesign
          publisher
          hasNoTeacherBook
          contributors
          nbContributors
          isRenewed
          renewalLabel
          firstValidPage {
            id
            slug
          }
          collection {
            id
            name
            publisher
          }
          chapters {
            id
            pages {
              id
              title
              createdAt
              numericOrder
              isWorkplan
              page
              isPartOfSession
              isOriginal
              slug
              isExercise
              chapter {
                id
              }
              book {
                id
              }
            }
          }
          oldBook {
            id
          }
          subjects {
            id
            slug
            name
          }
          levels {
            id
            slug
            name
            isHighSchool
            order
          }
          workbooks {
            id
            slug
            uri
          }
          workplans {
            id
            slug
            uri
          }
          textbooks {
            id
            slug
            uri
            displayTitle
            firstValidPage {
              id
              slug
            }
          }
          tools {
            ${toolsFragment}
            ${bookToolsFragment}
          }
          ${filtersFragment}
          ${summaryFragment}
          news (startsBefore: $date, endsAfter: $date){
            id
            displayTitle
            category
            content
            cover
            books {
              id
            }
            subjects {
              id
            }
            levels {
              id
            }
          }
        }
      }
    }
  }`,
      variables: {
        slugs,
        uris,
        hasNewDesign: true,
        publishers: GQL_PUBLISHERS,
        date: (0, import_dayjs3.default)().hour(12).minute(0).second(0).millisecond(0).toISOString(),
        token
      }
    }).then(normalizeData8);
    fetchBookPages = ({ slugs }) => {
      return gql({
        query: `query coreFetchBookPages ($slugs: [String]!, $hasNewDesign: Boolean!) {
    viewer {
      books (slugs: $slugs, hasNewDesign: $hasNewDesign) {
        hits {
          id
          ${summaryFragment}
        }
      }
    }
  }`,
        variables: { slugs, hasNewDesign: true }
      }).then(normalizeData8);
    };
    fetchMarketingViewerScreen = ({ slug }) => fetchPagesApi({ slugs: [slug] }).then(normalizeData8);
    fetchGroupsSettingsScreen = ({ token }) => gqlNoCache({
      query: `query coreFetchGroupsSettingsScreen ($token: String!) {
    viewer (token: $token) {
      me {
        id
        students {
          id
          firstname
          lastname
          connectorName
          lastLogin
          isGarUser
          schools {
            id
          }
          isStudent
          isTeacher
          levels {
            id
          }
        }
        garDivisions {
          id
          code
          name
          school {
            id
          }
          students {
            id
            lastname
            firstname
            levels {
              id
            }
          }
        }
        groups {
          id
          name
          code
          createdAt
          isEnt
          owner {
            id
          }
          students {
            id
          }
        }
        schools {
          id
          groups {
            id
            name
            isEnt
            owner {
              id
              lastname
              firstname
            }
            students {
              id
            }
          }
        }
      }
      levels {
        id
        name
        order
        schoolTypes {
          id
          slug
        }
      }
    }
  }`,
      variables: {
        token
      }
    }).then(normalizeData8);
    fetchUpdateUserInfosScreen = () => gql({
      query: `query {
      viewer {
        subjects {
          hits {
            id
            name
            code
            schoolTypes
          }
        }
        levels {
          id
          name
          order
          schoolTypes {
            id
          }
        }
        schoolTypes {
          hits {
            id
            name
            order
          }
        }
      }
    }`,
      variables: {}
    }).then(normalizeData8);
    fetchRevisionScreen = ({ bookIds, subjectIds }) => gql({
      query: `query coreFetchRevisionScreen ( $subjectIds: [Int], $bookIds: [Int]) {
    viewer {
      books (ids: $bookIds,subjectIds: $subjectIds, hasNewDesign: true, isValid: true) {
        hits {
          id
          uri
          urlLite
          displayTitle
          subjects {
            id
            name
            url
          }
          levels {
            id
            name
            order
          }
          chapters {
            id
            book {
              id
            }
          }
          revisionPages {
            id
            thematicName
            title
            slug
            chapter {
              id
            }
            book {
              id
            }
          }
        }
      }
    }
  }`,
      variables: {
        bookIds,
        subjectIds
      }
    }).then(normalizeData8);
    fetchRevisionBookScreen = ({ uri, token }) => gqlNoCache({
      query: `query coreFetchRevisionBookScreen ($uri: String, $token: String!) {
    viewer (token: $token) {
      me {
        groups {
          id
          name
          owner {
            id
          }
        }
      }
      books (uris: [$uri], hasNewDesign: true, isValid: true) {
        hits {
          id
          uri
          urlLite
          hasNewDesign
          displayTitle
          subjects {
            id
            name
            url
          }
          levels {
            id
          }
          chapters {
            id
            title
            number
            numShow
            book {
              id
            }
          }
          revisionPages {
            id
            thematicName
            title
            displayTitle
            slug
            chapter {
              id
            }
          }
        }
      }
    }
  }`,
      variables: {
        token,
        uri
      }
    }).then(normalizeData8);
    fetchLearningAssessmentScreen = async ({ uri, token, isTeacher }) => {
      const teacherFragment = `
      groups {
        id
        name
        students {
          id
          firstname
          lastname
        }
        owner {
          id
        }
      }
      userPages: pages {
        id
        children {
          id
        }
      }
  `;
      const studentFragment = `
    sharedPages{
      ${pageFragment}
      children {
        id
        responses
        uuid
        rightResponses
      }
      user {
        id
        firstname
        lastname
        gender
        isTeacher
        schools {
          id
        }
      }
      sharedAt
    }
  `;
      const userQuery = gqlNoCache({
        query: `query coreFetchLearningAssessmentScreen ($token: String!) {
    viewer (token: $token) {
      me {
        id
        ${isTeacher ? teacherFragment : studentFragment}
      }
    }
  }`,
        variables: {
          token
        }
      });
      const bookQuery = gql({
        query: `query coreFetchLearningAssessmentScreen ($uri: String, $publishers: [Publishers]) {
    viewer {
      books (uris: [$uri], hasNewDesign: true, isValid: true, publishers: $publishers) {
        hits {
          id
          uri
          urlLite
          hasNewDesign
          displayTitle
          subjects {
            id
            name
            url
          }
          levels {
            id
          }
          chapters {
            id
            title
            number
            numShow
            book {
              id
            }
          }
          revisionPages {
            id
            thematicName
            displayTitle
            slug
            isLearningAssessment
            chapter {
              id
            }
          }
        }
      }
    }
  }`,
        variables: {
          uri,
          publishers: GQL_COMMUNITY_PUBLISHER
        }
      });
      return Promise.all([userQuery, bookQuery]).then(
        ([userQueryResult, bookQueryResult]) => normalizeData8(_62.merge(userQueryResult, bookQueryResult))
      );
    };
    fetchUserScreen = fetchUpdateUserInfosScreen;
    fetchProfileScreen = ({ token }) => gqlNoCache({
      query: `query coreFetchProfileScreenApi($token: String!) {
    viewer(token: $token) {
      me {
        id
        hasContentNewsletter
      }
      schoolTypes(includeOptionals: true) {
        hits {
          id
          name
          order
        }
      }
      subjects {
        hits {
          id
          name
          code
          schoolTypes
          hasBooks
        }
      }
      levels {
        id
        name
        order
        schoolTypes {
          id
          slug
        }
      }
    }
}`,
      variables: { token }
    }).then(normalizeData8);
    fetchBookBrowsingModal = ({ token, bookIds = [], subjectIds }) => gql({
      query: `query coreFetchBookBrowsingModalApi ($token: String!,$hasNewDesign: Boolean, $publishers: [Publishers], $bookIds : [Int]!, $subjectIds : [Int]!) {
    viewer (token: $token) {
      books(publishers: $publishers, hasNewDesign: $hasNewDesign, ids: $bookIds, subjectIds: $subjectIds){
        hits{
          id
          displayTitle
          hasNewDesign
          uri
          publisher
          firstValidPage{
            id
            slug
          }
          subjects {
            id
          }
          oldBook {
            id
          }
          chapters {
            id
            numShow
            title
            book {
              id
            }
          }
        }
      }
    }
  }`,
      variables: {
        hasNewDesign: true,
        publishers: GQL_LLS_PUBLISHER,
        bookIds,
        subjectIds,
        token
      }
    }).then(normalizeData8);
  }
});

// src/hooks/fetch.js
import _63 from "lodash/fp.js";
import { useEffect as useEffect22 } from "react";
import { useDispatch as useDispatch19, useSelector as useSelector31 } from "react-redux";
import { getScreenLoadingEventName as getScreenLoadingEventName3 } from "@lls/utils";
import { setEntitiesReducer } from "@lls/store";
var fetchData, fetch2, singleFetch, useFetch, multiFetch, getInitialState, useMultiFetch;
var init_fetch = __esm({
  "src/hooks/fetch.js"() {
    "use strict";
    init_constants();
    init_es62();
    init_es();
    init_actions();
    init_panorama3();
    init_screen();
    init_user();
    init_loading2();
    init_loading3();
    init_notificationUi();
    init_loading();
    fetchData = ({ screen, params = {} }) => {
      switch (screen) {
        case SCREEN_PARTIAL_PANORAMA_DRAWER:
          return fetchPanoramaScreen(params);
        case SCREEN_PARTIAL_PANORAMA_DATA:
          return fetchPanoramas(params);
        case SCREEN_PARTIAL_PAGE_MAIN:
          return fetchPageScreen(params);
        case SCREEN_COPIES:
          return fetchCopiesScreen(params);
        case SCREEN_COPY:
          return fetchCopyScreen(params);
        case SCREEN_SHARE_CORRECTIONS:
          return fetchShareCorrectionsScreen(params);
        case SCREEN_SHARE_CORRECTIONS_STUDENTS:
          return fetchShareCorrectionsStudentsScreen(params);
        case SCREEN_PARTIAL_PAGE_CUSTOM_CACHE:
          return fetchCustomPagesCacheScreen(params);
        case SCREEN_PARTIAL_PAGE_CUSTOM_NOCACHE:
          return fetchCustomPagesNoCacheScreen(params);
        case SCREEN_PARTIAL_BOOK_DRAWER:
        case SCREEN_PARTIAL_PAGE_DRAWER:
          return fetchBookDrawerScreen(params);
        case SCREEN_PARTIAL_BOOK_PAGES:
          return fetchBookPages(params);
        case SCREEN_MARKETING_VIEWER:
          return fetchMarketingViewerScreen(params);
        case SCREEN_GROUPS_SETTINGS:
          return fetchGroupsSettingsScreen(params);
        case SCREEN_BOOK_REDIRECT:
          return fetchBookRedirectScreen(params);
        case SCREEN_PARTIAL_HOME_BOOKS:
          return fetchHomeScreen(params);
        case SCREEN_PARTIAL_MY_BOOKS:
        case NAVBAR_MODAL:
          return fetchMyBooksScreen(params);
        case SCREEN_USER:
          return fetchUserScreen(params);
        case SCREEN_PARTIAL_BOOK_MAIN:
          return fetchBookScreen(params);
        case SCREEN_PARTIAL_HOME_USER:
          return fetchUserWithGroups(params);
        case SCREEN_PARTIAL_MY_BOOKS_USER:
          return fetchUser(params);
        case SCREEN_CREATE_PAGE:
          return fetchCreatePageScreen(params);
        case SCREEN_REVISION:
          return fetchRevisionScreen(params);
        case SCREEN_REVISION_BOOK:
          return fetchRevisionBookScreen(params);
        case SCREEN_LEARNING_ASSESSMENT:
          return fetchLearningAssessmentScreen(params);
        case SCREEN_PROFILE:
          return fetchProfileScreen(params);
        case SCREEN_BOOK_BROWSING_MODAL:
          return fetchBookBrowsingModal(params);
      }
    };
    fetch2 = async ({ dispatch, screen, params = {} }) => {
      const screenEvent = getScreenLoadingEventName3(screen, params);
      dispatch(setLoadingScreen({ [screenEvent]: LOADING_STATUS }));
      const result = await fetchData({ screen, params });
      const entities2 = _63.get("entities", result);
      dispatch(setEntities(entities2));
      dispatch(setLoadingScreen({ [screenEvent]: LOADED_STATUS }));
      return result;
    };
    singleFetch = async ({
      dispatch,
      loading: loading2,
      // singleFetchOptions
      screen,
      params,
      fetchEvenIfLoaded
    }) => {
      if (loading2 === LOADING_STATUS) return;
      if (loading2 === LOADED_STATUS && !fetchEvenIfLoaded) return;
      try {
        await fetch2({ dispatch, screen, params });
      } catch (e) {
        console.error("fetch error:", _63.getOr(e, "response.data", e), "was", params);
        dispatch(addNotification(makeNotification({ name: "fetch_error" })));
      }
    };
    useFetch = ({ ssrFetcher, ...singleFetchOptions }) => {
      if (ssrFetcher) {
        return ssrFetcher(singleFetchOptions);
      }
      const { screen, params } = singleFetchOptions;
      const loading2 = useSelector31((state) => getLoadingStatus(state, screen, params));
      const dispatch = useDispatch19();
      return singleFetch({ loading: loading2, dispatch, ...singleFetchOptions });
    };
    multiFetch = async ({
      dispatch,
      cookies,
      screenEvent,
      loading: loading2,
      initialState: initialState5,
      // multiFetchOptions
      params,
      seq: seq5,
      screenToOptions
    }) => {
      if (loading2 === LOADING_STATUS) return;
      if (loading2 === LOADED_STATUS && !_63.some("fetchEvenIfLoaded", screenToOptions)) return;
      let state = initialState5;
      let deltaEntities = {};
      const localDispatch = ({ type, payload }) => {
        if (type === actionTypes.SET_ENTITIES) {
          const entities2 = setEntitiesReducer(state.entities, payload);
          if (entities2 !== state.entities) {
            state = _63.set("entities", entities2, state);
          }
          deltaEntities = setEntitiesReducer(deltaEntities, payload);
        } else {
          const loading3 = setLoadingReducer(state.loading, payload);
          state = _63.set("loading", loading3, state);
        }
      };
      const useSelector78 = (f) => f(state);
      dispatch(setLoadingScreen({ [screenEvent]: LOADING_STATUS }));
      const doFetch = async ({ screen: localScreen, getFetchParams = _63.constant(params) }) => {
        const localParams = getFetchParams({ params, dispatch: localDispatch, useSelector: useSelector78, cookies });
        if (!localParams) return;
        const localLoading = useSelector78((state2) => getLoadingStatus(state2, localScreen, localParams));
        return singleFetch({
          loading: localLoading,
          dispatch: localDispatch,
          screen: localScreen,
          params: localParams,
          fetchEvenIfLoaded: _63.get([localScreen, "fetchEvenIfLoaded"], screenToOptions)
        });
      };
      for (const fetchObjectOrArray of seq5) {
        await _63.flow(_63.castArray, _63.map(doFetch), Promise.all.bind(Promise))(fetchObjectOrArray);
      }
      dispatch(setEntities(deltaEntities));
      dispatch(
        setLoadingScreen({
          ..._63.pickBy(_63.isEqual(LOADED_STATUS), state.loading),
          [screenEvent]: LOADED_STATUS
        })
      );
    };
    getInitialState = createSelector(_63.identity, _63.assign({}));
    useMultiFetch = ({ ssrFetcher, ...multiFetchOptions }) => {
      if (ssrFetcher) {
        return ssrFetcher(multiFetchOptions);
      }
      const { screen, params } = multiFetchOptions;
      const dispatch = useDispatch19();
      const [cookies] = useCookies();
      const screenEvent = getScreenLoadingEventName3(screen, params);
      const loading2 = useSelector31((state) => getLoadingStatus(state, screen, params));
      const initialState5 = useSelector31(getInitialState);
      useEffect22(() => {
        multiFetch({ dispatch, cookies, screenEvent, loading: loading2, initialState: initialState5, ...multiFetchOptions });
      }, [dispatch, cookies, screenEvent, loading2, initialState5, multiFetchOptions]);
    };
  }
});

// src/utils/home.js
import _65 from "lodash/fp.js";
var import_dayjs4, getHomeDisplayedDate, extractSharedPagesFromGroups;
var init_home = __esm({
  "src/utils/home.js"() {
    "use strict";
    import_dayjs4 = __toESM(require_dayjs_min(), 1);
    getHomeDisplayedDate = (date) => {
      const days = (0, import_dayjs4.default)(Date.now()).diff(date, "day");
      switch (days) {
        case 0:
          return "aujourd'hui";
        case 1:
          return "hier";
        default:
          return `il y a ${days} jours`;
      }
    };
    extractSharedPagesFromGroups = (groups) => _65.flow(
      _65.flatMap(({ sharedPages, ...group }) => _65.map((sharedPage) => ({ ...sharedPage, group }), sharedPages)),
      _65.filter((page) => page.isCreatedFromScratch || page.hasRightResponses),
      _65.orderBy("sharedAt", "desc")
    )(groups);
  }
});

// src/utils/string.js
import _66 from "lodash/fp.js";
var priceFormatter, handlePlural, cleanString, formatPrice;
var init_string = __esm({
  "src/utils/string.js"() {
    "use strict";
    priceFormatter = new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" });
    handlePlural = (string, items) => `${string}${_66.size(items) > 1 ? "s" : ""}`;
    cleanString = _66.flow(_66.toLower, _66.trim, _66.deburr);
    formatPrice = priceFormatter.format;
  }
});

// css-modules:css-modules://NGTay09RbmV1SJRRX4C1sp9e1RdeWWmbN8oYvGnLoW0.css
var init_NGTay09RbmV1SJRRX4C1sp9e1RdeWWmbN8oYvGnLoW0 = __esm({
  "css-modules:css-modules://NGTay09RbmV1SJRRX4C1sp9e1RdeWWmbN8oYvGnLoW0.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_home_activity.module.css
var src_components_home_activity_default;
var init_src_components_home_activity = __esm({
  "tmp_esbuild1736180049684/_src_components_home_activity.module.css"() {
    "use strict";
    init_NGTay09RbmV1SJRRX4C1sp9e1RdeWWmbN8oYvGnLoW0();
    src_components_home_activity_default = { "header": "core-2-ChHG-header", "itemHeaderComplementary": "core-2-ChHG-itemHeaderComplementary", "placeholder": "core-2-ChHG-placeholder", "placeholderTitle": "core-2-ChHG-placeholderTitle", "headerTitles": "core-2-ChHG-headerTitles", "placeholderButton": "core-2-ChHG-placeholderButton", "itemHeader": "core-2-ChHG-itemHeader", "subtitle": "core-2-ChHG-subtitle", "itemHeaderPagination": "core-2-ChHG-itemHeaderPagination", "itemHeaderPageTitle": "core-2-ChHG-itemHeaderPageTitle", "content": "core-2-ChHG-content", "activity": "core-2-ChHG-activity", "itemAnswersProgressBar": "core-2-ChHG-itemAnswersProgressBar", "item": "core-2-ChHG-item", "itemAnswersProgressBarProgression": "core-2-ChHG-itemAnswersProgressBarProgression", "itemAnswers": "core-2-ChHG-itemAnswers", "bgRight": "core-2-ChHG-bgRight", "itemHeaderClassroom": "core-2-ChHG-itemHeaderClassroom", "answersLabel": "core-2-ChHG-answersLabel", "answersData": "core-2-ChHG-answersData", "title": "core-2-ChHG-title", "placeholderDescription": "core-2-ChHG-placeholderDescription", "bgLeft": "core-2-ChHG-bgLeft", "illu": "core-2-ChHG-illu", "itemBody": "core-2-ChHG-itemBody" };
  }
});

// src/components/home/activity.module.css
var init_activity = __esm({
  "src/components/home/activity.module.css"() {
    "use strict";
    init_src_components_home_activity();
  }
});

// src/components/home/activity.jsx
import { Button as Button31, List } from "@lls/lls-kit";
import { getUserGroups, useSearchCurrentUserSharedPages } from "@lls/store";
import { dispatchAnalyticsEvent as dispatchAnalyticsEvent16, getPageInterval } from "@lls/utils";
import _67 from "lodash/fp.js";
import { useDispatch as useDispatch21, useSelector as useSelector34 } from "react-redux";
import { useHistory as useHistory14 } from "react-router-dom";
import { jsx as jsx71, jsxs as jsxs48 } from "react/jsx-runtime";
var Activity, activity_default;
var init_activity2 = __esm({
  "src/components/home/activity.jsx"() {
    "use strict";
    init_actions();
    init_link();
    init_analytics4();
    init_tour2();
    init_home();
    init_route();
    init_string();
    init_activity();
    Activity = ({ startTour, currentUser }) => {
      const history = useHistory14();
      const dispatch = useDispatch21();
      const groups = useSelector34(getUserGroups);
      const sharedPagesToGroup = extractSharedPagesFromGroups(groups);
      const sharedPagesToMe = useSearchCurrentUserSharedPages({ parentIds: _67.map("id", sharedPagesToGroup) });
      const onItemClick = ({ bookId, pageId, index: index3 }) => {
        dispatchAnalyticsEvent16(ANALYTICS_EVENTS.LINK_CLICKED, {
          featureName: "home|group_activity",
          resourceId: [`${bookId}|${pageId}`],
          extraData: `${index3 + 1}`
        });
      };
      const launchTour = () => {
        dispatch(setScenarioId(ONBOARDING_SCENARIO));
        startTour(SHARE_TOUR);
      };
      return _67.isEmpty(groups) ? /* @__PURE__ */ jsxs48("div", { className: src_components_home_activity_default.placeholder, "data-type": "no-group", children: [
        /* @__PURE__ */ jsx71("img", { className: src_components_home_activity_default.bgLeft, src: "/assets/img/home/numeric_resources_left_blue.svg" }),
        /* @__PURE__ */ jsx71("img", { className: src_components_home_activity_default.bgRight, src: "/assets/img/home/numeric_resources_right_blue.svg" }),
        /* @__PURE__ */ jsxs48("div", { className: src_components_home_activity_default.content, children: [
          /* @__PURE__ */ jsx71("h3", { className: src_components_home_activity_default.placeholderTitle, children: "Ajoutez vos classes" }),
          /* @__PURE__ */ jsx71("div", { className: src_components_home_activity_default.placeholderDescription, children: "Partagez des cours ou des exercices plus facilement et suivez l'activit\xE9 de vos \xE9l\xE8ves en cr\xE9ant des groupes." }),
          /* @__PURE__ */ jsx71(
            Button31,
            {
              className: src_components_home_activity_default.placeholderButton,
              icon: "arrowright",
              iconPosition: "right",
              href: getPath("classroom_settings"),
              onGoTo: ({ href }) => history.push(href),
              children: "Ajouter mes classes"
            }
          )
        ] }),
        /* @__PURE__ */ jsx71("div", { className: src_components_home_activity_default.illu, children: /* @__PURE__ */ jsx71("img", { src: "/assets/img/home/numeric_school.webp" }) })
      ] }) : _67.isEmpty(sharedPagesToGroup) ? /* @__PURE__ */ jsxs48("div", { className: src_components_home_activity_default.placeholder, "data-type": "no-share", children: [
        /* @__PURE__ */ jsx71("img", { className: src_components_home_activity_default.bgLeft, src: "/assets/img/home/numeric_resources_left.svg" }),
        /* @__PURE__ */ jsx71("img", { className: src_components_home_activity_default.bgRight, src: "/assets/img/home/numeric_resources_right.svg" }),
        /* @__PURE__ */ jsxs48("div", { className: src_components_home_activity_default.content, children: [
          /* @__PURE__ */ jsx71("h3", { className: src_components_home_activity_default.placeholderTitle, children: "Partagez des contenus \xE0 vos classes" }),
          /* @__PURE__ */ jsxs48("div", { className: src_components_home_activity_default.placeholderDescription, children: [
            "Envoyez des cours, des activit\xE9s, ou des exercices \xE0 vos classes. Une fois renvoy\xE9es par vos \xE9l\xE8ves, vous pourrez consulter directement leurs r\xE9ponses.",
            /* @__PURE__ */ jsx71("span", { children: "La pr\xE9sentation de cette fonctionnalit\xE9 n'est pas disponible sur mobile. Pour plus d'accompagnement, privil\xE9giez une tablette ou un ordinateur." })
          ] }),
          !(currentUser == null ? void 0 : currentUser.isTrial) && /* @__PURE__ */ jsx71(Button31, { className: src_components_home_activity_default.placeholderButton, theme: "premium", onClick: launchTour, children: "Comment faire ?" })
        ] }),
        /* @__PURE__ */ jsx71("div", { className: src_components_home_activity_default.illu, children: /* @__PURE__ */ jsx71("img", { src: "/assets/img/home/numeric_resources.webp" }) })
      ] }) : /* @__PURE__ */ jsxs48(List, { className: src_components_home_activity_default.activity, foldedMaxLength: 5, children: [
        /* @__PURE__ */ jsxs48("div", { className: src_components_home_activity_default.header, children: [
          /* @__PURE__ */ jsxs48("div", { className: src_components_home_activity_default.headerTitles, children: [
            /* @__PURE__ */ jsx71("h2", { className: src_components_home_activity_default.title, children: "Activit\xE9 de mes classes" }),
            /* @__PURE__ */ jsx71("div", { className: src_components_home_activity_default.subtitle, children: "des 2 derni\xE8res semaines" })
          ] }),
          /* @__PURE__ */ jsx71(
            Button31,
            {
              accent: "floating",
              icon: "groupfilled",
              href: getPath("classroom_settings"),
              onGoTo: ({ href }) => history.push(href),
              children: "G\xE9rer mes classes"
            }
          )
        ] }),
        sharedPagesToGroup == null ? void 0 : sharedPagesToGroup.map((sharedPage, index3) => {
          var _a2, _b2, _c2, _d, _e, _f, _g, _h, _i;
          const paginationLabel = `${((_a2 = sharedPage.chapter) == null ? void 0 : _a2.numShow) ? `${sharedPage.chapter.numShow} - ` : ""}${getPageInterval({ page: sharedPage })}`;
          const students = (_b2 = sharedPage.group) == null ? void 0 : _b2.students;
          const studentTotal = _67.size(students);
          const isPartOfSession = sharedPage == null ? void 0 : sharedPage.isPartOfSession;
          const studentAnswers = isPartOfSession ? (_e = (_d = sharedPage.nbSessionAnswersByGroups) == null ? void 0 : _d[(_c2 = sharedPage.group) == null ? void 0 : _c2.id]) == null ? void 0 : _e.nbAnswers : _67.flow(_67.filter({ parent: sharedPage.id }), _67.size)(sharedPagesToMe);
          const isWorkplan = sharedPage == null ? void 0 : sharedPage.isWorkplan;
          const progress = Math.round(studentAnswers / (studentTotal || 1) * 100);
          const key = `${sharedPage.id}-${((_f = sharedPage.group) == null ? void 0 : _f.id) ?? ""}`;
          const isLearningAssessment = sharedPage == null ? void 0 : sharedPage.isLearningAssessment;
          const bookSlug = (_g = sharedPage == null ? void 0 : sharedPage.book) == null ? void 0 : _g.uri;
          const to = isLearningAssessment ? getPath("learning_assessment") : isPartOfSession ? getPath("page", { slug: sharedPage.slug }) : isWorkplan ? getPath("book", { uri: bookSlug }) : getPath("copies", { parentId: sharedPage.id, query: { defaultGroup: (_h = sharedPage.group) == null ? void 0 : _h.id } });
          return /* @__PURE__ */ jsxs48(
            link_default,
            {
              className: src_components_home_activity_default.item,
              to,
              onClick: () => {
                var _a3;
                return onItemClick({ bookId: (_a3 = sharedPage.book) == null ? void 0 : _a3.id, pageId: sharedPage.id, index: index3 + 1 });
              },
              children: [
                /* @__PURE__ */ jsxs48("div", { className: src_components_home_activity_default.itemHeader, children: [
                  /* @__PURE__ */ jsx71("h3", { className: src_components_home_activity_default.itemHeaderClassroom, "data-clarity-mask": "true", children: (_i = sharedPage.group) == null ? void 0 : _i.name }),
                  /* @__PURE__ */ jsxs48("div", { className: src_components_home_activity_default.itemHeaderComplementary, children: [
                    /* @__PURE__ */ jsx71("div", { className: src_components_home_activity_default.itemHeaderPagination, children: paginationLabel }),
                    /* @__PURE__ */ jsx71("div", { className: src_components_home_activity_default.itemHeaderPageTitle, children: sharedPage.displayTitle })
                  ] })
                ] }),
                /* @__PURE__ */ jsxs48("div", { className: src_components_home_activity_default.itemBody, children: [
                  /* @__PURE__ */ jsxs48("div", { className: src_components_home_activity_default.itemAnswers, "data-completed": +(progress === 100), children: [
                    /* @__PURE__ */ jsx71("div", { className: src_components_home_activity_default.answersLabel, children: isLearningAssessment ? "Session partag\xE9e \xE0" : "R\xE9ponses re\xE7ues" }),
                    /* @__PURE__ */ jsx71("div", { className: src_components_home_activity_default.answersData, children: isLearningAssessment ? `${studentTotal} ${handlePlural("\xE9l\xE8ve", students)}` : `${studentAnswers} ${handlePlural("\xE9l\xE8ve", Array(studentAnswers))} sur ${studentTotal}` })
                  ] }),
                  !isLearningAssessment && !isWorkplan && /* @__PURE__ */ jsx71("div", { className: src_components_home_activity_default.itemAnswersProgressBar, children: /* @__PURE__ */ jsx71(
                    "div",
                    {
                      className: src_components_home_activity_default.itemAnswersProgressBarProgression,
                      style: { "--c-progress": `${progress}%` }
                    }
                  ) })
                ] })
              ]
            },
            key
          );
        })
      ] });
    };
    activity_default = Activity;
  }
});

// src/hooks/useLastPagesViewed.ts
import { useSearchPages as useSearchPages5 } from "@lls/store";
import _68 from "lodash/fp.js";
import { useMemo as useMemo14 } from "react";
var useLastPagesViewed, useLastPagesViewed_default;
var init_useLastPagesViewed = __esm({
  "src/hooks/useLastPagesViewed.ts"() {
    "use strict";
    useLastPagesViewed = ({ currentUser, book }) => {
      const lastPagesViewedIds = _68.get("lastPagesViewed", currentUser);
      const ids = _68.compact(lastPagesViewedIds);
      const sortByQuery = useMemo14(() => _68.flow(_68.orderBy("seenAt", "desc"), _68.take(3)), []);
      return useSearchPages5({ ids, bookIds: [_68.get("id", book)], sortByQuery });
    };
    useLastPagesViewed_default = useLastPagesViewed;
  }
});

// css-modules:css-modules://1NxOOCGf5f2UKgM6qSB0hmKrha7wVm07tKsvhBY0F44.css
var init_NxOOCGf5f2UKgM6qSB0hmKrha7wVm07tKsvhBY0F44 = __esm({
  "css-modules:css-modules://1NxOOCGf5f2UKgM6qSB0hmKrha7wVm07tKsvhBY0F44.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_home_bookCard.module.css
var src_components_home_bookCard_default;
var init_src_components_home_bookCard = __esm({
  "tmp_esbuild1736180049684/_src_components_home_bookCard.module.css"() {
    "use strict";
    init_NxOOCGf5f2UKgM6qSB0hmKrha7wVm07tKsvhBY0F44();
    src_components_home_bookCard_default = { "title": "core-KBTXnG-title", "pageTitle": "core-KBTXnG-pageTitle", "page": "core-KBTXnG-page", "infos": "core-KBTXnG-infos", "card": "core-KBTXnG-card", "numShow": "core-KBTXnG-numShow", "pageInterval": "core-KBTXnG-pageInterval", "list": "core-KBTXnG-list" };
  }
});

// src/components/home/bookCard.module.css
var init_bookCard = __esm({
  "src/components/home/bookCard.module.css"() {
    "use strict";
    init_src_components_home_bookCard();
  }
});

// src/components/home/bookCard.jsx
import _69 from "lodash/fp.js";
import React8, { useCallback as useCallback30 } from "react";
import { useSelector as useSelector35 } from "react-redux";
import { useHistory as useHistory15 } from "react-router-dom";
import { BookCover as BookCover2, Divider as Divider7 } from "@lls/lls-kit";
import { dispatchAnalyticsEvent as dispatchAnalyticsEvent17, getPageInterval as getPageInterval2 } from "@lls/utils";
import { getCollection, useSearchChapters as useSearchChapters2 } from "@lls/store";
import { jsx as jsx72, jsxs as jsxs49 } from "react/jsx-runtime";
var BookCard, bookCard_default;
var init_bookCard2 = __esm({
  "src/components/home/bookCard.jsx"() {
    "use strict";
    init_analytics4();
    init_route();
    init_link();
    init_useLastPagesViewed();
    init_home();
    init_bookCard();
    BookCard = ({ book, currentUser, setActiveBook, activeBook, isMobile, index: index3, listSize }) => {
      const history = useHistory15();
      const active = activeBook === (book == null ? void 0 : book.id);
      const onHover = useCallback30(() => {
        !isMobile && setActiveBook(book == null ? void 0 : book.id);
      }, [setActiveBook, book, isMobile]);
      const onLeave = useCallback30(() => {
        setActiveBook(null);
      }, [setActiveBook]);
      const lastPagesViewed = useLastPagesViewed_default({ currentUser, book });
      const chapters = useSearchChapters2({ ids: _69.map("chapter", lastPagesViewed) });
      const collection = useSelector35((state) => getCollection(state, _69.get("collection", book)));
      const dispatchPageAnalytics = ({ page, pageIndex }) => {
        dispatchAnalyticsEvent17(ANALYTICS_EVENTS.LINK_CLICKED, {
          featureName: "home|recent_pages",
          resourceId: [`${book == null ? void 0 : book.id}|${page == null ? void 0 : page.id}`],
          extraData: `${pageIndex + 1}`
        });
      };
      const onGoToBook = () => {
        dispatchAnalyticsEvent17(ANALYTICS_EVENTS.LINK_CLICKED, {
          featureName: "home|recent_books",
          resourceId: [`${book == null ? void 0 : book.id}`],
          extraData: `${index3 + 1}`
        });
        history.push(getPath("book", book));
      };
      return /* @__PURE__ */ jsxs49(
        "div",
        {
          className: src_components_home_bookCard_default.card,
          onMouseLeave: onLeave,
          "data-active": +active,
          "data-noactive": +(!active && activeBook !== null),
          "data-lastindex": +(index3 === listSize - 1),
          children: [
            /* @__PURE__ */ jsx72(
              BookCover2,
              {
                height: "240px",
                src: book.urlLite,
                hasWallShadow: !active && !isMobile,
                onMouseEnter: onHover,
                onClick: onGoToBook,
                withArrow: active
              }
            ),
            /* @__PURE__ */ jsxs49("div", { className: src_components_home_bookCard_default.infos, children: [
              /* @__PURE__ */ jsxs49("div", { className: src_components_home_bookCard_default.title, children: [
                /* @__PURE__ */ jsx72("h2", { children: book == null ? void 0 : book.displayTitle }),
                /* @__PURE__ */ jsx72("span", { children: collection == null ? void 0 : collection.name })
              ] }),
              /* @__PURE__ */ jsx72("div", { className: src_components_home_bookCard_default.list, children: _69.map.convert({ cap: false })((page, pageIndex) => {
                const chapter = _69.find({ id: page == null ? void 0 : page.chapter }, chapters);
                const url = getPath("page", { slug: page == null ? void 0 : page.slug });
                return /* @__PURE__ */ jsxs49(React8.Fragment, { children: [
                  pageIndex !== 0 && /* @__PURE__ */ jsx72(Divider7, {}),
                  /* @__PURE__ */ jsxs49(
                    link_default,
                    {
                      className: src_components_home_bookCard_default.page,
                      to: url,
                      onClick: () => dispatchPageAnalytics({ page, pageIndex }),
                      "data-mobile": +isMobile,
                      children: [
                        isMobile ? /* @__PURE__ */ jsxs49("span", { className: src_components_home_bookCard_default.numShow, children: [
                          chapter == null ? void 0 : chapter.numShow,
                          " - ",
                          getPageInterval2({ page })
                        ] }) : /* @__PURE__ */ jsx72("span", { className: src_components_home_bookCard_default.numShow, children: chapter == null ? void 0 : chapter.numShow }),
                        /* @__PURE__ */ jsxs49("div", { className: src_components_home_bookCard_default.pageTitle, children: [
                          /* @__PURE__ */ jsx72("h4", { children: page == null ? void 0 : page.displayTitle }),
                          /* @__PURE__ */ jsx72("span", { children: (page == null ? void 0 : page.seenAt) ? `Consult\xE9e ${getHomeDisplayedDate(page == null ? void 0 : page.seenAt)}` : "D\xE9couvrez ce manuel !" })
                        ] }),
                        !isMobile ? /* @__PURE__ */ jsx72("span", { className: src_components_home_bookCard_default.pageInterval, children: getPageInterval2({ page }) }) : null
                      ]
                    }
                  )
                ] }, page == null ? void 0 : page.id);
              }, lastPagesViewed) })
            ] })
          ]
        }
      );
    };
    bookCard_default = BookCard;
  }
});

// css-modules:css-modules://ERk3Drk_9mV6r5EFsLp4B-Nrg-K_zJYA4L1qV-1Q1bg.css
var init_ERk3Drk_9mV6r5EFsLp4B_Nrg_K_zJYA4L1qV_1Q1bg = __esm({
  "css-modules:css-modules://ERk3Drk_9mV6r5EFsLp4B-Nrg-K_zJYA4L1qV-1Q1bg.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_home_bookList.module.css
var src_components_home_bookList_default;
var init_src_components_home_bookList = __esm({
  "tmp_esbuild1736180049684/_src_components_home_bookList.module.css"() {
    "use strict";
    init_ERk3Drk_9mV6r5EFsLp4B_Nrg_K_zJYA4L1qV_1Q1bg();
    src_components_home_bookList_default = { "tip": "core-4l7Mba-tip superkit-permanentMarkerRegular", "lastBooks": "core-4l7Mba-lastBooks" };
  }
});

// src/components/home/bookList.module.css
var init_bookList = __esm({
  "src/components/home/bookList.module.css"() {
    "use strict";
    init_src_components_home_bookList();
  }
});

// src/components/home/bookList.jsx
import _70 from "lodash/fp.js";
import { useEffect as useEffect23, useState as useState20 } from "react";
import { useSelector as useSelector36 } from "react-redux";
import { Carousel as Carousel2 } from "@lls/lls-kit";
import { getBrowserWidth as getBrowserWidth2 } from "@lls/utils";
import { getCurrentUser as getCurrentUser22 } from "@lls/store";
import { Fragment as Fragment15, jsx as jsx73, jsxs as jsxs50 } from "react/jsx-runtime";
var BookList, bookList_default;
var init_bookList2 = __esm({
  "src/components/home/bookList.jsx"() {
    "use strict";
    init_book3();
    init_style();
    init_bookCard2();
    init_bookList();
    BookList = () => {
      const currentUser = useSelector36(getCurrentUser22);
      const [isMobile, setIsMobile] = useState20(false);
      useEffect23(() => {
        setIsMobile(getBrowserWidth2() < BREAKPOINT_PHABLET);
      }, []);
      const selectedBooks = useSelector36(getBestMatchingBooksForUser);
      const [activeBook, setActiveBook] = useState20(null);
      return /* @__PURE__ */ jsxs50("div", { className: src_components_home_bookList_default.lastBooks, children: [
        /* @__PURE__ */ jsxs50("p", { className: src_components_home_bookList_default.tip, "data-hidden": +!!activeBook, children: [
          "Vos derniers",
          /* @__PURE__ */ jsx73("br", {}),
          " manuels consult\xE9s"
        ] }),
        isMobile ? /* @__PURE__ */ jsx73(
          Carousel2,
          {
            items: _70.map.convert({ cap: false })(
              (book, index3) => ({
                book,
                isMobile,
                currentUser,
                index: index3,
                setActiveBook,
                activeBook,
                listSize: _70.size(selectedBooks)
              }),
              selectedBooks
            ),
            ComponentItem: bookCard_default,
            width: "100%"
          }
        ) : /* @__PURE__ */ jsx73(Fragment15, { children: selectedBooks == null ? void 0 : selectedBooks.map((book, index3) => /* @__PURE__ */ jsx73(
          bookCard_default,
          {
            isMobile,
            book,
            currentUser,
            setActiveBook,
            activeBook,
            index: index3,
            listSize: _70.size(selectedBooks)
          },
          book.id
        )) })
      ] });
    };
    bookList_default = BookList;
  }
});

// css-modules:css-modules://7ScCUE4U-Rfn1dYDdEgqXA7S4wzWHApPfS2VzWZWqOk.css
var init_ScCUE4U_Rfn1dYDdEgqXA7S4wzWHApPfS2VzWZWqOk = __esm({
  "css-modules:css-modules://7ScCUE4U-Rfn1dYDdEgqXA7S4wzWHApPfS2VzWZWqOk.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_home_index.module.css
var src_components_home_index_default;
var init_src_components_home_index = __esm({
  "tmp_esbuild1736180049684/_src_components_home_index.module.css"() {
    "use strict";
    init_ScCUE4U_Rfn1dYDdEgqXA7S4wzWHApPfS2VzWZWqOk();
    src_components_home_index_default = { "body": "core-7JFMTa-body", "communityContactHelp": "core-7JFMTa-communityContactHelp", "container": "core-7JFMTa-container", "home": "core-7JFMTa-home", "bookList": "core-7JFMTa-bookList", "side": "core-7JFMTa-side", "title": "core-7JFMTa-title", "main": "core-7JFMTa-main" };
  }
});

// src/components/home/index.module.css
var init_home2 = __esm({
  "src/components/home/index.module.css"() {
    "use strict";
    init_src_components_home_index();
  }
});

// src/constants/home.js
var MAX_USER_PAGES;
var init_home3 = __esm({
  "src/constants/home.js"() {
    "use strict";
    MAX_USER_PAGES = 7;
  }
});

// css-modules:css-modules://aV2vhadFcK71dbOywxqRgQ_xMnz85lOCrhWjANpoVUM.css
var init_aV2vhadFcK71dbOywxqRgQ_xMnz85lOCrhWjANpoVUM = __esm({
  "css-modules:css-modules://aV2vhadFcK71dbOywxqRgQ_xMnz85lOCrhWjANpoVUM.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_home_lastExercisesDone.module.css
var src_components_home_lastExercisesDone_default;
var init_src_components_home_lastExercisesDone = __esm({
  "tmp_esbuild1736180049684/_src_components_home_lastExercisesDone.module.css"() {
    "use strict";
    init_aV2vhadFcK71dbOywxqRgQ_xMnz85lOCrhWjANpoVUM();
    src_components_home_lastExercisesDone_default = { "title": "core-GHh6Ra-title", "placeholder": "core-GHh6Ra-placeholder", "list": "core-GHh6Ra-list" };
  }
});

// src/components/home/lastExercisesDone.module.css
var init_lastExercisesDone = __esm({
  "src/components/home/lastExercisesDone.module.css"() {
    "use strict";
    init_src_components_home_lastExercisesDone();
  }
});

// css-modules:css-modules://6R6ufmDwu6jGqjTj1lDN78M3nyXiPg94e8JU0UtdJIw.css
var init_R6ufmDwu6jGqjTj1lDN78M3nyXiPg94e8JU0UtdJIw = __esm({
  "css-modules:css-modules://6R6ufmDwu6jGqjTj1lDN78M3nyXiPg94e8JU0UtdJIw.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_home_pageListItem.module.css
var src_components_home_pageListItem_default;
var init_src_components_home_pageListItem = __esm({
  "tmp_esbuild1736180049684/_src_components_home_pageListItem.module.css"() {
    "use strict";
    init_R6ufmDwu6jGqjTj1lDN78M3nyXiPg94e8JU0UtdJIw();
    src_components_home_pageListItem_default = { "secondaryInfos": "core-XpXRnG-secondaryInfos", "tags": "core-XpXRnG-tags", "informations": "core-XpXRnG-informations", "mainInfos": "core-XpXRnG-mainInfos", "pageTitle": "core-XpXRnG-pageTitle", "container": "core-XpXRnG-container", "listItem": "core-XpXRnG-listItem" };
  }
});

// src/components/home/pageListItem.module.css
var init_pageListItem = __esm({
  "src/components/home/pageListItem.module.css"() {
    "use strict";
    init_src_components_home_pageListItem();
  }
});

// src/components/home/pageListItem.jsx
import { Divider as Divider8 } from "@lls/lls-kit";
import _71 from "lodash/fp.js";
import { jsx as jsx74, jsxs as jsxs51 } from "react/jsx-runtime";
var PageListItem, pageListItem_default;
var init_pageListItem2 = __esm({
  "src/components/home/pageListItem.jsx"() {
    "use strict";
    init_link();
    init_pageListItem();
    PageListItem = ({
      tagsChildren = null,
      paginationLabel = "",
      to = "",
      title = "",
      timeLabel = "",
      onClick = _71.noop
    }) => {
      return /* @__PURE__ */ jsxs51("div", { className: src_components_home_pageListItem_default.container, children: [
        /* @__PURE__ */ jsxs51(link_default, { className: src_components_home_pageListItem_default.listItem, to, onClick, children: [
          /* @__PURE__ */ jsx74("div", { className: src_components_home_pageListItem_default.tags, children: tagsChildren }),
          /* @__PURE__ */ jsxs51("div", { className: src_components_home_pageListItem_default.informations, children: [
            /* @__PURE__ */ jsx74("span", { className: src_components_home_pageListItem_default.secondaryInfos, children: paginationLabel }),
            /* @__PURE__ */ jsx74("div", { className: src_components_home_pageListItem_default.mainInfos, children: /* @__PURE__ */ jsx74("h3", { className: src_components_home_pageListItem_default.pageTitle, children: title }) }),
            /* @__PURE__ */ jsx74("span", { className: src_components_home_pageListItem_default.secondaryInfos, children: timeLabel })
          ] })
        ] }),
        /* @__PURE__ */ jsx74(Divider8, {})
      ] });
    };
    pageListItem_default = PageListItem;
  }
});

// src/components/home/lastExercisesDone.jsx
import _72 from "lodash/fp.js";
import { List as List2, Tag as Tag2 } from "@lls/lls-kit";
import {
  ANALYTICS_LINK_CLICKED as ANALYTICS_LINK_CLICKED5,
  dispatchAnalyticsEvent as dispatchAnalyticsEvent18,
  displayUserGenderTitle as displayUserGenderTitle2,
  getPageInterval as getPageInterval3,
  getPagePath as getPagePath4
} from "@lls/utils";
import { useSelector as useSelector37 } from "react-redux";
import { getUsers } from "@lls/store";
import { Fragment as Fragment16, jsx as jsx75, jsxs as jsxs52 } from "react/jsx-runtime";
var LastExercisesDone, lastExercisesDone_default;
var init_lastExercisesDone2 = __esm({
  "src/components/home/lastExercisesDone.jsx"() {
    "use strict";
    init_home3();
    init_home();
    init_lastExercisesDone();
    init_pageListItem2();
    LastExercisesDone = ({ customPages, books, chapters, originalPages }) => {
      const users = useSelector37(getUsers);
      const lastPages = _72.flow(
        _72.compact,
        _72.orderBy((page) => page.sharedAt || page.updatedAt || page.createdAt, "desc"),
        _72.take(MAX_USER_PAGES)
      )(customPages);
      const onItemClick = ({ book, page, index: index3 }) => {
        dispatchAnalyticsEvent18(ANALYTICS_LINK_CLICKED5, {
          featureName: "home|groups_activity",
          resourceId: [`${book == null ? void 0 : book.id}|${page == null ? void 0 : page.id}`],
          extraData: `${index3 + 1}`
        });
      };
      return /* @__PURE__ */ jsxs52(List2, { className: src_components_home_lastExercisesDone_default.list, foldedMaxLength: 4, children: [
        /* @__PURE__ */ jsx75("h3", { className: src_components_home_lastExercisesDone_default.title, children: "Mes derniers exercices r\xE9alis\xE9s" }),
        _72.isEmpty(lastPages) ? /* @__PURE__ */ jsxs52("p", { className: src_components_home_lastExercisesDone_default.placeholder, children: [
          /* @__PURE__ */ jsx75("span", { children: "Aucune r\xE9ponse pour l'instant." }),
          /* @__PURE__ */ jsx75("br", {}),
          "Les derni\xE8res pages avec tes exercices r\xE9alis\xE9s s'afficheront ici."
        ] }) : lastPages == null ? void 0 : lastPages.map((page, index3) => {
          const book = _72.find({ id: page.book }, books);
          const chapter = _72.find({ id: page.chapter }, chapters);
          const originalPage = _72.find({ id: page.originalPage }, originalPages);
          const teacher = _72.find({ id: page.sharedTeacher }, users);
          const lastModificationDate = (page == null ? void 0 : page.sharedAt) || (page == null ? void 0 : page.updatedAt) || (page == null ? void 0 : page.createdAt);
          const timeLabel = teacher ? `Partag\xE9e ${getHomeDisplayedDate(lastModificationDate)}` : `Modifi\xE9e ${getHomeDisplayedDate(lastModificationDate)}`;
          const paginationLabel = `${(chapter == null ? void 0 : chapter.numShow) ? `${chapter.numShow} - ` : ""}${getPageInterval3({ page: originalPage })}`;
          const tagsChildren = /* @__PURE__ */ jsxs52(Fragment16, { children: [
            book ? /* @__PURE__ */ jsx75(Tag2, { icon: "importcontactfilled", children: book.displayTitle }) : null,
            /* @__PURE__ */ jsx75(
              Tag2,
              {
                "data-clarity-mask": teacher ? "true" : "false",
                icon: teacher ? "personfilled" : "warningfilled",
                theme: teacher ? "success" : "gray",
                children: teacher ? `Partag\xE9 avec ${displayUserGenderTitle2(_72.pick(["gender"], teacher))} ${_72.get("lastname", teacher)}` : "Pas partag\xE9"
              }
            )
          ] });
          return /* @__PURE__ */ jsx75(
            pageListItem_default,
            {
              to: getPagePath4({ slug: page == null ? void 0 : page.slug }),
              tagsChildren,
              paginationLabel,
              timeLabel,
              title: page == null ? void 0 : page.displayTitle,
              onClick: () => onItemClick({ book, page, index: index3 })
            },
            page == null ? void 0 : page.id
          );
        })
      ] });
    };
    lastExercisesDone_default = LastExercisesDone;
  }
});

// css-modules:css-modules://ZU8C9pCp1xf9J2Ppq3eIsl9NuEMXDF1XSo71o0YZmjI.css
var init_ZU8C9pCp1xf9J2Ppq3eIsl9NuEMXDF1XSo71o0YZmjI = __esm({
  "css-modules:css-modules://ZU8C9pCp1xf9J2Ppq3eIsl9NuEMXDF1XSo71o0YZmjI.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_home_lastPagesCreated.module.css
var src_components_home_lastPagesCreated_default;
var init_src_components_home_lastPagesCreated = __esm({
  "tmp_esbuild1736180049684/_src_components_home_lastPagesCreated.module.css"() {
    "use strict";
    init_ZU8C9pCp1xf9J2Ppq3eIsl9NuEMXDF1XSo71o0YZmjI();
    src_components_home_lastPagesCreated_default = { "placeholder": "core-tvZhGW-placeholder", "list": "core-tvZhGW-list", "title": "core-tvZhGW-title", "placeholderDescription": "core-tvZhGW-placeholderDescription", "placeholderText": "core-tvZhGW-placeholderText", "placeholderButton": "core-tvZhGW-placeholderButton", "placeholderTitle": "core-tvZhGW-placeholderTitle" };
  }
});

// src/components/home/lastPagesCreated.module.css
var init_lastPagesCreated = __esm({
  "src/components/home/lastPagesCreated.module.css"() {
    "use strict";
    init_src_components_home_lastPagesCreated();
  }
});

// src/components/home/lastPagesCreated.jsx
import { useDispatch as useDispatch22 } from "react-redux";
import { Button as Button32, List as List3, Tag as Tag3 } from "@lls/lls-kit";
import { ANALYTICS_LINK_CLICKED as ANALYTICS_LINK_CLICKED6, dispatchAnalyticsEvent as dispatchAnalyticsEvent19, getPageInterval as getPageInterval4, getPagePath as getPagePath5, makeComponent as makeComponent4 } from "@lls/utils";
import _73 from "lodash/fp.js";
import { jsx as jsx76, jsxs as jsxs53 } from "react/jsx-runtime";
var StyledPlaceholder, LastPagesCreated, lastPagesCreated_default;
var init_lastPagesCreated2 = __esm({
  "src/components/home/lastPagesCreated.jsx"() {
    "use strict";
    init_actions();
    init_home3();
    init_tour2();
    init_home();
    init_route();
    init_lastPagesCreated();
    init_pageListItem2();
    StyledPlaceholder = makeComponent4("div", src_components_home_lastPagesCreated_default.placeholder);
    LastPagesCreated = ({ customPages, books, chapters, originalPages, startTour }) => {
      const dispatch = useDispatch22();
      const lastPages = _73.flow(
        _73.compact,
        _73.orderBy((page) => page.updatedAt || page.createdAt, "desc"),
        _73.take(MAX_USER_PAGES)
      )(customPages);
      const onItemClick = ({ book, page, index: index3 }) => {
        dispatchAnalyticsEvent19(ANALYTICS_LINK_CLICKED6, {
          featureName: "home|latest_pages_created",
          resourceId: [`${book == null ? void 0 : book.id}|${page == null ? void 0 : page.id}`],
          extraData: `${index3 + 1}`
        });
      };
      const launchTour = () => {
        dispatch(setScenarioId(ONBOARDING_SCENARIO));
        startTour(CREATE_PAGE_TOUR);
      };
      return _73.size(lastPages) > 0 ? /* @__PURE__ */ jsxs53(List3, { className: src_components_home_lastPagesCreated_default.list, foldedMaxLength: 4, children: [
        /* @__PURE__ */ jsx76("h2", { className: src_components_home_lastPagesCreated_default.title, children: "Mes derni\xE8res pages cr\xE9\xE9es" }),
        lastPages == null ? void 0 : lastPages.map((page, index3) => {
          const book = _73.find({ id: page.book }, books);
          const chapter = _73.find({ id: page.chapter }, chapters);
          const originalPage = _73.find({ id: page.originalPage }, originalPages);
          const timeLabel = page.updatedAt ? `Modifi\xE9e ${getHomeDisplayedDate(page == null ? void 0 : page.updatedAt)}` : `Cr\xE9\xE9e ${getHomeDisplayedDate(page == null ? void 0 : page.createdAt)}`;
          const paginationLabel = `${(chapter == null ? void 0 : chapter.numShow) ? `${chapter.numShow} - ` : ""}${getPageInterval4({ page: originalPage })}`;
          const to = (page == null ? void 0 : page.isLearningAssessment) ? getPath("learning_assessment") : getPagePath5({ slug: page == null ? void 0 : page.slug });
          return /* @__PURE__ */ jsx76(
            pageListItem_default,
            {
              to,
              tagsChildren: book ? /* @__PURE__ */ jsx76(Tag3, { icon: "importcontactfilled", children: book.displayTitle }) : null,
              paginationLabel,
              timeLabel,
              title: page == null ? void 0 : page.displayTitle,
              onClick: () => onItemClick({ book, page, index: index3 })
            },
            page == null ? void 0 : page.id
          );
        })
      ] }) : /* @__PURE__ */ jsxs53("div", { className: src_components_home_lastPagesCreated_default.placeholder, children: [
        /* @__PURE__ */ jsxs53("div", { className: src_components_home_lastPagesCreated_default.placeholderText, children: [
          /* @__PURE__ */ jsx76("h3", { className: src_components_home_lastPagesCreated_default.placeholderTitle, children: "Cr\xE9er vos contenus" }),
          /* @__PURE__ */ jsxs53("div", { className: src_components_home_lastPagesCreated_default.placeholderDescription, children: [
            "Cr\xE9ez des pages de cours ou d'exercices que vous pourrez ensuite partager \xE0 vos \xE9l\xE8ves :",
            /* @__PURE__ */ jsx76("span", { children: "La pr\xE9sentation de cette fonctionnalit\xE9 n'est pas disponible sur mobile. Pour plus d'accompagnement, privil\xE9giez une tablette ou un ordinateur." })
          ] })
        ] }),
        /* @__PURE__ */ jsx76(Button32, { className: src_components_home_lastPagesCreated_default.placeholderButton, theme: "premium", onClick: launchTour, children: "Comment faire ?" })
      ] });
    };
    lastPagesCreated_default = LastPagesCreated;
  }
});

// css-modules:css-modules://t2xqR3YC2FmPbZ-6EEaA7GjZPa-ReeU9aL6YNnFmnpE.css
var init_t2xqR3YC2FmPbZ_6EEaA7GjZPa_ReeU9aL6YNnFmnpE = __esm({
  "css-modules:css-modules://t2xqR3YC2FmPbZ-6EEaA7GjZPa-ReeU9aL6YNnFmnpE.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_home_lastPagesReceived.module.css
var src_components_home_lastPagesReceived_default;
var init_src_components_home_lastPagesReceived = __esm({
  "tmp_esbuild1736180049684/_src_components_home_lastPagesReceived.module.css"() {
    "use strict";
    init_t2xqR3YC2FmPbZ_6EEaA7GjZPa_ReeU9aL6YNnFmnpE();
    src_components_home_lastPagesReceived_default = { "title": "core-koCXuq-title", "bgRight": "core-koCXuq-bgRight", "illuImg": "core-koCXuq-illuImg", "placeholderTitle": "core-koCXuq-placeholderTitle", "content": "core-koCXuq-content", "placeholder": "core-koCXuq-placeholder", "bgLeft": "core-koCXuq-bgLeft", "placeholderDescription": "core-koCXuq-placeholderDescription", "illu": "core-koCXuq-illu", "bell": "core-koCXuq-bell", "list": "core-koCXuq-list", "icon": "core-koCXuq-icon" };
  }
});

// src/components/home/lastPagesReceived.module.css
var init_lastPagesReceived = __esm({
  "src/components/home/lastPagesReceived.module.css"() {
    "use strict";
    init_src_components_home_lastPagesReceived();
  }
});

// src/components/home/lastPagesReceived.jsx
import { Icon as Icon7, List as List4, Tag as Tag4 } from "@lls/lls-kit";
import { getAuth as getAuth5, useSearchBooks as useSearchBooks3, useSearchChapters as useSearchChapters3, useSearchPages as useSearchPages6 } from "@lls/store";
import { getMainNotifications as getMainNotifications2 } from "@lls/store";
import { dispatchAnalyticsEvent as dispatchAnalyticsEvent20 } from "@lls/utils";
import _74 from "lodash/fp.js";
import { useSelector as useSelector38 } from "react-redux";
import { Fragment as Fragment17, jsx as jsx77, jsxs as jsxs54 } from "react/jsx-runtime";
var LastPagesReceived, lastPagesReceived_default;
var init_lastPagesReceived2 = __esm({
  "src/components/home/lastPagesReceived.jsx"() {
    "use strict";
    init_analytics4();
    init_notification3();
    init_useCustomEffect();
    init_home();
    init_route();
    init_lastPagesReceived();
    init_pageListItem2();
    LastPagesReceived = () => {
      const auth2 = useSelector38(getAuth5);
      const token = _74.get("token", auth2);
      const mainNotifs = useSelector38(getMainNotifications2);
      const notifications2 = _74.flow(
        _74.compact,
        _74.orderBy((notif) => notif.createdAt, "desc"),
        _74.take(7)
      )(mainNotifs);
      const pages = useSearchPages6({ ids: _74.map("page", notifications2) });
      const books = useSearchBooks3({ hasNewDesign: true, ids: _74.map("book", pages) });
      const chapters = useSearchChapters3({ ids: _74.map("chapter", pages) });
      const markNotificationAsReadEffectFn = useCustomEffect_default(markNotificationAsReadEffect);
      const onItemClick = ({ notification, book, page, index: index3 }) => {
        dispatchAnalyticsEvent20(ANALYTICS_EVENTS.LINK_CLICKED, {
          featureName: "home|last_pages_received",
          resourceId: [`${book == null ? void 0 : book.id}|${page == null ? void 0 : page.id}`],
          extraData: `${index3 + 1}`
        });
        markNotificationAsReadEffectFn({ token, notification });
      };
      return _74.size(notifications2) > 0 ? /* @__PURE__ */ jsxs54(List4, { className: src_components_home_lastPagesReceived_default.list, foldedMaxLength: 4, children: [
        /* @__PURE__ */ jsx77("h2", { className: src_components_home_lastPagesReceived_default.title, children: "Derni\xE8res pages re\xE7ues" }),
        notifications2 == null ? void 0 : notifications2.map((notification, index3) => {
          var _a2, _b2, _c2;
          const page = _74.find({ id: notification == null ? void 0 : notification.page }, pages);
          const book = _74.find({ id: page == null ? void 0 : page.book }, books);
          const chapter = _74.find({ id: page == null ? void 0 : page.chapter }, chapters);
          const timeLabel = `Re\xE7ue ${getHomeDisplayedDate(notification == null ? void 0 : notification.createdAt)}`;
          const paginationLabel = `${(chapter == null ? void 0 : chapter.numShow) ? `${chapter.numShow} - ` : ""}${((_a2 = notification == null ? void 0 : notification.content) == null ? void 0 : _a2.pageInterval) ?? ""}`;
          const title = _74.replace(/,[^,]*$/, "", (_b2 = notification == null ? void 0 : notification.content) == null ? void 0 : _b2.subtitle);
          return /* @__PURE__ */ jsx77(
            pageListItem_default,
            {
              to: getPath((_c2 = new URL(notification == null ? void 0 : notification.content.url)) == null ? void 0 : _c2.pathname),
              tagsChildren: book ? /* @__PURE__ */ jsx77(Tag4, { icon: "importcontactfilled", children: book.displayTitle }) : null,
              paginationLabel,
              timeLabel,
              title: /* @__PURE__ */ jsxs54(Fragment17, { children: [
                title,
                notification.read ? null : /* @__PURE__ */ jsx77(Icon7, { className: src_components_home_lastPagesReceived_default.icon, name: "circlefilled", width: "12", height: "12" })
              ] }),
              onClick: () => onItemClick({ notification, book, page, index: index3 })
            },
            notification == null ? void 0 : notification.id
          );
        })
      ] }) : /* @__PURE__ */ jsxs54("div", { className: src_components_home_lastPagesReceived_default.placeholder, children: [
        /* @__PURE__ */ jsx77("img", { className: src_components_home_lastPagesReceived_default.bgLeft, src: "/assets/img/home/numeric_resources_left.svg" }),
        /* @__PURE__ */ jsx77("img", { className: src_components_home_lastPagesReceived_default.bgRight, src: "/assets/img/home/numeric_resources_right.svg" }),
        /* @__PURE__ */ jsxs54("div", { className: src_components_home_lastPagesReceived_default.content, children: [
          /* @__PURE__ */ jsx77("h3", { className: src_components_home_lastPagesReceived_default.placeholderTitle, children: "Pages partag\xE9es par tes professeurs" }),
          /* @__PURE__ */ jsxs54("div", { className: src_components_home_lastPagesReceived_default.placeholderDescription, children: [
            "Les derni\xE8res pages partag\xE9es par tes professeurs s'afficheront ici. Tu pourras aussi les retrouver en cliquant sur le bouton ",
            /* @__PURE__ */ jsx77(Icon7, { className: src_components_home_lastPagesReceived_default.bell, name: "bell" }),
            " en haut de l'\xE9cran."
          ] })
        ] }),
        /* @__PURE__ */ jsx77("div", { className: src_components_home_lastPagesReceived_default.illu, children: /* @__PURE__ */ jsx77("img", { className: src_components_home_lastPagesReceived_default.illuImg, src: "/assets/img/home/numeric_resources.webp" }) })
      ] });
    };
    lastPagesReceived_default = LastPagesReceived;
  }
});

// src/components/home/index.jsx
import _75 from "lodash/fp.js";
import { useSelector as useSelector39 } from "react-redux";
import { Wavy as Wavy8 } from "@lls/lls-kit";
import { displayUserGenderTitle as displayUserGenderTitle3 } from "@lls/utils";
import {
  getContact as getContact2,
  useSearchBooks as useSearchBooks4,
  useSearchChapters as useSearchChapters4,
  useSearchModifiedPages,
  useSearchPages as useSearchPages7,
  useSearchSubjects
} from "@lls/store";
import { getSchool as getSchool2 } from "@lls/store";
import { CommunityContactHelp } from "@lls/superkit";
import { jsx as jsx78, jsxs as jsxs55 } from "react/jsx-runtime";
var Home, home_default;
var init_home4 = __esm({
  "src/components/home/index.jsx"() {
    "use strict";
    init_ui3();
    init_useTour();
    init_ui2();
    init_activity2();
    init_bookList2();
    init_home2();
    init_lastExercisesDone2();
    init_lastPagesCreated2();
    init_lastPagesReceived2();
    Home = ({ currentUser }) => {
      const { startTour } = useTour_default();
      const customPages = useSearchModifiedPages({ userIds: [currentUser == null ? void 0 : currentUser.id] });
      const originalPages = useSearchPages7({ ids: _75.map("originalPage", customPages) });
      const contact = useSelector39((state) => {
        var _a2;
        return getContact2(state, ((_a2 = currentUser == null ? void 0 : currentUser.contacts) == null ? void 0 : _a2[0]) ?? null);
      });
      const school = useSelector39((state) => {
        var _a2;
        return getSchool2(state, ((_a2 = currentUser == null ? void 0 : currentUser.schools) == null ? void 0 : _a2[0]) ?? null);
      });
      const subjects = useSearchSubjects({ ids: (currentUser == null ? void 0 : currentUser.subjects) ?? [] });
      const isTrial = currentUser == null ? void 0 : currentUser.isTrial;
      const isStudentViewActivated = useSelector39(getUiIsStudentViewActivated);
      const isTeacher = (currentUser == null ? void 0 : currentUser.isTeacher) && (!isTrial || !isStudentViewActivated);
      const books = useSearchBooks4({ hasNewDesign: true, ids: _75.map("book", customPages) });
      const chapters = useSearchChapters4({ ids: _75.map("chapter", customPages) });
      const sideProps = {
        customPages,
        originalPages,
        books,
        chapters
      };
      return /* @__PURE__ */ jsx78("div", { className: src_components_home_index_default.home, children: /* @__PURE__ */ jsxs55("div", { className: src_components_home_index_default.container, style: { "--cr-navbar-height": `${NAVBAR_HEIGHT}px` }, children: [
        /* @__PURE__ */ jsxs55("h1", { className: src_components_home_index_default.title, "data-clarity-mask": "true", children: [
          "Bonjour",
          " ",
          isTeacher && _75.get("lastname", currentUser) && `${displayUserGenderTitle3(_75.pick(["gender"], currentUser))} `,
          isTrial && isStudentViewActivated ? "\xE9l\xE8ve" : /* @__PURE__ */ jsx78(Wavy8, { waveColor: "var(--premium-50-color)", children: isTeacher ? _75.get("lastname", currentUser) && _75.get("lastname", currentUser) : _75.get("firstname", currentUser) && _75.get("firstname", currentUser) }),
          "\xA0!"
        ] }),
        /* @__PURE__ */ jsx78("div", { className: src_components_home_index_default.bookList, children: /* @__PURE__ */ jsx78(bookList_default, {}) }),
        /* @__PURE__ */ jsxs55("div", { className: src_components_home_index_default.body, children: [
          /* @__PURE__ */ jsx78("div", { className: src_components_home_index_default.main, children: isTeacher ? /* @__PURE__ */ jsx78(activity_default, { startTour, currentUser }) : /* @__PURE__ */ jsx78(lastPagesReceived_default, {}) }),
          /* @__PURE__ */ jsx78("div", { className: src_components_home_index_default.side, children: isTeacher ? /* @__PURE__ */ jsx78(lastPagesCreated_default, { ...sideProps, startTour }) : /* @__PURE__ */ jsx78(lastExercisesDone_default, { ...sideProps }) })
        ] }),
        isTeacher && /* @__PURE__ */ jsx78("div", { className: src_components_home_index_default.communityContactHelp, children: /* @__PURE__ */ jsx78(
          CommunityContactHelp,
          {
            isTrial: currentUser == null ? void 0 : currentUser.isTrial,
            contact,
            school,
            subjects,
            firstContactNameIcon: "Emmanuelle",
            secondContactNameIcon: "Dylan",
            displayChatButton: true
          }
        ) })
      ] }) });
    };
    home_default = Home;
  }
});

// src/constants/seo.js
var SEO_ORGANIZATION;
var init_seo = __esm({
  "src/constants/seo.js"() {
    "use strict";
    init_constants();
    SEO_ORGANIZATION = `{
  "@context": "https://schema.org",
  "@type": "Organization",
  "url": "${META_CANONICAL_PREFIX}",
  "logo": "${META_CANONICAL_PREFIX}/assets/img/logo-baseline.png",
  "name": "Lelivrescolaire.fr"
}`;
  }
});

// src/utils/meta.ts
import _76 from "lodash/fp.js";
import { generateBreadcrumbs, generateCourse, getPageDescription, getPageTitle } from "@lls/utils";
var getMetas, getPageCanonical, getPanoramaCanonical, getHomeBreadcrumbItems, getHomeMetas, getMyBooksMetas, getPanoramaMetas, getCopyMetas, getClassroomsMetas, getLearningAssessmentMetas, getCopiesMetas, getShareCorrectionsMeta, getShareCorrectionsStudentsMeta, getCreatePageMetas, getBookMetas, getPageMetas, getRevisionMetas, getRevisionBookMetas, getMarketingViewerMetas, getMarketingOralMetas, getMarketingArduinoMetas, getMarketingPythonMetas, getMarketingRecorderMetas, getMarketingLaboOralMetas, getMarketingMapMetas, getMarketingLaboElectricMetas, getWhoScienceMetas, getWhoFrenchMetas, getWhoSpanishMetas, getWhoHgMetas, getWhoEnglishMetas;
var init_meta = __esm({
  "src/utils/meta.ts"() {
    "use strict";
    init_panorama();
    init_seo();
    init_route();
    init_constants();
    getMetas = (screen, params = {}) => {
      const { title, book, page, tool, bookId, chapterId, copy, parentId, groupId } = params;
      switch (screen) {
        case SCREEN_MULTIFETCH_HOME:
          return getHomeMetas();
        case SCREEN_MULTIFETCH_MY_BOOKS:
          return getMyBooksMetas();
        case SCREEN_MULTIFETCH_PANORAMA:
          return getPanoramaMetas({ bookId, chapterId });
        case SCREEN_MULTIFETCH_PAGE:
        case SCREEN_READONLY:
          return getPageMetas({ page });
        case SCREEN_CREATE_PAGE:
          return getCreatePageMetas({ book, page });
        case SCREEN_MARKETING_VIEWER:
          return getMarketingViewerMetas({ tool });
        case SCREEN_COPY:
          return getCopyMetas({ copy, parentId });
        case SCREEN_COPIES:
          return getCopiesMetas({ parentId, title });
        case SCREEN_SHARE_CORRECTIONS:
          return getShareCorrectionsMeta({ parentId, title, groupId });
        case SCREEN_SHARE_CORRECTIONS_STUDENTS:
          return getShareCorrectionsStudentsMeta({ parentId, title });
        case SCREEN_MULTIFETCH_BOOK:
        case SCREEN_BOOK_REDIRECT:
          return getBookMetas({ book });
        case SCREEN_REVISION:
          return getRevisionMetas();
        case SCREEN_LEARNING_ASSESSMENT:
          return getLearningAssessmentMetas();
        case SCREEN_REVISION_BOOK:
          return getRevisionBookMetas({ book });
        case SCREEN_GROUPS_SETTINGS:
          return getClassroomsMetas();
        default:
          return;
      }
    };
    getPageCanonical = (page) => `${META_CANONICAL_PREFIX}${getPath("page", { slug: _76.get("slug", page) })}`;
    getPanoramaCanonical = ({ bookId, chapterId }) => `${META_CANONICAL_PREFIX}${getPath("panorama", { bookId, chapterId })}`;
    getHomeBreadcrumbItems = () => [{ name: "Home", item: `${META_CANONICAL_PREFIX}` }];
    getHomeMetas = () => ({
      title: "Lelivrescolaire.fr Premium : manuels num\xE9riques pour le coll\xE8ge et le lyc\xE9e",
      description: "Lelivrescolaire.fr : \xE9diteur de manuels scolaires collaboratifs et innovants.",
      image: `${META_IMAGE}`,
      canonical: `${META_CANONICAL_PREFIX}`,
      breadcrumbs: generateBreadcrumbs([getHomeBreadcrumbItems()]),
      organization: SEO_ORGANIZATION
    });
    getMyBooksMetas = () => ({
      title: "Mes Manuels Premium | Lelivrescolaire.fr",
      description: "Biblioth\xE8que de manuels Premium Lelivrescolaire.fr, des manuels scolaires collaboratifs et innovants.",
      image: `${META_IMAGE}`,
      canonical: `${META_CANONICAL_PREFIX}${getPath("my-books")}`
    });
    getPanoramaMetas = ({ bookId, chapterId }) => ({
      title: `${_76.getOr("", [chapterId, "metas", "title"], PANORAMA_CHAPTERS)} | Lelivrescolaire.fr`,
      description: "Concevez votre s\xE9quence id\xE9ale gr\xE2ce \xE0 notre s\xE9lection de ressources in\xE9dites, aux formats vari\xE9s et co-cr\xE9\xE9es avec les professeurs de la communaut\xE9 !",
      image: `${META_CANONICAL_PREFIX}${_76.getOr("", [chapterId, "metas", "image"], PANORAMA_CHAPTERS)}`,
      canonical: getPanoramaCanonical({ bookId, chapterId })
    });
    getCopyMetas = ({ parentId, copy }) => {
      return {
        title: `${_76.getOr("R\xE9ponse", "title", copy)} | Lelivrescolaire.fr`,
        description: "Un espace de consultation des copies enregistr\xE9es par les \xE9l\xE8ves. ",
        image: `${META_IMAGE}`,
        canonical: `${META_CANONICAL_PREFIX}${getPath("copy", { parentId, copyId: _76.get("id", copy) })}`
      };
    };
    getClassroomsMetas = () => ({
      title: "Mes classes | Lelivrescolaire.fr",
      description: "Mes classes | Lelivrescolaire.fr"
    });
    getLearningAssessmentMetas = () => {
      return {
        title: "Suivi des acquis| Lelivrescolaire.fr",
        description: "Suivi des acquis ",
        image: `${META_CANONICAL_PREFIX}/assets/img/home/meta.png`,
        canonical: `${META_CANONICAL_PREFIX}${getPath("learning_assessment")}}`
      };
    };
    getCopiesMetas = ({ parentId, title }) => {
      return {
        title: `R\xE9ponses - ${title} | Lelivrescolaire.fr`,
        description: "Un espace de consultation des copies enregistr\xE9es par les \xE9l\xE8ves. ",
        image: `${META_CANONICAL_PREFIX}/assets/img/home/meta.png`,
        canonical: `${META_CANONICAL_PREFIX}${getPath("copies", { parentId })}`
      };
    };
    getShareCorrectionsMeta = ({
      parentId,
      title,
      groupId
    }) => {
      return {
        title: `R\xE9ponses - ${title} | Lelivrescolaire.fr`,
        description: "Un espace de consultation des copies enregistr\xE9es par les \xE9l\xE8ves. ",
        image: `${META_CANONICAL_PREFIX}/assets/img/home/meta.png`,
        canonical: `${META_CANONICAL_PREFIX}${getPath("corrections", { parentId, groupId })}`
      };
    };
    getShareCorrectionsStudentsMeta = ({ parentId, title }) => {
      return {
        title: `R\xE9ponses - ${title} | Lelivrescolaire.fr`,
        description: "Un espace de consultation des copies enregistr\xE9es par les \xE9l\xE8ves. ",
        image: `${META_CANONICAL_PREFIX}/assets/img/home/meta.png`,
        canonical: `${META_CANONICAL_PREFIX}${getPath("corrections_students", { parentId })}`
      };
    };
    getCreatePageMetas = ({ book, page }) => ({
      title: `Cr\xE9ation de ${(page == null ? void 0 : page.pageType) === "exercice" ? "fiche d'exercices" : "page"} | Lelivrescolaire.fr`,
      description: `Cr\xE9ez vos cours et vos fiches d'exercices pour le manuel ${book == null ? void 0 : book.displayTitle}`,
      image: _76.get("urlLite", book),
      canonical: `${META_CANONICAL_PREFIX}${getPath("page-creation", _76.pick(["slug", "uri"], book))}`
    });
    getBookMetas = ({ book }) => ({
      title: `Manuel ${_76.get("displayTitle", book)} | Lelivrescolaire.fr`,
      description: `Retrouvez les documents, le\xE7ons et exercices interactifs du manuel ${_76.get("displayTitle", book)}`,
      image: _76.get("urlLite", book),
      canonical: `${META_CANONICAL_PREFIX}${getPath("book", _76.pick(["slug", "uri"], book))}`
    });
    getPageMetas = ({ page }) => ({
      title: getPageTitle(page, { clean: false }),
      description: getPageDescription(page),
      image: `${META_IMAGE}`,
      canonical: getPageCanonical(page),
      course: generateCourse({ page })
    });
    getRevisionMetas = () => ({
      title: "R\xE9vision - Choix des ressources | Lelivrescolaire.fr",
      image: `${META_IMAGE}`,
      description: "Retrouvez nos ressources et outils d\xE9di\xE9s aux r\xE9visions sur Lelivrescolaire.fr Premium",
      canonical: `${META_CANONICAL_PREFIX}${getPath("revision")}`
    });
    getRevisionBookMetas = ({ book }) => ({
      title: "R\xE9vision - Liste des ressources | Lelivrescolaire.fr",
      image: `${META_IMAGE}`,
      description: "Retrouvez nos ressources et outils d\xE9di\xE9s aux r\xE9visions sur Lelivrescolaire.fr Premium",
      canonical: `${META_CANONICAL_PREFIX}${getPath("revision_book", { bookUri: book == null ? void 0 : book.uri })}`
    });
    getMarketingViewerMetas = ({ tool }) => {
      switch (tool) {
        case TOOL_PYTHON:
          return getMarketingPythonMetas(TOOL_PYTHON);
        case TOOL_RECORDER:
          return getMarketingRecorderMetas(TOOL_RECORDER);
        case TOOL_ORAL:
          return getMarketingOralMetas(TOOL_PYTHON);
        case TOOL_ARDUINO:
          return getMarketingArduinoMetas(TOOL_RECORDER);
        case TOOL_LABO_ORAL:
          return getMarketingLaboOralMetas(TOOL_LABO_ORAL);
        case TOOL_MAP:
          return getMarketingMapMetas(TOOL_MAP);
        case TOOL_LABO_ELECTRIC:
          return getMarketingLaboElectricMetas(TOOL_LABO_ELECTRIC);
        case TOOL_WHO_SCIENCE:
          return getWhoScienceMetas(TOOL_LABO_ELECTRIC);
        case TOOL_WHO_FRENCH:
          return getWhoFrenchMetas(TOOL_LABO_ELECTRIC);
        case TOOL_WHO_SPANISH:
          return getWhoSpanishMetas(TOOL_LABO_ELECTRIC);
        case TOOL_WHO_HG:
          return getWhoHgMetas(TOOL_LABO_ELECTRIC);
        case TOOL_WHO_ENGLISH:
          return getWhoEnglishMetas(TOOL_LABO_ELECTRIC);
      }
    };
    getMarketingOralMetas = (tool) => ({
      title: "Laboratoire de pr\xE9paration au Grand oral | Lelivrescolaire.fr",
      description: "Entra\xEEnez-vous au Grand oral en un clic ! Gr\xE2ce \xE0 notre enregistreur audio, vous allez pouvoir am\xE9liorer votre prononciation, vous entra\xEEner \xE0 l\u2019oral et partager simplement vos enregistrements.",
      image: `${META_IMAGE}`,
      canonical: `${META_CANONICAL_PREFIX}${getPath("marketing_viewer", { tool })}`
    });
    getMarketingArduinoMetas = (tool) => ({
      title: "Laboratoire Arduino | Lelivrescolaire.fr",
      description: "Un environnement de travail Arduino accessible \xE0 toutes et \xE0 tous ! Retrouvez une console Arduino ainsi que des ressources pour travailler efficacement la lecture et le d\xE9codage du code pour le microcontr\xF4leur Arduino.",
      image: `${META_IMAGE}`,
      canonical: `${META_CANONICAL_PREFIX}${getPath("marketing_viewer", { tool })}`
    });
    getMarketingPythonMetas = (tool) => ({
      title: "Laboratoire Python | Lelivrescolaire.fr",
      description: "Apprendre le code passe par la pratique ! Retrouvez une console Python ainsi que des ressources pour travailler efficacement l'algorithmique avec vos \xE9l\xE8ves.",
      image: `${META_IMAGE}`,
      canonical: `${META_CANONICAL_PREFIX}${getPath("marketing_viewer", { tool })}`
    });
    getMarketingRecorderMetas = (tool) => ({
      title: "Laboratoire de langues | Lelivrescolaire.fr",
      description: "Am\xE9liorez votre prononciation, entra\xEEnez-vous \xE0 l'oral et partagez vos enregistrements.",
      image: `${META_IMAGE}`,
      canonical: `${META_CANONICAL_PREFIX}${getPath("marketing_viewer", { tool })}`
    });
    getMarketingLaboOralMetas = (tool) => ({
      title: "Laboratoire oral | Lelivrescolaire.fr",
      description: "Am\xE9liorez votre prononciation, entra\xEEnez-vous \xE0 l\u2019oral et partagez vos enregistrements.",
      image: `${META_IMAGE}`,
      canonical: `${META_CANONICAL_PREFIX}${getPath("marketing_viewer", { tool })}`
    });
    getMarketingMapMetas = (tool) => ({
      title: "Fonds de carte | Lelivrescolaire.fr",
      description: "Retrouvez en t\xE9l\xE9chargement libre tous les fonds de carte de vos manuels Lelivrescolaire.fr !",
      image: `${META_IMAGE}`,
      canonical: `${META_CANONICAL_PREFIX}${getPath("marketing_viewer", { tool })}`
    });
    getMarketingLaboElectricMetas = (tool) => ({
      title: "Laboratoire d'\xE9l\xE9ctricit\xE9 | Lelivrescolaire.fr",
      description: "R\xE9alisez des sch\xE9mas simples de circuits \xE9lectriques pour le coll\xE8ge ou le lyc\xE9e avec diff\xE9rents composants/dip\xF4les gr\xE2ce au Labo d'\xE9lectricit\xE9.",
      image: `${META_IMAGE}`,
      canonical: `${META_CANONICAL_PREFIX}${getPath("marketing_viewer", { tool })}`
    });
    getWhoScienceMetas = (tool) => ({
      title: "Sciences : Qui est-ce ? | Lelivrescolaire.fr",
      description: 'Revisitez le c\xE9l\xE8bre jeu "Qui est-ce" avec vos \xE9l\xE8ves gr\xE2ce \xE0 notre d\xE9clinaison scientifique. En classe, devinez quels scientifiques c\xE9l\xE8bres \u2013 biologistes, m\xE9decins, math\xE9maticiens, chimistes, etc. \u2013  se cachent derri\xE8re ces indices...',
      canonical: `${META_CANONICAL_PREFIX}${getPath("marketing_viewer", { tool })}`
    });
    getWhoFrenchMetas = (tool) => ({
      title: "Fran\xE7ais : Qui est-ce ? | Lelivrescolaire.fr",
      description: 'Revisitez le c\xE9l\xE8bre jeu "Qui est-ce" avec vos \xE9l\xE8ves gr\xE2ce \xE0 notre d\xE9clinaison sp\xE9ciale Fran\xE7ais. En classe, devinez quels auteurs et autrices c\xE9l\xE8bres de la litt\xE9rature fran\xE7aise se cachent derri\xE8re ces indices.',
      canonical: `${META_CANONICAL_PREFIX}${getPath("marketing_viewer", { tool })}`
    });
    getWhoSpanishMetas = (tool) => ({
      title: "Espagnol : Qui est-ce ? | Lelivrescolaire.fr",
      description: 'Revisitez le c\xE9l\xE8bre jeu "Qui est-ce" avec vos \xE9l\xE8ves gr\xE2ce \xE0 notre d\xE9clinaison sp\xE9ciale Espagnol. En classe, devinez quelles figures hispanophones c\xE9l\xE8bres se cachent derri\xE8re ces indices...',
      canonical: `${META_CANONICAL_PREFIX}${getPath("marketing_viewer", { tool })}`
    });
    getWhoHgMetas = (tool) => ({
      title: "Histoire : Qui est-ce ? | Lelivrescolaire.fr",
      description: 'Revisitez le c\xE9l\xE8bre jeu "Qui est-ce" avec vos \xE9l\xE8ves gr\xE2ce \xE0 notre d\xE9clinaison sp\xE9ciale "Femmes de l\u2019Histoire". En classe, devinez quelles figures historiques f\xE9minines \u2013 politiques, reines, militantes, exploratrices, etc. \u2013 se cachent derri\xE8re ces indices.',
      canonical: `${META_CANONICAL_PREFIX}${getPath("marketing_viewer", { tool })}`
    });
    getWhoEnglishMetas = (tool) => ({
      title: "Anglais : Qui est-ce ? | Lelivrescolaire.fr",
      description: 'Revisitez le c\xE9l\xE8bre jeu "Qui est-ce" avec vos \xE9l\xE8ves gr\xE2ce \xE0 notre d\xE9clinaison sp\xE9ciale Anglais. En classe, devinez quelles figures anglophones c\xE9l\xE8bres se cachent derri\xE8re ces indices...',
      canonical: `${META_CANONICAL_PREFIX}${getPath("marketing_viewer", { tool })}`
    });
  }
});

// src/components/metas/index.tsx
import { Helmet as Helmet2 } from "react-helmet";
import { jsx as jsx79, jsxs as jsxs56 } from "react/jsx-runtime";
var Metas, metas_default;
var init_metas = __esm({
  "src/components/metas/index.tsx"() {
    "use strict";
    init_meta();
    Metas = ({ screen, params }) => {
      const { title, description, image, canonical, breadcrumbs, organization, course } = getMetas(screen, params) ?? {};
      return !title ? null : /* @__PURE__ */ jsxs56(Helmet2, { children: [
        /* @__PURE__ */ jsx79("title", { children: title }),
        /* @__PURE__ */ jsx79("meta", { name: "og:title", content: title }),
        /* @__PURE__ */ jsx79("meta", { name: "twitter:title", content: title }),
        /* @__PURE__ */ jsx79("meta", { name: "description", content: description }),
        /* @__PURE__ */ jsx79("meta", { name: "abstract", content: description }),
        /* @__PURE__ */ jsx79("meta", { name: "og:description", content: description }),
        /* @__PURE__ */ jsx79("meta", { name: "twitter:description", content: description }),
        /* @__PURE__ */ jsx79("meta", { name: "image", content: image }),
        /* @__PURE__ */ jsx79("meta", { name: "og:image", content: image }),
        /* @__PURE__ */ jsx79("meta", { name: "og:image:secure_url", content: image }),
        /* @__PURE__ */ jsx79("meta", { name: "twitter:image", content: image }),
        /* @__PURE__ */ jsx79("link", { rel: "canonical", href: canonical }),
        /* @__PURE__ */ jsx79("meta", { name: "og:url", content: canonical }),
        organization && /* @__PURE__ */ jsx79("script", { type: "application/ld+json", children: organization }),
        breadcrumbs && /* @__PURE__ */ jsx79("script", { type: "application/ld+json", children: breadcrumbs }),
        course && /* @__PURE__ */ jsx79("script", { type: "application/ld+json", children: course })
      ] });
    };
    metas_default = Metas;
  }
});

// src/screens/home.jsx
var home_exports = {};
__export(home_exports, {
  default: () => home_default2
});
import { getAuth as getAuth6 } from "@lls/store";
import { getCurrentUser as getCurrentUser23 } from "@lls/store";
import { dispatchAnalyticsEvent as dispatchAnalyticsEvent21 } from "@lls/utils";
import _77 from "lodash/fp.js";
import { useEffect as useEffect24, useRef as useRef13 } from "react";
import { useSelector as useSelector40 } from "react-redux";
import { Fragment as Fragment18, jsx as jsx80, jsxs as jsxs57 } from "react/jsx-runtime";
var import_dayjs5, seq, HomeScreen, home_default2;
var init_home5 = __esm({
  "src/screens/home.jsx"() {
    "use strict";
    init_home4();
    init_loading4();
    init_metas();
    init_analytics4();
    init_home3();
    init_constants();
    init_fetch();
    import_dayjs5 = __toESM(require_dayjs_min(), 1);
    seq = [
      {
        screen: SCREEN_PARTIAL_HOME_BOOKS
      },
      {
        screen: SCREEN_PARTIAL_HOME_USER
      }
    ];
    HomeScreen = ({ ssrFetcher, previousLocation }) => {
      const currentUser = useSelector40(getCurrentUser23);
      const isTeacher = currentUser == null ? void 0 : currentUser.isTeacher;
      const token = _77.get("token", useSelector40(getAuth6));
      const fetchedUserRef = useRef13(false);
      const shouldRefreshUser = !fetchedUserRef.current && !!previousLocation;
      const params = {
        token,
        isTeacher,
        sharedAfter: isTeacher ? (0, import_dayjs5.default)().subtract(2, "week").startOf("day").toISOString() : null,
        maxUserPages: MAX_USER_PAGES
      };
      useMultiFetch({
        ssrFetcher,
        screen: SCREEN_MULTIFETCH_HOME,
        params,
        screenToOptions: { [SCREEN_PARTIAL_HOME_USER]: { fetchEvenIfLoaded: shouldRefreshUser } },
        seq
      });
      fetchedUserRef.current = true;
      useEffect24(() => {
        dispatchAnalyticsEvent21(ANALYTICS_EVENTS.PAGE_VIEWED, { contentViewFormat: "web" });
      }, []);
      return /* @__PURE__ */ jsxs57(Fragment18, { children: [
        /* @__PURE__ */ jsx80(metas_default, { screen: SCREEN_MULTIFETCH_HOME, params }),
        /* @__PURE__ */ jsx80(loading_default2, { screen: SCREEN_MULTIFETCH_HOME, params }),
        /* @__PURE__ */ jsx80(home_default, { currentUser })
      ] });
    };
    home_default2 = HomeScreen;
  }
});

// css-modules:css-modules://Kn4x9Mylz3IDs_NyfY6QhlzEidHeopHjqK-XMAF9cvQ.css
var init_Kn4x9Mylz3IDs_NyfY6QhlzEidHeopHjqK_XMAF9cvQ = __esm({
  "css-modules:css-modules://Kn4x9Mylz3IDs_NyfY6QhlzEidHeopHjqK-XMAF9cvQ.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_profile.module.css
var src_components_profile_default;
var init_src_components_profile = __esm({
  "tmp_esbuild1736180049684/_src_components_profile.module.css"() {
    "use strict";
    init_Kn4x9Mylz3IDs_NyfY6QhlzEidHeopHjqK_XMAF9cvQ();
    src_components_profile_default = { "background": "core-YFJGMa-background", "profileContainer": "core-YFJGMa-profileContainer", "profileWrapper": "core-YFJGMa-profileWrapper", "profileTitle": "core-YFJGMa-profileTitle" };
  }
});

// src/components/profile.module.css
var init_profile = __esm({
  "src/components/profile.module.css"() {
    "use strict";
    init_src_components_profile();
  }
});

// src/components/profile.tsx
import { Wavy as Wavy9 } from "@lls/lls-kit";
import { getAuth as getAuth7, useSearchSubjects as useSearchSubjects2 } from "@lls/store";
import { getSchoolTypes } from "@lls/store";
import { useSearchLevels } from "@lls/store";
import { getCurrentUser as getCurrentUser24 } from "@lls/store";
import { useSearchSchools as useSearchSchools2 } from "@lls/store";
import { Profile } from "@lls/superkit";
import { SECONDARY_SCHOOL_TYPES_SLUGS, getAllowedFormSchoolTypes, getFluidSize as getFluidSize2 } from "@lls/utils";
import _78 from "lodash/fp.js";
import { useCallback as useCallback31 } from "react";
import { useDispatch as useDispatch23 } from "react-redux";
import { jsx as jsx81, jsxs as jsxs58 } from "react/jsx-runtime";
var ProfileComponent, profile_default;
var init_profile2 = __esm({
  "src/components/profile.tsx"() {
    "use strict";
    init_school();
    init_user2();
    init_user2();
    init_store();
    init_profile();
    ProfileComponent = () => {
      var _a2;
      const subjects = useSearchSubjects2({ hasBooks: true });
      const schoolTypes = getAllowedFormSchoolTypes(useMySelector(getSchoolTypes));
      const levels = useSearchLevels({ schoolTypes: SECONDARY_SCHOOL_TYPES_SLUGS });
      const currentUser = useMySelector(getCurrentUser24);
      const token = (_a2 = useMySelector(getAuth7)) == null ? void 0 : _a2.token;
      const userSchools = useSearchSchools2({ ids: currentUser == null ? void 0 : currentUser.schools });
      const dispatch = useDispatch23();
      const onSubmit = useCallback31(
        (form) => {
          updatePreferencesEffect({
            dispatch,
            params: {
              form: { ...form, id: currentUser == null ? void 0 : currentUser.id },
              token
            }
          });
        },
        [dispatch, token, currentUser]
      );
      const onSubscribeClick = async (subscribeValue) => {
        await subscribeContactEffect({ dispatch, params: { token, user: currentUser, subscribeValue } });
      };
      const onUdpatePassword = async (form) => {
        await updatePasswordEffect({ dispatch, params: { ...form, token } });
      };
      const profileUser = { ...currentUser, schools: userSchools };
      const hasUnsubscribedFromNL = !(currentUser == null ? void 0 : currentUser.hasContentNewsletter);
      return /* @__PURE__ */ jsxs58("div", { className: src_components_profile_default.profileContainer, children: [
        /* @__PURE__ */ jsx81("div", { className: src_components_profile_default.background }),
        /* @__PURE__ */ jsxs58(
          "div",
          {
            className: src_components_profile_default.profileWrapper,
            style: {
              "--c-padding": `${getFluidSize2({ minSize: 12, maxSize: 60 })} ${getFluidSize2({ minSize: 12, maxSize: 48 })}`
            },
            children: [
              /* @__PURE__ */ jsxs58("h2", { className: src_components_profile_default.profileTitle, children: [
                "Mon ",
                /* @__PURE__ */ jsx81(Wavy9, { waveColor: "var(--premium-40-color)", children: "Compte" })
              ] }),
              /* @__PURE__ */ jsx81(
                Profile,
                {
                  subjects,
                  levels,
                  searchSchoolsApi: searchSchools,
                  user: profileUser,
                  isAccountProfile: true,
                  schoolTypes,
                  submitPersonalInfos: onSubmit,
                  onSubscribeClick,
                  hasUnsubscribed: hasUnsubscribedFromNL,
                  onDeleteInfosClick: _78.noop,
                  onUpdatePassword: onUdpatePassword
                }
              )
            ]
          }
        )
      ] });
    };
    profile_default = ProfileComponent;
  }
});

// src/screens/profile.tsx
var profile_exports = {};
__export(profile_exports, {
  default: () => profile_default2
});
import { getToken as getToken10 } from "@lls/store";
import { Fragment as Fragment19, jsx as jsx82, jsxs as jsxs59 } from "react/jsx-runtime";
var ProfileScreen, profile_default2;
var init_profile3 = __esm({
  "src/screens/profile.tsx"() {
    "use strict";
    init_metas();
    init_profile2();
    init_constants();
    init_fetch();
    init_store();
    ProfileScreen = (props) => {
      const token = useMySelector(getToken10);
      useFetch({ screen: SCREEN_PROFILE, ssrFetcher: props.ssrFetcher, params: { token } });
      return /* @__PURE__ */ jsxs59(Fragment19, { children: [
        /* @__PURE__ */ jsx82(metas_default, { screen: SCREEN_PROFILE }),
        /* @__PURE__ */ jsx82(profile_default, {})
      ] });
    };
    profile_default2 = ProfileScreen;
  }
});

// css-modules:css-modules://9M4B-hLNgvtIbA4L5OktyRNU13Zb2qS8gD4rcJqJGJM.css
var init_M4B_hLNgvtIbA4L5OktyRNU13Zb2qS8gD4rcJqJGJM = __esm({
  "css-modules:css-modules://9M4B-hLNgvtIbA4L5OktyRNU13Zb2qS8gD4rcJqJGJM.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_mybooks_bookCard.module.css
var src_components_mybooks_bookCard_default;
var init_src_components_mybooks_bookCard = __esm({
  "tmp_esbuild1736180049684/_src_components_mybooks_bookCard.module.css"() {
    "use strict";
    init_M4B_hLNgvtIbA4L5OktyRNU13Zb2qS8gD4rcJqJGJM();
    src_components_mybooks_bookCard_default = { "bookCardCollection": "core-v092dq-bookCardCollection", "link": "core-v092dq-link", "renewalLabel": "core-v092dq-renewalLabel", "bookCardTextContainer": "core-v092dq-bookCardTextContainer", "bookCardTitle": "core-v092dq-bookCardTitle" };
  }
});

// src/components/mybooks/bookCard.module.css
var init_bookCard3 = __esm({
  "src/components/mybooks/bookCard.module.css"() {
    "use strict";
    init_src_components_mybooks_bookCard();
  }
});

// src/components/mybooks/bookCard.tsx
import _79 from "lodash/fp.js";
import { BookCover as BookCover3 } from "@lls/lls-kit";
import { dispatchAnalyticsEvent as dispatchAnalyticsEvent22 } from "@lls/utils";
import { getCollection as getCollection2 } from "@lls/store";
import { jsx as jsx83, jsxs as jsxs60 } from "react/jsx-runtime";
var BookCard2, bookCard_default2;
var init_bookCard4 = __esm({
  "src/components/mybooks/bookCard.tsx"() {
    "use strict";
    init_link();
    init_analytics4();
    init_store();
    init_route();
    init_bookCard3();
    BookCard2 = ({ book = {} }) => {
      const collection = useMySelector((state) => getCollection2(state, book.collection));
      const bookTitle = _79.get("displayTitle", book);
      const disabled = !_79.get("valid", book);
      const path = getPath("book", _79.pick(["slug", "uri"], book));
      const onItemClick = () => {
        dispatchAnalyticsEvent22(ANALYTICS_EVENTS.LINK_CLICKED, {
          featureName: "my_books|books_list",
          resourceId: [`${book == null ? void 0 : book.id}`]
        });
      };
      return /* @__PURE__ */ jsxs60(link_default, { className: src_components_mybooks_bookCard_default.link, to: path, onClick: onItemClick, "data-disabled": +disabled, children: [
        (book == null ? void 0 : book.renewalLabel) ? /* @__PURE__ */ jsx83("div", { className: src_components_mybooks_bookCard_default.renewalLabel, children: book.renewalLabel }) : null,
        /* @__PURE__ */ jsx83(BookCover3, { src: book == null ? void 0 : book.urlLite, hasWallShadow: false, height: "240px" }),
        /* @__PURE__ */ jsxs60("div", { className: src_components_mybooks_bookCard_default.bookCardTextContainer, children: [
          /* @__PURE__ */ jsx83("h2", { className: src_components_mybooks_bookCard_default.bookCardTitle, "data-disabled": +disabled, children: bookTitle }),
          /* @__PURE__ */ jsx83("div", { className: src_components_mybooks_bookCard_default.bookCardCollection, "data-disabled": +disabled, children: _79.get("name", collection) })
        ] })
      ] });
    };
    bookCard_default2 = BookCard2;
  }
});

// css-modules:css-modules://9y-l3FxnarapLT0I6Yz2hOVeMoI7L3WSkbrS121SCsU.css
var init_y_l3FxnarapLT0I6Yz2hOVeMoI7L3WSkbrS121SCsU = __esm({
  "css-modules:css-modules://9y-l3FxnarapLT0I6Yz2hOVeMoI7L3WSkbrS121SCsU.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_mybooks_filter.module.css
var src_components_mybooks_filter_default;
var init_src_components_mybooks_filter = __esm({
  "tmp_esbuild1736180049684/_src_components_mybooks_filter.module.css"() {
    "use strict";
    init_y_l3FxnarapLT0I6Yz2hOVeMoI7L3WSkbrS121SCsU();
    src_components_mybooks_filter_default = { "label": "core-8FEWMW-label", "contentFilter": "core-8FEWMW-contentFilter" };
  }
});

// src/components/mybooks/filter.module.css
var init_filter = __esm({
  "src/components/mybooks/filter.module.css"() {
    "use strict";
    init_src_components_mybooks_filter();
  }
});

// src/components/mybooks/filter.tsx
import _80 from "lodash/fp.js";
import { useCallback as useCallback32, useMemo as useMemo15 } from "react";
import { Chip, ChipSelect, Z_SELECT_CHIP_ALTERNATIVE } from "@lls/lls-kit";
import {
  formatChipSelectOptions,
  getOptionsForChipSelect
} from "@lls/utils";
import { jsx as jsx84, jsxs as jsxs61 } from "react/jsx-runtime";
var Filter, filter_default;
var init_filter2 = __esm({
  "src/components/mybooks/filter.tsx"() {
    "use strict";
    init_filter();
    Filter = ({
      label,
      userList,
      list,
      onChange,
      enabledIds,
      sortName
    }) => {
      const selectedList = formatChipSelectOptions({ list: userList });
      const options = useMemo15(
        () => getOptionsForChipSelect({ list, enabledIds, selectedList, sortName }),
        [enabledIds, list, selectedList, sortName]
      );
      const onChangeItem = useCallback32(
        (item) => {
          const currentItem = _80.find({ id: item == null ? void 0 : item.value }, list);
          if (currentItem) onChange(_80.concat(currentItem));
        },
        [list, onChange]
      );
      const onClickChip = useCallback32(
        (item) => {
          const currentItem = _80.find({ id: item == null ? void 0 : item.value }, list);
          if (currentItem) onChange(_80.remove(currentItem));
        },
        [list, onChange]
      );
      const isShownChipSelect = _80.size(userList) < _80.size(_80.defaultTo(list, enabledIds));
      return /* @__PURE__ */ jsxs61("div", { className: src_components_mybooks_filter_default.contentFilter, children: [
        /* @__PURE__ */ jsxs61("span", { className: src_components_mybooks_filter_default.label, children: [
          label,
          " :"
        ] }),
        _80.map(
          (item) => /* @__PURE__ */ jsx84(Chip, { onClick: () => onClickChip(item), label: item.label }, item.value),
          selectedList
        ),
        isShownChipSelect && /* @__PURE__ */ jsx84(
          ChipSelect,
          {
            variant: "singleAction",
            onChange: onChangeItem,
            options,
            optionsZIndex: Z_SELECT_CHIP_ALTERNATIVE
          }
        )
      ] });
    };
    filter_default = Filter;
  }
});

// css-modules:css-modules://gViwjQk7_jWLvR1_BPxSWsfrATF_J5TT0t3rcKN52To.css
var init_gViwjQk7_jWLvR1_BPxSWsfrATF_J5TT0t3rcKN52To = __esm({
  "css-modules:css-modules://gViwjQk7_jWLvR1_BPxSWsfrATF_J5TT0t3rcKN52To.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_mybooks_filters.module.css
var src_components_mybooks_filters_default;
var init_src_components_mybooks_filters = __esm({
  "tmp_esbuild1736180049684/_src_components_mybooks_filters.module.css"() {
    "use strict";
    init_gViwjQk7_jWLvR1_BPxSWsfrATF_J5TT0t3rcKN52To();
    src_components_mybooks_filters_default = { "filters": "core-b0g7nW-filters" };
  }
});

// src/components/mybooks/filters.module.css
var init_filters = __esm({
  "src/components/mybooks/filters.module.css"() {
    "use strict";
    init_src_components_mybooks_filters();
  }
});

// src/components/mybooks/filters.tsx
import _81 from "lodash/fp.js";
import { useEffect as useEffect25 } from "react";
import { Divider as Divider9 } from "@lls/lls-kit";
import { jsx as jsx85, jsxs as jsxs62 } from "react/jsx-runtime";
var Filters, filters_default;
var init_filters2 = __esm({
  "src/components/mybooks/filters.tsx"() {
    "use strict";
    init_filter2();
    init_filters();
    Filters = ({
      subjects,
      userLevels,
      userSubjects,
      licenseLevels,
      levels,
      licenseSubjects,
      isTeacher,
      selectedSubjects,
      setSelectedSubjects,
      selectedLevels,
      setSelectedLevels
    }) => {
      const licenseSubjectIds = _81.compact(_81.map("id", licenseSubjects));
      const licenseLevelIds = _81.compact(_81.map("id", licenseLevels));
      useEffect25(() => {
        setSelectedLevels(isTeacher ? [] : userLevels);
        setSelectedSubjects(isTeacher ? userSubjects : []);
      }, [setSelectedLevels, setSelectedSubjects, userSubjects, userLevels, isTeacher]);
      return /* @__PURE__ */ jsxs62("div", { className: src_components_mybooks_filters_default.filters, children: [
        /* @__PURE__ */ jsxs62("div", { children: [
          /* @__PURE__ */ jsx85(
            filter_default,
            {
              label: "Mati\xE8res",
              userList: selectedSubjects,
              onChange: setSelectedSubjects,
              list: subjects,
              enabledIds: licenseSubjectIds
            }
          ),
          /* @__PURE__ */ jsx85(
            filter_default,
            {
              label: "Niveaux",
              userList: selectedLevels,
              onChange: setSelectedLevels,
              list: levels,
              enabledIds: licenseLevelIds,
              sortName: "order"
            }
          )
        ] }),
        /* @__PURE__ */ jsx85(Divider9, {})
      ] });
    };
    filters_default = Filters;
  }
});

// css-modules:css-modules://GyaUTC30l0R2zHJC3Mmg-x5JjgdFkJfWubcLy8kxOPI.css
var init_GyaUTC30l0R2zHJC3Mmg_x5JjgdFkJfWubcLy8kxOPI = __esm({
  "css-modules:css-modules://GyaUTC30l0R2zHJC3Mmg-x5JjgdFkJfWubcLy8kxOPI.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_mybooks_index.module.css
var src_components_mybooks_index_default;
var init_src_components_mybooks_index = __esm({
  "tmp_esbuild1736180049684/_src_components_mybooks_index.module.css"() {
    "use strict";
    init_GyaUTC30l0R2zHJC3Mmg_x5JjgdFkJfWubcLy8kxOPI();
    src_components_mybooks_index_default = { "body": "core-Iyf7yW-body", "container": "core-Iyf7yW-container", "title": "core-Iyf7yW-title", "noBooksMessage": "core-Iyf7yW-noBooksMessage", "home": "core-Iyf7yW-home", "booksList": "core-Iyf7yW-booksList" };
  }
});

// src/components/mybooks/index.module.css
var init_mybooks = __esm({
  "src/components/mybooks/index.module.css"() {
    "use strict";
    init_src_components_mybooks_index();
  }
});

// src/components/mybooks/index.tsx
import { useMemo as useMemo16, useState as useState21 } from "react";
import { Wavy as Wavy10 } from "@lls/lls-kit";
import { sortBooks } from "@lls/utils";
import _82 from "lodash/fp.js";
import { useSearchBooks as useSearchBooks5 } from "@lls/store";
import { jsx as jsx86, jsxs as jsxs63 } from "react/jsx-runtime";
var MAX_COL_COUNT, COL_GAP, MyBooks, mybooks_default;
var init_mybooks2 = __esm({
  "src/components/mybooks/index.tsx"() {
    "use strict";
    init_bookCard4();
    init_filters2();
    init_ui3();
    init_mybooks();
    MAX_COL_COUNT = 4;
    COL_GAP = 24;
    MyBooks = ({
      currentUser,
      licenseBooks,
      levels,
      subjects,
      licenseSubjects,
      licenseLevels,
      validUserSubjects,
      userLevels
    }) => {
      const isTeacher = Boolean(currentUser == null ? void 0 : currentUser.isTeacher);
      const [selectedLevels, setSelectedLevels] = useState21(isTeacher ? [] : userLevels);
      const [selectedSubjects, setSelectedSubjects] = useState21(isTeacher ? validUserSubjects : []);
      const selectedLevelIds = _82.map("id", selectedLevels);
      const selectedSubjectIds = _82.map("id", selectedSubjects);
      const filteredBooks = useSearchBooks5({
        ids: _82.map("id", licenseBooks),
        levelIds: _82.isEmpty(selectedLevelIds) ? void 0 : selectedLevelIds,
        subjectIds: _82.isEmpty(selectedSubjectIds) ? void 0 : selectedSubjectIds
      });
      const sortedBooks = useMemo16(() => sortBooks(filteredBooks, levels, subjects), [filteredBooks, levels, subjects]);
      return /* @__PURE__ */ jsx86("div", { className: src_components_mybooks_index_default.home, children: /* @__PURE__ */ jsxs63("div", { className: src_components_mybooks_index_default.container, style: { "--cr-navbar-height": `${NAVBAR_HEIGHT}px` }, children: [
        /* @__PURE__ */ jsxs63("h1", { className: src_components_mybooks_index_default.title, children: [
          "Mes manuels num\xE9riques ",
          /* @__PURE__ */ jsx86(Wavy10, { waveColor: "var(--premium-50-color)", children: "Premium" })
        ] }),
        /* @__PURE__ */ jsxs63("div", { className: src_components_mybooks_index_default.body, children: [
          /* @__PURE__ */ jsx86(
            filters_default,
            {
              isTeacher,
              subjects,
              licenseSubjects,
              licenseLevels,
              userSubjects: validUserSubjects,
              userLevels,
              selectedSubjects,
              setSelectedSubjects,
              selectedLevels,
              setSelectedLevels,
              levels
            }
          ),
          _82.isEmpty(sortedBooks) ? /* @__PURE__ */ jsx86("p", { className: src_components_mybooks_index_default.noBooksMessage, children: "Aucun manuel disponible pour cette recherche" }) : /* @__PURE__ */ jsx86(
            "div",
            {
              className: src_components_mybooks_index_default.booksList,
              style: { "--cr-col-gap": `${COL_GAP}px`, "--cr-max-col-count": MAX_COL_COUNT },
              children: sortedBooks == null ? void 0 : sortedBooks.map((book) => /* @__PURE__ */ jsx86(bookCard_default2, { book }, book.id))
            }
          )
        ] })
      ] }) });
    };
    mybooks_default = MyBooks;
  }
});

// src/screens/mybooks.jsx
var mybooks_exports = {};
__export(mybooks_exports, {
  default: () => mybooks_default2
});
import _83 from "lodash/fp.js";
import { useRef as useRef14 } from "react";
import { useSelector as useSelector41 } from "react-redux";
import { getAuth as getAuth8, useSearchBooks as useSearchBooks6, useSearchLevels as useSearchLevels2, useSearchSubjects as useSearchSubjects3, useSearchValidBooks } from "@lls/store";
import { getCurrentUser as getCurrentUser25 } from "@lls/store";
import { SECONDARY_SCHOOL_TYPES_SLUGS as SECONDARY_SCHOOL_TYPES_SLUGS2 } from "@lls/utils";
import { Fragment as Fragment20, jsx as jsx87, jsxs as jsxs64 } from "react/jsx-runtime";
var seq2, MyBooksScreen, mybooks_default2;
var init_mybooks3 = __esm({
  "src/screens/mybooks.jsx"() {
    "use strict";
    init_loading4();
    init_metas();
    init_mybooks2();
    init_constants();
    init_fetch();
    seq2 = [
      {
        screen: SCREEN_PARTIAL_MY_BOOKS
      },
      {
        screen: SCREEN_PARTIAL_MY_BOOKS_USER
      }
    ];
    MyBooksScreen = ({ ssrFetcher, previousLocation }) => {
      const currentUser = useSelector41(getCurrentUser25);
      const token = _83.get("token", useSelector41(getAuth8));
      const fetchedUserRef = useRef14(false);
      const shouldRefreshUser = !fetchedUserRef.current && !!previousLocation;
      const params = { token };
      useMultiFetch({
        ssrFetcher,
        screen: SCREEN_MULTIFETCH_MY_BOOKS,
        params,
        screenToOptions: { [SCREEN_PARTIAL_MY_BOOKS_USER]: { fetchEvenIfLoaded: shouldRefreshUser } },
        seq: seq2
      });
      fetchedUserRef.current = true;
      const licenseBooks = useSearchBooks6({ ids: currentUser == null ? void 0 : currentUser.booksV2 });
      const books = useSearchValidBooks({ hasNewDesign: true, isValid: true });
      const subjects = useSearchSubjects3({ ids: _83.flatMap("subjects", books) });
      const validUserSubjects = useSearchSubjects3({
        ids: _83.intersection(_83.map("id", subjects), _83.getOr([], "subjects", currentUser))
      });
      const licenseSubjects = useSearchSubjects3({ ids: _83.flatMap("subjects", licenseBooks) });
      const highSchoolLevels = useSearchLevels2({
        schoolTypes: SECONDARY_SCHOOL_TYPES_SLUGS2
      });
      const licenseLevels = useSearchLevels2({ ids: _83.flatMap("levels", licenseBooks) });
      const userLevels = useSearchLevels2({ ids: _83.getOr([], "levels", currentUser) });
      return /* @__PURE__ */ jsxs64(Fragment20, { children: [
        /* @__PURE__ */ jsx87(metas_default, { screen: SCREEN_MULTIFETCH_MY_BOOKS, params }),
        /* @__PURE__ */ jsx87(loading_default2, { screen: SCREEN_MULTIFETCH_MY_BOOKS, params }),
        /* @__PURE__ */ jsx87(
          mybooks_default,
          {
            currentUser,
            licenseBooks,
            levels: highSchoolLevels,
            subjects,
            licenseSubjects,
            licenseLevels,
            validUserSubjects,
            userLevels
          }
        )
      ] });
    };
    mybooks_default2 = MyBooksScreen;
  }
});

// src/components/book/pageList.jsx
import { PageList } from "@lls/superkit";
import _84 from "lodash/fp.js";
import { useCallback as useCallback33 } from "react";
import { useHistory as useHistory16 } from "react-router-dom";
import { jsx as jsx88 } from "react/jsx-runtime";
var PageListComponent, pageList_default;
var init_pageList = __esm({
  "src/components/book/pageList.jsx"() {
    "use strict";
    init_route();
    PageListComponent = (props) => {
      const history = useHistory16();
      const onClick = useCallback33(
        (page) => {
          history.push(getPath("page", { slug: _84.get("slug", page), at_medium: "landing_book" }));
        },
        [history]
      );
      return /* @__PURE__ */ jsx88(PageList, { ...props, onClick });
    };
    pageList_default = PageListComponent;
  }
});

// src/components/book/myExercises.jsx
import { jsx as jsx89 } from "react/jsx-runtime";
var MyExercises, myExercises_default;
var init_myExercises = __esm({
  "src/components/book/myExercises.jsx"() {
    "use strict";
    init_pageList();
    MyExercises = ({ book, modifiedPages }) => /* @__PURE__ */ jsx89(
      pageList_default,
      {
        pages: modifiedPages,
        iconProps: {
          iconName: "squareandpencil",
          iconBg: "var(--tertiary-10-color)",
          iconColor: "var(--tertiary-40-color)"
        },
        title: "Derniers exercices r\xE9alis\xE9s",
        emptyTitle: "Aucune r\xE9ponse pour l'instant",
        emptySubtitle: "Tes derni\xE8res pages d'exercices r\xE9alis\xE9s s'afficheront ici.",
        book,
        withTimePrefix: false
      }
    );
    myExercises_default = MyExercises;
  }
});

// css-modules:css-modules://rSwNssWHW960MyctZ8a3Jpu_-O_ILnGio5bCClvOMlE.css
var init_rSwNssWHW960MyctZ8a3Jpu_O_ILnGio5bCClvOMlE = __esm({
  "css-modules:css-modules://rSwNssWHW960MyctZ8a3Jpu_-O_ILnGio5bCClvOMlE.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_book_common.module.css
var src_components_book_common_default;
var init_src_components_book_common = __esm({
  "tmp_esbuild1736180049684/_src_components_book_common.module.css"() {
    "use strict";
    init_rSwNssWHW960MyctZ8a3Jpu_O_ILnGio5bCClvOMlE();
    src_components_book_common_default = { "title": "core-SGWZva-title" };
  }
});

// src/components/book/common.module.css
var init_common5 = __esm({
  "src/components/book/common.module.css"() {
    "use strict";
    init_src_components_book_common();
  }
});

// src/components/book/common.jsx
import { makeComponent as makeComponent5 } from "@lls/utils";
var StyledTitle, commonIconProps;
var init_common6 = __esm({
  "src/components/book/common.jsx"() {
    "use strict";
    init_common5();
    StyledTitle = makeComponent5("div", src_components_book_common_default.title);
    commonIconProps = {
      iconName: "page",
      iconBg: "var(--primary-10-color)",
      iconColor: "var(--primary-40-color)"
    };
  }
});

// css-modules:css-modules://esIKYxSLorI_dSUGi__grGyJO7CG0cTVneDwxwj9oh8.css
var init_esIKYxSLorI_dSUGi_grGyJO7CG0cTVneDwxwj9oh8 = __esm({
  "css-modules:css-modules://esIKYxSLorI_dSUGi__grGyJO7CG0cTVneDwxwj9oh8.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_book_myPages.module.css
var src_components_book_myPages_default;
var init_src_components_book_myPages = __esm({
  "tmp_esbuild1736180049684/_src_components_book_myPages.module.css"() {
    "use strict";
    init_esIKYxSLorI_dSUGi_grGyJO7CG0cTVneDwxwj9oh8();
    src_components_book_myPages_default = { "button": "core-muh-Jq-button", "myPagesContainer": "core-muh-Jq-myPagesContainer" };
  }
});

// src/components/book/myPages.module.css
var init_myPages = __esm({
  "src/components/book/myPages.module.css"() {
    "use strict";
    init_src_components_book_myPages();
  }
});

// src/components/book/myPages.jsx
import { useSelector as useSelector42 } from "react-redux";
import { Button as Button33 } from "@lls/lls-kit";
import { jsx as jsx90 } from "react/jsx-runtime";
var TitleButton, MyPages, myPages_default;
var init_myPages2 = __esm({
  "src/components/book/myPages.jsx"() {
    "use strict";
    init_pageList();
    init_ui2();
    init_common6();
    init_myPages();
    TitleButton = ({ onCreateCustomPage }) => /* @__PURE__ */ jsx90(Button33, { className: src_components_book_myPages_default.button, onClick: () => onCreateCustomPage("page"), icon: "plus", children: "Cr\xE9er une page" });
    MyPages = ({ modifiedPages, book, onCreateCustomPage, isOffline = false }) => {
      const isStudentView = useSelector42(getUiIsStudentViewActivated);
      return /* @__PURE__ */ jsx90("div", { className: src_components_book_myPages_default.myPagesContainer, children: /* @__PURE__ */ jsx90(
        pageList_default,
        {
          pages: modifiedPages,
          iconProps: commonIconProps,
          title: "Pages et adaptations",
          emptyTitle: "Retrouvez ici vos cr\xE9ations et adaptations du manuel",
          emptySubtitle: "Cela inclut les pages de manuels que vous avez personnalis\xE9es",
          premiumIcon: true,
          titleButtonElement: isStudentView || isOffline ? void 0 : /* @__PURE__ */ jsx90(TitleButton, { onCreateCustomPage }),
          book
        }
      ) });
    };
    myPages_default = MyPages;
  }
});

// css-modules:css-modules://d9WiKkFWw5-_0z2uNl66EYNQ1RHtOtylzatbgN8DAQg.css
var init_d9WiKkFWw5_0z2uNl66EYNQ1RHtOtylzatbgN8DAQg = __esm({
  "css-modules:css-modules://d9WiKkFWw5-_0z2uNl66EYNQ1RHtOtylzatbgN8DAQg.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_book_mySharedPages.module.css
var src_components_book_mySharedPages_default;
var init_src_components_book_mySharedPages = __esm({
  "tmp_esbuild1736180049684/_src_components_book_mySharedPages.module.css"() {
    "use strict";
    init_d9WiKkFWw5_0z2uNl66EYNQ1RHtOtylzatbgN8DAQg();
    src_components_book_mySharedPages_default = { "mySharedPagesContainer": "core-ubHTYa-mySharedPagesContainer" };
  }
});

// src/components/book/mySharedPages.module.css
var init_mySharedPages = __esm({
  "src/components/book/mySharedPages.module.css"() {
    "use strict";
    init_src_components_book_mySharedPages();
  }
});

// src/components/book/mySharedPages.tsx
import { useSearchCurrentUserSharedPages as useSearchCurrentUserSharedPages2 } from "@lls/store";
import _85 from "lodash/fp.js";
import { jsx as jsx91 } from "react/jsx-runtime";
var MySharedPages, mySharedPages_default;
var init_mySharedPages2 = __esm({
  "src/components/book/mySharedPages.tsx"() {
    "use strict";
    init_pageList();
    init_common6();
    init_mySharedPages();
    MySharedPages = ({ book }) => {
      const sharedPages = useSearchCurrentUserSharedPages2({ bookIds: [_85.get("id", book)] });
      return /* @__PURE__ */ jsx91("div", { className: src_components_book_mySharedPages_default.mySharedPagesContainer, children: /* @__PURE__ */ jsx91(
        pageList_default,
        {
          pages: sharedPages,
          iconProps: commonIconProps,
          title: "Pages re\xE7ues",
          emptyTitle: "Aucune page re\xE7ue pour le moment",
          emptySubtitle: "Les derni\xE8res pages partag\xE9es par tes professeurs s'afficheront ici.",
          timeProp: "sharedAt",
          book
        }
      ) });
    };
    mySharedPages_default = MySharedPages;
  }
});

// css-modules:css-modules://0A0ll4ihv0OG1B_10ocWVeW547jw--Fh1wNv20v63CA.css
var init_A0ll4ihv0OG1B_10ocWVeW547jw_Fh1wNv20v63CA = __esm({
  "css-modules:css-modules://0A0ll4ihv0OG1B_10ocWVeW547jw--Fh1wNv20v63CA.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_book_news.module.css
var src_components_book_news_default;
var init_src_components_book_news = __esm({
  "tmp_esbuild1736180049684/_src_components_book_news.module.css"() {
    "use strict";
    init_A0ll4ihv0OG1B_10ocWVeW547jw_Fh1wNv20v63CA();
    src_components_book_news_default = { "carousel": "core-2yTG2W-carousel", "newsCover": "core-2yTG2W-newsCover", "newsTitle": "core-2yTG2W-newsTitle", "newsItem": "core-2yTG2W-newsItem", "carouselContainer": "core-2yTG2W-carouselContainer" };
  }
});

// src/components/book/news.module.css
var init_news = __esm({
  "src/components/book/news.module.css"() {
    "use strict";
    init_src_components_book_news();
  }
});

// src/components/book/news.jsx
import { dispatchAnalyticsEvent as dispatchAnalyticsEvent23 } from "@lls/utils";
import _86 from "lodash/fp.js";
import { useCallback as useCallback34, useMemo as useMemo17 } from "react";
import { useDispatch as useDispatch24 } from "react-redux";
import { Carousel as Carousel3, Stamp as Stamp2 } from "@lls/lls-kit";
import { useSearchNews } from "@lls/store";
import { jsx as jsx92, jsxs as jsxs65 } from "react/jsx-runtime";
var NEWS_ITEM_WIDTH, NewsItem, News, news_default;
var init_news2 = __esm({
  "src/components/book/news.jsx"() {
    "use strict";
    init_actions();
    init_analytics4();
    init_constants();
    init_common6();
    init_news();
    NEWS_ITEM_WIDTH = 250;
    NewsItem = ({ newsItem, handleClick }) => {
      return /* @__PURE__ */ jsxs65(
        "div",
        {
          className: src_components_book_news_default.newsItem,
          style: { "--cr-news-item-width": `${NEWS_ITEM_WIDTH}px` },
          onClick: () => handleClick(newsItem),
          children: [
            /* @__PURE__ */ jsx92("div", { className: src_components_book_news_default.newsCover, style: { "--cr-url": `url(${_86.get("cover", newsItem)})` } }),
            /* @__PURE__ */ jsx92(Stamp2, { size: "small", theme: "light-blue", children: _86.get("category", newsItem) }),
            /* @__PURE__ */ jsx92("div", { className: src_components_book_news_default.newsTitle, children: _86.get("displayTitle", newsItem) })
          ]
        }
      );
    };
    News = ({ isDrawerOpen, book }) => {
      const dispatch = useDispatch24();
      const news = useSearchNews({ ids: _86.get("news", book) });
      const bookId = _86.get("id", book);
      const handleClick = useCallback34(
        (newsItem) => {
          dispatchAnalyticsEvent23(ANALYTICS_EVENTS.LINK_CLICKED, { featureName: `news_${_86.get("id", newsItem)}`, bookId });
          dispatch(
            setModal({
              name: MODAL_NEWS,
              open: true,
              data: { newsItem }
            })
          );
        },
        [dispatch, bookId]
      );
      const items = useMemo17(() => _86.map((newsItem) => ({ type: "item", newsItem, handleClick }), news), [news, handleClick]);
      return _86.isEmpty(news) ? null : /* @__PURE__ */ jsxs65("div", { className: src_components_book_news_default.carouselContainer, "data-drawer-open": +isDrawerOpen, children: [
        /* @__PURE__ */ jsx92(StyledTitle, { children: "Actualit\xE9s" }),
        /* @__PURE__ */ jsx92(Carousel3, { className: src_components_book_news_default.carousel, items, scrollStep: 1, ComponentItem: NewsItem, width: "100%" })
      ] });
    };
    news_default = News;
  }
});

// css-modules:css-modules://qxY92FbZdpCC8lyRxZWKkDajyhZ-bivLhpkQ0IzNXFo.css
var init_qxY92FbZdpCC8lyRxZWKkDajyhZ_bivLhpkQ0IzNXFo = __esm({
  "css-modules:css-modules://qxY92FbZdpCC8lyRxZWKkDajyhZ-bivLhpkQ0IzNXFo.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_book_pageHistory.module.css
var src_components_book_pageHistory_default;
var init_src_components_book_pageHistory = __esm({
  "tmp_esbuild1736180049684/_src_components_book_pageHistory.module.css"() {
    "use strict";
    init_qxY92FbZdpCC8lyRxZWKkDajyhZ_bivLhpkQ0IzNXFo();
    src_components_book_pageHistory_default = { "pageHistoryContainer": "core-Bjf32a-pageHistoryContainer" };
  }
});

// src/components/book/pageHistory.module.css
var init_pageHistory = __esm({
  "src/components/book/pageHistory.module.css"() {
    "use strict";
    init_src_components_book_pageHistory();
  }
});

// src/components/book/pageHistory.jsx
import { jsx as jsx93 } from "react/jsx-runtime";
var PageHistory, pageHistory_default;
var init_pageHistory2 = __esm({
  "src/components/book/pageHistory.jsx"() {
    "use strict";
    init_pageList();
    init_useLastPagesViewed();
    init_pageHistory();
    PageHistory = ({ currentUser, book }) => {
      const lastPagesViewed = useLastPagesViewed_default({ currentUser, book });
      return /* @__PURE__ */ jsx93("div", { className: src_components_book_pageHistory_default.pageHistoryContainer, children: /* @__PURE__ */ jsx93(
        pageList_default,
        {
          title: "Consult\xE9es r\xE9cemment",
          emptyTitle: `Retrouve${(currentUser == null ? void 0 : currentUser.isTeacher) ? "z" : ""} ici les derni\xE8res pages consult\xE9es`,
          emptySubtitle: `N'h\xE9site${(currentUser == null ? void 0 : currentUser.isTeacher) ? "z" : ""} pas \xE0 utiliser le sommaire et ses filtres`,
          pages: lastPagesViewed,
          iconProps: {
            iconName: "clock",
            iconBg: "var(--tertiary-10-color)",
            iconColor: "var(--tertiary-40-color)"
          },
          timeProp: "seenAt",
          book
        }
      ) });
    };
    pageHistory_default = PageHistory;
  }
});

// css-modules:css-modules://2JIVtZze5q-xbzB_lHEvnoXVBJNz0pr4UhGq1h1okLE.css
var init_JIVtZze5q_xbzB_lHEvnoXVBJNz0pr4UhGq1h1okLE = __esm({
  "css-modules:css-modules://2JIVtZze5q-xbzB_lHEvnoXVBJNz0pr4UhGq1h1okLE.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_book_resources.module.css
var src_components_book_resources_default;
var init_src_components_book_resources = __esm({
  "tmp_esbuild1736180049684/_src_components_book_resources.module.css"() {
    "use strict";
    init_JIVtZze5q_xbzB_lHEvnoXVBJNz0pr4UhGq1h1okLE();
    src_components_book_resources_default = { "resourcesWrapper": "core-eAjk-G-resourcesWrapper" };
  }
});

// src/components/book/resources.module.css
var init_resources = __esm({
  "src/components/book/resources.module.css"() {
    "use strict";
    init_src_components_book_resources();
  }
});

// src/components/book/resources.jsx
import _87 from "lodash/fp.js";
import { useCallback as useCallback35, useEffect as useEffect26 } from "react";
import { useDispatch as useDispatch25 } from "react-redux";
import { useHistory as useHistory17, useLocation as useLocation14 } from "react-router-dom";
import { BookResources, categoryHasResources } from "@lls/superkit";
import { getQueryParams as getQueryParams4 } from "@lls/utils";
import { jsx as jsx94 } from "react/jsx-runtime";
var Resources, resources_default;
var init_resources2 = __esm({
  "src/components/book/resources.jsx"() {
    "use strict";
    init_actions();
    init_constants();
    init_route();
    init_resources();
    Resources = ({ book, resources, chapters, pages }) => {
      const dispatch = useDispatch25();
      const query = getQueryParams4(useLocation14());
      const history = useHistory17();
      const openModal = useCallback35(
        (category2) => {
          if (categoryHasResources({ category: category2, resources }))
            dispatch(setModal({ name: MODAL_BOOK_RESOURCES, open: true, data: { resources, category: category2, chapters, pages } }));
        },
        [resources, chapters, dispatch, pages]
      );
      const onResourceClick = useCallback35(
        (resource) => {
          const newCategory = _87.get("category", resource);
          history.push(getPath("book", { item: newCategory, ..._87.pick(["slug", "uri"], book) }));
          openModal(newCategory);
        },
        [history, book, openModal]
      );
      const category = _87.get("item", query);
      useEffect26(() => {
        _87.noop(resources, chapters);
        if (!_87.isEmpty(category)) {
          openModal(category);
        }
      }, [resources, category, chapters, openModal]);
      return /* @__PURE__ */ jsx94("div", { className: src_components_book_resources_default.resourcesWrapper, children: !_87.isEmpty(resources) && /* @__PURE__ */ jsx94(BookResources, { resources, onClick: onResourceClick }) });
    };
    resources_default = Resources;
  }
});

// src/api/stats.js
import _88 from "lodash/fp.js";
var fetchStudentsStats, fetchStats, fetchWorkplanStats, fetchWorkplanStatsByGroupIds, fetchLearningAssessmentStatsByGroupIds, fetchLearningAssessmentStats;
var init_stats = __esm({
  "src/api/stats.js"() {
    "use strict";
    init_graphql();
    fetchStudentsStats = ({ token, pageIds }) => gqlNoCache({
      query: `query coreFetchStudentsStats ($token: String!, $pageIds: [Int]!, $dimensions: [String], $statUnit: StatUnitTypeEnum!) {
      viewer (token: $token) {
        stats {
          students (pageIds: $pageIds, dimensions: $dimensions, statUnit: $statUnit)
        }
      }
    }`,
      variables: {
        token,
        pageIds,
        dimensions: ["userId", "notion", "userId.notion", "statUnit"],
        statUnit: "day"
      }
    }).then(_88.get("viewer.stats.students"));
    fetchStats = ({ token, pageIds, sessionTokens, createdAfter }) => gqlNoCache({
      query: `query coreFetchStats ($token: String!, $pageIds: [Int]!, $dimensions: [String], $statUnit: StatUnitTypeEnum!, $sessionTokens: [String], $createdAfter: String) {
      viewer (token: $token) {
        stats {
          me (pageIds: $pageIds, dimensions: $dimensions, statUnit: $statUnit, tokens: $sessionTokens, createdAfter: $createdAfter)
        }
      }
    }`,
      variables: {
        token,
        pageIds,
        dimensions: ["notion", "statUnit"],
        createdAfter,
        statUnit: "day",
        sessionTokens
      }
    }).then(_88.get("viewer.stats.me"));
    fetchWorkplanStats = ({ token, pageIds, dataSource, studentIds }) => gqlNoCache({
      query: `query coreFetchWorkplanStats ($token: String!, $pageIds: [Int]! $statUnit: StatUnitTypeEnum!, $dataSource: String, $studentIds: [Int],$dimensions: [String]) {
      viewer (token: $token) {
        stats {
          students (pageIds: $pageIds, dimensions: $dimensions, statUnit: $statUnit, dataSource: $dataSource, studentIds: $studentIds)
        }
      }
    }
`,
      variables: {
        dataSource,
        dimensions: ["userId"],
        pageIds,
        statUnit: "day",
        studentIds,
        token
      }
    }).then(_88.get("viewer.stats.students"));
    fetchWorkplanStatsByGroupIds = ({ token, pageIds, dataSource, groupIds }) => gqlNoCache({
      query: `query coreFetchWorkplanStatsByGroupIds ($token: String!, $pageIds: [Int]! $statUnit: StatUnitTypeEnum!, $dataSource: String, $groupIds: [Int],$dimensions: [String]) {
      viewer (token: $token) {
        stats {
          groups (pageIds: $pageIds, dimensions: $dimensions, statUnit: $statUnit, dataSource: $dataSource, groupIds: $groupIds)
        }
      }
    }
`,
      variables: {
        dataSource,
        dimensions: ["userId"],
        pageIds,
        statUnit: "day",
        groupIds,
        token
      }
    }).then(_88.get("viewer.stats.students"));
    fetchLearningAssessmentStatsByGroupIds = ({ token, pageIds, dataSource, groupIds }) => gqlNoCache({
      query: `query coreFetchLearningAssessmentStatsByGroupIds ($token: String!, $pageIds: [Int]! $statUnit: StatUnitTypeEnum!, $dataSource: String, $groupIds: [Int],$dimensions: [String]) {
      viewer (token: $token) {
        stats {
          groups (pageIds: $pageIds, dimensions: $dimensions, statUnit: $statUnit, dataSource: $dataSource, groupIds: $groupIds)
        }
      }
    }
`,
      variables: {
        dataSource,
        dimensions: ["userId"],
        pageIds,
        statUnit: "day",
        groupIds,
        token
      }
    }).then(_88.get("viewer.stats.groups"));
    fetchLearningAssessmentStats = ({ token, pageIds, dataSource, studentIds }) => gqlNoCache({
      query: `query coreFetchLearningAssessmentStats ($token: String!, $pageIds: [Int]! $statUnit: StatUnitTypeEnum!, $dataSource: String, $studentIds: [Int],$dimensions: [String]) {
      viewer (token: $token) {
        stats {
          students (pageIds: $pageIds, dimensions: $dimensions, statUnit: $statUnit, dataSource: $dataSource, studentIds: $studentIds)
        }
      }
    }
`,
      variables: {
        dataSource,
        dimensions: ["userId"],
        pageIds,
        statUnit: "day",
        studentIds,
        token
      }
    }).then(_88.get("viewer.stats.students"));
  }
});

// src/effects/stats.js
import { SESSION_EXERCISE_TAB, SESSION_STATS_TAB, SESSION_STATS_TEACHER_TAB } from "@lls/superkit";
import _89 from "lodash/fp.js";
var LEARNING_ASSESSMENT_DATA_SOURCE, WORKPLAN_DATA_SOURCE, WORKPLAN_TAB, LEARNING_ASSESSMENT_TAB, fetchStats2, fetchExerciseStats, fetchSessionEndStats, fetchStatsEffect, fetchSessionEndStatsEffect;
var init_stats2 = __esm({
  "src/effects/stats.js"() {
    "use strict";
    init_stats();
    init_constants();
    init_utils3();
    LEARNING_ASSESSMENT_DATA_SOURCE = "learning_assessment";
    WORKPLAN_DATA_SOURCE = "workplan";
    WORKPLAN_TAB = "WORKPLAN";
    LEARNING_ASSESSMENT_TAB = "LEARNING_ASSESSMENT";
    fetchStats2 = async ({ params: { tab, token, pageIds, ctx, createdAfter, studentIds, groupIds } } = {}) => {
      if (_89.isEmpty(token)) return;
      switch (tab) {
        case SESSION_EXERCISE_TAB: {
          return fetchExerciseStats({ params: { token, pageIds, ctx } });
        }
        case SESSION_STATS_TEACHER_TAB: {
          return fetchStudentsStats({ token, pageIds });
        }
        case SESSION_STATS_TAB: {
          return fetchStats({ token, pageIds, createdAfter });
        }
        case LEARNING_ASSESSMENT_TAB: {
          return _89.isEmpty(groupIds) ? fetchLearningAssessmentStats({ token, pageIds, dataSource: LEARNING_ASSESSMENT_DATA_SOURCE, studentIds }) : fetchLearningAssessmentStatsByGroupIds({
            token,
            pageIds,
            dataSource: LEARNING_ASSESSMENT_DATA_SOURCE,
            groupIds
          });
        }
        case WORKPLAN_TAB: {
          return _89.isEmpty(groupIds) ? fetchWorkplanStats({ token, pageIds, dataSource: WORKPLAN_DATA_SOURCE, studentIds }) : fetchWorkplanStatsByGroupIds({ token, pageIds, dataSource: WORKPLAN_DATA_SOURCE, groupIds });
        }
        default:
      }
    };
    fetchExerciseStats = async ({ params: { token, pageIds, ctx } } = {}) => (ctx == null ? void 0 : ctx.sessionEnd) ? fetchSessionEndStats({ params: { token, pageIds, ctx } }) : fetchStats({ token, pageIds });
    fetchSessionEndStats = async ({ params: { token, pageIds, ctx } } = {}) => {
      const result = await fetchStats({
        token,
        pageIds,
        sessionTokens: [_89.get("token", ctx)]
      });
      return result;
    };
    fetchStatsEffect = ({ dispatch, params }) => tryCatch({
      dispatch,
      params,
      effect: fetchStats2,
      loadingName: STATS_FETCH
    });
    fetchSessionEndStatsEffect = ({ dispatch, params }) => tryCatch({
      dispatch,
      params,
      effect: fetchSessionEndStats,
      loadingName: STATS_FETCH
    });
  }
});

// src/utils/common.ts
import _90 from "lodash/fp.js";
var parseOrUndefined;
var init_common7 = __esm({
  "src/utils/common.ts"() {
    "use strict";
    parseOrUndefined = (radix) => (str) => {
      const parsed = _90.parseInt(radix, str);
      return Number.isNaN(parsed) ? void 0 : parsed;
    };
  }
});

// src/constants/summary.js
var PAGE_TYPE, CHAPTER_TYPE, DRAWER_WIDTH;
var init_summary2 = __esm({
  "src/constants/summary.js"() {
    "use strict";
    PAGE_TYPE = "Page";
    CHAPTER_TYPE = "Chapter";
    DRAWER_WIDTH = 350;
  }
});

// src/utils/summary.js
import { editSummary } from "@lls/superkit";
import _91 from "lodash/fp.js";
var extractPages, addPanoramaPages, rejectSessionPages;
var init_summary3 = __esm({
  "src/utils/summary.js"() {
    "use strict";
    init_summary2();
    init_panorama2();
    extractPages = (summary = {}) => {
      if (_91.matches({ type: PAGE_TYPE }, summary)) return [summary];
      if (_91.isEmpty(summary)) return [];
      return _91.flow(
        _91.get("elements"),
        _91.flatMap(extractPages),
        // add type-related (slug, valid, ...) fields in root
        _91.map((page) => ({
          ...page,
          ..._91.get("element", page)
        }))
      )(summary);
    };
    addPanoramaPages = (summary, { bookId, query } = {}) => {
      return editSummary(summary, (node, next) => {
        if (_91.matches({ type: CHAPTER_TYPE }, node)) {
          const scrollTo = query && query.chapterId === node.id && query.scrollTo;
          const page = getPanoramaPageIfExists({
            withPanorama: true,
            bookId,
            chapterId: node.id,
            scrollTo
          });
          const elements = _91.getOr([], "elements", node);
          if (page && !_91.find({ id: _91.get("id", page) }, elements)) {
            const summaryPage = {
              id: page.id,
              title: page.title,
              type: PAGE_TYPE,
              element: page
            };
            return _91.set("elements", _91.concat(summaryPage, elements), node);
          }
        }
        return next(node);
      });
    };
    rejectSessionPages = (summary) => editSummary(summary, (node, next) => {
      if (_91.matches({ type: "Page" }, node)) return _91.get("element.isPartOfSession", node) ? void 0 : node;
      return next(node);
    });
  }
});

// src/utils/workplan.js
import _92 from "lodash/fp.js";
var isShownWorkplanStudentTracking, getWorkplanGoals, getWorkplanGoalIds;
var init_workplan = __esm({
  "src/utils/workplan.js"() {
    "use strict";
    init_summary3();
    isShownWorkplanStudentTracking = (book) => {
      const pages = extractPages(_92.get("summary", book));
      if (_92.isEmpty(pages)) return false;
      return _92.every("isWorkplan", pages);
    };
    getWorkplanGoals = ({ book, selectedWorkplanOptions }) => _92.flow(
      _92.get("workplanStudentsStats"),
      _92.values,
      _92.groupBy("chapter"),
      _92.get(_92.get("value", selectedWorkplanOptions))
    )(book);
    getWorkplanGoalIds = ({ selectedWorkplanOptions, chapterElement, modifiedPages }) => {
      const selectedChapterId = _92.get("value", selectedWorkplanOptions);
      const modifiedWorkplanGoals = _92.filter({ isWorkplan: true, chapter: selectedChapterId }, modifiedPages);
      return _92.flow(
        _92.find({ id: selectedChapterId }),
        _92.get("elements"),
        _92.concat(modifiedWorkplanGoals),
        _92.map("id")
      )(chapterElement);
    };
  }
});

// css-modules:css-modules://t-WMog77GzlYRDtMX-ajJsyBi8aORdf6tDg_LHlNH0k.css
var init_t_WMog77GzlYRDtMX_ajJsyBi8aORdf6tDg_LHlNH0k = __esm({
  "css-modules:css-modules://t-WMog77GzlYRDtMX-ajJsyBi8aORdf6tDg_LHlNH0k.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_book_studentTracking.module.css
var src_components_book_studentTracking_default;
var init_src_components_book_studentTracking = __esm({
  "tmp_esbuild1736180049684/_src_components_book_studentTracking.module.css"() {
    "use strict";
    init_t_WMog77GzlYRDtMX_ajJsyBi8aORdf6tDg_LHlNH0k();
    src_components_book_studentTracking_default = { "container": "core-_RDjPW-container" };
  }
});

// src/components/book/studentTracking.module.css
var init_studentTracking = __esm({
  "src/components/book/studentTracking.module.css"() {
    "use strict";
    init_src_components_book_studentTracking();
  }
});

// src/components/book/studentTracking.jsx
import _93 from "lodash/fp.js";
import { useCallback as useCallback36, useEffect as useEffect27, useMemo as useMemo18, useState as useState22 } from "react";
import { useDispatch as useDispatch26, useSelector as useSelector43 } from "react-redux";
import { useHistory as useHistory18, useLocation as useLocation15 } from "react-router-dom";
import { getAuth as getAuth9 } from "@lls/store";
import { WorkplanStudentTracking } from "@lls/superkit";
import { getQueryParams as getQueryParams5 } from "@lls/utils";
import { jsx as jsx95, jsxs as jsxs66 } from "react/jsx-runtime";
var StudentTracking, studentTracking_default;
var init_studentTracking2 = __esm({
  "src/components/book/studentTracking.jsx"() {
    "use strict";
    init_constants();
    init_stats2();
    init_loading3();
    init_common7();
    init_route();
    init_workplan();
    init_common6();
    init_studentTracking();
    StudentTracking = ({ book, groups, students: allStudents, currentUser, modifiedPages }) => {
      const history = useHistory18();
      const location = useLocation15();
      const dispatch = useDispatch26();
      const auth2 = useSelector43(getAuth9);
      const token = _93.get("token", auth2);
      const queryParams = getQueryParams5(location);
      const chapterElement = _93.get("summary.elements", book);
      const groupId = _93.flow(_93.get("groupId"), parseOrUndefined(10))(queryParams);
      const students = useMemo18(
        () => _93.get("isStudent", currentUser) ? [currentUser] : allStudents,
        [currentUser, allStudents]
      );
      const workplansChapterOptions = useMemo18(
        () => _93.map(
          (workplan) => ({ id: _93.get("id", workplan), value: _93.get("id", workplan), label: _93.get("title", workplan) }),
          chapterElement
        ),
        [chapterElement]
      );
      const [selectedWorkplanOptions, setSelectedWorkplanOptions] = useState22(_93.first(workplansChapterOptions));
      const [displayedStudentIds, setDisplayedStudentIds] = useState22([]);
      const [stats, setStats] = useState22({});
      const handleChangeWorkplan = useCallback36(
        (value) => {
          setSelectedWorkplanOptions(_93.find({ value }, workplansChapterOptions));
        },
        [workplansChapterOptions]
      );
      const workplanGoals = useMemo18(
        () => getWorkplanGoals({ book, selectedWorkplanOptions }),
        [selectedWorkplanOptions, book]
      );
      const workplanGoalIds = useMemo18(
        () => getWorkplanGoalIds({ chapterElement, selectedWorkplanOptions, modifiedPages }),
        [chapterElement, selectedWorkplanOptions, modifiedPages]
      );
      const onManageGroupClick = useCallback36(() => history.push(getPath("classroom_settings")), [history]);
      const handleChangeGroup = useCallback36(
        (selectedGroup2) => {
          history.replace({
            pathname: location.pathname,
            search: `?groupId=${_93.get("id", selectedGroup2)}`,
            state: { isActive: true }
          });
        },
        [history, location]
      );
      const onClickStudentTask = useCallback36(
        ({ taskId, pageSlug, studentId }) => {
          history.push(getPath("workplan_student_page", { slug: pageSlug, studentId, taskId, groupId }));
        },
        [history, groupId]
      );
      const selectedGroup = _93.find({ id: groupId }, groups);
      const selectedStudents = useMemo18(
        () => _93.isNil(selectedGroup) ? students : _93.intersectionWith(
          (student, studentId) => _93.get("id", student) === studentId,
          students,
          _93.get("students", selectedGroup)
        ),
        [selectedGroup, students]
      );
      useEffect27(() => {
        _93.noop(groupId);
        async function fetchData2() {
          const fetchedStats = await fetchStatsEffect({
            dispatch,
            params: {
              token,
              dataSource: "workplan",
              tab: WORKPLAN_TAB,
              pageIds: workplanGoalIds,
              studentIds: displayedStudentIds
            }
          });
          setStats(_93.get("userId", fetchedStats));
        }
        !_93.isEmpty(displayedStudentIds) && fetchData2();
      }, [dispatch, token, displayedStudentIds, workplanGoalIds, groupId]);
      const isLoadingWorkplanStats = useSelector43(
        (state) => getIsLoading(state, STATS_FETCH, {
          token,
          dataSource: "workplan",
          tab: WORKPLAN_TAB,
          pageIds: workplanGoalIds,
          studentIds: displayedStudentIds
        })
      );
      return /* @__PURE__ */ jsxs66("div", { className: src_components_book_studentTracking_default.container, children: [
        /* @__PURE__ */ jsx95(StyledTitle, { children: "Plan de travail" }),
        /* @__PURE__ */ jsx95(
          WorkplanStudentTracking,
          {
            currentUser,
            groups,
            selectedGroup,
            onChangeWorkplan: handleChangeWorkplan,
            setDisplayedStudentIds,
            workplansOptions: workplansChapterOptions,
            selectedWorkplanOptions,
            selectedStudents,
            statsByStudentIds: stats,
            handleChangeGroup,
            workplanGoals,
            onManageGroupClick,
            onClickStudentTask,
            isLoadingStats: isLoadingWorkplanStats
          }
        )
      ] });
    };
    studentTracking_default = StudentTracking;
  }
});

// css-modules:css-modules://sfFbW_Enxy5dFH3H9STXXKe4kKFOQj77JFOtt8kGOfw.css
var init_sfFbW_Enxy5dFH3H9STXXKe4kKFOQj77JFOtt8kGOfw = __esm({
  "css-modules:css-modules://sfFbW_Enxy5dFH3H9STXXKe4kKFOQj77JFOtt8kGOfw.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_book_tips.module.css
var src_components_book_tips_default;
var init_src_components_book_tips = __esm({
  "tmp_esbuild1736180049684/_src_components_book_tips.module.css"() {
    "use strict";
    init_sfFbW_Enxy5dFH3H9STXXKe4kKFOQj77JFOtt8kGOfw();
    src_components_book_tips_default = { "daylyTipsIllustration": "core-KlXlNq-daylyTipsIllustration superkit-permanentMarkerRegular", "tipTitle": "core-KlXlNq-tipTitle", "buttonContainer": "core-KlXlNq-buttonContainer", "img": "core-KlXlNq-img", "description": "core-KlXlNq-description", "animTraces": "core-KlXlNq-animTraces", "pictureTips": "core-KlXlNq-pictureTips", "tipContent": "core-KlXlNq-tipContent", "daylyTipContainer": "core-KlXlNq-daylyTipContainer", "content": "core-KlXlNq-content" };
  }
});

// src/components/book/tips.module.css
var init_tips = __esm({
  "src/components/book/tips.module.css"() {
    "use strict";
    init_src_components_book_tips();
  }
});

// src/components/book/tips.jsx
import _94 from "lodash/fp.js";
import { useDispatch as useDispatch27 } from "react-redux";
import { Button as Button34 } from "@lls/lls-kit";
import { dispatchAnalyticsEvent as dispatchAnalyticsEvent24, openWindow as openWindow15 } from "@lls/utils";
import { Fragment as Fragment21, jsx as jsx96, jsxs as jsxs67 } from "react/jsx-runtime";
var TipCard, Tips, tips_default;
var init_tips2 = __esm({
  "src/components/book/tips.jsx"() {
    "use strict";
    init_actions();
    init_constants();
    init_style();
    init_common6();
    init_tips();
    TipCard = ({ tip = {}, isDrawerOpen }) => {
      const dispatch = useDispatch27();
      const onClick = () => {
        dispatchAnalyticsEvent24(tip.event, { featureName: `tips_${tip.name}` });
        dispatch(setModal({ name: MODAL_TIP, open: true, data: tip }));
      };
      return /* @__PURE__ */ jsxs67("div", { className: src_components_book_tips_default.tipContent, onClick, "data-drawer-open": +isDrawerOpen, children: [
        /* @__PURE__ */ jsx96("div", { className: src_components_book_tips_default.pictureTips, children: /* @__PURE__ */ jsx96("img", { className: src_components_book_tips_default.img, src: tip.url }) }),
        /* @__PURE__ */ jsxs67("div", { className: src_components_book_tips_default.content, children: [
          /* @__PURE__ */ jsx96("span", { className: src_components_book_tips_default.tipTitle, children: tip.title }),
          /* @__PURE__ */ jsx96("span", { className: src_components_book_tips_default.description, children: tip.description }),
          /* @__PURE__ */ jsx96(Button34, { icon: "arrowright", accent: "floating", position: "left", children: "D\xE9couvrir" })
        ] })
      ] });
    };
    Tips = ({ currentUser, isDrawerOpen }) => {
      const onClick = () => {
        openWindow15("https://helpdesk.lelivrescolaire.fr/fr/category/astuces-1l909eq", "_blank");
      };
      const tip = _94.get("tipOfTheDay", currentUser);
      const fluidSize = getFluidSize({ minSize: 18, maxSize: 28 });
      return tip && /* @__PURE__ */ jsxs67(Fragment21, { children: [
        /* @__PURE__ */ jsx96(StyledTitle, { children: "Astuces" }),
        /* @__PURE__ */ jsxs67("div", { className: src_components_book_tips_default.daylyTipContainer, children: [
          /* @__PURE__ */ jsx96(TipCard, { isDrawerOpen, tip }),
          /* @__PURE__ */ jsx96(
            "span",
            {
              className: src_components_book_tips_default.daylyTipsIllustration,
              style: { "--cr-fluid-size": fluidSize },
              "data-drawer-open": +isDrawerOpen,
              children: /* @__PURE__ */ jsxs67("span", { children: [
                "Astuce ",
                /* @__PURE__ */ jsx96("br", {}),
                "du jour"
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ jsx96("div", { className: src_components_book_tips_default.buttonContainer, children: /* @__PURE__ */ jsx96(Button34, { accent: "floating", onClick, children: "Explorer les autres astuces" }) })
      ] });
    };
    tips_default = Tips;
  }
});

// css-modules:css-modules://HjAcMPiUbKJoPzLZ84nFzhrfhUt2ELhONuFN37V9fGQ.css
var init_HjAcMPiUbKJoPzLZ84nFzhrfhUt2ELhONuFN37V9fGQ = __esm({
  "css-modules:css-modules://HjAcMPiUbKJoPzLZ84nFzhrfhUt2ELhONuFN37V9fGQ.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_tour_tourMobileBanner.module.css
var src_components_tour_tourMobileBanner_default;
var init_src_components_tour_tourMobileBanner = __esm({
  "tmp_esbuild1736180049684/_src_components_tour_tourMobileBanner.module.css"() {
    "use strict";
    init_HjAcMPiUbKJoPzLZ84nFzhrfhUt2ELhONuFN37V9fGQ();
    src_components_tour_tourMobileBanner_default = { "title": "core-PQbDJa-title", "bannerContainer": "core-PQbDJa-bannerContainer", "text": "core-PQbDJa-text" };
  }
});

// src/components/tour/tourMobileBanner.module.css
var init_tourMobileBanner = __esm({
  "src/components/tour/tourMobileBanner.module.css"() {
    "use strict";
    init_src_components_tour_tourMobileBanner();
  }
});

// src/components/tour/tourMobileBanner.jsx
import { useSelector as useSelector44 } from "react-redux";
import { Icon as Icon8 } from "@lls/lls-kit";
import { getCurrentUser as getCurrentUser26 } from "@lls/store";
import { jsx as jsx97, jsxs as jsxs68 } from "react/jsx-runtime";
var TourMobileBanner, tourMobileBanner_default;
var init_tourMobileBanner2 = __esm({
  "src/components/tour/tourMobileBanner.jsx"() {
    "use strict";
    init_tourMobileBanner();
    TourMobileBanner = () => {
      const currentUser = useSelector44(getCurrentUser26);
      return (currentUser == null ? void 0 : currentUser.isTrial) ? /* @__PURE__ */ jsxs68("div", { className: src_components_tour_tourMobileBanner_default.bannerContainer, children: [
        /* @__PURE__ */ jsxs68("h3", { className: src_components_tour_tourMobileBanner_default.title, children: [
          /* @__PURE__ */ jsx97(Icon8, { name: "infocirclefilled", color: "var(--secondary-40-color)" }),
          " Profitez de l'exp\xE9rience compl\xE8te sur ordinateur\xA0!"
        ] }),
        /* @__PURE__ */ jsx97("p", { className: src_components_tour_tourMobileBanner_default.text, children: "L'essai Premium est limit\xE9 sur smartphone. Pour profiter pleinement de votre essai, ouvrez le lien pr\xE9sent dans le mail depuis votre ordinateur \u{1F642}" })
      ] }) : null;
    };
    tourMobileBanner_default = TourMobileBanner;
  }
});

// src/effects/page.js
import { getPageFromSummary, getPagesFromSummary as getPagesFromSummary2 } from "@lls/superkit";
import { displayUser as displayUser3, isPageOwner as isPageOwner2 } from "@lls/utils";
import _95 from "lodash/fp.js";
var savePage, createScratchPage, searchPage, deletePage, sharePage, sharePageToGroup, updateAppreciationPage, addCorrectionsToUsers2, fetchPage, addCorrectionsToUsersEffect, savePageEffect, createScratchPageEffect, searchPageEffect, deletePageEffect, sharePageEffect, sharePageToGroupEffect, updateAppreciationPageEffect, fetchPageEffect;
var init_page2 = __esm({
  "src/effects/page.js"() {
    "use strict";
    init_actions();
    init_analytics();
    init_revision();
    init_page();
    init_screen();
    init_constants();
    init_route();
    init_utils3();
    savePage = async ({ dispatch, history, params: { page, title, token, currentUser, background = false } }) => {
      const isUpdating = !(page == null ? void 0 : page.isOriginal) && isPageOwner2(page, currentUser);
      if (_95.getOr(false, "isTeacher", currentUser)) dispatch(setShownContextualActions(false));
      const pageToSave = {
        ...page,
        title: title || _95.get("title", page),
        parent: isUpdating ? _95.get("parent", page) : _95.get("id", page),
        bookId: _95.get("isStudent", currentUser) && (page == null ? void 0 : page.isCreatedFromScratch) ? _95.get("book", page) : void 0
      };
      const methodToUse = isUpdating ? updatePageApi : createPageApi;
      const { entities: entities2, result } = await methodToUse({
        token,
        page: pageToSave
      }).catch((err) => {
        dispatch(setShownContextualActions(true));
        throw err;
      });
      const originalPageId = _95.get("id", page);
      const cleanedEntities = _95.flow(
        _95.set(`pages.${originalPageId}.isDraft`, false),
        _95.set(`pages.${originalPageId}.shouldRender`, true)
      )(entities2);
      dispatch(setEntities(cleanedEntities));
      const savedPageId = _95.flow(_95.get("viewer"), _95.values, _95.first)(result);
      if ((page == null ? void 0 : page.isWorkplan) && !isUpdating) {
        const options = _95.flow(
          _95.get("workplans.0.options"),
          _95.map(_95.pick(["uuid", "time", "difficulty", "modalities"]))
        )(page);
        !_95.isEmpty(options) && saveWorkplanCardsOptions({
          pageId: savedPageId,
          options,
          token
        });
      }
      !background && history.push(getPath("page", { pageId: savedPageId }));
      !isUpdating && dispatch(deleteEntity({ path: `drafts.${_95.get("id", page)}` }));
      !background && triggerNotification({
        name: "success",
        params: { title: "Page sauvegard\xE9e !" },
        dispatch
      });
      return savedPageId;
    };
    createScratchPage = async ({ dispatch, history, params: { page: iPage, title, token, bookId } }) => {
      const { id: fakeId, ...pageProps } = iPage;
      const page = {
        ...pageProps,
        title,
        isCreatedFromScratch: true,
        hasNewDesign: true,
        valid: true,
        bookId
      };
      const { entities: entities2, result } = await createPageApi({
        token,
        page
      });
      dispatch(setEntities(entities2));
      const savedPageId = _95.flow(_95.get("viewer"), _95.values, _95.first)(result);
      history.push(getPath("page", { pageId: savedPageId }));
      dispatch(deleteEntity({ path: `drafts.${fakeId}` }));
      triggerNotification({
        name: "success",
        params: { title: "Page sauvegard\xE9e !" },
        dispatch
      });
      return savedPageId;
    };
    searchPage = async ({
      dispatch,
      history,
      params: {
        isLicensedBook,
        teaserMode,
        book,
        modifiedPages,
        searchValue,
        currentUser,
        isBookBrowsingMode = false,
        changeBrowsingModalPage
      }
    }) => {
      const filteredPage = getPageFromSummary({ summary: _95.get("summary", book), searchValue, modifiedPages, currentUser });
      if (!_95.isEmpty(filteredPage)) {
        if (teaserMode && !isLicensedBook && !filteredPage.teaser) {
          return dispatch(setModal({ name: MODAL_NOT_TEASER, open: true }));
        }
        if (isBookBrowsingMode) {
          changeBrowsingModalPage(filteredPage);
        } else {
          history.push(getPath("page", { slug: _95.get("slug", filteredPage) }));
        }
      } else if (_95.isUndefined(filteredPage)) {
        triggerNotification({
          name: "warning",
          message: "Merci de v\xE9rifier votre num\xE9ro de page. Vous pouvez aussi chercher directement dans le sommaire.",
          params: { title: "Cette page n'existe pas" },
          dispatch
        });
      }
    };
    deletePage = async ({ dispatch, history, params: { page, token, book } }) => {
      await deletePageApi({
        token,
        page
      });
      const slugToRedirect = _95.flow(
        _95.get("summary"),
        getPagesFromSummary2,
        _95.find({ id: page.originalPage }),
        _95.get("slug")
      )(book);
      switch (true) {
        case !!slugToRedirect:
          history.push(getPath("page", { slug: slugToRedirect }));
          break;
        case (page == null ? void 0 : page.isCreatedFromScratch):
          history.push(getPath("book", _95.pick(["uri", "slug"], book)));
          break;
        default:
          history.push(getPath("page", { pageId: _95.get("originalPage", page) }));
          break;
      }
      dispatch(deleteEntity({ path: `pages.${_95.get("id", page)}` }));
      triggerNotification({
        name: "success",
        params: { title: "Page supprim\xE9e !" },
        dispatch
      });
    };
    sharePage = async ({ dispatch, params: { token, page, teacher, notify = false } }) => {
      const pageId = _95.get("id", page);
      const teacherId = _95.get("id", teacher);
      const { entities: entities2 } = await sharePageToUserApi({
        token,
        pageId,
        sharedUserId: teacherId
      });
      dispatch(setEntities(entities2));
      dispatch(setShownContextualActions(false));
      notify ? triggerNotification({
        name: "success",
        params: { title: "Professeur(e) notifi\xE9(e)" },
        dispatch
      }) : triggerNotification({
        name: "success",
        // @TODO normalize teacher format in lls-viewer-builder
        // teacher: { name: "M. Durand", id: 123, subject: "Français, Anglais, Physique-Chimie"}
        message: `Votre page a bien \xE9t\xE9 partag\xE9e avec ${_95.get("name", teacher)}`,
        params: { title: "Page partag\xE9e !", clarityHidden: true },
        dispatch
      });
    };
    sharePageToGroup = async ({ dispatch, params: { group, page, token } }) => {
      const pageId = _95.get("id", page);
      const groupId = _95.get("id", group);
      const { entities: entities2 } = await sharePageToGroupApi({ pageId, groupId, token });
      dispatch(setEntities(entities2));
      triggerNotification({
        name: "success",
        message: `Votre page a bien \xE9t\xE9 partag\xE9e \xE0 la classe ${_95.get("name", group)}`,
        params: { clarityHidden: true },
        dispatch
      });
    };
    updateAppreciationPage = async ({ dispatch, params: { page, copyOwner, token, input, currentUser } }) => {
      const pageId = _95.get("id", page);
      const appreciation = {
        content: input,
        teacherId: _95.get("id", currentUser)
      };
      const { entities: entities2 } = await updatePageAppreciationApi({
        pageId,
        token,
        appreciation
      });
      const updatedPage = _95.get(["pages", pageId], entities2);
      dispatch(
        updateEntity({
          path: ["sharedPages", pageId],
          entity: updatedPage
        })
      );
      triggerNotification({
        name: "success",
        message: `Votre appr\xE9ciation a bien \xE9t\xE9 partag\xE9e avec ${displayUser3(copyOwner, {
          inlined: true
        })}.`,
        params: { clarityHidden: true },
        dispatch
      });
    };
    addCorrectionsToUsers2 = async ({
      dispatch,
      history,
      params: { token, parentId, studentIds, corrections, sharedPages }
    }) => {
      const studentPages = _95.map((page) => {
        return {
          pageId: page.id,
          userId: page.user
        };
      }, sharedPages);
      const { entities: entities2 } = await addCorrectionsToUsers({
        token,
        studentIds,
        corrections,
        studentPages
      });
      const sharedCorrections = _95.get(`pages.${parentId}.sharedCorrections`, entities2);
      const updatedSharedPages = _95.map(_95.set("sharedCorrections", sharedCorrections), sharedPages);
      dispatch(setEntities({ ...entities2, sharedPages: _95.keyBy("id", updatedSharedPages) }));
      triggerNotification({
        name: "success",
        message: "Les corrig\xE9s sont partag\xE9s avec les \xE9l\xE8ves s\xE9lectionn\xE9s",
        params: { title: "Corrections partag\xE9es" },
        dispatch
      });
      history.push(getPath("copies", { parentId }));
    };
    fetchPage = async ({ dispatch, params: { slug, token, useCache } } = {}) => {
      const { entities: entities2 } = await fetchPageScreen({ slug, token, useCache });
      dispatch(setEntities(entities2));
    };
    addCorrectionsToUsersEffect = ({ dispatch, history, params }) => {
      tryCatch({ dispatch, params, history, effect: addCorrectionsToUsers2 });
    };
    savePageEffect = ({ dispatch, history, params }) => tryCatch({ dispatch, history, effect: savePage, params });
    createScratchPageEffect = ({ dispatch, history, params }) => tryCatch({
      dispatch,
      history,
      effect: createScratchPage,
      params
    });
    searchPageEffect = ({ dispatch, history, params }) => tryCatch({ dispatch, history, effect: searchPage, params });
    deletePageEffect = ({ dispatch, history, params }) => tryCatch({ dispatch, history, effect: deletePage, params });
    sharePageEffect = ({ dispatch, params }) => tryCatch({ dispatch, effect: sharePage, params });
    sharePageToGroupEffect = ({ dispatch, params }) => tryCatch({ dispatch, effect: sharePageToGroup, params });
    updateAppreciationPageEffect = ({ dispatch, params }) => tryCatch({ dispatch, effect: updateAppreciationPage, params });
    fetchPageEffect = ({ dispatch, params }) => tryCatch({ dispatch, effect: fetchPage, params });
  }
});

// css-modules:css-modules://aFVPa5WArHryD6fRMG9EyhTgq_NpaH-eIyPfex-7nNY.css
var init_aFVPa5WArHryD6fRMG9EyhTgq_NpaH_eIyPfex_7nNY = __esm({
  "css-modules:css-modules://aFVPa5WArHryD6fRMG9EyhTgq_NpaH-eIyPfex-7nNY.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_book_index.module.css
var src_components_book_index_default;
var init_src_components_book_index = __esm({
  "tmp_esbuild1736180049684/_src_components_book_index.module.css"() {
    "use strict";
    init_aFVPa5WArHryD6fRMG9EyhTgq_NpaH_eIyPfex_7nNY();
    src_components_book_index_default = { "bookContainer": "core-Q8wMFq-bookContainer", "pagesSection": "core-Q8wMFq-pagesSection", "appointmentBooking": "core-Q8wMFq-appointmentBooking", "bookElements": "core-Q8wMFq-bookElements", "book": "core-Q8wMFq-book" };
  }
});

// src/components/book/index.module.css
var init_book4 = __esm({
  "src/components/book/index.module.css"() {
    "use strict";
    init_src_components_book_index();
  }
});

// src/components/book/index.jsx
import {
  getAuth as getAuth10,
  getContact as getContact3,
  useSearchChapters as useSearchChapters5,
  useSearchPages as useSearchPages8,
  useSearchPremiumResources,
  useSearchResources,
  useSearchSubjects as useSearchSubjects4
} from "@lls/store";
import { getCollection as getCollection3 } from "@lls/store";
import { getBook as getBook2 } from "@lls/store";
import { getSchool as getSchool3 } from "@lls/store";
import {
  AppointmentBooking,
  BookHeader,
  BookPremiumResources,
  BookToolbar,
  ClassicEpubLink,
  ClassicResourcesLink,
  CommunityContactHelp as CommunityContactHelp2
} from "@lls/superkit";
import { ANALYTICS_LINK_CLICKED as ANALYTICS_LINK_CLICKED7, dispatchAnalyticsEvent as dispatchAnalyticsEvent25, openWindow as openWindow16 } from "@lls/utils";
import _96 from "lodash/fp.js";
import { useCallback as useCallback37 } from "react";
import { useDispatch as useDispatch28, useSelector as useSelector45 } from "react-redux";
import { useHistory as useHistory19 } from "react-router-dom";
import { Fragment as Fragment22, jsx as jsx98, jsxs as jsxs69 } from "react/jsx-runtime";
var TeacherBookElements, StudentBookElements, Book, book_default;
var init_book5 = __esm({
  "src/components/book/index.jsx"() {
    "use strict";
    init_actions();
    init_myExercises();
    init_myPages2();
    init_mySharedPages2();
    init_news2();
    init_pageHistory2();
    init_resources2();
    init_studentTracking2();
    init_tips2();
    init_tourMobileBanner2();
    init_analytics4();
    init_tour2();
    init_page2();
    init_withRouterProvider();
    init_useCustomEffect();
    init_useTour();
    init_route();
    init_constants();
    init_book4();
    TeacherBookElements = ({
      book,
      modifiedPages,
      currentUser,
      isDrawerOpen,
      resources,
      chapters,
      onCreateCustomPage,
      history,
      pages
    }) => {
      var _a2;
      const { sendEvent: sendEvent2 } = useTour_default();
      const premiumResources = useSearchPremiumResources({ bookIds: [book == null ? void 0 : book.id] });
      const contact = useSelector45((state) => {
        var _a3;
        return getContact3(state, ((_a3 = currentUser == null ? void 0 : currentUser.contacts) == null ? void 0 : _a3[0]) ?? null);
      });
      const school = useSelector45((state) => {
        var _a3;
        return getSchool3(state, ((_a3 = currentUser == null ? void 0 : currentUser.schools) == null ? void 0 : _a3[0]) ?? null);
      });
      const subjects = useSearchSubjects4({ ids: (currentUser == null ? void 0 : currentUser.subjects) ?? [] });
      const isOffline = (_a2 = useAppData()) == null ? void 0 : _a2.isOffline;
      return /* @__PURE__ */ jsxs69(Fragment22, { children: [
        /* @__PURE__ */ jsxs69("div", { className: src_components_book_index_default.bookElements, "data-margin": +_96.flow(_96.get("contacts"), _96.isEmpty)(currentUser), children: [
          /* @__PURE__ */ jsxs69("div", { className: src_components_book_index_default.pagesSection, "data-drawer-open": +isDrawerOpen, children: [
            /* @__PURE__ */ jsx98(pageHistory_default, { currentUser, book }),
            (book == null ? void 0 : book.isClassic) ? /* @__PURE__ */ jsx98(ClassicEpubLink, { book, width: "50%", epubLink: getPath("external_epub", { uri: book == null ? void 0 : book.uri }) }) : /* @__PURE__ */ jsx98(
              myPages_default,
              {
                modifiedPages,
                book,
                onCreateCustomPage,
                isOffline
              }
            )
          ] }),
          (book == null ? void 0 : book.isClassic) ? /* @__PURE__ */ jsx98(
            ClassicResourcesLink,
            {
              book,
              isDrawerOpen,
              resourceUrl: getPath("classic-ressources", { uri: book == null ? void 0 : book.uri, query: { at_medium: "premium" } })
            }
          ) : !_96.isEmpty(premiumResources) && /* @__PURE__ */ jsx98(
            BookPremiumResources,
            {
              onResourceClick: ({ url }) => {
                dispatchAnalyticsEvent25(ANALYTICS_EVENTS.LINK_CLICKED, {
                  featureName: "actualisation_resource",
                  resourceId: [url]
                });
                _96.startsWith("http", url) ? openWindow16(url, "_blank") : history.push(url);
              },
              onCategoryClick: ({ title }) => {
                sendEvent2(TOUR_EVENTS.OPEN_RENEWAL_CATEGORY);
                dispatchAnalyticsEvent25(ANALYTICS_EVENTS.LINK_CLICKED, {
                  featureName: "actualisation_card",
                  resourceId: [title]
                });
              },
              premiumResources
            }
          ),
          /* @__PURE__ */ jsx98(news_default, { book, isDrawerOpen }),
          _96.isEmpty(resources) ? /* @__PURE__ */ jsx98(tips_default, { currentUser, isDrawerOpen }) : /* @__PURE__ */ jsx98(resources_default, { book, resources, chapters, pages })
        ] }),
        /* @__PURE__ */ jsx98(AppointmentBooking, { className: src_components_book_index_default.appointmentBooking }),
        /* @__PURE__ */ jsx98(
          CommunityContactHelp2,
          {
            contact,
            subjects,
            school,
            isTrial: currentUser == null ? void 0 : currentUser.isTrial,
            isDrawerOpen,
            firstContactNameIcon: "Emmanuelle",
            secondContactNameIcon: "Dylan",
            displayChatButton: true
          }
        )
      ] });
    };
    StudentBookElements = ({ currentUser, book, modifiedPages, isDrawerOpen, resources, chapters }) => /* @__PURE__ */ jsxs69("div", { className: src_components_book_index_default.bookElements, "data-margin": 1, children: [
      /* @__PURE__ */ jsxs69("div", { className: src_components_book_index_default.pagesSection, "data-drawer-open": +isDrawerOpen, children: [
        /* @__PURE__ */ jsx98(pageHistory_default, { currentUser, book }),
        (book == null ? void 0 : book.isClassic) ? /* @__PURE__ */ jsx98(ClassicEpubLink, { book, width: "50%", epubLink: getPath("external_epub", { uri: book == null ? void 0 : book.uri }) }) : /* @__PURE__ */ jsx98(mySharedPages_default, { book })
      ] }),
      /* @__PURE__ */ jsx98(myExercises_default, { book, modifiedPages }),
      (book == null ? void 0 : book.isClassic) && /* @__PURE__ */ jsx98(
        ClassicResourcesLink,
        {
          book,
          isDrawerOpen,
          resourceUrl: getPath("classic-ressources", { uri: book == null ? void 0 : book.uri, query: { at_medium: "premium" } })
        }
      ),
      _96.isEmpty(resources) ? /* @__PURE__ */ jsx98(tips_default, { currentUser, isDrawerOpen }) : /* @__PURE__ */ jsx98(resources_default, { book, resources, chapters })
    ] });
    Book = ({ book, drawer, modifiedPages, currentUser, groups, students, isShownStudentTracking }) => {
      const history = useHistory19();
      const isTeacher = _96.get("isTeacher", currentUser);
      const isDrawerOpen = _96.get("isDrawerOpen", drawer);
      const collection = useSelector45((state) => getCollection3(state, _96.get("collection", book)));
      const auth2 = useSelector45(getAuth10);
      const token = auth2 == null ? void 0 : auth2.token;
      const { teaserMode, licensedBookIds = currentUser == null ? void 0 : currentUser.booksV2 } = useAppData();
      const dispatch = useDispatch28();
      const isLicensedBook = _96.includes(book == null ? void 0 : book.id, licensedBookIds);
      const searchPageEffectFn = useCustomEffect_default(searchPageEffect);
      const onSearchPage = useCallback37(
        (value) => {
          searchPageEffectFn({
            modifiedPages,
            book,
            currentUser,
            searchValue: value,
            isBookBrowsingMode: false,
            teaserMode,
            isLicensedBook
          });
        },
        [modifiedPages, book, currentUser, searchPageEffectFn, teaserMode, isLicensedBook]
      );
      const workbook = useSelector45((state) => getBook2(state, _96.get("workbooks.0", book)));
      const textbook = useSelector45((state) => getBook2(state, _96.get("textbooks.0", book)));
      const workplan = useSelector45((state) => getBook2(state, _96.get("workplans.0", book)));
      const onGoTo2 = useCallback37(
        ({ href, target }) => {
          if (target === "_blank") openWindow16(href, target);
          else history.push(href);
        },
        [history]
      );
      const pages = useSearchPages8({ bookIds: [_96.get("id", book)] });
      const chapters = useSearchChapters5({ bookIds: [_96.get("id", book)] });
      const resources = useSearchResources({ chapterIds: _96.map("id", chapters) });
      const onCreateCustomPage = () => {
        history.push(getPath("page-creation", { ...book, originType: "page" }));
      };
      const bookElementsProps = {
        book,
        currentUser,
        modifiedPages,
        isDrawerOpen,
        chapters,
        resources,
        pages
      };
      const bookElementsPropsForTeacher = {
        ...bookElementsProps,
        groups,
        students,
        onCreateCustomPage,
        history
      };
      const bookHeaderProps = {
        book,
        collection,
        currentUser,
        isDrawerOpen,
        workbook: _96.includes(workbook == null ? void 0 : workbook.id, licensedBookIds) ? workbook : void 0,
        textbook: _96.includes(textbook == null ? void 0 : textbook.id, licensedBookIds) ? textbook : void 0,
        workplan: _96.includes(workplan == null ? void 0 : workplan.id, licensedBookIds) ? workplan : void 0,
        onSearchSubmit: onSearchPage,
        onTeacherBookClick: () => {
          dispatchAnalyticsEvent25(ANALYTICS_LINK_CLICKED7, {
            featureName: "LDP",
            extraData: "LDP_ouverture_premium"
          });
          dispatch(setModal({ open: true, name: MODAL_TEACHER_BOOK_DETAIL, data: { book, token } }));
        },
        onGoTo: onGoTo2,
        navLinks: {
          participateLink: getPath("join_community", { query: { medium: "book" } }),
          textbookLink: getPath("book", _96.pick(["slug", "uri"], textbook)),
          workbookLink: getPath("book", _96.pick(["slug", "uri"], workbook)),
          teacherBookLink: getPath("teacher_book", { bookUri: _96.get("uri", book) }),
          workplanLink: getPath("book", _96.pick(["slug", "uri"], workplan))
        }
      };
      return /* @__PURE__ */ jsx98(Fragment22, { children: /* @__PURE__ */ jsxs69("div", { className: src_components_book_index_default.book, children: [
        /* @__PURE__ */ jsx98(BookToolbar, { drawer }),
        /* @__PURE__ */ jsx98(tourMobileBanner_default, {}),
        /* @__PURE__ */ jsxs69("div", { className: src_components_book_index_default.bookContainer, children: [
          /* @__PURE__ */ jsx98(BookHeader, { ...bookHeaderProps, renewalLabel: book == null ? void 0 : book.renewalLabel }),
          isShownStudentTracking ? /* @__PURE__ */ jsx98(
            studentTracking_default,
            {
              book,
              groups,
              students,
              currentUser,
              modifiedPages
            }
          ) : /* @__PURE__ */ jsx98(Fragment22, { children: isTeacher ? /* @__PURE__ */ jsx98(TeacherBookElements, { ...bookElementsPropsForTeacher }) : /* @__PURE__ */ jsx98(StudentBookElements, { ...bookElementsProps }) })
        ] })
      ] }) });
    };
    book_default = Book;
  }
});

// css-modules:css-modules://akDM7Cd-00ZIVYQqGLq453vCvV0OvU4P0S5zFbo00Oo.css
var init_akDM7Cd_00ZIVYQqGLq453vCvV0OvU4P0S5zFbo00Oo = __esm({
  "css-modules:css-modules://akDM7Cd-00ZIVYQqGLq453vCvV0OvU4P0S5zFbo00Oo.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_common_viewerContainers.module.css
var src_components_common_viewerContainers_default;
var init_src_components_common_viewerContainers = __esm({
  "tmp_esbuild1736180049684/_src_components_common_viewerContainers.module.css"() {
    "use strict";
    init_akDM7Cd_00ZIVYQqGLq453vCvV0OvU4P0S5zFbo00Oo();
    src_components_common_viewerContainers_default = { "container": "core-UyEE4q-container", "viewerWrapperMargin": "core-UyEE4q-viewerWrapperMargin", "viewerWrapper": "core-UyEE4q-viewerWrapper" };
  }
});

// src/components/common/viewerContainers.module.css
var init_viewerContainers = __esm({
  "src/components/common/viewerContainers.module.css"() {
    "use strict";
    init_src_components_common_viewerContainers();
  }
});

// src/components/common/viewerContainers.jsx
import { Z_PRESENTATION_MODE } from "@lls/lls-kit";
import { cx as cx6, makeComponent as makeComponent6 } from "@lls/utils";
import { jsx as jsx99 } from "react/jsx-runtime";
var VIEWER_WRAPPER_MAX_WIDTH, StyledViewerWrapper, StyledContainer, StyledViewerWrapperMargin;
var init_viewerContainers2 = __esm({
  "src/components/common/viewerContainers.jsx"() {
    "use strict";
    init_ui3();
    init_viewerContainers();
    VIEWER_WRAPPER_MAX_WIDTH = 1250;
    StyledViewerWrapper = makeComponent6("div", src_components_common_viewerContainers_default.viewerWrapper);
    StyledContainer = ({ className, style, ...props }) => /* @__PURE__ */ jsx99(
      "div",
      {
        className: cx6(className, src_components_common_viewerContainers_default.container),
        style: {
          "--cr-toolbar-height": `${NAVBAR_HEIGHT}px`,
          "--cr-z-presentation-mode": Z_PRESENTATION_MODE,
          "--cr-viewer-wrapper-max-width": `${VIEWER_WRAPPER_MAX_WIDTH}px`,
          ...style
        },
        ...props
      }
    );
    StyledViewerWrapperMargin = makeComponent6("div", src_components_common_viewerContainers_default.viewerWrapperMargin);
  }
});

// css-modules:css-modules://4piAmN9JBLsDwcp15PmPMaFGaw1Q-9j4YHUUouM0jTc.css
var init_piAmN9JBLsDwcp15PmPMaFGaw1Q_9j4YHUUouM0jTc = __esm({
  "css-modules:css-modules://4piAmN9JBLsDwcp15PmPMaFGaw1Q-9j4YHUUouM0jTc.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_page_notReachable_pageEmpty.module.css
var src_components_page_notReachable_pageEmpty_default;
var init_src_components_page_notReachable_pageEmpty = __esm({
  "tmp_esbuild1736180049684/_src_components_page_notReachable_pageEmpty.module.css"() {
    "use strict";
    init_piAmN9JBLsDwcp15PmPMaFGaw1Q_9j4YHUUouM0jTc();
    src_components_page_notReachable_pageEmpty_default = { "pageEmptyTitle": "core-Jr4LCG-pageEmptyTitle latoWebBold", "pageEmpty": "core-Jr4LCG-pageEmpty" };
  }
});

// src/components/page/notReachable/pageEmpty.module.css
var init_pageEmpty = __esm({
  "src/components/page/notReachable/pageEmpty.module.css"() {
    "use strict";
    init_src_components_page_notReachable_pageEmpty();
  }
});

// src/components/page/notReachable/pageEmpty.jsx
import { Button as Button35 } from "@lls/lls-kit";
import { useHistory as useHistory20 } from "react-router-dom";
import { jsx as jsx100, jsxs as jsxs70 } from "react/jsx-runtime";
var PageEmpty, pageEmpty_default;
var init_pageEmpty2 = __esm({
  "src/components/page/notReachable/pageEmpty.jsx"() {
    "use strict";
    init_route();
    init_pageEmpty();
    PageEmpty = () => {
      const history = useHistory20();
      return /* @__PURE__ */ jsxs70("div", { className: src_components_page_notReachable_pageEmpty_default.pageEmpty, children: [
        /* @__PURE__ */ jsx100("h4", { className: src_components_page_notReachable_pageEmpty_default.pageEmptyTitle, children: "Oups cette page n'est pas disponible pour le moment." }),
        /* @__PURE__ */ jsx100(Button35, { onClick: goBack({ history }), children: "Revenir \xE0 la page pr\xE9c\xE9dente" })
      ] });
    };
    pageEmpty_default = PageEmpty;
  }
});

// css-modules:css-modules://ml6KvsNk4cKlb2yEH30AOdNbV6mvNV403u2DNEyxp9E.css
var init_ml6KvsNk4cKlb2yEH30AOdNbV6mvNV403u2DNEyxp9E = __esm({
  "css-modules:css-modules://ml6KvsNk4cKlb2yEH30AOdNbV6mvNV403u2DNEyxp9E.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_page_notReachable_pageInvalid.module.css
var src_components_page_notReachable_pageInvalid_default;
var init_src_components_page_notReachable_pageInvalid = __esm({
  "tmp_esbuild1736180049684/_src_components_page_notReachable_pageInvalid.module.css"() {
    "use strict";
    init_ml6KvsNk4cKlb2yEH30AOdNbV6mvNV403u2DNEyxp9E();
    src_components_page_notReachable_pageInvalid_default = { "pageInvalid": "core-aGc_8W-pageInvalid", "pageInvalidTitle": "core-aGc_8W-pageInvalidTitle latoWebBold" };
  }
});

// src/components/page/notReachable/pageInvalid.module.css
var init_pageInvalid = __esm({
  "src/components/page/notReachable/pageInvalid.module.css"() {
    "use strict";
    init_src_components_page_notReachable_pageInvalid();
  }
});

// src/components/page/notReachable/pageInvalid.jsx
import { jsx as jsx101, jsxs as jsxs71 } from "react/jsx-runtime";
var PageInvalid, pageInvalid_default;
var init_pageInvalid2 = __esm({
  "src/components/page/notReachable/pageInvalid.jsx"() {
    "use strict";
    init_pageInvalid();
    PageInvalid = () => {
      return /* @__PURE__ */ jsxs71("div", { className: src_components_page_notReachable_pageInvalid_default.pageInvalid, children: [
        /* @__PURE__ */ jsx101("h4", { className: src_components_page_notReachable_pageInvalid_default.pageInvalidTitle, children: "Oups cette page n'est pas disponible pour le moment." }),
        /* @__PURE__ */ jsx101("div", { children: "Nos \xE9quipes sont \xE0 pied d'\u0153uvre pour finaliser la mise en ligne de ce contenu. Il sera tr\xE8s prochainement accessible en ligne." })
      ] });
    };
    pageInvalid_default = PageInvalid;
  }
});

// css-modules:css-modules://xBkeKJdK7Yixmt9paSWO41WBtl5dw4R627SRo5e0LhY.css
var init_xBkeKJdK7Yixmt9paSWO41WBtl5dw4R627SRo5e0LhY = __esm({
  "css-modules:css-modules://xBkeKJdK7Yixmt9paSWO41WBtl5dw4R627SRo5e0LhY.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_page_notReachable_pageMessage.module.css
var src_components_page_notReachable_pageMessage_default;
var init_src_components_page_notReachable_pageMessage = __esm({
  "tmp_esbuild1736180049684/_src_components_page_notReachable_pageMessage.module.css"() {
    "use strict";
    init_xBkeKJdK7Yixmt9paSWO41WBtl5dw4R627SRo5e0LhY();
    src_components_page_notReachable_pageMessage_default = { "h1": "core-CgYz3q-h1", "notValidMessage": "core-CgYz3q-notValidMessage", "h3": "core-CgYz3q-h3" };
  }
});

// src/components/page/notReachable/pageMessage.module.css
var init_pageMessage = __esm({
  "src/components/page/notReachable/pageMessage.module.css"() {
    "use strict";
    init_src_components_page_notReachable_pageMessage();
  }
});

// src/components/page/notReachable/pageMessage.jsx
import { Icon as Icon9 } from "@lls/lls-kit";
import { jsx as jsx102, jsxs as jsxs72 } from "react/jsx-runtime";
var PageMessage, pageMessage_default;
var init_pageMessage2 = __esm({
  "src/components/page/notReachable/pageMessage.jsx"() {
    "use strict";
    init_pageMessage();
    PageMessage = ({ title, message, icon }) => /* @__PURE__ */ jsxs72("div", { className: src_components_page_notReachable_pageMessage_default.notValidMessage, children: [
      icon && /* @__PURE__ */ jsx102(Icon9, { name: icon }),
      /* @__PURE__ */ jsx102("h1", { className: src_components_page_notReachable_pageMessage_default.h1, children: title }),
      /* @__PURE__ */ jsx102("h3", { className: src_components_page_notReachable_pageMessage_default.h3, children: message })
    ] });
    pageMessage_default = PageMessage;
  }
});

// src/utils/page.js
import { hasAccessToInvalidPage as hasAccessToInvalidPage2 } from "@lls/utils";
var shouldDisplayInvalidPage;
var init_page3 = __esm({
  "src/utils/page.js"() {
    "use strict";
    shouldDisplayInvalidPage = ({ screenReady, book, chapter, page, user }) => Boolean(screenReady && (!(page == null ? void 0 : page.valid) || !(book == null ? void 0 : book.valid) || !(page == null ? void 0 : page.isCreatedFromScratch) && !(chapter == null ? void 0 : chapter.valid))) && !hasAccessToInvalidPage2(user);
  }
});

// css-modules:css-modules://zpWCrgG--sgEJ8oDEyfaMGggu2_odvMEFsKgcy1lsG8.css
var init_zpWCrgG_sgEJ8oDEyfaMGggu2_odvMEFsKgcy1lsG8 = __esm({
  "css-modules:css-modules://zpWCrgG--sgEJ8oDEyfaMGggu2_odvMEFsKgcy1lsG8.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_page_notReachable_index.module.css
var src_components_page_notReachable_index_default;
var init_src_components_page_notReachable_index = __esm({
  "tmp_esbuild1736180049684/_src_components_page_notReachable_index.module.css"() {
    "use strict";
    init_zpWCrgG_sgEJ8oDEyfaMGggu2_odvMEFsKgcy1lsG8();
    src_components_page_notReachable_index_default = { "container": "core-ZgMHqG-container" };
  }
});

// src/components/page/notReachable/index.module.css
var init_notReachable = __esm({
  "src/components/page/notReachable/index.module.css"() {
    "use strict";
    init_src_components_page_notReachable_index();
  }
});

// src/components/page/notReachable/index.jsx
import _97 from "lodash/fp.js";
import { useHistory as useHistory21 } from "react-router-dom";
import { Button as Button36 } from "@lls/lls-kit";
import { jsx as jsx103, jsxs as jsxs73 } from "react/jsx-runtime";
var BackToBookPageButton, WithNotReachable, notReachable_default;
var init_notReachable2 = __esm({
  "src/components/page/notReachable/index.jsx"() {
    "use strict";
    init_pageEmpty2();
    init_pageInvalid2();
    init_pageMessage2();
    init_ui3();
    init_withRouterProvider();
    init_page3();
    init_route();
    init_notReachable();
    BackToBookPageButton = ({ book }) => {
      const history = useHistory21();
      const onClick = () => {
        history.push(getPath("book", { uri: book == null ? void 0 : book.uri }));
      };
      return (book == null ? void 0 : book.uri) && /* @__PURE__ */ jsx103(Button36, { onClick, children: "Revenir au manuel" });
    };
    WithNotReachable = ({ screenReady, page, book, chapter, user, children }) => {
      const isPageEmpty = screenReady && _97.isEmpty(page == null ? void 0 : page.children) && _97.isNil(page == null ? void 0 : page.contentMd);
      const isSession = page == null ? void 0 : page.isPartOfSession;
      const { isOffline } = useAppData();
      switch (true) {
        case (isOffline && (isPageEmpty || isSession)):
          return /* @__PURE__ */ jsx103(
            pageMessage_default,
            {
              title: "Page non disponible",
              icon: "wifislash",
              message: isSession ? "Vous devez disposer d'une connexion internet pour acc\xE9der aux exercices de r\xE9vision." : "Veuillez vous connecter \xE0 internet ou t\xE9l\xE9charger le manuel afin d'acc\xE9der \xE0 ce contenu hors connexion."
            }
          );
        case isPageEmpty:
          return /* @__PURE__ */ jsxs73("div", { className: src_components_page_notReachable_index_default.container, style: { "--cr-navbar-height": `${NAVBAR_HEIGHT}px` }, children: [
            /* @__PURE__ */ jsx103(pageEmpty_default, {}),
            /* @__PURE__ */ jsx103(BackToBookPageButton, { book })
          ] });
        case shouldDisplayInvalidPage({ screenReady, book, chapter, page, user }):
          return /* @__PURE__ */ jsxs73("div", { className: src_components_page_notReachable_index_default.container, style: { "--cr-navbar-height": `${NAVBAR_HEIGHT}px` }, children: [
            /* @__PURE__ */ jsx103(pageInvalid_default, {}),
            /* @__PURE__ */ jsx103(BackToBookPageButton, { book })
          ] });
        default:
          return children;
      }
    };
    notReachable_default = WithNotReachable;
  }
});

// src/hooks/useShare.js
import { getTeachersDisplayList, orderTeachersBySubjectId, shouldShowSaveModal } from "@lls/utils";
import _98 from "lodash/fp.js";
import { useCallback as useCallback38, useEffect as useEffect28, useMemo as useMemo19, useState as useState23 } from "react";
import { useDispatch as useDispatch29, useSelector as useSelector46 } from "react-redux";
import { useHistory as useHistory22 } from "react-router-dom";
var useShare, useShare_default;
var init_useShare = __esm({
  "src/hooks/useShare.js"() {
    "use strict";
    init_actions();
    init_constants();
    init_tour2();
    init_trial2();
    init_page2();
    init_trial3();
    init_useCustomEffect();
    init_useTour();
    init_ui2();
    init_route();
    useShare = ({
      page,
      book,
      token,
      currentUser,
      teachers,
      subjects,
      groups,
      isBookBrowsingMode = false,
      isCreatingPage = false,
      tabId
    }) => {
      const history = useHistory22();
      const dispatch = useDispatch29();
      const createScratchPageEffectFn = useCustomEffect_default(createScratchPageEffect);
      const savePageEffectFn = useCustomEffect_default(savePageEffect);
      const sharePageEffectFn = useCustomEffect_default(sharePageEffect);
      const deletePageEffectFn = useCustomEffect_default(deletePageEffect);
      const forceSaveModalToOpen = useSelector46(getUiIsOpenSaveModal);
      const sharePageToGroupEffectFn = useCustomEffect_default(sharePageToGroupEffect);
      const { sendEvent: sendEvent2 } = useTour_default();
      const [isShareModalOpen, setIsShareModalOpen] = useState23(false);
      const [pickerMode, setPickerMode] = useState23(isBookBrowsingMode);
      const bookId = _98.get("id", book);
      const onDisabledFeatureClick = useCustomEffect_default(openDisabledModalEffect);
      useEffect28(() => {
        return history.listen((_167, action) => {
          if (action === "POP") {
            setIsShareModalOpen(false);
          }
        });
      }, [history]);
      const onSave = useCallback38(
        async (title) => {
          if (currentUser == null ? void 0 : currentUser.isTrial) return onDisabledFeatureClick({ featureName: MODAL_SAVE_PAGE });
          if (isCreatingPage) {
            return await createScratchPageEffectFn({ page, title, token, bookId });
          }
          return await savePageEffectFn({ title, page, token, currentUser });
        },
        [
          page,
          savePageEffectFn,
          token,
          currentUser,
          isCreatingPage,
          bookId,
          createScratchPageEffectFn,
          onDisabledFeatureClick
        ]
      );
      const shouldDisplaySaveModal = shouldShowSaveModal({ page, user: currentUser, isCreatingPage });
      const onOpenSaveModalEvent = useCallback38(
        (_event, defaultBehavior, isRenaming = false) => {
          sendEvent2(TOUR_EVENTS.OPEN_SAVE_MODAL);
          if (shouldDisplaySaveModal || isRenaming) {
            defaultBehavior();
          } else {
            onSave();
          }
          dispatch(setIsOpenSaveModal(false));
        },
        [shouldDisplaySaveModal, onSave, dispatch, sendEvent2]
      );
      const onDeleteButtonClick = useCallback38((_event, defaultBehavior) => {
        defaultBehavior();
      }, []);
      const onDelete = useCallback38(async () => {
        await deletePageEffectFn({ book, page, token });
      }, [book, page, deletePageEffectFn, token]);
      const onShareButtonClick = useCallback38(
        async (_event, defaultBehavior) => {
          if (currentUser == null ? void 0 : currentUser.isTrial)
            return dispatch(setModal({ name: MODAL_TRIAL_TIP, data: { tip: SHARE_TRIAL_TIP }, open: true }));
          if (page == null ? void 0 : page.isDraft) {
            await savePageEffectFn({
              page,
              token,
              currentUser
            });
          }
          defaultBehavior();
        },
        [savePageEffectFn, page, token, currentUser, dispatch]
      );
      const onSelectClick = useCallback38(() => {
        setPickerMode(true);
      }, []);
      const onManageGroupClick = useCallback38(() => history.push(getPath("classroom_settings")), [history]);
      const onShare = useCallback38(
        async (teacher) => {
          const notify = _98.includes(teacher.id, page.sharedUsers);
          if (page == null ? void 0 : page.isDraft) {
            await savePageEffectFn({
              page,
              token,
              currentUser
            });
          }
          await sharePageEffectFn({ page, teacher, token, notify });
        },
        [savePageEffectFn, sharePageEffectFn, page, currentUser, token]
      );
      const onShareGroup = useCallback38(
        async (group) => {
          await sharePageToGroupEffectFn({ page, group, token });
        },
        [page, sharePageToGroupEffectFn, token]
      );
      const subjectId = _98.get("subjects.0", book);
      const teachersListMemo = useMemo19(
        () => _98.flow(
          (teachers2) => orderTeachersBySubjectId(teachers2, subjectId),
          (teachers2) => getTeachersDisplayList(teachers2, subjects)
        )(teachers),
        [teachers, subjectId, subjects]
      );
      const sharedGroupIds = _98.get("sharedGroups", page);
      const sharedGroups = useMemo19(
        () => _98.filter((group) => _98.includes(_98.get("id", group), sharedGroupIds), groups),
        [sharedGroupIds, groups]
      );
      const sharedUser = _98.find({ id: _98.get("sharedTeacher", page) }, teachersListMemo);
      const teachersList = !sharedUser ? teachersListMemo : void 0;
      return useMemo19(
        () => ({
          currentUser,
          page,
          onOpenSaveModalEvent,
          onSave,
          onDeleteButtonClick,
          onDelete,
          onShareButtonClick,
          onSelectClick,
          pickerMode,
          setPickerMode,
          onShare,
          onShareGroup,
          teachersList,
          groups,
          sharedUser,
          isShareModalOpen,
          setIsShareModalOpen,
          sharedGroups,
          onManageGroupClick,
          forceSaveModalToOpen,
          tabId
        }),
        [
          currentUser,
          page,
          onOpenSaveModalEvent,
          onSave,
          onDeleteButtonClick,
          onDelete,
          onShareButtonClick,
          onSelectClick,
          pickerMode,
          onShare,
          onShareGroup,
          teachersList,
          groups,
          sharedUser,
          isShareModalOpen,
          sharedGroups,
          onManageGroupClick,
          forceSaveModalToOpen,
          tabId
        ]
      );
    };
    useShare_default = useShare;
  }
});

// src/utils/drawer.js
import _99 from "lodash/fp.js";
var shouldHideDrawer;
var init_drawer = __esm({
  "src/utils/drawer.js"() {
    "use strict";
    shouldHideDrawer = (toolbar) => Boolean(_99.get("isCreatingPage", toolbar));
  }
});

// src/constants/scroll.js
var VIEWER_SCROLL_OFFSET;
var init_scroll = __esm({
  "src/constants/scroll.js"() {
    "use strict";
    VIEWER_SCROLL_OFFSET = -170;
  }
});

// src/hooks/useViewer.js
import { getPagePath as getPagePath6, getQueryParams as getQueryParams6, isAcademicEnabled } from "@lls/utils";
import _100 from "lodash/fp.js";
import { useCallback as useCallback39, useEffect as useEffect29, useState as useState24 } from "react";
import { useDispatch as useDispatch30 } from "react-redux";
import { useHistory as useHistory23, useLocation as useLocation16, useParams } from "react-router-dom";
var useViewer, useViewer_default;
var init_useViewer = __esm({
  "src/hooks/useViewer.js"() {
    "use strict";
    init_actions();
    init_constants();
    init_tour2();
    init_trial2();
    init_trial3();
    init_viewer();
    init_useTour();
    init_route();
    useViewer = ({
      book,
      currentUser,
      page,
      makePath = getPagePath6,
      bookPages,
      token,
      toolbar = {},
      isWorkplanStudentTask
    }) => {
      const { sendEvent: sendEvent2, tourId } = useTour_default();
      const isInsideSession = page == null ? void 0 : page.isPartOfSession;
      const setFullscreenHtml = _100.getOr(_100.noop, "viewerProps.setFullscreenHtml", toolbar);
      const [rightResponsesDocumentIds, setRightResponsesDocumentIds] = useState24([]);
      const dispatch = useDispatch30();
      const history = useHistory23();
      const queryParams = getQueryParams6(useLocation16());
      const pageId = _100.get("id", page);
      const slug = _100.get("slug", page);
      const isDraft = _100.get("isDraft", page);
      const groupId = _100.get("groupId", queryParams);
      const studentId = _100.flow(_100.get("studentId"), _100.parseInt(10))(useParams());
      const goTo = _100.get("goTo", queryParams) || _100.get("goto", queryParams);
      const taskId = _100.get("taskId", queryParams);
      const { uuids: filterShowResponsesDocumentIds, correctedUuids: customCorrections } = _100.flow(
        _100.get("sharedCorrections"),
        _100.orderBy("updatedAt", "desc"),
        _100.getOr({}, 0)
      )(page);
      useEffect29(() => {
        _100.noop(pageId);
        setRightResponsesDocumentIds([]);
      }, [pageId]);
      const setTaskId = useCallback39(
        (taskId2) => {
          const path = isWorkplanStudentTask ? getPath("book", { ..._100.pick(["slug", "uri"], book), taskId: taskId2, groupId }) : makePath({ slug }, { isDraft, taskId: taskId2 });
          history.push(path);
        },
        [history, isDraft, slug, makePath, book, groupId, isWorkplanStudentTask]
      );
      const onOpenAnswersCb = useCallback39(
        ({ hasRightResponses, nextRightResponsesDocumentIds }) => {
          sendEvent2(TOUR_EVENTS.OPEN_ANSWERS);
          if (!_100.get("id", book)) return;
          if (hasRightResponses && isAcademicEnabled(currentUser) || !_100.isEmpty(filterShowResponsesDocumentIds)) {
            setRightResponsesDocumentIds(nextRightResponsesDocumentIds);
            return;
          }
          if (currentUser == null ? void 0 : currentUser.isTrial) {
            return openDisabledModalEffect({ dispatch, params: { featureName: MODAL_CORRECTION } });
          }
          dispatch(
            setModal({
              name: MODAL_OPEN_ANSWERS,
              open: true,
              data: { bookUri: _100.get("uri", book) }
            })
          );
        },
        [dispatch, book, currentUser, filterShowResponsesDocumentIds, sendEvent2]
      );
      const presentationProps = toolbar.presentationProps;
      const onGoToCb = useCallback39(
        (data) => {
          onGoToEffect({
            dispatch,
            history,
            params: { data, pages: bookPages, user: currentUser, currentPage: page, token, makePath, presentationProps }
          });
        },
        [dispatch, bookPages, history, page, currentUser, token, makePath, presentationProps]
      );
      const onOpenFullscreenCb = useCallback39(
        (params) => {
          setFullscreenHtml(_100.get("html", params));
          const path = isWorkplanStudentTask ? getWorkplanStudentPagePath({ slug }, { studentId, docId: _100.get("doc.uuid", params), taskId, groupId }) : makePath({ slug }, { docId: _100.get("doc.uuid", params), isDraft, taskId });
          history.push(path);
        },
        [makePath, history, setFullscreenHtml, slug, isDraft, taskId, groupId, studentId, isWorkplanStudentTask]
      );
      return {
        isInsideSession,
        onOpenAnswersCb,
        rightResponsesDocumentIds,
        filterShowResponsesDocumentIds,
        customCorrections,
        onGoToCb,
        onOpenFullscreenCb,
        goTo,
        taskId,
        setTaskId,
        isInTour: !!tourId
      };
    };
    useViewer_default = useViewer;
  }
});

// src/utils/dom.js
var interop;
var init_dom = __esm({
  "src/utils/dom.js"() {
    "use strict";
    interop = (key) => (m) => ({ default: m[key] || m.default[key] });
  }
});

// css-modules:css-modules://rQAF6G9v9i1s1R0J34Bvb7cNGRuxECcLYwEc5amKYmg.css
var init_rQAF6G9v9i1s1R0J34Bvb7cNGRuxECcLYwEc5amKYmg = __esm({
  "css-modules:css-modules://rQAF6G9v9i1s1R0J34Bvb7cNGRuxECcLYwEc5amKYmg.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_page_lightEditor.module.css
var src_components_page_lightEditor_default;
var init_src_components_page_lightEditor = __esm({
  "tmp_esbuild1736180049684/_src_components_page_lightEditor.module.css"() {
    "use strict";
    init_rQAF6G9v9i1s1R0J34Bvb7cNGRuxECcLYwEc5amKYmg();
    src_components_page_lightEditor_default = { "editorContainer": "core-P_L_hG-editorContainer" };
  }
});

// src/components/page/lightEditor.module.css
var init_lightEditor = __esm({
  "src/components/page/lightEditor.module.css"() {
    "use strict";
    init_src_components_page_lightEditor();
  }
});

// src/components/page/lightEditor.tsx
import {
  LIGHT_EDITOR_ONCHANGE_EDIT_LAYOUT_CONTEXT,
  LIGHT_EDITOR_ONCHANGE_TEXT_CONTEXT,
  formatWorkplanCardsOptions,
  updateTemplateWithWorkplanOptions
} from "@lls/viewer/staticImports";
import React9, { Suspense as Suspense3, useCallback as useCallback40, useRef as useRef15, useEffect as useEffect30, useState as useState25, useMemo as useMemo20 } from "react";
import { useDispatch as useDispatch31 } from "react-redux";
import { useHistory as useHistory24 } from "react-router-dom";
import { Snackbar as Snackbar2 } from "@lls/lls-kit";
import { getCustomizationDraftFromTemplate } from "@lls/utils";
import _101 from "lodash/fp.js";
import { Fragment as Fragment23, jsx as jsx104, jsxs as jsxs74 } from "react/jsx-runtime";
var LazyLightEditor, WrappedLightEditor, lightEditor_default;
var init_lightEditor2 = __esm({
  "src/components/page/lightEditor.tsx"() {
    "use strict";
    init_constants();
    init_scroll();
    init_trial2();
    init_ui3();
    init_trial3();
    init_viewer();
    init_withRouterProvider();
    init_useCustomEffect();
    init_useTour();
    init_useViewer();
    init_cookie();
    init_dom();
    init_es62();
    init_lightEditor();
    LazyLightEditor = React9.lazy(() => import("@lls/viewer").then(interop("LightEditor")));
    WrappedLightEditor = ({
      page,
      isHidden = false,
      isOffline,
      bookPages,
      token,
      clientFetch: clientFetch2,
      currentUser,
      subHeaderComponent,
      topBarComponent,
      toolbar,
      book,
      goTo: goToFromProps,
      keepMountedUuids,
      onResourceButtonClick,
      isAICreationButtonEnabled,
      onAICreationButtonClick,
      wasSsrRendered,
      viewerRef,
      isWorkplanStudentTask = false,
      viewerReady,
      hideEnhancedFeatures,
      renewalDisplayed,
      setRenewalDisplayed,
      onCopyDocUrl,
      routeReady,
      tabId,
      setTabId
    }) => {
      var _a2, _b2;
      const dispatch = useDispatch31();
      const history = useHistory24();
      const [cookies, setCookie] = useCookies([COOKIE_LIGHTEDITOR_WARNING, COOKIE_RENEWAL_ORIGINAl_WARNING_DISABLED]);
      const {
        onOpenAnswersCb,
        rightResponsesDocumentIds,
        onGoToCb,
        onOpenFullscreenCb,
        goTo,
        taskId,
        setTaskId,
        isInTour
      } = useViewer_default({
        book,
        currentUser,
        page,
        bookPages,
        token,
        toolbar,
        isWorkplanStudentTask
      });
      const pageId = page == null ? void 0 : page.id;
      const lastPageId = useRef15(void 0);
      lastPageId.current = pageId;
      const warningCookie = _101.get(COOKIE_LIGHTEDITOR_WARNING, cookies);
      const hasDisabledOriginalWarning = (cookies == null ? void 0 : cookies[COOKIE_RENEWAL_ORIGINAl_WARNING_DISABLED]) === "true";
      const [showLightEditWarningSnackBar, setShowLightEditWarningSnackBar] = useState25(false);
      useEffect30(() => {
        if (warningCookie) return;
        const isElementEditable = (container) => {
          if (!container) return false;
          if (container.contentEditable === "true" || container.contentEditable === "false") {
            return container.contentEditable === "true";
          }
          return !!container.parentNode && isElementEditable(container.parentNode);
        };
        const onSelectionChange = () => {
          const selection = window.getSelection();
          viewerReady && setShowLightEditWarningSnackBar(isElementEditable(selection == null ? void 0 : selection.anchorNode));
        };
        document.addEventListener("selectionchange", onSelectionChange);
        return () => {
          document.removeEventListener("selectionchange", onSelectionChange);
        };
      }, [viewerReady, warningCookie]);
      const onLightEditWarningSnackBarClose = (days) => {
        setShowLightEditWarningSnackBar(false);
        setCookie(COOKIE_LIGHTEDITOR_WARNING, "true", getCookieOptions(days));
      };
      const onRenewalWarningSnackbarClose = (days) => {
        setCookie(COOKIE_RENEWAL_ORIGINAl_WARNING_DISABLED, "true", getCookieOptions(days));
      };
      const [workplanCardsOptions, setWorkplanCardsOptions] = useState25({});
      const onChange = useCallback40(
        (template2, ctx) => {
          let formattedWorkplanCardOptions;
          switch (true) {
            case lastPageId.current !== template2.id:
              return;
            case (page == null ? void 0 : page.isWorkplan):
              formattedWorkplanCardOptions = formatWorkplanCardsOptions({ workplanCardsOptions, ctx });
              setWorkplanCardsOptions(formattedWorkplanCardOptions);
              onTemplateChangeEffect({
                dispatch,
                history,
                params: {
                  template: getCustomizationDraftFromTemplate({ template: template2 }),
                  ctx,
                  token,
                  currentUser,
                  workplanCardsOptions: formattedWorkplanCardOptions
                }
              });
              break;
            case _101.get("source", ctx) === "exercise": {
              onTemplateChangeEffect({ dispatch, history, params: { template: template2, ctx, token, currentUser } });
              onTemplateChangeEffect({
                dispatch,
                history,
                params: {
                  template: getCustomizationDraftFromTemplate({ template: template2, shouldRender: false }),
                  currentUser
                }
              });
              break;
            }
            // @ts-ignore: TODO, fix bug ?
            case LIGHT_EDITOR_ONCHANGE_TEXT_CONTEXT === ctx:
              onTemplateChangeEffect({
                dispatch,
                history,
                params: {
                  template: getCustomizationDraftFromTemplate({ template: template2, shouldRender: false }),
                  currentUser
                }
              });
              break;
            // @ts-ignore: TODO, fix bug ?
            case LIGHT_EDITOR_ONCHANGE_EDIT_LAYOUT_CONTEXT === ctx:
              _101.debounce(1e3, () => {
                onTemplateChangeEffect({
                  dispatch,
                  history,
                  params: { template: getCustomizationDraftFromTemplate({ template: template2 }), currentUser }
                });
              })();
              break;
            default:
              onTemplateChangeEffect({
                dispatch,
                history,
                params: { template: getCustomizationDraftFromTemplate({ template: template2 }), currentUser }
              });
          }
        },
        [dispatch, history, token, page, workplanCardsOptions, currentUser]
      );
      const onRenewalToggleClick = useCallback40(() => {
        setRenewalDisplayed((old) => !old);
      }, [setRenewalDisplayed]);
      const isPresentationMode = (_a2 = toolbar == null ? void 0 : toolbar.presentationProps) == null ? void 0 : _a2.isPresentationMode;
      const template = useMemo20(() => {
        return (page == null ? void 0 : page.isWorkplan) ? updateTemplateWithWorkplanOptions(page) : page;
      }, [page]);
      const isTouchable = (_b2 = useAppData()) == null ? void 0 : _b2.isTouchable;
      const { sendEvent: sendEvent2, tourId } = useTour_default();
      const onDisabledFeatureClickFn = useCustomEffect_default(openDisabledModalEffect);
      const onDisabledFeatureClick = useCallback40(() => {
        onDisabledFeatureClickFn({ featureName: MODAL_PROJECTION });
      }, [onDisabledFeatureClickFn]);
      return /* @__PURE__ */ jsxs74(Fragment23, { children: [
        /* @__PURE__ */ jsx104("div", { className: src_components_page_lightEditor_default.editorContainer, "data-hidden": +isHidden, "data-ispresentation": +isPresentationMode, children: /* @__PURE__ */ jsx104(Suspense3, { children: /* @__PURE__ */ jsx104(
          LazyLightEditor,
          {
            goTo: goToFromProps || goTo,
            onGoTo: onGoToCb,
            isTouchable,
            onOpenAnswers: onOpenAnswersCb,
            template,
            onChange,
            onOpenFullscreen: onOpenFullscreenCb,
            scrollOffset: isPresentationMode ? 0 : VIEWER_SCROLL_OFFSET,
            presentationProps: toolbar == null ? void 0 : toolbar.presentationProps,
            rightResponsesDocumentIds,
            user: currentUser,
            topBarComponent,
            sessionStatsTab: true,
            isWorkplanStudentTask,
            setDocId: setTaskId,
            docId: taskId,
            subHeaderComponent,
            clientFetch: clientFetch2,
            keepMountedUuids,
            onCopyDocUrl,
            onResourceButtonClick,
            isAICreationButtonEnabled,
            onAICreationButtonClick,
            wasSsrRendered,
            presentationToolbarHeight: PRESENTATION_TOOLBAR_HEIGHT,
            ref: viewerRef,
            enableRenewal: true,
            mep010_addWorkplanTask: true,
            isOffline,
            renewalDisplayed,
            onRenewalToggleClick,
            hideEnhancedFeatures,
            isInTour,
            routeReady,
            tabId,
            setTabId,
            sendTourEvent: sendEvent2,
            onDisabledFeatureClick,
            ...toolbar.viewerProps,
            ...toolbar.ttsProps
          }
        ) }) }),
        showLightEditWarningSnackBar && !warningCookie && process.env.CORE_PERSO_SNACKBAR !== "0" && !tourId && /* @__PURE__ */ jsx104(
          Snackbar2,
          {
            autoHide: null,
            open: showLightEditWarningSnackBar,
            title: "Personnalisez cette page sans inqui\xE9tude !",
            message: "Vous pouvez modifier cette page sans risque, vous aurez toujours acc\xE8s \xE0 la page originale du manuel, et vos \xE9l\xE8ves aussi.",
            action: {
              text: "J'ai compris",
              cb: () => onLightEditWarningSnackBarClose(365)
            },
            secondAction: {
              text: "Me le rappeler",
              cb: () => onLightEditWarningSnackBarClose(0.5)
            }
          }
        ),
        !renewalDisplayed && (currentUser == null ? void 0 : currentUser.isTeacher) && !hasDisabledOriginalWarning && /* @__PURE__ */ jsx104(
          Snackbar2,
          {
            open: !renewalDisplayed,
            autoHide: 1e4,
            severity: "warning",
            title: "Vous avez choisi d'afficher la version du manuel papier",
            message: `Pour que vos \xE9l\xE8ves voient le m\xEAme contenu que vous, demandez-leur de cliquer sur "Afficher la version d'origine".'`,
            action: {
              text: "J'ai compris",
              cb: () => onRenewalWarningSnackbarClose(180)
            }
          }
        )
      ] });
    };
    lightEditor_default = WrappedLightEditor;
  }
});

// css-modules:css-modules://2kBJpuyBJ9Q2T1KnJZOeM-6cnQixcfFzNgcPAExPCu8.css
var init_kBJpuyBJ9Q2T1KnJZOeM_6cnQixcfFzNgcPAExPCu8 = __esm({
  "css-modules:css-modules://2kBJpuyBJ9Q2T1KnJZOeM-6cnQixcfFzNgcPAExPCu8.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_page_picker.module.css
var src_components_page_picker_default;
var init_src_components_page_picker = __esm({
  "tmp_esbuild1736180049684/_src_components_page_picker.module.css"() {
    "use strict";
    init_kBJpuyBJ9Q2T1KnJZOeM_6cnQixcfFzNgcPAExPCu8();
    src_components_page_picker_default = { "pickerContainer": "core-EstRsq-pickerContainer" };
  }
});

// src/components/page/picker.module.css
var init_picker = __esm({
  "src/components/page/picker.module.css"() {
    "use strict";
    init_src_components_page_picker();
  }
});

// src/components/page/picker.jsx
import { ShareBar } from "@lls/superkit";
import React10, { useState as useState26, useCallback as useCallback41, Suspense as Suspense4 } from "react";
import { mergePageAndPickedTemplate } from "@lls/utils";
import _102 from "lodash/fp.js";
import { jsx as jsx105, jsxs as jsxs75 } from "react/jsx-runtime";
var LazyPicker, WrappedPicker, picker_default;
var init_picker2 = __esm({
  "src/components/page/picker.jsx"() {
    "use strict";
    init_page2();
    init_useCustomEffect();
    init_useTour();
    init_dom();
    init_picker();
    LazyPicker = React10.lazy(() => import("@lls/viewer").then(interop("Picker")));
    WrappedPicker = ({
      page,
      isLoading = false,
      toolbar,
      shareProps = {},
      currentUser,
      token,
      onChange = _102.noop,
      isBookBrowsingMode,
      wasSsrRendered,
      viewerRef,
      ...props
    }) => {
      const [pickedTemplate, setPickedTemplate] = useState26();
      const setPickerMode = _102.get("setPickerMode", shareProps);
      const savePageEffectFn = useCustomEffect_default(savePageEffect);
      const handleChange = useCallback41(
        (newPickedTemplate) => {
          setPickedTemplate(newPickedTemplate);
          onChange(newPickedTemplate);
        },
        [onChange]
      );
      const onShareClick = useCallback41(() => {
        savePageEffectFn({ page: mergePageAndPickedTemplate(page, pickedTemplate), token, currentUser });
        setPickerMode(false);
      }, [savePageEffectFn, pickedTemplate, setPickerMode, page, currentUser, token]);
      const { sendEvent: sendEvent2 } = useTour_default();
      return /* @__PURE__ */ jsxs75("div", { className: src_components_page_picker_default.pickerContainer, "data-is-loading": +isLoading, children: [
        /* @__PURE__ */ jsx105(Suspense4, { children: /* @__PURE__ */ jsx105(
          LazyPicker,
          {
            ref: viewerRef,
            template: page,
            pickedTemplate,
            onChange: handleChange,
            wasSsrRendered,
            screenMode: isBookBrowsingMode ? "grid-xs" : void 0,
            enableRenewal: true,
            sendTourEvent: sendEvent2,
            ...toolbar.viewerProps,
            ...props
          }
        ) }),
        !isBookBrowsingMode && /* @__PURE__ */ jsx105(
          ShareBar,
          {
            isShown: !_102.isEmpty(pickedTemplate == null ? void 0 : pickedTemplate.children),
            onShareClick,
            isShareButtonDisabled: false,
            shareProps
          }
        )
      ] });
    };
    picker_default = WrappedPicker;
  }
});

// css-modules:css-modules://iFd2WHLP2SrbSc6IHUWmSfVMX0Vu0nY7GuPiALQHiIA.css
var init_iFd2WHLP2SrbSc6IHUWmSfVMX0Vu0nY7GuPiALQHiIA = __esm({
  "css-modules:css-modules://iFd2WHLP2SrbSc6IHUWmSfVMX0Vu0nY7GuPiALQHiIA.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_page_viewer.module.css
var src_components_page_viewer_default;
var init_src_components_page_viewer = __esm({
  "tmp_esbuild1736180049684/_src_components_page_viewer.module.css"() {
    "use strict";
    init_iFd2WHLP2SrbSc6IHUWmSfVMX0Vu0nY7GuPiALQHiIA();
    src_components_page_viewer_default = { "viewerContainer": "core-hOripa-viewerContainer" };
  }
});

// src/components/page/viewer.module.css
var init_viewer2 = __esm({
  "src/components/page/viewer.module.css"() {
    "use strict";
    init_src_components_page_viewer();
  }
});

// src/components/page/viewer.jsx
import { ANALYTICS_LINK_CLICKED as ANALYTICS_LINK_CLICKED8, dispatchAnalyticsEvent as dispatchAnalyticsEvent26 } from "@lls/utils";
import { getAnsweredOnlyTemplate } from "@lls/viewer/staticImports";
import _103 from "lodash/fp.js";
import React11, { Suspense as Suspense5, memo, useCallback as useCallback42, useMemo as useMemo21 } from "react";
import { useDispatch as useDispatch32 } from "react-redux";
import { useHistory as useHistory25 } from "react-router-dom";
import { jsx as jsx106 } from "react/jsx-runtime";
var LazyViewer, WrappedViewer, viewer_default;
var init_viewer3 = __esm({
  "src/components/page/viewer.jsx"() {
    "use strict";
    init_actions();
    init_constants();
    init_scroll();
    init_ui3();
    init_viewer();
    init_withRouterProvider();
    init_useViewer();
    init_dom();
    init_viewer2();
    LazyViewer = React11.lazy(() => import("@lls/viewer").then(interop("Viewer")));
    WrappedViewer = ({
      page,
      isHidden = false,
      book,
      areStudentResponsesShown = false,
      bookPages,
      token,
      clientFetch: clientFetch2,
      currentUser,
      subHeaderComponent,
      makePath,
      onlyFullscreenCard,
      areQuestionsDisabled = false,
      toolbar,
      /*drawer,*/
      topBarComponent,
      goTo: goToFromProps,
      keepMountedUuids,
      forceShowAnswerButton,
      shouldRecordChanges = true,
      wasSsrRendered,
      viewerRef,
      isWorkplanStudentTask = false,
      readonly,
      onConnect,
      onCopyDocUrl,
      renewalDisplayed = true,
      setRenewalDisplayed = _103.noop,
      hideEnhancedFeatures = false,
      tabId,
      setTabId,
      routeReady,
      isRevisionPage
    }) => {
      var _a2, _b2;
      const dispatch = useDispatch32();
      const history = useHistory25();
      const {
        onOpenAnswersCb,
        rightResponsesDocumentIds,
        filterShowResponsesDocumentIds,
        customCorrections,
        onGoToCb,
        onOpenFullscreenCb,
        goTo,
        taskId,
        setTaskId
      } = useViewer_default({ book, currentUser, page, makePath, bookPages, toolbar, isWorkplanStudentTask });
      const onChangeCb = useCallback42(
        (template2, ctx) => {
          onTemplateChangeEffect({
            dispatch,
            history,
            params: { template: template2, ctx, token, currentUser, readonly }
          });
        },
        [dispatch, token, currentUser, history, readonly]
      );
      const onTeacherBookClick = useCallback42(() => {
        dispatchAnalyticsEvent26(ANALYTICS_LINK_CLICKED8, {
          featureName: "LDP",
          extraData: "LDP_page_premium"
        });
        dispatch(setModal({ name: MODAL_TEACHER_BOOK_DETAIL, open: true }));
      }, [dispatch]);
      const onRenewalToggleClick = useCallback42(() => {
        setRenewalDisplayed((old) => !old);
      }, [setRenewalDisplayed]);
      const template = useMemo21(() => {
        return areStudentResponsesShown ? getAnsweredOnlyTemplate(page) : page;
      }, [page, areStudentResponsesShown]);
      const isPresentationMode = (_a2 = toolbar == null ? void 0 : toolbar.presentationProps) == null ? void 0 : _a2.isPresentationMode;
      const isTouchable = (_b2 = useAppData()) == null ? void 0 : _b2.isTouchable;
      return /* @__PURE__ */ jsx106("div", { className: src_components_page_viewer_default.viewerContainer, "data-hidden": +isHidden, "data-ispresentation": +isPresentationMode, children: /* @__PURE__ */ jsx106(Suspense5, { children: /* @__PURE__ */ jsx106(
        LazyViewer,
        {
          ref: viewerRef,
          goTo: goToFromProps || goTo,
          template,
          isTouchable,
          onGoTo: onGoToCb,
          onChange: shouldRecordChanges ? onChangeCb : _103.noop,
          onOpenAnswers: onOpenAnswersCb,
          onOpenFullscreen: onOpenFullscreenCb,
          scrollOffset: isPresentationMode ? 0 : VIEWER_SCROLL_OFFSET,
          rightResponsesDocumentIds,
          user: currentUser,
          subHeaderComponent,
          onlyFullscreenCard,
          areQuestionsDisabled,
          clientFetch: clientFetch2,
          keepMountedUuids,
          forceShowAnswerButton,
          filterShowResponsesDocumentIds,
          customCorrections,
          setDocId: setTaskId,
          docId: taskId,
          wasSsrRendered,
          isWorkplanStudentTask,
          routeReady,
          ...toolbar.viewerProps,
          ...toolbar.ttsProps,
          presentationProps: toolbar == null ? void 0 : toolbar.presentationProps,
          presentationToolbarHeight: readonly ? READONLY_BANNER_HEIGHT : PRESENTATION_TOOLBAR_HEIGHT,
          topBarComponent,
          onTeacherBookClick: !(book == null ? void 0 : book.isWorkbook) && (book == null ? void 0 : book.uri) ? onTeacherBookClick : void 0,
          readonly,
          onConnect,
          onCopyDocUrl,
          hideEnhancedFeatures,
          tabId,
          setTabId,
          renewalDisplayed,
          onRenewalToggleClick,
          isRevisionPage,
          enableRenewal: true
        }
      ) }) });
    };
    viewer_default = memo(WrappedViewer);
  }
});

// src/api/assets.ts
import _104 from "lodash/fp.js";
var clientFetch, clientFetchCallback;
var init_assets = __esm({
  "src/api/assets.ts"() {
    "use strict";
    init_axios();
    init_rest();
    clientFetch = async ({
      body,
      path = "custom/pages",
      query = { rename: true },
      responseType,
      token,
      onUploadProgress,
      cancelToken
    }) => {
      return post(`${_104.replace(/^\//, "", path)}`, body, {
        onUploadProgress,
        cancelToken,
        token,
        responseType,
        query
      });
    };
    clientFetchCallback = async ({
      body,
      path = "custom/pages",
      query = { rename: true },
      responseType,
      onUploadStart = _104.noop,
      onUploadEnd = _104.noop,
      onUploadComplete = _104.noop,
      onUploadProgress = _104.noop,
      onUploadError = _104.noop,
      token
    }) => {
      let error;
      onUploadStart();
      const CancelToken = axios_default.CancelToken;
      const source = CancelToken.source();
      clientFetch({
        body,
        path,
        query,
        responseType,
        onUploadProgress,
        cancelToken: source.token,
        token
      }).then((res) => {
        return onUploadComplete(_104.getOr(res, "url", res));
      }).catch((e) => {
        console.error(e);
        error = e;
        onUploadError(e);
      }).finally(() => {
        !error && onUploadEnd();
      });
      return { source };
    };
  }
});

// css-modules:css-modules://S031TDvbwFEPsQIpbnqTMrb2kuCfXxxY_CEBIeIijgM.css
var init_S031TDvbwFEPsQIpbnqTMrb2kuCfXxxY_CEBIeIijgM = __esm({
  "css-modules:css-modules://S031TDvbwFEPsQIpbnqTMrb2kuCfXxxY_CEBIeIijgM.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_page_session.module.css
var src_components_page_session_default;
var init_src_components_page_session = __esm({
  "tmp_esbuild1736180049684/_src_components_page_session.module.css"() {
    "use strict";
    init_S031TDvbwFEPsQIpbnqTMrb2kuCfXxxY_CEBIeIijgM();
    src_components_page_session_default = { "wrapper": "core-Z2KPOG-wrapper" };
  }
});

// src/components/page/session.module.css
var init_session = __esm({
  "src/components/page/session.module.css"() {
    "use strict";
    init_src_components_page_session();
  }
});

// src/components/page/session.jsx
import React12, { Suspense as Suspense6, useCallback as useCallback43, useState as useState27, useRef as useRef16, useEffect as useEffect31, useMemo as useMemo22 } from "react";
import { useSearchPages as useSearchPages9, useSearchStudents } from "@lls/store";
import { useSearchGroups } from "@lls/store";
import {
  SESSION_EXERCISE_TAB as SESSION_EXERCISE_TAB2,
  SESSION_STATS_TAB as SESSION_STATS_TAB2,
  SESSION_STATS_TEACHER_TAB as SESSION_STATS_TEACHER_TAB2,
  Session as VBSession,
  getTabs
} from "@lls/superkit";
import { extractOldDaLessonId, useAnalyticsEventEnhancer } from "@lls/utils";
import _105 from "lodash/fp.js";
import { useDispatch as useDispatch33, useSelector as useSelector47 } from "react-redux";
import { useHistory as useHistory26 } from "react-router-dom";
import { jsx as jsx107 } from "react/jsx-runtime";
var LazyViewer2, Session, session_default;
var init_session2 = __esm({
  "src/components/page/session.jsx"() {
    "use strict";
    init_constants();
    init_tour2();
    init_stats2();
    init_viewer();
    init_useTour();
    init_useViewer();
    init_loading3();
    init_ui2();
    init_dom();
    init_route();
    init_session();
    LazyViewer2 = React12.lazy(() => import("@lls/viewer").then(interop("Viewer")));
    Session = ({ page, currentUser: iCurrentUser, token, bookSubject, toolbar = {}, drawer = {}, viewerRef }) => {
      var _a2;
      const isStudentViewActivated = useSelector47(getUiIsStudentViewActivated);
      const currentUser = useMemo22(
        () => isStudentViewActivated ? { ...iCurrentUser, isTeacher: false, isStudent: true } : iCurrentUser,
        [iCurrentUser, isStudentViewActivated]
      );
      const dispatch = useDispatch33();
      const history = useHistory26();
      const { sendEvent: sendEvent2, tourStep, tourId } = useTour_default();
      useAnalyticsEventEnhancer({ pageId: _105.get("id", page) });
      const oldLessonId = extractOldDaLessonId(page);
      const daPage = (_a2 = useSearchPages9({ oldLessonIds: [oldLessonId], isOriginal: true })) == null ? void 0 : _a2[0];
      const [stats, setStats] = useState27();
      const [selectedTab, setSelectedTab] = useState27(
        tourId === SESSION_TOUR && tourStep === 1 ? SESSION_EXERCISE_TAB2 : void 0
      );
      const [isSessionEnded, setIsSessionEnded] = useState27(false);
      const [score, setScore] = useState27(_105.getOr(0, "score", stats));
      const endSessionCtxRef = useRef16();
      const groups = useSearchGroups({ ownerIds: [_105.get("id", currentUser)] });
      const students = useSearchStudents({ ids: _105.get("students", currentUser) });
      const isLoadingTabStats = useSelector47(
        (state) => getIsLoading(state, STATS_FETCH, {
          tab: selectedTab,
          token,
          pageIds: [oldLessonId, _105.get("id", daPage)],
          ctx: endSessionCtxRef.current
        })
      );
      const isLoadingSessionEndStats = useSelector47(
        (state) => getIsLoading(state, STATS_FETCH, {
          token,
          pageIds: [oldLessonId, _105.get("id", daPage)],
          ctx: endSessionCtxRef.current
        })
      );
      const sessionTabs = useMemo22(() => getTabs(currentUser == null ? void 0 : currentUser.isTeacher), [currentUser == null ? void 0 : currentUser.isTeacher]);
      useEffect31(() => {
        if (!selectedTab) {
          if ((currentUser == null ? void 0 : currentUser.isTrial) && !tourId) {
            return setSelectedTab(isStudentViewActivated ? SESSION_STATS_TAB2 : SESSION_STATS_TEACHER_TAB2);
          }
          setSelectedTab(_105.first(sessionTabs));
        }
      }, [isStudentViewActivated, currentUser, tourId, selectedTab, sessionTabs]);
      useEffect31(() => {
        if (tourId === SESSION_TOUR) {
          if (tourStep === 1 && selectedTab === SESSION_STATS_TEACHER_TAB2) {
            return sendEvent2(TOUR_EVENTS.SESSION_TEACHER_TAB_LOADED);
          }
        }
      }, [sendEvent2, selectedTab, tourId, tourStep]);
      const onPeriodChangeCb = useCallback43(
        async (createdAfter) => {
          const pageIds = [oldLessonId, _105.get("id", daPage)];
          const stats2 = await fetchStatsEffect({
            dispatch,
            params: {
              tab: selectedTab,
              token,
              pageIds,
              ctx: endSessionCtxRef.current,
              createdAfter
            }
          });
          setStats(stats2);
        },
        [token, dispatch, selectedTab, oldLessonId, daPage]
      );
      const onOpenGroupsSettingsCb = useCallback43(() => history.push(getPath("classroom_settings")), [history]);
      const handleChange = useCallback43(
        async (template, ctx) => {
          const pageIds = [oldLessonId, _105.get("id", daPage)];
          setIsSessionEnded(_105.get("sessionEnd", ctx));
          onTemplateChangeEffect({ dispatch, history, params: { template, ctx, token, currentUser } });
          if (ctx == null ? void 0 : ctx.sessionEnd) {
            endSessionCtxRef.current = ctx;
            const stats2 = await fetchSessionEndStatsEffect({
              dispatch,
              params: { token, pageIds, ctx }
            });
            stats2 && setStats(stats2);
          }
          setScore(_105.flow(_105.get("stats.score"), _105.add)(ctx));
        },
        [dispatch, token, oldLessonId, daPage, history, currentUser]
      );
      const { isInsideSession } = useViewer_default({ page });
      useEffect31(() => {
        setScore(_105.getOr(0, "global.score", stats));
      }, [stats]);
      const reloadStats = useCallback43(async ({ oldLessonId: oldLessonId2, daPage: daPage2, selectedTab: selectedTab2, token: token2, dispatch: dispatch2 }) => {
        const pageIds = [oldLessonId2, _105.get("id", daPage2)];
        setStats(
          await fetchStatsEffect({
            dispatch: dispatch2,
            params: {
              tab: selectedTab2,
              token: token2,
              pageIds,
              ctx: endSessionCtxRef.current
            }
          })
        );
      }, []);
      useEffect31(() => {
        reloadStats({ oldLessonId, daPage, selectedTab, token, dispatch });
      }, [reloadStats, oldLessonId, daPage, selectedTab, token, dispatch]);
      return /* @__PURE__ */ jsx107("div", { className: src_components_page_session_default.wrapper, children: /* @__PURE__ */ jsx107(
        VBSession,
        {
          viewerElement: /* @__PURE__ */ jsx107(Suspense6, { children: /* @__PURE__ */ jsx107(
            LazyViewer2,
            {
              ref: viewerRef,
              template: page,
              ...toolbar.viewerProps,
              ...drawer.viewerProps,
              user: currentUser,
              isInsideSession,
              onChange: handleChange
            }
          ) }),
          user: currentUser,
          template: page,
          selectedTab,
          setSelectedTab,
          isLoadingStats: isLoadingTabStats || isLoadingSessionEndStats,
          stats,
          score,
          isSessionEnded,
          setIsSessionEnded,
          students,
          groups,
          onOpenGroupsSettings: onOpenGroupsSettingsCb,
          color: _105.get("color", bookSubject),
          onPeriodChange: onPeriodChangeCb,
          isDrawerOpen: drawer.isDrawerOpen,
          ...toolbar.accessibilityProps
        }
      ) });
    };
    session_default = Session;
  }
});

// src/components/toolbar/index.jsx
import { Toolbar } from "@lls/superkit";
import { jsx as jsx108 } from "react/jsx-runtime";
var ToolbarComponent, toolbar_default;
var init_toolbar = __esm({
  "src/components/toolbar/index.jsx"() {
    "use strict";
    init_viewerContainers2();
    init_trial2();
    init_ui3();
    init_trial3();
    init_withRouterProvider();
    init_useCustomEffect();
    init_useTour();
    ToolbarComponent = ({
      page,
      toolbar,
      drawer,
      shareProps,
      pageUser,
      currentUser,
      areShownContextualActions,
      renewalDisplayed,
      tabId
    }) => {
      const { isOffline } = useAppData();
      const { sendEvent: sendEvent2 } = useTour_default();
      const onDisabledFeatureClick = useCustomEffect_default(openDisabledModalEffect);
      return /* @__PURE__ */ jsx108(
        Toolbar,
        {
          isOffline,
          isCreatingPage: toolbar == null ? void 0 : toolbar.isCreatingPage,
          isRevisionPage: toolbar == null ? void 0 : toolbar.isRevisionPage,
          onGoBack: toolbar == null ? void 0 : toolbar.onGoBack,
          offset: NAVBAR_HEIGHT,
          maxWidth: VIEWER_WRAPPER_MAX_WIDTH,
          currentPage: page,
          onExportButtonClick: toolbar == null ? void 0 : toolbar.onExportButtonClick,
          accessibilityProps: toolbar == null ? void 0 : toolbar.accessibilityProps,
          presentationProps: toolbar == null ? void 0 : toolbar.presentationProps,
          printProps: toolbar == null ? void 0 : toolbar.printProps,
          historyProps: toolbar == null ? void 0 : toolbar.historyProps,
          drawerProps: drawer,
          shareProps,
          pageUser,
          areShownContextualActions,
          currentUser,
          renewalDisplayed,
          tabId,
          sendTourEvent: sendEvent2,
          onDisabledFeatureClick: () => onDisabledFeatureClick({ featureName: MODAL_EXPORT })
        }
      );
    };
    toolbar_default = ToolbarComponent;
  }
});

// src/components/viewerFooter.jsx
import _106 from "lodash/fp.js";
import { useCallback as useCallback44 } from "react";
import { useDispatch as useDispatch34, useSelector as useSelector48 } from "react-redux";
import { getAuth as getAuth11 } from "@lls/store";
import { getSchool as getSchool4 } from "@lls/store";
import { ReportFooter } from "@lls/superkit";
import { jsx as jsx109 } from "react/jsx-runtime";
var ViewerFooter, viewerFooter_default;
var init_viewerFooter = __esm({
  "src/components/viewerFooter.jsx"() {
    "use strict";
    init_user2();
    init_withRouterProvider();
    ViewerFooter = ({ pageId, bookId, user, isPresentationMode }) => {
      const dispatch = useDispatch34();
      const auth2 = useSelector48(getAuth11);
      const token = _106.get("token", auth2);
      const school = useSelector48((state) => getSchool4(state, _106.get("schools.0", user)));
      const { isOffline } = useAppData();
      const onSubmitReport = useCallback44(
        (payload) => {
          suggestionEmailEffect({
            dispatch,
            params: {
              ...payload,
              token,
              user,
              pageId,
              schoolRne: _106.get("rne", school),
              bookId
            }
          });
        },
        [dispatch, user, pageId, bookId, school, token]
      );
      return /* @__PURE__ */ jsx109(
        ReportFooter,
        {
          onSubmitReport,
          isFree: false,
          user,
          isPresentationMode,
          isOffline
        }
      );
    };
    viewerFooter_default = ViewerFooter;
  }
});

// src/hooks/useAvailableSoonModal.js
import _107 from "lodash/fp.js";
import { useCallback as useCallback45 } from "react";
import { useDispatch as useDispatch35 } from "react-redux";
var useAvailableSoonModal, useAvailableSoonModal_default;
var init_useAvailableSoonModal = __esm({
  "src/hooks/useAvailableSoonModal.js"() {
    "use strict";
    init_actions();
    init_constants();
    useAvailableSoonModal = () => {
      const dispatch = useDispatch35();
      return useCallback45(
        (e) => {
          dispatch(setModal({ name: MODAL_AVAILABLE_SOON, open: true }));
          _107.invoke("preventDefault", e);
        },
        [dispatch]
      );
    };
    useAvailableSoonModal_default = useAvailableSoonModal;
  }
});

// src/hooks/useContextualActions.js
import { shouldHideContextualActions } from "@lls/superkit";
import { usePrevious as usePrevious3 } from "@lls/utils";
import { useEffect as useEffect32 } from "react";
import { useSelector as useSelector49 } from "react-redux";
var useContextualActions, useContextualActions_default;
var init_useContextualActions = __esm({
  "src/hooks/useContextualActions.js"() {
    "use strict";
    init_actions();
    init_ui2();
    useContextualActions = ({ page, dispatch, viewerReady }) => {
      const oldPage = usePrevious3(page);
      const areShownContextualActions = useSelector49(getUiAreShownContextualActions);
      useEffect32(() => {
        if (viewerReady && (page == null ? void 0 : page.isDraft)) {
          dispatch(setShownContextualActions(true));
        }
      }, [viewerReady, page, dispatch]);
      useEffect32(() => {
        if (viewerReady && !(page == null ? void 0 : page.isDraft) && shouldHideContextualActions({ page, oldPage })) {
          dispatch(setShownContextualActions(false));
        }
      }, [viewerReady, page, oldPage, dispatch]);
      return { areShownContextualActions };
    };
    useContextualActions_default = useContextualActions;
  }
});

// src/hooks/useOnCopyDoc.js
import { copyToClipboard, getPagePath as getPagePath7, getQueryParams as getQueryParams7 } from "@lls/utils";
import _108 from "lodash/fp.js";
import { useCallback as useCallback46, useEffect as useEffect33 } from "react";
import { useDispatch as useDispatch36 } from "react-redux";
import { useLocation as useLocation17 } from "react-router-dom";
var useOnCopyDoc, useOnCopyDoc_default;
var init_useOnCopyDoc = __esm({
  "src/hooks/useOnCopyDoc.js"() {
    "use strict";
    init_config();
    init_constants();
    init_utils3();
    init_cookie();
    init_es62();
    useOnCopyDoc = ({ viewerReady, slug }) => {
      const dispatch = useDispatch36();
      const queryParams = getQueryParams7(useLocation17());
      const [cookies, setCookie] = useCookies([COOKIE_ALLOW_COPY_DOC_BUTTON]);
      const allowCopyDocButton = _108.get(COOKIE_ALLOW_COPY_DOC_BUTTON, cookies);
      const plandetravail = _108.get("plandetravail", queryParams);
      useEffect33(() => {
        const sanitized = plandetravail === "1" ? "1" : "0";
        if (viewerReady && !_108.isUndefined(plandetravail) && sanitized !== allowCopyDocButton) {
          setCookie(COOKIE_ALLOW_COPY_DOC_BUTTON, sanitized, getCookieOptions());
        }
      }, [viewerReady, plandetravail, setCookie, allowCopyDocButton]);
      const queryParamsKey = JSON.stringify(queryParams);
      const onCopyDocUrl = useCallback46(
        (uuid) => {
          const queryParams2 = JSON.parse(queryParamsKey);
          copyToClipboard(`${config_default.premium_url}${getPagePath7({ slug }, { ...queryParams2, docId: uuid })}`);
          triggerNotification({
            name: "success",
            message: "Le lien de la ressource a \xE9t\xE9 copi\xE9 dans votre presse-papier.",
            dispatch
          });
        },
        [slug, dispatch, queryParamsKey]
      );
      return allowCopyDocButton === "1" ? onCopyDocUrl : void 0;
    };
    useOnCopyDoc_default = useOnCopyDoc;
  }
});

// src/utils/viewer.js
import { isPageReachable } from "@lls/utils";
import _109 from "lodash/fp.js";
var SHOW_VIEWER, SHOW_LIGHT_EDITOR, getViewerModeToShow;
var init_viewer4 = __esm({
  "src/utils/viewer.js"() {
    "use strict";
    SHOW_VIEWER = "show_viewer";
    SHOW_LIGHT_EDITOR = "show_light_editor";
    getViewerModeToShow = ({
      page,
      currentUser,
      isRevisionPage,
      isStudentViewActivated,
      isWorkplanStudentTask
    }) => {
      switch (true) {
        case isStudentViewActivated:
        case (!(page == null ? void 0 : page.valid) && isPageReachable(page, currentUser)):
        case ((page == null ? void 0 : page.valid) && _109.get("isStudent", currentUser)):
        case isWorkplanStudentTask:
        case isRevisionPage:
          return SHOW_VIEWER;
        case ((page == null ? void 0 : page.valid) && _109.get("isTeacher", currentUser)):
          return SHOW_LIGHT_EDITOR;
        case process.env.CORE_VIEWER_READONLY === "1":
          return SHOW_VIEWER;
        default:
          return null;
      }
    };
  }
});

// css-modules:css-modules://uRfzS00lXhAWfO-O2REsQ0hrNhHSrlCq90ZdYth9t2Q.css
var init_uRfzS00lXhAWfO_O2REsQ0hrNhHSrlCq90ZdYth9t2Q = __esm({
  "css-modules:css-modules://uRfzS00lXhAWfO-O2REsQ0hrNhHSrlCq90ZdYth9t2Q.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_page_pageContent.module.css
var src_components_page_pageContent_default;
var init_src_components_page_pageContent = __esm({
  "tmp_esbuild1736180049684/_src_components_page_pageContent.module.css"() {
    "use strict";
    init_uRfzS00lXhAWfO_O2REsQ0hrNhHSrlCq90ZdYth9t2Q();
    src_components_page_pageContent_default = { "button": "core-5LcYBq-button" };
  }
});

// src/components/page/pageContent.module.css
var init_pageContent = __esm({
  "src/components/page/pageContent.module.css"() {
    "use strict";
    init_src_components_page_pageContent();
  }
});

// src/components/page/statusPage.jsx
import { SubToolbarStatusPage } from "@lls/superkit";
import _110 from "lodash/fp.js";
import { useHistory as useHistory27 } from "react-router-dom";
import { jsx as jsx110 } from "react/jsx-runtime";
var StatusPage, statusPage_default;
var init_statusPage = __esm({
  "src/components/page/statusPage.jsx"() {
    "use strict";
    init_route();
    StatusPage = ({ page, sharedPages, currentUser, teachers }) => {
      const history = useHistory27();
      const onChangePage = (pageId) => {
        history.push(getPath("page", { pageId }));
      };
      return (page == null ? void 0 : page.isWorkplan) && (currentUser == null ? void 0 : currentUser.isStudent) && !_110.isEmpty(sharedPages) ? /* @__PURE__ */ jsx110(SubToolbarStatusPage, { page, pages: sharedPages, teachers, onChangePage }) : null;
    };
    statusPage_default = StatusPage;
  }
});

// css-modules:css-modules://HlVwK7AnLKeLOjAdcdeckZFbJvYHm23LYKa3r8jO3mo.css
var init_HlVwK7AnLKeLOjAdcdeckZFbJvYHm23LYKa3r8jO3mo = __esm({
  "css-modules:css-modules://HlVwK7AnLKeLOjAdcdeckZFbJvYHm23LYKa3r8jO3mo.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_page_subHeaderViewer.module.css
var src_components_page_subHeaderViewer_default;
var init_src_components_page_subHeaderViewer = __esm({
  "tmp_esbuild1736180049684/_src_components_page_subHeaderViewer.module.css"() {
    "use strict";
    init_HlVwK7AnLKeLOjAdcdeckZFbJvYHm23LYKa3r8jO3mo();
    src_components_page_subHeaderViewer_default = { "workplansBreadcrumbContainer": "core--VJwVq-workplansBreadcrumbContainer" };
  }
});

// src/components/page/subHeaderViewer.module.css
var init_subHeaderViewer = __esm({
  "src/components/page/subHeaderViewer.module.css"() {
    "use strict";
    init_src_components_page_subHeaderViewer();
  }
});

// src/components/page/subHeaderViewer.jsx
import { AppreciationHeader, AvailableCopiesHeader, WorkplansBreadcrumb } from "@lls/superkit";
import { getQueryParams as getQueryParams8 } from "@lls/utils";
import _111 from "lodash/fp.js";
import { useCallback as useCallback47 } from "react";
import { useHistory as useHistory28, useLocation as useLocation18, useParams as useParams2 } from "react-router-dom";
import { jsx as jsx111 } from "react/jsx-runtime";
var SubHeaderViewer, subHeaderViewer_default;
var init_subHeaderViewer2 = __esm({
  "src/components/page/subHeaderViewer.jsx"() {
    "use strict";
    init_common7();
    init_route();
    init_subHeaderViewer();
    SubHeaderViewer = ({
      currentUser,
      isPageStudentOwner,
      lastAppreciation,
      page,
      taskId,
      isWorkplanStudentTask,
      teacherCorrection,
      students,
      book,
      nbAvailableCopies
    }) => {
      const queryParams = getQueryParams8(useLocation18());
      const history = useHistory28();
      const studentId = _111.flow(_111.get("studentId"), _111.parseInt(10))(useParams2());
      const slug = _111.get("slug", page);
      const groupId = _111.flow(_111.get("groupId"), parseOrUndefined(10))(queryParams);
      const onGoBack = useCallback47(() => {
        const path = isWorkplanStudentTask ? getPath("book", { ..._111.pick(["slug", "uri"], book), groupId }) : getPath("page", { slug, goTo: taskId });
        history.push(path);
      }, [history, book, groupId, isWorkplanStudentTask, slug, taskId]);
      const onChangeStudent = (studentId2) => {
        const inputSearch = groupId ? `?groupId=${groupId}&taskId=${taskId}` : `?taskId=${taskId}`;
        history.replace({
          pathname: getPath("workplan_student_page", { slug: _111.get("slug", page), studentId: studentId2 }),
          search: inputSearch
        });
      };
      const handleShowCopyClick = useCallback47(() => {
        history.push(getPath("copies", { parentId: _111.get("id", page) }));
      }, [page, history]);
      const selectedStudent = _111.find({ id: studentId }, students);
      const onPageClick = (page2 = {}) => history.push(getPath("page", { slug: page2.slug }));
      switch (true) {
        case (isPageStudentOwner && !_111.isEmpty(lastAppreciation)):
          return /* @__PURE__ */ jsx111(AppreciationHeader, { teacher: teacherCorrection, content: _111.get("content", lastAppreciation) });
        case ((page == null ? void 0 : page.isWorkplan) && !!taskId):
          return /* @__PURE__ */ jsx111("div", { className: src_components_page_subHeaderViewer_default.workplansBreadcrumbContainer, children: /* @__PURE__ */ jsx111(
            WorkplansBreadcrumb,
            {
              currentUser,
              page,
              taskId,
              onChangeStudent,
              onGoBack,
              onPageClick,
              isStudentTask: isWorkplanStudentTask,
              analyticEventsCallback: _111.noop,
              students,
              selectedStudent
            }
          ) });
        case (nbAvailableCopies > 0 && (currentUser == null ? void 0 : currentUser.isTeacher)):
          return /* @__PURE__ */ jsx111(AvailableCopiesHeader, { nbAvailableCopies, onClick: handleShowCopyClick });
        default:
          return null;
      }
    };
    subHeaderViewer_default = SubHeaderViewer;
  }
});

// src/components/page/pageContent.jsx
import { useCallback as useCallback48, useEffect as useEffect34, useMemo as useMemo23, useState as useState28 } from "react";
import { Button as Button37 } from "@lls/lls-kit";
import { PrintView } from "@lls/superkit";
import {
  dispatchAnalyticsEvent as dispatchAnalyticsEvent27,
  getPagePath as getPagePath8,
  getQueryParams as getQueryParams9,
  isPageOwner as isPageOwner3,
  shouldShowCreationPageButton,
  useWasSsrRendered
} from "@lls/utils";
import _112 from "lodash/fp.js";
import { useDispatch as useDispatch37, useSelector as useSelector50 } from "react-redux";
import { useHistory as useHistory29, useLocation as useLocation19 } from "react-router-dom";
import { getTeacher } from "@lls/store";
import { Fragment as Fragment24, jsx as jsx112, jsxs as jsxs76 } from "react/jsx-runtime";
var ViewerElement, PageContent, pageContent_default;
var init_pageContent2 = __esm({
  "src/components/page/pageContent.jsx"() {
    "use strict";
    init_analytics4();
    init_lightEditor2();
    init_picker2();
    init_viewer3();
    init_assets();
    init_notReachable2();
    init_session2();
    init_toolbar();
    init_tourMobileBanner2();
    init_viewerFooter();
    init_tour2();
    init_ui3();
    init_viewer();
    init_useAvailableSoonModal();
    init_useContextualActions();
    init_useOnCopyDoc();
    init_useTour();
    init_ui2();
    init_route();
    init_viewer4();
    init_pageContent();
    init_statusPage();
    init_subHeaderViewer2();
    ViewerElement = ({
      shareProps,
      toolbar,
      page,
      chapter,
      book,
      isRevisionPage,
      currentUser,
      viewerProps = {},
      sharedPages,
      pageUser,
      drawer,
      viewerToShow,
      screenReady,
      isBookBrowsingMode,
      onPickerChange = _112.noop,
      onResourceButtonClick,
      students,
      viewerRef,
      viewerReady,
      tabId
    }) => {
      const [aRenewalDisplayed, setRenewalDisplayed] = useState28(true);
      const renewalDisplayed = aRenewalDisplayed || !_112.some("renewalUpdatedAt", page == null ? void 0 : page.children);
      const dispatch = useDispatch37();
      const history = useHistory29();
      const pickerMode = _112.get("pickerMode", shareProps);
      const isSession = page == null ? void 0 : page.isPartOfSession;
      const nbAvailableCopies = _112.size(sharedPages);
      const presentationProps = toolbar == null ? void 0 : toolbar.presentationProps;
      const { isWorkplanStudentTask, bookPages, token } = viewerProps;
      const queryParams = getQueryParams9(useLocation19());
      const taskId = _112.get("taskId", queryParams);
      const slug = _112.get("slug", page);
      const chapterTitle = _112.get("title", chapter);
      const { sendEvent: sendEvent2 } = useTour_default();
      const handleCreateCustomPage = useCallback48(() => {
        history.push(
          getPath("page-creation", { ...book, originSlug: slug, originType: "exercice", originThematicName: chapterTitle })
        );
        sendEvent2(TOUR_EVENTS.CREATE_PAGE_BUTTON_CLICK);
      }, [book, chapterTitle, slug, history, sendEvent2]);
      const isPresentationMode = presentationProps == null ? void 0 : presentationProps.isPresentationMode;
      const withTopBarComponent = shouldShowCreationPageButton({ page, user: currentUser, isPresentationMode });
      const topBarComponent = useMemo23(() => {
        return withTopBarComponent ? /* @__PURE__ */ jsx112(
          Button37,
          {
            className: src_components_page_pageContent_default.button,
            icon: "squareandpencil",
            theme: "yellow",
            onClick: handleCreateCustomPage,
            "data-tour": "core-create-exercises-button",
            children: "Cr\xE9er ma fiche d'exercices"
          }
        ) : null;
      }, [withTopBarComponent, handleCreateCustomPage]);
      const isPageStudentOwner = isPageOwner3(page, currentUser) && _112.get("isStudent", currentUser);
      const lastAppreciation = _112.get("appreciations[0]", page);
      const teacherCorrection = useSelector50((state) => getTeacher(state, _112.get("teacherId", lastAppreciation)));
      const subHeaderComponentViewer = /* @__PURE__ */ jsx112(
        subHeaderViewer_default,
        {
          currentUser,
          isPageStudentOwner,
          lastAppreciation,
          teacherCorrection,
          book: _112.get("book", viewerProps),
          students,
          page,
          taskId,
          isWorkplanStudentTask,
          nbAvailableCopies
        }
      );
      const isPrintMode = toolbar.isPrintMode;
      const onGoToCb = useCallback48(
        (data) => {
          onGoToEffect({
            dispatch,
            history,
            params: {
              data,
              pages: bookPages,
              user: currentUser,
              currentPage: page,
              token,
              makePath: getPagePath8,
              presentationProps,
              isPrintMode
            }
          });
        },
        [dispatch, bookPages, history, page, currentUser, token, presentationProps, isPrintMode]
      );
      const onCopyDocUrl = useOnCopyDoc_default({ viewerReady, slug });
      const { areShownContextualActions } = useContextualActions_default({ dispatch, page, viewerReady });
      const wasSsrRendered = useWasSsrRendered();
      switch (true) {
        /*    case licensedBookIds &&
          !_.includes(book?.id, licensedBookIds) &&
          (page?.premium || (!page?.teaser && !originalPage?.teaser)):
          return (
            <PageMessage
              title='Contenu Bloqué.'
              message={
                !_.isEmpty(licensedBookIds)
                  ? "Vous ne pouvez pas accéder à ce contenu car le manuel n'est pas inclus dans votre licence."
                  : "Pour consulter l'entièreté du contenu, vous devez acheter le manuel entier ou posséder un abonnement."
              }
            />
          )*/
        case pickerMode:
          return /* @__PURE__ */ jsx112(
            picker_default,
            {
              ...viewerProps,
              shareProps,
              isBookBrowsingMode,
              onChange: onPickerChange,
              wasSsrRendered,
              renewalDisplayed,
              setRenewalDisplayed,
              viewerRef
            }
          );
        case isSession:
          return /* @__PURE__ */ jsxs76(Fragment24, { children: [
            /* @__PURE__ */ jsx112(
              toolbar_default,
              {
                page,
                toolbar,
                shareProps,
                pageUser,
                currentUser,
                drawer,
                areShownContextualActions,
                tabId
              }
            ),
            /* @__PURE__ */ jsx112(tourMobileBanner_default, {}),
            /* @__PURE__ */ jsx112(session_default, { ...viewerProps, viewerRef })
          ] });
        case viewerToShow === SHOW_VIEWER:
          return /* @__PURE__ */ jsxs76(Fragment24, { children: [
            /* @__PURE__ */ jsx112(
              toolbar_default,
              {
                page,
                toolbar,
                shareProps,
                pageUser,
                currentUser,
                drawer,
                renewalDisplayed,
                areShownContextualActions,
                tabId
              }
            ),
            /* @__PURE__ */ jsx112(tourMobileBanner_default, {}),
            /* @__PURE__ */ jsx112(
              statusPage_default,
              {
                page,
                sharedPages,
                currentUser,
                teachers: shareProps == null ? void 0 : shareProps.teachersList
              }
            ),
            isPrintMode && /* @__PURE__ */ jsx112(
              PrintView,
              {
                currentPage: page,
                isPresentationMode,
                presentationToolbarHeight: PRESENTATION_TOOLBAR_HEIGHT,
                onGoTo: onGoToCb
              }
            ),
            /* @__PURE__ */ jsx112(
              viewer_default,
              {
                ...viewerProps,
                isRevisionPage,
                subHeaderComponent: subHeaderComponentViewer,
                isHidden: isPrintMode,
                wasSsrRendered,
                renewalDisplayed,
                setRenewalDisplayed,
                viewerRef,
                onCopyDocUrl
              }
            )
          ] });
        case viewerToShow === SHOW_LIGHT_EDITOR:
          return /* @__PURE__ */ jsxs76(Fragment24, { children: [
            /* @__PURE__ */ jsx112(
              toolbar_default,
              {
                page,
                toolbar,
                shareProps,
                pageUser,
                currentUser,
                drawer,
                renewalDisplayed,
                areShownContextualActions,
                tabId
              }
            ),
            /* @__PURE__ */ jsx112(tourMobileBanner_default, {}),
            isPrintMode && /* @__PURE__ */ jsx112(
              PrintView,
              {
                currentPage: page,
                isPresentationMode,
                presentationToolbarHeight: PRESENTATION_TOOLBAR_HEIGHT,
                onGoTo: onGoToCb
              }
            ),
            /* @__PURE__ */ jsx112(
              lightEditor_default,
              {
                ...viewerProps,
                subHeaderComponent: subHeaderComponentViewer,
                topBarComponent,
                isHidden: isPrintMode,
                onResourceButtonClick,
                wasSsrRendered,
                renewalDisplayed,
                setRenewalDisplayed,
                viewerRef,
                viewerReady,
                onCopyDocUrl
              }
            )
          ] });
        default:
          return /* @__PURE__ */ jsx112(notReachable_default, { screenReady, page });
      }
    };
    PageContent = ({
      page,
      currentUser,
      screenReady,
      chapter,
      book,
      isRevisionPage = false,
      bookPages,
      bookSubject,
      students,
      token,
      shareProps,
      toolbar,
      drawer,
      sharedPages,
      pageUser,
      isBookBrowsingMode = false,
      onPickerChange = _112.noop,
      onResourceButtonClick,
      isAICreationButtonEnabled,
      onAICreationButtonClick,
      viewerRef,
      viewerReady,
      lazyLoadScrollContainerSelector,
      isWorkplanStudentTask = false,
      hideEnhancedFeatures,
      routeReady,
      docId,
      isOffline,
      tabId,
      setTabId
    }) => {
      var _a2;
      const pageId = _112.get("id", page);
      useEffect34(() => {
        pageId && dispatchAnalyticsEvent27(ANALYTICS_EVENTS.PAGE_VIEWED, { pageId });
      }, [pageId]);
      const isStudentViewActivated = useSelector50(getUiIsStudentViewActivated);
      const clientFetch2 = useCallback48((params) => clientFetchCallback({ ...params, token }), [token]);
      const viewerProps = {
        isHidden: !screenReady,
        page,
        book,
        bookSubject,
        bookPages,
        currentUser,
        token,
        clientFetch: clientFetch2,
        toolbar,
        isOffline,
        drawer,
        lazyLoadScrollContainerSelector,
        isWorkplanStudentTask,
        screenReady,
        hideEnhancedFeatures,
        forceShowAnswerButton: isStudentViewActivated ? false : void 0,
        routeReady,
        isAICreationButtonEnabled,
        onAICreationButtonClick,
        tabId,
        setTabId,
        readonly: _112.isEmpty(currentUser) || isWorkplanStudentTask && (page == null ? void 0 : page.user) && (currentUser == null ? void 0 : currentUser.id) && (page == null ? void 0 : page.user) !== (currentUser == null ? void 0 : currentUser.id)
      };
      const viewerToShow = getViewerModeToShow({
        page,
        isRevisionPage,
        currentUser,
        isStudentViewActivated,
        isWorkplanStudentTask
      });
      const openAvailableSoonModal = useAvailableSoonModal_default();
      useEffect34(() => {
        if (screenReady && !viewerToShow) {
          openAvailableSoonModal();
        }
      }, [viewerToShow, screenReady, openAvailableSoonModal]);
      return /* @__PURE__ */ jsxs76(Fragment24, { children: [
        /* @__PURE__ */ jsx112("div", { children: /* @__PURE__ */ jsx112(
          ViewerElement,
          {
            shareProps,
            toolbar,
            page,
            chapter,
            book,
            viewerToShow,
            currentUser,
            isRevisionPage,
            viewerProps,
            sharedPages,
            pageUser,
            drawer,
            screenReady,
            isBookBrowsingMode,
            onPickerChange,
            onResourceButtonClick,
            viewerRef,
            viewerReady,
            students,
            tabId,
            docId
          }
        ) }),
        (currentUser == null ? void 0 : currentUser.isTeacher) && !isBookBrowsingMode && !(currentUser == null ? void 0 : currentUser.isTrial) && /* @__PURE__ */ jsx112(
          viewerFooter_default,
          {
            pageId: _112.get("id", page),
            bookId: _112.get("id", book),
            user: currentUser,
            isPresentationMode: (_a2 = toolbar == null ? void 0 : toolbar.presentationProps) == null ? void 0 : _a2.isPresentationMode
          }
        )
      ] });
    };
    pageContent_default = PageContent;
  }
});

// src/components/page/pageContainer.jsx
import { TtsModal } from "@lls/superkit";
import { useAnalyticsEventEnhancer as useAnalyticsEventEnhancer2 } from "@lls/utils";
import _113 from "lodash/fp.js";
import { memo as memo2, useMemo as useMemo24 } from "react";
import { jsx as jsx113, jsxs as jsxs77 } from "react/jsx-runtime";
var PageContainer, pageContainer_default;
var init_pageContainer = __esm({
  "src/components/page/pageContainer.jsx"() {
    "use strict";
    init_viewerContainers2();
    init_bookDrawer2();
    init_notReachable2();
    init_useShare();
    init_drawer();
    init_summary3();
    init_pageContent2();
    PageContainer = ({
      page,
      chapter,
      book,
      bookSubject,
      modifiedPages,
      scratchPages,
      screenReady,
      token,
      currentUser,
      teachers,
      subjects,
      toolbar,
      pageUser,
      sharedPages,
      groups,
      drawer,
      isBookBrowsingMode = false,
      isTouchable,
      changeBrowsingModalPage = _113.noop,
      onPickerChange = _113.noop,
      onResourceButtonClick,
      viewerRef,
      viewerReady,
      lazyLoadScrollContainerSelector,
      isWorkplanStudentTask,
      students,
      defaultFilter,
      disableFilter,
      routeReady,
      isOffline,
      tabId,
      setTabId
    }) => {
      const bookPages = useMemo24(() => {
        const originalPages = extractPages(_113.get("summary", book));
        return [...scratchPages, ...originalPages];
      }, [book, scratchPages]);
      const pageId = _113.get("id", page);
      const bookId = _113.get("id", book);
      const shareProps = useShare_default({
        page,
        book,
        token,
        currentUser,
        groups,
        teachers,
        subjects,
        isBookBrowsingMode,
        tabId
      });
      useAnalyticsEventEnhancer2({ pageId, bookId, ...toolbar == null ? void 0 : toolbar.analyticsProps });
      const isDrawerOpen = _113.get("isDrawerOpen", drawer) && !shouldHideDrawer(toolbar);
      const {
        ttsProps: { isTtsModalOpen, closeTtsModal, subjectId, fullscreenHtml }
      } = toolbar;
      return /* @__PURE__ */ jsxs77(StyledContainer, { "data-ispresentationmode": +(toolbar == null ? void 0 : toolbar.presentationProps.isPresentationMode), children: [
        /* @__PURE__ */ jsx113(
          bookDrawer_default,
          {
            page,
            book,
            modifiedPages,
            scratchPages,
            currentUser,
            drawer,
            toolbar,
            isBookBrowsingMode,
            changeBrowsingModalPage,
            defaultFilter,
            disableFilter
          }
        ),
        /* @__PURE__ */ jsx113(StyledViewerWrapperMargin, { "data-isdraweropen": +isDrawerOpen, children: /* @__PURE__ */ jsx113(StyledViewerWrapper, { children: /* @__PURE__ */ jsxs77(notReachable_default, { page, chapter, book, screenReady, user: currentUser, children: [
          /* @__PURE__ */ jsx113(
            pageContent_default,
            {
              drawer,
              page,
              currentUser,
              screenReady,
              chapter,
              book,
              isOffline,
              bookPages,
              bookSubject,
              students,
              token,
              toolbar,
              shareProps,
              pageUser,
              sharedPages,
              isBookBrowsingMode,
              onPickerChange,
              onResourceButtonClick,
              viewerRef,
              viewerReady,
              lazyLoadScrollContainerSelector,
              isWorkplanStudentTask,
              routeReady,
              tabId,
              setTabId
            }
          ),
          /* @__PURE__ */ jsx113(
            TtsModal,
            {
              open: isTtsModalOpen,
              close: closeTtsModal,
              subjectId,
              isTouchable,
              fullscreenHtml
            }
          )
        ] }) }) })
      ] });
    };
    pageContainer_default = memo2(PageContainer, (old, next) => {
      if (!next.screenReady) {
        return true;
      }
      return _113.isEqual(old, next);
    });
  }
});

// src/constants/page.js
var THEMATIC_NAMES_ALLOWING_CREATION_PAGE_BUTTON;
var init_page4 = __esm({
  "src/constants/page.js"() {
    "use strict";
    THEMATIC_NAMES_ALLOWING_CREATION_PAGE_BUTTON = [
      "\xA1Expert@s!",
      "Actividad",
      "Activit\xE9",
      "Activit\xE9 d'exploration",
      "Activit\xE9 en groupe",
      "Activit\xE9 documentaire",
      "Activit\xE9 exp\xE9rimentale",
      "Activit\xE9 Pix",
      "Activity",
      "Applications directes",
      "Apprendre \xE0 d\xE9montrer",
      "Apprendre autrement",
      "Auto-\xE9valuation",
      "Autoevaluaci\xF3n",
      "Brevet",
      "Camino al BAC",
      "Conjugaison",
      "Consolidation",
      "Contraction de texte",
      "Cours et exercices",
      "Exercices",
      "Dict\xE9es",
      "Dossier",
      "Dossier EMC",
      "Dossier EPI",
      "Entrer dans l'\u0153uvre",
      "\xC9tude",
      "\xC9tude d'\u0153uvre",
      "\xC9tude de cas",
      "\xC9tude th\xE9matique",
      "\xC9valuations",
      "Exam File",
      "Exercice Bac",
      "Expression \xE9crite",
      "Expression orale",
      "Fiche d'activit\xE9s",
      "Final challenge",
      "Final Project",
      "Pour aller plus loin",
      "Get Ready for the Bac!",
      "Get ready for the final project",
      "Gram\xE1tica y l\xE9xico",
      "Grammaire",
      "Synth\xE8se",
      "Livret maths",
      "Travailler autrement",
      "Entra\xEEnement bac",
      "Langue",
      "Livret BAC",
      "M\xE9thode Bac",
      "Mise en perspective",
      "Mission",
      "Orthographe",
      "Paso",
      "Parcours diff\xE9renci\xE9s",
      "Probl\xE8mes",
      "Projet final",
      "Proyecto final",
      "Python",
      "QCM",
      "Entra\xEEnement brevet",
      "Sujet BAC",
      "Sujet Brevet",
      "Sujet d'\xE9tude",
      "T\xE2che complexe",
      "TD",
      "TP / TICE",
      "Vocabulaire"
    ];
  }
});

// src/hooks/useCrisp.js
import { getCurrentUser as getCurrentUser27 } from "@lls/store";
import { getDocument, getQueryParams as getQueryParams10, getWindow as getWindow5 } from "@lls/utils";
import _114 from "lodash/fp.js";
import { useEffect as useEffect35 } from "react";
import { useSelector as useSelector51 } from "react-redux";
import { useLocation as useLocation20 } from "react-router-dom";
var useCrisp_default;
var init_useCrisp = __esm({
  "src/hooks/useCrisp.js"() {
    "use strict";
    init_marketing();
    useCrisp_default = process.env.CORE_CRISP === "0" ? () => null : function useCrisp({ isPresentationMode }) {
      const user = useSelector51(getCurrentUser27);
      const location = useLocation20();
      const query = getQueryParams10(location);
      useEffect35(() => {
        var _a2;
        const crisp = _114.get("$crisp", getWindow5());
        const crispBackup = getDocument().querySelector(".crisp-backup");
        try {
          if (crisp && isShownCrispComponent({ user, isPresentationMode, query })) {
            if (crispBackup) crispBackup.style.display = "block";
            crisp.push(["do", "chat:show"]);
            try {
              _114.includes("/page/", location.pathname) && crisp.push(["do", "trigger:run", "sondage-revision"]);
            } catch (_e) {
            }
          } else {
            if (crispBackup) crispBackup.style.display = "none";
            (_a2 = crisp == null ? void 0 : crisp.push) == null ? void 0 : _a2.call(crisp, ["do", "chat:hide"]);
          }
        } catch (error) {
          console.error("error loading crisp", error);
        }
      }, [isPresentationMode, query, user, location.pathname]);
    };
  }
});

// src/hooks/useReadDrawerNotification.js
import _115 from "lodash/fp.js";
import { useEffect as useEffect36 } from "react";
import { useSelector as useSelector52 } from "react-redux";
import { getAuth as getAuth12, useSearchDrawerNotifications } from "@lls/store";
var useReadDrawerNotification, useReadDrawerNotification_default;
var init_useReadDrawerNotification = __esm({
  "src/hooks/useReadDrawerNotification.js"() {
    "use strict";
    init_notification3();
    init_useCustomEffect();
    useReadDrawerNotification = ({ pageId }) => {
      const auth2 = useSelector52(getAuth12);
      const token = _115.get("token", auth2);
      const markNotificationAsReadEffectFn = useCustomEffect_default(markNotificationAsReadEffect);
      const drawerNotifications = useSearchDrawerNotifications({ pageIds: [pageId], read: false });
      useEffect36(() => {
        if (!_115.isEmpty(drawerNotifications))
          markNotificationAsReadEffectFn({
            token,
            notification: _115.first(drawerNotifications)
          });
      }, [drawerNotifications, markNotificationAsReadEffectFn, token]);
    };
    useReadDrawerNotification_default = useReadDrawerNotification;
  }
});

// src/utils/file.js
import _116 from "lodash/fp.js";
var downLoadFile, getFileName;
var init_file = __esm({
  "src/utils/file.js"() {
    "use strict";
    downLoadFile = (blob, fileName) => {
      const anchorElement = document.createElement("a");
      document.body.appendChild(anchorElement);
      anchorElement.style.display = "none";
      const url = window.URL.createObjectURL(blob);
      anchorElement.href = url;
      anchorElement.download = fileName;
      anchorElement.click();
      window.URL.revokeObjectURL(url);
    };
    getFileName = _116.flow(_116.get("headers.content-disposition"), _116.split('"'), _116.compact, _116.last);
  }
});

// src/constants/accessibility.js
var DEFAULT_ACCESSIBILITY_STATE;
var init_accessibility = __esm({
  "src/constants/accessibility.js"() {
    "use strict";
    DEFAULT_ACCESSIBILITY_STATE = {
      sizeIndex: 2,
      fontFamily: "LatoWeb",
      isDarkMode: false,
      isDysMode: false
    };
  }
});

// src/hooks/useAccessibilityCookie.js
import _117 from "lodash/fp.js";
import { useEffect as useEffect37, useMemo as useMemo25 } from "react";
import { getCurrentUser as getCurrentUser28 } from "@lls/store";
import { useSelector as useSelector53 } from "react-redux";
var useAccessibilityCookie, useAccessibilityCookie_default;
var init_useAccessibilityCookie = __esm({
  "src/hooks/useAccessibilityCookie.js"() {
    "use strict";
    init_es62();
    init_cookie();
    init_accessibility();
    init_constants();
    useAccessibilityCookie = ({ accessibilityState, isPresentationMode }) => {
      const [cookies, setCookie] = useCookies([COOKIE_ACCESSIBILITY_STATE]);
      const currentUser = useSelector53(getCurrentUser28);
      const accessibilityStateCookie = _117.get(COOKIE_ACCESSIBILITY_STATE, cookies);
      const pickedAccessibility = useMemo25(() => {
        return {
          [_117.get("id", currentUser)]: {
            ..._117.pickBy((value, key) => {
              return DEFAULT_ACCESSIBILITY_STATE[key] !== value && (!isPresentationMode || key !== "sizeIndex");
            }, accessibilityState)
          }
        };
      }, [currentUser, accessibilityState, isPresentationMode]);
      useEffect37(() => {
        if ((currentUser || process.env.CORE_MANAGED_COOKIES === "1") && !_117.isEqual(accessibilityStateCookie, pickedAccessibility)) {
          setCookie(COOKIE_ACCESSIBILITY_STATE, pickedAccessibility, getCookieOptions(365));
        }
      }, [pickedAccessibility, currentUser, accessibilityStateCookie, setCookie]);
      return pickedAccessibility;
    };
    useAccessibilityCookie_default = useAccessibilityCookie;
  }
});

// src/hooks/useToolbarAdapter.js
import { getVoiceIdBySubjectId, useAccessibilityState } from "@lls/superkit";
import { getPagePath as getPagePath9, getQueryParams as getQueryParams11, isPrintModeEnabled, openWindow as openWindow17 } from "@lls/utils";
import { usePresentation, useViewerHistory } from "@lls/viewer/staticImports";
import _118 from "lodash/fp.js";
import { useCallback as useCallback49, useEffect as useEffect38, useMemo as useMemo26, useRef as useRef17, useState as useState29 } from "react";
import { useDispatch as useDispatch38, useSelector as useSelector54 } from "react-redux";
import { useHistory as useHistory30, useLocation as useLocation21 } from "react-router-dom";
import { getCurrentUser as getCurrentUser29 } from "@lls/store";
var onPrintModeChange, onAccessibilityButtonClick, onExportButtonClick, useToolbarAdapter, useToolbarAdapter_default;
var init_useToolbarAdapter = __esm({
  "src/hooks/useToolbarAdapter.js"() {
    "use strict";
    init_es62();
    init_rest();
    init_constants();
    init_utils3();
    init_viewer();
    init_file();
    init_route();
    init_useAccessibilityCookie();
    init_useTour();
    onPrintModeChange = (_value, defaultCb) => defaultCb();
    onAccessibilityButtonClick = (_e, defaultCb) => defaultCb();
    onExportButtonClick = (dispatch) => async ({ link, shouldLoad = false, resetLoader = _118.noop }) => {
      if (!shouldLoad) return openWindow17(link, "_blank");
      try {
        const result = await getPdf(link);
        const blob = _118.get("data", result);
        if (_118.has("coreOpenWindow", window)) {
          return openWindow17(link, "_blank");
        }
        const fileName = getFileName(result);
        downLoadFile(blob, decodeURIComponent(fileName));
        triggerNotification({
          name: "success",
          message: "Le fichier a bien \xE9t\xE9 t\xE9l\xE9charg\xE9.",
          params: {
            action: {
              text: "OK",
              cb: _118.noop
            }
          },
          dispatch
        });
      } catch (error) {
        triggerNotification({
          name: "error",
          message: "D\xE9sol\xE9, une erreur est survenue lors de la pr\xE9paration du document. Veuillez r\xE9essayer ult\xE9rieurement.",
          dispatch
        });
        console.error(error);
      } finally {
        resetLoader();
      }
    };
    useToolbarAdapter = ({
      subjectId,
      page: iPage,
      book,
      token,
      isRevisionPage,
      screenReady,
      isCreatingPage = false
    }) => {
      const { sendEvent: sendEvent2 } = useTour_default();
      const pageId = _118.get("id", iPage);
      const queryParams = getQueryParams11(useLocation21());
      const originSlug = _118.get("originSlug", queryParams);
      const docId = _118.get("docId", queryParams);
      const taskId = _118.get("taskId", queryParams);
      const isCreatingFromScratch = iPage == null ? void 0 : iPage.isCreatedFromScratch;
      const history = useHistory30();
      const dispatch = useDispatch38();
      const currentUser = useSelector54(getCurrentUser29);
      const currentUserId = _118.get("id", currentUser);
      const [isPrintMode, setIsPrintMode] = useState29(false);
      const [fullscreenHtml, setFullscreenHtml] = useState29(null);
      const presentationProps = usePresentation(iPage, sendEvent2);
      const isPresentationMode = presentationProps.isPresentationMode;
      const presentationView = presentationProps.presentationView;
      const openFullscreenCard = presentationProps == null ? void 0 : presentationProps.openFullscreenCard;
      const isSlideView = (presentationView == null ? void 0 : presentationView.view) === "slide";
      const page = screenReady ? iPage : void 0;
      useEffect38(() => {
        if ((presentationView == null ? void 0 : presentationView.view) === "slide" && !isRevisionPage) {
          history.push(
            getPagePath9(
              { slug: _118.get("slug", page) },
              { isDraft: _118.get("isDraft", page), taskId, docId: presentationView == null ? void 0 : presentationView.uuid }
            )
          );
          return () => {
            _118.isEqual(history.location.pathname.slice(1), _118.get("slug", page)) && history.push(getPagePath9({ slug: _118.get("slug", page) }, { isDraft: _118.get("isDraft", page), taskId }));
          };
        }
      }, [presentationView, isRevisionPage, page, taskId, history]);
      const init_fullscreen = useRef17(false);
      const docIdExists = docId && _118.flow(_118.get("children"), _118.some({ uuid: docId }))(page);
      useEffect38(() => {
        if (!screenReady) return;
        if (docIdExists && !isSlideView && !init_fullscreen.current) {
          openFullscreenCard(docId);
        }
        init_fullscreen.current = true;
      }, [docId, openFullscreenCard, isSlideView, docIdExists, screenReady]);
      useEffect38(() => {
        const clarity = _118.get("clarity", window);
        if (_118.isUndefined(clarity)) return;
        switch (presentationView == null ? void 0 : presentationView.view) {
          case "page":
            clarity("set", "Vid\xE9oprojection", "true");
            clarity("set", "Vid\xE9oprojection-Page", "true");
            break;
          case "slide":
            clarity("set", "Vid\xE9oprojection", "true");
            clarity("set", "Vid\xE9oprojection-Doc", "true");
            break;
          case "split":
            clarity("set", "Vid\xE9oprojection", "true");
            clarity("set", "Vid\xE9oprojection-Split", "true");
            break;
        }
      }, [presentationView == null ? void 0 : presentationView.view]);
      const { accessibilityState, handleAccessibilityChange } = useAccessibilityState({
        currentUserId,
        accessibilityCookie: _118.flow(useCookies, _118.get([0, COOKIE_ACCESSIBILITY_STATE]))([COOKIE_ACCESSIBILITY_STATE])
      });
      useAccessibilityCookie_default({ accessibilityState, isPresentationMode });
      const onGoBack = useCallback49(() => {
        const path = isRevisionPage ? getPath("revision_book", { bookUri: book == null ? void 0 : book.uri }) : originSlug ? getPath("page", { slug: originSlug }) : getPath("book", _118.pick(["slug", "uri"], book));
        history.push(path);
      }, [history, originSlug, isRevisionPage, book]);
      const onChangeCb = useCallback49(
        (template, ctx) => {
          onTemplateChangeEffect({ dispatch, history, params: { template, ctx, token, currentUser } });
        },
        [dispatch, token, history, currentUser]
      );
      const historyProps = useViewerHistory({ template: page, onChange: onChangeCb });
      const [voiceId, setVoiceId] = useState29(null);
      const isTtsModalOpen = fullscreenHtml !== null;
      const openTtsModal = useCallback49((html) => {
        setFullscreenHtml(html);
      }, []);
      const closeTtsModal = useCallback49(() => {
        setFullscreenHtml(null);
      }, []);
      useEffect38(() => {
        setVoiceId(getVoiceIdBySubjectId(subjectId));
      }, [subjectId]);
      useEffect38(() => {
        _118.noop(page);
        closeTtsModal();
      }, [page, closeTtsModal]);
      useEffect38(() => {
        if (!page) return;
        setIsPrintMode((isPrintMode2) => isPrintModeEnabled({ page, isPrintMode: isPrintMode2 }));
      }, [page]);
      return useMemo26(
        () => ({
          viewerProps: {
            ...accessibilityState,
            areQuestionsHidden: accessibilityState.areQuestionsHidden && isPresentationMode,
            setFullscreenHtml,
            isPresentationMode,
            isCreatingFromScratch,
            historyProps
          },
          analyticsProps: {
            ...accessibilityState,
            presentationView,
            isPrintMode
          },
          accessibilityProps: {
            ...accessibilityState,
            onAccessibilityButtonClick,
            onAccessibilityChange: handleAccessibilityChange
          },
          presentationProps,
          ttsProps: {
            voiceId,
            subjectId,
            setVoiceId,
            openTtsModal,
            closeTtsModal,
            isTtsModalOpen,
            fullscreenHtml,
            setFullscreenHtml
          },
          printProps: {
            isPrintMode,
            setIsPrintMode,
            onPrintModeChange
          },
          historyProps,
          onExportButtonClick: onExportButtonClick(dispatch),
          isCreatingPage,
          isRevisionPage,
          onGoBack,
          pageId,
          isPrintMode,
          // tts
          subjectId,
          voiceId,
          setVoiceId,
          fullscreenHtml,
          setFullscreenHtml
        }),
        [
          subjectId,
          pageId,
          isRevisionPage,
          fullscreenHtml,
          voiceId,
          closeTtsModal,
          openTtsModal,
          isTtsModalOpen,
          presentationView,
          isPresentationMode,
          presentationProps,
          isPrintMode,
          historyProps,
          accessibilityState,
          handleAccessibilityChange,
          isCreatingFromScratch,
          isCreatingPage,
          onGoBack,
          dispatch
        ]
      );
    };
    useToolbarAdapter_default = useToolbarAdapter;
  }
});

// src/hooks/useUnload.js
import _119 from "lodash/fp.js";
import { useCallback as useCallback50, useEffect as useEffect39 } from "react";
var useUnload, useUnload_default;
var init_useUnload = __esm({
  "src/hooks/useUnload.js"() {
    "use strict";
    useUnload = ({ onUnloadCallback = _119.noop, isActive }) => {
      const onUnload = useCallback50(
        (e) => {
          e.preventDefault();
          e.stopImmediatePropagation();
          e.returnValue = "leave";
          onUnloadCallback(e);
        },
        [onUnloadCallback]
      );
      useEffect39(() => {
        if (window && isActive) {
          window.addEventListener("beforeunload", onUnload);
          return () => window.removeEventListener("beforeunload", onUnload);
        }
      }, [onUnload, isActive]);
    };
    useUnload_default = useUnload;
  }
});

// src/hooks/useGetScreenPageProps.js
import _120 from "lodash/fp.js";
import { useCallback as useCallback51, useEffect as useEffect40, useMemo as useMemo27, useRef as useRef18, useState as useState30 } from "react";
import { useDispatch as useDispatch39, useSelector as useSelector55 } from "react-redux";
import { useHistory as useHistory31, useLocation as useLocation22 } from "react-router-dom";
import { getAuth as getAuth13, getDrafts as getDrafts2, getIsLogged, useSearchDrafts, useSearchUsers as useSearchUsers2 } from "@lls/store";
import { getSubject, getSubjects } from "@lls/store";
import { getLevel } from "@lls/store";
import {
  makeSearchBooks as makeSearchBooks2,
  makeSearchPages,
  useSearchCurrentUserSharedPages as useSearchCurrentUserSharedPages3,
  useSearchGroups as useSearchGroups2,
  useSearchModifiedPages as useSearchModifiedPages2,
  useSearchPages as useSearchPages10,
  useSearchTeachers
} from "@lls/store";
import { getChapter } from "@lls/store";
import { getBook as getBook3 } from "@lls/store";
import { getCurrentUser as getCurrentUser30 } from "@lls/store";
import { getBrowserWidth as getBrowserWidth3, getQueryParams as getQueryParams12, isUserPage, needNewCustomDraft as needNewCustomDraft2 } from "@lls/utils";
var mayNeedPageFetch, getSeq, useResetToolbar, useGetScreenPageProps, useGetScreenPageProps_default;
var init_useGetScreenPageProps = __esm({
  "src/hooks/useGetScreenPageProps.js"() {
    "use strict";
    init_es62();
    init_actions();
    init_constants();
    init_withRouterProvider();
    init_fetch();
    init_useCrisp();
    init_useDrawer();
    init_useReadDrawerNotification();
    init_useToolbarAdapter();
    init_useUnload();
    init_useViewerReady();
    init_loading3();
    init_tour6();
    init_cookie();
    init_route();
    init_style();
    mayNeedPageFetch = [
      {
        screen: SCREEN_PARTIAL_PAGE_DRAWER,
        getFetchParams: ({ params: { slug, token }, useSelector: useSelector78 }) => {
          var _a2, _b2;
          const page = (_a2 = useSelector78((state) => makeSearchPages()(state, { slugs: [slug] }))) == null ? void 0 : _a2[0];
          const book = (_b2 = useSelector78((state) => makeSearchBooks2()(state, { ids: [_120.get("book", page)] }))) == null ? void 0 : _b2[0];
          const params = { slugs: [_120.get("slug", book)], token };
          return !_120.isNil(_120.get("book", page)) && params;
        }
      },
      {
        screen: SCREEN_PARTIAL_PAGE_CUSTOM_CACHE,
        getFetchParams: ({ params: { slug }, useSelector: useSelector78 }) => {
          var _a2;
          const page = (_a2 = useSelector78((state) => makeSearchPages()(state, { slugs: [slug] }))) == null ? void 0 : _a2[0];
          const params = {
            bookIds: [_120.get("book", page)]
          };
          return !!_120.get("book", page) && params;
        }
      },
      {
        screen: SCREEN_PARTIAL_PAGE_CUSTOM_NOCACHE,
        getFetchParams: ({ params: { appCustomPagesAfter, slug, token, isWorkplanStudentTask }, useSelector: useSelector78 }) => {
          var _a2, _b2;
          const page = (_a2 = useSelector78((state) => makeSearchPages()(state, { slugs: [slug] }))) == null ? void 0 : _a2[0];
          const book = (_b2 = useSelector78((state) => makeSearchBooks2()(state, { ids: [_120.get("book", page)] }))) == null ? void 0 : _b2[0];
          const subjectIds = _120.get("subjects", book);
          const currentUser = useSelector78(getCurrentUser30);
          const params = {
            bookIds: [_120.get("book", page)],
            token,
            isStudent: _120.get("isStudent", currentUser),
            subjectIds,
            pageId: _120.get("id", page),
            isWorkplanStudentTask,
            appCustomPagesAfter
          };
          return !!token && !!_120.get("book", page) && !!subjectIds && params;
        }
      }
    ];
    getSeq = ({ readonly, isRevisionPage, isDraft }) => {
      switch (true) {
        case isDraft:
          return [];
        case isRevisionPage:
        case readonly:
          return [
            { screen: SCREEN_PARTIAL_PAGE_MAIN },
            {
              screen: SCREEN_PARTIAL_BOOK_PAGES,
              getFetchParams: ({ params: { slug }, useSelector: useSelector78 }) => {
                var _a2, _b2;
                const page = (_a2 = useSelector78((state) => makeSearchPages()(state, { slugs: [slug] }))) == null ? void 0 : _a2[0];
                const book = (_b2 = useSelector78((state) => makeSearchBooks2()(state, { ids: [_120.get("book", page)] }))) == null ? void 0 : _b2[0];
                const params = { slugs: [_120.get("slug", book)] };
                return !_120.isNil(_120.get("book", page)) && params;
              }
            }
          ];
        default:
          return [
            [
              {
                screen: SCREEN_PARTIAL_PAGE_MAIN
              },
              mayNeedPageFetch
            ],
            mayNeedPageFetch
          ];
      }
    };
    useResetToolbar = (toolbar, book) => {
      const toolbarRef = useRef18();
      toolbarRef.current = toolbar;
      useEffect40(() => {
        _120.noop(book);
        const obj = toolbarRef.current;
        obj.printProps.setIsPrintMode(false);
        obj.setFullscreenHtml(null);
        obj.presentationProps.closeProjectorView();
      }, [book]);
    };
    useGetScreenPageProps = ({
      reactRouterProps = {},
      slug: iSlug,
      isDraft: iIsDraft,
      isWorkplanStudentTask = false,
      readonly = false,
      isRevisionPage = false,
      consumer,
      notifyOnUnmount
    } = {}) => {
      var _a2, _b2, _c2, _d, _e, _f;
      const location = useLocation22();
      const queryParams = getQueryParams12(useLocation22());
      const history = useHistory31();
      const dispatch = useDispatch39();
      const isDraft = _120.isUndefined(iIsDraft) ? _120.get("isDraft", queryParams) : iIsDraft;
      const slug = iSlug || _120.getOr("", "location.pathname", reactRouterProps).slice(1);
      const auth2 = useSelector55(getAuth13);
      const currentUser = useSelector55(getCurrentUser30);
      const isLogged = useSelector55(getIsLogged);
      const token = _120.get("token", auth2);
      const userId = _120.get("id", auth2);
      const schoolIds = _120.get("schools", currentUser);
      const pageTemp = (_a2 = useSearchPages10({ slugs: [slug] })) == null ? void 0 : _a2[0];
      const pageDraft = (_b2 = useSearchDrafts({ slugs: [slug] })) == null ? void 0 : _b2[0];
      const page = isDraft && needNewCustomDraft2(pageTemp, currentUser) && !_120.isEmpty(pageDraft) ? pageDraft : pageTemp;
      const book = useSelector55((state) => getBook3(state, _120.get("book", page)));
      const bookLevel = useSelector55((state) => getLevel(state, _120.get("levels.0", book)));
      const bookSubject = useSelector55((state) => getSubject(state, _120.get("subjects.0", book)));
      const chapter = useSelector55((state) => getChapter(state, _120.get("chapter", page)));
      const draftModifiedPages = useSearchModifiedPages2({ isDraft: true });
      const draftPagesOriginal = useSelector55(getDrafts2);
      const draftPages = [...draftModifiedPages, ...draftPagesOriginal];
      const isCreatedFromScratch = _120.get("isCreatedFromScratch", page);
      const currentPageDraft = isDraft ? page : _120.first(draftPages);
      const tourId = useSelector55(getCurrentTourId);
      const openWarningSavePageModal = useCallback51(() => {
        !tourId && !currentUser.isTrial && dispatch(setModal({ name: MODAL_WARNING_SAVE_PAGE, open: true, data: { currentPageDraft } }));
      }, [currentPageDraft, dispatch, tourId, currentUser]);
      useUnload_default({
        onUnloadCallback: openWarningSavePageModal,
        isActive: !_120.isEmpty(draftPages) && IS_WARNING_MODAL_ENABLED
      });
      useEffect40(() => {
        if (isDraft) {
          return history.listen((_params, action) => {
            if (action === "PUSH") {
              !isAlreadyOnDraftPage(history, currentPageDraft) && IS_WARNING_MODAL_ENABLED && openWarningSavePageModal();
            }
          });
        }
      }, [history, openWarningSavePageModal, isDraft, currentPageDraft]);
      const modifiedPages = useSearchModifiedPages2({
        bookIds: [_120.get("id", book)],
        userIds: [userId],
        isCreatedFromScratch: false
      });
      const scratchPages = useSearchModifiedPages2({
        bookIds: [_120.get("id", book)],
        isCreatedFromScratch: true,
        userIds: [userId]
      });
      const pageUser = (_c2 = useSearchUsers2({ ids: [_120.get("user", page)], schoolIds: _120.get("schools", currentUser) })) == null ? void 0 : _c2[0];
      const drawer = useDrawer_default(page);
      const pageId = _120.get("id", page);
      const useCache = !isUserPage(auth2, pageId);
      const isOffline = (_d = useAppData()) == null ? void 0 : _d.isOffline;
      const isTouchable = (_e = useAppData()) == null ? void 0 : _e.isTouchable;
      const params = {
        slug,
        useCache,
        token,
        isStudent: currentUser == null ? void 0 : currentUser.isStudent,
        isWorkplanStudentTask,
        isOffline,
        appCustomPagesAfter: (_f = useAppData()) == null ? void 0 : _f.fetchCustomPagesAfter
      };
      const screenReady = useSelector55((state) => getIsLoaded(state, SCREEN_MULTIFETCH_PAGE, params));
      const toolbar = useToolbarAdapter_default({
        subjectId: _120.get("subjects.0", book),
        book,
        page,
        isRevisionPage,
        drawer,
        token,
        screenReady,
        isWorkplanStudentTask
      });
      if (process.env.CORE_RESET_TOOLBAR === "1") {
        useResetToolbar(toolbar, book);
      }
      const subjects = useSelector55(getSubjects);
      const isTeacher = currentUser == null ? void 0 : currentUser.isTeacher;
      const sharedPages = useSearchCurrentUserSharedPages3({
        parentIds: [isTeacher || isCreatedFromScratch ? pageId : (page == null ? void 0 : page.isOriginal) ? pageId : _120.get("parent", page)]
      });
      const teachers = useSearchTeachers({ ids: _120.get("teachers", currentUser), schoolIds });
      const groups = useSearchGroups2({ ownerIds: [_120.get("id", currentUser)] });
      const [, setCookie] = useCookies();
      const { viewerRef, viewerReady } = useViewerReady_default({ consumer, notifyOnUnmount });
      useEffect40(() => {
        viewerReady && setCookie(COOKIE_FIRST_OPEN_BOOK, true, getCookieOptions());
      }, [setCookie, viewerReady]);
      const setIsDrawerOpen2 = _120.get("setIsDrawerOpen", drawer);
      useEffect40(() => {
        _120.noop(page, readonly, isRevisionPage);
        if (viewerReady) {
          const width = getBrowserWidth3();
          if (width <= BREAKPOINT_PHABLET) {
            setIsDrawerOpen2(false);
          }
        }
      }, [viewerReady, page, setIsDrawerOpen2, readonly, isRevisionPage]);
      const seq5 = useMemo27(() => getSeq({ readonly, isDraft, isRevisionPage }), [readonly, isRevisionPage, isDraft]);
      useMultiFetch({ ssrFetcher: reactRouterProps.ssrFetcher, screen: SCREEN_MULTIFETCH_PAGE, params, seq: seq5 });
      useCrisp_default({ isPresentationMode: toolbar == null ? void 0 : toolbar.presentationProps.isPresentationMode });
      useReadDrawerNotification_default({ pageId });
      useEffect40(() => {
        _120.noop(pageId);
        const clarity = _120.get("clarity", window);
        if (viewerReady && _120.isFunction(clarity) && isCreatedFromScratch) {
          clarity("set", "feature", "Ecran de cr\xE9ation de page");
        }
      }, [isCreatedFromScratch, viewerReady, pageId]);
      const isSession = page == null ? void 0 : page.isPartOfSession;
      useEffect40(() => {
        _120.noop(pageId);
        const clarity = _120.getOr("clarity", window);
        if (isSession && _120.isFunction(clarity)) {
          clarity("set", "feature", "Exercices de R\xE9vision");
        }
      }, [pageId, isSession]);
      const metaParams = {
        page,
        book,
        subject: bookSubject,
        level: bookLevel
      };
      const modifiedPagesWithDraftPagesOriginal = useMemo27(
        () => (
          // avoid 4+ renders of viewer
          [...draftPagesOriginal, ...modifiedPages]
        ),
        [draftPagesOriginal, modifiedPages]
      );
      const [tabId, setTabId] = useState30(queryParams == null ? void 0 : queryParams.tabId);
      const onTabChange = useCallback51(
        (tabId2) => {
          if (!!tabId2 && typeof tabId2 === "string" && consumer !== VIEWER_BOOK_BROWSING_MODAL)
            history.push({ search: `?${new URLSearchParams({ ...getQueryParams12(location), tabId: tabId2 }).toString()}` });
          setTabId(tabId2);
        },
        [history, consumer, location]
        // updating query params should not change function ref and therefore break viewer memo, so we use immutable location as dep
      );
      const pageContainerProps = {
        appData: reactRouterProps == null ? void 0 : reactRouterProps.appData,
        page,
        screenReady,
        book,
        bookLevel,
        bookSubject,
        chapter,
        modifiedPages: modifiedPagesWithDraftPagesOriginal,
        scratchPages,
        token,
        currentUser,
        pageUser,
        isOffline,
        isTouchable,
        isLogged,
        toolbar,
        drawer,
        subjects,
        sharedPages,
        teachers,
        groups,
        viewerRef,
        viewerReady,
        routeReady: reactRouterProps == null ? void 0 : reactRouterProps.routeReady,
        tabId,
        setTabId: onTabChange
      };
      return {
        loadingParams: params,
        metaParams,
        pageContainerProps
      };
    };
    useGetScreenPageProps_default = useGetScreenPageProps;
  }
});

// css-modules:css-modules://whT_z1rFDGsltdQzKISFWfg1uLItD6M3vi8hnEx1OEo.css
var init_whT_z1rFDGsltdQzKISFWfg1uLItD6M3vi8hnEx1OEo = __esm({
  "css-modules:css-modules://whT_z1rFDGsltdQzKISFWfg1uLItD6M3vi8hnEx1OEo.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_modal_bookBrowsingModal.module.css
var src_components_modal_bookBrowsingModal_default;
var init_src_components_modal_bookBrowsingModal = __esm({
  "tmp_esbuild1736180049684/_src_components_modal_bookBrowsingModal.module.css"() {
    "use strict";
    init_whT_z1rFDGsltdQzKISFWfg1uLItD6M3vi8hnEx1OEo();
    src_components_modal_bookBrowsingModal_default = { "closeButton": "core-MQ_j0W-closeButton", "footer": "core-MQ_j0W-footer", "modal": "core-MQ_j0W-modal", "toolbar": "core-MQ_j0W-toolbar", "header": "core-MQ_j0W-header", "loadingContainer": "core-MQ_j0W-loadingContainer", "message": "core-MQ_j0W-message", "pageContainer": "core-MQ_j0W-pageContainer", "span": "core-MQ_j0W-span", "flex": "core-MQ_j0W-flex" };
  }
});

// src/components/modal/bookBrowsingModal.module.css
var init_bookBrowsingModal = __esm({
  "src/components/modal/bookBrowsingModal.module.css"() {
    "use strict";
    init_src_components_modal_bookBrowsingModal();
  }
});

// src/components/modal/bookBrowsingModal.jsx
import {
  Button as Button38,
  CircularProgressBar as CircularProgressBar2,
  KIT_CLASSNAME_DARK_THEME as KIT_CLASSNAME_DARK_THEME2,
  KIT_CLASSNAME_LIGHT_THEME as KIT_CLASSNAME_LIGHT_THEME2,
  Modal as Modal17,
  SelectField2 as SelectField22,
  Z_NAVBAR as Z_NAVBAR2
} from "@lls/lls-kit";
import { getAuth as getAuth14, getBook as getBook4, getCurrentUser as getCurrentUser31, getDraft, getPage as getPage3, useSearchBooks as useSearchBooks7 } from "@lls/store";
import { useAccessibilityState as useAccessibilityState2 } from "@lls/superkit";
import {
  cx as cx7,
  dispatchAnalyticsEvent as dispatchAnalyticsEvent28,
  getCustomizationDraftFromTemplate as getCustomizationDraftFromTemplate2,
  getPagePath as getPagePath10,
  getQueryParams as getQueryParams13,
  useAnalyticsEventEnhancer as useAnalyticsEventEnhancer3
} from "@lls/utils";
import { addChildrenUtil as addChildren } from "@lls/viewer";
import _121 from "lodash/fp.js";
import { useCallback as useCallback52, useEffect as useEffect41, useMemo as useMemo28, useRef as useRef19, useState as useState31 } from "react";
import { useSelector as useSelector56 } from "react-redux";
import { useHistory as useHistory32, useLocation as useLocation23 } from "react-router";
import { Fragment as Fragment25, jsx as jsx114, jsxs as jsxs78 } from "react/jsx-runtime";
var BROWSING_MODAL_HEADER_HEIGHT, BROWSING_MODAL_TOOLBAR_HEIGHT, BROWSING_MODAL_FOOTER_HEIGHT, BROWSING_MODAL_CLASSNAME, EXERCICE_FILTER, BookBrowsingModalContent, BookBrowsingModal, bookBrowsingModal_default;
var init_bookBrowsingModal2 = __esm({
  "src/components/modal/bookBrowsingModal.jsx"() {
    "use strict";
    init_loading4();
    init_pageContainer();
    init_analytics4();
    init_constants();
    init_page4();
    init_tour2();
    init_viewer();
    init_withRouterProvider();
    init_fetch();
    init_useCustomEffect();
    init_useDrawer();
    init_useGetScreenPageProps();
    init_useTour();
    init_useViewer();
    init_loading3();
    init_string();
    init_es62();
    init_bookBrowsingModal();
    BROWSING_MODAL_HEADER_HEIGHT = 80;
    BROWSING_MODAL_TOOLBAR_HEIGHT = 54;
    BROWSING_MODAL_FOOTER_HEIGHT = 52;
    BROWSING_MODAL_CLASSNAME = "browsing-modal";
    EXERCICE_FILTER = {
      type: "CUSTOM",
      title: "Exercices",
      match: {
        thematicNames: THEMATIC_NAMES_ALLOWING_CREATION_PAGE_BUTTON,
        premium: null,
        isOriginal: null
      },
      displayConditions: null
    };
    BookBrowsingModalContent = ({
      close,
      uuid,
      defaultSlug,
      originType,
      licenseBooks,
      page: defaultPage,
      addEntry = _121.noop
    }) => {
      const onTemplateChangeEffectFn = useCustomEffect_default(onTemplateChangeEffect);
      const { sendEvent: sendEvent2 } = useTour_default();
      const [slug, setSlug] = useState31(defaultSlug);
      const [isDraft, setIsDraft] = useState31();
      const changeBrowsingModalPage = useCallback52((newPage) => {
        const newIsDraft = _121.getOr(false, "isDraft", newPage);
        const newSlug = _121.get("slug", newPage);
        setIsDraft(newIsDraft);
        setSlug(newSlug);
      }, []);
      const {
        pageContainerProps: { currentUser, book, token, page, ...iPageContainerProps },
        loadingParams
      } = useGetScreenPageProps_default({ slug, isDraft, consumer: VIEWER_BOOK_BROWSING_MODAL, notifyOnUnmount: true });
      const [isDrawerOpen, setIsDrawerOpen2] = useState31(true);
      const { expandedId, setExpandedId } = useDrawer_default();
      const pageContainerProps = _121.set(
        "drawer",
        { isDrawerOpen, setIsDrawerOpen: setIsDrawerOpen2, expandedId, setExpandedId },
        iPageContainerProps
      );
      const [initialTemplate] = useState31(defaultPage || page);
      const hasExistingDraft = !!useSelector56((state) => getDraft(state, _121.get("id", initialTemplate)));
      const [shouldGetFirstValidPageSlug, setShouldGetFirstValidPageSlug] = useState31(false);
      const [selectedBook, setSelectedBook] = useState31(book);
      const bookRef = useRef19(book);
      const textBooks = useSearchBooks7({ ids: _121.get("textbooks", bookRef.current) });
      const isWorkplanPage = initialTemplate == null ? void 0 : initialTemplate.isWorkplan;
      const isFromScratchPage = initialTemplate == null ? void 0 : initialTemplate.isCreatedFromScratch;
      const books = isWorkplanPage ? _121.concat(licenseBooks, textBooks) : licenseBooks;
      const booksOptions = useMemo28(() => {
        return _121.map((book2) => ({ value: book2.id, label: book2.displayTitle }), books);
      }, [books]);
      const onBookSelect = useCallback52(
        (bookId) => {
          setShouldGetFirstValidPageSlug(true);
          setSelectedBook(_121.find({ id: bookId }, books));
        },
        [books]
      );
      const firstValidPage = useSelector56((state) => getPage3(state, _121.get("firstValidPage", selectedBook)));
      useEffect41(() => {
        _121.has("slug", firstValidPage) && shouldGetFirstValidPageSlug && setSlug(_121.get("slug", firstValidPage));
      }, [firstValidPage, shouldGetFirstValidPageSlug]);
      const [pickedTemplate, setPickedTemplate] = useState31();
      const docSize = _121.flow(_121.get("children"), _121.size)(pickedTemplate);
      useAnalyticsEventEnhancer3({
        pageId: _121.get("id", page),
        bookId: _121.get("id", book),
        pageType: isFromScratchPage || isWorkplanPage ? void 0 : "resource_selection"
      });
      const { setTaskId } = useViewer_default({ book, currentUser, page: initialTemplate, token });
      const onAddResources = useCallback52(() => {
        if (!_121.isUndefined(pickedTemplate) && initialTemplate) {
          const children = _121.flow(_121.get("children"), uuid ? _121.reverse : _121.identity, _121.map(_121.omit("uuid")))(pickedTemplate);
          const isWorkplan = _121.get("isWorkplan", initialTemplate);
          const newTemplate = addChildren({
            template: initialTemplate,
            children,
            layoutId: uuid,
            parentLayoutId: isWorkplan ? uuid : null
          });
          onTemplateChangeEffectFn({
            template: getCustomizationDraftFromTemplate2({ template: newTemplate }),
            currentUser,
            hasExistingDraft
          });
          if (isWorkplan) {
            setTaskId(uuid);
          } else {
            addEntry(newTemplate, _121.get("id", newTemplate));
          }
          const analyticsEvent = isWorkplan ? ANALYTICS_EVENTS.TASK_INSERTED : ANALYTICS_EVENTS.DOCUMENT_INSERTED;
          dispatchAnalyticsEvent28(analyticsEvent, {
            featureName: "from_textbook",
            resourceId: _121.flow(
              _121.get("children"),
              _121.map((child) => `${_121.get("initialPage", child)}|${_121.get("uuid", child)}`)
            )(pickedTemplate)
          });
        }
        close();
        sendEvent2(TOUR_EVENTS.ADD_RESOURCE_BUTTON_CLICK);
      }, [
        pickedTemplate,
        close,
        uuid,
        currentUser,
        initialTemplate,
        onTemplateChangeEffectFn,
        addEntry,
        setTaskId,
        sendEvent2,
        hasExistingDraft
      ]);
      const isExercicePage = originType === "exercice";
      const defaultFilter = isExercicePage ? EXERCICE_FILTER : void 0;
      const viewerProps = {
        currentUser,
        book,
        token,
        page,
        ...pageContainerProps,
        isBookBrowsingMode: true,
        lazyLoadScrollContainerSelector: `.${BROWSING_MODAL_CLASSNAME} [data-scrollingcontainer]`,
        onPickerChange: setPickedTemplate,
        changeBrowsingModalPage,
        defaultFilter,
        disableFilter: isExercicePage
      };
      const pageContainerRef = useRef19();
      const pageId = _121.get("id", page);
      useEffect41(() => {
        var _a2;
        pageId && ((_a2 = pageContainerRef.current) == null ? void 0 : _a2.scrollIntoView());
      }, [pageId]);
      const isCurrentWorkplanPage = _121.get("isWorkplan", page);
      return /* @__PURE__ */ jsxs78(Fragment25, { children: [
        /* @__PURE__ */ jsxs78(
          "div",
          {
            className: cx7(src_components_modal_bookBrowsingModal_default.toolbar, KIT_CLASSNAME_DARK_THEME2),
            style: {
              "--cr-browsing-modal-toolbar-height": `${BROWSING_MODAL_TOOLBAR_HEIGHT}px`,
              "--cr-z-navbar": Z_NAVBAR2
            },
            children: [
              /* @__PURE__ */ jsx114(
                Button38,
                {
                  disabled: isCurrentWorkplanPage,
                  icon: "sidebarleft",
                  theme: "gray",
                  accent: "floating",
                  onClick: () => setIsDrawerOpen2(!isDrawerOpen),
                  children: `${isDrawerOpen ? "Masquer" : "Afficher"} le sommaire`
                }
              ),
              /* @__PURE__ */ jsxs78("div", { className: src_components_modal_bookBrowsingModal_default.flex, children: [
                "Changer de manuel :",
                " ",
                /* @__PURE__ */ jsx114(SelectField22, { onChange: onBookSelect, value: _121.get("id", selectedBook), options: booksOptions })
              ] })
            ]
          }
        ),
        /* @__PURE__ */ jsx114(loading_default2, { screen: SCREEN_MULTIFETCH_PAGE, params: loadingParams }),
        /* @__PURE__ */ jsx114("div", { className: src_components_modal_bookBrowsingModal_default.pageContainer, ref: pageContainerRef, children: isCurrentWorkplanPage ? /* @__PURE__ */ jsx114("div", { className: src_components_modal_bookBrowsingModal_default.message, children: /* @__PURE__ */ jsx114("span", { className: src_components_modal_bookBrowsingModal_default.span, children: "Veuillez s\xE9lectionner un livre, puis les ressources que vous voulez ajouter." }) }) : /* @__PURE__ */ jsx114(pageContainer_default, { ...viewerProps }) }),
        /* @__PURE__ */ jsxs78(
          "div",
          {
            className: src_components_modal_bookBrowsingModal_default.footer,
            style: {
              "--cr-browsing-modal-footer-height": `${BROWSING_MODAL_FOOTER_HEIGHT}px`,
              "--cr-z-navbar": Z_NAVBAR2
            },
            children: [
              `${docSize} ${handlePlural("ressource", _121.get("children", pickedTemplate))} ${handlePlural(
                "s\xE9lectionn\xE9e",
                _121.get("children", pickedTemplate)
              )}.`,
              /* @__PURE__ */ jsxs78("div", { className: src_components_modal_bookBrowsingModal_default.flex, children: [
                /* @__PURE__ */ jsx114(Button38, { theme: "gray", accent: "floating", onClick: close, children: "Annuler" }),
                /* @__PURE__ */ jsx114(
                  Button38,
                  {
                    icon: "plus",
                    onClick: onAddResources,
                    disabled: docSize === 0,
                    "data-tour": "premium-add-selected-resources",
                    children: `Ajouter ${docSize} ${handlePlural("ressource", _121.get("children", pickedTemplate))}`
                  }
                )
              ] })
            ]
          }
        )
      ] });
    };
    BookBrowsingModal = (props) => {
      const { isCreatingPage, page: currentPage, close } = props;
      const history = useHistory32();
      const auth2 = useSelector56(getAuth14);
      const { token } = auth2;
      const queryParams = getQueryParams13(useLocation23());
      const originType = _121.get("originType", queryParams) || _121.get("pageType", currentPage);
      const bookId = currentPage == null ? void 0 : currentPage.book;
      const book = useSelector56((state) => getBook4(state, bookId));
      const firstValidPage = useSelector56((state) => getPage3(state, _121.get("firstValidPage", book)));
      const originSlug = _121.get("originSlug", queryParams) || _121.get("slug", firstValidPage);
      const defaultSlug = isCreatingPage ? originSlug ? getPagePath10({ slug: originSlug }).slice(1) : void 0 : _121.getOr("", "location.pathname", history).slice(1);
      const currentUser = useSelector56(getCurrentUser31);
      const userSubjects = _121.getOr([], "subjects", currentUser);
      const { licensedBookIds = currentUser == null ? void 0 : currentUser.booksV2 } = useAppData();
      const licenseBooks = useSearchBooks7({
        ids: licensedBookIds,
        subjectIds: userSubjects,
        publishers: [LLS_PUBLISHER],
        isValid: true
      });
      const fetchParams = useMemo28(
        () => ({ token, bookIds: licensedBookIds, subjectIds: userSubjects }),
        [token, licensedBookIds, userSubjects]
      );
      useFetch({
        screen: SCREEN_BOOK_BROWSING_MODAL,
        params: fetchParams
      });
      const isLoading = useSelector56((state) => getIsLoading(state, SCREEN_BOOK_BROWSING_MODAL, fetchParams));
      const { accessibilityState } = useAccessibilityState2({
        currentUserId: currentUser == null ? void 0 : currentUser.id,
        accessibilityCookie: _121.flow(useCookies, _121.get([0, COOKIE_ACCESSIBILITY_STATE]))([COOKIE_ACCESSIBILITY_STATE])
      });
      return /* @__PURE__ */ jsx114("div", { className: accessibilityState.isDarkMode ? KIT_CLASSNAME_DARK_THEME2 : KIT_CLASSNAME_LIGHT_THEME2, children: /* @__PURE__ */ jsxs78(
        Modal17,
        {
          maxwidth: "md",
          isRoot: true,
          withCloseButton: false,
          className: cx7(BROWSING_MODAL_CLASSNAME, src_components_modal_bookBrowsingModal_default.modal),
          closeModal: close,
          children: [
            /* @__PURE__ */ jsxs78(
              "div",
              {
                className: src_components_modal_bookBrowsingModal_default.header,
                style: {
                  "--cr-browsing-modal-header-height": `${BROWSING_MODAL_HEADER_HEIGHT}px`,
                  "--cr-z-navbar": Z_NAVBAR2
                },
                children: [
                  "Ajouter des ressources",
                  /* @__PURE__ */ jsx114(
                    Button38,
                    {
                      className: src_components_modal_bookBrowsingModal_default.closeButton,
                      size: "small",
                      icon: "cancel",
                      theme: "gray",
                      accent: "floating",
                      onClick: close,
                      inverted: true
                    }
                  )
                ]
              }
            ),
            isLoading ? /* @__PURE__ */ jsx114("div", { className: src_components_modal_bookBrowsingModal_default.loadingContainer, children: /* @__PURE__ */ jsx114(CircularProgressBar2, {}) }) : /* @__PURE__ */ jsx114(
              BookBrowsingModalContent,
              {
                ...props,
                defaultSlug,
                originType,
                licenseBooks
              }
            )
          ]
        }
      ) });
    };
    bookBrowsingModal_default = BookBrowsingModal;
  }
});

// css-modules:css-modules://Z59AxYzxsxjtLBr9lqOOx7CjhX6qoCnNDe2BehbwxS4.css
var init_Z59AxYzxsxjtLBr9lqOOx7CjhX6qoCnNDe2BehbwxS4 = __esm({
  "css-modules:css-modules://Z59AxYzxsxjtLBr9lqOOx7CjhX6qoCnNDe2BehbwxS4.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_page_bookDrawer_drawerHeaderInner.module.css
var src_components_page_bookDrawer_drawerHeaderInner_default;
var init_src_components_page_bookDrawer_drawerHeaderInner = __esm({
  "tmp_esbuild1736180049684/_src_components_page_bookDrawer_drawerHeaderInner.module.css"() {
    "use strict";
    init_Z59AxYzxsxjtLBr9lqOOx7CjhX6qoCnNDe2BehbwxS4();
    src_components_page_bookDrawer_drawerHeaderInner_default = { "drawerHeaderInner": "core-HRSpSG-drawerHeaderInner" };
  }
});

// src/components/page/bookDrawer/drawerHeaderInner.module.css
var init_drawerHeaderInner = __esm({
  "src/components/page/bookDrawer/drawerHeaderInner.module.css"() {
    "use strict";
    init_src_components_page_bookDrawer_drawerHeaderInner();
  }
});

// src/components/page/bookDrawer/drawerHeaderInner.jsx
import { useCallback as useCallback53, useMemo as useMemo29 } from "react";
import { useHistory as useHistory33 } from "react-router-dom";
import { Button as Button39, Tooltip } from "@lls/lls-kit";
import { FiltersButton, Search } from "@lls/superkit";
import { getFiltersForUser } from "@lls/utils";
import _122 from "lodash/fp.js";
import { Fragment as Fragment26, jsx as jsx115, jsxs as jsxs79 } from "react/jsx-runtime";
var BookDrawerHeaderInner, drawerHeaderInner_default;
var init_drawerHeaderInner2 = __esm({
  "src/components/page/bookDrawer/drawerHeaderInner.jsx"() {
    "use strict";
    init_withRouterProvider();
    init_route();
    init_drawerHeaderInner();
    BookDrawerHeaderInner = ({
      book,
      isBookCanopePublisher,
      currentUser,
      currentFilter,
      isDrawerOpen,
      isBookBrowsingMode,
      onFilterChange,
      onSearchPage,
      setIsDrawerOpen: setIsDrawerOpen2,
      disableFilter
    }) => {
      const history = useHistory33();
      const filtersList = useMemo29(() => getFiltersForUser(book, currentUser), [currentUser, book]);
      const onClickHome = useCallback53(() => {
        if (isOnBookPath(_122.get("location", history))) return setIsDrawerOpen2(false);
        history.push(getPath("book", _122.pick(["slug", "uri"], book)));
      }, [history, setIsDrawerOpen2, book]);
      const { isOffline } = useAppData();
      return /* @__PURE__ */ jsxs79("div", { className: src_components_page_bookDrawer_drawerHeaderInner_default.drawerHeaderInner, children: [
        !isBookBrowsingMode && !isOffline && /* @__PURE__ */ jsx115(
          Tooltip,
          {
            content: isBookCanopePublisher ? "Tableau de suivi" : "Accueil du manuel",
            withTail: true,
            position: "bottom",
            disabled: !isDrawerOpen,
            children: /* @__PURE__ */ jsx115(Button39, { onClick: onClickHome, icon: "dashboard", theme: "gray", accent: "alt", inverted: true, children: isBookCanopePublisher && "Tableau de suivi" })
          }
        ),
        !isBookCanopePublisher && /* @__PURE__ */ jsxs79(Fragment26, { children: [
          /* @__PURE__ */ jsx115(Search, { noBorder: true, onSubmit: onSearchPage }),
          /* @__PURE__ */ jsx115(
            FiltersButton,
            {
              currentUser,
              currentFilter,
              filtersList,
              onFilterChange,
              disabled: disableFilter
            }
          )
        ] })
      ] });
    };
    drawerHeaderInner_default = BookDrawerHeaderInner;
  }
});

// src/hooks/useNotTeaserModal.js
import _123 from "lodash/fp.js";
import { useCallback as useCallback54 } from "react";
import { useDispatch as useDispatch40 } from "react-redux";
var useNotTeaserModal, useNotTeaserModal_default;
var init_useNotTeaserModal = __esm({
  "src/hooks/useNotTeaserModal.js"() {
    "use strict";
    init_actions();
    init_constants();
    useNotTeaserModal = () => {
      const dispatch = useDispatch40();
      return useCallback54(
        (e) => {
          dispatch(setModal({ name: MODAL_NOT_TEASER, open: true }));
          _123.invoke("preventDefault", e);
        },
        [dispatch]
      );
    };
    useNotTeaserModal_default = useNotTeaserModal;
  }
});

// src/components/page/summary/chapterComponent.jsx
import { useSearchDrawerNotifications as useSearchDrawerNotifications2 } from "@lls/store";
import { SummaryChapterComponent } from "@lls/superkit";
import _124 from "lodash/fp.js";
import { jsx as jsx116 } from "react/jsx-runtime";
var ChapterComponent, chapterComponent_default;
var init_chapterComponent = __esm({
  "src/components/page/summary/chapterComponent.jsx"() {
    "use strict";
    init_useAvailableSoonModal();
    init_useNotTeaserModal();
    init_summary3();
    ChapterComponent = ({
      chapter,
      chapterProps: {
        teaserMode,
        expandedId,
        getRelatedPages,
        setExpandedId,
        currentUser,
        activeChapterId,
        isLicensedBook
      },
      ...props
    }) => {
      const collapsed = chapter.id !== expandedId;
      const setCollapse = collapsed ? () => setExpandedId(chapter.id) : () => setExpandedId(void 0);
      const pages = extractPages(chapter);
      const matchingPageIds = _124.flow(
        _124.flatMap((page) => {
          const { relatedPage, relatedPages } = getRelatedPages(page);
          return [relatedPage, ...relatedPages];
        }),
        _124.map("id")
      )(pages);
      const notifications2 = useSearchDrawerNotifications2({ pageIds: matchingPageIds });
      const openAvailableSoonModal = useAvailableSoonModal_default();
      const openNotTeaserModal = useNotTeaserModal_default();
      return /* @__PURE__ */ jsx116(
        SummaryChapterComponent,
        {
          ...props,
          currentUser,
          chapter,
          filterCount: _124.get("filterCount", chapter),
          collapsed,
          onCollapse: setCollapse,
          hasNotification: collapsed && !_124.isEmpty(notifications2),
          onAvailableSoon: openAvailableSoonModal,
          onNotTeaser: openNotTeaserModal,
          activeChapterId,
          teaserMode,
          isLicensedBook
        }
      );
    };
    chapterComponent_default = ChapterComponent;
  }
});

// css-modules:css-modules://lMllGzVJfZTitFkx8-jIspmmLnjG2VaKMCaoUHl1PGw.css
var init_lMllGzVJfZTitFkx8_jIspmmLnjG2VaKMCaoUHl1PGw = __esm({
  "css-modules:css-modules://lMllGzVJfZTitFkx8-jIspmmLnjG2VaKMCaoUHl1PGw.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_page_summary_myPagesChapterComponent.module.css
var src_components_page_summary_myPagesChapterComponent_default;
var init_src_components_page_summary_myPagesChapterComponent = __esm({
  "tmp_esbuild1736180049684/_src_components_page_summary_myPagesChapterComponent.module.css"() {
    "use strict";
    init_lMllGzVJfZTitFkx8_jIspmmLnjG2VaKMCaoUHl1PGw();
    src_components_page_summary_myPagesChapterComponent_default = { "button": "core-srxZbW-button", "empty": "core-srxZbW-empty", "container": "core-srxZbW-container" };
  }
});

// src/components/page/summary/myPagesChapterComponent.module.css
var init_myPagesChapterComponent = __esm({
  "src/components/page/summary/myPagesChapterComponent.module.css"() {
    "use strict";
    init_src_components_page_summary_myPagesChapterComponent();
  }
});

// src/components/page/summary/pageComponent.jsx
import { SummaryPageComponent } from "@lls/superkit";
import { keepLastModifiedPages } from "@lls/utils";
import _125 from "lodash/fp.js";
import { useMemo as useMemo30 } from "react";
import { useSearchDrawerNotifications as useSearchDrawerNotifications3 } from "@lls/store";
import { jsx as jsx117 } from "react/jsx-runtime";
var LinkComponent, PageComponent, pageComponent_default;
var init_pageComponent = __esm({
  "src/components/page/summary/pageComponent.jsx"() {
    "use strict";
    init_link();
    init_route();
    LinkComponent = ({ page, children, className, linkProps: { getRelatedPages }, onClick }) => {
      const { relatedPage } = getRelatedPages(page);
      const path = _125.get("isPanorama", page) ? getPath("panorama", page) : getPath("page", relatedPage);
      return /* @__PURE__ */ jsx117(link_default, { className, to: path, onClick, children });
    };
    PageComponent = ({
      page,
      pageProps: { teaserMode, getActivePageId, getRelatedPages, onClick, isActivePageDraft, isLicensedBook },
      ...props
    }) => {
      const { relatedPage, relatedPages } = getRelatedPages(page.element);
      const matchingPageIds = _125.map("id", [relatedPage, ...relatedPages]);
      const notifications2 = useSearchDrawerNotifications3({ pageIds: matchingPageIds });
      const linkProps = useMemo30(() => ({ getRelatedPages }), [getRelatedPages]);
      const activePageId = getActivePageId(page);
      const modifiedPages = keepLastModifiedPages(relatedPages);
      return /* @__PURE__ */ jsx117(
        SummaryPageComponent,
        {
          ...props,
          page,
          activePageId,
          LinkComponent,
          linkProps,
          modifiedPages,
          notificationIds: _125.map("page", notifications2),
          onClick,
          relatedPage,
          isActivePageDraft,
          teaserMode,
          isLicensedBook
        }
      );
    };
    pageComponent_default = PageComponent;
  }
});

// src/components/page/summary/myPagesChapterComponent.jsx
import _126 from "lodash/fp.js";
import { Button as Button40 } from "@lls/lls-kit";
import { DRAWER_MY_PAGES_ID as DRAWER_MY_PAGES_ID2 } from "@lls/superkit";
import { jsx as jsx118, jsxs as jsxs80 } from "react/jsx-runtime";
var MyPagesChapter, myPagesChapterComponent_default;
var init_myPagesChapterComponent2 = __esm({
  "src/components/page/summary/myPagesChapterComponent.jsx"() {
    "use strict";
    init_chapterComponent();
    init_myPagesChapterComponent();
    init_pageComponent();
    MyPagesChapter = ({
      chapterProps,
      pageProps,
      pages,
      onCreateCustomPage,
      isBookBrowsingMode = false,
      withFilter = false,
      isTeacher = false,
      isOffline = false
    }) => {
      if (withFilter && _126.isEmpty(pages)) return null;
      const children = /* @__PURE__ */ jsxs80("div", { className: src_components_page_summary_myPagesChapterComponent_default.container, children: [
        _126.isEmpty(pages) ? /* @__PURE__ */ jsxs80("div", { className: src_components_page_summary_myPagesChapterComponent_default.empty, children: [
          "Vous n'avez pas encore de page personnalis\xE9e",
          !isOffline ? ", cr\xE9ez-en une !" : ""
        ] }) : _126.map.convert({ cap: false })((page, index3) => {
          const summaryElement = {
            element: {
              ...page,
              valid: true,
              nbPages: null,
              isCreatedFromScratch: true
            },
            id: _126.get("id", page),
            title: _126.get("title", page),
            type: "Page"
          };
          return /* @__PURE__ */ jsx118(
            pageComponent_default,
            {
              page: summaryElement,
              pageProps,
              isChapterPage: true,
              index: index3,
              depth: 2
            },
            _126.get("id", page)
          );
        }, pages),
        isTeacher && !isBookBrowsingMode && !isOffline && /* @__PURE__ */ jsx118(
          Button40,
          {
            className: src_components_page_summary_myPagesChapterComponent_default.button,
            icon: "plus",
            inverted: true,
            onClick: () => onCreateCustomPage("page"),
            "data-tour": "premium-create-page-btn-summary",
            children: "Cr\xE9er une page"
          }
        )
      ] });
      return isTeacher || !_126.isEmpty(pages) ? /* @__PURE__ */ jsx118(
        chapterComponent_default,
        {
          children,
          index: 0,
          isRoot: true,
          dataTour: "core-my-pages",
          chapter: {
            title: isTeacher ? "Mes Pages" : "Pages de mon professeur",
            type: "Chapter",
            filterCount: withFilter ? _126.size(pages) : void 0,
            id: DRAWER_MY_PAGES_ID2,
            element: {
              isVisible: true,
              valid: true
            }
          },
          chapterProps
        }
      ) : null;
    };
    myPagesChapterComponent_default = MyPagesChapter;
  }
});

// css-modules:css-modules://hHIUpj5QpkuCPfzBE3Rm1FVM-o0B4rHsjrhH4f_5_ok.css
var init_hHIUpj5QpkuCPfzBE3Rm1FVM_o0B4rHsjrhH4f_5_ok = __esm({
  "css-modules:css-modules://hHIUpj5QpkuCPfzBE3Rm1FVM-o0B4rHsjrhH4f_5_ok.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_page_summary_index.module.css
var src_components_page_summary_index_default;
var init_src_components_page_summary_index = __esm({
  "tmp_esbuild1736180049684/_src_components_page_summary_index.module.css"() {
    "use strict";
    init_hHIUpj5QpkuCPfzBE3Rm1FVM_o0B4rHsjrhH4f_5_ok();
    src_components_page_summary_index_default = { "resultsCount": "core-awkldq-resultsCount" };
  }
});

// src/components/page/summary/index.module.css
var init_summary4 = __esm({
  "src/components/page/summary/index.module.css"() {
    "use strict";
    init_src_components_page_summary_index();
  }
});

// src/components/page/summary/index.jsx
import { Summary as VBSummary, getActivePageId as vbGetActivePageId } from "@lls/superkit";
import _127 from "lodash/fp.js";
import { useCallback as useCallback55, useMemo as useMemo31 } from "react";
import { useSearchCurrentUserSharedPages as useSearchCurrentUserSharedPages4, useSearchModifiedPages as useSearchModifiedPages3 } from "@lls/store";
import { useSelector as useSelector57 } from "react-redux";
import { Fragment as Fragment27, jsx as jsx119, jsxs as jsxs81 } from "react/jsx-runtime";
var useStudentPages, Summary, summary_default;
var init_summary5 = __esm({
  "src/components/page/summary/index.jsx"() {
    "use strict";
    init_chapterComponent();
    init_myPagesChapterComponent2();
    init_pageComponent();
    init_withRouterProvider();
    init_ui2();
    init_summary4();
    useStudentPages = ({ currentPage, currentUser, bookId }) => {
      const sharedPages = useSearchCurrentUserSharedPages4({ bookIds: [bookId], isCreatedFromScratch: true });
      const modifiedPages = useSearchModifiedPages3({
        bookIds: [bookId],
        chapterIds: [null],
        userIds: [currentUser == null ? void 0 : currentUser.id],
        isParentCreatedFromScratch: true
      });
      const studentPages = useMemo31(() => {
        const concat = (arr1, arr2) => _127.flow(
          _127.concat(arr1),
          _127.uniqBy((page) => (page == null ? void 0 : page.originalPage) || (page == null ? void 0 : page.id)),
          _127.sortBy((page) => (page == null ? void 0 : page.originalPage) || (page == null ? void 0 : page.id))
        )(arr2);
        const concatenedPages = concat(modifiedPages, sharedPages);
        if (currentPage == null ? void 0 : currentPage.isCreatedFromScratch) return concat(currentPage, concatenedPages);
        return concatenedPages;
      }, [modifiedPages, sharedPages, currentPage]);
      return studentPages;
    };
    Summary = ({
      currentFilter,
      activeChapterId,
      expandedId,
      setExpandedId,
      currentPage,
      currentUser,
      onClick,
      summary,
      bookId,
      isActivePageDraft,
      isBookBrowsingMode,
      getRelatedPages,
      scratchPages,
      onCreateCustomPage,
      isWorkplan
    }) => {
      const getActivePageId = useCallback55(
        (page) => vbGetActivePageId({ user: currentUser, page: currentPage, summaryPage: page }),
        [currentUser, currentPage]
      );
      const { teaserMode, licensedBookIds = currentUser == null ? void 0 : currentUser.booksV2, isOffline } = useAppData();
      const isLicensedBook = _127.includes(bookId, licensedBookIds);
      const chapterProps = useMemo31(
        () => ({ expandedId, getRelatedPages, setExpandedId, currentUser, activeChapterId, teaserMode, isLicensedBook }),
        [expandedId, getRelatedPages, setExpandedId, currentUser, activeChapterId, teaserMode, isLicensedBook]
      );
      const isTeacher = currentUser == null ? void 0 : currentUser.isTeacher;
      const isStudent = currentUser == null ? void 0 : currentUser.isStudent;
      const pageProps = useMemo31(
        () => ({
          getRelatedPages,
          onClick,
          getActivePageId,
          isActivePageDraft,
          isStudent,
          teaserMode,
          isLicensedBook
        }),
        [getActivePageId, getRelatedPages, onClick, isActivePageDraft, isStudent, teaserMode, isLicensedBook]
      );
      const studentPages = useStudentPages({ currentPage, currentUser, bookId });
      const isStudentView = useSelector57(getUiIsStudentViewActivated);
      return /* @__PURE__ */ jsxs81(Fragment27, { children: [
        currentFilter && /* @__PURE__ */ jsxs81("div", { className: src_components_page_summary_index_default.resultsCount, children: [
          _127.getOr(0, "filterCount", summary),
          " pages trouv\xE9es"
        ] }),
        !isWorkplan && !isStudentView && /* @__PURE__ */ jsx119(
          myPagesChapterComponent_default,
          {
            chapterProps,
            pageProps,
            pages: isTeacher ? scratchPages : studentPages,
            isBookBrowsingMode,
            withFilter: !!currentFilter,
            onCreateCustomPage,
            isTeacher,
            isOffline
          }
        ),
        /* @__PURE__ */ jsx119(
          VBSummary,
          {
            currentUser,
            summary,
            ChapterComponent: chapterComponent_default,
            chapterProps,
            PageComponent: pageComponent_default,
            pageProps
          }
        )
      ] });
    };
    summary_default = Summary;
  }
});

// src/hooks/useRelatedPages.js
import { buildSummaryPageMapping } from "@lls/superkit";
import _128 from "lodash/fp.js";
import { useMemo as useMemo32, useRef as useRef20 } from "react";
var useRelatedPages, useRelatedPages_default;
var init_useRelatedPages = __esm({
  "src/hooks/useRelatedPages.js"() {
    "use strict";
    useRelatedPages = ({ modifiedPages, currentUser }) => {
      const lastPages = useRef20();
      const fnRef = useRef20();
      const back = useMemo32(() => {
        const drawerPageProps = [
          "slug",
          "numericOrder",
          "page",
          "nbPages",
          "valid",
          "premium",
          "thematicName",
          "displayTitle",
          "title",
          "sharedGroups",
          "isDraft"
        ];
        const subset = _128.map(_128.pick(["id", "parent", "originalPage", "updatedAt", ...drawerPageProps]), modifiedPages);
        if (_128.isEqual(lastPages.current, subset)) {
          lastPages.current = subset;
          return fnRef.current;
        }
        const getRelatedPages = buildSummaryPageMapping(subset, currentUser);
        fnRef.current = getRelatedPages;
        lastPages.current = subset;
        return getRelatedPages;
      }, [modifiedPages, currentUser]);
      return back;
    };
    useRelatedPages_default = useRelatedPages;
  }
});

// src/utils/memo.js
import _129 from "lodash/fp.js";
var shouldReturnCurrentBookDrawer;
var init_memo = __esm({
  "src/utils/memo.js"() {
    "use strict";
    shouldReturnCurrentBookDrawer = (old, next) => {
      var _a2, _b2, _c2, _d;
      const sameToolbar = _129.isEqual(
        (_b2 = (_a2 = old.toolbar) == null ? void 0 : _a2.presentationProps) == null ? void 0 : _b2.isPresentationMode,
        (_d = (_c2 = next.toolbar) == null ? void 0 : _c2.presentationProps) == null ? void 0 : _d.isPresentationMode
      );
      return _129.isEqual(_129.omit("toolbar", old), _129.omit("toolbar", next)) && sameToolbar;
    };
  }
});

// css-modules:css-modules://aJhzJ_uAGZLoYCol1MbkvNJFGO8qJuPKUNVnV5d5GSk.css
var init_aJhzJ_uAGZLoYCol1MbkvNJFGO8qJuPKUNVnV5d5GSk = __esm({
  "css-modules:css-modules://aJhzJ_uAGZLoYCol1MbkvNJFGO8qJuPKUNVnV5d5GSk.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_page_bookDrawer_index.module.css
var src_components_page_bookDrawer_index_default;
var init_src_components_page_bookDrawer_index = __esm({
  "tmp_esbuild1736180049684/_src_components_page_bookDrawer_index.module.css"() {
    "use strict";
    init_aJhzJ_uAGZLoYCol1MbkvNJFGO8qJuPKUNVnV5d5GSk();
    src_components_page_bookDrawer_index_default = { "drawer": "core-OlKdWG-drawer", "drawerHeader": "core-OlKdWG-drawerHeader", "viewer-fullscreen-modal": "core-OlKdWG-viewer-fullscreen-modal", "fillGap": "core-OlKdWG-fillGap" };
  }
});

// src/components/page/bookDrawer/index.module.css
var init_bookDrawer = __esm({
  "src/components/page/bookDrawer/index.module.css"() {
    "use strict";
    init_src_components_page_bookDrawer_index();
  }
});

// src/components/page/bookDrawer/index.tsx
import { Divider as Divider10 } from "@lls/lls-kit";
import { BookInfos, Drawer, STYLED_DRAWER_HEADER_HEIGHT, ToolBox, filterSummary, getNewChapterId } from "@lls/superkit";
import {
  ANALYTICS_LINK_CLICKED as ANALYTICS_LINK_CLICKED9,
  canSeeCalameo,
  cx as cx8,
  dispatchAnalyticsEvent as dispatchAnalyticsEvent29,
  getQueryParams as getQueryParams14,
  hasAccessToInvalidPage as hasAccessToInvalidPage3,
  isAcademicEnabled as isAcademicEnabled2,
  isCanopePublisher as isCanopePublisher2,
  openWindow as openWindow18,
  pipe as pipe3,
  useUnderBreakpoint as useUnderBreakpoint2
} from "@lls/utils";
import _130 from "lodash/fp.js";
import { memo as memo3, useCallback as useCallback56, useEffect as useEffect42, useMemo as useMemo33, useState as useState32 } from "react";
import { useDispatch as useDispatch41, useSelector as useSelector58 } from "react-redux";
import { useHistory as useHistory34, useLocation as useLocation24 } from "react-router-dom";
import { getAuth as getAuth15, useSearchPages as useSearchPages11 } from "@lls/store";
import { useSearchTools } from "@lls/store";
import { filterPages } from "@lls/store";
import { jsx as jsx120, jsxs as jsxs82 } from "react/jsx-runtime";
var usePanoramaScrollTo, getDrawerHeightAndTop, THEME_STYLE, BookDrawer, bookDrawer_default;
var init_bookDrawer2 = __esm({
  "src/components/page/bookDrawer/index.tsx"() {
    "use strict";
    init_actions();
    init_bookBrowsingModal2();
    init_drawerHeaderInner2();
    init_summary5();
    init_constants();
    init_analytics4();
    init_summary2();
    init_tour2();
    init_ui3();
    init_page2();
    init_withRouterProvider();
    init_useAvailableSoonModal();
    init_useCustomEffect();
    init_useRelatedPages();
    init_useTour();
    init_analytics2();
    init_drawer();
    init_memo();
    init_route();
    init_style();
    init_summary3();
    init_bookDrawer();
    usePanoramaScrollTo = (page) => {
      const scrollTo = _130.flow(useLocation24, getQueryParams14, _130.get("scrollto"))();
      return useMemo33(() => {
        const chapterId = _130.get("chapter", page);
        return _130.get("isPanorama", page) ? { scrollTo, chapterId } : {};
      }, [page, scrollTo]);
    };
    getDrawerHeightAndTop = (isPresentationMode, isBookBrowsingMode = false) => {
      switch (true) {
        case isPresentationMode:
          return { "--c-height": "100vh", "--c-top": "0" };
        case isBookBrowsingMode:
          return {
            "--c-height": `calc(100vh - ${BROWSING_MODAL_HEADER_HEIGHT + BROWSING_MODAL_TOOLBAR_HEIGHT + BROWSING_MODAL_FOOTER_HEIGHT}px - 2 * var(--kit-modal-margin))`,
            "--c-top": `${BROWSING_MODAL_HEADER_HEIGHT + BROWSING_MODAL_TOOLBAR_HEIGHT}px`
          };
        default:
          return { "--c-height": `calc(100vh - ${NAVBAR_HEIGHT}px)`, "--c-top": `${NAVBAR_HEIGHT}px` };
      }
    };
    THEME_STYLE = { transform: "translateX(0)" };
    BookDrawer = ({
      currentUser,
      page,
      book,
      modifiedPages,
      scratchPages,
      toolbar,
      drawer,
      isBookBrowsingMode,
      changeBrowsingModalPage,
      defaultFilter,
      disableFilter
    }) => {
      var _a2;
      const history = useHistory34();
      const isDrawerOpenFromProps = _130.get("isDrawerOpen", drawer);
      const dispatch = useDispatch41();
      const { sendEvent: sendEvent2 } = useTour_default();
      const [currentFilter, setCurrentFilter] = useState32(defaultFilter);
      const bookId = _130.get("id", book);
      const pageId = _130.get("id", page);
      const searchPageEffectFn = useCustomEffect_default(searchPageEffect);
      const { teaserMode, licensedBookIds = currentUser == null ? void 0 : currentUser.booksV2, isTouchable, isOffline } = useAppData();
      const isLicensedBook = _130.includes(book == null ? void 0 : book.id, licensedBookIds);
      useEffect42(() => {
        _130.noop(bookId);
        setCurrentFilter(defaultFilter);
      }, [defaultFilter, bookId]);
      const onSearchPage = useCallback56(
        (value) => {
          !defaultFilter && setCurrentFilter(void 0);
          searchPageEffectFn({
            teaserMode,
            isLicensedBook,
            modifiedPages,
            book,
            currentUser,
            searchValue: value,
            isBookBrowsingMode,
            changeBrowsingModalPage
          });
        },
        [
          teaserMode,
          modifiedPages,
          book,
          currentUser,
          isBookBrowsingMode,
          changeBrowsingModalPage,
          searchPageEffectFn,
          defaultFilter,
          isLicensedBook
        ]
      );
      const isMobile = useUnderBreakpoint2(BREAKPOINT_PHABLET);
      const { setIsDrawerOpen: setIsDrawerOpen2, setExpandedId, expandedId } = drawer;
      const openAvailableSoonModal = useAvailableSoonModal_default();
      const onClick = useCallback56(
        ({
          event,
          isValid,
          active,
          page: page2
        }) => {
          var _a3;
          if (((_a3 = page2 == null ? void 0 : page2.element) == null ? void 0 : _a3.isPartOfSession) && isValid) {
            sendEvent2(TOUR_EVENTS.SESSION_PAGE_CLICKED);
          }
          if (!isValid && !hasAccessToInvalidPage3(currentUser)) openAvailableSoonModal(event);
          if (active && isMobile) setIsDrawerOpen2(false);
          if (isBookBrowsingMode) {
            event.preventDefault();
            changeBrowsingModalPage(_130.getOr(page2, "element", page2));
          }
        },
        [
          setIsDrawerOpen2,
          openAvailableSoonModal,
          isMobile,
          currentUser,
          isBookBrowsingMode,
          changeBrowsingModalPage,
          sendEvent2
        ]
      );
      const iTools = useSearchTools({ bookIds: [bookId], locked: false });
      const tools = useMemo33(() => isBookBrowsingMode ? [] : iTools, [isBookBrowsingMode, iTools]);
      const auth2 = useSelector58(getAuth15);
      const token = _130.get("token", auth2);
      const onToolClick = useCallback56(
        ({ defaultBehavior, tool }) => {
          if (isOffline)
            return dispatch(
              setModal({
                name: MODAL_OFFLINE,
                open: true
              })
            );
          if (!isAcademicEnabled2(currentUser) && _130.get("locked", tool)) {
            dispatch(setModal({ name: MODAL_TEACHER_BOOK_DETAIL, open: true }));
          } else {
            defaultBehavior();
          }
          dispatchAnalyticsEvent29(ANALYTICS_EVENTS.TOOLBOX_USED, { featureName: _130.get("title", tool), pageId, bookId });
        },
        [currentUser, isOffline, dispatch, pageId, bookId]
      );
      const isDrawerOpen = isDrawerOpenFromProps && !shouldHideDrawer(toolbar);
      const bookUri = _130.get("uri", book);
      const isBookCanopePublisher = isCanopePublisher2(_130.get("publisher", book));
      const handleClick = useCallback56(
        (path) => {
          if (isOffline)
            return dispatch(
              setModal({
                name: MODAL_OFFLINE,
                open: true
              })
            );
          openWindow18(path, "_blank");
        },
        [isOffline, dispatch]
      );
      const bookInfosActions = useMemo33(() => {
        if (isBookCanopePublisher) return null;
        return _130.filter(Boolean, [
          (currentUser == null ? void 0 : currentUser.isTeacher) && {
            msg: (book == null ? void 0 : book.isClassic) ? "Guide p\xE9dagogique" : "Livre du professeur",
            onClick: () => {
              dispatchAnalyticsEvent29(ANALYTICS_LINK_CLICKED9, {
                featureName: "LDP",
                extraData: "LDP_page_premium"
              });
              return handleClick(getPath("teacher_book", { bookUri }));
            }
          },
          canSeeCalameo(currentUser, book) && {
            msg: "Voir la version papier",
            onClick: () => handleClick(_130.get("renderer", book))
          },
          process.env.CORE_ENABLE_APP_OPEN !== "0" && {
            msg: "Ouvrir dans l'application",
            onClick: () => dispatch(
              setModal({
                name: MODAL_ONE_CLICK,
                open: true,
                data: { pageId: _130.get("id", page), bookId }
              })
            )
          }
        ]);
      }, [bookId, bookUri, handleClick, dispatch, currentUser, page, book, isBookCanopePublisher]);
      const toolboxChild = useMemo33(
        () => _130.isEmpty(tools) ? void 0 : /* @__PURE__ */ jsx120(
          ToolBox,
          {
            tools,
            user: currentUser,
            token,
            bookUri,
            onClick: onToolClick,
            isTouchable
          }
        ),
        [tools, currentUser, token, bookUri, onToolClick, isTouchable]
      );
      useEffect42(() => {
        isOnBookPath(_130.get("location", history)) && isMobile && setIsDrawerOpen2(false);
      }, [history, setIsDrawerOpen2, isMobile]);
      const onFilterChange = useCallback56(
        (filter) => {
          setCurrentFilter(filter);
          dispatchAnalyticsEvent29(ANALYTICS_EVENTS.FILTER_USED, { filters: getFiltersParamValue(filter), pageId, bookId });
        },
        [pageId, bookId]
      );
      const panoramaScrollTo = usePanoramaScrollTo(page);
      const getRelatedPages = useRelatedPages_default({ modifiedPages, currentUser });
      const filteredSummary = useMemo33(
        () => pipe3(
          book == null ? void 0 : book.summary,
          (summary) => {
            if (isBookBrowsingMode) return rejectSessionPages(summary);
            return addPanoramaPages(summary, { bookId: _130.get("id", book), query: panoramaScrollTo });
          },
          (summary) => (
            // @ts-ignore TODO: need to type properly superkit from @lls/store models
            filterSummary(summary, {
              getRelatedPages,
              filter: _130.getOr({}, "match", currentFilter),
              filterPages: (pages, params) => filterPages(params)(pages)
            })
          )
        ),
        [getRelatedPages, book, currentFilter, panoramaScrollTo, isBookBrowsingMode]
      );
      const filteredScratchPages = filterPages(_130.getOr({}, "match", currentFilter))(scratchPages);
      const onCreateCustomPage = () => {
        history.push(getPath("page-creation", { ...book, originSlug: _130.get("slug", page), originType: "page" }));
        sendEvent2(TOUR_EVENTS.CREATE_PAGE_BUTTON_CLICK);
      };
      const summaryProps = {
        currentFilter,
        scratchPages: filteredScratchPages,
        currentPage: page,
        currentUser,
        onClick,
        summary: filteredSummary,
        bookId,
        isActivePageDraft: page == null ? void 0 : page.isDraft,
        isBookBrowsingMode,
        getRelatedPages,
        onCreateCustomPage,
        isWorkplan: isBookCanopePublisher
      };
      const originalPage = (_a2 = useSearchPages11({ ids: [page == null ? void 0 : page.originalPage] })) == null ? void 0 : _a2[0];
      const isOriginalPageCreatedFromScratch = !!(originalPage == null ? void 0 : originalPage.isCreatedFromScratch);
      return /* @__PURE__ */ jsxs82(
        Drawer,
        {
          page,
          summary: filteredSummary,
          width: DRAWER_WIDTH,
          "data-drawer-open": +isDrawerOpen,
          isDrawerOpen,
          toolboxChild,
          navbarHeight: NAVBAR_HEIGHT,
          className: cx8(getDarkClassNames(), src_components_page_bookDrawer_index_default.drawer),
          style: {
            ...THEME_STYLE,
            "--c-styled-drawer-header-height": `${STYLED_DRAWER_HEADER_HEIGHT}px`,
            ...getDrawerHeightAndTop(_130.get("isPresentationMode", toolbar), isBookBrowsingMode)
          },
          SummaryComponent: summary_default,
          isOriginalPageCreatedFromScratch,
          setExpandedId,
          isBookBrowsingMode,
          expandedId: expandedId === UNINITIALIZED_EXPANDED_ID && filteredSummary ? getNewChapterId({
            // @ts-ignore TODO: type superkit
            page,
            summary: filteredSummary,
            isOriginalPageCreatedFromScratch
          }) : expandedId,
          children: [
            /* @__PURE__ */ jsxs82("div", { className: src_components_page_bookDrawer_index_default.drawerHeader, children: [
              !isBookBrowsingMode && /* @__PURE__ */ jsx120(BookInfos, { book, actions: bookInfosActions }),
              /* @__PURE__ */ jsx120(
                drawerHeaderInner_default,
                {
                  book,
                  currentFilter,
                  currentUser,
                  isBookCanopePublisher,
                  isDrawerOpen,
                  isBookBrowsingMode,
                  onFilterChange,
                  onSearchPage,
                  setIsDrawerOpen: setIsDrawerOpen2,
                  disableFilter
                }
              ),
              /* @__PURE__ */ jsx120(Divider10, {})
            ] }),
            /* @__PURE__ */ jsx120(summary_default, { ...summaryProps }),
            /* @__PURE__ */ jsx120("div", { className: src_components_page_bookDrawer_index_default.fillGap, "data-hastoolbox": +!_130.isEmpty(tools) })
          ]
        }
      );
    };
    bookDrawer_default = memo3(BookDrawer, shouldReturnCurrentBookDrawer);
  }
});

// src/hooks/useOnboarding.ts
import { getToken as getToken11 } from "@lls/store";
import { getCurrentUser as getCurrentUser32 } from "@lls/store";
import { getQueryParams as getQueryParams15, useUnderBreakpoint as useUnderBreakpoint3 } from "@lls/utils";
import { useEffect as useEffect43, useRef as useRef21 } from "react";
import { useDispatch as useDispatch42, useSelector as useSelector59 } from "react-redux";
import { useLocation as useLocation25 } from "react-router-dom";
var useOnboarding, useOnboarding_default;
var init_useOnboarding = __esm({
  "src/hooks/useOnboarding.ts"() {
    "use strict";
    init_actions();
    init_constants();
    init_onboarding2();
    init_withRouterProvider();
    init_useCustomEffect();
    init_style();
    useOnboarding = () => {
      var _a2;
      const { forceOnboarding } = getQueryParams15(useLocation25());
      const isMobile = useUnderBreakpoint3(BREAKPOINT_PHABLET, true);
      const isTouchable = (_a2 = useAppData()) == null ? void 0 : _a2.isTouchable;
      const hasShownModal = useRef21(false);
      const hasRegisteredLogin = useRef21(false);
      const user = useSelector59(getCurrentUser32);
      const token = useSelector59(getToken11);
      const dispatch = useDispatch42();
      const registerLogin2 = useCustomEffect_default(registerLoginEffect);
      useEffect43(() => {
        var _a3;
        if (((user == null ? void 0 : user.shouldOnboard) || forceOnboarding) && !hasShownModal.current && !isMobile && !isTouchable) {
          dispatch(
            setModal({
              name: ((_a3 = user == null ? void 0 : user.onboardingData) == null ? void 0 : _a3.firstDismissalDate) ? MODAL_ONBOARDING_CHOOSE_TOUR : MODAL_ONBOARDING_CHOOSE_PROFILE,
              open: true
            })
          );
          hasShownModal.current = true;
        }
      }, [dispatch, user, forceOnboarding, isMobile, isTouchable]);
      useEffect43(() => {
        var _a3;
        user && !((_a3 = user == null ? void 0 : user.onboardingData) == null ? void 0 : _a3.lastBookScreenView) && !(user == null ? void 0 : user.isTrial) && !hasRegisteredLogin.current && registerLogin2({ user, token });
        hasRegisteredLogin.current = true;
      }, [registerLogin2, user, token]);
    };
    useOnboarding_default = useOnboarding;
  }
});

// css-modules:css-modules://aGPhAMte6H5VyeQ-WkwhfChTtrLvZGSIIucVK1s5_VQ.css
var init_aGPhAMte6H5VyeQ_WkwhfChTtrLvZGSIIucVK1s5_VQ = __esm({
  "css-modules:css-modules://aGPhAMte6H5VyeQ-WkwhfChTtrLvZGSIIucVK1s5_VQ.css"() {
  }
});

// tmp_esbuild1736180049684/_src_screens_book.module.css
var src_screens_book_default;
var init_src_screens_book = __esm({
  "tmp_esbuild1736180049684/_src_screens_book.module.css"() {
    "use strict";
    init_aGPhAMte6H5VyeQ_WkwhfChTtrLvZGSIIucVK1s5_VQ();
    src_screens_book_default = { "container": "core-XkVDia-container" };
  }
});

// src/screens/book.module.css
var init_book6 = __esm({
  "src/screens/book.module.css"() {
    "use strict";
    init_src_screens_book();
  }
});

// src/screens/book.jsx
var book_exports = {};
__export(book_exports, {
  default: () => book_default2
});
import { useEffect as useEffect44, useMemo as useMemo34, useRef as useRef22 } from "react";
import { useParams as useParams3 } from "react-router-dom";
import { getToken as getToken12, useSearchGroups as useSearchGroups3, useSearchStudents as useSearchStudents2 } from "@lls/store";
import { getCollection as getCollection4 } from "@lls/store";
import { useSearchModifiedPages as useSearchModifiedPages4 } from "@lls/store";
import { makeSearchBooks as makeSearchBooks3, useSearchBooks as useSearchBooks8 } from "@lls/store";
import { getCurrentUser as getCurrentUser33 } from "@lls/store";
import { dispatchAnalyticsEvent as dispatchAnalyticsEvent30, useAnalyticsEventEnhancer as useAnalyticsEventEnhancer4 } from "@lls/utils";
import _131 from "lodash/fp.js";
import { useSelector as useSelector60 } from "react-redux";
import { jsx as jsx121, jsxs as jsxs83 } from "react/jsx-runtime";
var seq3, BookScreen, book_default2;
var init_book7 = __esm({
  "src/screens/book.jsx"() {
    "use strict";
    init_book5();
    init_loading4();
    init_metas();
    init_bookDrawer2();
    init_analytics4();
    init_constants();
    init_fetch();
    init_useDrawer();
    init_useOnboarding();
    init_loading3();
    init_workplan();
    init_book6();
    seq3 = [
      {
        screen: SCREEN_PARTIAL_BOOK_DRAWER
      },
      {
        screen: SCREEN_PARTIAL_BOOK_MAIN,
        getFetchParams: ({ params: { token, uris }, useSelector: useSelector78 }) => {
          var _a2;
          const book = (_a2 = useSelector78((state) => makeSearchBooks3()(state, { uris, hasNewDesign: true }))) == null ? void 0 : _a2[0];
          const collection = useSelector78((state) => getCollection4(state, _131.get("collection", book)));
          const params = { bookId: _131.get("id", book), token, collectionPublisher: _131.get("publisher", collection) };
          return !!token && !!book && params;
        }
      }
    ];
    BookScreen = ({ previousLocation, ssrFetcher }) => {
      var _a2;
      const bookUri = _131.get("bookUri", useParams3());
      const book = (_a2 = useSearchBooks8({ uris: [bookUri], hasNewDesign: true })) == null ? void 0 : _a2[0];
      const currentUser = useSelector60(getCurrentUser33);
      const groups = useSearchGroups3({ ownerIds: [_131.get("id", currentUser)] });
      const students = useSearchStudents2({ ids: _131.get("students", currentUser) });
      const token = useSelector60(getToken12);
      const fetchParams = {
        token,
        isTrial: currentUser == null ? void 0 : currentUser.isTrial,
        isStudent: currentUser == null ? void 0 : currentUser.isStudent,
        uris: [bookUri]
      };
      const fetchedBookRef = useRef22(false);
      const shouldRefreshScreenBook = !fetchedBookRef.current && !!previousLocation;
      const screenToOptions = { [SCREEN_PARTIAL_BOOK_MAIN]: { fetchEvenIfLoaded: shouldRefreshScreenBook } };
      useMultiFetch({ ssrFetcher, screen: SCREEN_MULTIFETCH_BOOK, params: fetchParams, seq: seq3, screenToOptions });
      const isShownStudentTracking = isShownWorkplanStudentTracking(book);
      useAnalyticsEventEnhancer4({
        bookId: _131.get("id", book),
        pageType: isShownStudentTracking ? "workplan_opening" : "textbook"
      });
      const screenReady = useSelector60((state) => getIsLoaded(state, SCREEN_MULTIFETCH_BOOK, fetchParams));
      useEffect44(() => {
        screenReady && dispatchAnalyticsEvent30(ANALYTICS_EVENTS.PAGE_VIEWED, { contentViewFormat: "web" });
      }, [screenReady]);
      useEffect44(() => {
        fetchedBookRef.current = true;
      }, []);
      const modifiedPages = useSearchModifiedPages4({
        chapterIds: _131.get("chapters", book),
        userIds: [_131.get("id", currentUser)]
      });
      const scratchPages = useSearchModifiedPages4({
        bookIds: [_131.get("id", book)],
        isCreatedFromScratch: true,
        userIds: [_131.get("id", currentUser)]
      });
      const drawer = useDrawer_default();
      const metaParams = { book };
      const modifiedPagesWithScratchPages = useMemo34(
        () => [...modifiedPages, ...scratchPages],
        [modifiedPages, scratchPages]
      );
      useOnboarding_default();
      return /* @__PURE__ */ jsxs83("div", { className: src_screens_book_default.container, children: [
        /* @__PURE__ */ jsx121(metas_default, { screen: SCREEN_MULTIFETCH_BOOK, params: metaParams }),
        /* @__PURE__ */ jsx121(loading_default2, { screen: SCREEN_MULTIFETCH_BOOK, params: fetchParams }),
        /* @__PURE__ */ jsx121(
          bookDrawer_default,
          {
            book,
            modifiedPages,
            scratchPages,
            currentUser,
            drawer
          }
        ),
        /* @__PURE__ */ jsx121(
          book_default,
          {
            book,
            drawer,
            modifiedPages: modifiedPagesWithScratchPages,
            currentUser,
            isShownStudentTracking,
            groups,
            students
          }
        )
      ] });
    };
    book_default2 = BookScreen;
  }
});

// css-modules:css-modules://LhFQpWYZHqbn6Xy6j0wS3nqna-Ebz-rzJWYcHgG3NPA.css
var init_LhFQpWYZHqbn6Xy6j0wS3nqna_Ebz_rzJWYcHgG3NPA = __esm({
  "css-modules:css-modules://LhFQpWYZHqbn6Xy6j0wS3nqna-Ebz-rzJWYcHgG3NPA.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_panorama_category.module.css
var src_components_panorama_category_default;
var init_src_components_panorama_category = __esm({
  "tmp_esbuild1736180049684/_src_components_panorama_category.module.css"() {
    "use strict";
    init_LhFQpWYZHqbn6Xy6j0wS3nqna_Ebz_rzJWYcHgG3NPA();
    src_components_panorama_category_default = { "categoryAnchor": "core-ESaYfa-categoryAnchor", "categoryResources": "core-ESaYfa-categoryResources", "resourceGroup": "core-ESaYfa-resourceGroup", "categoryScrollingButton": "core-ESaYfa-categoryScrollingButton", "categoryRow": "core-ESaYfa-categoryRow" };
  }
});

// src/components/panorama/category.module.css
var init_category = __esm({
  "src/components/panorama/category.module.css"() {
    "use strict";
    init_src_components_panorama_category();
  }
});

// css-modules:css-modules://S9q1uqYHUHX-gbCx38ysaAj6E3V-BC63xfmMcaPg1V0.css
var init_S9q1uqYHUHX_gbCx38ysaAj6E3V_BC63xfmMcaPg1V0 = __esm({
  "css-modules:css-modules://S9q1uqYHUHX-gbCx38ysaAj6E3V-BC63xfmMcaPg1V0.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_panorama_resourcePack.module.css
var src_components_panorama_resourcePack_default;
var init_src_components_panorama_resourcePack = __esm({
  "tmp_esbuild1736180049684/_src_components_panorama_resourcePack.module.css"() {
    "use strict";
    init_S9q1uqYHUHX_gbCx38ysaAj6E3V_BC63xfmMcaPg1V0();
    src_components_panorama_resourcePack_default = { "resourceTitle": "core--W8lgW-resourceTitle", "resourceShortDesc": "core--W8lgW-resourceShortDesc", "resource": "core--W8lgW-resource", "resourcesContainer": "core--W8lgW-resourcesContainer", "resourceStamps": "core--W8lgW-resourceStamps", "resourcePicture": "core--W8lgW-resourcePicture" };
  }
});

// src/components/panorama/resourcePack.module.css
var init_resourcePack = __esm({
  "src/components/panorama/resourcePack.module.css"() {
    "use strict";
    init_src_components_panorama_resourcePack();
  }
});

// src/components/panorama/resourcePack.jsx
import { Stamp as Stamp3 } from "@lls/lls-kit";
import _132 from "lodash/fp.js";
import { jsx as jsx122, jsxs as jsxs84 } from "react/jsx-runtime";
var ResourcePack, resourcePack_default;
var init_resourcePack2 = __esm({
  "src/components/panorama/resourcePack.jsx"() {
    "use strict";
    init_panorama2();
    init_resourcePack();
    ResourcePack = ({ selectResourcePack = _132.noop, ...resourcePackDatas }) => {
      const resourcePack = getResourcePackWithType(resourcePackDatas);
      const onClickResource = () => selectResourcePack(resourcePack);
      return /* @__PURE__ */ jsx122("div", { className: src_components_panorama_resourcePack_default.resourcesContainer, style: { "--c-picture": `url(${resourcePack.vignette})` }, children: /* @__PURE__ */ jsxs84("div", { className: src_components_panorama_resourcePack_default.resource, onClick: onClickResource, children: [
        /* @__PURE__ */ jsx122("div", { className: src_components_panorama_resourcePack_default.resourcePicture }),
        /* @__PURE__ */ jsx122("div", { className: src_components_panorama_resourcePack_default.resourceStamps, children: _132.map(
          (tag) => /* @__PURE__ */ jsx122(Stamp3, { theme: "light-red", size: "small", children: tag }, tag),
          resourcePack.tags
        ) }),
        /* @__PURE__ */ jsx122("div", { className: src_components_panorama_resourcePack_default.resourceTitle, dangerouslySetInnerHTML: { __html: resourcePack.title } }),
        /* @__PURE__ */ jsx122("div", { className: src_components_panorama_resourcePack_default.resourceShortDesc, dangerouslySetInnerHTML: { __html: resourcePack.shortDesc } })
      ] }) });
    };
    resourcePack_default = ResourcePack;
  }
});

// src/components/panorama/category.jsx
import { useCallback as useCallback57, useState as useState33 } from "react";
import _133 from "lodash/fp.js";
import { jsx as jsx123, jsxs as jsxs85 } from "react/jsx-runtime";
var Category, category_default;
var init_category2 = __esm({
  "src/components/panorama/category.jsx"() {
    "use strict";
    init_analytics3();
    init_panorama();
    init_ui3();
    init_category();
    init_resourcePack2();
    Category = ({ goal, slug, resourcesPack = [], selectResourcePack = _133.noop }) => {
      const [translation, setTranslation] = useState33(0);
      const title = _133.getOr("", [goal, "title"], WORDING_GOALS);
      const description = _133.getOr("", [goal, "description"], WORDING_GOALS);
      const scrollBack = useCallback57(() => {
        setTranslation((prev) => Math.max(0, prev - 307));
      }, []);
      const scrollForward = useCallback57(() => {
        setTranslation((prev) => Math.min(prev + 307, (resourcesPack.length - 1) * 307));
      }, [resourcesPack]);
      return /* @__PURE__ */ jsxs85("div", { className: src_components_panorama_category_default.resourceGroup, style: { "--c-translation": `-${translation}px` }, children: [
        /* @__PURE__ */ jsx123(
          "div",
          {
            className: src_components_panorama_category_default.categoryAnchor,
            style: { "--cr-navbar-height": `${NAVBAR_HEIGHT}px` },
            "data-scrollto": slug
          }
        ),
        /* @__PURE__ */ jsx123("div", { className: src_components_panorama_category_default.categoryRow, children: /* @__PURE__ */ jsx123("h3", { children: title }) }),
        /* @__PURE__ */ jsxs85("div", { className: src_components_panorama_category_default.categoryRow, children: [
          /* @__PURE__ */ jsx123("h4", { children: description }),
          /* @__PURE__ */ jsx123(
            Button,
            {
              className: src_components_panorama_category_default.categoryScrollingButton,
              icon: "arrowleft",
              theme: "gray",
              inverted: true,
              onClick: scrollBack
            }
          ),
          /* @__PURE__ */ jsx123(
            Button,
            {
              className: src_components_panorama_category_default.categoryScrollingButton,
              icon: "arrowright",
              theme: "gray",
              inverted: true,
              onClick: scrollForward
            }
          )
        ] }),
        /* @__PURE__ */ jsx123("div", { className: src_components_panorama_category_default.categoryResources, children: _133.map.convert({ cap: false })(
          (resourcePack, index3) => /* @__PURE__ */ jsx123(resourcePack_default, { selectResourcePack, ...resourcePack }, index3),
          resourcesPack
        ) })
      ] });
    };
    category_default = Category;
  }
});

// css-modules:css-modules://oRvJTcbLZfo5Il8T_vU2YkrnX9e1l_YhMePwppLd5lQ.css
var init_oRvJTcbLZfo5Il8T_vU2YkrnX9e1l_YhMePwppLd5lQ = __esm({
  "css-modules:css-modules://oRvJTcbLZfo5Il8T_vU2YkrnX9e1l_YhMePwppLd5lQ.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_panorama_panoramaContainer.module.css
var src_components_panorama_panoramaContainer_default;
var init_src_components_panorama_panoramaContainer = __esm({
  "tmp_esbuild1736180049684/_src_components_panorama_panoramaContainer.module.css"() {
    "use strict";
    init_oRvJTcbLZfo5Il8T_vU2YkrnX9e1l_YhMePwppLd5lQ();
    src_components_panorama_panoramaContainer_default = { "panoramaGrow": "core-1MGmcW-panoramaGrow", "panoramaActions": "core-1MGmcW-panoramaActions", "panoramaBody": "core-1MGmcW-panoramaBody", "panorama": "core-1MGmcW-panorama", "container": "core-1MGmcW-container", "panoramaPremiumStampIcon": "core-1MGmcW-panoramaPremiumStampIcon", "panoramaHeader": "core-1MGmcW-panoramaHeader" };
  }
});

// src/components/panorama/panoramaContainer.module.css
var init_panoramaContainer = __esm({
  "src/components/panorama/panoramaContainer.module.css"() {
    "use strict";
    init_src_components_panorama_panoramaContainer();
  }
});

// src/components/panorama/panoramaContainer.jsx
import { useCallback as useCallback58, useEffect as useEffect45, useMemo as useMemo35 } from "react";
import { Icon as Icon10, Stamp as Stamp4 } from "@lls/lls-kit";
import { FULLWIDTH_DRAWER_BREAKPOINT } from "@lls/superkit";
import { getBrowserWidth as getBrowserWidth4, getQueryParams as getQueryParams16, useAnalyticsEventEnhancer as useAnalyticsEventEnhancer5 } from "@lls/utils";
import _134 from "lodash/fp.js";
import { useDispatch as useDispatch43 } from "react-redux";
import { useLocation as useLocation26 } from "react-router-dom";
import { jsx as jsx124, jsxs as jsxs86 } from "react/jsx-runtime";
var useScrollTo, PanoramaContainer, panoramaContainer_default;
var init_panoramaContainer2 = __esm({
  "src/components/panorama/panoramaContainer.jsx"() {
    "use strict";
    init_actions();
    init_analytics3();
    init_bookDrawer2();
    init_constants();
    init_panorama2();
    init_category2();
    init_panoramaContainer();
    useScrollTo = ({ panorama, isMobile, isDrawerOpen, showPanoramaModal }) => {
      const scrollTo = _134.flow(useLocation26, getQueryParams16, _134.get("scrollto"))();
      const resourcePackFromScrollTo = useMemo35(() => {
        const packs = _134.flow(_134.get("category"), _134.flatMap("resourcesPack"))(panorama);
        return getResourcePackWithTypeFromScroll(scrollTo, packs);
      }, [panorama, scrollTo]);
      useEffect45(() => {
        if (scrollTo && (!isMobile || !isDrawerOpen)) {
          if (resourcePackFromScrollTo) {
            showPanoramaModal(resourcePackFromScrollTo);
          } else {
            const node = document.querySelector(`[data-scrollto=${scrollTo}]`);
            if (node) {
              node.scrollIntoView();
            }
          }
        }
      }, [isMobile, isDrawerOpen, scrollTo, resourcePackFromScrollTo, showPanoramaModal]);
    };
    PanoramaContainer = ({ panorama, chapterId, book, drawer }) => {
      const dispatch = useDispatch43();
      const width = getBrowserWidth4();
      const isMobile = width < FULLWIDTH_DRAWER_BREAKPOINT;
      const isDrawerOpen = _134.get("isDrawerOpen", drawer);
      const setIsDrawerOpen2 = _134.get("setIsDrawerOpen", drawer);
      const onFoldSummaryClick = useCallback58(() => {
        setIsDrawerOpen2(!isDrawerOpen);
      }, [isDrawerOpen, setIsDrawerOpen2]);
      const showPanoramaModal = useCallback58(
        (resourcePack) => {
          dispatch(
            setModal({
              name: MODAL_PANORAMA,
              open: true,
              data: {
                chapterId,
                resourcePack,
                isMobile
              }
            })
          );
        },
        [dispatch, isMobile, chapterId]
      );
      const page = useMemo35(() => {
        return getPanoramaPageIfExists({ withPanorama: true, bookId: _134.get("id", book), chapterId });
      }, [book, chapterId]);
      useScrollTo({ panorama, isMobile, isDrawerOpen, showPanoramaModal });
      useAnalyticsEventEnhancer5({ pageId: _134.get("id", page), bookId: _134.get("id", book) });
      return /* @__PURE__ */ jsxs86(
        "div",
        {
          className: src_components_panorama_panoramaContainer_default.container,
          style: {
            "--c-picture": `linear-gradient(0deg, rgb(0, 20, 31) 1%, rgba(0, 20, 31, 0) 56.69%),
    url('${_134.get("header", panorama)}')`
          },
          children: [
            /* @__PURE__ */ jsx124(bookDrawer_default, { page, book, drawer }),
            /* @__PURE__ */ jsxs86("div", { className: src_components_panorama_panoramaContainer_default.panorama, children: [
              /* @__PURE__ */ jsxs86("div", { className: src_components_panorama_panoramaContainer_default.panoramaHeader, children: [
                /* @__PURE__ */ jsxs86("div", { className: src_components_panorama_panoramaContainer_default.panoramaActions, children: [
                  /* @__PURE__ */ jsx124(Button, { icon: "summaryfold", theme: "premium", onClick: onFoldSummaryClick }),
                  /* @__PURE__ */ jsxs86(Stamp4, { theme: "light-red", children: [
                    /* @__PURE__ */ jsx124(Icon10, { className: src_components_panorama_panoramaContainer_default.panoramaPremiumStampIcon, name: "premium", width: "16", height: "16" }),
                    _134.get("stamp", panorama)
                  ] })
                ] }),
                /* @__PURE__ */ jsx124("div", { className: src_components_panorama_panoramaContainer_default.panoramaGrow }),
                /* @__PURE__ */ jsx124("h1", { children: _134.get("title", panorama) }),
                /* @__PURE__ */ jsx124("h2", { children: _134.get("subtitle", panorama) })
              ] }),
              /* @__PURE__ */ jsx124("div", { className: src_components_panorama_panoramaContainer_default.panoramaBody, children: _134.map.convert({ cap: false })(
                (group, index3) => /* @__PURE__ */ jsx124(
                  category_default,
                  {
                    goal: group.goal,
                    slug: goalToSlug(group.goal),
                    resourcesPack: group.resourcesPack,
                    selectResourcePack: showPanoramaModal
                  },
                  index3
                ),
                _134.get("category", panorama)
              ) })
            ] })
          ]
        }
      );
    };
    panoramaContainer_default = PanoramaContainer;
  }
});

// src/screens/panorama.jsx
var panorama_exports = {};
__export(panorama_exports, {
  default: () => panorama_default
});
import { getAuth as getAuth16 } from "@lls/store";
import { getPanorama } from "@lls/store";
import { getBook as getBook5 } from "@lls/store";
import { getBrowserWidth as getBrowserWidth5 } from "@lls/utils";
import _135 from "lodash/fp.js";
import { useEffect as useEffect46, useMemo as useMemo36 } from "react";
import { useSelector as useSelector61 } from "react-redux";
import { jsx as jsx125, jsxs as jsxs87 } from "react/jsx-runtime";
var seq4, PanoramaScreen, panorama_default;
var init_panorama4 = __esm({
  "src/screens/panorama.jsx"() {
    "use strict";
    init_loading4();
    init_metas();
    init_panoramaContainer2();
    init_constants();
    init_panorama();
    init_fetch();
    init_useDrawer();
    init_style();
    seq4 = [
      {
        screen: SCREEN_PARTIAL_PANORAMA_DRAWER
      },
      {
        screen: SCREEN_PARTIAL_PANORAMA_DATA
      }
    ];
    PanoramaScreen = (props) => {
      const bookId = _135.flow(_135.get("match.params.bookId"), _135.parseInt(10))(props);
      const chapterId = _135.flow(_135.get("match.params.chapterId"), _135.parseInt(10))(props);
      const auth2 = useSelector61(getAuth16);
      const token = _135.get("token", auth2);
      const params = useMemo36(() => ({ bookIds: [bookId], token }), [bookId, token]);
      useMultiFetch({ ssrFetcher: props.ssrFetcher, screen: SCREEN_MULTIFETCH_PANORAMA, params, seq: seq4 });
      const panoramaId = _135.get([chapterId, "dataId"], PANORAMA_CHAPTERS);
      const panorama = useSelector61((state) => getPanorama(state, panoramaId));
      const book = useSelector61((state) => getBook5(state, bookId));
      const drawer = useDrawer_default();
      const setIsDrawerOpen2 = _135.get("setIsDrawerOpen", drawer);
      useEffect46(() => {
        _135.noop(chapterId);
        const width = getBrowserWidth5();
        if (width <= BREAKPOINT_PHABLET) setIsDrawerOpen2(false);
      }, [chapterId, setIsDrawerOpen2]);
      return /* @__PURE__ */ jsxs87("div", { children: [
        /* @__PURE__ */ jsx125(metas_default, { screen: SCREEN_MULTIFETCH_PANORAMA, params: { bookId, chapterId } }),
        /* @__PURE__ */ jsx125(loading_default2, { screen: SCREEN_MULTIFETCH_PANORAMA, params }),
        /* @__PURE__ */ jsx125(panoramaContainer_default, { panorama, book, chapterId, drawer })
      ] });
    };
    panorama_default = PanoramaScreen;
  }
});

// src/api/ai.js
var createExerciseStream;
var init_ai = __esm({
  "src/api/ai.js"() {
    "use strict";
    init_rest();
    createExerciseStream = ({ token, pageId, onChunk }) => {
      return getStream("ai/exercise/stream", {
        params: {
          pageId
        },
        token,
        onChunk
      });
    };
  }
});

// src/components/createPage/createPageContainer.jsx
import { getQueryParams as getQueryParams17, useAnalyticsEventEnhancer as useAnalyticsEventEnhancer6 } from "@lls/utils";
import { removeAILoader, transformNDJSONToQuestionCheckbox } from "@lls/viewer/staticImports";
import _136 from "lodash/fp.js";
import { memo as memo4, useCallback as useCallback59, useMemo as useMemo37 } from "react";
import { useDispatch as useDispatch44 } from "react-redux";
import { useLocation as useLocation27 } from "react-router-dom";
import { jsx as jsx126 } from "react/jsx-runtime";
var CreatePageContainer, createPageContainer_default;
var init_createPageContainer = __esm({
  "src/components/createPage/createPageContainer.jsx"() {
    "use strict";
    init_actions();
    init_ai();
    init_viewerContainers2();
    init_pageContent2();
    init_config();
    init_useShare();
    init_summary3();
    CreatePageContainer = ({
      page,
      book,
      isLogged,
      token,
      currentUser,
      toolbar,
      onResourceButtonClick,
      viewerRef,
      viewerReady,
      screenReady
    }) => {
      const queryParams = getQueryParams17(useLocation27());
      const originSlug = queryParams == null ? void 0 : queryParams.originSlug;
      const dispatch = useDispatch44();
      const bookPages = useMemo37(() => extractPages(_136.get("summary", book)), [book]);
      const shareProps = useShare_default({
        page,
        book,
        token,
        currentUser,
        isCreatingPage: true
      });
      useAnalyticsEventEnhancer6({ bookId: _136.get("id", book), ...toolbar == null ? void 0 : toolbar.analyticsProps });
      const onAICreationButtonClick = useCallback59(
        ({ uuid, newTemplate }) => {
          var _a2;
          const chunksAccumulator = [];
          let newPage;
          createExerciseStream({
            token,
            pageId: (_a2 = _136.split("/", originSlug)) == null ? void 0 : _a2[1],
            onChunk: (chunk) => {
              chunksAccumulator.push(JSON.parse(chunk));
              newPage = {
                ...newTemplate,
                children: _136.map(
                  (child) => child.uuid === uuid ? {
                    ...child,
                    ...transformNDJSONToQuestionCheckbox(chunksAccumulator)
                  } : child,
                  newTemplate.children
                )
              };
              dispatch(
                updateEntity({
                  path: ["drafts", newPage.id],
                  entity: newPage
                })
              );
            }
          }).then(() => {
            dispatch(
              updateEntity({
                path: ["drafts", newPage.id],
                entity: removeAILoader(newPage, uuid)
              })
            );
          });
        },
        [token, originSlug, dispatch]
      );
      return /* @__PURE__ */ jsx126(StyledContainer, { "data-ispresentationmode": +(toolbar == null ? void 0 : toolbar.presentationProps.isPresentationMode), children: /* @__PURE__ */ jsx126(StyledViewerWrapperMargin, { children: /* @__PURE__ */ jsx126(StyledViewerWrapper, { children: /* @__PURE__ */ jsx126(
        pageContent_default,
        {
          page,
          currentUser,
          isLogged,
          screenReady,
          book,
          shareProps,
          bookPages,
          token,
          toolbar,
          onResourceButtonClick,
          viewerRef,
          viewerReady,
          hideEnhancedFeatures: true,
          isAICreationButtonEnabled: config_default.feature_skynet && !!originSlug,
          onAICreationButtonClick
        }
      ) }) }) });
    };
    createPageContainer_default = memo4(CreatePageContainer, (old, next) => {
      if (!next.screenReady) {
        return true;
      }
      return _136.isEqual(old, next);
    });
  }
});

// src/components/screenRequisite.jsx
import { getPage as getPage4 } from "@lls/store";
import _137 from "lodash/fp.js";
import { useSelector as useSelector62 } from "react-redux";
import { getAuth as getAuth17 } from "@lls/store";
import { getGroup } from "@lls/store";
import { Fragment as Fragment28, jsx as jsx127, jsxs as jsxs88 } from "react/jsx-runtime";
var useMyMetas, ScreenRequisite, screenRequisite_default;
var init_screenRequisite = __esm({
  "src/components/screenRequisite.jsx"() {
    "use strict";
    init_loading4();
    init_metas();
    init_fetch();
    useMyMetas = (props) => {
      const parentId = _137.flow(_137.get("match.params.parentId"), _137.parseInt(10))(props);
      const parent = useSelector62((state) => getPage4(state, parentId));
      const bookId = _137.flow(_137.get("match.params.bookId"), _137.parseInt(10))(props);
      const groupId = _137.flow(_137.get("match.params.groupId"), _137.parseInt(10))(props);
      const group = useSelector62((state) => getGroup(state, groupId));
      const title = _137.get("title", parent);
      const auth2 = useSelector62(getAuth17);
      const token = _137.get("token", auth2);
      const chapterId = _137.flow(_137.get("match.params.chapterId"), _137.parseInt(10))(props);
      const copyId = _137.flow(_137.get("match.params.copyId"), _137.parseInt(10))(props);
      const copy = useSelector62((state) => getPage4(state, copyId));
      const tool = _137.get("match.params.tool", props);
      return { title, token, chapterId, copy, bookId, parentId, tool, group };
    };
    ScreenRequisite = ({ screen, metaParams: iMetaParams, fetchParams, ssrFetcher, ...props }) => {
      const defaultMetaParams = useMyMetas(props);
      const metaParams = iMetaParams || defaultMetaParams;
      useFetch({
        ssrFetcher,
        screen,
        params: fetchParams
      });
      return /* @__PURE__ */ jsxs88(Fragment28, { children: [
        /* @__PURE__ */ jsx127(metas_default, { screen, params: metaParams }),
        /* @__PURE__ */ jsx127(loading_default2, { screen, params: fetchParams })
      ] });
    };
    screenRequisite_default = ScreenRequisite;
  }
});

// src/hooks/useBookBrowsingModal.js
import _138 from "lodash/fp.js";
import { useCallback as useCallback60, useState as useState34 } from "react";
var useBookBrowsingModal, useBookBrowsingModal_default;
var init_useBookBrowsingModal = __esm({
  "src/hooks/useBookBrowsingModal.js"() {
    "use strict";
    useBookBrowsingModal = ({ page, toolbar, isCreatingPage = false } = {}) => {
      const [uuid, setUuid] = useState34();
      const [isOpen, setIsOpen] = useState34(false);
      const addEntry = _138.get("historyProps.addEntry", toolbar);
      const modalData = {
        close: () => setIsOpen(false),
        isCreatingPage,
        page,
        uuid,
        addEntry
      };
      const onResourceButtonClick = useCallback60(({ uuid: uuid2 }) => {
        setUuid(uuid2);
        setIsOpen(true);
      }, []);
      return {
        isOpen,
        modalData,
        onResourceButtonClick
      };
    };
    useBookBrowsingModal_default = useBookBrowsingModal;
  }
});

// src/selectors/ssr.ts
var getSsrFakePageId;
var init_ssr2 = __esm({
  "src/selectors/ssr.ts"() {
    "use strict";
    getSsrFakePageId = (state) => {
      var _a2;
      return (_a2 = state == null ? void 0 : state.ssr) == null ? void 0 : _a2.fakePageId;
    };
  }
});

// src/screens/createPage.jsx
var createPage_exports = {};
__export(createPage_exports, {
  default: () => createPage_default
});
import { getIsLogged as getIsLogged2, getToken as getToken13, useSearchBooks as useSearchBooks9, useSearchDrafts as useSearchDrafts2 } from "@lls/store";
import { getCurrentUser as getCurrentUser34 } from "@lls/store";
import { displayUser as displayUser4, getQueryParams as getQueryParams18 } from "@lls/utils";
import { fillPageWithEmptyTemplate } from "@lls/viewer/staticImports";
import _139 from "lodash/fp.js";
import { useCallback as useCallback61, useEffect as useEffect47, useMemo as useMemo38, useState as useState35 } from "react";
import { useDispatch as useDispatch45, useSelector as useSelector63 } from "react-redux";
import { useHistory as useHistory35, useLocation as useLocation28, useParams as useParams4 } from "react-router-dom";
import { Fragment as Fragment29, jsx as jsx128, jsxs as jsxs89 } from "react/jsx-runtime";
var CreatePageScreen, createPage_default;
var init_createPage = __esm({
  "src/screens/createPage.jsx"() {
    "use strict";
    init_actions();
    init_createPageContainer();
    init_bookBrowsingModal2();
    init_screenRequisite();
    init_constants();
    init_tour2();
    init_useBookBrowsingModal();
    init_useToolbarAdapter();
    init_useTour();
    init_useUnload();
    init_useViewerReady();
    init_ssr2();
    init_route();
    CreatePageScreen = ({ ssrFetcher }) => {
      var _a2, _b2;
      const queryParams = getQueryParams18(useLocation28());
      const dispatch = useDispatch45();
      const history = useHistory35();
      const isDraft = _139.get("isDraft", queryParams);
      const draftId = _139.get("draftId", queryParams);
      const bookUri = _139.get("bookUri", useParams4());
      useMemo38(() => {
        if (!ssrFetcher) return;
        dispatch(setSsrFakePageId(-1 * (_139.uniqueId() + 1)));
      }, [dispatch, ssrFetcher]);
      const ssrFakePageId = useSelector63(getSsrFakePageId);
      const [fakePageId] = useState35(draftId ? +draftId : ssrFakePageId || -1 * (_139.uniqueId() + 1));
      const book = (_a2 = useSearchBooks9({ uris: [bookUri], hasNewDesign: true })) == null ? void 0 : _a2[0];
      const { viewerRef, viewerReady } = useViewerReady_default({ consumer: VIEWER_CREATE_PAGE, notifyOnUnmount: true });
      const currentUser = useSelector63(getCurrentUser34);
      const bookId = _139.get("id", book);
      const isLogged = useSelector63(getIsLogged2);
      const token = useSelector63(getToken13);
      const originType = _139.get("originType", queryParams);
      const originThematicName = _139.getOr("", "originThematicName", queryParams);
      const fetchParams = { uris: [bookUri] };
      const userName = displayUser4(currentUser);
      const pageTemp = useMemo38(
        () => fillPageWithEmptyTemplate({
          page: {
            id: fakePageId,
            hasNewDesign: true,
            isCreatedFromScratch: true,
            valid: true,
            isDraft: false,
            book: bookId,
            bookId
            // bookId is expected for scratchPage api
          },
          type: originType,
          userName,
          chapterTitle: originThematicName
        }),
        [originType, originThematicName, bookId, fakePageId, userName]
      );
      const pageDraft = (_b2 = useSearchDrafts2({ ids: [fakePageId] })) == null ? void 0 : _b2[0];
      const page = isDraft && !_139.isEmpty(pageDraft) ? pageDraft : pageTemp;
      const metaParams = { book, page };
      const { sendEvent: sendEvent2, tourId } = useTour_default();
      const openWarningSavePageModal = useCallback61(() => {
        !tourId && !(currentUser == null ? void 0 : currentUser.isTrial) && dispatch(setModal({ name: MODAL_WARNING_SAVE_PAGE, open: true, data: { currentPageDraft: pageDraft } }));
      }, [pageDraft, dispatch, tourId, currentUser]);
      useUnload_default({ onUnloadCallback: openWarningSavePageModal, isActive: !_139.isEmpty(pageDraft) && IS_WARNING_MODAL_ENABLED });
      useEffect47(() => {
        if (isDraft) {
          return history.listen((_params, action) => {
            if (action === "PUSH") {
              !isAlreadyOnDraftPage(history, pageDraft) && IS_WARNING_MODAL_ENABLED && openWarningSavePageModal();
            }
          });
        }
      }, [history, openWarningSavePageModal, isDraft, pageDraft]);
      const isCreatingPage = true;
      const toolbar = useToolbarAdapter_default({
        subjectId: _139.get("subjects.0", book),
        book,
        page,
        token,
        screenReady: true,
        isWorkplanStudentTask: false,
        isCreatingPage
      });
      const {
        isOpen: isBrowsingModalOpen,
        modalData: browsingModalData,
        onResourceButtonClick
      } = useBookBrowsingModal_default({ page, toolbar, isCreatingPage });
      const onResourceButtonClickCb = useCallback61(
        (props) => {
          onResourceButtonClick(props);
          sendEvent2(TOUR_EVENTS.CREATION_HELPER_CLICK);
        },
        [onResourceButtonClick, sendEvent2]
      );
      const isTeacher = currentUser == null ? void 0 : currentUser.isTeacher;
      useEffect47(() => {
        const clarity = _139.get("clarity", window);
        if (viewerReady && !_139.isUndefined(clarity)) {
          clarity("set", "feature", "Ecran de cr\xE9ation de page");
          clarity("set", "user_type", isTeacher ? "teacher" : "student");
        }
      }, [viewerReady, isTeacher]);
      return /* @__PURE__ */ jsxs89(Fragment29, { children: [
        /* @__PURE__ */ jsx128(
          screenRequisite_default,
          {
            screen: SCREEN_CREATE_PAGE,
            ssrFetcher,
            fetchParams,
            metaParams
          }
        ),
        /* @__PURE__ */ jsx128(
          createPageContainer_default,
          {
            page,
            book,
            toolbar,
            screenReady: true,
            isLogged,
            token,
            currentUser,
            viewerRef,
            viewerReady,
            onResourceButtonClick: onResourceButtonClickCb
          }
        ),
        isBrowsingModalOpen && /* @__PURE__ */ jsx128(bookBrowsingModal_default, { ...browsingModalData })
      ] });
    };
    createPage_default = CreatePageScreen;
  }
});

// src/hooks/useNps.js
import { getCurrentUser as getCurrentUser35 } from "@lls/store";
import { getQueryParams as getQueryParams19, shouldDisplayNps } from "@lls/utils";
import _140 from "lodash/fp.js";
import { useEffect as useEffect48, useRef as useRef23 } from "react";
import { shallowEqual as shallowEqual7, useDispatch as useDispatch46, useSelector as useSelector64 } from "react-redux";
import { useLocation as useLocation29 } from "react-router-dom";
var useNps, useNps_default;
var init_useNps = __esm({
  "src/hooks/useNps.js"() {
    "use strict";
    init_actions();
    init_constants();
    init_modal();
    init_es62();
    useNps = () => {
      const dispatch = useDispatch46();
      const { currentUser, openModal } = useSelector64(
        (state) => ({
          currentUser: getCurrentUser35(state),
          openModal: getOpenModal(state)
        }),
        shallowEqual7
      );
      const location = useLocation29();
      const pathname = _140.get("pathname", location);
      const [cookies] = useCookies();
      const cookie3 = _140.get(COOKIE_NPS, cookies);
      const forceNps = _140.get("forceNps", getQueryParams19(location));
      const hasRendered = useRef23(false);
      useEffect48(() => {
        if (!hasRendered.current && shouldDisplayNps({ currentUser, cookie: cookie3, forceNps, pathname, hasOpenModal: !!openModal })) {
          dispatch(setModal({ name: MODAL_NPS, open: true, data: { userId: _140.get("id", currentUser) } }));
        }
        hasRendered.current = true;
      }, [cookie3, currentUser, pathname, forceNps, dispatch, openModal]);
    };
    useNps_default = useNps;
  }
});

// src/screens/page.jsx
var page_exports = {};
__export(page_exports, {
  default: () => page_default
});
import { jsx as jsx129, jsxs as jsxs90 } from "react/jsx-runtime";
var PageScreen, page_default;
var init_page5 = __esm({
  "src/screens/page.jsx"() {
    "use strict";
    init_constants();
    init_useBookBrowsingModal();
    init_useGetScreenPageProps();
    init_loading4();
    init_metas();
    init_pageContainer();
    init_bookBrowsingModal2();
    init_useNps();
    PageScreen = (props) => {
      const { loadingParams, metaParams, pageContainerProps } = useGetScreenPageProps_default({ reactRouterProps: props });
      const {
        isOpen: isBrowsingModalOpen,
        modalData: browsingModalData,
        onResourceButtonClick
      } = useBookBrowsingModal_default(pageContainerProps);
      useNps_default();
      return /* @__PURE__ */ jsxs90("div", { children: [
        /* @__PURE__ */ jsx129(metas_default, { screen: SCREEN_MULTIFETCH_PAGE, params: metaParams }),
        /* @__PURE__ */ jsx129(loading_default2, { screen: SCREEN_MULTIFETCH_PAGE, params: loadingParams }),
        /* @__PURE__ */ jsx129(pageContainer_default, { ...pageContainerProps, onResourceButtonClick }),
        isBrowsingModalOpen && /* @__PURE__ */ jsx129(bookBrowsingModal_default, { ...browsingModalData })
      ] });
    };
    page_default = PageScreen;
  }
});

// src/screens/workplanStudentPage.jsx
var workplanStudentPage_exports = {};
__export(workplanStudentPage_exports, {
  default: () => workplanStudentPage_default
});
import { getQueryParams as getQueryParams20 } from "@lls/utils";
import { buildPageWithStudentStats } from "@lls/viewer/staticImports";
import _141 from "lodash/fp.js";
import { useEffect as useEffect49, useMemo as useMemo39, useState as useState36 } from "react";
import { useDispatch as useDispatch47, useSelector as useSelector65 } from "react-redux";
import { useLocation as useLocation30, useParams as useParams5 } from "react-router-dom";
import { getAuth as getAuth18, useSearchStudents as useSearchStudents3 } from "@lls/store";
import { getGroup as getGroup2 } from "@lls/store";
import { getCurrentUser as getCurrentUser36 } from "@lls/store";
import { jsx as jsx130, jsxs as jsxs91 } from "react/jsx-runtime";
var WorkplanStudentPageScreen, workplanStudentPage_default;
var init_workplanStudentPage = __esm({
  "src/screens/workplanStudentPage.jsx"() {
    "use strict";
    init_constants();
    init_useBookBrowsingModal();
    init_useGetScreenPageProps();
    init_loading4();
    init_metas();
    init_bookBrowsingModal2();
    init_pageContainer();
    init_stats2();
    WorkplanStudentPageScreen = (props) => {
      const queryParams = getQueryParams20(useLocation30());
      const studentId = _141.flow(_141.get("studentId"), _141.parseInt(10))(useParams5());
      const pageId = _141.flow(_141.get("pageId"), _141.parseInt(10))(useParams5());
      const groupId = _141.flow(_141.get("groupId"), _141.parseInt(10))(queryParams);
      const dispatch = useDispatch47();
      const auth2 = useSelector65(getAuth18);
      const token = _141.get("token", auth2);
      const currentUser = useSelector65(getCurrentUser36);
      const group = useSelector65((state) => getGroup2(state, groupId));
      const students = useSearchStudents3({ ids: _141.get("students", currentUser) });
      const workplanStudents = useMemo39(
        () => group ? _141.flow(_141.filter((student) => _141.includes(student.id, _141.get("students", group))))(students) : students,
        [group, students]
      );
      const { loadingParams, metaParams, pageContainerProps } = useGetScreenPageProps_default({
        reactRouterProps: props,
        slug: `page/${pageId}`,
        isWorkplanStudentTask: true
      });
      const { isOpen: isBrowsingModalOpen, modalData: browsingModalData, onResourceButtonClick } = useBookBrowsingModal_default();
      const [stats, setStats] = useState36({});
      useEffect49(() => {
        async function fetchData2() {
          const fetchedStats = await fetchStatsEffect({
            dispatch,
            params: {
              token,
              dataSource: "workplan",
              tab: WORKPLAN_TAB,
              pageIds: [pageId],
              studentIds: [_141.parseInt(10, studentId)]
            }
          });
          setStats(_141.get("userId", fetchedStats));
        }
        studentId && fetchData2();
      }, [dispatch, token, pageId, studentId]);
      const studentStats = _141.get(studentId, stats);
      const page = _141.get("page", pageContainerProps);
      const pageWithStats = useMemo39(() => {
        return buildPageWithStudentStats({ page, stats: studentStats, studentId });
      }, [page, studentStats, studentId]);
      return /* @__PURE__ */ jsxs91("div", { children: [
        /* @__PURE__ */ jsx130(metas_default, { screen: SCREEN_MULTIFETCH_PAGE, params: metaParams }),
        /* @__PURE__ */ jsx130(loading_default2, { screen: SCREEN_MULTIFETCH_PAGE, params: loadingParams }),
        /* @__PURE__ */ jsx130(
          pageContainer_default,
          {
            ..._141.omit("page", pageContainerProps),
            page: pageWithStats,
            isWorkplanStudentTask: true,
            onResourceButtonClick,
            students: workplanStudents
          }
        ),
        isBrowsingModalOpen && /* @__PURE__ */ jsx130(bookBrowsingModal_default, { ...browsingModalData })
      ] });
    };
    workplanStudentPage_default = WorkplanStudentPageScreen;
  }
});

// src/components/readonly/index.jsx
import { useWasSsrRendered as useWasSsrRendered2 } from "@lls/utils";
import _142 from "lodash/fp.js";
import { useMemo as useMemo40, useState as useState37 } from "react";
import { jsx as jsx131 } from "react/jsx-runtime";
var ReadonlyComponent, readonly_default;
var init_readonly = __esm({
  "src/components/readonly/index.jsx"() {
    "use strict";
    init_viewerContainers2();
    init_notReachable2();
    init_viewer3();
    init_route();
    init_summary3();
    ReadonlyComponent = ({ page, book, chapter, screenReady, viewerRef, toolbar, tabId, setTabId }) => {
      const [aRenewalDisplayed, setRenewalDisplayed] = useState37(true);
      const renewalDisplayed = aRenewalDisplayed || !_142.some("renewalUpdatedAt", page == null ? void 0 : page.children);
      const wasSsrRendered = useWasSsrRendered2();
      const onConnect = () => redirectToConnect();
      const bookPages = useMemo40(() => extractPages(_142.get("summary", book)), [book]);
      const viewerProps = {
        isHidden: !screenReady,
        page,
        readonly: true,
        wasSsrRendered,
        viewerRef,
        forceShowAnswerButton: false,
        onConnect,
        bookPages,
        toolbar,
        renewalDisplayed,
        setRenewalDisplayed,
        tabId,
        setTabId
      };
      return /* @__PURE__ */ jsx131(notReachable_default, { page, chapter, book, screenReady, children: /* @__PURE__ */ jsx131(StyledContainer, { "data-ispresentationmode": 0, children: /* @__PURE__ */ jsx131(StyledViewerWrapperMargin, { "data-isdraweropen": 0, children: /* @__PURE__ */ jsx131(StyledViewerWrapper, { children: /* @__PURE__ */ jsx131(viewer_default, { ...viewerProps }) }) }) }) });
    };
    readonly_default = ReadonlyComponent;
  }
});

// css-modules:css-modules://yUvPO9T0w2hk1B6YEiyE_-5lj5rFKPRs6y-amICG_Gg.css
var init_yUvPO9T0w2hk1B6YEiyE_5lj5rFKPRs6y_amICG_Gg = __esm({
  "css-modules:css-modules://yUvPO9T0w2hk1B6YEiyE_-5lj5rFKPRs6y-amICG_Gg.css"() {
  }
});

// tmp_esbuild1736180049684/_src_components_readonly_readonlyBanner.module.css
var src_components_readonly_readonlyBanner_default;
var init_src_components_readonly_readonlyBanner = __esm({
  "tmp_esbuild1736180049684/_src_components_readonly_readonlyBanner.module.css"() {
    "use strict";
    init_yUvPO9T0w2hk1B6YEiyE_5lj5rFKPRs6y_amICG_Gg();
    src_components_readonly_readonlyBanner_default = { "bannerSubtitle": "core-lqr6BG-bannerSubtitle", "premium": "core-lqr6BG-premium", "bannerTitle": "core-lqr6BG-bannerTitle", "readonlyBanner": "core-lqr6BG-readonlyBanner" };
  }
});

// src/components/readonly/readonlyBanner.module.css
var init_readonlyBanner = __esm({
  "src/components/readonly/readonlyBanner.module.css"() {
    "use strict";
    init_src_components_readonly_readonlyBanner();
  }
});

// src/components/readonly/readonlyBanner.jsx
import { Wavy as Wavy11, Z_NAVBAR as Z_NAVBAR3 } from "@lls/lls-kit";
import { jsx as jsx132, jsxs as jsxs92 } from "react/jsx-runtime";
var WavyConnect, ReadonlyBanner, readonlyBanner_default;
var init_readonlyBanner2 = __esm({
  "src/components/readonly/readonlyBanner.jsx"() {
    "use strict";
    init_ui3();
    init_route();
    init_readonlyBanner();
    WavyConnect = ({ children }) => /* @__PURE__ */ jsx132(Wavy11, { waveColor: "var(--secondary-20-color)", children });
    ReadonlyBanner = () => /* @__PURE__ */ jsxs92(
      "div",
      {
        className: src_components_readonly_readonlyBanner_default.readonlyBanner,
        style: { "--c-z-navbar": Z_NAVBAR3, "--cr-readonly-banner-height": `${READONLY_BANNER_HEIGHT}px` },
        onClick: redirectToConnect,
        children: [
          /* @__PURE__ */ jsx132("h1", { className: src_components_readonly_readonlyBanner_default.bannerTitle, children: "Les fonctionnalit\xE9s sont limit\xE9es car vous n'\xEAtes pas connect\xE9" }),
          /* @__PURE__ */ jsxs92("h3", { className: src_components_readonly_readonlyBanner_default.bannerSubtitle, children: [
            /* @__PURE__ */ jsx132(WavyConnect, { children: /* @__PURE__ */ jsx132("b", { children: "Connectez-vous" }) }),
            " ",
            "pour acc\xE9der \xE0 votre espace et profiter pleinement de l'exp\xE9rience ",
            /* @__PURE__ */ jsx132("b", { className: src_components_readonly_readonlyBanner_default.premium, children: "Premium" }),
            "."
          ] })
        ]
      }
    );
    readonlyBanner_default = ReadonlyBanner;
  }
});

// src/screens/readonly.jsx
var readonly_exports = {};
__export(readonly_exports, {
  default: () => readonly_default2
});
import _143 from "lodash/fp.js";
import { useParams as useParams6 } from "react-router-dom";
import { jsx as jsx133, jsxs as jsxs93 } from "react/jsx-runtime";
var ReadonlyScreen, readonly_default2;
var init_readonly2 = __esm({
  "src/screens/readonly.jsx"() {
    "use strict";
    init_constants();
    init_useGetScreenPageProps();
    init_loading4();
    init_metas();
    init_readonly();
    init_readonlyBanner2();
    ReadonlyScreen = (props) => {
      const pageId = _143.flow(_143.get("pageId"), _143.parseInt(10))(useParams6());
      const { loadingParams, metaParams, pageContainerProps } = useGetScreenPageProps_default({
        reactRouterProps: props,
        slug: `page/${pageId}`,
        readonly: true
      });
      return /* @__PURE__ */ jsxs93("div", { children: [
        /* @__PURE__ */ jsx133(metas_default, { screen: SCREEN_READONLY, params: metaParams }),
        /* @__PURE__ */ jsx133(loading_default2, { screen: SCREEN_READONLY, params: loadingParams }),
        /* @__PURE__ */ jsx133(readonlyBanner_default, {}),
        /* @__PURE__ */ jsx133(readonly_default, { ...pageContainerProps })
      ] });
    };
    readonly_default2 = ReadonlyScreen;
  }
});

// css-modules:css-modules://mjxovuiPEi1CZJDpBHEGjt34pVJU4K56KF5LlqJQSyo.css
var init_mjxovuiPEi1CZJDpBHEGjt34pVJU4K56KF5LlqJQSyo = __esm({
  "css-modules:css-modules://mjxovuiPEi1CZJDpBHEGjt34pVJU4K56KF5LlqJQSyo.css"() {
  }
});

// tmp_esbuild1736180049684/_src_screens_copies.module.css
var src_screens_copies_default;
var init_src_screens_copies = __esm({
  "tmp_esbuild1736180049684/_src_screens_copies.module.css"() {
    "use strict";
    init_mjxovuiPEi1CZJDpBHEGjt34pVJU4K56KF5LlqJQSyo();
    src_screens_copies_default = { "container": "core-IQ-B4a-container", "contentTable": "core-IQ-B4a-contentTable" };
  }
});

// src/screens/copies.module.css
var init_copies = __esm({
  "src/screens/copies.module.css"() {
    "use strict";
    init_src_screens_copies();
  }
});

// src/screens/copies.jsx
var copies_exports = {};
__export(copies_exports, {
  default: () => copies_default
});
import { CopiesBreadcrumb, CopiesTable } from "@lls/superkit";
import { getQueryParams as getQueryParams21, useAnalyticsEventEnhancer as useAnalyticsEventEnhancer7 } from "@lls/utils";
import _144 from "lodash/fp.js";
import { useCallback as useCallback62, useEffect as useEffect50, useState as useState38 } from "react";
import { useSelector as useSelector66 } from "react-redux";
import { useHistory as useHistory36, useLocation as useLocation31 } from "react-router-dom";
import {
  getAuth as getAuth19,
  useSearchCopyNotifications,
  useSearchCurrentUserSharedPages as useSearchCurrentUserSharedPages5,
  useSearchGroups as useSearchGroups4,
  useSearchStudents as useSearchStudents4,
  useSearchUsers as useSearchUsers3
} from "@lls/store";
import { getStudents } from "@lls/store";
import { getPage as getPage5 } from "@lls/store";
import { getBook as getBook6 } from "@lls/store";
import { getCurrentUser as getCurrentUser37 } from "@lls/store";
import { Fragment as Fragment30, jsx as jsx134, jsxs as jsxs94 } from "react/jsx-runtime";
var CopiesScreen, copies_default;
var init_copies2 = __esm({
  "src/screens/copies.jsx"() {
    "use strict";
    init_screenRequisite();
    init_constants();
    init_ui3();
    init_notification3();
    init_useCustomEffect();
    init_useReadDrawerNotification();
    init_notificationEntity();
    init_route();
    init_copies();
    CopiesScreen = (props) => {
      const history = useHistory36();
      const location = useLocation31();
      const query = getQueryParams21(location);
      const defaultGroupId = _144.isNil(query == null ? void 0 : query.defaultGroup) ? void 0 : _144.toFinite(query.defaultGroup);
      const markNotificationAsNotReadEffectFn = useCustomEffect_default(markNotificationAsNotReadEffect);
      const parentId = _144.flow(_144.get("match.params.parentId"), Number.parseInt)(props);
      const parent = useSelector66((state) => getPage5(state, parentId));
      const book = useSelector66((state) => getBook6(state, _144.get("book", parent)));
      const currentUser = useSelector66(getCurrentUser37);
      const groups = useSearchGroups4({ ownerIds: [_144.get("id", currentUser)] });
      const sharedPages = useSearchCurrentUserSharedPages5({ parentIds: [parentId] });
      useAnalyticsEventEnhancer7({ pageId: parentId, bookId: _144.get("id", book) });
      const readCopyNotifications = useSearchCopyNotifications({ pageIds: _144.map("id", sharedPages), read: true });
      const sharedPagesStudents = useSearchUsers3({ ids: _144.map("user", sharedPages) });
      const studentIdsFromGroup = _144.flatMap("students", groups);
      const students = useSearchStudents4({ ids: studentIdsFromGroup });
      const allStudents = _144.flow(_144.concat(sharedPagesStudents), _144.uniqBy("id"))(students);
      const allStudentsFromSchool = useSelector66(getStudents);
      const auth2 = useSelector66(getAuth19);
      const token = _144.get("token", auth2);
      const onGoBack = useCallback62(() => history.push(getPath("page", parent)), [history, parent]);
      const onManageGroupClick = useCallback62(() => history.push(getPath("classroom_settings")), [history]);
      const onCopyClick = useCallback62(
        (page) => {
          history.push(getPath("copy", { parentId, copyId: page.id }));
        },
        [parentId, history]
      );
      const markAsNotRead = useCallback62(
        (pageId) => {
          const notification = getNotificationByPageId(readCopyNotifications, pageId);
          markNotificationAsNotReadEffectFn({ notification, token });
        },
        [markNotificationAsNotReadEffectFn, token, readCopyNotifications]
      );
      useEffect50(() => {
        if (!_144.get("isTeacher", currentUser)) history.push(getPath("home"));
      }, [currentUser, history]);
      const [shareGroup, setShareGroup] = useState38(null);
      const onShareGroup = useCallback62(() => {
        shareGroup && history.push(getPath("corrections", { parentId, groupId: _144.get("id", shareGroup) }));
      }, [parentId, history, shareGroup]);
      const [shareStudents, setShareStudents] = useState38(null);
      const onShareStudents = useCallback62(() => {
        !_144.isEmpty(shareStudents) && history.push(getPath("corrections_students", { parentId, query: { studentIds: _144.map("id", shareStudents) } }));
      }, [parentId, history, shareStudents]);
      useReadDrawerNotification_default({ pageId: parentId });
      const fetchParams = { parentId, token };
      return /* @__PURE__ */ jsxs94(Fragment30, { children: [
        /* @__PURE__ */ jsx134(screenRequisite_default, { screen: SCREEN_COPIES, fetchParams, ...props }),
        /* @__PURE__ */ jsxs94("div", { className: src_screens_copies_default.container, style: { "--cr-navbar-height": `${NAVBAR_HEIGHT}px` }, children: [
          /* @__PURE__ */ jsx134(
            CopiesBreadcrumb,
            {
              page: parent,
              book,
              onGoBack,
              onManageGroupClick,
              groups,
              showSharebutton: true,
              shareGroup,
              setShareGroup,
              onShareGroup,
              students: allStudentsFromSchool,
              setSelectedStudents: setShareStudents,
              selectedStudents: shareStudents,
              onShareStudents
            }
          ),
          /* @__PURE__ */ jsx134("div", { className: src_screens_copies_default.contentTable, children: /* @__PURE__ */ jsx134(
            CopiesTable,
            {
              groups,
              sharedPages,
              students: allStudents,
              readPageIds: _144.map("page", readCopyNotifications),
              onCopyClick,
              onManageGroupClick,
              markAsNotRead,
              defaultGroupId
            }
          ) })
        ] })
      ] });
    };
    copies_default = CopiesScreen;
  }
});

// src/api/group.js
import { normalizeData as normalizeData9 } from "@lls/store";
var updateGroup, createGroup, addStudentToGroup, deleteGroup, addCorrectionsToGroup;
var init_group = __esm({
  "src/api/group.js"() {
    "use strict";
    init_graphql();
    updateGroup = ({ token, group }) => gqlNoCache({
      query: `mutation ($token: String!, $group: GroupInput!) {
      viewer(token: $token) {
        updateGroup(group: $group) {
          id
          name
          code
          isEnt
          students {
            id
          }
        }
      }
    }`,
      variables: {
        token,
        group
      }
    }).then(normalizeData9);
    createGroup = ({ token, group }) => gqlNoCache({
      query: `mutation ($token: String!, $group: GroupInput!) {
      viewer(token: $token) {
        createGroup(group: $group) {
          id
          name
          code
          createdAt
          isEnt
          owner {
            id
          }
          students {
            id
          }
        }
      }
    }`,
      variables: {
        token,
        group
      }
    }).then(normalizeData9);
    addStudentToGroup = ({ token, code }) => gqlNoCache({
      query: `mutation ($token: String!, $code: String!) {
      viewer(token: $token) {
        addStudentToGroup(code: $code) {
          id
          name
          code
          createdAt
          isEnt
          owner {
            id
            gender
            lastname
            firstname
            isTeacher
          }
          students {
            id
          }
        }
      }
    }`,
      variables: {
        token,
        code
      }
    }).then(normalizeData9);
    deleteGroup = ({ token, group }) => gqlNoCache({
      query: `mutation ($token: String!, $group: GroupInput!) {
      viewer(token: $token) {
        deleteGroup (group: $group) {
          id
        }
      }
    }`,
      variables: {
        token,
        group
      }
    });
    addCorrectionsToGroup = ({ token, groupId, corrections, studentPages }) => gqlNoCache({
      query: `mutation($token: String!, $groupId: Int!, $corrections: [GroupCorrectionDocumentsInput]! $studentPages: [GroupCorrectionStudentPageInput]!){
    viewer(token: $token){
      addCorrectionsToGroup(groupId: $groupId, corrections: $corrections, studentPages: $studentPages){
        id
        name
        sharedCorrections{
          pageId
          uuids
          correctedUuids
          updatedAt
        }
      }
    }
  }`,
      variables: {
        token,
        groupId,
        corrections,
        studentPages
      }
    }).then(normalizeData9);
  }
});

// src/effects/group.js
import { dispatchAnalyticsEvent as dispatchAnalyticsEvent31, displayUser as displayUser5, getAddedStudentsMessage, getDuplicatedGroup, groupData } from "@lls/utils";
import _145 from "lodash/fp.js";
var createGroup2, addStudentToGroup2, deleteGroup2, updateGroup2, addCorrectionsToGroup2, trialDisabledEffect, shareLearningAssessmentSession, addStudentToGroupEffect, createGroupEffect, deleteGroupEffect, updateGroupEffect, addCorrectionsToGroupEffect, shareLearningAssessmentSessionEffect;
var init_group2 = __esm({
  "src/effects/group.js"() {
    "use strict";
    init_actions();
    init_group();
    init_page();
    init_analytics4();
    init_utils3();
    init_route();
    init_string();
    createGroup2 = async ({ dispatch, params: { token, group, groups, isDuplicated = false } }) => {
      const groupToCreate = isDuplicated ? getDuplicatedGroup({ group, groups }) : group;
      const { entities: entities2 } = await createGroup({ token, group: groupData(groupToCreate) });
      isDuplicated && dispatchAnalyticsEvent31(ANALYTICS_EVENTS.GROUP_DUPLICATED);
      dispatch(setEntities(entities2));
      if (isDuplicated) {
        triggerNotification({
          name: "success",
          message: `Classe "${_145.get("name", group)}" dupliqu\xE9e avec succ\xE8s !`,
          params: { clarityHidden: true },
          dispatch
        });
      }
    };
    addStudentToGroup2 = async ({ dispatch, history, params: { token, code } }) => {
      const { entities: entities2, result } = await addStudentToGroup({ token, code });
      dispatch(setEntities(entities2));
      const groupId = _145.get("viewer.addStudentToGroup", result);
      const ownerId = _145.get(["groups", groupId, "owner"], entities2);
      const groupName = _145.get(["groups", groupId, "name"], entities2);
      const teacher = _145.get(["teachers", ownerId], entities2);
      history.push(getPath("home"));
      triggerNotification({
        name: "success",
        message: `Vous avez bien rejoint la classe ${groupName} de ${displayUser5(teacher)}`,
        params: { clarityHidden: true },
        dispatch
      });
    };
    deleteGroup2 = async ({ dispatch, params: { token, group, callback = _145.noop } }) => {
      await deleteGroup({ token, group: groupData(group) });
      dispatch(deleteEntity({ path: `groups.${_145.get("id", group)}` }));
      triggerNotification({
        name: "success",
        message: `Classe "${_145.get("name", group)}" supprim\xE9e !`,
        params: { clarityHidden: true },
        dispatch
      });
      callback();
    };
    updateGroup2 = async ({ dispatch, params: { token, currentGroup, updatedGroup } }) => {
      const { entities: entities2 } = await updateGroup({ token, group: groupData(updatedGroup) });
      const updatedMessage = getAddedStudentsMessage({ currentGroup, updatedGroup });
      dispatch(setEntities(entities2));
      triggerNotification({
        name: "success",
        message: !_145.isNull(updatedMessage) ? `Classe mise \xE0 jour : ${updatedMessage}` : "Classe mise \xE0 jour",
        params: { clarityHidden: true },
        dispatch
      });
    };
    addCorrectionsToGroup2 = async ({
      dispatch,
      history,
      params: { token, group, corrections, parentId, sharedPages }
    }) => {
      const studentPages = _145.map((page) => {
        return {
          pageId: page.id,
          userId: page.user
        };
      }, sharedPages);
      const { entities: entities2 } = await addCorrectionsToGroup({
        token,
        groupId: _145.get("id", group),
        parentId,
        corrections,
        studentPages
      });
      const sharedCorrections = _145.get(`groups.${_145.get("id", group)}.sharedCorrections`, entities2);
      const updatedSharedPages = _145.map(_145.set("sharedCorrections", sharedCorrections), sharedPages);
      dispatch(setEntities({ ...entities2, sharedPages: _145.keyBy("id", updatedSharedPages) }));
      triggerNotification({
        name: "success",
        message: `Les corrig\xE9s sont partag\xE9s avec ${_145.get("name", group)}`,
        params: { title: "Corrections partag\xE9es", clarityHidden: true },
        dispatch
      });
      history.push(getPath("copies", { parentId }));
    };
    trialDisabledEffect = ({ dispatch, params, effect }) => {
      var _a2;
      if ((_a2 = params == null ? void 0 : params.currentUser) == null ? void 0 : _a2.isTrial) {
        !(params == null ? void 0 : params.silent) && triggerNotification({ name: "trial_disabled_feature", dispatch });
        return _145.noop;
      }
      return effect;
    };
    shareLearningAssessmentSession = async ({ dispatch, params: { page, title, token, groups } }) => {
      const pageToSave = {
        ...page,
        title: title || _145.get("title", page),
        parent: _145.get("id", page),
        bookId: void 0
      };
      const {
        entities: entities2,
        result: {
          viewer: { createPage: createPageId }
        }
      } = await createPageApi({
        token,
        page: pageToSave
      });
      const groupIds = _145.map("id", groups);
      await Promise.all(_145.map((groupId) => sharePageToGroupApi({ pageId: createPageId, groupId, token }), groupIds));
      dispatch(setEntities(entities2));
      dispatch(
        setEntity({
          path: `pages.${createPageId}`,
          entity: {
            ..._145.get(`pages.${createPageId}`, entities2),
            sharedGroups: groupIds
          }
        })
      );
      triggerNotification({
        name: "success",
        message: `La session a \xE9t\xE9 partag\xE9e avec succ\xE8s ${_145.size(groups) > 1 ? "aux" : "\xE0 la"} ${handlePlural("classe", groups)} ${handlePlural(
          "suivante",
          groups
        )} : ${_145.flow(_145.map("name"), _145.join(", "))(groups)}.`,
        params: { title: "Session cr\xE9\xE9e", clarityHidden: true },
        dispatch
      });
    };
    addStudentToGroupEffect = ({ dispatch, params, history }) => tryCatch({ dispatch, history, effect: trialDisabledEffect({ dispatch, params, effect: addStudentToGroup2 }), params });
    createGroupEffect = ({ dispatch, params }) => tryCatch({ dispatch, effect: trialDisabledEffect({ dispatch, params, effect: createGroup2 }), params });
    deleteGroupEffect = ({ dispatch, params }) => tryCatch({ dispatch, effect: trialDisabledEffect({ dispatch, params, effect: deleteGroup2 }), params });
    updateGroupEffect = ({ dispatch, params }) => tryCatch({ dispatch, effect: trialDisabledEffect({ dispatch, params, effect: updateGroup2 }), params });
    addCorrectionsToGroupEffect = ({ dispatch, history, params }) => tryCatch({
      dispatch,
      history,
      effect: trialDisabledEffect({ dispatch, params, effect: addCorrectionsToGroup2 }),
      params
    });
    shareLearningAssessmentSessionEffect = ({ dispatch, history, params }) => tryCatch({
      dispatch,
      history,
      effect: trialDisabledEffect({ dispatch, params, effect: shareLearningAssessmentSession }),
      params
    });
  }
});

// src/utils/classroom.js
var buildUrlCodeClassroomPdf;
var init_classroom = __esm({
  "src/utils/classroom.js"() {
    "use strict";
    init_config();
    buildUrlCodeClassroomPdf = ({ classroomId, token }) => `${config_default.api_url}/codes/${classroomId}/classroom?access_token=${token}`;
  }
});

// css-modules:css-modules://BRuYqHcfP6oXPCYUcMi5fHp7ZRybRTgjWkiy__1FG9o.css
var init_BRuYqHcfP6oXPCYUcMi5fHp7ZRybRTgjWkiy_1FG9o = __esm({
  "css-modules:css-modules://BRuYqHcfP6oXPCYUcMi5fHp7ZRybRTgjWkiy__1FG9o.css"() {
  }
});

// tmp_esbuild1736180049684/_src_screens_classroom.module.css
var src_screens_classroom_default;
var init_src_screens_classroom = __esm({
  "tmp_esbuild1736180049684/_src_screens_classroom.module.css"() {
    "use strict";
    init_BRuYqHcfP6oXPCYUcMi5fHp7ZRybRTgjWkiy_1FG9o();
    src_screens_classroom_default = { "groupsContainer": "core-lZG6YW-groupsContainer" };
  }
});

// src/screens/classroom.module.css
var init_classroom2 = __esm({
  "src/screens/classroom.module.css"() {
    "use strict";
    init_src_screens_classroom();
  }
});

// src/screens/classroom.jsx
var classroom_exports = {};
__export(classroom_exports, {
  default: () => classroom_default
});
import { CLASSROOM_STEP, Classrooms } from "@lls/superkit";
import _146 from "lodash/fp.js";
import { useCallback as useCallback63, useEffect as useEffect51 } from "react";
import { useDispatch as useDispatch48, useSelector as useSelector67 } from "react-redux";
import { getAuth as getAuth20, useSearchLevels as useSearchLevels3, useSearchStudents as useSearchStudents5 } from "@lls/store";
import { getTeachers } from "@lls/store";
import { getGroups } from "@lls/store";
import { getGarDivisions } from "@lls/store";
import { getCurrentUser as getCurrentUser38 } from "@lls/store";
import { SECONDARY_SCHOOL_TYPES_SLUGS as SECONDARY_SCHOOL_TYPES_SLUGS3, dispatchAnalyticsEvent as dispatchAnalyticsEvent32, getQueryParams as getQueryParams22, openWindow as openWindow19 } from "@lls/utils";
import { Redirect as Redirect2, useHistory as useHistory37, useLocation as useLocation32, useParams as useParams7 } from "react-router-dom";
import { Fragment as Fragment31, jsx as jsx135, jsxs as jsxs95 } from "react/jsx-runtime";
var getStepFromRoute, getRouteToStep, getPageType, ClassroomScreen, classroom_default;
var init_classroom3 = __esm({
  "src/screens/classroom.jsx"() {
    "use strict";
    init_loading4();
    init_metas();
    init_analytics4();
    init_constants();
    init_trial2();
    init_group2();
    init_trial3();
    init_utils3();
    init_withRouterProvider();
    init_fetch();
    init_useCustomEffect();
    init_loading3();
    init_classroom();
    init_route();
    init_classroom2();
    getStepFromRoute = ({ pathname, classroomId }) => {
      switch (pathname) {
        case "/mesclasses/add/choose":
          return CLASSROOM_STEP.CHOOSE_CLASSROOM_TYPE;
        case "/mesclasses/add/ent":
          return CLASSROOM_STEP.ADD_ENT_CLASSROOM;
        case "/mesclasses/add/custom":
          return CLASSROOM_STEP.ADD_CUSTOM_CLASSROOM;
        case "/mesclasses/add/retrieve":
          return CLASSROOM_STEP.SUCCES_RETRIEVE_CLASS;
        case "/mesclasses/add/success":
          return CLASSROOM_STEP.SUCCES_ADDED_CLASS;
        default:
          return _146.isNil(classroomId) ? CLASSROOM_STEP.ALL_CLASSROOMS : CLASSROOM_STEP.CLASSROOM;
      }
    };
    getRouteToStep = ({ step, classroomId, withInviteModal }) => {
      switch (step) {
        case CLASSROOM_STEP.CHOOSE_CLASSROOM_TYPE:
          return { pathname: "/mesclasses/add/choose" };
        case CLASSROOM_STEP.ADD_ENT_CLASSROOM:
          return { pathname: "/mesclasses/add/ent" };
        case CLASSROOM_STEP.ADD_CUSTOM_CLASSROOM:
          return { pathname: "/mesclasses/add/custom" };
        case CLASSROOM_STEP.SUCCES_RETRIEVE_CLASS:
          return { pathname: "/mesclasses/add/retrieve" };
        case CLASSROOM_STEP.SUCCES_ADDED_CLASS:
          return { pathname: "/mesclasses/add/success" };
        case CLASSROOM_STEP.ALL_CLASSROOMS:
          return { pathname: "/mesclasses" };
        case CLASSROOM_STEP.CLASSROOM:
          return { pathname: `/mesclasses/${classroomId}`, search: withInviteModal ? "?withInviteModal=true" : "" };
      }
    };
    getPageType = (step) => {
      switch (step) {
        case CLASSROOM_STEP.CHOOSE_CLASSROOM_TYPE:
          return "Cr\xE9ation de groupes \xE9tape 1";
        case CLASSROOM_STEP.ADD_ENT_CLASSROOM:
          return "Cr\xE9ation de groupes ENT \xE9tape 2";
        case CLASSROOM_STEP.ADD_CUSTOM_CLASSROOM:
          return "Cr\xE9ation de groupes manuelle \xE9tape 2";
      }
    };
    ClassroomScreen = ({ ssrFetcher }) => {
      var _a2;
      const history = useHistory37();
      const location = useLocation32();
      const currentUser = useSelector67(getCurrentUser38);
      const classroomId = _146.get("classroomId", useParams7());
      const allClassrooms = useSelector67(getGroups);
      const [groups, otherClassrooms] = _146.partition({ owner: _146.get("id", currentUser) }, allClassrooms);
      const entClassrooms = useSelector67(getGarDivisions);
      const students = useSearchStudents5({
        ids: _146.get("students", currentUser)
      });
      const teachers = useSelector67(getTeachers);
      const levels = useSearchLevels3({ schoolTypes: SECONDARY_SCHOOL_TYPES_SLUGS3 });
      const onGoBack = useCallback63(() => history.goBack(), [history]);
      const goTo = useCallback63(
        ({ step, classroomId: classroomId2, withInviteModal: withInviteModal2 }) => history.push(getRouteToStep({ step, classroomId: classroomId2, withInviteModal: withInviteModal2 })),
        [history]
      );
      const auth2 = useSelector67(getAuth20);
      const token = _146.get("token", auth2);
      const fetchParams = { token };
      useFetch({ ssrFetcher, screen: SCREEN_GROUPS_SETTINGS, params: fetchParams });
      const createGroupEffectFn = useCustomEffect_default(createGroupEffect);
      const onCreateClassroom = useCallback63(
        (group) => createGroupEffectFn({ group, token, currentUser, silent: true }),
        [createGroupEffectFn, token, currentUser]
      );
      const onDuplicateClassroom = useCallback63(
        (group) => {
          createGroupEffectFn({ group, groups, token, isDuplicated: true, currentUser });
        },
        [createGroupEffectFn, groups, token, currentUser]
      );
      const updateGroupEffectFn = useCustomEffect_default(updateGroupEffect);
      const onUpdateClassroom = useCallback63(
        ({ classroom, updatedClassroom }) => updateGroupEffectFn({ currentGroup: classroom, updatedGroup: updatedClassroom, token, currentUser }),
        [updateGroupEffectFn, token, currentUser]
      );
      const deleteGroupEffectFn = useCustomEffect_default(deleteGroupEffect);
      const onDeleteClassroom = useCallback63(
        (group) => {
          deleteGroupEffectFn({ token, group, currentUser });
        },
        [deleteGroupEffectFn, token, currentUser]
      );
      const onOpenCodeClassroomPdf = useCallback63(
        (classroomId2) => {
          openWindow19(buildUrlCodeClassroomPdf({ classroomId: classroomId2, token }));
        },
        [token]
      );
      const withInviteModal = _146.flow(useLocation32, getQueryParams22, _146.get("withInviteModal"))();
      const screenReady = useSelector67((state) => getIsLoaded(state, SCREEN_GROUPS_SETTINGS, fetchParams));
      const currentStep = getStepFromRoute({ pathname: _146.get("pathname", location), classroomId });
      useEffect51(() => {
        const pageType = getPageType(currentStep);
        dispatchAnalyticsEvent32(ANALYTICS_EVENTS.SCREEN_VIEWED, { pageType });
      }, [currentStep]);
      useEffect51(() => {
        const clarity = window.clarity;
        if (clarity) {
          clarity("set", "feature", "Cr\xE9ation de groupe");
        }
      }, []);
      const onDisabledFeatureClick = useCustomEffect_default(openDisabledModalEffect);
      const isOffline = (_a2 = useAppData()) == null ? void 0 : _a2.isOffline;
      const dispatch = useDispatch48();
      useEffect51(() => {
        if (isOffline) {
          triggerNotification({
            name: "is_offline",
            type: "snackbar_notification",
            dispatch
          });
        }
      }, [isOffline, dispatch]);
      return /* @__PURE__ */ jsxs95(Fragment31, { children: [
        /* @__PURE__ */ jsx135(metas_default, { screen: SCREEN_GROUPS_SETTINGS, params: {} }),
        /* @__PURE__ */ jsx135(loading_default2, { screen: SCREEN_GROUPS_SETTINGS, params: fetchParams }),
        screenReady ? _146.get("isTeacher", currentUser) ? /* @__PURE__ */ jsx135(
          "div",
          {
            className: src_screens_classroom_default.groupsContainer,
            "data-withoutnavbar": +shouldHideNavbar(_146.get("pathname", location)),
            children: /* @__PURE__ */ jsx135(
              Classrooms,
              {
                isOffline,
                classrooms: groups,
                entClassrooms,
                students,
                levels,
                onGoBack,
                onCreateClassroom,
                onDuplicateClassroom,
                onUpdateClassroom,
                onDeleteClassroom,
                isTrial: currentUser == null ? void 0 : currentUser.isTrial,
                allClassrooms: otherClassrooms,
                goTo,
                currentStep,
                classroomId,
                teachers,
                onOpenCodeClassroomPdf,
                withInviteModal,
                onDisabledFeatureClick: () => onDisabledFeatureClick({ featureName: MODAL_CLASSROOM })
              }
            )
          }
        ) : /* @__PURE__ */ jsx135(Redirect2, { push: true, to: getPath("home") }) : null
      ] });
    };
    classroom_default = ClassroomScreen;
  }
});

// css-modules:css-modules://-wAAOtO2u4P-QgrjGE2GyFevY1m3SHL2NhPSRmbgKGo.css
var init_wAAOtO2u4P_QgrjGE2GyFevY1m3SHL2NhPSRmbgKGo = __esm({
  "css-modules:css-modules://-wAAOtO2u4P-QgrjGE2GyFevY1m3SHL2NhPSRmbgKGo.css"() {
  }
});

// tmp_esbuild1736180049684/_src_screens_copy.module.css
var src_screens_copy_default;
var init_src_screens_copy = __esm({
  "tmp_esbuild1736180049684/_src_screens_copy.module.css"() {
    "use strict";
    init_wAAOtO2u4P_QgrjGE2GyFevY1m3SHL2NhPSRmbgKGo();
    src_screens_copy_default = { "toolbar": "core-7B-rCa-toolbar", "copiesBreadcrumbContainer": "core-7B-rCa-copiesBreadcrumbContainer" };
  }
});

// src/screens/copy.module.css
var init_copy = __esm({
  "src/screens/copy.module.css"() {
    "use strict";
    init_src_screens_copy();
  }
});

// src/screens/copy.jsx
var copy_exports = {};
__export(copy_exports, {
  default: () => copy_default
});
import _147 from "lodash/fp.js";
import { useCallback as useCallback64, useEffect as useEffect52, useMemo as useMemo41, useState as useState39 } from "react";
import { useSelector as useSelector68 } from "react-redux";
import { useHistory as useHistory38 } from "react-router-dom";
import { Z_NAVBAR as Z_NAVBAR4 } from "@lls/lls-kit";
import { CopyBreadcrumb, TeacherAppreciationHeader, Toolbar as Toolbar2 } from "@lls/superkit";
import { useAnalyticsEventEnhancer as useAnalyticsEventEnhancer8 } from "@lls/utils";
import { getAuth as getAuth21, useSearchCopyNotifications as useSearchCopyNotifications2, useSearchCurrentUserSharedPages as useSearchCurrentUserSharedPages6, useSearchUsers as useSearchUsers4 } from "@lls/store";
import { getSharedPage } from "@lls/store";
import { getCurrentUser as getCurrentUser39, getUser } from "@lls/store";
import { getBook as getBook7 } from "@lls/store";
import { Fragment as Fragment32, jsx as jsx136, jsxs as jsxs96 } from "react/jsx-runtime";
var CopyScreen, copy_default;
var init_copy2 = __esm({
  "src/screens/copy.jsx"() {
    "use strict";
    init_notification3();
    init_notificationEntity();
    init_constants();
    init_route();
    init_viewer3();
    init_screenRequisite();
    init_page2();
    init_withRouterProvider();
    init_useCrisp();
    init_useCustomEffect();
    init_useToolbarAdapter();
    init_loading3();
    init_copy();
    CopyScreen = (props) => {
      const history = useHistory38();
      const copyId = _147.flow(_147.get("match.params.copyId"), _147.parseInt(10))(props);
      const parentId = _147.flow(_147.get("match.params.parentId"), _147.parseInt(10))(props);
      const copy = useSelector68((state) => getSharedPage(state, copyId));
      const currentUser = useSelector68(getCurrentUser39);
      const copyOwner = useSelector68((state) => getUser(state, _147.get("user", copy)));
      const appreciation = _147.get("appreciations.0", copy);
      const [areStudentResponsesShown, setAreStudentResponsesShown] = useState39(false);
      const [aRenewalDisplayed, setRenewalDisplayed] = useState39(true);
      const renewalDisplayed = aRenewalDisplayed || !_147.some("renewalUpdatedAt", copy == null ? void 0 : copy.children);
      const book = useSelector68((state) => getBook7(state, _147.get("book", copy)));
      const auth2 = useSelector68(getAuth21);
      const token = _147.get("token", auth2);
      const hasFetchedCopy = useSelector68((state) => getIsLoaded(state, SCREEN_COPY, { token, copyId, parentId }));
      const updateAppreciationPageEffectFn = useCustomEffect_default(updateAppreciationPageEffect);
      const sharedPages = useSearchCurrentUserSharedPages6({ parentIds: [parentId] });
      const studentIds = _147.map("user", sharedPages);
      const students = useSearchUsers4({ ids: studentIds });
      const unreadCopyNotifications = useSearchCopyNotifications2({ pageIds: _147.map("id", sharedPages), read: false });
      const markNotificationAsReadEffectFn = useCustomEffect_default(markNotificationAsReadEffect);
      useEffect52(() => {
        if (!_147.get("isTeacher", currentUser)) return history.push(getPath("home"));
        const notification = getNotificationByPageId(unreadCopyNotifications, copyId);
        notification && markNotificationAsReadEffectFn({ notification, token });
      }, [currentUser, history, copyId, unreadCopyNotifications, token, markNotificationAsReadEffectFn]);
      useAnalyticsEventEnhancer8({ pageId: parentId, bookId: _147.get("id", book) });
      const onSendAppreciation = useCallback64(
        async (input) => {
          await updateAppreciationPageEffectFn({ page: copy, copyOwner, token, input, currentUser });
        },
        [copy, token, updateAppreciationPageEffectFn, currentUser, copyOwner]
      );
      const onStudentChange = useCallback64(
        (copyId2) => {
          history.push(getPath("copy", { parentId, copyId: copyId2 }));
        },
        [history, parentId]
      );
      const onGoBack = useCallback64(
        () => history.push(getPath("copies", { parentId: _147.get("parent", copy) })),
        [history, copy]
      );
      const subHeader = useMemo41(
        () => /* @__PURE__ */ jsx136(
          TeacherAppreciationHeader,
          {
            appreciationDefaultContent: _147.getOr("", "content", appreciation),
            onSend: onSendAppreciation,
            teacher: currentUser
          }
        ),
        [onSendAppreciation, currentUser, appreciation]
      );
      const makePath = useCallback64(
        (__, { docId } = {}) => {
          const query = docId ? { query: { docId } } : {};
          return getPath("copy", { parentId, copyId, ...query });
        },
        [copyId, parentId]
      );
      const toolbar = useToolbarAdapter_default({
        subjectId: _147.get("subjects.0", book),
        book,
        page: copy,
        screenReady: hasFetchedCopy,
        token
      });
      const isPresentationMode = toolbar == null ? void 0 : toolbar.presentationProps.isPresentationMode;
      useCrisp_default({ isPresentationMode });
      const fetchParams = { token, copyId, parentId };
      const { isOffline } = useAppData();
      return /* @__PURE__ */ jsxs96(Fragment32, { children: [
        isPresentationMode && /* @__PURE__ */ jsx136(
          Toolbar2,
          {
            style: { "--c-z-navbar": Z_NAVBAR4 },
            isOffline,
            page: copy,
            presentationProps: toolbar == null ? void 0 : toolbar.presentationProps,
            accessibilityProps: toolbar == null ? void 0 : toolbar.accessibilityProps,
            printProps: toolbar == null ? void 0 : toolbar.printProps,
            user: currentUser
          }
        ),
        /* @__PURE__ */ jsx136(screenRequisite_default, { screen: SCREEN_COPY, fetchParams, ...props }),
        /* @__PURE__ */ jsx136("div", { className: src_screens_copy_default.copiesBreadcrumbContainer, "data-hidden": +!hasFetchedCopy, children: /* @__PURE__ */ jsx136(
          CopyBreadcrumb,
          {
            book,
            page: copy,
            onGoBack,
            onStudentResponsesChange: setAreStudentResponsesShown,
            students,
            sharedPages,
            onStudentChange,
            selectedPageId: _147.get("id", copy),
            areStudentResponsesShown
          }
        ) }),
        /* @__PURE__ */ jsx136(
          viewer_default,
          {
            areQuestionsDisabled: true,
            areStudentResponsesShown,
            book,
            isHidden: !hasFetchedCopy,
            page: copy,
            subHeaderComponent: subHeader,
            makePath,
            currentUser,
            onlyFullscreenCard: true,
            toolbar,
            forceShowAnswerButton: true,
            hideEnhancedFeatures: true,
            renewalDisplayed,
            setRenewalDisplayed,
            routeReady: props.routeReady
          }
        )
      ] });
    };
    copy_default = CopyScreen;
  }
});

// src/utils/correction.js
import _148 from "lodash/fp.js";
var mergeCorrection;
var init_correction = __esm({
  "src/utils/correction.js"() {
    "use strict";
    mergeCorrection = (newCorrectionDocs, template) => {
      return _148.update(
        "children",
        _148.map((child) => {
          const newCorrectionDoc = _148.find({ uuid: _148.get("uuid", child) }, newCorrectionDocs);
          return _148.isNil(newCorrectionDoc) ? child : _148.set("rightResponses", _148.get("rightResponses", newCorrectionDoc), child);
        }),
        template
      );
    };
  }
});

// css-modules:css-modules://9Onq3xE6O4FLpFaNtlB3exRPNFj-6kzpMix9XGyYgx8.css
var init_Onq3xE6O4FLpFaNtlB3exRPNFj_6kzpMix9XGyYgx8 = __esm({
  "css-modules:css-modules://9Onq3xE6O4FLpFaNtlB3exRPNFj-6kzpMix9XGyYgx8.css"() {
  }
});

// tmp_esbuild1736180049684/_src_screens_shareCorrections.module.css
var src_screens_shareCorrections_default;
var init_src_screens_shareCorrections = __esm({
  "tmp_esbuild1736180049684/_src_screens_shareCorrections.module.css"() {
    "use strict";
    init_Onq3xE6O4FLpFaNtlB3exRPNFj_6kzpMix9XGyYgx8();
    src_screens_shareCorrections_default = { "container": "core-6LFxBq-container" };
  }
});

// src/screens/shareCorrections.module.css
var init_shareCorrections = __esm({
  "src/screens/shareCorrections.module.css"() {
    "use strict";
    init_src_screens_shareCorrections();
  }
});

// src/screens/shareCorrections.jsx
var shareCorrections_exports = {};
__export(shareCorrections_exports, {
  default: () => shareCorrections_default
});
import React13, { Suspense as Suspense7, useCallback as useCallback65, useEffect as useEffect53, useState as useState40, useMemo as useMemo42 } from "react";
import { getAuth as getAuth22, useSearchCurrentUserSharedPages as useSearchCurrentUserSharedPages7 } from "@lls/store";
import { getGroup as getGroup3 } from "@lls/store";
import { getPage as getPage6 } from "@lls/store";
import { getCurrentUser as getCurrentUser40 } from "@lls/store";
import { ShareCorrectionsBreadcrumb as Breadcrumb, ShareBar as ShareBar2 } from "@lls/superkit";
import { getShareCorrectionTemplates } from "@lls/viewer/staticImports";
import _149 from "lodash/fp.js";
import { useSelector as useSelector69 } from "react-redux";
import { useHistory as useHistory39 } from "react-router-dom";
import { Fragment as Fragment33, jsx as jsx137, jsxs as jsxs97 } from "react/jsx-runtime";
var LazyPicker2, ShareCorrectionsScreen, shareCorrections_default;
var init_shareCorrections2 = __esm({
  "src/screens/shareCorrections.jsx"() {
    "use strict";
    init_screenRequisite();
    init_constants();
    init_ui3();
    init_group2();
    init_useCustomEffect();
    init_correction();
    init_dom();
    init_route();
    init_shareCorrections();
    LazyPicker2 = React13.lazy(() => import("@lls/viewer").then(interop("Picker")));
    ShareCorrectionsScreen = (props) => {
      const history = useHistory39();
      const parentId = _149.flow(_149.get("match.params.parentId"), _149.parseInt(10))(props);
      const groupId = _149.flow(_149.get("match.params.groupId"), _149.parseInt(10))(props);
      const user = useSelector69(getCurrentUser40);
      const auth2 = useSelector69(getAuth22);
      const token = _149.get("token", auth2);
      const group = useSelector69((state) => getGroup3(state, groupId));
      const parent = useSelector69((state) => getPage6(state, parentId));
      const studentIds = _149.get("students", group);
      const sharedPages = useSearchCurrentUserSharedPages7({ parentIds: [parentId], userIds: studentIds });
      const [pickedTemplate, setPickedTemplate] = useState40(null);
      const [customCorrectedUuids, setCustomCorrectedUuids] = useState40(null);
      const [template, setTemplate] = useState40(null);
      const onChange = useCallback65((data, ctx) => {
        if (ctx === "picker") {
          setPickedTemplate(data);
        } else {
          if (_149.get("source", ctx) === "exercise") {
            setTemplate((oldTemplate) => mergeCorrection([_149.get("document", ctx)], oldTemplate));
            setCustomCorrectedUuids((oldCustomCorrection) => ({
              ...oldCustomCorrection,
              [_149.get("document.uuid", ctx)]: _149.get("document.rightResponses", ctx)
            }));
          }
        }
      }, []);
      const pickedDocuments = _149.get("children", pickedTemplate);
      const pickedDocumentsUuids = _149.map("uuid", pickedDocuments);
      const addCorrectionsToGroupEffectFn = useCustomEffect_default(addCorrectionsToGroupEffect);
      const existingCorrections = useMemo42(
        () => _149.flow(_149.get("sharedCorrections"), _149.find({ pageId: parentId }))(group),
        [parentId, group]
      );
      useEffect53(() => {
        const correctedUuids = _149.getOr({}, "correctedUuids", existingCorrections);
        setCustomCorrectedUuids(correctedUuids);
      }, [existingCorrections]);
      const onAddCorrections = useCallback65(() => {
        const correctionDocumentUuids = _149.getOr([], "uuids", existingCorrections);
        const allCorrectionsUuids = _149.concat(correctionDocumentUuids, pickedDocumentsUuids);
        const corrections = [{ pageId: parentId, uuids: allCorrectionsUuids, correctedUuids: customCorrectedUuids }];
        addCorrectionsToGroupEffectFn({ group, sharedPages, token, corrections, parentId, currentUser: user });
      }, [
        group,
        sharedPages,
        token,
        parentId,
        existingCorrections,
        customCorrectedUuids,
        pickedDocumentsUuids,
        addCorrectionsToGroupEffectFn,
        user
      ]);
      const answeredUuids = useMemo42(() => _149.flow(_149.get("answeredExercises"), _149.map("uuid"))(group), [group]);
      useEffect53(() => {
        _149.noop(group);
        if (_149.get("isStudent", user)) history.push(getPath("home"));
        const { template: viewerTemplate, pickedTemplate: viewerPickedTemplate } = getShareCorrectionTemplates(
          answeredUuids,
          parent
        );
        const newCorrectionDocs = _149.flow(
          _149.get("correctedUuids"),
          _149.toPairs,
          _149.map(([uuid, rightResponses]) => ({ uuid, rightResponses }))
        )(existingCorrections);
        setTemplate(mergeCorrection(newCorrectionDocs, viewerTemplate));
        setPickedTemplate(viewerPickedTemplate);
      }, [parent, group, answeredUuids, user, history, existingCorrections]);
      const onGoBack = useCallback65(() => history.push(getPath("copies", { parentId })), [history, parentId]);
      const [areAnsweredDocumentsShown, setAreAnsweredDocumentsShown] = useState40(false);
      const onAnsweredDocumentsChange = useCallback65(
        () => setAreAnsweredDocumentsShown((prevAreAnsweredDocumentsShown) => !prevAreAnsweredDocumentsShown),
        []
      );
      const fetchParams = { parentIds: [parentId], groupIds: [groupId], token };
      return /* @__PURE__ */ jsxs97(Fragment33, { children: [
        /* @__PURE__ */ jsx137(screenRequisite_default, { screen: SCREEN_SHARE_CORRECTIONS, fetchParams, ...props }),
        /* @__PURE__ */ jsxs97("div", { className: src_screens_shareCorrections_default.container, style: { "--cr-navbar-height": `${NAVBAR_HEIGHT}px` }, children: [
          /* @__PURE__ */ jsx137("div", { className: "share-corrections-breadcrumb", children: /* @__PURE__ */ jsx137(
            Breadcrumb,
            {
              onGoBack,
              documents: pickedDocuments,
              onAnsweredDocumentsChange,
              areAnsweredDocumentsShown
            }
          ) }),
          template ? /* @__PURE__ */ jsx137(Suspense7, { children: /* @__PURE__ */ jsx137(
            LazyPicker2,
            {
              areShownAnswers: true,
              areSharedCorrections: true,
              forceShowAnswerButton: false,
              correctionDocumentUuids: _149.get("uuids", existingCorrections),
              template,
              onChange,
              pickedTemplate,
              areAnsweredDocumentsShown,
              answeredUuids,
              user
            }
          ) }) : null
        ] }),
        template && /* @__PURE__ */ jsx137(
          ShareBar2,
          {
            isShown: !_149.isEmpty(pickedDocumentsUuids),
            areSharedCorrections: true,
            onShareClick: onAddCorrections,
            title: "Partager les corrections"
          }
        )
      ] });
    };
    shareCorrections_default = ShareCorrectionsScreen;
  }
});

// css-modules:css-modules://p_S9GR_FwyBBltU_Xrmsv1FKL-l-lndx2GpG3vmM9HQ.css
var init_p_S9GR_FwyBBltU_Xrmsv1FKL_l_lndx2GpG3vmM9HQ = __esm({
  "css-modules:css-modules://p_S9GR_FwyBBltU_Xrmsv1FKL-l-lndx2GpG3vmM9HQ.css"() {
  }
});

// tmp_esbuild1736180049684/_src_screens_shareCorrectionsStudents.module.css
var src_screens_shareCorrectionsStudents_default;
var init_src_screens_shareCorrectionsStudents = __esm({
  "tmp_esbuild1736180049684/_src_screens_shareCorrectionsStudents.module.css"() {
    "use strict";
    init_p_S9GR_FwyBBltU_Xrmsv1FKL_l_lndx2GpG3vmM9HQ();
    src_screens_shareCorrectionsStudents_default = { "container": "core-4F4Qwa-container" };
  }
});

// src/screens/shareCorrectionsStudents.module.css
var init_shareCorrectionsStudents = __esm({
  "src/screens/shareCorrectionsStudents.module.css"() {
    "use strict";
    init_src_screens_shareCorrectionsStudents();
  }
});

// src/screens/shareCorrectionsStudents.jsx
var shareCorrectionsStudents_exports = {};
__export(shareCorrectionsStudents_exports, {
  default: () => shareCorrectionsStudents_default
});
import React14, { Suspense as Suspense8, useCallback as useCallback66, useEffect as useEffect54, useState as useState41 } from "react";
import { getAuth as getAuth23, useSearchCurrentUserSharedPages as useSearchCurrentUserSharedPages8 } from "@lls/store";
import { getPage as getPage7 } from "@lls/store";
import { getCurrentUser as getCurrentUser41 } from "@lls/store";
import { ShareCorrectionsBreadcrumb as Breadcrumb2, ShareBar as ShareBar3 } from "@lls/superkit";
import { getQueryParams as getQueryParams23 } from "@lls/utils";
import { getShareCorrectionTemplates as getShareCorrectionTemplates2 } from "@lls/viewer/staticImports";
import _150 from "lodash/fp.js";
import { useSelector as useSelector70 } from "react-redux";
import { useHistory as useHistory40, useLocation as useLocation33 } from "react-router-dom";
import { Fragment as Fragment34, jsx as jsx138, jsxs as jsxs98 } from "react/jsx-runtime";
var LazyPicker3, ShareCorrectionsScreen2, shareCorrectionsStudents_default;
var init_shareCorrectionsStudents2 = __esm({
  "src/screens/shareCorrectionsStudents.jsx"() {
    "use strict";
    init_screenRequisite();
    init_constants();
    init_ui3();
    init_page2();
    init_useCustomEffect();
    init_correction();
    init_dom();
    init_route();
    init_shareCorrectionsStudents();
    LazyPicker3 = React14.lazy(() => import("@lls/viewer").then(interop("Picker")));
    ShareCorrectionsScreen2 = (props) => {
      const queryParams = getQueryParams23(useLocation33());
      const history = useHistory40();
      const parentId = _150.flow(_150.get("match.params.parentId"), _150.parseInt(10))(props);
      const user = useSelector70(getCurrentUser41);
      const auth2 = useSelector70(getAuth23);
      const token = _150.get("token", auth2);
      const parent = useSelector70((state) => getPage7(state, parentId));
      const studentIds = _150.flow(_150.get("studentIds"), _150.split(","), _150.map(_150.parseInt(10)))(queryParams);
      const sharedPages = useSearchCurrentUserSharedPages8({ parentIds: [parentId], userIds: studentIds });
      const [pickedTemplate, setPickedTemplate] = useState41(null);
      const [customCorrectedUuids, setCustomCorrectedUuids] = useState41(null);
      const [template, setTemplate] = useState41(null);
      const pickedDocuments = _150.get("children", pickedTemplate);
      const pickedDocumentsUuids = _150.map("uuid", pickedDocuments);
      const addCorrectionsToUsersEffectFn = useCustomEffect_default(addCorrectionsToUsersEffect);
      const onChange = useCallback66((data, ctx) => {
        if (ctx === "picker") {
          setPickedTemplate(data);
        } else {
          if (_150.get("source", ctx) === "exercise") {
            setTemplate((oldTemplate) => mergeCorrection([_150.get("document", ctx)], oldTemplate));
            setCustomCorrectedUuids((oldCustomCorrection) => ({
              ...oldCustomCorrection,
              [_150.get("document.uuid", ctx)]: _150.get("document.rightResponses", ctx)
            }));
          }
        }
      }, []);
      const onAddCorrections = useCallback66(() => {
        const corrections = [{ pageId: parentId, uuids: pickedDocumentsUuids, correctedUuids: customCorrectedUuids }];
        addCorrectionsToUsersEffectFn({ token, corrections, parentId, studentIds, sharedPages });
      }, [
        studentIds,
        token,
        parentId,
        pickedDocumentsUuids,
        addCorrectionsToUsersEffectFn,
        sharedPages,
        customCorrectedUuids
      ]);
      useEffect54(() => {
        if (_150.get("isStudent", user)) history.push(getPath("home"));
        const { template: viewerTemplate, pickedTemplate: viewerPickedTemplate } = getShareCorrectionTemplates2({}, parent);
        setTemplate(viewerTemplate);
        setPickedTemplate(viewerPickedTemplate);
      }, [parent, user, history]);
      const onGoBack = useCallback66(() => history.push(getPath("copies", { parentId })), [history, parentId]);
      const [areAnsweredDocumentsShown, setAreAnsweredDocumentsShown] = useState41(false);
      const onAnsweredDocumentsChange = useCallback66(
        () => setAreAnsweredDocumentsShown((prevAreAnsweredDocumentsShown) => !prevAreAnsweredDocumentsShown),
        []
      );
      const fetchParams = { parentIds: [parentId], token };
      return /* @__PURE__ */ jsxs98(Fragment34, { children: [
        /* @__PURE__ */ jsx138(screenRequisite_default, { screen: SCREEN_SHARE_CORRECTIONS_STUDENTS, fetchParams, ...props }),
        /* @__PURE__ */ jsxs98("div", { className: src_screens_shareCorrectionsStudents_default.container, style: { "--cr-navbar-height": `${NAVBAR_HEIGHT}px` }, children: [
          /* @__PURE__ */ jsx138("div", { className: "share-corrections-breadcrumb", children: /* @__PURE__ */ jsx138(
            Breadcrumb2,
            {
              onGoBack,
              documents: pickedDocuments,
              onAnsweredDocumentsChange,
              areAnsweredDocumentsShown
            }
          ) }),
          template ? /* @__PURE__ */ jsxs98(Fragment34, { children: [
            /* @__PURE__ */ jsx138(Suspense8, { children: /* @__PURE__ */ jsx138(
              LazyPicker3,
              {
                areShownAnswers: true,
                areSharedCorrections: true,
                forceShowAnswerButton: false,
                template,
                onChange,
                user,
                pickedTemplate,
                areAnsweredDocumentsShown
              }
            ) }),
            /* @__PURE__ */ jsx138(
              ShareBar3,
              {
                isShown: !_150.isEmpty(pickedDocumentsUuids),
                areSharedCorrections: true,
                onShareClick: onAddCorrections,
                title: "Partager les corrections"
              }
            )
          ] }) : null
        ] })
      ] });
    };
    shareCorrectionsStudents_default = ShareCorrectionsScreen2;
  }
});

// css-modules:css-modules://MFiNvkKKvorzZZTe8oIu3Uh6dZbfQhDwls7_8xaEE7w.css
var init_MFiNvkKKvorzZZTe8oIu3Uh6dZbfQhDwls7_8xaEE7w = __esm({
  "css-modules:css-modules://MFiNvkKKvorzZZTe8oIu3Uh6dZbfQhDwls7_8xaEE7w.css"() {
  }
});

// tmp_esbuild1736180049684/_src_screens_marketingViewer.module.css
var src_screens_marketingViewer_default;
var init_src_screens_marketingViewer = __esm({
  "tmp_esbuild1736180049684/_src_screens_marketingViewer.module.css"() {
    "use strict";
    init_MFiNvkKKvorzZZTe8oIu3Uh6dZbfQhDwls7_8xaEE7w();
    src_screens_marketingViewer_default = { "viewer": "core-fEMmKa-viewer" };
  }
});

// src/screens/marketingViewer.module.css
var init_marketingViewer = __esm({
  "src/screens/marketingViewer.module.css"() {
    "use strict";
    init_src_screens_marketingViewer();
  }
});

// src/screens/marketingViewer.jsx
var marketingViewer_exports = {};
__export(marketingViewer_exports, {
  default: () => marketingViewer_default
});
import { useSearchPages as useSearchPages12 } from "@lls/store";
import _151 from "lodash/fp.js";
import { useSelector as useSelector71 } from "react-redux";
import { Fragment as Fragment35, jsx as jsx139, jsxs as jsxs99 } from "react/jsx-runtime";
var MarketingViewerScreen, marketingViewer_default;
var init_marketingViewer2 = __esm({
  "src/screens/marketingViewer.jsx"() {
    "use strict";
    init_viewer3();
    init_screenRequisite();
    init_constants();
    init_ui3();
    init_useToolbarAdapter();
    init_loading3();
    init_marketingViewer();
    MarketingViewerScreen = (props) => {
      var _a2;
      const tool = _151.get("match.params.tool", props);
      const slug = _151.get(tool, TOOLS_TO_SLUG);
      const params = { slug };
      const page = (_a2 = useSearchPages12({ slugs: [slug] })) == null ? void 0 : _a2[0];
      const screenReady = useSelector71((state) => getIsLoaded(state, SCREEN_MARKETING_VIEWER, params));
      const toolbar = useToolbarAdapter_default({
        page,
        screenReady
      });
      return /* @__PURE__ */ jsxs99(Fragment35, { children: [
        /* @__PURE__ */ jsx139(screenRequisite_default, { screen: SCREEN_MARKETING_VIEWER, fetchParams: params, ...props }),
        /* @__PURE__ */ jsx139("div", { className: src_screens_marketingViewer_default.viewer, style: { "--c-navbarheight": `${NAVBAR_HEIGHT}px` }, children: /* @__PURE__ */ jsx139(viewer_default, { page, toolbar, shouldRecordChanges: false, hideEnhancedFeatures: true }) })
      ] });
    };
    marketingViewer_default = MarketingViewerScreen;
  }
});

// css-modules:css-modules://MGLOkcNSpUDJl6Yp07XZNIlkqNAevTYyptONfT7aSlg.css
var init_MGLOkcNSpUDJl6Yp07XZNIlkqNAevTYyptONfT7aSlg = __esm({
  "css-modules:css-modules://MGLOkcNSpUDJl6Yp07XZNIlkqNAevTYyptONfT7aSlg.css"() {
  }
});

// tmp_esbuild1736180049684/_src_screens_revision.module.css
var src_screens_revision_default;
var init_src_screens_revision = __esm({
  "tmp_esbuild1736180049684/_src_screens_revision.module.css"() {
    "use strict";
    init_MGLOkcNSpUDJl6Yp07XZNIlkqNAevTYyptONfT7aSlg();
    src_screens_revision_default = { "revisionContainer": "core-qlMk1W-revisionContainer" };
  }
});

// src/screens/revision.module.css
var init_revision2 = __esm({
  "src/screens/revision.module.css"() {
    "use strict";
    init_src_screens_revision();
  }
});

// src/screens/revision.jsx
var revision_exports = {};
__export(revision_exports, {
  default: () => revision_default
});
import _152 from "lodash/fp.js";
import { useCallback as useCallback67 } from "react";
import { useSelector as useSelector72 } from "react-redux";
import { useHistory as useHistory41, useLocation as useLocation34 } from "react-router-dom";
import { getCurrentUser as getCurrentUser42, useSearchBooks as useSearchBooks10, useSearchLevels as useSearchLevels4, useSearchSubjects as useSearchSubjects5 } from "@lls/store";
import { Revision as RevisionSK } from "@lls/superkit";
import { getQueryParams as getQueryParams24, openWindow as openWindow20 } from "@lls/utils";
import { Fragment as Fragment36, jsx as jsx140, jsxs as jsxs100 } from "react/jsx-runtime";
var Revision, revision_default;
var init_revision3 = __esm({
  "src/screens/revision.jsx"() {
    "use strict";
    init_screenRequisite();
    init_constants();
    init_ui3();
    init_loading3();
    init_route();
    init_revision2();
    Revision = (props) => {
      const history = useHistory41();
      const user = useSelector72(getCurrentUser42);
      const userBookIds = user == null ? void 0 : user.booksV2;
      const userSubjectIds = user == null ? void 0 : user.subjects;
      const isStudent = user == null ? void 0 : user.isStudent;
      const bookSelectorParams = isStudent ? { ids: userBookIds, levelIds: user == null ? void 0 : user.levels } : { subjectIds: userSubjectIds, ids: userBookIds };
      const books = useSearchBooks10(bookSelectorParams);
      const subjects = useSearchSubjects5({ ids: isStudent ? _152.flatMap("subjects", books) : userSubjectIds });
      const levels = useSearchLevels4({ ids: isStudent ? user == null ? void 0 : user.levels : _152.flatMap("levels", books) });
      const params = isStudent ? { bookIds: userBookIds } : { subjectIds: userSubjectIds };
      const onGoToRevisionBook = useCallback67(
        (book, { query } = {}) => {
          history.push(getPath("revision_book", { bookUri: book == null ? void 0 : book.uri, query }));
        },
        [history]
      );
      const onGoToJoinCommunity = useCallback67(() => openWindow20(getPath("join_community")), []);
      const screenReady = useSelector72((state) => getIsLoaded(state, SCREEN_REVISION, params));
      const queryParams = getQueryParams24(useLocation34());
      return /* @__PURE__ */ jsxs100(Fragment36, { children: [
        /* @__PURE__ */ jsx140(screenRequisite_default, { screen: SCREEN_REVISION, fetchParams: params, ...props }),
        /* @__PURE__ */ jsx140("div", { className: src_screens_revision_default.revisionContainer, style: { "--cr-navbar-height": `${NAVBAR_HEIGHT}px` }, children: screenReady && /* @__PURE__ */ jsx140(
          RevisionSK,
          {
            books,
            queryParams,
            onGoToRevisionBook,
            onGoToJoinCommunity,
            subjects,
            user,
            levels
          }
        ) })
      ] });
    };
    revision_default = Revision;
  }
});

// css-modules:css-modules://t9vi9Mr7y4XUO5Qo6rptl3YJXCJ9ZlPMOiWEWQd1ZhI.css
var init_t9vi9Mr7y4XUO5Qo6rptl3YJXCJ9ZlPMOiWEWQd1ZhI = __esm({
  "css-modules:css-modules://t9vi9Mr7y4XUO5Qo6rptl3YJXCJ9ZlPMOiWEWQd1ZhI.css"() {
  }
});

// tmp_esbuild1736180049684/_src_screens_revisionBook.module.css
var src_screens_revisionBook_default;
var init_src_screens_revisionBook = __esm({
  "tmp_esbuild1736180049684/_src_screens_revisionBook.module.css"() {
    "use strict";
    init_t9vi9Mr7y4XUO5Qo6rptl3YJXCJ9ZlPMOiWEWQd1ZhI();
    src_screens_revisionBook_default = { "revisionContainer": "core-KEa6ua-revisionContainer" };
  }
});

// src/screens/revisionBook.module.css
var init_revisionBook = __esm({
  "src/screens/revisionBook.module.css"() {
    "use strict";
    init_src_screens_revisionBook();
  }
});

// src/screens/revisionBook.jsx
var revisionBook_exports = {};
__export(revisionBook_exports, {
  default: () => revisionBook_default
});
import _153 from "lodash/fp.js";
import { useCallback as useCallback68, useState as useState42 } from "react";
import { useSelector as useSelector73 } from "react-redux";
import { useHistory as useHistory42, useLocation as useLocation35 } from "react-router";
import { useParams as useParams8 } from "react-router-dom";
import {
  getToken as getToken14,
  useSearchBooks as useSearchBooks11,
  useSearchChapters as useSearchChapters6,
  useSearchGroups as useSearchGroups5,
  useSearchPages as useSearchPages13,
  useSearchSubjects as useSearchSubjects6
} from "@lls/store";
import { getCurrentUser as getCurrentUser43 } from "@lls/store";
import { RevisionBook as RevisionBookSK } from "@lls/superkit";
import { getQueryParams as getQueryParams25 } from "@lls/utils";
import { Fragment as Fragment37, jsx as jsx141, jsxs as jsxs101 } from "react/jsx-runtime";
var RevisionBook, revisionBook_default;
var init_revisionBook2 = __esm({
  "src/screens/revisionBook.jsx"() {
    "use strict";
    init_screenRequisite();
    init_constants();
    init_ui3();
    init_page2();
    init_useCustomEffect();
    init_route();
    init_revisionBook();
    RevisionBook = (props) => {
      var _a2, _b2;
      const history = useHistory42();
      const uri = _153.get("bookUri", useParams8());
      const query = getQueryParams25(useLocation35());
      const token = useSelector73(getToken14);
      const book = (_a2 = useSearchBooks11({ uris: [uri], hasNewDesign: true })) == null ? void 0 : _a2[0];
      const chapters = useSearchChapters6({ ids: book == null ? void 0 : book.chapters });
      const subject = (_b2 = useSearchSubjects6({ ids: book == null ? void 0 : book.subjects })) == null ? void 0 : _b2[0];
      const revisionPages = useSearchPages13({ ids: book == null ? void 0 : book.revisionPages });
      const currentUser = useSelector73(getCurrentUser43);
      const groups = useSearchGroups5({ ownerIds: [_153.get("id", currentUser)] });
      const onGoBack = useCallback68(() => {
        history.push(getPath("revision", { query }));
      }, [query, history]);
      const onGoToPage = useCallback68(
        (page) => {
          history.push(getPath("revision_page", { slug: page == null ? void 0 : page.slug }));
        },
        [history]
      );
      const [selectedPage, setSelectedPage] = useState42({});
      const sharePageToGroupEffectFn = useCustomEffect_default(sharePageToGroupEffect);
      const onShareGroup = useCallback68(
        (group) => {
          sharePageToGroupEffectFn({ page: selectedPage, group, token });
        },
        [selectedPage, token, sharePageToGroupEffectFn]
      );
      const onManageGroupClick = useCallback68(() => history.push(getPath("classroom_settings")), [history]);
      return /* @__PURE__ */ jsxs101(Fragment37, { children: [
        /* @__PURE__ */ jsx141(screenRequisite_default, { screen: SCREEN_REVISION_BOOK, metaParams: { book }, fetchParams: { uri, token }, ...props }),
        /* @__PURE__ */ jsx141("div", { className: src_screens_revisionBook_default.revisionContainer, style: { "--cr-navbar-height": `${NAVBAR_HEIGHT}px` }, children: /* @__PURE__ */ jsx141(
          RevisionBookSK,
          {
            book,
            subject,
            chapters,
            groups,
            pages: revisionPages,
            onGoBack,
            onGoToPage,
            selectedPage,
            onShareGroup,
            onManageGroupClick,
            setSelectedPage,
            user: currentUser
          }
        ) })
      ] });
    };
    revisionBook_default = RevisionBook;
  }
});

// src/screens/revisionPage.jsx
var revisionPage_exports = {};
__export(revisionPage_exports, {
  default: () => revisionPage_default
});
import _154 from "lodash/fp.js";
import { useParams as useParams9 } from "react-router";
import { Fragment as Fragment38, jsx as jsx142, jsxs as jsxs102 } from "react/jsx-runtime";
var RevisionPageScreen, revisionPage_default;
var init_revisionPage = __esm({
  "src/screens/revisionPage.jsx"() {
    "use strict";
    init_viewerContainers2();
    init_loading4();
    init_metas();
    init_pageContent2();
    init_constants();
    init_useGetScreenPageProps();
    init_useShare();
    RevisionPageScreen = (props) => {
      var _a2, _b2;
      const pageId = _154.flow(_154.get("pageId"), _154.parseInt(10))(useParams9());
      const { loadingParams, metaParams, pageContainerProps } = useGetScreenPageProps_default({
        reactRouterProps: props,
        slug: `page/${pageId}`,
        isRevisionPage: true
      });
      const shareProps = useShare_default(pageContainerProps);
      return /* @__PURE__ */ jsxs102(Fragment38, { children: [
        /* @__PURE__ */ jsx142(metas_default, { screen: SCREEN_MULTIFETCH_PAGE, params: metaParams }),
        /* @__PURE__ */ jsx142(loading_default2, { screen: SCREEN_MULTIFETCH_PAGE, params: loadingParams }),
        /* @__PURE__ */ jsx142(StyledContainer, { "data-ispresentationmode": +!!((_b2 = (_a2 = pageContainerProps == null ? void 0 : pageContainerProps.toolbar) == null ? void 0 : _a2.presentationProps) == null ? void 0 : _b2.isPresentationMode), children: /* @__PURE__ */ jsx142(StyledViewerWrapperMargin, { children: /* @__PURE__ */ jsx142(StyledViewerWrapper, { children: /* @__PURE__ */ jsx142(pageContent_default, { ...pageContainerProps, shareProps, isRevisionPage: true }) }) }) })
      ] });
    };
    revisionPage_default = RevisionPageScreen;
  }
});

// src/screens/codeClassroom.jsx
var codeClassroom_exports = {};
__export(codeClassroom_exports, {
  default: () => codeClassroom_default
});
import { getAuth as getAuth24 } from "@lls/store";
import _155 from "lodash/fp.js";
import { useEffect as useEffect55 } from "react";
import { useSelector as useSelector74 } from "react-redux";
import { jsx as jsx143 } from "react/jsx-runtime";
var CodeClassroom, codeClassroom_default;
var init_codeClassroom = __esm({
  "src/screens/codeClassroom.jsx"() {
    "use strict";
    init_group2();
    init_useCustomEffect();
    CodeClassroom = (props) => {
      var _a2, _b2;
      const code = (_b2 = (_a2 = props == null ? void 0 : props.match) == null ? void 0 : _a2.params) == null ? void 0 : _b2.code;
      const auth2 = useSelector74(getAuth24);
      const token = _155.get("token", auth2);
      const addStudentToGroupEffectFn = useCustomEffect_default(addStudentToGroupEffect);
      useEffect55(() => {
        !_155.isNil(code) && addStudentToGroupEffectFn({ code, token });
      }, [code, token, addStudentToGroupEffectFn]);
      return /* @__PURE__ */ jsx143("div", {});
    };
    codeClassroom_default = CodeClassroom;
  }
});

// src/utils/chapter.js
import _156 from "lodash/fp.js";
var sortChapters;
var init_chapter = __esm({
  "src/utils/chapter.js"() {
    "use strict";
    sortChapters = _156.sortBy("number");
  }
});

// src/components/learningAssessment/session.jsx
import { Loader as Loader2 } from "@lls/lls-kit";
import _157 from "lodash/fp.js";
import React15, { Suspense as Suspense9, useCallback as useCallback69 } from "react";
import { useDispatch as useDispatch49 } from "react-redux";
import { useHistory as useHistory43 } from "react-router-dom";
import { jsx as jsx144 } from "react/jsx-runtime";
var LazyViewer3, LearningAssessmentSession, session_default2;
var init_session3 = __esm({
  "src/components/learningAssessment/session.jsx"() {
    "use strict";
    init_viewer();
    init_dom();
    LazyViewer3 = React15.lazy(() => import("@lls/viewer").then(interop("Viewer")));
    LearningAssessmentSession = ({ page, user, token, setSelectedExercises, stats }) => {
      const dispatch = useDispatch49();
      const history = useHistory43();
      const isTeacher = user == null ? void 0 : user.isTeacher;
      const userId = user == null ? void 0 : user.id;
      const pageId = page == null ? void 0 : page.id;
      const learningAssessmentStats = _157.flow(
        _157.get(userId),
        _157.filter({ pageId }),
        _157.map(_157.pick(["userWrongResponseCount", "uuid"]))
      )(stats);
      const handleChange = useCallback69(
        (template, ctx) => {
          if (isTeacher) {
            return setSelectedExercises(ctx == null ? void 0 : ctx.exercises);
          }
          onTemplateChangeEffect({
            dispatch,
            history,
            params: {
              template,
              ctx,
              token,
              currentUser: user,
              learningAssessmentStatsUuids: _157.map("uuid", learningAssessmentStats)
            }
          });
        },
        [dispatch, isTeacher, user, setSelectedExercises, learningAssessmentStats, token, history]
      );
      return /* @__PURE__ */ jsx144(Suspense9, { fallback: /* @__PURE__ */ jsx144(Loader2, {}), children: /* @__PURE__ */ jsx144(
        LazyViewer3,
        {
          template: page,
          user,
          learningAssessmentStats: isTeacher ? [] : learningAssessmentStats,
          sessionDefaultMaxExerciseCount: null,
          isInsideSession: true,
          onChange: handleChange
        }
      ) });
    };
    session_default2 = LearningAssessmentSession;
  }
});

// src/hooks/useLearningAssessmentStats.js
import _158 from "lodash/fp.js";
import { useEffect as useEffect56, useState as useState43 } from "react";
import { useDispatch as useDispatch50 } from "react-redux";
var useLearningAssessmentStats, useLearningAssessmentStats_default;
var init_useLearningAssessmentStats = __esm({
  "src/hooks/useLearningAssessmentStats.js"() {
    "use strict";
    init_stats2();
    useLearningAssessmentStats = ({ token, pages = [], groups = [], user }) => {
      const dispatch = useDispatch50();
      const [stats, setStats] = useState43({});
      useEffect56(() => {
        const additionalParams = (user == null ? void 0 : user.isTeacher) ? { groupIds: _158.map("id", groups) } : { studentIds: [user == null ? void 0 : user.id] };
        const shouldFetch = user && !_158.isEmpty(pages);
        async function fetchData2() {
          const fetchedStats = await fetchStatsEffect({
            dispatch,
            params: {
              token,
              tab: LEARNING_ASSESSMENT_TAB,
              pageIds: _158.map("id", pages),
              ...additionalParams
            }
          });
          setStats(_158.get("userId", fetchedStats));
        }
        shouldFetch && fetchData2();
      }, [dispatch, user, groups, pages, token]);
      return stats;
    };
    useLearningAssessmentStats_default = useLearningAssessmentStats;
  }
});

// src/screens/learningAssessment.jsx
var learningAssessment_exports = {};
__export(learningAssessment_exports, {
  default: () => learningAssessment_default
});
import { LEARNING_ASSESSMENT_STEPS, LearningAssessment, PAGES_THEMATIC } from "@lls/superkit";
import { ANALYTICS_PAGE_VIEWED as ANALYTICS_PAGE_VIEWED3, dispatchAnalyticsEvent as dispatchAnalyticsEvent33, getQueryParams as getQueryParams26, handleQuerystring as handleQuerystring3 } from "@lls/utils";
import _159 from "lodash/fp.js";
import { useCallback as useCallback70, useEffect as useEffect57, useMemo as useMemo43, useState as useState44 } from "react";
import { useSelector as useSelector75 } from "react-redux";
import { useHistory as useHistory44, useLocation as useLocation36 } from "react-router-dom";
import {
  getAuth as getAuth25,
  useSearchBooks as useSearchBooks12,
  useSearchChapters as useSearchChapters7,
  useSearchCurrentUserSharedPages as useSearchCurrentUserSharedPages9,
  useSearchGroups as useSearchGroups6,
  useSearchModifiedPages as useSearchModifiedPages5,
  useSearchPages as useSearchPages14,
  useSearchSchools as useSearchSchools3,
  useSearchStudents as useSearchStudents6,
  useSearchUsers as useSearchUsers5
} from "@lls/store";
import { getCurrentUser as getCurrentUser44 } from "@lls/store";
import { Fragment as Fragment39, jsx as jsx145, jsxs as jsxs103 } from "react/jsx-runtime";
var sendPageViewedEvent, getStepFromRoute2, getRouteToStep2, LearningAssessmentScreen, learningAssessment_default;
var init_learningAssessment = __esm({
  "src/screens/learningAssessment.jsx"() {
    "use strict";
    init_loading4();
    init_constants();
    init_chapter();
    init_route();
    init_session3();
    init_metas();
    init_group2();
    init_onboarding2();
    init_page2();
    init_fetch();
    init_useCustomEffect();
    init_useLearningAssessmentStats();
    sendPageViewedEvent = (currentStep) => {
      switch (currentStep) {
        case LEARNING_ASSESSMENT_STEPS.SELECT_NOTION:
          return dispatchAnalyticsEvent33(ANALYTICS_PAGE_VIEWED3, { pageName: LEARNING_ASSESSMENT_STEPS.SELECT_NOTION });
        case LEARNING_ASSESSMENT_STEPS.SELECT_EXERCISES:
          return dispatchAnalyticsEvent33(ANALYTICS_PAGE_VIEWED3, { pageName: LEARNING_ASSESSMENT_STEPS.SELECT_EXERCISES });
        case LEARNING_ASSESSMENT_STEPS.SELECT_GROUPS:
          return dispatchAnalyticsEvent33(ANALYTICS_PAGE_VIEWED3, { pageName: LEARNING_ASSESSMENT_STEPS.SELECT_GROUPS });
        case LEARNING_ASSESSMENT_STEPS.DEFAULT:
          return dispatchAnalyticsEvent33(ANALYTICS_PAGE_VIEWED3, { pageName: LEARNING_ASSESSMENT_STEPS.DEFAULT });
      }
    };
    getStepFromRoute2 = (pathname) => {
      switch (pathname) {
        case "/suivi-des-acquis/step/select_notion":
          return LEARNING_ASSESSMENT_STEPS.SELECT_NOTION;
        case "/suivi-des-acquis/step/select_exercises":
          return LEARNING_ASSESSMENT_STEPS.SELECT_EXERCISES;
        case "/suivi-des-acquis/step/select_groups":
          return LEARNING_ASSESSMENT_STEPS.SELECT_GROUPS;
        case "/suivi-des-acquis/step/start_session":
          return LEARNING_ASSESSMENT_STEPS.START_SESSION;
        case "/suivi-des-acquis/step/follow_group_progression":
          return LEARNING_ASSESSMENT_STEPS.FOLLOW_GROUP_PROGRESSION;
        default:
          return LEARNING_ASSESSMENT_STEPS.DEFAULT;
      }
    };
    getRouteToStep2 = (step, query) => {
      switch (step) {
        case LEARNING_ASSESSMENT_STEPS.SELECT_NOTION:
          return `/suivi-des-acquis/step/select_notion${handleQuerystring3({ chapterId: query == null ? void 0 : query.chapterId })}`;
        case LEARNING_ASSESSMENT_STEPS.SELECT_EXERCISES:
          return `/suivi-des-acquis/step/select_exercises${handleQuerystring3({ pageSlug: query == null ? void 0 : query.pageSlug, chapterId: query == null ? void 0 : query.chapterId })}`;
        case LEARNING_ASSESSMENT_STEPS.SELECT_GROUPS:
          return `/suivi-des-acquis/step/select_groups${handleQuerystring3({ pageSlug: query == null ? void 0 : query.pageSlug, chapterId: query == null ? void 0 : query.chapterId })}`;
        case LEARNING_ASSESSMENT_STEPS.START_SESSION:
          return `/suivi-des-acquis/step/start_session${handleQuerystring3({ pageSlug: query == null ? void 0 : query.pageSlug })}`;
        case LEARNING_ASSESSMENT_STEPS.FOLLOW_GROUP_PROGRESSION:
          return `/suivi-des-acquis/step/follow_group_progression${handleQuerystring3({ groupId: query == null ? void 0 : query.groupId, pageSlug: query == null ? void 0 : query.pageSlug })}`;
        default:
          return "/suivi-des-acquis";
      }
    };
    LearningAssessmentScreen = ({ ssrFetcher }) => {
      var _a2, _b2, _c2, _d;
      const history = useHistory44();
      const location = useLocation36();
      const queryParams = getQueryParams26(location);
      const token = _159.get("token", useSelector75(getAuth25));
      const currentUser = useSelector75(getCurrentUser44);
      const schools = useSearchSchools3({ ids: currentUser == null ? void 0 : currentUser.schools });
      const uri = "mathematiques-1re-2022-suividesacquis";
      const book = (_a2 = useSearchBooks12({ uris: [uri], hasNewDesign: true })) == null ? void 0 : _a2[0];
      const updateUserOnboardingData2 = useCustomEffect_default(updateUserOnboardingDataEffect);
      const setHasSeenLearningAssessment = useCallback70(() => {
        updateUserOnboardingData2({
          userId: currentUser == null ? void 0 : currentUser.id,
          onboardingData: { hasSeenLearningAssessment: true },
          token
        });
      }, [currentUser, token, updateUserOnboardingData2]);
      const isTeacher = currentUser == null ? void 0 : currentUser.isTeacher;
      const learningAssessmentPage = (_b2 = useSearchPages14({ slugs: [(queryParams == null ? void 0 : queryParams.pageSlug) ? queryParams == null ? void 0 : queryParams.pageSlug : ""] })) == null ? void 0 : _b2[0];
      const revisionPages = useSearchPages14({
        ids: (book == null ? void 0 : book.revisionPages) ?? [],
        thematicNames: [PAGES_THEMATIC.REVISION_EXERCISE],
        isLearningAssessment: true
      });
      const teacherAssessmentPages = useSearchModifiedPages5({
        userIds: [currentUser == null ? void 0 : currentUser.id],
        thematicNames: [PAGES_THEMATIC.REVISION_EXERCISE],
        isLearningAssessment: true,
        sharedGroups: currentUser == null ? void 0 : currentUser.groups
      });
      const userSharedPages = useSearchCurrentUserSharedPages9({ isLearningAssessment: true });
      const myLearningAssessmentPages = isTeacher ? teacherAssessmentPages : userSharedPages;
      const chapters = useSearchChapters7({ ids: _159.map("chapter", revisionPages), sortByQuery: sortChapters });
      const chapter = (_c2 = useSearchChapters7({ ids: [learningAssessmentPage == null ? void 0 : learningAssessmentPage.chapter] })) == null ? void 0 : _c2[0];
      const teachers = useSearchUsers5({
        ids: _159.map("user", myLearningAssessmentPages),
        schoolIds: _159.get("schools", currentUser)
      });
      const groups = useSearchGroups6({ ownerIds: [_159.get("id", currentUser)] });
      const students = useSearchStudents6({ ids: _159.flatMap("students", groups) });
      const onManageGroupClick = useCallback70(() => history.push(getPath("classroom_settings")), [history]);
      const onGoToHome = useCallback70(() => history.push(getPath("home")), [history]);
      const onGoTo2 = useCallback70((step, query) => history.push(getRouteToStep2(step, query)), [history]);
      const [selectedExercises, setSelectedExercises] = useState44([]);
      const shareLearningAssessmentSessionEffectFn = useCustomEffect_default(shareLearningAssessmentSessionEffect);
      const onShareSession = useCallback70(
        (selectedGroups) => {
          const uuids = _159.map("uuid", selectedExercises);
          const newPage = {
            ...learningAssessmentPage,
            children: selectedExercises,
            layouts: {
              vt: _159.intersection(uuids, learningAssessmentPage == null ? void 0 : learningAssessmentPage.layouts.vt)
            }
          };
          shareLearningAssessmentSessionEffectFn({ page: newPage, token, groups: selectedGroups });
        },
        [shareLearningAssessmentSessionEffectFn, token, learningAssessmentPage, selectedExercises]
      );
      const currentStep = getStepFromRoute2(_159.get("pathname", location));
      useEffect57(() => {
        sendPageViewedEvent(currentStep);
      }, [currentStep]);
      const fetchLearningAssessmentScreenParams = { uri, token, isTeacher: currentUser == null ? void 0 : currentUser.isTeacher };
      useFetch({ ssrFetcher, screen: SCREEN_LEARNING_ASSESSMENT, params: fetchLearningAssessmentScreenParams });
      const fetchPageEffectFn = useCustomEffect_default(fetchPageEffect);
      const queryParamsPageSlug = queryParams == null ? void 0 : queryParams.pageSlug;
      const canAccessLearningAssessment = _159.flow(
        _159.flatMap("validLicenses"),
        _159.some({ isEnabledForLearningAssessment: true })
      )(schools);
      useEffect57(() => {
        if (!canAccessLearningAssessment) return history.push(getPath("home"));
        !_159.isEmpty(queryParamsPageSlug) && fetchPageEffectFn({ slug: queryParamsPageSlug, token, useCache: false });
      }, [queryParamsPageSlug, fetchPageEffectFn, token, history, canAccessLearningAssessment]);
      const [finishedLearningAssessmentPages, learningAssessmentPages] = useMemo43(
        () => _159.partition((page) => {
          return _159.every((child) => !_159.isEmpty(child == null ? void 0 : child.responses), page.children);
        }, myLearningAssessmentPages),
        [myLearningAssessmentPages]
      );
      const stats = useLearningAssessmentStats_default({
        token,
        pages: myLearningAssessmentPages,
        groups,
        user: currentUser
      });
      const teacherProps = {
        groups,
        queryParams,
        students,
        myLearningAssessmentPages,
        onManageGroupClick,
        revisionPages,
        onShareSession,
        selectedExercises,
        setSelectedExercises,
        setHasSeenLearningAssessment,
        isFirstConnection: !((_d = currentUser == null ? void 0 : currentUser.onboardingData) == null ? void 0 : _d.hasSeenLearningAssessment)
      };
      const studentProps = {
        finishedLearningAssessmentPages,
        learningAssessmentPages,
        teachers,
        queryParams
      };
      return /* @__PURE__ */ jsxs103(Fragment39, { children: [
        /* @__PURE__ */ jsx145(metas_default, { screen: SCREEN_LEARNING_ASSESSMENT }),
        /* @__PURE__ */ jsx145(loading_default2, { screen: SCREEN_LEARNING_ASSESSMENT, params: fetchLearningAssessmentScreenParams }),
        /* @__PURE__ */ jsx145(
          LearningAssessment,
          {
            user: currentUser,
            chapter,
            onGoTo: onGoTo2,
            onGoToHome,
            chapters,
            currentStep,
            teacherProps,
            studentProps,
            stats,
            viewerElement: /* @__PURE__ */ jsx145(
              session_default2,
              {
                user: currentUser,
                stats,
                token,
                page: learningAssessmentPage,
                setSelectedExercises
              }
            )
          }
        )
      ] });
    };
    learningAssessment_default = LearningAssessmentScreen;
  }
});

// css-modules:css-modules://DiienxYN3ZzhHRqFL-T8a6E_FIzVWr0XHDEQg8TpusM.css
var init_DiienxYN3ZzhHRqFL_T8a6E_FIzVWr0XHDEQg8TpusM = __esm({
  "css-modules:css-modules://DiienxYN3ZzhHRqFL-T8a6E_FIzVWr0XHDEQg8TpusM.css"() {
  }
});

// tmp_esbuild1736180049684/_src_screens_externalLink.module.css
var src_screens_externalLink_default;
var init_src_screens_externalLink = __esm({
  "tmp_esbuild1736180049684/_src_screens_externalLink.module.css"() {
    "use strict";
    init_DiienxYN3ZzhHRqFL_T8a6E_FIzVWr0XHDEQg8TpusM();
    src_screens_externalLink_default = { "subtitle": "core-xBiENW-subtitle", "link": "core-xBiENW-link", "titleContainer": "core-xBiENW-titleContainer", "container": "core-xBiENW-container", "title": "core-xBiENW-title" };
  }
});

// src/screens/externalLink.module.css
var init_externalLink = __esm({
  "src/screens/externalLink.module.css"() {
    "use strict";
    init_src_screens_externalLink();
  }
});

// src/screens/externalLink.jsx
var externalLink_exports = {};
__export(externalLink_exports, {
  default: () => externalLink_default
});
import { getCurrentUser as getCurrentUser45 } from "@lls/store";
import { dispatchAnalyticsEvent as dispatchAnalyticsEvent34, getQueryParams as getQueryParams27, openWindow as openWindow21 } from "@lls/utils";
import _160 from "lodash/fp.js";
import { useEffect as useEffect58 } from "react";
import { useSelector as useSelector76 } from "react-redux";
import { useHistory as useHistory45, useLocation as useLocation37 } from "react-router-dom";
import { Icon as Icon11 } from "@lls/lls-kit";
import { jsx as jsx146, jsxs as jsxs104 } from "react/jsx-runtime";
var ExternalLinkScreen, externalLink_default;
var init_externalLink2 = __esm({
  "src/screens/externalLink.jsx"() {
    "use strict";
    init_analytics4();
    init_route();
    init_externalLink();
    ExternalLinkScreen = () => {
      const history = useHistory45();
      const location = useLocation37();
      const user = useSelector76(getCurrentUser45);
      const redirect = _160.flow(getQueryParams27, _160.get("redirect"))(location);
      useEffect58(() => {
        if (location.pathname !== getPath("external_redirect")) return;
        if (!redirect) return history.push(getPath("home"));
        if (!(user == null ? void 0 : user.isGarUser)) return openWindow21(redirect);
      }, [history, redirect, user, location]);
      useEffect58(() => {
        dispatchAnalyticsEvent34(ANALYTICS_EVENTS.PAGE_VIEWED);
      }, []);
      return /* @__PURE__ */ jsxs104("div", { className: src_screens_externalLink_default.container, children: [
        /* @__PURE__ */ jsxs104("div", { className: src_screens_externalLink_default.titleContainer, children: [
          /* @__PURE__ */ jsx146(Icon11, { height: "46", width: "46", name: "warningfilled" }),
          /* @__PURE__ */ jsx146("h1", { className: src_screens_externalLink_default.title, children: "Ce lien est bloqu\xE9" })
        ] }),
        /* @__PURE__ */ jsx146("div", { className: src_screens_externalLink_default.subtitle, children: "Vous voyez cet avertissement car vous \xEAtes connect\xE9 \xE0 votre ENT." }),
        /* @__PURE__ */ jsx146(
          "a",
          {
            className: src_screens_externalLink_default.link,
            onClick: () => dispatchAnalyticsEvent34(ANALYTICS_EVENTS.LINK_CLICKED),
            href: redirect,
            target: "_blank",
            rel: "noreferrer",
            children: "Continuer en sortant de l'ENT"
          }
        )
      ] });
    };
    externalLink_default = ExternalLinkScreen;
  }
});

// src/screens/notfound/index.jsx
var notfound_exports = {};
__export(notfound_exports, {
  default: () => notfound_default
});
import { Link as Link2 } from "react-router-dom";
import { Fragment as Fragment40, jsx as jsx147, jsxs as jsxs105 } from "react/jsx-runtime";
var NotFound, notfound_default;
var init_notfound = __esm({
  "src/screens/notfound/index.jsx"() {
    "use strict";
    NotFound = () => {
      const msg = "Revenir sur le site";
      const to = "/";
      return /* @__PURE__ */ jsxs105(Fragment40, { children: [
        /* @__PURE__ */ jsx147("h1", { children: "Erreur 404" }),
        /* @__PURE__ */ jsx147("p", { children: "Page introuvable" }),
        /* @__PURE__ */ jsx147(Link2, { to, children: msg })
      ] });
    };
    notfound_default = NotFound;
  }
});

// ../../node_modules/.pnpm/shallowequal@1.1.0/node_modules/shallowequal/index.js
var require_shallowequal = __commonJS({
  "../../node_modules/.pnpm/shallowequal@1.1.0/node_modules/shallowequal/index.js"(exports, module) {
    "use strict";
    module.exports = function shallowEqual8(objA, objB, compare, compareContext) {
      var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
      if (ret !== void 0) {
        return !!ret;
      }
      if (objA === objB) {
        return true;
      }
      if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
        return false;
      }
      var keysA = Object.keys(objA);
      var keysB = Object.keys(objB);
      if (keysA.length !== keysB.length) {
        return false;
      }
      var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
      for (var idx = 0; idx < keysA.length; idx++) {
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) {
          return false;
        }
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) {
          return false;
        }
      }
      return true;
    };
  }
});

// src/index.jsx
init_rootReducer();

// src/app.jsx
init_analytics3();

// src/components/clarity.tsx
init_config();
import { getCurrentUser } from "@lls/store";
import { useClarity } from "@lls/utils";
import { useSelector as useSelector2 } from "react-redux";
var Clarity = () => {
  const currentUser = useSelector2(getCurrentUser);
  useClarity({ user: currentUser, projectId: config_default.clarity_project_id });
  return null;
};
var clarity_default = Clarity;

// src/components/cookies.jsx
init_constants();
init_cookie();
init_es62();
import { getCurrentUser as getCurrentUser2 } from "@lls/store";
import { Cookies as CookiesSK } from "@lls/superkit";
import _11 from "lodash/fp.js";
import { useCallback as useCallback2, useEffect as useEffect2, useState as useState2 } from "react";
import { useSelector as useSelector3 } from "react-redux";
import { jsx as jsx2 } from "react/jsx-runtime";
var Cookies2 = () => {
  const [cookies, setCookie] = useCookies();
  const user = useSelector3(getCurrentUser2);
  const cookie3 = _11.get(COOKIE_DATA_COOKIE, cookies);
  const isGarStudent = (user == null ? void 0 : user.isGarUser) && (user == null ? void 0 : user.isStudent);
  const [hide4, setHide] = useState2(!!cookie3 || isGarStudent);
  useEffect2(() => {
    setHide(!!cookie3 || isGarStudent);
  }, [cookie3, isGarStudent]);
  const onClose = useCallback2(() => {
    setCookie(COOKIE_DATA_COOKIE, "true", getCookieOptions());
    setHide(true);
  }, [setCookie]);
  return !hide4 && /* @__PURE__ */ jsx2(CookiesSK, { onClose });
};
var cookies_default = process.env.CORE_COOKIES_SK === "0" ? () => null : Cookies2;

// src/components/crisp.jsx
init_actions();
init_config();
init_constants();
init_marketing();
import { useEffect as useEffect3, useRef as useRef2, useState as useState3 } from "react";
import { Z_BACKUPCRISP } from "@lls/lls-kit";
import { cx as cx2, getCrispUser, getWindow as getWindow3 } from "@lls/utils";
import _13 from "lodash/fp.js";
import { useDispatch, useSelector as useSelector4 } from "react-redux";
import { getCurrentUser as getCurrentUser3 } from "@lls/store";

// tmp_esbuild1736180049684/_src_components_crisp.module.css
var src_components_crisp_default = { "backup": "core-J86OAW-backup" };

// src/components/crisp.jsx
import { jsx as jsx3 } from "react/jsx-runtime";
var crisp_default = process.env.CORE_CRISP === "0" ? () => null : function Crisp() {
  const dispatch = useDispatch();
  const user = useSelector4(getCurrentUser3);
  const [isCrispReady, setCrispReady] = useState3(false);
  const [backupReturn, setBackupReturn] = useState3(true);
  const userRef = useRef2(user);
  const onBackupClick = () => {
    dispatch(setModal({ name: MODAL_CONTACT, open: true }));
  };
  useEffect3(() => {
    if (!_13.get("current.isGarUser", userRef)) {
      const windowRef = getWindow3();
      windowRef.$crisp = [];
      windowRef.CRISP_WEBSITE_ID = config_default.crisp_website_id;
      (() => {
        const d = document;
        const s = d.createElement("script");
        s.src = "https://client.crisp.chat/l.js";
        s.async = 1;
        d.getElementsByTagName("head")[0].appendChild(s);
      })();
      windowRef.CRISP_READY_TRIGGER = () => {
        setCrispReady(true);
      };
    }
  }, []);
  useEffect3(() => {
    if (isCrispReady === true) {
      setBackupReturn(false);
      const email = _13.get("emailCanonical", user);
      const crisp = _13.get("$crisp", window);
      try {
        crisp.push(["config", "container:index", [Z_BACKUPCRISP]]);
        if (isShownCrispComponent({ user })) {
          crisp.push(["do", "chat:show"]);
          email && crisp.push(["set", "user:email", email]);
          crisp.push(["set", "session:data", [getCrispUser(user)]]);
        } else {
          crisp.push(["do", "chat:hide"]);
        }
      } catch (error) {
        setBackupReturn(true);
        console.error("error loading crisp", error);
      }
    }
  }, [user, isCrispReady]);
  return backupReturn ? /* @__PURE__ */ jsx3(
    "button",
    {
      style: { "--cr-z-backupcrisp": Z_BACKUPCRISP },
      className: cx2("crisp-backup", src_components_crisp_default.backup),
      onClick: onBackupClick
    }
  ) : null;
};

// src/components/lazySwitch.jsx
import { usePrevious } from "@lls/utils";
import { Suspense, useCallback as useCallback3, useMemo as useMemo2, useRef as useRef3, useState as useState4 } from "react";
import { Route, Switch, matchPath as matchPath2, useLocation as useLocation2 } from "react-router-dom";
import { jsx as jsx4 } from "react/jsx-runtime";
import { createElement as createElement2 } from "react";
var useOldLocation = () => {
  const location = useLocation2();
  const oldLocationRef = useRef3();
  oldLocationRef.current = usePrevious(location) || location;
  return oldLocationRef;
};
var LazySwitch = ({ routes: iRoutes }) => {
  const location = useLocation2();
  const [localPathname, setLocalPathname] = useState4(location.pathname);
  const nextPathname = location.pathname;
  const oldLocationRef = useOldLocation(nextPathname);
  const onReady = useCallback3(() => {
    setLocalPathname(nextPathname);
  }, [nextPathname]);
  const routeReady = localPathname === nextPathname;
  const routes2 = useMemo2(() => {
    let display404 = true;
    return iRoutes.map(({ component: Component2, ...route }) => {
      return /* @__PURE__ */ createElement2(
        Route,
        { ...route, key: route.path },
        // we use a route to get the injected props
        // we use the children fashion so we can get the "match" object
        (props) => {
          if (!display404 && props.match && !route.exact) {
            return null;
          }
          const oldMatch = matchPath2(localPathname, route);
          if (props.match || oldMatch) {
            display404 = false;
            return /* @__PURE__ */ jsx4(
              Component2,
              {
                isNextRoute: !!props.match,
                routeReady,
                ...props,
                ...props.match ? {} : { match: oldMatch, location: oldLocationRef.current },
                onReady
              }
            );
          }
          return null;
        }
      );
    });
  }, [localPathname, routeReady, onReady, iRoutes, oldLocationRef]);
  return /* @__PURE__ */ jsx4(Suspense, { children: routes2 });
};
var StaticSwitch = ({ routes: routes2 }) => {
  return /* @__PURE__ */ jsx4(Switch, { children: routes2.map((route) => {
    return /* @__PURE__ */ createElement2(Route, { ...route, key: route.path });
  }) });
};
var lazySwitch_default = process.env.LAZYSWITCH === "1" ? LazySwitch : StaticSwitch;

// src/app.jsx
init_loading4();

// src/components/metas/static.jsx
init_config();
import { Helmet } from "react-helmet";
import { jsx as jsx6, jsxs } from "react/jsx-runtime";
var StaticMetas = () => /* @__PURE__ */ jsxs(Helmet, { children: [
  /* @__PURE__ */ jsx6("meta", { charSet: "utf-8" }),
  process.env.CORE_MANAGED_META !== "1" && /* @__PURE__ */ jsx6("meta", { name: "viewport", content: "width=device-width, initial-scale=1" }),
  /* @__PURE__ */ jsx6("meta", { name: "author", content: "Lelivrescolaire.fr \xC9ditions" }),
  /* @__PURE__ */ jsx6("meta", { name: "subject", content: "Manuel Scolaire Num\xE9rique" }),
  /* @__PURE__ */ jsx6("meta", { name: "rating", content: "safe for kids" }),
  /* @__PURE__ */ jsx6("meta", { name: "copyright", content: "Lelivrescolaire.fr \xC9ditions" }),
  /* @__PURE__ */ jsx6("meta", { name: "robots", content: config_default.env === "production" ? "noindex,nofollow" : "noindex,nofollow" }),
  /* @__PURE__ */ jsx6(
    "meta",
    {
      name: "keywords",
      content: "manuel scolaire, manuel numerique, livre, manuel enrichi, manuel personnalisable, exercices interactifs, exercice personnalisable, collaboratif, programme 2016, professeur, college, lyc\xE9e"
    }
  ),
  /* @__PURE__ */ jsx6("meta", { name: "og:type", content: "website" }),
  /* @__PURE__ */ jsx6("meta", { name: "og:locale", content: "fr_FR" }),
  /* @__PURE__ */ jsx6("meta", { name: "twitter:card", content: "summary" }),
  /* @__PURE__ */ jsx6("meta", { name: "twitter:site", content: "@Lelivrescolaire.fr" }),
  /* @__PURE__ */ jsx6("meta", { name: "twitter:creator", content: "@Lelivrescolaire.fr \xC9ditions" })
] });
var static_default = StaticMetas;

// src/effects/modal.js
init_actions();
init_utils3();
var closeModal = ({ dispatch, params }) => {
  const { modalName } = params;
  dispatch(
    setModal({
      name: modalName,
      open: false
    })
  );
};
var closeModalEffect = ({ dispatch, params }) => {
  tryCatch({
    dispatch,
    params,
    effect: closeModal,
    silent: true
  });
};

// src/components/modal/index.jsx
init_useCustomEffect();

// src/hooks/useNavigationModalCloser.js
init_useCustomEffect();
init_modal();
import _17 from "lodash/fp.js";
import { useEffect as useEffect4 } from "react";
import { useSelector as useSelector6 } from "react-redux";
import { useHistory as useHistory2 } from "react-router-dom";
var useNavigationModalCloser = ({ closeModalEffect: closeModalEffect2 }) => {
  const history = useHistory2();
  const closeModalEffectFn = useCustomEffect_default(closeModalEffect2);
  const openModal = useSelector6(getOpenModal);
  const modalName = _17.get("name", openModal);
  useEffect4(
    () => history.listen((_location, action) => {
      if (action === "POP") {
        closeModalEffectFn(modalName);
      }
    }),
    [history, modalName, closeModalEffectFn]
  );
};
var useNavigationModalCloser_default = useNavigationModalCloser;

// src/components/modal/index.jsx
init_modal();
init_constants();
import _44 from "lodash/fp.js";
import { useCallback as useCallback16 } from "react";
import { useSelector as useSelector20 } from "react-redux";

// src/components/modal/answersModal.jsx
init_route();
import { useCallback as useCallback5 } from "react";
import { Button as Button2, Modal } from "@lls/lls-kit";
import { openWindow as openWindow2 } from "@lls/utils";

// tmp_esbuild1736180049684/_src_components_modal_answersModal.module.css
var src_components_modal_answersModal_default = { "buttonContainer": "core-Il63Vq-buttonContainer", "modalContent": "core-Il63Vq-modalContent", "cta": "core-Il63Vq-cta" };

// src/components/modal/answersModal.jsx
import { jsx as jsx7, jsxs as jsxs2 } from "react/jsx-runtime";
var AnswersModal = ({ bookUri, close }) => {
  const goTo = useCallback5(() => {
    close();
    openWindow2(getPath("teacher_book", { bookUri }), "_blank");
  }, [close, bookUri]);
  return /* @__PURE__ */ jsx7(Modal, { title: "Afficher la correction", withCloseButton: false, closeModal: close, children: /* @__PURE__ */ jsx7("div", { className: src_components_modal_answersModal_default.modalContent, children: /* @__PURE__ */ jsxs2("div", { className: src_components_modal_answersModal_default.cta, children: [
    /* @__PURE__ */ jsx7("span", { children: "La correction est accessible dans le Livre du Professeur et peut \xEAtre affich\xE9e dans les champs de r\xE9ponses pour les enseignants abonn\xE9s \xE0 la version Premium." }),
    /* @__PURE__ */ jsx7("br", {}),
    /* @__PURE__ */ jsxs2("div", { className: src_components_modal_answersModal_default.buttonContainer, children: [
      /* @__PURE__ */ jsx7(Button2, { onClick: close, accent: "floating", theme: "gray", children: "Fermer" }),
      /* @__PURE__ */ jsx7(Button2, { onClick: goTo, inverted: true, accent: "floating", children: "Acc\xE9der au Livre du Professeur" })
    ] })
  ] }) }) });
};
var answersModal_default = AnswersModal;

// src/components/modal/availableSoonModal.jsx
import { Modal as Modal2 } from "@lls/lls-kit";

// tmp_esbuild1736180049684/_src_components_modal_availableSoonModal.module.css
var src_components_modal_availableSoonModal_default = { "modalContent": "core-MobTea-modalContent" };

// src/components/modal/availableSoonModal.jsx
import { jsx as jsx8 } from "react/jsx-runtime";
var AvailableSoonModal = ({ close }) => {
  return /* @__PURE__ */ jsx8(Modal2, { title: "Bient\xF4t disponible", closeModal: close, children: /* @__PURE__ */ jsx8("div", { className: src_components_modal_availableSoonModal_default.modalContent, children: "Nos \xE9quipes sont \xE0 pied d'\u0153uvre pour finaliser la mise en ligne de ce contenu. Il sera tr\xE8s prochainement accessible en ligne." }) });
};
var availableSoonModal_default = AvailableSoonModal;

// src/components/modal/bookResourcesModal.jsx
import { BookResourcesModal as BookResourcesModalSK } from "@lls/superkit";
import { getQueryParams as getQueryParams2, handleQuerystring as handleQuerystring2 } from "@lls/utils";
import _18 from "lodash/fp.js";
import { useCallback as useCallback6 } from "react";
import { useHistory as useHistory3, useLocation as useLocation3 } from "react-router-dom";
import { jsx as jsx9 } from "react/jsx-runtime";
var BookResourcesModal = ({ close, ...props }) => {
  const history = useHistory3();
  const query = getQueryParams2(useLocation3());
  const onClose = useCallback6(() => {
    const newStringifiedQuery = _18.flow(_18.unset("item"), handleQuerystring2)(query);
    history.replace({ search: newStringifiedQuery });
    close();
  }, [close, history, query]);
  return /* @__PURE__ */ jsx9(BookResourcesModalSK, { close: onClose, ...props });
};
var bookResourcesModal_default = BookResourcesModal;

// src/components/modal/contactModal.jsx
import { useSelector as useSelector7 } from "react-redux";
import { Button as Button3, Modal as Modal3 } from "@lls/lls-kit";
import { getCurrentUser as getCurrentUser4 } from "@lls/store";

// tmp_esbuild1736180049684/_src_components_modal_contactModal.module.css
var src_components_modal_contactModal_default = { "contactModalText": "core-DZL19W-contactModalText", "modalContent": "core-DZL19W-modalContent" };

// src/components/modal/contactModal.jsx
import { Fragment, jsx as jsx10, jsxs as jsxs3 } from "react/jsx-runtime";
var ContactModal = ({ close }) => {
  const currentUser = useSelector7(getCurrentUser4);
  const isTrial = currentUser == null ? void 0 : currentUser.isTrial;
  return /* @__PURE__ */ jsx10(Modal3, { title: "Informations de contact", closeModal: close, children: /* @__PURE__ */ jsxs3("div", { className: src_components_modal_contactModal_default.modalContent, children: [
    /* @__PURE__ */ jsxs3("p", { className: src_components_modal_contactModal_default.contactModalText, children: [
      "Nous serons ravis de vous r\xE9pondre \xE0 l'adresse mail",
      " ",
      /* @__PURE__ */ jsx10("a", { href: "mailto: numerique@lelivrescolaire.fr", children: "numerique@lelivrescolaire.fr" }),
      !isTrial && /* @__PURE__ */ jsxs3(Fragment, { children: [
        ", ou par t\xE9l\xE9phone au ",
        /* @__PURE__ */ jsx10("a", { href: "tel: +33982212994", children: "+33 (0)9 82 21 29 94" })
      ] }),
      " ",
      "pour tout besoin d'informations suppl\xE9mentaires \u{1F60A}"
    ] }),
    /* @__PURE__ */ jsx10(Button3, { accent: "floating", onClick: close, children: "Fermer" })
  ] }) });
};
var contactModal_default = ContactModal;

// src/components/modal/newsModal.jsx
import { Modal as Modal4 } from "@lls/lls-kit";
import _19 from "lodash/fp.js";

// tmp_esbuild1736180049684/_src_components_modal_newsModal.module.css
var src_components_modal_newsModal_default = { "newsContent": "core-EbJOPG-newsContent", "modalContent": "core-EbJOPG-modalContent" };

// src/components/modal/newsModal.jsx
import { jsx as jsx11 } from "react/jsx-runtime";
var NewsModal = ({ newsItem, close }) => {
  return /* @__PURE__ */ jsx11(Modal4, { title: _19.get("displayTitle", newsItem), closeModal: close, children: /* @__PURE__ */ jsx11("div", { className: src_components_modal_newsModal_default.modalContent, children: /* @__PURE__ */ jsx11("div", { className: src_components_modal_newsModal_default.newsContent, dangerouslySetInnerHTML: { __html: _19.get("content", newsItem) } }) }) });
};
var newsModal_default = NewsModal;

// src/components/modal/notTeaserModal.jsx
init_withRouterProvider();
import { Button as Button4, Icon, Modal as Modal5 } from "@lls/lls-kit";

// tmp_esbuild1736180049684/_src_components_modal_notTeaserModal.module.css
var src_components_modal_notTeaserModal_default = { "modalContent": "core-y-rJxG-modalContent", "marketingModalActions": "core-y-rJxG-marketingModalActions" };

// src/components/modal/notTeaserModal.jsx
import { jsx as jsx13, jsxs as jsxs4 } from "react/jsx-runtime";
var NotTeaserModal = ({ close }) => {
  const onClick = useAppData().onUnlockApplication;
  return /* @__PURE__ */ jsx13(Modal5, { title: "Contenu bloqu\xE9", maxWidth: 360, closeModal: close, children: /* @__PURE__ */ jsxs4("div", { className: src_components_modal_notTeaserModal_default.modalContent, children: [
    /* @__PURE__ */ jsx13(Icon, { name: "lockfilled", color: "var(--primary-40-color)", width: 48, height: 48 }),
    /* @__PURE__ */ jsxs4("p", { children: [
      "Nous vous offrons un extrait du manuel.",
      /* @__PURE__ */ jsx13("br", {}),
      "Pour consulter l'enti\xE8ret\xE9 du contenu, vous devez acheter le manuel entier ou poss\xE9der un abonnement."
    ] }),
    /* @__PURE__ */ jsxs4("div", { className: src_components_modal_notTeaserModal_default.marketingModalActions, children: [
      /* @__PURE__ */ jsx13(Button4, { onClick, maxSize: true, children: "D\xE9bloquer l'application" }),
      /* @__PURE__ */ jsx13(Button4, { maxSize: true, theme: "primary", accent: "floating", onClick: close, children: "Continuer l'essai" })
    ] })
  ] }) });
};
var notTeaserModal_default = NotTeaserModal;

// src/components/modal/npsModal.jsx
init_constants();

// src/effects/marketing.js
init_marketing2();
init_utils3();
var sendNps2 = ({ dispatch, params }) => {
  sendNps(params);
  triggerNotification({
    name: "success",
    message: "Merci pour votre retour. Votre avis est important pour nous",
    dispatch
  });
};
var sendNpsEffect = ({ dispatch, params }) => {
  tryCatch({ dispatch, params, effect: sendNps2 });
};

// src/components/modal/npsModal.jsx
init_useCustomEffect();
init_cookie();
init_es62();
import { NpsModal as NpsModalSK } from "@lls/superkit";
import { useCallback as useCallback7 } from "react";
import { jsx as jsx14 } from "react/jsx-runtime";
var NpsModal = ({ close, userId }) => {
  const [, setCookies] = useCookies();
  const onClose = useCallback7(() => {
    setCookies(COOKIE_NPS, "true", getCookieOptions(COOKIE_NPS_DURATION));
    close();
  }, [close, setCookies]);
  const sendNpsEffectFunction = useCustomEffect_default(sendNpsEffect);
  const onSubmit = useCallback7(
    (note) => {
      sendNpsEffectFunction({
        note,
        userId
      });
      onClose();
    },
    [sendNpsEffectFunction, userId, onClose]
  );
  return /* @__PURE__ */ jsx14(NpsModalSK, { close: onClose, onSubmit });
};
var npsModal_default = NpsModal;

// src/components/modal/offlineModal.jsx
import { OfflineModal as OfflineModalSk } from "@lls/superkit";
import { jsx as jsx15 } from "react/jsx-runtime";
var OfflineModal = (props) => /* @__PURE__ */ jsx15(OfflineModalSk, { ...props });
var offlineModal_default = OfflineModal;

// ../../node_modules/.pnpm/react-hook-form@7.52.1_react@18.3.1/node_modules/react-hook-form/dist/index.esm.mjs
import React5 from "react";
var isCheckBoxInput = (element) => element.type === "checkbox";
var isDateObject = (value) => value instanceof Date;
var isNullOrUndefined = (value) => value == null;
var isObjectType = (value) => typeof value === "object";
var isObject = (value) => !isNullOrUndefined(value) && !Array.isArray(value) && isObjectType(value) && !isDateObject(value);
var getEventValue = (event) => isObject(event) && event.target ? isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var getNodeParentName = (name) => name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var isNameInFieldArray = (names, name) => names.has(getNodeParentName(name));
var isPlainObject = (tempObject) => {
  const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
  return isObject(prototypeCopy) && prototypeCopy.hasOwnProperty("isPrototypeOf");
};
var isWeb = typeof window !== "undefined" && typeof window.HTMLElement !== "undefined" && typeof document !== "undefined";
function cloneObject(data) {
  let copy;
  const isArray = Array.isArray(data);
  if (data instanceof Date) {
    copy = new Date(data);
  } else if (data instanceof Set) {
    copy = new Set(data);
  } else if (!(isWeb && (data instanceof Blob || data instanceof FileList)) && (isArray || isObject(data))) {
    copy = isArray ? [] : {};
    if (!isArray && !isPlainObject(data)) {
      copy = data;
    } else {
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          copy[key] = cloneObject(data[key]);
        }
      }
    }
  } else {
    return data;
  }
  return copy;
}
var compact = (value) => Array.isArray(value) ? value.filter(Boolean) : [];
var isUndefined = (val) => val === void 0;
var get = (object, path, defaultValue) => {
  if (!path || !isObject(object)) {
    return defaultValue;
  }
  const result = compact(path.split(/[,[\].]+?/)).reduce((result2, key) => isNullOrUndefined(result2) ? result2 : result2[key], object);
  return isUndefined(result) || result === object ? isUndefined(object[path]) ? defaultValue : object[path] : result;
};
var isBoolean = (value) => typeof value === "boolean";
var isKey = (value) => /^\w*$/.test(value);
var stringToPath = (input) => compact(input.replace(/["|']|\]/g, "").split(/\.|\[/));
var set = (object, path, value) => {
  let index3 = -1;
  const tempPath = isKey(path) ? [path] : stringToPath(path);
  const length = tempPath.length;
  const lastIndex = length - 1;
  while (++index3 < length) {
    const key = tempPath[index3];
    let newValue = value;
    if (index3 !== lastIndex) {
      const objValue = object[key];
      newValue = isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index3 + 1]) ? [] : {};
    }
    if (key === "__proto__") {
      return;
    }
    object[key] = newValue;
    object = object[key];
  }
  return object;
};
var EVENTS = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
};
var VALIDATION_MODE = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
};
var INPUT_VALIDATION_RULES = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
};
var HookFormContext = React5.createContext(null);
var useFormContext = () => React5.useContext(HookFormContext);
var getProxyFormState = (formState, control, localProxyFormState, isRoot = true) => {
  const result = {
    defaultValues: control._defaultValues
  };
  for (const key in formState) {
    Object.defineProperty(result, key, {
      get: () => {
        const _key = key;
        if (control._proxyFormState[_key] !== VALIDATION_MODE.all) {
          control._proxyFormState[_key] = !isRoot || VALIDATION_MODE.all;
        }
        localProxyFormState && (localProxyFormState[_key] = true);
        return formState[_key];
      }
    });
  }
  return result;
};
var isEmptyObject = (value) => isObject(value) && !Object.keys(value).length;
var shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot) => {
  updateFormState(formStateData);
  const { name, ...formState } = formStateData;
  return isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key) => _proxyFormState[key] === (!isRoot || VALIDATION_MODE.all));
};
var convertToArrayPayload = (value) => Array.isArray(value) ? value : [value];
var shouldSubscribeByName = (name, signalName, exact) => !name || !signalName || name === signalName || convertToArrayPayload(name).some((currentName) => currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
function useSubscribe(props) {
  const _props = React5.useRef(props);
  _props.current = props;
  React5.useEffect(() => {
    const subscription = !props.disabled && _props.current.subject && _props.current.subject.subscribe({
      next: _props.current.next
    });
    return () => {
      subscription && subscription.unsubscribe();
    };
  }, [props.disabled]);
}
function useFormState(props) {
  const methods = useFormContext();
  const { control = methods.control, disabled, name, exact } = props || {};
  const [formState, updateFormState] = React5.useState(control._formState);
  const _mounted = React5.useRef(true);
  const _localProxyFormState = React5.useRef({
    isDirty: false,
    isLoading: false,
    dirtyFields: false,
    touchedFields: false,
    validatingFields: false,
    isValidating: false,
    isValid: false,
    errors: false
  });
  const _name = React5.useRef(name);
  _name.current = name;
  useSubscribe({
    disabled,
    next: (value) => _mounted.current && shouldSubscribeByName(_name.current, value.name, exact) && shouldRenderFormState(value, _localProxyFormState.current, control._updateFormState) && updateFormState({
      ...control._formState,
      ...value
    }),
    subject: control._subjects.state
  });
  React5.useEffect(() => {
    _mounted.current = true;
    _localProxyFormState.current.isValid && control._updateValid(true);
    return () => {
      _mounted.current = false;
    };
  }, [control]);
  return getProxyFormState(formState, control, _localProxyFormState.current, false);
}
var isString = (value) => typeof value === "string";
var generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue) => {
  if (isString(names)) {
    isGlobal && _names.watch.add(names);
    return get(formValues, names, defaultValue);
  }
  if (Array.isArray(names)) {
    return names.map((fieldName) => (isGlobal && _names.watch.add(fieldName), get(formValues, fieldName)));
  }
  isGlobal && (_names.watchAll = true);
  return formValues;
};
function useWatch(props) {
  const methods = useFormContext();
  const { control = methods.control, name, defaultValue, disabled, exact } = props || {};
  const _name = React5.useRef(name);
  _name.current = name;
  useSubscribe({
    disabled,
    subject: control._subjects.values,
    next: (formState) => {
      if (shouldSubscribeByName(_name.current, formState.name, exact)) {
        updateValue(cloneObject(generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
      }
    }
  });
  const [value, updateValue] = React5.useState(control._getWatch(name, defaultValue));
  React5.useEffect(() => control._removeUnmounted());
  return value;
}
function useController(props) {
  const methods = useFormContext();
  const { name, disabled, control = methods.control, shouldUnregister } = props;
  const isArrayField = isNameInFieldArray(control._names.array, name);
  const value = useWatch({
    control,
    name,
    defaultValue: get(control._formValues, name, get(control._defaultValues, name, props.defaultValue)),
    exact: true
  });
  const formState = useFormState({
    control,
    name
  });
  const _registerProps = React5.useRef(control.register(name, {
    ...props.rules,
    value,
    ...isBoolean(props.disabled) ? { disabled: props.disabled } : {}
  }));
  React5.useEffect(() => {
    const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
    const updateMounted = (name2, value2) => {
      const field = get(control._fields, name2);
      if (field && field._f) {
        field._f.mount = value2;
      }
    };
    updateMounted(name, true);
    if (_shouldUnregisterField) {
      const value2 = cloneObject(get(control._options.defaultValues, name));
      set(control._defaultValues, name, value2);
      if (isUndefined(get(control._formValues, name))) {
        set(control._formValues, name, value2);
      }
    }
    return () => {
      (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
    };
  }, [name, control, isArrayField, shouldUnregister]);
  React5.useEffect(() => {
    if (get(control._fields, name)) {
      control._updateDisabledField({
        disabled,
        fields: control._fields,
        name,
        value: get(control._fields, name)._f.value
      });
    }
  }, [disabled, name, control]);
  return {
    field: {
      name,
      value,
      ...isBoolean(disabled) || formState.disabled ? { disabled: formState.disabled || disabled } : {},
      onChange: React5.useCallback((event) => _registerProps.current.onChange({
        target: {
          value: getEventValue(event),
          name
        },
        type: EVENTS.CHANGE
      }), [name]),
      onBlur: React5.useCallback(() => _registerProps.current.onBlur({
        target: {
          value: get(control._formValues, name),
          name
        },
        type: EVENTS.BLUR
      }), [name, control]),
      ref: (elm) => {
        const field = get(control._fields, name);
        if (field && elm) {
          field._f.ref = {
            focus: () => elm.focus(),
            select: () => elm.select(),
            setCustomValidity: (message) => elm.setCustomValidity(message),
            reportValidity: () => elm.reportValidity()
          };
        }
      }
    },
    formState,
    fieldState: Object.defineProperties({}, {
      invalid: {
        enumerable: true,
        get: () => !!get(formState.errors, name)
      },
      isDirty: {
        enumerable: true,
        get: () => !!get(formState.dirtyFields, name)
      },
      isTouched: {
        enumerable: true,
        get: () => !!get(formState.touchedFields, name)
      },
      isValidating: {
        enumerable: true,
        get: () => !!get(formState.validatingFields, name)
      },
      error: {
        enumerable: true,
        get: () => get(formState.errors, name)
      }
    })
  };
}
var Controller = (props) => props.render(useController(props));
var appendErrors = (name, validateAllFieldCriteria, errors, type, message) => validateAllFieldCriteria ? {
  ...errors[name],
  types: {
    ...errors[name] && errors[name].types ? errors[name].types : {},
    [type]: message || true
  }
} : {};
var getValidationModes = (mode) => ({
  isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
  isOnBlur: mode === VALIDATION_MODE.onBlur,
  isOnChange: mode === VALIDATION_MODE.onChange,
  isOnAll: mode === VALIDATION_MODE.all,
  isOnTouch: mode === VALIDATION_MODE.onTouched
});
var isWatched = (name, _names, isBlurEvent) => !isBlurEvent && (_names.watchAll || _names.watch.has(name) || [..._names.watch].some((watchName) => name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
var iterateFieldsByAction = (fields, action, fieldsNames, abortEarly) => {
  for (const key of fieldsNames || Object.keys(fields)) {
    const field = get(fields, key);
    if (field) {
      const { _f, ...currentField } = field;
      if (_f) {
        if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) {
          break;
        } else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) {
          break;
        } else {
          iterateFieldsByAction(currentField, action);
        }
      } else if (isObject(currentField)) {
        iterateFieldsByAction(currentField, action);
      }
    }
  }
};
var updateFieldArrayRootError = (errors, error, name) => {
  const fieldArrayErrors = convertToArrayPayload(get(errors, name));
  set(fieldArrayErrors, "root", error[name]);
  set(errors, name, fieldArrayErrors);
  return errors;
};
var isFileInput = (element) => element.type === "file";
var isFunction = (value) => typeof value === "function";
var isHTMLElement = (value) => {
  if (!isWeb) {
    return false;
  }
  const owner = value ? value.ownerDocument : 0;
  return value instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var isMessage = (value) => isString(value);
var isRadioInput = (element) => element.type === "radio";
var isRegex = (value) => value instanceof RegExp;
var defaultResult = {
  value: false,
  isValid: false
};
var validResult = { value: true, isValid: true };
var getCheckboxValue = (options) => {
  if (Array.isArray(options)) {
    if (options.length > 1) {
      const values = options.filter((option) => option && option.checked && !option.disabled).map((option) => option.value);
      return { value: values, isValid: !!values.length };
    }
    return options[0].checked && !options[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      options[0].attributes && !isUndefined(options[0].attributes.value) ? isUndefined(options[0].value) || options[0].value === "" ? validResult : { value: options[0].value, isValid: true } : validResult
    ) : defaultResult;
  }
  return defaultResult;
};
var defaultReturn = {
  isValid: false,
  value: null
};
var getRadioValue = (options) => Array.isArray(options) ? options.reduce((previous, option) => option && option.checked && !option.disabled ? {
  isValid: true,
  value: option.value
} : previous, defaultReturn) : defaultReturn;
function getValidateError(result, ref, type = "validate") {
  if (isMessage(result) || Array.isArray(result) && result.every(isMessage) || isBoolean(result) && !result) {
    return {
      type,
      message: isMessage(result) ? result : "",
      ref
    };
  }
}
var getValueAndMessage = (validationData) => isObject(validationData) && !isRegex(validationData) ? validationData : {
  value: validationData,
  message: ""
};
var validateField = async (field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray) => {
  const { ref, refs, required, maxLength, minLength, min: min2, max: max2, pattern, validate, name, valueAsNumber, mount, disabled } = field._f;
  const inputValue = get(formValues, name);
  if (!mount || disabled) {
    return {};
  }
  const inputRef = refs ? refs[0] : ref;
  const setCustomValidity = (message) => {
    if (shouldUseNativeValidation && inputRef.reportValidity) {
      inputRef.setCustomValidity(isBoolean(message) ? "" : message || "");
      inputRef.reportValidity();
    }
  };
  const error = {};
  const isRadio = isRadioInput(ref);
  const isCheckBox = isCheckBoxInput(ref);
  const isRadioOrCheckbox2 = isRadio || isCheckBox;
  const isEmpty = (valueAsNumber || isFileInput(ref)) && isUndefined(ref.value) && isUndefined(inputValue) || isHTMLElement(ref) && ref.value === "" || inputValue === "" || Array.isArray(inputValue) && !inputValue.length;
  const appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);
  const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = INPUT_VALIDATION_RULES.maxLength, minType = INPUT_VALIDATION_RULES.minLength) => {
    const message = exceedMax ? maxLengthMessage : minLengthMessage;
    error[name] = {
      type: exceedMax ? maxType : minType,
      message,
      ref,
      ...appendErrorsCurry(exceedMax ? maxType : minType, message)
    };
  };
  if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox2 && (isEmpty || isNullOrUndefined(inputValue)) || isBoolean(inputValue) && !inputValue || isCheckBox && !getCheckboxValue(refs).isValid || isRadio && !getRadioValue(refs).isValid)) {
    const { value, message } = isMessage(required) ? { value: !!required, message: required } : getValueAndMessage(required);
    if (value) {
      error[name] = {
        type: INPUT_VALIDATION_RULES.required,
        message,
        ref: inputRef,
        ...appendErrorsCurry(INPUT_VALIDATION_RULES.required, message)
      };
      if (!validateAllFieldCriteria) {
        setCustomValidity(message);
        return error;
      }
    }
  }
  if (!isEmpty && (!isNullOrUndefined(min2) || !isNullOrUndefined(max2))) {
    let exceedMax;
    let exceedMin;
    const maxOutput = getValueAndMessage(max2);
    const minOutput = getValueAndMessage(min2);
    if (!isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
      const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
      if (!isNullOrUndefined(maxOutput.value)) {
        exceedMax = valueNumber > maxOutput.value;
      }
      if (!isNullOrUndefined(minOutput.value)) {
        exceedMin = valueNumber < minOutput.value;
      }
    } else {
      const valueDate = ref.valueAsDate || new Date(inputValue);
      const convertTimeToDate = (time) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + time);
      const isTime = ref.type == "time";
      const isWeek = ref.type == "week";
      if (isString(maxOutput.value) && inputValue) {
        exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
      }
      if (isString(minOutput.value) && inputValue) {
        exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
      }
    }
    if (exceedMax || exceedMin) {
      getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);
      if (!validateAllFieldCriteria) {
        setCustomValidity(error[name].message);
        return error;
      }
    }
  }
  if ((maxLength || minLength) && !isEmpty && (isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
    const maxLengthOutput = getValueAndMessage(maxLength);
    const minLengthOutput = getValueAndMessage(minLength);
    const exceedMax = !isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
    const exceedMin = !isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
    if (exceedMax || exceedMin) {
      getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
      if (!validateAllFieldCriteria) {
        setCustomValidity(error[name].message);
        return error;
      }
    }
  }
  if (pattern && !isEmpty && isString(inputValue)) {
    const { value: patternValue, message } = getValueAndMessage(pattern);
    if (isRegex(patternValue) && !inputValue.match(patternValue)) {
      error[name] = {
        type: INPUT_VALIDATION_RULES.pattern,
        message,
        ref,
        ...appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, message)
      };
      if (!validateAllFieldCriteria) {
        setCustomValidity(message);
        return error;
      }
    }
  }
  if (validate) {
    if (isFunction(validate)) {
      const result = await validate(inputValue, formValues);
      const validateError = getValidateError(result, inputRef);
      if (validateError) {
        error[name] = {
          ...validateError,
          ...appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message)
        };
        if (!validateAllFieldCriteria) {
          setCustomValidity(validateError.message);
          return error;
        }
      }
    } else if (isObject(validate)) {
      let validationResult = {};
      for (const key in validate) {
        if (!isEmptyObject(validationResult) && !validateAllFieldCriteria) {
          break;
        }
        const validateError = getValidateError(await validate[key](inputValue, formValues), inputRef, key);
        if (validateError) {
          validationResult = {
            ...validateError,
            ...appendErrorsCurry(key, validateError.message)
          };
          setCustomValidity(validateError.message);
          if (validateAllFieldCriteria) {
            error[name] = validationResult;
          }
        }
      }
      if (!isEmptyObject(validationResult)) {
        error[name] = {
          ref: inputRef,
          ...validationResult
        };
        if (!validateAllFieldCriteria) {
          return error;
        }
      }
    }
  }
  setCustomValidity(true);
  return error;
};
function baseGet(object, updatePath) {
  const length = updatePath.slice(0, -1).length;
  let index3 = 0;
  while (index3 < length) {
    object = isUndefined(object) ? index3++ : object[updatePath[index3++]];
  }
  return object;
}
function isEmptyArray(obj) {
  for (const key in obj) {
    if (obj.hasOwnProperty(key) && !isUndefined(obj[key])) {
      return false;
    }
  }
  return true;
}
function unset(object, path) {
  const paths = Array.isArray(path) ? path : isKey(path) ? [path] : stringToPath(path);
  const childObject = paths.length === 1 ? object : baseGet(object, paths);
  const index3 = paths.length - 1;
  const key = paths[index3];
  if (childObject) {
    delete childObject[key];
  }
  if (index3 !== 0 && (isObject(childObject) && isEmptyObject(childObject) || Array.isArray(childObject) && isEmptyArray(childObject))) {
    unset(object, paths.slice(0, -1));
  }
  return object;
}
var createSubject = () => {
  let _observers = [];
  const next = (value) => {
    for (const observer of _observers) {
      observer.next && observer.next(value);
    }
  };
  const subscribe = (observer) => {
    _observers.push(observer);
    return {
      unsubscribe: () => {
        _observers = _observers.filter((o) => o !== observer);
      }
    };
  };
  const unsubscribe = () => {
    _observers = [];
  };
  return {
    get observers() {
      return _observers;
    },
    next,
    subscribe,
    unsubscribe
  };
};
var isPrimitive = (value) => isNullOrUndefined(value) || !isObjectType(value);
function deepEqual(object1, object2) {
  if (isPrimitive(object1) || isPrimitive(object2)) {
    return object1 === object2;
  }
  if (isDateObject(object1) && isDateObject(object2)) {
    return object1.getTime() === object2.getTime();
  }
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);
  if (keys1.length !== keys2.length) {
    return false;
  }
  for (const key of keys1) {
    const val1 = object1[key];
    if (!keys2.includes(key)) {
      return false;
    }
    if (key !== "ref") {
      const val2 = object2[key];
      if (isDateObject(val1) && isDateObject(val2) || isObject(val1) && isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !deepEqual(val1, val2) : val1 !== val2) {
        return false;
      }
    }
  }
  return true;
}
var isMultipleSelect = (element) => element.type === `select-multiple`;
var isRadioOrCheckbox = (ref) => isRadioInput(ref) || isCheckBoxInput(ref);
var live = (ref) => isHTMLElement(ref) && ref.isConnected;
var objectHasFunction = (data) => {
  for (const key in data) {
    if (isFunction(data[key])) {
      return true;
    }
  }
  return false;
};
function markFieldsDirty(data, fields = {}) {
  const isParentNodeArray = Array.isArray(data);
  if (isObject(data) || isParentNodeArray) {
    for (const key in data) {
      if (Array.isArray(data[key]) || isObject(data[key]) && !objectHasFunction(data[key])) {
        fields[key] = Array.isArray(data[key]) ? [] : {};
        markFieldsDirty(data[key], fields[key]);
      } else if (!isNullOrUndefined(data[key])) {
        fields[key] = true;
      }
    }
  }
  return fields;
}
function getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
  const isParentNodeArray = Array.isArray(data);
  if (isObject(data) || isParentNodeArray) {
    for (const key in data) {
      if (Array.isArray(data[key]) || isObject(data[key]) && !objectHasFunction(data[key])) {
        if (isUndefined(formValues) || isPrimitive(dirtyFieldsFromValues[key])) {
          dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? markFieldsDirty(data[key], []) : { ...markFieldsDirty(data[key]) };
        } else {
          getDirtyFieldsFromDefaultValues(data[key], isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        }
      } else {
        dirtyFieldsFromValues[key] = !deepEqual(data[key], formValues[key]);
      }
    }
  }
  return dirtyFieldsFromValues;
}
var getDirtyFields = (defaultValues, formValues) => getDirtyFieldsFromDefaultValues(defaultValues, formValues, markFieldsDirty(formValues));
var getFieldValueAs = (value, { valueAsNumber, valueAsDate, setValueAs }) => isUndefined(value) ? value : valueAsNumber ? value === "" ? NaN : value ? +value : value : valueAsDate && isString(value) ? new Date(value) : setValueAs ? setValueAs(value) : value;
function getFieldValue(_f) {
  const ref = _f.ref;
  if (_f.refs ? _f.refs.every((ref2) => ref2.disabled) : ref.disabled) {
    return;
  }
  if (isFileInput(ref)) {
    return ref.files;
  }
  if (isRadioInput(ref)) {
    return getRadioValue(_f.refs).value;
  }
  if (isMultipleSelect(ref)) {
    return [...ref.selectedOptions].map(({ value }) => value);
  }
  if (isCheckBoxInput(ref)) {
    return getCheckboxValue(_f.refs).value;
  }
  return getFieldValueAs(isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation) => {
  const fields = {};
  for (const name of fieldsNames) {
    const field = get(_fields, name);
    field && set(fields, name, field._f);
  }
  return {
    criteriaMode,
    names: [...fieldsNames],
    fields,
    shouldUseNativeValidation
  };
};
var getRuleValue = (rule) => isUndefined(rule) ? rule : isRegex(rule) ? rule.source : isObject(rule) ? isRegex(rule.value) ? rule.value.source : rule.value : rule;
var hasValidation = (options) => options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
function schemaErrorLookup(errors, _fields, name) {
  const error = get(errors, name);
  if (error || isKey(name)) {
    return {
      error,
      name
    };
  }
  const names = name.split(".");
  while (names.length) {
    const fieldName = names.join(".");
    const field = get(_fields, fieldName);
    const foundError = get(errors, fieldName);
    if (field && !Array.isArray(field) && name !== fieldName) {
      return { name };
    }
    if (foundError && foundError.type) {
      return {
        name: fieldName,
        error: foundError
      };
    }
    names.pop();
  }
  return {
    name
  };
}
var skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode) => {
  if (mode.isOnAll) {
    return false;
  } else if (!isSubmitted && mode.isOnTouch) {
    return !(isTouched || isBlurEvent);
  } else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) {
    return !isBlurEvent;
  } else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) {
    return isBlurEvent;
  }
  return true;
};
var unsetEmptyArray = (ref, name) => !compact(get(ref, name)).length && unset(ref, name);
var defaultOptions = {
  mode: VALIDATION_MODE.onSubmit,
  reValidateMode: VALIDATION_MODE.onChange,
  shouldFocusError: true
};
function createFormControl(props = {}) {
  let _options = {
    ...defaultOptions,
    ...props
  };
  let _formState = {
    submitCount: 0,
    isDirty: false,
    isLoading: isFunction(_options.defaultValues),
    isValidating: false,
    isSubmitted: false,
    isSubmitting: false,
    isSubmitSuccessful: false,
    isValid: false,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: _options.errors || {},
    disabled: _options.disabled || false
  };
  let _fields = {};
  let _defaultValues = isObject(_options.defaultValues) || isObject(_options.values) ? cloneObject(_options.defaultValues || _options.values) || {} : {};
  let _formValues = _options.shouldUnregister ? {} : cloneObject(_defaultValues);
  let _state = {
    action: false,
    mount: false,
    watch: false
  };
  let _names = {
    mount: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  };
  let delayErrorCallback;
  let timer = 0;
  const _proxyFormState = {
    isDirty: false,
    dirtyFields: false,
    validatingFields: false,
    touchedFields: false,
    isValidating: false,
    isValid: false,
    errors: false
  };
  const _subjects = {
    values: createSubject(),
    array: createSubject(),
    state: createSubject()
  };
  const validationModeBeforeSubmit = getValidationModes(_options.mode);
  const validationModeAfterSubmit = getValidationModes(_options.reValidateMode);
  const shouldDisplayAllAssociatedErrors = _options.criteriaMode === VALIDATION_MODE.all;
  const debounce = (callback) => (wait) => {
    clearTimeout(timer);
    timer = setTimeout(callback, wait);
  };
  const _updateValid = async (shouldUpdateValid) => {
    if (_proxyFormState.isValid || shouldUpdateValid) {
      const isValid = _options.resolver ? isEmptyObject((await _executeSchema()).errors) : await executeBuiltInValidation(_fields, true);
      if (isValid !== _formState.isValid) {
        _subjects.state.next({
          isValid
        });
      }
    }
  };
  const _updateIsValidating = (names, isValidating) => {
    if (_proxyFormState.isValidating || _proxyFormState.validatingFields) {
      (names || Array.from(_names.mount)).forEach((name) => {
        if (name) {
          isValidating ? set(_formState.validatingFields, name, isValidating) : unset(_formState.validatingFields, name);
        }
      });
      _subjects.state.next({
        validatingFields: _formState.validatingFields,
        isValidating: !isEmptyObject(_formState.validatingFields)
      });
    }
  };
  const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true) => {
    if (args && method) {
      _state.action = true;
      if (shouldUpdateFieldsAndState && Array.isArray(get(_fields, name))) {
        const fieldValues = method(get(_fields, name), args.argA, args.argB);
        shouldSetValues && set(_fields, name, fieldValues);
      }
      if (shouldUpdateFieldsAndState && Array.isArray(get(_formState.errors, name))) {
        const errors = method(get(_formState.errors, name), args.argA, args.argB);
        shouldSetValues && set(_formState.errors, name, errors);
        unsetEmptyArray(_formState.errors, name);
      }
      if (_proxyFormState.touchedFields && shouldUpdateFieldsAndState && Array.isArray(get(_formState.touchedFields, name))) {
        const touchedFields = method(get(_formState.touchedFields, name), args.argA, args.argB);
        shouldSetValues && set(_formState.touchedFields, name, touchedFields);
      }
      if (_proxyFormState.dirtyFields) {
        _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
      }
      _subjects.state.next({
        name,
        isDirty: _getDirty(name, values),
        dirtyFields: _formState.dirtyFields,
        errors: _formState.errors,
        isValid: _formState.isValid
      });
    } else {
      set(_formValues, name, values);
    }
  };
  const updateErrors = (name, error) => {
    set(_formState.errors, name, error);
    _subjects.state.next({
      errors: _formState.errors
    });
  };
  const _setErrors = (errors) => {
    _formState.errors = errors;
    _subjects.state.next({
      errors: _formState.errors,
      isValid: false
    });
  };
  const updateValidAndValue = (name, shouldSkipSetValueAs, value, ref) => {
    const field = get(_fields, name);
    if (field) {
      const defaultValue = get(_formValues, name, isUndefined(value) ? get(_defaultValues, name) : value);
      isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? set(_formValues, name, shouldSkipSetValueAs ? defaultValue : getFieldValue(field._f)) : setFieldValue(name, defaultValue);
      _state.mount && _updateValid();
    }
  };
  const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender) => {
    let shouldUpdateField = false;
    let isPreviousDirty = false;
    const output = {
      name
    };
    const disabledField = !!(get(_fields, name) && get(_fields, name)._f && get(_fields, name)._f.disabled);
    if (!isBlurEvent || shouldDirty) {
      if (_proxyFormState.isDirty) {
        isPreviousDirty = _formState.isDirty;
        _formState.isDirty = output.isDirty = _getDirty();
        shouldUpdateField = isPreviousDirty !== output.isDirty;
      }
      const isCurrentFieldPristine = disabledField || deepEqual(get(_defaultValues, name), fieldValue);
      isPreviousDirty = !!(!disabledField && get(_formState.dirtyFields, name));
      isCurrentFieldPristine || disabledField ? unset(_formState.dirtyFields, name) : set(_formState.dirtyFields, name, true);
      output.dirtyFields = _formState.dirtyFields;
      shouldUpdateField = shouldUpdateField || _proxyFormState.dirtyFields && isPreviousDirty !== !isCurrentFieldPristine;
    }
    if (isBlurEvent) {
      const isPreviousFieldTouched = get(_formState.touchedFields, name);
      if (!isPreviousFieldTouched) {
        set(_formState.touchedFields, name, isBlurEvent);
        output.touchedFields = _formState.touchedFields;
        shouldUpdateField = shouldUpdateField || _proxyFormState.touchedFields && isPreviousFieldTouched !== isBlurEvent;
      }
    }
    shouldUpdateField && shouldRender && _subjects.state.next(output);
    return shouldUpdateField ? output : {};
  };
  const shouldRenderByError = (name, isValid, error, fieldState) => {
    const previousFieldError = get(_formState.errors, name);
    const shouldUpdateValid = _proxyFormState.isValid && isBoolean(isValid) && _formState.isValid !== isValid;
    if (props.delayError && error) {
      delayErrorCallback = debounce(() => updateErrors(name, error));
      delayErrorCallback(props.delayError);
    } else {
      clearTimeout(timer);
      delayErrorCallback = null;
      error ? set(_formState.errors, name, error) : unset(_formState.errors, name);
    }
    if ((error ? !deepEqual(previousFieldError, error) : previousFieldError) || !isEmptyObject(fieldState) || shouldUpdateValid) {
      const updatedFormState = {
        ...fieldState,
        ...shouldUpdateValid && isBoolean(isValid) ? { isValid } : {},
        errors: _formState.errors,
        name
      };
      _formState = {
        ..._formState,
        ...updatedFormState
      };
      _subjects.state.next(updatedFormState);
    }
  };
  const _executeSchema = async (name) => {
    _updateIsValidating(name, true);
    const result = await _options.resolver(_formValues, _options.context, getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
    _updateIsValidating(name);
    return result;
  };
  const executeSchemaAndUpdateState = async (names) => {
    const { errors } = await _executeSchema(names);
    if (names) {
      for (const name of names) {
        const error = get(errors, name);
        error ? set(_formState.errors, name, error) : unset(_formState.errors, name);
      }
    } else {
      _formState.errors = errors;
    }
    return errors;
  };
  const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
    valid: true
  }) => {
    for (const name in fields) {
      const field = fields[name];
      if (field) {
        const { _f, ...fieldValue } = field;
        if (_f) {
          const isFieldArrayRoot = _names.array.has(_f.name);
          _updateIsValidating([name], true);
          const fieldError = await validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
          _updateIsValidating([name]);
          if (fieldError[_f.name]) {
            context.valid = false;
            if (shouldOnlyCheckValid) {
              break;
            }
          }
          !shouldOnlyCheckValid && (get(fieldError, _f.name) ? isFieldArrayRoot ? updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : set(_formState.errors, _f.name, fieldError[_f.name]) : unset(_formState.errors, _f.name));
        }
        fieldValue && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
      }
    }
    return context.valid;
  };
  const _removeUnmounted = () => {
    for (const name of _names.unMount) {
      const field = get(_fields, name);
      field && (field._f.refs ? field._f.refs.every((ref) => !live(ref)) : !live(field._f.ref)) && unregister(name);
    }
    _names.unMount = /* @__PURE__ */ new Set();
  };
  const _getDirty = (name, data) => (name && data && set(_formValues, name, data), !deepEqual(getValues(), _defaultValues));
  const _getWatch = (names, defaultValue, isGlobal) => generateWatchOutput(names, _names, {
    ..._state.mount ? _formValues : isUndefined(defaultValue) ? _defaultValues : isString(names) ? { [names]: defaultValue } : defaultValue
  }, isGlobal, defaultValue);
  const _getFieldArray = (name) => compact(get(_state.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? get(_defaultValues, name, []) : []));
  const setFieldValue = (name, value, options = {}) => {
    const field = get(_fields, name);
    let fieldValue = value;
    if (field) {
      const fieldReference = field._f;
      if (fieldReference) {
        !fieldReference.disabled && set(_formValues, name, getFieldValueAs(value, fieldReference));
        fieldValue = isHTMLElement(fieldReference.ref) && isNullOrUndefined(value) ? "" : value;
        if (isMultipleSelect(fieldReference.ref)) {
          [...fieldReference.ref.options].forEach((optionRef) => optionRef.selected = fieldValue.includes(optionRef.value));
        } else if (fieldReference.refs) {
          if (isCheckBoxInput(fieldReference.ref)) {
            fieldReference.refs.length > 1 ? fieldReference.refs.forEach((checkboxRef) => (!checkboxRef.defaultChecked || !checkboxRef.disabled) && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find((data) => data === checkboxRef.value) : fieldValue === checkboxRef.value)) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
          } else {
            fieldReference.refs.forEach((radioRef) => radioRef.checked = radioRef.value === fieldValue);
          }
        } else if (isFileInput(fieldReference.ref)) {
          fieldReference.ref.value = "";
        } else {
          fieldReference.ref.value = fieldValue;
          if (!fieldReference.ref.type) {
            _subjects.values.next({
              name,
              values: { ..._formValues }
            });
          }
        }
      }
    }
    (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
    options.shouldValidate && trigger(name);
  };
  const setValues = (name, value, options) => {
    for (const fieldKey in value) {
      const fieldValue = value[fieldKey];
      const fieldName = `${name}.${fieldKey}`;
      const field = get(_fields, fieldName);
      (_names.array.has(name) || !isPrimitive(fieldValue) || field && !field._f) && !isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
    }
  };
  const setValue = (name, value, options = {}) => {
    const field = get(_fields, name);
    const isFieldArray = _names.array.has(name);
    const cloneValue = cloneObject(value);
    set(_formValues, name, cloneValue);
    if (isFieldArray) {
      _subjects.array.next({
        name,
        values: { ..._formValues }
      });
      if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) && options.shouldDirty) {
        _subjects.state.next({
          name,
          dirtyFields: getDirtyFields(_defaultValues, _formValues),
          isDirty: _getDirty(name, cloneValue)
        });
      }
    } else {
      field && !field._f && !isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
    }
    isWatched(name, _names) && _subjects.state.next({ ..._formState });
    _subjects.values.next({
      name: _state.mount ? name : void 0,
      values: { ..._formValues }
    });
  };
  const onChange = async (event) => {
    _state.mount = true;
    const target = event.target;
    let name = target.name;
    let isFieldValueUpdated = true;
    const field = get(_fields, name);
    const getCurrentFieldValue = () => target.type ? getFieldValue(field._f) : getEventValue(event);
    const _updateIsFieldValueUpdated = (fieldValue) => {
      isFieldValueUpdated = Number.isNaN(fieldValue) || fieldValue === get(_formValues, name, fieldValue);
    };
    if (field) {
      let error;
      let isValid;
      const fieldValue = getCurrentFieldValue();
      const isBlurEvent = event.type === EVENTS.BLUR || event.type === EVENTS.FOCUS_OUT;
      const shouldSkipValidation = !hasValidation(field._f) && !_options.resolver && !get(_formState.errors, name) && !field._f.deps || skipValidation(isBlurEvent, get(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
      const watched = isWatched(name, _names, isBlurEvent);
      set(_formValues, name, fieldValue);
      if (isBlurEvent) {
        field._f.onBlur && field._f.onBlur(event);
        delayErrorCallback && delayErrorCallback(0);
      } else if (field._f.onChange) {
        field._f.onChange(event);
      }
      const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
      const shouldRender = !isEmptyObject(fieldState) || watched;
      !isBlurEvent && _subjects.values.next({
        name,
        type: event.type,
        values: { ..._formValues }
      });
      if (shouldSkipValidation) {
        _proxyFormState.isValid && _updateValid();
        return shouldRender && _subjects.state.next({ name, ...watched ? {} : fieldState });
      }
      !isBlurEvent && watched && _subjects.state.next({ ..._formState });
      if (_options.resolver) {
        const { errors } = await _executeSchema([name]);
        _updateIsFieldValueUpdated(fieldValue);
        if (isFieldValueUpdated) {
          const previousErrorLookupResult = schemaErrorLookup(_formState.errors, _fields, name);
          const errorLookupResult = schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
          error = errorLookupResult.error;
          name = errorLookupResult.name;
          isValid = isEmptyObject(errors);
        }
      } else {
        _updateIsValidating([name], true);
        error = (await validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
        _updateIsValidating([name]);
        _updateIsFieldValueUpdated(fieldValue);
        if (isFieldValueUpdated) {
          if (error) {
            isValid = false;
          } else if (_proxyFormState.isValid) {
            isValid = await executeBuiltInValidation(_fields, true);
          }
        }
      }
      if (isFieldValueUpdated) {
        field._f.deps && trigger(field._f.deps);
        shouldRenderByError(name, isValid, error, fieldState);
      }
    }
  };
  const _focusInput = (ref, key) => {
    if (get(_formState.errors, key) && ref.focus) {
      ref.focus();
      return 1;
    }
    return;
  };
  const trigger = async (name, options = {}) => {
    let isValid;
    let validationResult;
    const fieldNames = convertToArrayPayload(name);
    if (_options.resolver) {
      const errors = await executeSchemaAndUpdateState(isUndefined(name) ? name : fieldNames);
      isValid = isEmptyObject(errors);
      validationResult = name ? !fieldNames.some((name2) => get(errors, name2)) : isValid;
    } else if (name) {
      validationResult = (await Promise.all(fieldNames.map(async (fieldName) => {
        const field = get(_fields, fieldName);
        return await executeBuiltInValidation(field && field._f ? { [fieldName]: field } : field);
      }))).every(Boolean);
      !(!validationResult && !_formState.isValid) && _updateValid();
    } else {
      validationResult = isValid = await executeBuiltInValidation(_fields);
    }
    _subjects.state.next({
      ...!isString(name) || _proxyFormState.isValid && isValid !== _formState.isValid ? {} : { name },
      ..._options.resolver || !name ? { isValid } : {},
      errors: _formState.errors
    });
    options.shouldFocus && !validationResult && iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
    return validationResult;
  };
  const getValues = (fieldNames) => {
    const values = {
      ..._state.mount ? _formValues : _defaultValues
    };
    return isUndefined(fieldNames) ? values : isString(fieldNames) ? get(values, fieldNames) : fieldNames.map((name) => get(values, name));
  };
  const getFieldState = (name, formState) => ({
    invalid: !!get((formState || _formState).errors, name),
    isDirty: !!get((formState || _formState).dirtyFields, name),
    error: get((formState || _formState).errors, name),
    isValidating: !!get(_formState.validatingFields, name),
    isTouched: !!get((formState || _formState).touchedFields, name)
  });
  const clearErrors = (name) => {
    name && convertToArrayPayload(name).forEach((inputName) => unset(_formState.errors, inputName));
    _subjects.state.next({
      errors: name ? _formState.errors : {}
    });
  };
  const setError = (name, error, options) => {
    const ref = (get(_fields, name, { _f: {} })._f || {}).ref;
    const currentError = get(_formState.errors, name) || {};
    const { ref: currentRef, message, type, ...restOfErrorTree } = currentError;
    set(_formState.errors, name, {
      ...restOfErrorTree,
      ...error,
      ref
    });
    _subjects.state.next({
      name,
      errors: _formState.errors,
      isValid: false
    });
    options && options.shouldFocus && ref && ref.focus && ref.focus();
  };
  const watch = (name, defaultValue) => isFunction(name) ? _subjects.values.subscribe({
    next: (payload) => name(_getWatch(void 0, defaultValue), payload)
  }) : _getWatch(name, defaultValue, true);
  const unregister = (name, options = {}) => {
    for (const fieldName of name ? convertToArrayPayload(name) : _names.mount) {
      _names.mount.delete(fieldName);
      _names.array.delete(fieldName);
      if (!options.keepValue) {
        unset(_fields, fieldName);
        unset(_formValues, fieldName);
      }
      !options.keepError && unset(_formState.errors, fieldName);
      !options.keepDirty && unset(_formState.dirtyFields, fieldName);
      !options.keepTouched && unset(_formState.touchedFields, fieldName);
      !options.keepIsValidating && unset(_formState.validatingFields, fieldName);
      !_options.shouldUnregister && !options.keepDefaultValue && unset(_defaultValues, fieldName);
    }
    _subjects.values.next({
      values: { ..._formValues }
    });
    _subjects.state.next({
      ..._formState,
      ...!options.keepDirty ? {} : { isDirty: _getDirty() }
    });
    !options.keepIsValid && _updateValid();
  };
  const _updateDisabledField = ({ disabled, name, field, fields, value }) => {
    if (isBoolean(disabled) && _state.mount || !!disabled) {
      const inputValue = disabled ? void 0 : isUndefined(value) ? getFieldValue(field ? field._f : get(fields, name)._f) : value;
      set(_formValues, name, inputValue);
      updateTouchAndDirty(name, inputValue, false, false, true);
    }
  };
  const register = (name, options = {}) => {
    let field = get(_fields, name);
    const disabledIsDefined = isBoolean(options.disabled);
    set(_fields, name, {
      ...field || {},
      _f: {
        ...field && field._f ? field._f : { ref: { name } },
        name,
        mount: true,
        ...options
      }
    });
    _names.mount.add(name);
    if (field) {
      _updateDisabledField({
        field,
        disabled: options.disabled,
        name,
        value: options.value
      });
    } else {
      updateValidAndValue(name, true, options.value);
    }
    return {
      ...disabledIsDefined ? { disabled: options.disabled } : {},
      ..._options.progressive ? {
        required: !!options.required,
        min: getRuleValue(options.min),
        max: getRuleValue(options.max),
        minLength: getRuleValue(options.minLength),
        maxLength: getRuleValue(options.maxLength),
        pattern: getRuleValue(options.pattern)
      } : {},
      name,
      onChange,
      onBlur: onChange,
      ref: (ref) => {
        if (ref) {
          register(name, options);
          field = get(_fields, name);
          const fieldRef = isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll("input,select,textarea")[0] || ref : ref : ref;
          const radioOrCheckbox = isRadioOrCheckbox(fieldRef);
          const refs = field._f.refs || [];
          if (radioOrCheckbox ? refs.find((option) => option === fieldRef) : fieldRef === field._f.ref) {
            return;
          }
          set(_fields, name, {
            _f: {
              ...field._f,
              ...radioOrCheckbox ? {
                refs: [
                  ...refs.filter(live),
                  fieldRef,
                  ...Array.isArray(get(_defaultValues, name)) ? [{}] : []
                ],
                ref: { type: fieldRef.type, name }
              } : { ref: fieldRef }
            }
          });
          updateValidAndValue(name, false, void 0, fieldRef);
        } else {
          field = get(_fields, name, {});
          if (field._f) {
            field._f.mount = false;
          }
          (_options.shouldUnregister || options.shouldUnregister) && !(isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
        }
      }
    };
  };
  const _focusError = () => _options.shouldFocusError && iterateFieldsByAction(_fields, _focusInput, _names.mount);
  const _disableForm = (disabled) => {
    if (isBoolean(disabled)) {
      _subjects.state.next({ disabled });
      iterateFieldsByAction(_fields, (ref, name) => {
        const currentField = get(_fields, name);
        if (currentField) {
          ref.disabled = currentField._f.disabled || disabled;
          if (Array.isArray(currentField._f.refs)) {
            currentField._f.refs.forEach((inputRef) => {
              inputRef.disabled = currentField._f.disabled || disabled;
            });
          }
        }
      }, 0, false);
    }
  };
  const handleSubmit = (onValid, onInvalid) => async (e) => {
    let onValidError = void 0;
    if (e) {
      e.preventDefault && e.preventDefault();
      e.persist && e.persist();
    }
    let fieldValues = cloneObject(_formValues);
    _subjects.state.next({
      isSubmitting: true
    });
    if (_options.resolver) {
      const { errors, values } = await _executeSchema();
      _formState.errors = errors;
      fieldValues = values;
    } else {
      await executeBuiltInValidation(_fields);
    }
    unset(_formState.errors, "root");
    if (isEmptyObject(_formState.errors)) {
      _subjects.state.next({
        errors: {}
      });
      try {
        await onValid(fieldValues, e);
      } catch (error) {
        onValidError = error;
      }
    } else {
      if (onInvalid) {
        await onInvalid({ ..._formState.errors }, e);
      }
      _focusError();
      setTimeout(_focusError);
    }
    _subjects.state.next({
      isSubmitted: true,
      isSubmitting: false,
      isSubmitSuccessful: isEmptyObject(_formState.errors) && !onValidError,
      submitCount: _formState.submitCount + 1,
      errors: _formState.errors
    });
    if (onValidError) {
      throw onValidError;
    }
  };
  const resetField = (name, options = {}) => {
    if (get(_fields, name)) {
      if (isUndefined(options.defaultValue)) {
        setValue(name, cloneObject(get(_defaultValues, name)));
      } else {
        setValue(name, options.defaultValue);
        set(_defaultValues, name, cloneObject(options.defaultValue));
      }
      if (!options.keepTouched) {
        unset(_formState.touchedFields, name);
      }
      if (!options.keepDirty) {
        unset(_formState.dirtyFields, name);
        _formState.isDirty = options.defaultValue ? _getDirty(name, cloneObject(get(_defaultValues, name))) : _getDirty();
      }
      if (!options.keepError) {
        unset(_formState.errors, name);
        _proxyFormState.isValid && _updateValid();
      }
      _subjects.state.next({ ..._formState });
    }
  };
  const _reset = (formValues, keepStateOptions = {}) => {
    const updatedValues = formValues ? cloneObject(formValues) : _defaultValues;
    const cloneUpdatedValues = cloneObject(updatedValues);
    const isEmptyResetValues = isEmptyObject(formValues);
    const values = isEmptyResetValues ? _defaultValues : cloneUpdatedValues;
    if (!keepStateOptions.keepDefaultValues) {
      _defaultValues = updatedValues;
    }
    if (!keepStateOptions.keepValues) {
      if (keepStateOptions.keepDirtyValues) {
        for (const fieldName of _names.mount) {
          get(_formState.dirtyFields, fieldName) ? set(values, fieldName, get(_formValues, fieldName)) : setValue(fieldName, get(values, fieldName));
        }
      } else {
        if (isWeb && isUndefined(formValues)) {
          for (const name of _names.mount) {
            const field = get(_fields, name);
            if (field && field._f) {
              const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
              if (isHTMLElement(fieldReference)) {
                const form = fieldReference.closest("form");
                if (form) {
                  form.reset();
                  break;
                }
              }
            }
          }
        }
        _fields = {};
      }
      _formValues = props.shouldUnregister ? keepStateOptions.keepDefaultValues ? cloneObject(_defaultValues) : {} : cloneObject(values);
      _subjects.array.next({
        values: { ...values }
      });
      _subjects.values.next({
        values: { ...values }
      });
    }
    _names = {
      mount: keepStateOptions.keepDirtyValues ? _names.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: false,
      focus: ""
    };
    _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid || !!keepStateOptions.keepDirtyValues;
    _state.watch = !!props.shouldUnregister;
    _subjects.state.next({
      submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
      isDirty: isEmptyResetValues ? false : keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !deepEqual(formValues, _defaultValues)),
      isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
      dirtyFields: isEmptyResetValues ? {} : keepStateOptions.keepDirtyValues ? keepStateOptions.keepDefaultValues && _formValues ? getDirtyFields(_defaultValues, _formValues) : _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? getDirtyFields(_defaultValues, formValues) : keepStateOptions.keepDirty ? _formState.dirtyFields : {},
      touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
      errors: keepStateOptions.keepErrors ? _formState.errors : {},
      isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
      isSubmitting: false
    });
  };
  const reset = (formValues, keepStateOptions) => _reset(isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
  const setFocus = (name, options = {}) => {
    const field = get(_fields, name);
    const fieldReference = field && field._f;
    if (fieldReference) {
      const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
      if (fieldRef.focus) {
        fieldRef.focus();
        options.shouldSelect && fieldRef.select();
      }
    }
  };
  const _updateFormState = (updatedFormState) => {
    _formState = {
      ..._formState,
      ...updatedFormState
    };
  };
  const _resetDefaultValues = () => isFunction(_options.defaultValues) && _options.defaultValues().then((values) => {
    reset(values, _options.resetOptions);
    _subjects.state.next({
      isLoading: false
    });
  });
  return {
    control: {
      register,
      unregister,
      getFieldState,
      handleSubmit,
      setError,
      _executeSchema,
      _getWatch,
      _getDirty,
      _updateValid,
      _removeUnmounted,
      _updateFieldArray,
      _updateDisabledField,
      _getFieldArray,
      _reset,
      _resetDefaultValues,
      _updateFormState,
      _disableForm,
      _subjects,
      _proxyFormState,
      _setErrors,
      get _fields() {
        return _fields;
      },
      get _formValues() {
        return _formValues;
      },
      get _state() {
        return _state;
      },
      set _state(value) {
        _state = value;
      },
      get _defaultValues() {
        return _defaultValues;
      },
      get _names() {
        return _names;
      },
      set _names(value) {
        _names = value;
      },
      get _formState() {
        return _formState;
      },
      set _formState(value) {
        _formState = value;
      },
      get _options() {
        return _options;
      },
      set _options(value) {
        _options = {
          ..._options,
          ...value
        };
      }
    },
    trigger,
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    reset,
    resetField,
    clearErrors,
    unregister,
    setError,
    setFocus,
    getFieldState
  };
}
function useForm(props = {}) {
  const _formControl = React5.useRef();
  const _values = React5.useRef();
  const [formState, updateFormState] = React5.useState({
    isDirty: false,
    isValidating: false,
    isLoading: isFunction(props.defaultValues),
    isSubmitted: false,
    isSubmitting: false,
    isSubmitSuccessful: false,
    isValid: false,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: props.errors || {},
    disabled: props.disabled || false,
    defaultValues: isFunction(props.defaultValues) ? void 0 : props.defaultValues
  });
  if (!_formControl.current) {
    _formControl.current = {
      ...createFormControl(props),
      formState
    };
  }
  const control = _formControl.current.control;
  control._options = props;
  useSubscribe({
    subject: control._subjects.state,
    next: (value) => {
      if (shouldRenderFormState(value, control._proxyFormState, control._updateFormState, true)) {
        updateFormState({ ...control._formState });
      }
    }
  });
  React5.useEffect(() => control._disableForm(props.disabled), [control, props.disabled]);
  React5.useEffect(() => {
    if (control._proxyFormState.isDirty) {
      const isDirty = control._getDirty();
      if (isDirty !== formState.isDirty) {
        control._subjects.state.next({
          isDirty
        });
      }
    }
  }, [control, formState.isDirty]);
  React5.useEffect(() => {
    if (props.values && !deepEqual(props.values, _values.current)) {
      control._reset(props.values, control._options.resetOptions);
      _values.current = props.values;
      updateFormState((state) => ({ ...state }));
    } else {
      control._resetDefaultValues();
    }
  }, [props.values, control]);
  React5.useEffect(() => {
    if (props.errors) {
      control._setErrors(props.errors);
    }
  }, [props.errors, control]);
  React5.useEffect(() => {
    if (!control._state.mount) {
      control._updateValid();
      control._state.mount = true;
    }
    if (control._state.watch) {
      control._state.watch = false;
      control._subjects.state.next({ ...control._formState });
    }
    control._removeUnmounted();
  });
  React5.useEffect(() => {
    props.shouldUnregister && control._subjects.values.next({
      values: control._getWatch()
    });
  }, [props.shouldUnregister, control]);
  _formControl.current.formState = getProxyFormState(formState, control);
  return _formControl.current;
}

// src/components/modal/onboarding/askForTrainingModal.jsx
init_actions();
import { shallowEqual, useDispatch as useDispatch3, useSelector as useSelector8 } from "react-redux";
import { Button as Button5, SelectField as SelectField2, TextField as TextField2 } from "@lls/lls-kit";
import { displayUserGenderTitle, hasFieldError as hasFieldError2 } from "@lls/utils";

// src/components/form/index.jsx
import { SelectField, TextField } from "@lls/lls-kit";
import _23 from "lodash/fp.js";
import { useEffect as useEffect5, useState as useState5 } from "react";
init_school();
import { departments, displayDepartment, displaySchool, groupSchoolByCity, useDidUpdate } from "@lls/utils";
import { getFieldHint, hasFieldError } from "@lls/utils";

// tmp_esbuild1736180049684/_src_components_form_index.module.css
var src_components_form_index_default = { "schoolsSelectorContainer": "core-RhMpnG-schoolsSelectorContainer" };

// src/components/form/index.jsx
import { jsx as jsx16, jsxs as jsxs5 } from "react/jsx-runtime";
var Email = ({ control, name = "email", label = "Mon adresse e-mail", error = false, hint, ...props }) => /* @__PURE__ */ jsx16(
  Controller,
  {
    rules: {
      required: {
        value: true,
        message: "Email obligatoire"
      },
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Email incorrect"
      }
    },
    name,
    control,
    render: ({ field }) => /* @__PURE__ */ jsx16(TextField, { label, state: error ? "error" : void 0, hint, ...field, ...props })
  }
);
var Firstname = ({ control, name = "firstname", label = "Pr\xE9nom", error = false, hint, ...props }) => /* @__PURE__ */ jsx16(
  Controller,
  {
    rules: {
      required: {
        value: true,
        message: "Un pr\xE9nom est obligatoire."
      }
    },
    name,
    control,
    render: ({ field }) => /* @__PURE__ */ jsx16(TextField, { label, state: error ? "error" : void 0, hint, ...props, ...field })
  }
);
var Departments = ({ control, label = "D\xE9partement", filterFn = _23.identity, multiple, error, ...props }) => /* @__PURE__ */ jsx16(
  Controller,
  {
    rules: { required: "Obligatoire pour s\xE9lectionner un \xE9tablissement" },
    name: "departments",
    control,
    render: ({ field }) => /* @__PURE__ */ jsx16(
      SelectField,
      {
        searchable: true,
        multiple,
        label,
        listMaxHeight: "200px",
        state: error ? "error" : void 0,
        ...props,
        options: _23.flow(
          _23.filter(filterFn),
          _23.sortBy("zipcode"),
          _23.map((department) => ({
            value: _23.get("zipcode", department),
            label: displayDepartment(department)
          }))
        )(departments),
        ...field
      }
    )
  }
);
var Schools = ({
  label = "\xC9tablissement",
  schools,
  control,
  multiple,
  error,
  schoolValue = "id",
  ...props
}) => /* @__PURE__ */ jsx16(
  Controller,
  {
    rules: { required: "\xC9tablissement scolaire obligatoire" },
    name: "schools",
    control,
    render: ({ field }) => /* @__PURE__ */ jsx16(
      SelectField,
      {
        searchable: true,
        multiple,
        label,
        listMaxHeight: "200px",
        state: error ? "error" : void 0,
        ...props,
        options: _23.flow(
          groupSchoolByCity,
          _23.toPairs,
          _23.map(([city, sortedSchools]) => ({
            label: city,
            options: _23.map(
              (school) => ({
                value: _23.get(schoolValue, school),
                label: displaySchool(school),
                group: city
              }),
              sortedSchools
            )
          }))
        )(schools),
        ...field
      }
    )
  }
);
var SchoolsSelector = ({
  control,
  departmentFilterFn,
  onChange = _23.noop,
  labels: { department: departmentLabel, schools: schoolsLabel } = {},
  setValue,
  multiple = false,
  formState,
  defaultSchools = [],
  disabled = false,
  width,
  schoolValue
}) => {
  const watchDepartment = useWatch({
    control,
    name: "departments"
  });
  const [schoolsOptions, setSchoolsOptions] = useState5(defaultSchools);
  useEffect5(() => {
    const fetchSchools = async () => {
      const schools = await searchSchools({ department: watchDepartment });
      setSchoolsOptions(schools);
      onChange(schools);
    };
    !_23.isEmpty(watchDepartment) && fetchSchools();
  }, [watchDepartment, onChange]);
  useDidUpdate(() => {
    if (!multiple) setValue("schools", null);
  }, [watchDepartment, setValue, multiple]);
  return /* @__PURE__ */ jsxs5("div", { className: src_components_form_index_default.schoolsSelectorContainer, children: [
    /* @__PURE__ */ jsx16(
      Departments,
      {
        control,
        label: departmentLabel,
        filterFn: departmentFilterFn,
        multiple,
        error: hasFieldError("departments", formState),
        hint: getFieldHint("departments", formState),
        disabled,
        width
      }
    ),
    /* @__PURE__ */ jsx16(
      Schools,
      {
        schools: schoolsOptions,
        control,
        label: schoolsLabel,
        multiple,
        error: hasFieldError("schools", formState),
        hint: getFieldHint("schools", formState),
        disabled,
        width,
        schoolValue
      }
    )
  ] });
};
var Phone = ({ control, width, name = "phone", label = "N\xB0 de t\xE9l\xE9phone", error = false, ...props }) => /* @__PURE__ */ jsx16(
  Controller,
  {
    render: ({ field }) => /* @__PURE__ */ jsx16(TextField, { width, label, state: error ? "error" : void 0, ...props, ...field }),
    rules: { required: "N\xB0 obligatoire" },
    name,
    control
  }
);

// src/components/modal/onboarding/askForTrainingModal.jsx
init_constants();
init_onboarding2();
init_useCustomEffect();

// src/utils/contact.ts
var searchMarketingContactByDepartment = ({
  department,
  contacts
}) => {
  return contacts.find((contact) => contact.departments.includes(department));
};

// src/components/modal/onboarding/askForTrainingModal.jsx
import { getToken, useSearchBooks, useSearchPages } from "@lls/store";
import { getContact, getContacts } from "@lls/store";
import { getCurrentUser as getCurrentUser5 } from "@lls/store";
import { getSchool } from "@lls/store";
import { Departments as Departments2 } from "@lls/superkit";
import { matchPath as matchPath3, useLocation as useLocation5 } from "react-router-dom";

// tmp_esbuild1736180049684/_src_components_modal_onboarding_askForTrainingModal.module.css
var src_components_modal_onboarding_askForTrainingModal_default = { "emailContainer": "core-EDlW8q-emailContainer", "buttonContainer": "core-EDlW8q-buttonContainer", "formContainer": "core-EDlW8q-formContainer", "info": "core-EDlW8q-info", "form": "core-EDlW8q-form", "sectionTitle": "core-EDlW8q-sectionTitle", "formInfoContainer": "core-EDlW8q-formInfoContainer" };

// src/components/modal/onboarding/askForTrainingModal.jsx
init_common2();
import { jsx as jsx20, jsxs as jsxs9 } from "react/jsx-runtime";
var PARTICIPATION_MODE_OPTIONS = ["Visioconf\xE9rence", "Pr\xE9sentiel"];
var AskForTrainingModal = ({ close }) => {
  var _a2, _b2, _c2, _d, _e, _f;
  const dispatch = useDispatch3();
  const { currentUser, token } = useSelector8(
    (state) => ({
      currentUser: getCurrentUser5(state),
      token: getToken(state)
    }),
    shallowEqual
  );
  const school = useSelector8((state) => {
    var _a3;
    return getSchool(state, (_a3 = currentUser == null ? void 0 : currentUser.schools) == null ? void 0 : _a3[0]);
  });
  const userContact = useSelector8((state) => {
    var _a3;
    return getContact(state, ((_a3 = currentUser == null ? void 0 : currentUser.contacts) == null ? void 0 : _a3[0]) ?? null);
  });
  const contacts = useSelector8(getContacts);
  const location = useLocation5();
  const bookUri = (_b2 = (_a2 = matchPath3(location.pathname, { path: "/manuels/:bookUri" })) == null ? void 0 : _a2.params) == null ? void 0 : _b2.bookUri;
  const pageId = (_d = (_c2 = matchPath3(location.pathname, { path: "/page/:pageId" })) == null ? void 0 : _c2.params) == null ? void 0 : _d.pageId;
  const page = (_e = useSearchPages({ slugs: [`page/${pageId}`], hasNewDesign: true })) == null ? void 0 : _e[0];
  const book = (_f = useSearchBooks({ uris: bookUri ? [bookUri] : [] })) == null ? void 0 : _f[0];
  const { handleSubmit, control, formState } = useForm({
    defaultValues: {
      email: "",
      department: school == null ? void 0 : school.department,
      nbInterestedPersons: "",
      participationMode: ""
    }
  });
  const errors = formState == null ? void 0 : formState.errors;
  const sendAskForTrainingEmail3 = useCustomEffect_default(sendAskForTrainingEmailEffect);
  const onSubmit = (data = {}) => {
    const contact = (school == null ? void 0 : school.department) && userContact ? userContact : searchMarketingContactByDepartment({ department: data.department, contacts });
    const isVisio = data.participationMode === PARTICIPATION_MODE_OPTIONS[0];
    sendAskForTrainingEmail3({
      ...data,
      bookId: (book == null ? void 0 : book.id) ?? (page == null ? void 0 : page.book),
      token,
      calendarUrl: isVisio ? contact == null ? void 0 : contact.calendarUrl : void 0
    });
  };
  const onBack = () => {
    dispatch(setModal({ name: MODAL_ONBOARDING_CHOOSE_TOUR, open: true }));
  };
  return /* @__PURE__ */ jsx20(StyledModal, { closeModal: close, withCloseButton: false, maxwidth: "lg", closeOnMaskClick: false, children: /* @__PURE__ */ jsxs9(StyledModalContent, { children: [
    /* @__PURE__ */ jsxs9(StyledModalHeader, { children: [
      displayUserGenderTitle(currentUser),
      " ",
      currentUser == null ? void 0 : currentUser.lastname,
      ", organisons une formation personnalis\xE9e\xA0!"
    ] }),
    /* @__PURE__ */ jsx20(StyledModalBody, { children: /* @__PURE__ */ jsxs9("form", { className: src_components_modal_onboarding_askForTrainingModal_default.form, onSubmit: handleSubmit(onSubmit), children: [
      "Pour organiser la formation, nous avons besoin des informations suivantes :",
      /* @__PURE__ */ jsx20("h3", { className: src_components_modal_onboarding_askForTrainingModal_default.sectionTitle, children: "Information de contact" }),
      /* @__PURE__ */ jsxs9("div", { className: src_components_modal_onboarding_askForTrainingModal_default.formContainer, children: [
        /* @__PURE__ */ jsxs9("div", { className: src_components_modal_onboarding_askForTrainingModal_default.emailContainer, children: [
          /* @__PURE__ */ jsx20(
            Email,
            {
              label: "Adresse e-mail",
              width: !(school == null ? void 0 : school.department) ? "100%" : void 0,
              control,
              error: errors.email,
              required: true
            }
          ),
          /* @__PURE__ */ jsx20("span", { className: src_components_modal_onboarding_askForTrainingModal_default.info, children: " Nous vous recontacterons sur cette adresse." })
        ] }),
        !(school == null ? void 0 : school.department) && /* @__PURE__ */ jsx20(
          Departments2,
          {
            name: "department",
            control,
            error: hasFieldError2("department", formState),
            required: true
          }
        )
      ] }),
      /* @__PURE__ */ jsx20("h3", { className: src_components_modal_onboarding_askForTrainingModal_default.sectionTitle, children: "Modalit\xE9s" }),
      /* @__PURE__ */ jsxs9("div", { className: src_components_modal_onboarding_askForTrainingModal_default.formContainer, children: [
        /* @__PURE__ */ jsx20(
          Controller,
          {
            name: "nbInterestedPersons",
            control,
            render: ({ field }) => /* @__PURE__ */ jsx20(TextField2, { label: "Nombre de professeurs int\xE9ress\xE9s", type: "number", ...field, min: 0, max: 1e3 })
          }
        ),
        /* @__PURE__ */ jsx20(
          Controller,
          {
            name: "participationMode",
            control,
            render: ({ field }) => /* @__PURE__ */ jsx20(
              SelectField2,
              {
                label: "Mode de participation",
                listMaxHeight: "200px",
                options: PARTICIPATION_MODE_OPTIONS.map((mode) => ({ value: mode, label: mode })),
                ...field
              }
            )
          }
        )
      ] }),
      /* @__PURE__ */ jsx20("span", { className: src_components_modal_onboarding_askForTrainingModal_default.info, children: "* Cette information est obligatoire." }),
      /* @__PURE__ */ jsxs9("div", { className: src_components_modal_onboarding_askForTrainingModal_default.buttonContainer, children: [
        /* @__PURE__ */ jsx20(Button5, { onClick: onBack, theme: "gray", accent: "floating", children: "Retour" }),
        /* @__PURE__ */ jsx20(Button5, { icon: "paperplane", type: "submit", iconPosition: "left", children: "Envoyer" })
      ] })
    ] }) })
  ] }) });
};
var askForTrainingModal_default = AskForTrainingModal;

// src/components/modal/onboarding/chooseProfileModal.jsx
init_onboarding();
init_onboarding2();
init_useCustomEffect();
init_useTour();
import { useEffect as useEffect9 } from "react";
import { shallowEqual as shallowEqual2, useSelector as useSelector12 } from "react-redux";
import { Button as Button6, Divider, Wavy } from "@lls/lls-kit";
import { getToken as getToken3 } from "@lls/store";
import { getCurrentUser as getCurrentUser8 } from "@lls/store";
import { ANALYTICS_ONBOARDING_STARTED, ANALYTICS_PAGE_VIEWED, dispatchAnalyticsEvent as dispatchAnalyticsEvent4 } from "@lls/utils";

// tmp_esbuild1736180049684/_src_components_modal_onboarding_chooseProfileModal.module.css
var src_components_modal_onboarding_chooseProfileModal_default = { "modalTitle": "core-2v2QkW-modalTitle", "profiles": "core-2v2QkW-profiles", "profile": "core-2v2QkW-profile", "profileIllustration": "core-2v2QkW-profileIllustration", "modalFooter": "core-2v2QkW-modalFooter" };

// src/components/modal/onboarding/chooseProfileModal.jsx
init_common2();
import { jsx as jsx21, jsxs as jsxs10 } from "react/jsx-runtime";
var ChooseProfileModal = ({ close }) => {
  var _a2, _b2;
  const { startTour } = useTour_default();
  const chooseOnboardingProfileFn = useCustomEffect_default(chooseOnboardingProfileEffect);
  const { currentUser, token } = useSelector12(
    (state) => ({
      currentUser: getCurrentUser8(state),
      token: getToken3(state)
    }),
    shallowEqual2
  );
  const onProfileClick = (profile) => {
    chooseOnboardingProfileFn({ profile, token, user: currentUser, close, startTour });
    dispatchAnalyticsEvent4(ANALYTICS_ONBOARDING_STARTED, { extraData: `profile:${profile}` });
  };
  const dismissModal2 = useCustomEffect_default(dismissModalEffect);
  const onDismiss = () => {
    close();
    dismissModal2({ user: currentUser, token });
  };
  const hasFirstDismissal = (_a2 = currentUser == null ? void 0 : currentUser.onboardingData) == null ? void 0 : _a2.firstDismissalDate;
  useEffect9(() => {
    dispatchAnalyticsEvent4(ANALYTICS_PAGE_VIEWED, { featureName: "Onboarding profil choice" });
  }, []);
  const profileIdToSrc = {
    [BEGINNER_PROFILE]: "/assets/img/onboarding/level-beginner.webp",
    [INTERMEDIATE_PROFILE]: "/assets/img/onboarding/level-intermediate.webp",
    [EXPERT_PROFILE]: "/assets/img/onboarding/level-expert.webp"
  };
  return /* @__PURE__ */ jsx21(StyledModal, { closeModal: close, withCloseButton: false, closeOnMaskClick: false, children: /* @__PURE__ */ jsxs10(StyledModalContent, { children: [
    /* @__PURE__ */ jsxs10(StyledModalHeader, { children: [
      "Bienvenue dans votre ",
      /* @__PURE__ */ jsx21(Wavy, { waveColor: "var(--premium-50-color)", children: " Manuel" }),
      /* @__PURE__ */ jsx21("br", {}),
      /* @__PURE__ */ jsx21(Wavy, { waveColor: "var(--premium-50-color)", children: "Num\xE9rique Premium" })
    ] }),
    /* @__PURE__ */ jsxs10(StyledModalBody, { children: [
      /* @__PURE__ */ jsx21("div", { className: src_components_modal_onboarding_chooseProfileModal_default.modalTitle, children: "Commen\xE7ons par vous, adaptons votre parcours" }),
      /* @__PURE__ */ jsx21("div", { className: src_components_modal_onboarding_chooseProfileModal_default.profiles, children: (_b2 = PROFILES) == null ? void 0 : _b2.map((profile, index3) => /* @__PURE__ */ jsxs10("div", { className: src_components_modal_onboarding_chooseProfileModal_default.profile, onClick: () => onProfileClick(profile.id), children: [
        /* @__PURE__ */ jsxs10("div", { className: src_components_modal_onboarding_chooseProfileModal_default.profileIllustration, children: [
          /* @__PURE__ */ jsx21("div", {}),
          /* @__PURE__ */ jsx21("img", { src: profileIdToSrc[profile.id] })
        ] }),
        profile.wording
      ] }, index3)) }),
      /* @__PURE__ */ jsx21(Divider, {}),
      /* @__PURE__ */ jsx21("div", { className: src_components_modal_onboarding_chooseProfileModal_default.modalFooter, children: /* @__PURE__ */ jsx21(Button6, { accent: "floating", theme: "gray", onClick: onDismiss, children: hasFirstDismissal ? "Quitter" : "Reprendre plus tard" }) })
    ] })
  ] }) });
};
var chooseProfileModal_default = ChooseProfileModal;

// src/components/modal/onboarding/chooseTourModal.jsx
init_actions();
init_constants();
init_tour2();
init_onboarding2();
init_useCustomEffect();
init_useTour();
init_tour3();
import _33 from "lodash/fp.js";
import { shallowEqual as shallowEqual3, useDispatch as useDispatch7, useSelector as useSelector13 } from "react-redux";
import { Button as Button7, Divider as Divider2, Icon as Icon3, Wavy as Wavy2 } from "@lls/lls-kit";
import { getToken as getToken4 } from "@lls/store";
import { getCurrentUser as getCurrentUser9 } from "@lls/store";

// tmp_esbuild1736180049684/_src_components_modal_onboarding_chooseTourModal.module.css
var src_components_modal_onboarding_chooseTourModal_default = { "modalFooter": "core-alnfcq-modalFooter", "tour": "core-alnfcq-tour", "tourTitle": "core-alnfcq-tourTitle", "completedStamp": "core-alnfcq-completedStamp", "modalTitle": "core-alnfcq-modalTitle", "tourRow": "core-alnfcq-tourRow" };

// src/components/modal/onboarding/chooseTourModal.jsx
init_common2();
import { Fragment as Fragment4, jsx as jsx22, jsxs as jsxs11 } from "react/jsx-runtime";
var Tour = ({ tour: tour2 = {}, onTourClick = _33.noop, isCompleted = false }) => /* @__PURE__ */ jsxs11("div", { className: src_components_modal_onboarding_chooseTourModal_default.tour, onClick: () => onTourClick(tour2.id), "data-completed": +isCompleted, children: [
  /* @__PURE__ */ jsx22("img", { src: `/assets/img/onboarding/tour-illustrations/${tour2.id}.webp` }),
  /* @__PURE__ */ jsxs11("span", { className: src_components_modal_onboarding_chooseTourModal_default.tourTitle, children: [
    isCompleted && /* @__PURE__ */ jsx22(Icon3, { color: "var(--success-50-color)", name: "checkmarkfilled", width: "24", height: "24" }),
    " ",
    tour2.title
  ] }),
  isCompleted && /* @__PURE__ */ jsx22("img", { className: src_components_modal_onboarding_chooseTourModal_default.completedStamp, src: "/assets/img/onboarding/acquis.webp" })
] });
var TourRow = ({ tourIds, onTourClick, completedTourIds }) => /* @__PURE__ */ jsx22("div", { className: src_components_modal_onboarding_chooseTourModal_default.tourRow, children: tourIds == null ? void 0 : tourIds.map((tourId) => {
  const tour2 = getTour(tourId);
  return /* @__PURE__ */ jsx22(
    Tour,
    {
      tour: tour2,
      onTourClick,
      isCompleted: hasUserCompletedTour(tourId, completedTourIds)
    },
    tour2 == null ? void 0 : tour2.id
  );
}) });
var ChooseTourModal = ({ close, hasFinishedTour }) => {
  var _a2;
  const { startTour } = useTour_default();
  const dispatch = useDispatch7();
  const { currentUser, token } = useSelector13(
    (state) => ({
      currentUser: getCurrentUser9(state),
      token: getToken4(state)
    }),
    shallowEqual3
  );
  const completedTourIds = getCompletedTours(currentUser);
  const onTourClick = (tourId) => {
    dispatch(setScenarioId(ONBOARDING_SCENARIO));
    close();
    startTour(tourId);
  };
  const dismissModal2 = useCustomEffect_default(dismissModalEffect);
  const onDismiss = () => {
    close();
    dismissModal2({ user: currentUser, token });
  };
  const openAskForTrainingModal = () => {
    dispatch(setModal({ name: MODAL_ONBOARDING_ASK_FOR_TRAINING, open: true }));
  };
  const hasFirstDismissal = !!((_a2 = currentUser == null ? void 0 : currentUser.onboardingData) == null ? void 0 : _a2.firstDismissalDate);
  return /* @__PURE__ */ jsx22(StyledModal, { closeModal: close, withCloseButton: false, maxwidth: "lg", closeOnMaskClick: false, children: /* @__PURE__ */ jsxs11(StyledModalContent, { children: [
    /* @__PURE__ */ jsx22(StyledModalHeader, { children: hasFinishedTour ? /* @__PURE__ */ jsxs11(Fragment4, { children: [
      /* @__PURE__ */ jsx22(Wavy2, { waveColor: "var(--premium-50-color)", children: "Bravo !" }),
      "\xA0 Vous avez compl\xE9t\xE9 ce parcours de d\xE9couverte !"
    ] }) : hasFirstDismissal ? /* @__PURE__ */ jsx22(Fragment4, { children: "Reprenez vos parcours de d\xE9couverte" }) : /* @__PURE__ */ jsxs11(Fragment4, { children: [
      "Explorez les parcours de d\xE9couverte ",
      /* @__PURE__ */ jsx22(Wavy2, { waveColor: "var(--premium-50-color)", children: "avanc\xE9s !" })
    ] }) }),
    /* @__PURE__ */ jsxs11(StyledModalBody, { children: [
      /* @__PURE__ */ jsx22("div", { className: src_components_modal_onboarding_chooseTourModal_default.modalTitle, children: "Pour pr\xE9parer mes cours" }),
      /* @__PURE__ */ jsx22(
        TourRow,
        {
          onTourClick,
          tourIds: [DISCOVERY_TOUR, PAGE_ADAPTATION_TOUR, CREATE_PAGE_TOUR],
          completedTourIds
        }
      ),
      /* @__PURE__ */ jsx22("div", { className: src_components_modal_onboarding_chooseTourModal_default.modalTitle, children: "En classe avec mes \xE9l\xE8ves" }),
      /* @__PURE__ */ jsx22(
        TourRow,
        {
          onTourClick,
          tourIds: _33.compact([PROJECTION_TOUR, SHARE_TOUR, REVISION_TOUR]),
          completedTourIds
        }
      ),
      /* @__PURE__ */ jsx22(Divider2, {}),
      /* @__PURE__ */ jsxs11("div", { className: src_components_modal_onboarding_chooseTourModal_default.modalFooter, children: [
        /* @__PURE__ */ jsx22(Button7, { accent: "floating", theme: "gray", onClick: onDismiss, children: hasFirstDismissal ? "Quitter" : "Reprendre plus tard" }),
        /* @__PURE__ */ jsx22(Button7, { onClick: openAskForTrainingModal, children: "Je souhaite une formation personnalis\xE9e" })
      ] })
    ] })
  ] }) });
};
var chooseTourModal_default = ChooseTourModal;

// src/components/modal/onboarding/endOnboardingModal.jsx
init_constants();
init_common2();
import { Button as Button8, Wavy as Wavy3 } from "@lls/lls-kit";

// tmp_esbuild1736180049684/_src_components_modal_onboarding_endOnboardingModal.module.css
var src_components_modal_onboarding_endOnboardingModal_default = { "container": "core-_-WemG-container" };

// src/components/modal/onboarding/endOnboardingModal.jsx
import { jsx as jsx23, jsxs as jsxs12 } from "react/jsx-runtime";
var EndOnboardingModal = ({ close }) => {
  return /* @__PURE__ */ jsx23(StyledModal, { closeModal: close, withCloseButton: false, maxwidth: "lg", closeOnMaskClick: false, children: /* @__PURE__ */ jsxs12(StyledModalContent, { children: [
    /* @__PURE__ */ jsxs12(StyledModalHeader, { children: [
      /* @__PURE__ */ jsx23(Wavy3, { waveColor: "var(--premium-50-color)", children: "Profitez bien" }),
      " de votre manuel !"
    ] }),
    /* @__PURE__ */ jsx23(StyledModalBody, { children: /* @__PURE__ */ jsxs12("div", { className: src_components_modal_onboarding_endOnboardingModal_default.container, children: [
      /* @__PURE__ */ jsx23(StyledGif, { src: `${ASSETS_HOST}/onboarding/gif1.gif` }),
      /* @__PURE__ */ jsx23("span", { children: `Vous pouvez retrouver l'ensemble de nos parcours de d\xE9couverte dans le menu "Mon Profil".` }),
      /* @__PURE__ */ jsx23(Button8, { onClick: close, children: "Fermer" })
    ] }) })
  ] }) });
};
var endOnboardingModal_default = EndOnboardingModal;

// src/components/modal/onboarding/onboardingExpertModal.jsx
init_actions();
init_constants();
init_route();
init_common2();
import { Button as Button9, Carousel, Divider as Divider3, Wavy as Wavy4 } from "@lls/lls-kit";
import { openWindow as openWindow4 } from "@lls/utils";
import { useDispatch as useDispatch8 } from "react-redux";

// tmp_esbuild1736180049684/_src_components_modal_onboarding_onboardingExpertModal.module.css
var src_components_modal_onboarding_onboardingExpertModal_default = { "title": "core-9hyEpG-title", "year2023": "core-9hyEpG-year2023", "firstnameWithPencil": "core-9hyEpG-firstnameWithPencil", "divider": "core-9hyEpG-divider", "description": "core-9hyEpG-description", "carousel": "core-9hyEpG-carousel", "carouselItem": "core-9hyEpG-carouselItem", "modalFooter": "core-9hyEpG-modalFooter" };

// src/components/modal/onboarding/onboardingExpertModal.jsx
import { jsx as jsx24, jsxs as jsxs13 } from "react/jsx-runtime";
var CAROUSEL_ITEMS = [
  {
    title: "Projetez les contenus en un clic",
    gifNo: "6",
    description: "Naviguez facilement entre les ressources, annotez-les et profitez du mode c\xF4te \xE0 c\xF4te. Id\xE9al pour mettre un document et ses questions en regard !"
  },
  {
    title: "T\xE9l\xE9chargez vos pages en PDF/Word",
    gifNo: "7",
    description: "La mise en page a \xE9t\xE9 revue pour une meilleure lisibilit\xE9 et des options de param\xE9trage ont \xE9t\xE9 ajout\xE9es"
  },
  {
    title: "Une gestion de classe facilit\xE9e",
    gifNo: "8",
    description: "Cette ann\xE9e, r\xE9cup\xE9rez les classes depuis votre ENT ou appuyez-vous sur celles d\xE9j\xE0 cr\xE9\xE9s par vos coll\xE8gues. Plus besoin de les configurer vous m\xEAme : un gain de temps notable !"
  }
];
var CarouselItem = ({ title, gifNo, description }) => /* @__PURE__ */ jsxs13("div", { className: src_components_modal_onboarding_onboardingExpertModal_default.carouselItem, children: [
  /* @__PURE__ */ jsx24(StyledGif, { src: `${ASSETS_HOST}/onboarding/gif${gifNo}.gif` }),
  /* @__PURE__ */ jsxs13("div", { className: src_components_modal_onboarding_onboardingExpertModal_default.title, children: [
    title,
    " ",
    /* @__PURE__ */ jsx24("img", { src: "/assets/img/onboarding/expert/underline-double.svg" })
  ] }),
  /* @__PURE__ */ jsx24("div", { className: src_components_modal_onboarding_onboardingExpertModal_default.description, children: description })
] });
var FirstnameWithPencil = ({ firstname, color, top = "auto", left = "auto", bottom = "auto", right = "auto" }) => /* @__PURE__ */ jsxs13(
  "div",
  {
    className: src_components_modal_onboarding_onboardingExpertModal_default.firstnameWithPencil,
    style: { "--cr-top": top, "--cr-left": left, "--cr-right": right, "--cr-bottom": bottom, "--cr-color": color },
    children: [
      /* @__PURE__ */ jsx24("img", { src: "/assets/img/onboarding/expert/pencil-onboarding.webp" }),
      " ",
      firstname
    ]
  }
);
var OnboardingExpertModal = ({ close }) => {
  const dispatch = useDispatch8();
  const onDismiss = () => {
    close();
    dispatch(setModal({ name: MODAL_ONBOARDING_END, open: true }));
  };
  const buttonProps = { accent: "floating", theme: "gray" };
  return /* @__PURE__ */ jsx24(StyledModal, { closeModal: close, withCloseButton: false, maxwidth: "lg", closeOnMaskClick: false, children: /* @__PURE__ */ jsxs13(StyledModalContent, { children: [
    /* @__PURE__ */ jsxs13(StyledModalHeader, { children: [
      "D\xE9couvrez 3 \xA0",
      /* @__PURE__ */ jsx24(Wavy4, { waveColor: "var(--premium-50-color)", children: "fonctionnalit\xE9s cl\xE9s" }),
      "\xA0 pour",
      /* @__PURE__ */ jsxs13("div", { className: src_components_modal_onboarding_onboardingExpertModal_default.year2023, children: [
        /* @__PURE__ */ jsx24("img", { src: "/assets/img/onboarding/expert/hearts-pink.webp" }),
        /* @__PURE__ */ jsx24("span", { children: "2024" }),
        /* @__PURE__ */ jsx24("img", { src: "/assets/img/onboarding/expert/sprinkles-pink.webp" })
      ] }),
      /* @__PURE__ */ jsx24(FirstnameWithPencil, { left: "80x", top: "144px", firstname: "Pascal", color: "var(--green-40-color)" }),
      /* @__PURE__ */ jsx24(FirstnameWithPencil, { left: "-5px", top: "85px", firstname: "Chlo\xE9", color: "var(--orange-40-color)" }),
      /* @__PURE__ */ jsx24(FirstnameWithPencil, { right: "-15px", top: "50px", firstname: "Corinne", color: "var(--primary-40-color)" }),
      /* @__PURE__ */ jsx24(FirstnameWithPencil, { right: "60px", top: "120px", firstname: "Justine", color: "var(--purple-40-color)" })
    ] }),
    /* @__PURE__ */ jsxs13(StyledModalBody, { children: [
      /* @__PURE__ */ jsx24(
        Carousel,
        {
          className: src_components_modal_onboarding_onboardingExpertModal_default.carousel,
          ComponentItem: CarouselItem,
          items: CAROUSEL_ITEMS,
          width: "700px",
          leftButtonProps: { ...buttonProps, icon: "chevronleft" },
          rightButtonProps: { ...buttonProps, icon: "chevronright" }
        }
      ),
      /* @__PURE__ */ jsx24(Divider3, { className: src_components_modal_onboarding_onboardingExpertModal_default.divider }),
      /* @__PURE__ */ jsxs13("div", { className: src_components_modal_onboarding_onboardingExpertModal_default.modalFooter, children: [
        /* @__PURE__ */ jsx24(Button9, { accent: "floating", theme: "gray", onClick: onDismiss, children: "Quitter" }),
        /* @__PURE__ */ jsx24(
          Button9,
          {
            theme: "yellow",
            href: getPath("join_community", { query: { at_medium: "onboarding" } }),
            target: "_blank",
            onGoTo: ({ href, target }) => openWindow4(href, target),
            children: "Rejoindre la communaut\xE9"
          }
        )
      ] })
    ] })
  ] }) });
};
var onboardingExpertModal_default = OnboardingExpertModal;

// src/components/modal/onboarding/toursCompletedModal.jsx
init_actions();
init_constants();
init_onboarding2();
init_common2();
import { useEffect as useEffect10 } from "react";
import { shallowEqual as shallowEqual4, useDispatch as useDispatch9, useSelector as useSelector14 } from "react-redux";
import { Button as Button10, Wavy as Wavy5 } from "@lls/lls-kit";
import { getToken as getToken5 } from "@lls/store";
import { getCurrentUser as getCurrentUser10 } from "@lls/store";
import { ANALYTICS_ONBOARDING_FINISHED, dispatchAnalyticsEvent as dispatchAnalyticsEvent5 } from "@lls/utils";

// tmp_esbuild1736180049684/_src_components_modal_onboarding_toursCompletedModal.module.css
var src_components_modal_onboarding_toursCompletedModal_default = { "modalSubtitle": "core-AnaOaa-modalSubtitle", "modalTitle": "core-AnaOaa-modalTitle", "modalFooter": "core-AnaOaa-modalFooter", "modalBody": "core-AnaOaa-modalBody", "mainImg": "core-AnaOaa-mainImg" };

// src/components/modal/onboarding/toursCompletedModal.jsx
import { jsx as jsx25, jsxs as jsxs14 } from "react/jsx-runtime";
var ToursCompletedModal = ({ close }) => {
  const dispatch = useDispatch9();
  const { user, token } = useSelector14(
    (state) => ({
      user: getCurrentUser10(state),
      token: getToken5(state)
    }),
    shallowEqual4
  );
  const onBack = () => {
    close();
    dispatch(setModal({ name: MODAL_ONBOARDING_CHOOSE_TOUR, open: true }));
  };
  const onClose = () => {
    close();
    dispatch(setScenarioId(null));
    dispatch(setModal({ name: MODAL_ONBOARDING_END, open: true }));
  };
  useEffect10(() => {
    var _a2, _b2;
    if (!((_a2 = user == null ? void 0 : user.onboardingData) == null ? void 0 : _a2.onboardingEndDate)) {
      dispatchAnalyticsEvent5(ANALYTICS_ONBOARDING_FINISHED, { extraData: `profile:${(_b2 = user == null ? void 0 : user.onboardingData) == null ? void 0 : _b2.profile}` });
      endOnboardingEffect({ dispatch, params: { user, token } });
    }
  }, [dispatch, token, user]);
  return /* @__PURE__ */ jsx25(StyledModal, { closeModal: close, withCloseButton: false, closeOnMaskClick: false, children: /* @__PURE__ */ jsx25(StyledModalImgContent, { children: /* @__PURE__ */ jsxs14("div", { className: src_components_modal_onboarding_toursCompletedModal_default.modalBody, children: [
    /* @__PURE__ */ jsx25("img", { className: src_components_modal_onboarding_toursCompletedModal_default.mainImg, src: "/assets/img/onboarding/high-five.webp" }),
    /* @__PURE__ */ jsx25("div", { className: src_components_modal_onboarding_toursCompletedModal_default.modalTitle, children: /* @__PURE__ */ jsx25(Wavy5, { waveColor: "var(--premium-50-color)", children: "F\xE9licitations !" }) }),
    /* @__PURE__ */ jsxs14("div", { className: src_components_modal_onboarding_toursCompletedModal_default.modalSubtitle, children: [
      "Vous avez compl\xE9t\xE9 ",
      /* @__PURE__ */ jsx25("b", { children: "tous" }),
      " les parcours de d\xE9couverte !"
    ] }),
    /* @__PURE__ */ jsxs14("div", { className: src_components_modal_onboarding_toursCompletedModal_default.modalFooter, children: [
      /* @__PURE__ */ jsx25(Button10, { accent: "floating", onClick: onBack, children: "Revoir les parcours de d\xE9couverte" }),
      /* @__PURE__ */ jsx25(Button10, { onClick: onClose, children: "Quitter les parcours de d\xE9couverte" })
    ] })
  ] }) }) });
};
var toursCompletedModal_default = ToursCompletedModal;

// src/components/modal/onboarding/trainingBookingModal.tsx
init_actions();
init_constants();
init_onboarding2();
init_useCustomEffect();
init_common2();
import { shallowEqual as shallowEqual5, useDispatch as useDispatch10, useSelector as useSelector15 } from "react-redux";
import { Button as Button11, Wavy as Wavy6 } from "@lls/lls-kit";
import { getToken as getToken6 } from "@lls/store";
import { getCurrentUser as getCurrentUser11 } from "@lls/store";
import { openWindow as openWindow5 } from "@lls/utils";

// tmp_esbuild1736180049684/_src_components_modal_onboarding_trainingConfirmationModal.module.css
var src_components_modal_onboarding_trainingConfirmationModal_default = { "modalFooter": "core-lX_1ea-modalFooter", "modalTitle": "core-lX_1ea-modalTitle", "modalSubtitle": "core-lX_1ea-modalSubtitle", "modalBody": "core-lX_1ea-modalBody", "mainImg": "core-lX_1ea-mainImg" };

// src/components/modal/onboarding/trainingBookingModal.tsx
import { jsx as jsx26, jsxs as jsxs15 } from "react/jsx-runtime";
var TrainingBookingModal = ({ close, calendarUrl }) => {
  const dispatch = useDispatch10();
  const { user, token } = useSelector15(
    (state) => ({
      user: getCurrentUser11(state),
      token: getToken6(state)
    }),
    shallowEqual5
  );
  const endOnboarding2 = useCustomEffect_default(endOnboardingEffect);
  const handleClick = () => {
    openWindow5(`https://lls.fr/${calendarUrl}`, "_blank");
    close();
    dispatch(setModal({ name: MODAL_ONBOARDING_CHOOSE_TOUR, open: true }));
  };
  const onClose = () => {
    endOnboarding2({ user, token });
    close();
  };
  return /* @__PURE__ */ jsx26(StyledModal, { closeModal: close, withCloseButton: false, closeOnMaskClick: false, children: /* @__PURE__ */ jsx26(StyledModalImgContent, { children: /* @__PURE__ */ jsxs15("div", { className: src_components_modal_onboarding_trainingConfirmationModal_default.modalBody, children: [
    /* @__PURE__ */ jsx26("img", { className: src_components_modal_onboarding_trainingConfirmationModal_default.mainImg, src: "/assets/img/onboarding/thumb.webp" }),
    /* @__PURE__ */ jsx26("div", { className: src_components_modal_onboarding_trainingConfirmationModal_default.modalTitle, children: /* @__PURE__ */ jsx26(Wavy6, { waveColor: "var(--premium-50-color)", children: "Finalisez votre inscription !" }) }),
    /* @__PURE__ */ jsx26("div", { className: src_components_modal_onboarding_trainingConfirmationModal_default.modalSubtitle, children: "Merci d'avoir renseign\xE9 vos informations. Pour compl\xE9ter votre inscription, cliquez sur le bouton ci-dessous pour prendre rendez-vous avec votre r\xE9f\xE9rent num\xE9rique. Ensemble, vous pourrez d\xE9finir les meilleures options pour votre formation personnalis\xE9e" }),
    /* @__PURE__ */ jsxs15("div", { className: src_components_modal_onboarding_trainingConfirmationModal_default.modalFooter, children: [
      /* @__PURE__ */ jsx26(Button11, { theme: "gray", accent: "floating", onClick: onClose, inverted: true, children: "Revenir aux parcours de d\xE9couverte" }),
      /* @__PURE__ */ jsx26(Button11, { onClick: handleClick, children: "Prendre rendez-vous" })
    ] })
  ] }) }) });
};
var trainingBookingModal_default = TrainingBookingModal;

// src/components/modal/onboarding/trainingConfirmationModal.jsx
init_actions();
init_constants();
init_onboarding2();
init_useCustomEffect();
init_common2();
import { shallowEqual as shallowEqual6, useDispatch as useDispatch11, useSelector as useSelector16 } from "react-redux";
import { Button as Button12, Wavy as Wavy7 } from "@lls/lls-kit";
import { getToken as getToken7 } from "@lls/store";
import { getCurrentUser as getCurrentUser12 } from "@lls/store";
import { jsx as jsx27, jsxs as jsxs16 } from "react/jsx-runtime";
var TrainingConfirmationModal = ({ close }) => {
  const dispatch = useDispatch11();
  const { user, token } = useSelector16(
    (state) => ({
      user: getCurrentUser12(state),
      token: getToken7(state)
    }),
    shallowEqual6
  );
  const endOnboarding2 = useCustomEffect_default(endOnboardingEffect);
  const onBack = () => {
    close();
    dispatch(setModal({ name: MODAL_ONBOARDING_CHOOSE_TOUR, open: true }));
  };
  const onClose = () => {
    endOnboarding2({ user, token });
    close();
  };
  return /* @__PURE__ */ jsx27(StyledModal, { closeModal: close, withCloseButton: false, closeOnMaskClick: false, children: /* @__PURE__ */ jsx27(StyledModalImgContent, { children: /* @__PURE__ */ jsxs16("div", { className: src_components_modal_onboarding_trainingConfirmationModal_default.modalBody, children: [
    /* @__PURE__ */ jsx27("img", { className: src_components_modal_onboarding_trainingConfirmationModal_default.mainImg, src: "/assets/img/onboarding/thumb.webp" }),
    /* @__PURE__ */ jsx27("div", { className: src_components_modal_onboarding_trainingConfirmationModal_default.modalTitle, children: /* @__PURE__ */ jsx27(Wavy7, { waveColor: "var(--premium-50-color)", children: "C'est pris en compte !" }) }),
    /* @__PURE__ */ jsx27("div", { className: src_components_modal_onboarding_trainingConfirmationModal_default.modalSubtitle, children: "Votre r\xE9f\xE9rent num\xE9rique vous recontactera rapidement afin d'organiser la formation. En attendant, nous vous invitons \xE0 poursuivre l'exploration de vos Manuels Num\xE9riques Premium \u{1F642}" }),
    /* @__PURE__ */ jsxs16("div", { className: src_components_modal_onboarding_trainingConfirmationModal_default.modalFooter, children: [
      /* @__PURE__ */ jsx27(Button12, { theme: "gray", accent: "floating", onClick: onClose, inverted: true, children: "Quitter" }),
      /* @__PURE__ */ jsx27(Button12, { onClick: onBack, children: "Revenir aux parcours de d\xE9couverte" })
    ] })
  ] }) }) });
};
var trainingConfirmationModal_default = TrainingConfirmationModal;

// src/components/modal/oneClick/index.jsx
init_constants();
init_route();
import _35 from "lodash/fp.js";
import { useState as useState8 } from "react";
import { useSelector as useSelector17 } from "react-redux";
import { Modal as Modal7, Tab, Tabs } from "@lls/lls-kit";
import { getAuth as getAuth2 } from "@lls/store";

// tmp_esbuild1736180049684/_src_components_modal_oneClick_index.module.css
var src_components_modal_oneClick_index_default = { "modalContent": "core-YBx0da-modalContent" };

// src/components/modal/oneClick/openApp.jsx
import { Button as Button13 } from "@lls/lls-kit";
import { dispatchAnalyticsEvent as dispatchAnalyticsEvent6, openWindow as openWindow6 } from "@lls/utils";
import { ANALYTIC_EVENTS_LINK_CLICKED } from "@lls/superkit";

// tmp_esbuild1736180049684/_src_components_modal_oneClick_openApp.module.css
var src_components_modal_oneClick_openApp_default = { "button": "core-Rat2Ea-button", "link": "core-Rat2Ea-link", "openApp": "core-Rat2Ea-openApp", "openAppDescription": "core-Rat2Ea-openAppDescription" };

// src/components/modal/oneClick/openApp.jsx
import { jsx as jsx28, jsxs as jsxs17 } from "react/jsx-runtime";
var OpenApp = ({ urlScheme }) => {
  const onOpenApp = ({ href, target }) => {
    dispatchAnalyticsEvent6(ANALYTIC_EVENTS_LINK_CLICKED);
    openWindow6(href, target);
  };
  return /* @__PURE__ */ jsxs17("div", { className: src_components_modal_oneClick_openApp_default.openApp, children: [
    /* @__PURE__ */ jsx28("div", { className: src_components_modal_oneClick_openApp_default.openAppDescription, children: "Si vous poss\xE8dez d\xE9j\xE0 l\u2019application, cliquez sur le bouton ci-dessous :" }),
    /* @__PURE__ */ jsx28(Button13, { className: src_components_modal_oneClick_openApp_default.button, href: urlScheme, target: "_blank", onGoTo: onOpenApp, children: "Continuer sur l'application" })
  ] });
};
var openApp_default = OpenApp;

// src/components/applications/fixtures.jsx
var PLATFORMS = {
  WINDOWS: "Windows",
  ANDROID: "Android",
  MAC: "Mac",
  IPAD: "iPad",
  IPHONE: "iPhone",
  IPAD_IPHONE: "iPad/iPhone",
  LINUX: "Linux"
};
var LINK_TYPES_ORDER = ["store", "64 bits", "32 bits", "deb", "appImage"];
var APPLICATION_COMPUTER_LIST = [
  {
    title: "Windows",
    platform: PLATFORMS.WINDOWS,
    image: "/assets/img/applications/picto-windows.png",
    color: "#00bcf7",
    secondaryColor: "#afd3f6",
    links: {
      "64 bits": "https://ci.lls.fr/build/latest/win/Lelivrescolaire.fr.setup_64.exe"
    },
    event: "click_lycee_app_desktop_windows"
  },
  {
    title: "Mac",
    platform: PLATFORMS.MAC,
    image: "/assets/img/applications/picto-apple.png",
    color: "#a38ef1",
    secondaryColor: "#eab6e6",
    links: {
      "64 bits": "https://ci.lls.fr/build/latest/mac/Lelivrescolaire.fr.dmg"
    },
    event: "click_lycee_app_desktop_mac"
  },
  {
    title: "Linux",
    platform: PLATFORMS.LINUX,
    image: "/assets/img/applications/picto-linux.png",
    color: "#ff7900",
    secondaryColor: "#ffa800",
    links: {
      deb: "https://ci.lls.fr/build/latest/linux/Lelivrescolaire.fr.deb",
      appImage: "https://ci.lls.fr/build/latest/linux/Lelivrescolaire.fr.AppImage"
    },
    event: "click_lycee_app_desktop_linux"
  }
];
var APPLICATION_TABLET_LIST = [
  {
    title: "Ipad",
    platform: PLATFORMS.IPAD,
    image: "/assets/img/applications/picto-apple.png",
    color: "#a38ef1",
    secondaryColor: "#eab6e6",
    links: {
      store: "https://itunes.apple.com/fr/app/lelivrescolaire-fr-lyc%C3%A9e/id1455239230?mt=8"
    },
    event: "click_lycee_app_tablet_ios",
    targetLink: "_blank"
  },
  {
    title: "Tablette Android",
    platform: PLATFORMS.ANDROID,
    image: "/assets/img/applications/picto-android.png",
    color: "#8fbf00",
    secondaryColor: "#c0e829",
    links: {
      store: "https://play.google.com/store/apps/details?id=fr.lelivrescolaire.lycee&hl=fr"
    },
    event: "click_lycee_app_tablet_android",
    targetLink: "_blank"
  }
];
var APPLICATION_MOBILE_LIST = [
  {
    title: "Iphone",
    platform: PLATFORMS.IPHONE,
    image: "/assets/img/applications/picto-apple.png",
    color: "#a38ef1",
    secondaryColor: "#eab6e6",
    links: {
      store: "https://itunes.apple.com/fr/app/lelivrescolaire-fr-lyc%C3%A9e/id1455239230?mt=8"
    },
    event: "click_lycee_app_smartphone_ios",
    targetLink: "_blank"
  },
  {
    title: "Android",
    platform: PLATFORMS.ANDROID,
    image: "/assets/img/applications/picto-android.png",
    color: "#8fbf00",
    secondaryColor: "#c0e829",
    links: {
      store: "https://play.google.com/store/apps/details?id=fr.lelivrescolaire.lycee&hl=fr"
    },
    event: "click_lycee_app_smartphone_android",
    targetLink: "_blank"
  }
];
var APPLICATION_MOBILE_TABLET_LIST = [
  {
    title: "Ipad/Iphone",
    platform: PLATFORMS.IPAD_IPHONE,
    image: "/assets/img/applications/picto-apple.png",
    color: "#a38ef1",
    secondaryColor: "#eab6e6",
    links: {
      store: "https://itunes.apple.com/fr/app/lelivrescolaire-fr-lyc%C3%A9e/id1455239230?mt=8"
    },
    event: "click_lycee_app_tablet_ios",
    targetLink: "_blank"
  },
  {
    title: "Tablette Android",
    platform: PLATFORMS.ANDROID,
    image: "/assets/img/applications/picto-android.png",
    color: "#8fbf00",
    secondaryColor: "#c0e829",
    links: {
      store: "https://play.google.com/store/apps/details?id=fr.lelivrescolaire.lycee&hl=fr"
    },
    event: "click_lycee_app_tablet_android",
    targetLink: "_blank"
  }
];
var [WINDOWS_APPLICATION, MAC_APPLICATION, LINUX_APPLICATION] = APPLICATION_COMPUTER_LIST;
var [IPAD_APPLICATION, ANDROID_TABLET_APPLICATION] = APPLICATION_TABLET_LIST;
var [IPHONE_APPLICATION, ANDROID_MOBILE_APPLICATION] = APPLICATION_MOBILE_LIST;

// src/utils/device.js
var import_bowser = __toESM(require_es5(), 1);
import { hasWindowObject as hasWindowObject4 } from "@lls/utils";
import _34 from "lodash/fp.js";
var getNavigatorAgent = () => hasWindowObject4() ? window.navigator.userAgent : "";
var getBrowser = () => hasWindowObject4() ? import_bowser.default.parse(getNavigatorAgent()) : null;
var getOs = () => _34.get("os.name", getBrowser());
var getPlatform = () => _34.get("platform.type", getBrowser());
var getApplication = () => {
  const os = getOs();
  const platform2 = getPlatform();
  switch (true) {
    case (os === "iOS" && platform2 === "mobile"):
      return IPHONE_APPLICATION;
    case (os === "iOS" && platform2 === "tablet"):
      return IPAD_APPLICATION;
    case (os === "Android" && platform2 === "mobile"):
      return ANDROID_MOBILE_APPLICATION;
    case (os === "Android" && platform2 === "tablet"):
      return ANDROID_TABLET_APPLICATION;
    case os === "macOS":
      return MAC_APPLICATION;
    case os === "Windows":
      return WINDOWS_APPLICATION;
    case os === "Linux":
      return LINUX_APPLICATION;
    default:
      return null;
  }
};
var getAppLink = (app) => {
  const links = _34.get("links", app);
  const firstLinkType = _34.find((type) => !!_34.get(type, links), LINK_TYPES_ORDER);
  return _34.get(firstLinkType, links);
};

// src/components/modal/oneClick/twoSteps.jsx
init_link();
init_route();
init_style();
import { Button as Button14, Divider as Divider4, Icon as Icon4 } from "@lls/lls-kit";

// tmp_esbuild1736180049684/_src_components_modal_oneClick_twoSteps.module.css
var src_components_modal_oneClick_twoSteps_default = { "text": "core-TEySZa-text", "twoSteps": "core-TEySZa-twoSteps", "link": "core-TEySZa-link", "button": "core-TEySZa-button", "icons": "core-TEySZa-icons", "iconContainer": "core-TEySZa-iconContainer" };

// src/components/modal/oneClick/twoSteps.jsx
import { jsx as jsx30, jsxs as jsxs18 } from "react/jsx-runtime";
var TwoSteps = ({ urlScheme }) => {
  const application = getApplication();
  const link = getAppLink(application);
  const allAppLink = getPath("lls_applications");
  return /* @__PURE__ */ jsxs18("div", { className: src_components_modal_oneClick_twoSteps_default.twoSteps, children: [
    /* @__PURE__ */ jsx30("div", { className: src_components_modal_oneClick_twoSteps_default.text, children: "Si vous ne poss\xE8dez pas l'application, vous pouvez acc\xE9der \xE0 vos manuels num\xE9riques en compl\xE9tant les \xE9tapes suivantes :" }),
    /* @__PURE__ */ jsx30(link_default, { className: src_components_modal_oneClick_twoSteps_default.link, href: link, target: "_blank", rel: "noreferer", children: /* @__PURE__ */ jsx30(Button14, { className: src_components_modal_oneClick_twoSteps_default.button, icon: "number1circlefilled", size: "small", children: "T\xE9l\xE9charger l'application" }) }),
    /* @__PURE__ */ jsx30(link_default, { className: src_components_modal_oneClick_twoSteps_default.link, href: urlScheme, target: "_blank", rel: "noreferrer", children: /* @__PURE__ */ jsx30(Button14, { className: src_components_modal_oneClick_twoSteps_default.button, icon: "number2circlefilled", size: "small", children: "Activer votre licence" }) }),
    /* @__PURE__ */ jsx30(Divider4, {}),
    /* @__PURE__ */ jsx30("div", { className: src_components_modal_oneClick_twoSteps_default.text, children: "Vous pouvez retrouver l'ensemble de nos applications en cliquant sur le bouton ci-dessous :" }),
    /* @__PURE__ */ jsx30(link_default, { className: src_components_modal_oneClick_twoSteps_default.link, href: allAppLink, target: "_blank", rel: "noreferrer", children: /* @__PURE__ */ jsx30(Button14, { className: src_components_modal_oneClick_twoSteps_default.button, accent: "floating", theme: "gray", children: "Acc\xE9der \xE0 la liste compl\xE8te" }) }),
    /* @__PURE__ */ jsxs18("div", { className: src_components_modal_oneClick_twoSteps_default.icons, children: [
      /* @__PURE__ */ jsx30("div", { className: src_components_modal_oneClick_twoSteps_default.iconContainer, style: { "--cr-color-grey1": COLOR_GREY_1 }, children: /* @__PURE__ */ jsx30(Icon4, { name: "windows", width: 40, height: 40 }) }),
      /* @__PURE__ */ jsx30("div", { className: src_components_modal_oneClick_twoSteps_default.iconContainer, style: { "--cr-color-grey1": COLOR_GREY_1 }, children: /* @__PURE__ */ jsx30(Icon4, { name: "android", width: 40, height: 40 }) }),
      /* @__PURE__ */ jsx30("div", { className: src_components_modal_oneClick_twoSteps_default.iconContainer, style: { "--cr-color-grey1": COLOR_GREY_1 }, children: /* @__PURE__ */ jsx30(Icon4, { name: "apple", width: 40, height: 40 }) }),
      /* @__PURE__ */ jsx30("div", { className: src_components_modal_oneClick_twoSteps_default.iconContainer, style: { "--cr-color-grey1": COLOR_GREY_1 }, children: /* @__PURE__ */ jsx30(Icon4, { name: "linux", width: 40, height: 40 }) })
    ] })
  ] });
};
var twoSteps_default = TwoSteps;

// src/components/modal/oneClick/index.jsx
import { jsx as jsx31, jsxs as jsxs19 } from "react/jsx-runtime";
var OneClickModal = ({ close, pageId, bookId }) => {
  const [selectedTabIndex, setSelectedTabIndex] = useState8(0);
  const auth2 = useSelector17(getAuth2);
  const token = _35.get("token", auth2);
  const urlSchemeParams = {
    query: { pageId, bookId, token },
    commands: [URL_SCHEME_LOGIN, URL_SCHEME_RESOURCE_OPEN]
  };
  const urlScheme = getPath("url_scheme", urlSchemeParams);
  return /* @__PURE__ */ jsx31(Modal7, { title: "Ouvrir l'application", closeModal: close, children: /* @__PURE__ */ jsxs19("div", { className: src_components_modal_oneClick_index_default.modalContent, children: [
    /* @__PURE__ */ jsxs19(Tabs, { value: selectedTabIndex, onChange: setSelectedTabIndex, children: [
      /* @__PURE__ */ jsx31(Tab, { children: "Je poss\xE8de l'application" }),
      /* @__PURE__ */ jsx31(Tab, { children: "Je ne poss\xE8de pas l'application" })
    ] }),
    selectedTabIndex === 0 ? /* @__PURE__ */ jsx31(openApp_default, { urlScheme }) : /* @__PURE__ */ jsx31(twoSteps_default, { urlScheme })
  ] }) });
};
var oneClick_default = OneClickModal;

// src/components/modal/panoramaModal/index.jsx
import { useCallback as useCallback13, useMemo as useMemo6, useState as useState10 } from "react";

// src/components/modal/panoramaModal/panoramaModalHeader.jsx
init_panorama();
init_panorama2();
import _37 from "lodash/fp.js";
import { useCallback as useCallback11, useState as useState9 } from "react";
import { Button as Button15, Modal as Modal8, VideoPlayer } from "@lls/lls-kit";
import { cx as cx3 } from "@lls/utils";

// tmp_esbuild1736180049684/_src_components_modal_panoramaModal_panoramaModalHeader.module.css
var src_components_modal_panoramaModal_panoramaModalHeader_default = { "panoramaHeaderCloseButton": "core-GcmZMG-panoramaHeaderCloseButton", "videoPlayer": "core-GcmZMG-videoPlayer", "panoramaHeaderLogoBg": "core-GcmZMG-panoramaHeaderLogoBg", "modalContent": "core-GcmZMG-modalContent", "panoramaHeaderInfos": "core-GcmZMG-panoramaHeaderInfos", "panoramaHeaderLogoGenially": "core-GcmZMG-panoramaHeaderLogoGenially", "pictureHeader": "core-GcmZMG-pictureHeader", "geniallyHeader": "core-GcmZMG-geniallyHeader", "modal": "core-GcmZMG-modal", "panoramaHeaderLogoPadlet": "core-GcmZMG-panoramaHeaderLogoPadlet" };

// src/components/modal/panoramaModal/panoramaModalHeader.jsx
import { jsx as jsx32, jsxs as jsxs20 } from "react/jsx-runtime";
var PictureHeader = ({ resourcePack }) => {
  const { vignette = "" } = resourcePack;
  return /* @__PURE__ */ jsx32("div", { className: src_components_modal_panoramaModal_panoramaModalHeader_default.pictureHeader, style: { "--cr-picture": `url(${vignette})` } });
};
var VideoHeader = ({ resourcePack }) => {
  const videoResource = _37.first(getTypeResources([RESOURCE_FORMAT.Video], resourcePack));
  if (!videoResource) return null;
  return /* @__PURE__ */ jsx32("div", { className: src_components_modal_panoramaModal_panoramaModalHeader_default.videoPlayer, children: /* @__PURE__ */ jsx32(VideoPlayer, { src: videoResource.url, poster: resourcePack.vignette }) });
};
var EmbeddedHeader = ({ resourcePack }) => {
  const [isFullscreenShown, setIsFullscreenShown] = useState9(false);
  const toggleFullscreen = useCallback11(() => {
    setIsFullscreenShown((prevIsShown) => !prevIsShown);
  }, []);
  const { title: subTitle = "", type = RESOURCE_FORMAT.Genially } = resourcePack;
  const embeddedResource = _37.first(getTypeResources([type], resourcePack));
  if (!embeddedResource) return null;
  const title = type === RESOURCE_FORMAT.Genially ? GENIALLY_INFOS.title : PADLET_INFOS.title;
  const logoClassName = cx3(
    type === RESOURCE_FORMAT.Genially ? src_components_modal_panoramaModal_panoramaModalHeader_default.panoramaHeaderLogoGenially : src_components_modal_panoramaModal_panoramaModalHeader_default.panoramaHeaderLogoPadlet,
    src_components_modal_panoramaModal_panoramaModalHeader_default.panoramaHeaderLogoBg
  );
  const src = `${type === RESOURCE_FORMAT.Genially ? GENIALLY_INFOS.url : PADLET_INFOS.url}${embeddedResource.id}`;
  return /* @__PURE__ */ jsxs20("div", { className: src_components_modal_panoramaModal_panoramaModalHeader_default.geniallyHeader, children: [
    /* @__PURE__ */ jsx32("div", { className: logoClassName }),
    /* @__PURE__ */ jsxs20("div", { className: src_components_modal_panoramaModal_panoramaModalHeader_default.panoramaHeaderInfos, children: [
      /* @__PURE__ */ jsx32("h2", { children: title }),
      /* @__PURE__ */ jsx32("h3", { children: subTitle }),
      /* @__PURE__ */ jsx32(Button15, { onClick: toggleFullscreen, children: "Acc\xE9der au module" })
    ] }),
    isFullscreenShown && /* @__PURE__ */ jsx32(Modal8, { className: src_components_modal_panoramaModal_panoramaModalHeader_default.modal, fullscreen: true, withCloseButton: false, children: /* @__PURE__ */ jsxs20("div", { className: src_components_modal_panoramaModal_panoramaModalHeader_default.modalContent, children: [
      /* @__PURE__ */ jsx32(
        "iframe",
        {
          frameBorder: "0",
          height: "100%",
          width: "100%",
          src,
          type: "text/html",
          allowscriptaccess: "always",
          allowFullScreen: true,
          scrolling: "yes",
          allownetworking: "all",
          title
        }
      ),
      /* @__PURE__ */ jsx32(
        Button15,
        {
          className: src_components_modal_panoramaModal_panoramaModalHeader_default.panoramaHeaderCloseButton,
          theme: "gray",
          icon: "cancel",
          onClick: toggleFullscreen
        }
      )
    ] }) })
  ] });
};
var PanoramaModalHeader = ({ resourcePack }) => {
  switch (resourcePack.type) {
    case RESOURCE_FORMAT.Genially:
    case RESOURCE_FORMAT.Padlet:
      return /* @__PURE__ */ jsx32(EmbeddedHeader, { resourcePack });
    case RESOURCE_FORMAT.Video:
      return /* @__PURE__ */ jsx32(VideoHeader, { resourcePack });
    default:
      return /* @__PURE__ */ jsx32(PictureHeader, { resourcePack });
  }
};
var panoramaModalHeader_default = PanoramaModalHeader;

// src/components/modal/panoramaModal/index.jsx
init_panorama();
init_viewer();

// src/hooks/useResourceLikes.js
init_constants();
init_cookie();
init_panorama2();
init_es62();
import _39 from "lodash/fp.js";
import { useCallback as useCallback12, useMemo as useMemo5 } from "react";
var useResourceLikes = ({ analyticsResourceId }) => {
  const [cookies, setCookie] = useCookies();
  const panoramaLikesCookie = _39.get(COOKIE_PANORAMA_LIKE, cookies);
  const panoramaDislikesCookie = _39.get(COOKIE_PANORAMA_DISLIKE, cookies);
  const [userLikes, userDislikes] = useMemo5(() => {
    return [getPanoramaLikesCookieItems(panoramaLikesCookie), getPanoramaLikesCookieItems(panoramaDislikesCookie)];
  }, [panoramaLikesCookie, panoramaDislikesCookie]);
  const hasUserLikedThisResource = _39.includes(analyticsResourceId, userLikes);
  const hasUserDislikedThisResource = _39.includes(analyticsResourceId, userDislikes);
  const likeResource = useCallback12(() => {
    if (hasUserLikedThisResource) {
      setCookie(COOKIE_PANORAMA_LIKE, removePanoramaLikesCookieItem(analyticsResourceId, userLikes), getCookieOptions());
    } else {
      if (hasUserDislikedThisResource) {
        setCookie(
          COOKIE_PANORAMA_DISLIKE,
          removePanoramaLikesCookieItem(analyticsResourceId, userDislikes),
          getCookieOptions()
        );
      }
      setCookie(COOKIE_PANORAMA_LIKE, addNewPanoramaLikesCookieItem(analyticsResourceId, userLikes), getCookieOptions());
    }
  }, [setCookie, hasUserLikedThisResource, hasUserDislikedThisResource, userLikes, userDislikes, analyticsResourceId]);
  const dislikeResource = useCallback12(() => {
    if (hasUserDislikedThisResource) {
      setCookie(
        COOKIE_PANORAMA_DISLIKE,
        removePanoramaLikesCookieItem(analyticsResourceId, userDislikes),
        getCookieOptions()
      );
    } else {
      if (hasUserLikedThisResource) {
        setCookie(
          COOKIE_PANORAMA_LIKE,
          removePanoramaLikesCookieItem(analyticsResourceId, userLikes),
          getCookieOptions()
        );
      }
      setCookie(
        COOKIE_PANORAMA_DISLIKE,
        addNewPanoramaLikesCookieItem(analyticsResourceId, userDislikes),
        getCookieOptions()
      );
    }
  }, [setCookie, hasUserLikedThisResource, hasUserDislikedThisResource, userLikes, userDislikes, analyticsResourceId]);
  return { hasUserLikedThisResource, hasUserDislikedThisResource, likeResource, dislikeResource };
};
var useResourceLikes_default = useResourceLikes;

// src/components/modal/panoramaModal/index.jsx
init_panorama2();
import { Button as Button16, Icon as Icon5, Modal as Modal9, Stamp } from "@lls/lls-kit";
import _40 from "lodash/fp.js";
import { useDispatch as useDispatch12 } from "react-redux";
import { useHistory as useHistory5 } from "react-router-dom";

// tmp_esbuild1736180049684/_src_components_modal_panoramaModal_index.module.css
var src_components_modal_panoramaModal_index_default = { "panoramaModalPicture": "core-fb3PcG-panoramaModalPicture", "panoramaModalCredit": "core-fb3PcG-panoramaModalCredit", "panoramaModalContent": "core-fb3PcG-panoramaModalContent", "panoramaModalCloseButton": "core-fb3PcG-panoramaModalCloseButton", "panoramaModalCopyright": "core-fb3PcG-panoramaModalCopyright", "panoramaModalInfoIcon": "core-fb3PcG-panoramaModalInfoIcon", "panoramaModalLegend": "core-fb3PcG-panoramaModalLegend", "panoramaModalTitle": "core-fb3PcG-panoramaModalTitle", "panoramaModalFullDesc": "core-fb3PcG-panoramaModalFullDesc", "panoramaModalGallery": "core-fb3PcG-panoramaModalGallery", "panoramaModalHeadline": "core-fb3PcG-panoramaModalHeadline", "panoramaModalActions": "core-fb3PcG-panoramaModalActions", "panoramaModalExclu": "core-fb3PcG-panoramaModalExclu", "panoramaModalLinks": "core-fb3PcG-panoramaModalLinks", "galleryModal": "core-fb3PcG-galleryModal", "panoramaModalBody": "core-fb3PcG-panoramaModalBody", "link": "core-fb3PcG-link", "galleryModalContent": "core-fb3PcG-galleryModalContent", "galleryItem": "core-fb3PcG-galleryItem", "panoramaModalStamps": "core-fb3PcG-panoramaModalStamps", "modal": "core-fb3PcG-modal", "panoramaModalDislikeButton": "core-fb3PcG-panoramaModalDislikeButton" };

// src/components/modal/panoramaModal/index.jsx
import { jsx as jsx33, jsxs as jsxs21 } from "react/jsx-runtime";
var map = _40.map.convert({ cap: false });
var PanoramaLink = ({ link = {}, onGoToCb = _40.noop }) => {
  return /* @__PURE__ */ jsxs21("div", { className: src_components_modal_panoramaModal_index_default.link, children: [
    /* @__PURE__ */ jsx33("span", { children: _40.getOr("", [link.format, "label"], WORDING_LINKS) }),
    /* @__PURE__ */ jsx33(
      Button16,
      {
        theme: "premium",
        icon: _40.getOr("doctext", [link.format, "icon"], WORDING_LINKS),
        onGoTo: onGoToCb,
        page: link.page,
        doc: link.doc,
        quiz: link.quiz,
        target: "_blank",
        href: link.url,
        children: _40.getOr("", [link.format, "button"], WORDING_LINKS)
      }
    )
  ] });
};
var PanoramaGalleryItem = ({ item = {}, onShowPictureInFullscreen = _40.noop }) => {
  const onClickItem = useCallback13(() => {
    onShowPictureInFullscreen(item);
  }, [onShowPictureInFullscreen, item]);
  return /* @__PURE__ */ jsxs21("div", { className: src_components_modal_panoramaModal_index_default.galleryItem, style: { "--cr-picture": `url(${item.url})` }, onClick: onClickItem, children: [
    /* @__PURE__ */ jsx33("div", { className: src_components_modal_panoramaModal_index_default.panoramaModalPicture }),
    /* @__PURE__ */ jsx33("div", { className: src_components_modal_panoramaModal_index_default.panoramaModalLegend, dangerouslySetInnerHTML: { __html: item.legend } }),
    /* @__PURE__ */ jsxs21("div", { className: src_components_modal_panoramaModal_index_default.panoramaModalCredit, children: [
      /* @__PURE__ */ jsx33(Icon5, { name: "copyright", width: "12", height: "12", className: src_components_modal_panoramaModal_index_default.panoramaModalCopyright }),
      /* @__PURE__ */ jsx33("span", { dangerouslySetInnerHTML: { __html: item.credit } })
    ] })
  ] });
};
var PanoramaModal = ({ isMobile = false, chapterId = "", resourcePack = {}, close }) => {
  const { id: resourceId = "", title = "", fullDesc = "", tags = [] } = resourcePack;
  const analyticsResourceId = `${chapterId}_${resourceId}`;
  const [fullscreenPictureItem, setFullscreenPictureItem] = useState10(void 0);
  const { hasUserLikedThisResource, hasUserDislikedThisResource, likeResource, dislikeResource } = useResourceLikes_default({
    analyticsResourceId
  });
  const links = useMemo6(
    () => getTypeResources(
      [
        RESOURCE_FORMAT.DownloadPdf,
        RESOURCE_FORMAT.DownloadOther,
        RESOURCE_FORMAT.ExternalLink,
        RESOURCE_FORMAT.InternalLink
      ],
      resourcePack
    ),
    [resourcePack]
  );
  const galleryItems = useMemo6(
    () => _40.flow(getTypeResources([RESOURCE_FORMAT.Gallery]), _40.getOr([], "0.items"))(resourcePack),
    [resourcePack]
  );
  const dispatch = useDispatch12();
  const history = useHistory5();
  const onGoToCb = useCallback13(
    (data) => {
      onGoToEffect({
        dispatch,
        history,
        params: { data }
      });
    },
    [dispatch, history]
  );
  return /* @__PURE__ */ jsxs21(
    Modal9,
    {
      className: src_components_modal_panoramaModal_index_default.modal,
      fullscreen: isMobile,
      fullwidth: true,
      maxwidth: "sm",
      withCloseButton: false,
      closeModal: close,
      children: [
        /* @__PURE__ */ jsxs21("div", { className: src_components_modal_panoramaModal_index_default.modalContent, children: [
          /* @__PURE__ */ jsxs21("div", { children: [
            /* @__PURE__ */ jsx33("div", { className: src_components_modal_panoramaModal_index_default.panoramaModalContent, children: /* @__PURE__ */ jsx33(panoramaModalHeader_default, { resourcePack }) }),
            /* @__PURE__ */ jsx33(Button16, { className: src_components_modal_panoramaModal_index_default.panoramaModalCloseButton, theme: "gray", icon: "cancel", onClick: close })
          ] }),
          /* @__PURE__ */ jsxs21("div", { className: src_components_modal_panoramaModal_index_default.panoramaModalBody, children: [
            /* @__PURE__ */ jsxs21("div", { className: src_components_modal_panoramaModal_index_default.panoramaModalHeadline, children: [
              /* @__PURE__ */ jsx33("div", { className: src_components_modal_panoramaModal_index_default.panoramaModalStamps, children: _40.map(
                (tag) => /* @__PURE__ */ jsx33(Stamp, { theme: "light-red", size: "medium", children: tag }, tag),
                tags
              ) }),
              /* @__PURE__ */ jsxs21("div", { className: src_components_modal_panoramaModal_index_default.panoramaModalActions, children: [
                /* @__PURE__ */ jsx33(
                  Button16,
                  {
                    onClick: likeResource,
                    theme: hasUserLikedThisResource ? "blue" : "gray",
                    accent: "floating",
                    icon: "thumb"
                  }
                ),
                /* @__PURE__ */ jsx33(
                  Button16,
                  {
                    onClick: dislikeResource,
                    className: src_components_modal_panoramaModal_index_default.panoramaModalDislikeButton,
                    theme: hasUserDislikedThisResource ? "blue" : "gray",
                    accent: "floating",
                    icon: "thumb"
                  }
                )
              ] })
            ] }),
            /* @__PURE__ */ jsx33("div", { className: src_components_modal_panoramaModal_index_default.panoramaModalTitle, dangerouslySetInnerHTML: { __html: title } }),
            /* @__PURE__ */ jsx33("div", { className: src_components_modal_panoramaModal_index_default.panoramaModalFullDesc, dangerouslySetInnerHTML: { __html: fullDesc } }),
            /* @__PURE__ */ jsx33("div", { className: src_components_modal_panoramaModal_index_default.panoramaModalLinks, children: map(
              (link, index3) => /* @__PURE__ */ jsx33(PanoramaLink, { link, onGoToCb }, index3),
              links
            ) }),
            /* @__PURE__ */ jsx33("div", { className: src_components_modal_panoramaModal_index_default.panoramaModalGallery, children: map(
              (item, index3) => /* @__PURE__ */ jsx33(PanoramaGalleryItem, { item, onShowPictureInFullscreen: setFullscreenPictureItem }, index3),
              galleryItems
            ) })
          ] })
        ] }),
        fullscreenPictureItem && /* @__PURE__ */ jsx33(Modal9, { className: src_components_modal_panoramaModal_index_default.galleryModal, fullscreen: true, withCloseButton: false, children: /* @__PURE__ */ jsxs21(
          "div",
          {
            className: src_components_modal_panoramaModal_index_default.galleryModalContent,
            style: { "--cr-picture": `url(${fullscreenPictureItem.url})` },
            children: [
              /* @__PURE__ */ jsx33("div", { className: src_components_modal_panoramaModal_index_default.panoramaModalPicture }),
              /* @__PURE__ */ jsx33(
                Button16,
                {
                  className: src_components_modal_panoramaModal_index_default.panoramaModalCloseButton,
                  theme: "gray",
                  icon: "cancel",
                  onClick: () => setFullscreenPictureItem(void 0)
                }
              )
            ]
          }
        ) })
      ]
    }
  );
};
var panoramaModal_default = PanoramaModal;

// src/components/modal/teacherBookDetailModal.tsx
import _41 from "lodash/fp.js";
import { useEffect as useEffect11, useMemo as useMemo7 } from "react";
import { useDispatch as useDispatch13, useSelector as useSelector18 } from "react-redux";

// src/components/modal/teacherBookModal/chapters.tsx
import { Divider as Divider5 } from "@lls/lls-kit";
import { ANALYTICS_LINK_CLICKED, dispatchAnalyticsEvent as dispatchAnalyticsEvent8 } from "@lls/utils";
import { Fragment as Fragment5, useState as useState11 } from "react";

// tmp_esbuild1736180049684/_src_components_modal_teacherBookModal_chapters.module.css
var src_components_modal_teacherBookModal_chapters_default = { "chapterContainer": "core-zF2s7G-chapterContainer", "chapterTitle": "core-zF2s7G-chapterTitle", "chapters": "core-zF2s7G-chapters", "files": "core-zF2s7G-files", "divider": "core-zF2s7G-divider", "chapter": "core-zF2s7G-chapter" };

// src/components/modal/teacherBookModal/download.tsx
init_link();
import { Button as Button17 } from "@lls/lls-kit";
import { jsx as jsx34 } from "react/jsx-runtime";
var Download = ({ url, label = "T\xE9l\xE9charger", icon, accent = "floating", isHovered, onClick }) => /* @__PURE__ */ jsx34(link_default, { href: url, download: true, onClick, target: "_blank", rel: "noreferrer", children: /* @__PURE__ */ jsx34(
  Button17,
  {
    className: src_components_modal_teacherBookModal_chapters_default.downloadButton,
    disabled: !url,
    accent,
    theme: isHovered ? "blue" : "gray",
    icon,
    iconPosition: "right",
    children: label
  }
) });
var download_default = Download;

// src/components/modal/teacherBookModal/chapters.tsx
import { jsx as jsx35, jsxs as jsxs22 } from "react/jsx-runtime";
var Chapter = ({ chapter, bookId }) => {
  const [isHovered, setIsHovered] = useState11(false);
  const onClick = (feature) => {
    dispatchAnalyticsEvent8(ANALYTICS_LINK_CLICKED, {
      featureName: "LDP_DL",
      extraData: feature,
      bookId
    });
  };
  return /* @__PURE__ */ jsxs22(
    "div",
    {
      className: src_components_modal_teacherBookModal_chapters_default.chapterContainer,
      onMouseEnter: () => {
        setIsHovered(true);
      },
      onMouseLeave: () => {
        setIsHovered(false);
      },
      children: [
        /* @__PURE__ */ jsx35("div", { className: src_components_modal_teacherBookModal_chapters_default.chapter, children: /* @__PURE__ */ jsxs22("span", { className: src_components_modal_teacherBookModal_chapters_default.chapterTitle, children: [
          chapter.numShow ? `${chapter.numShow} :` : "",
          " ",
          chapter.title
        ] }) }),
        /* @__PURE__ */ jsxs22("div", { className: src_components_modal_teacherBookModal_chapters_default.files, children: [
          chapter.teacherDoc && /* @__PURE__ */ jsx35(
            download_default,
            {
              url: chapter.teacherDoc,
              label: "Compl\xE9ments",
              icon: "doc",
              isHovered,
              onClick: () => onClick("additionnal_chapter")
            }
          ),
          chapter.audios && /* @__PURE__ */ jsx35(
            download_default,
            {
              url: chapter.audios,
              label: "Audios",
              icon: "audioWave",
              isHovered,
              onClick: () => onClick("audio_chapter")
            }
          ),
          chapter.teacherBook && /* @__PURE__ */ jsx35(
            download_default,
            {
              url: chapter.teacherBook,
              icon: "download",
              isHovered,
              onClick: () => onClick("chapter")
            }
          )
        ] })
      ]
    }
  );
};
var Chapters = ({ chapters, bookId }) => /* @__PURE__ */ jsx35("div", { className: src_components_modal_teacherBookModal_chapters_default.chapters, children: chapters.map((chapter, index3) => /* @__PURE__ */ jsxs22(Fragment5, { children: [
  /* @__PURE__ */ jsx35(Chapter, { chapter, bookId }, chapter.id),
  index3 < chapters.length - 1 && /* @__PURE__ */ jsx35(Divider5, { className: src_components_modal_teacherBookModal_chapters_default.divider })
] }, index3)) });
var chapters_default = Chapters;

// src/components/modal/teacherBookDetailModal.tsx
init_constants();

// src/effects/book.js
init_actions();
init_book();
init_constants();
init_utils3();
var fetchTeacherBookChapters = async ({ params: { bookId, token } = {}, dispatch }) => {
  const { entities: entities2 } = await fetchTeacherBookChaptersApi({ bookId, token });
  dispatch(setEntities(entities2));
};
var fetchTeacherBookChaptersEffect = ({ dispatch, params }) => tryCatch({
  dispatch,
  effect: fetchTeacherBookChapters,
  params,
  loadingName: TEACHER_BOOK_ACCORDION_FETCH
});

// src/components/modal/teacherBookDetailModal.tsx
init_loading3();
import { BookCover, Button as Button18, Divider as Divider6, Modal as Modal10 } from "@lls/lls-kit";
import { useSearchChapters } from "@lls/store";
import { ANALYTICS_LINK_CLICKED as ANALYTICS_LINK_CLICKED2, dispatchAnalyticsEvent as dispatchAnalyticsEvent9 } from "@lls/utils";

// tmp_esbuild1736180049684/_src_components_modal_teacherBookDetailModal.module.css
var src_components_modal_teacherBookDetailModal_default = { "chapterContainer": "core-ZFQlTq-chapterContainer", "headerText": "core-ZFQlTq-headerText", "modalHeaderIntro": "core-ZFQlTq-modalHeaderIntro", "modalContainer": "core-ZFQlTq-modalContainer", "bookTitle": "core-ZFQlTq-bookTitle", "chapterTitle": "core-ZFQlTq-chapterTitle", "closeButton": "core-ZFQlTq-closeButton", "downloadButton": "core-ZFQlTq-downloadButton", "modalHeader": "core-ZFQlTq-modalHeader", "itemContainer": "core-ZFQlTq-itemContainer", "bookCover": "core-ZFQlTq-bookCover", "chapter": "core-ZFQlTq-chapter", "divider": "core-ZFQlTq-divider", "empty": "core-ZFQlTq-empty", "modalHeaderWrapper": "core-ZFQlTq-modalHeaderWrapper" };

// src/components/modal/teacherBookDetailModal.tsx
import { Fragment as Fragment6, jsx as jsx36, jsxs as jsxs23 } from "react/jsx-runtime";
var TeacherBookDetailModal = ({ book, close, token }) => {
  const dispatch = useDispatch13();
  const params = useMemo7(() => ({ bookId: book.id, token }), [book.id, token]);
  const chapters = useSearchChapters({ bookIds: [book.id], hasTeacherBook: true, sortByQuery: _41.sortBy("number") });
  useEffect11(() => {
    fetchTeacherBookChaptersEffect({ dispatch, params });
  }, [dispatch, params]);
  const isLoading = useSelector18(
    (state) => getIsLoading(state, TEACHER_BOOK_ACCORDION_FETCH, { bookId: book.id })
  );
  const onClick = () => {
    dispatchAnalyticsEvent9(ANALYTICS_LINK_CLICKED2, {
      featureName: "LDP_DL",
      extraData: "all_chapter",
      bookId: book == null ? void 0 : book.id
    });
  };
  return /* @__PURE__ */ jsx36(Modal10, { closeModal: close, fullwidth: true, withCloseButton: false, children: /* @__PURE__ */ jsxs23("div", { className: src_components_modal_teacherBookDetailModal_default.modalContainer, children: [
    /* @__PURE__ */ jsxs23("div", { className: src_components_modal_teacherBookDetailModal_default.modalHeader, children: [
      /* @__PURE__ */ jsxs23("div", { className: src_components_modal_teacherBookDetailModal_default.modalHeaderWrapper, children: [
        /* @__PURE__ */ jsxs23("div", { className: src_components_modal_teacherBookDetailModal_default.modalHeaderIntro, children: [
          /* @__PURE__ */ jsx36(
            BookCover,
            {
              width: "158px",
              height: "210px",
              src: book == null ? void 0 : book.url,
              className: src_components_modal_teacherBookDetailModal_default.bookCover,
              alt: book == null ? void 0 : book.displayTitle,
              hasWallShadow: false,
              teacherBookBanner: true
            }
          ),
          /* @__PURE__ */ jsxs23("div", { children: [
            /* @__PURE__ */ jsxs23("h2", { className: src_components_modal_teacherBookDetailModal_default.bookTitle, children: [
              " ",
              book.displayTitle,
              " "
            ] }),
            /* @__PURE__ */ jsx36("span", { className: src_components_modal_teacherBookDetailModal_default.headerText, children: "Livre du professeur" })
          ] })
        ] }),
        /* @__PURE__ */ jsx36(
          Button18,
          {
            className: src_components_modal_teacherBookDetailModal_default.closeButton,
            onClick: close,
            icon: "cancel",
            theme: "gray",
            accent: "floating",
            size: "small"
          }
        )
      ] }),
      !isLoading && !_41.isEmpty(chapters) && (book == null ? void 0 : book.teacherBook) && /* @__PURE__ */ jsxs23(Fragment6, { children: [
        /* @__PURE__ */ jsxs23("div", { className: src_components_modal_teacherBookDetailModal_default.chapterContainer, children: [
          /* @__PURE__ */ jsx36("div", { className: src_components_modal_teacherBookDetailModal_default.chapter, children: /* @__PURE__ */ jsx36("span", { className: src_components_modal_teacherBookDetailModal_default.chapterTitle, children: "Tout le livre du prof. (tous les chapitres) " }) }),
          /* @__PURE__ */ jsx36(download_default, { url: book == null ? void 0 : book.teacherBook, isHovered: true, accent: "main", icon: "download", onClick })
        ] }),
        /* @__PURE__ */ jsx36(Divider6, { className: src_components_modal_teacherBookDetailModal_default.divider })
      ] })
    ] }),
    !isLoading && _41.isEmpty(chapters) ? /* @__PURE__ */ jsx36("div", { className: src_components_modal_teacherBookDetailModal_default.empty, children: "Le livre du professeur pour ce manuel sera prochainement disponible." }) : /* @__PURE__ */ jsx36(chapters_default, { chapters, bookId: book == null ? void 0 : book.id })
  ] }) });
};
var teacherBookDetailModal_default = TeacherBookDetailModal;

// src/components/modal/tipModal.jsx
import { Button as Button19, Modal as Modal11, VideoPlayer as VideoPlayer2 } from "@lls/lls-kit";

// tmp_esbuild1736180049684/_src_components_modal_tipModal.module.css
var src_components_modal_tipModal_default = { "modalContent": "core-RnvXja-modalContent", "description": "core-RnvXja-description", "title": "core-RnvXja-title" };

// src/components/modal/tipModal.jsx
import { jsx as jsx37, jsxs as jsxs24 } from "react/jsx-runtime";
var TipModal = ({ title, videoUrl, description, close }) => {
  return /* @__PURE__ */ jsx37(Modal11, { closeModal: close, withCloseButton: false, children: /* @__PURE__ */ jsxs24("div", { className: src_components_modal_tipModal_default.modalContent, children: [
    /* @__PURE__ */ jsx37(VideoPlayer2, { src: videoUrl, autoPlay: true, loop: true }),
    /* @__PURE__ */ jsx37("span", { className: src_components_modal_tipModal_default.title, children: title }),
    /* @__PURE__ */ jsx37("span", { className: src_components_modal_tipModal_default.description, children: description }),
    /* @__PURE__ */ jsx37(Button19, { onClick: close, children: "Compris !" })
  ] }) });
};
var tipModal_default = TipModal;

// src/components/modal/trial/trialFeatureBlockedModal.jsx
init_trial2();
import _42 from "lodash/fp.js";
import { Button as Button20, Modal as Modal12 } from "@lls/lls-kit";
import { ANALYTICS_LINK_CLICKED as ANALYTICS_LINK_CLICKED3, ANALYTICS_PAGE_VIEWED as ANALYTICS_PAGE_VIEWED2, dispatchAnalyticsEvent as dispatchAnalyticsEvent10, openWindow as openWindow8 } from "@lls/utils";
import { useEffect as useEffect12 } from "react";

// tmp_esbuild1736180049684/_src_components_modal_trial_trialFeatureBlockedModal.module.css
var src_components_modal_trial_trialFeatureBlockedModal_default = { "modalContent": "core-Vkav9q-modalContent", "title": "core-Vkav9q-title" };

// src/components/modal/trial/trialFeatureBlockedModal.jsx
import { jsx as jsx38, jsxs as jsxs25 } from "react/jsx-runtime";
var TrialFeatureBlockedModal = ({ close, featureName = "modal_classroom" }) => {
  const { title, content } = _42.getOr({}, featureName, MODAL_FEATURES);
  useEffect12(() => {
    dispatchAnalyticsEvent10(ANALYTICS_PAGE_VIEWED2, { featureName });
  }, [featureName]);
  const onGoTo2 = ({ href, target }) => {
    dispatchAnalyticsEvent10(ANALYTICS_LINK_CLICKED3, { featureName });
    openWindow8(href, target);
  };
  return /* @__PURE__ */ jsx38(Modal12, { title: /* @__PURE__ */ jsx38("div", { className: src_components_modal_trial_trialFeatureBlockedModal_default.title, children: title }), withCloseButton: false, closeModal: close, children: /* @__PURE__ */ jsxs25("div", { className: src_components_modal_trial_trialFeatureBlockedModal_default.modalContent, children: [
    content,
    /* @__PURE__ */ jsxs25("div", { children: [
      /* @__PURE__ */ jsx38(Button20, { accent: "floating", theme: "gray", onClick: close, children: "Fermer" }),
      featureName !== MODAL_CORRECTION && /* @__PURE__ */ jsx38(Button20, { href: CALENDLY_LINK, target: "_blank", onGoTo: onGoTo2, children: "Prendre rendez-vous" })
    ] })
  ] }) });
};
var trialFeatureBlockedModal_default = TrialFeatureBlockedModal;

// src/components/modal/trialTipModal.jsx
init_tour2();
init_useTour();
import { useCallback as useCallback14 } from "react";
import { Button as Button21, Modal as Modal13, VideoPlayer as VideoPlayer3 } from "@lls/lls-kit";

// tmp_esbuild1736180049684/_src_components_modal_trialTipModal.module.css
var src_components_modal_trialTipModal_default = { "videoPlayer": "core-v_FEZa-videoPlayer", "subtext": "core-v_FEZa-subtext", "title": "core-v_FEZa-title", "modalContent": "core-v_FEZa-modalContent", "text": "core-v_FEZa-text" };

// src/components/modal/trialTipModal.jsx
import { jsx as jsx39, jsxs as jsxs26 } from "react/jsx-runtime";
var TrialTipModal = ({ close, tip }) => {
  const { sendEvent: sendEvent2 } = useTour_default();
  const onClose = useCallback14(() => {
    sendEvent2(TOUR_EVENTS.TIP_MODAL_CLOSED);
    close();
  }, [sendEvent2, close]);
  return /* @__PURE__ */ jsx39(Modal13, { closeModal: onClose, withCloseButton: false, children: /* @__PURE__ */ jsxs26("div", { className: src_components_modal_trialTipModal_default.modalContent, children: [
    /* @__PURE__ */ jsx39(VideoPlayer3, { className: src_components_modal_trialTipModal_default.videoPlayer, src: tip == null ? void 0 : tip.videoUrl, autoPlay: true, loop: true }),
    /* @__PURE__ */ jsx39("h1", { className: src_components_modal_trialTipModal_default.title, children: tip == null ? void 0 : tip.title }),
    /* @__PURE__ */ jsx39("p", { className: src_components_modal_trialTipModal_default.text, children: tip == null ? void 0 : tip.text }),
    /* @__PURE__ */ jsx39("p", { className: src_components_modal_trialTipModal_default.subtext, children: tip == null ? void 0 : tip.subtext }),
    /* @__PURE__ */ jsx39(Button21, { onClick: onClose, children: "Compris !" })
  ] }) });
};
var trialTipModal_default = TrialTipModal;

// src/components/modal/warningSavePageModal.jsx
init_actions();
init_route();
import { Button as Button22, Modal as Modal14 } from "@lls/lls-kit";
import { useCallback as useCallback15, useEffect as useEffect13, useRef as useRef6 } from "react";
import { getPagePath as getPagePath3, needNewCustomDraft } from "@lls/utils";
import _43 from "lodash/fp.js";
import { useDispatch as useDispatch14, useSelector as useSelector19 } from "react-redux";
import { useHistory as useHistory6 } from "react-router-dom";
import { getDrafts, useSearchPages as useSearchPages3 } from "@lls/store";
import { getBook } from "@lls/store";
import { getCurrentUser as getCurrentUser13 } from "@lls/store";

// tmp_esbuild1736180049684/_src_components_modal_warningSavePageModal.module.css
var src_components_modal_warningSavePageModal_default = { "warningSavePageModalActions": "core-Td4VnG-warningSavePageModalActions", "warningSavePageModalText": "core-Td4VnG-warningSavePageModalText", "modalContent": "core-Td4VnG-modalContent", "warningSavePageModalInput": "core-Td4VnG-warningSavePageModalInput", "modal": "core-Td4VnG-modal" };

// src/components/modal/warningSavePageModal.jsx
import { jsx as jsx40, jsxs as jsxs27 } from "react/jsx-runtime";
var WarningSavePageModal = ({ close, currentPageDraft }) => {
  var _a2;
  const title = currentPageDraft == null ? void 0 : currentPageDraft.displayTitle;
  const dispatch = useDispatch14();
  const history = useHistory6();
  const book = useSelector19((state) => getBook(state, _43.get("book", currentPageDraft)));
  const draftPages = useSelector19(getDrafts);
  const currentUser = useSelector19(getCurrentUser13);
  const pageTemp = (_a2 = useSearchPages3({ slugs: [currentPageDraft == null ? void 0 : currentPageDraft.slug] })) == null ? void 0 : _a2[0];
  const alreadyRegisterRef = useRef6(void 0);
  alreadyRegisterRef.current = needNewCustomDraft(currentPageDraft, currentUser) ? !_43.some({ id: _43.get("id", currentPageDraft) }, draftPages) : !_43.get("isDraft", pageTemp);
  const savePageModalClick = useCallback15(() => {
    if (!isAlreadyOnDraftPage(history, currentPageDraft)) {
      if (currentPageDraft.id < 0) {
        history.push(getPath("page-creation", { ...book, draftId: _43.get("id", currentPageDraft), isDraft: true }));
      } else {
        history.push(getPagePath3(_43.pick(["slug"], currentPageDraft), _43.pick(["isDraft"], currentPageDraft)));
      }
    } else {
      dispatch(setIsOpenSaveModal(true));
      close();
    }
  }, [book, dispatch, close, currentPageDraft, history]);
  useEffect13(() => {
    return history.listen((_params, action) => {
      if (alreadyRegisterRef.current) {
        close();
        return;
      }
      if (action === "PUSH" && isAlreadyOnDraftPage(history, currentPageDraft)) {
        !alreadyRegisterRef.current && dispatch(setIsOpenSaveModal(true));
        close();
      }
    });
  }, [history, dispatch, currentPageDraft, close]);
  return !alreadyRegisterRef.current && /* @__PURE__ */ jsx40(Modal14, { className: src_components_modal_warningSavePageModal_default.modal, title: "Quitter la page ?", closeModal: close, children: /* @__PURE__ */ jsxs27("div", { className: src_components_modal_warningSavePageModal_default.modalContent, children: [
    /* @__PURE__ */ jsxs27("p", { className: src_components_modal_warningSavePageModal_default.warningSavePageModalText, children: [
      'Cette page "',
      title,
      `" est actuellement en brouillon et vos modifications risquent d'\xEAtre perdues. Voulez-vous la sauvegarder ?`
    ] }),
    /* @__PURE__ */ jsxs27("div", { className: src_components_modal_warningSavePageModal_default.warningSavePageModalActions, children: [
      /* @__PURE__ */ jsx40(Button22, { type: "button", onClick: close, accent: "floating", children: "Ignorer" }),
      /* @__PURE__ */ jsx40(Button22, { type: "button", onClick: savePageModalClick, children: "Enregistrer la page" })
    ] })
  ] }) });
};
var warningSavePageModal_default = WarningSavePageModal;

// src/components/modal/index.jsx
import { Fragment as Fragment7, jsx as jsx41, jsxs as jsxs28 } from "react/jsx-runtime";
var Modal15 = () => {
  const closeModalEffectFn = useCustomEffect_default(closeModalEffect);
  const openModal = useSelector20(getOpenModal);
  const modalName = _44.get("name", openModal);
  const modalData = _44.getOr({}, "data", openModal);
  const open = _44.getOr(false, "open", openModal);
  const close = useCallback16(() => {
    closeModalEffectFn({ modalName });
  }, [closeModalEffectFn, modalName]);
  const modalProps = { close, ...modalData };
  useNavigationModalCloser_default({ closeModalEffect: closeModalEffectFn });
  return /* @__PURE__ */ jsx41("div", { children: open && /* @__PURE__ */ jsxs28(Fragment7, { children: [
    modalName === MODAL_PANORAMA && /* @__PURE__ */ jsx41(panoramaModal_default, { ...modalProps }),
    modalName === MODAL_AVAILABLE_SOON && /* @__PURE__ */ jsx41(availableSoonModal_default, { ...modalProps }),
    modalName === MODAL_TEACHER_BOOK_DETAIL && /* @__PURE__ */ jsx41(teacherBookDetailModal_default, { ...modalProps }),
    modalName === MODAL_NOT_TEASER && /* @__PURE__ */ jsx41(notTeaserModal_default, { ...modalProps }),
    modalName === MODAL_ONE_CLICK && /* @__PURE__ */ jsx41(oneClick_default, { ...modalProps }),
    modalName === MODAL_CONTACT && /* @__PURE__ */ jsx41(contactModal_default, { ...modalProps }),
    modalName === MODAL_NEWS && /* @__PURE__ */ jsx41(newsModal_default, { ...modalProps }),
    modalName === MODAL_TIP && /* @__PURE__ */ jsx41(tipModal_default, { ...modalProps }),
    modalName === MODAL_WARNING_SAVE_PAGE && /* @__PURE__ */ jsx41(warningSavePageModal_default, { ...modalProps }),
    modalName === MODAL_OPEN_ANSWERS && /* @__PURE__ */ jsx41(answersModal_default, { ...modalProps }),
    modalName === MODAL_OFFLINE && /* @__PURE__ */ jsx41(offlineModal_default, { ...modalProps }),
    modalName === MODAL_BOOK_RESOURCES && /* @__PURE__ */ jsx41(bookResourcesModal_default, { ...modalProps }),
    modalName === MODAL_NPS && /* @__PURE__ */ jsx41(npsModal_default, { ...modalProps }),
    modalName === MODAL_TRIAL_TIP && /* @__PURE__ */ jsx41(trialTipModal_default, { ...modalProps }),
    modalName === MODAL_ONBOARDING_CHOOSE_PROFILE && /* @__PURE__ */ jsx41(chooseProfileModal_default, { ...modalProps }),
    modalName === MODAL_ONBOARDING_CHOOSE_TOUR && /* @__PURE__ */ jsx41(chooseTourModal_default, { ...modalProps }),
    modalName === MODAL_TOURS_COMPLETED && /* @__PURE__ */ jsx41(toursCompletedModal_default, { ...modalProps }),
    modalName === MODAL_ONBOARDING_END && /* @__PURE__ */ jsx41(endOnboardingModal_default, { ...modalProps }),
    modalName === MODAL_ONBOARDING_EXPERT && /* @__PURE__ */ jsx41(onboardingExpertModal_default, { ...modalProps }),
    modalName === MODAL_ONBOARDING_ASK_FOR_TRAINING && /* @__PURE__ */ jsx41(askForTrainingModal_default, { ...modalProps }),
    modalName === MODAL_ONBOARDING_TRAINING_CONFIRMATION && /* @__PURE__ */ jsx41(trainingConfirmationModal_default, { ...modalProps }),
    modalName === MODAL_ONBOARDING_TRAINING_BOOKING && /* @__PURE__ */ jsx41(trainingBookingModal_default, { ...modalProps }),
    modalName === MODAL_TRIAL_FEATURE_BLOCKED && /* @__PURE__ */ jsx41(trialFeatureBlockedModal_default, { ...modalProps })
  ] }) });
};
var modal_default = Modal15;

// src/components/modal/trialWelcomeModal.jsx
init_es62();
init_actions();
init_analytics4();
init_constants();
init_trial2();
init_cookie();
import _45 from "lodash/fp.js";
import { useCallback as useCallback17, useState as useState12 } from "react";
import { useDispatch as useDispatch15, useSelector as useSelector21 } from "react-redux";
import { Button as Button23, Modal as Modal16, RadioButton } from "@lls/lls-kit";
import { getCurrentUser as getCurrentUser14 } from "@lls/store";
import { dispatchAnalyticsEvent as dispatchAnalyticsEvent11, hasWindowObject as hasWindowObject5 } from "@lls/utils";

// tmp_esbuild1736180049684/_src_components_modal_trialWelcomeModal.module.css
var src_components_modal_trialWelcomeModal_default = { "subText": "core-DLOMBW-subText", "journeyContainer": "core-DLOMBW-journeyContainer", "modal": "core-DLOMBW-modal", "journeyDescription": "core-DLOMBW-journeyDescription", "radio": "core-DLOMBW-radio", "modalContent": "core-DLOMBW-modalContent", "button": "core-DLOMBW-button", "imgContainer": "core-DLOMBW-imgContainer", "title": "core-DLOMBW-title", "container": "core-DLOMBW-container", "marker": "core-DLOMBW-marker permanentMarkerRegular", "img": "core-DLOMBW-img" };

// src/components/modal/trialWelcomeModal.jsx
import { jsx as jsx42, jsxs as jsxs29 } from "react/jsx-runtime";
var Journey = ({ selected, setSelected, id, title, description }) => /* @__PURE__ */ jsxs29("div", { className: src_components_modal_trialWelcomeModal_default.journeyContainer, onClick: () => setSelected(id), "data-selected": +selected, children: [
  /* @__PURE__ */ jsx42(RadioButton, { className: src_components_modal_trialWelcomeModal_default.radio, isChecked: selected, value: id, onChange: setSelected }),
  /* @__PURE__ */ jsxs29("div", { children: [
    title,
    /* @__PURE__ */ jsx42("div", { className: src_components_modal_trialWelcomeModal_default.journeyDescription, children: description })
  ] })
] });
var TrialWelcomeModal = () => {
  const [cookies, setCookie] = useCookies([COOKIE_TRIAL_JOURNEY]);
  const user = useSelector21(getCurrentUser14);
  const [selectedJourney, setSelectedJourney] = useState12();
  const dispatch = useDispatch15();
  const cookie3 = cookies == null ? void 0 : cookies[COOKIE_TRIAL_JOURNEY];
  const [hide4, setHide] = useState12(!!cookie3 || !(user == null ? void 0 : user.isTrial));
  const close = useCallback17(() => {
    var _a2;
    selectedJourney === JOURNEY_AUTONOMOUS && dispatch(setIsTourPanelOpen(false));
    setCookie(COOKIE_TRIAL_JOURNEY, selectedJourney, getCookieOptions());
    setHide(true);
    dispatchAnalyticsEvent11(ANALYTICS_EVENTS.TRIAL_STARTED, { extraData: (_a2 = _45.split("_", selectedJourney)) == null ? void 0 : _a2[1] });
  }, [setCookie, selectedJourney, dispatch]);
  return hide4 || !hasWindowObject5() ? null : /* @__PURE__ */ jsx42(Modal16, { className: src_components_modal_trialWelcomeModal_default.modal, closeModal: close, withCloseButton: false, closeOnMaskClick: false, children: /* @__PURE__ */ jsxs29("div", { className: src_components_modal_trialWelcomeModal_default.modalContent, children: [
    /* @__PURE__ */ jsxs29("div", { className: src_components_modal_trialWelcomeModal_default.imgContainer, children: [
      /* @__PURE__ */ jsx42("h1", { className: src_components_modal_trialWelcomeModal_default.marker, children: "Cette plateforme est exclusivement d\xE9di\xE9e \xE0 la d\xE9monstration. Certaines fonctionnalit\xE9s sont donc limit\xE9es." }),
      /* @__PURE__ */ jsx42("img", { className: src_components_modal_trialWelcomeModal_default.img, src: "/assets/img/modal/welcome_trial.webp", alt: "" })
    ] }),
    /* @__PURE__ */ jsxs29("div", { className: src_components_modal_trialWelcomeModal_default.container, children: [
      /* @__PURE__ */ jsx42("h1", { className: src_components_modal_trialWelcomeModal_default.title, children: "Bienvenue dans votre espace de d\xE9monstration !" }),
      /* @__PURE__ */ jsx42("p", { className: src_components_modal_trialWelcomeModal_default.subText, children: "Pour vous accompagner dans votre essai, nous avons imagin\xE9 3 parcours :" }),
      JOURNEYS.map((journey) => /* @__PURE__ */ jsx42(
        Journey,
        {
          selected: journey.id === selectedJourney,
          setSelected: setSelectedJourney,
          ...journey
        },
        journey.id
      )),
      /* @__PURE__ */ jsx42(Button23, { onClick: close, className: src_components_modal_trialWelcomeModal_default.button, disabled: !selectedJourney, children: "C'est parti !" })
    ] })
  ] }) });
};
var trialWelcomeModal_default = TrialWelcomeModal;

// src/components/navbar/index.jsx
import _50 from "lodash/fp.js";
import { useSelector as useSelector27 } from "react-redux";
import { useLocation as useLocation10 } from "react-router-dom";
import { Z_NAVBAR } from "@lls/lls-kit";
import { cx as cx4 } from "@lls/utils";

// src/components/navbar/navbarContent.tsx
init_link();
init_config();
init_store();
init_route();
import { Tag } from "@lls/lls-kit";
import { getAuth as getAuth4 } from "@lls/store";
import { getCurrentUser as getCurrentUser17 } from "@lls/store";
import { useSearchSchools } from "@lls/store";
import _49 from "lodash/fp.js";
import { SnowBall } from "@lls/superkit";

// tmp_esbuild1736180049684/_src_components_navbar_navbarContent.module.css
var src_components_navbar_navbarContent_default = { "navbar": "core-Eo5UPG-navbar", "flex": "core-Eo5UPG-flex", "logoLink": "core-Eo5UPG-logoLink", "snowBall": "core-Eo5UPG-snowBall", "img": "core-Eo5UPG-img", "snowBallWiggle": "core-Eo5UPG-snowBallWiggle", "tag": "core-Eo5UPG-tag" };

// src/components/navbar/premiumNavbar.jsx
init_config();

// src/components/navbar/items/accountButton.jsx
init_config();
init_actions();
init_constants();
init_user2();
init_useCustomEffect();
init_book3();
init_route();
init_style();
import _46 from "lodash/fp.js";
import { useCallback as useCallback18, useMemo as useMemo8 } from "react";
import { useDispatch as useDispatch16, useSelector as useSelector22 } from "react-redux";
import { useHistory as useHistory7, useLocation as useLocation8 } from "react-router-dom";
import { MenuButton } from "@lls/lls-kit";
import {
  ANALYTICS_LINK_CLICKED as ANALYTICS_LINK_CLICKED4,
  dispatchAnalyticsEvent as dispatchAnalyticsEvent12,
  displayUser as displayUser2,
  displayUserProfile,
  getQuizPath as getQuizPath2,
  openWindow as openWindow9,
  useUnderBreakpoint
} from "@lls/utils";

// tmp_esbuild1736180049684/_src_components_navbar_items_accountButton.module.css
var src_components_navbar_items_accountButton_default = { "menuButton": "core-b6L6TW-menuButton", "userProfile": "core-b6L6TW-userProfile", "navbarUsername": "core-b6L6TW-navbarUsername", "navbarUserProfile": "core-b6L6TW-navbarUserProfile" };

// src/components/navbar/items/accountButton.jsx
import { jsx as jsx43, jsxs as jsxs30 } from "react/jsx-runtime";
var AccountButton = ({ user, token }) => {
  var _a2, _b2;
  const dispatch = useDispatch16();
  const logoutEffectFn = useCustomEffect_default(logoutEffect);
  const history = useHistory7();
  const pathname = (_a2 = useLocation8()) == null ? void 0 : _a2.pathname;
  const bestMatchingBook = (_b2 = useSelector22(getBestMatchingBooksForUser)) == null ? void 0 : _b2[0];
  const hasTourBook = useSelector22(getHasTourBook);
  const openChooseTourModal = useCallback18(() => {
    !_46.overSome([matchBookPath, matchPagePath])(pathname) && history.push(getPath("book", { uri: bestMatchingBook == null ? void 0 : bestMatchingBook.uri }));
    dispatch(setModal({ name: MODAL_ONBOARDING_CHOOSE_TOUR, open: true }));
  }, [dispatch, bestMatchingBook, history, pathname]);
  const isMobile = useUnderBreakpoint(BREAKPOINT_PHABLET);
  const userListItems = useMemo8(
    () => _46.compact([
      {
        type: "component",
        content: /* @__PURE__ */ jsxs30("div", { className: src_components_navbar_items_accountButton_default.userProfile, children: [
          /* @__PURE__ */ jsx43("div", { className: src_components_navbar_items_accountButton_default.navbarUsername, "data-clarity-mask": "true", children: displayUser2(user) }),
          /* @__PURE__ */ jsx43("div", { className: src_components_navbar_items_accountButton_default.navbarUserProfile, children: displayUserProfile(user) })
        ] })
      },
      {
        type: "divider"
      },
      (user == null ? void 0 : user.isStudent) ? void 0 : {
        msg: "Livre du professeur",
        icon: "teacherbook",
        onClick: () => {
          dispatchAnalyticsEvent12(ANALYTICS_LINK_CLICKED4, {
            featureName: "LDP",
            extraData: "LDP_profil"
          });
          openWindow9(getPath("teacher_book"), "_blank");
        }
      },
      {
        msg: "Chronoquiz",
        icon: "chronoquiz",
        onClick: () => {
          openWindow9(getQuizPath2({ baseUrl: config_default.quiz_url, user, token }), "_blank");
        }
      },
      {
        type: "divider"
      },
      (user == null ? void 0 : user.isTrial) ? void 0 : {
        msg: "Mon compte",
        icon: "personfilled",
        onClick: () => {
          history.push(getPath("profile"));
        }
      },
      isMobile || !(user == null ? void 0 : user.isTeacher) || !hasTourBook ? void 0 : {
        msg: "Parcours de d\xE9couverte",
        icon: "explorefilled",
        onClick: openChooseTourModal
      },
      {
        msg: "Aide & Support",
        icon: "questionmarkcircle",
        onClick: () => {
          openWindow9("https://lls.fr/faq", "_blank");
        }
      },
      {
        type: "divider"
      },
      {
        msg: "Se d\xE9connecter",
        icon: "logout",
        onClick: () => {
          logoutEffectFn({ user });
        }
      }
    ]),
    [hasTourBook, user, isMobile, openChooseTourModal, token, history, logoutEffectFn]
  );
  return /* @__PURE__ */ jsx43(
    MenuButton,
    {
      className: src_components_navbar_items_accountButton_default.menuButton,
      position: "bottom",
      icon: "person",
      theme: "gray",
      accent: "main",
      listItems: userListItems,
      fixed: true
    }
  );
};
var accountButton_default = AccountButton;

// src/components/navbar/items/booksButton.jsx
init_route();
import { useHistory as useHistory8 } from "react-router-dom";

// src/components/navbar/items/common.jsx
import { Button as Button24, MenuButton as MenuButton2 } from "@lls/lls-kit";
import { makeComponent as makeComponent3 } from "@lls/utils";

// tmp_esbuild1736180049684/_src_components_navbar_items_common.module.css
var src_components_navbar_items_common_default = { "button": "core-mGv14W-button", "mobileButton": "core-mGv14W-mobileButton", "li": "core-mGv14W-li", "navItems": "core-mGv14W-navItems latoWebBold" };

// src/components/navbar/items/common.jsx
var StyledLi = makeComponent3("li", src_components_navbar_items_common_default.li);
var StyledButton = makeComponent3(Button24, src_components_navbar_items_common_default.button);
var StyledMobileButton = makeComponent3(Button24, src_components_navbar_items_common_default.mobileButton);
var StyledMenuButton = makeComponent3(MenuButton2, src_components_navbar_items_common_default.button);
var StyledMobileMenuButton = makeComponent3(MenuButton2, src_components_navbar_items_common_default.mobileButton);
var StyledNavItems = makeComponent3("ul", src_components_navbar_items_common_default.navItems);

// src/components/navbar/items/booksButton.jsx
import { jsx as jsx44, jsxs as jsxs31 } from "react/jsx-runtime";
var BooksButton = () => {
  const history = useHistory8();
  const goToMyBooks = () => {
    history.push(getPath("my-books"));
  };
  return /* @__PURE__ */ jsxs31(StyledLi, { onClick: goToMyBooks, children: [
    /* @__PURE__ */ jsx44(StyledButton, { accent: "floating", theme: "gray", icon: "booksfilled", size: "big", children: "Mes manuels" }),
    /* @__PURE__ */ jsx44(StyledMobileButton, { accent: "floating", theme: "gray", icon: "booksfilled", size: "big" })
  ] });
};
var booksButton_default = BooksButton;

// src/components/navbar/items/groupsButton.jsx
init_ui2();
init_route();
import { useSelector as useSelector23 } from "react-redux";
import { useHistory as useHistory9 } from "react-router-dom";
import { jsx as jsx45, jsxs as jsxs32 } from "react/jsx-runtime";
var GroupsButton = ({ user }) => {
  const history = useHistory9();
  const isStudentViewActivated = useSelector23(getUiIsStudentViewActivated);
  const goToMySchoolClasses = () => {
    history.push(getPath("classroom_settings"));
  };
  return (user == null ? void 0 : user.isTeacher) && /* @__PURE__ */ jsxs32(StyledLi, { children: [
    /* @__PURE__ */ jsx45(
      StyledButton,
      {
        accent: "floating",
        theme: "gray",
        icon: "groupfilled",
        size: "big",
        onClick: goToMySchoolClasses,
        disabled: isStudentViewActivated,
        children: "Mes classes"
      }
    ),
    /* @__PURE__ */ jsx45(
      StyledMobileButton,
      {
        accent: "floating",
        theme: "gray",
        icon: "groupfilled",
        size: "big",
        onClick: goToMySchoolClasses,
        disabled: isStudentViewActivated
      }
    )
  ] });
};
var groupsButton_default = GroupsButton;

// src/components/navbar/items/learningAssessmentButton.jsx
init_route();
import { useHistory as useHistory10 } from "react-router-dom";
import { jsx as jsx46, jsxs as jsxs33 } from "react/jsx-runtime";
var LearningAssessmentButton = () => {
  const history = useHistory10();
  const goToLearningAssessment = () => history.push(getPath("learning_assessment"));
  return /* @__PURE__ */ jsxs33(StyledLi, { children: [
    /* @__PURE__ */ jsx46(
      StyledButton,
      {
        accent: "floating",
        theme: "gray",
        icon: "gift",
        size: "big",
        onClick: goToLearningAssessment,
        "data-tour": "core-revision-button",
        children: "Suivi des acquis"
      }
    ),
    /* @__PURE__ */ jsx46(StyledMobileButton, { accent: "floating", theme: "gray", icon: "gift", size: "big", onClick: goToLearningAssessment })
  ] });
};
var learningAssessmentButton_default = LearningAssessmentButton;

// src/components/notificationsMenu.jsx
init_analytics4();
init_notification3();
init_user2();
init_useCustomEffect();
import _47 from "lodash/fp.js";
import { useCallback as useCallback19 } from "react";
import { useSelector as useSelector24 } from "react-redux";
import { getAuth as getAuth3 } from "@lls/store";
import { getMainNotifications } from "@lls/store";
import { getCurrentUser as getCurrentUser15 } from "@lls/store";
import { NotificationMenu } from "@lls/superkit";
import { dispatchAnalyticsEvent as dispatchAnalyticsEvent13, openWindow as openWindow10 } from "@lls/utils";

// tmp_esbuild1736180049684/_src_components_notificationsMenu.module.css
var src_components_notificationsMenu_default = { "notificationMenu": "core-P1drTa-notificationMenu" };

// src/components/notificationsMenu.jsx
import { Fragment as Fragment8, jsx as jsx47 } from "react/jsx-runtime";
var NotificationsMenu = ({ inverted = false }) => {
  const notifications2 = useSelector24(getMainNotifications);
  const user = useSelector24(getCurrentUser15);
  const auth2 = useSelector24(getAuth3);
  const token = _47.get("token", auth2);
  const updateLastActivitySeenAtEffectFn = useCustomEffect_default(updateLastActivitySeenAtEffect);
  const markNotificationAsReadEffectFn = useCustomEffect_default(markNotificationAsReadEffect);
  const onNotificationClick = useCallback19(
    (notification) => {
      const redirection = _47.get("content.url", notification);
      const notificationType = _47.get("type", notification);
      openWindow10(redirection, "_blank");
      markNotificationAsReadEffectFn({ token, notification });
      dispatchAnalyticsEvent13(ANALYTICS_EVENTS.LINK_CLICKED, {
        featureName: "notification",
        resourceId: [redirection],
        extraData: notificationType
      });
    },
    [token, markNotificationAsReadEffectFn]
  );
  const onNotificationOpen = useCallback19(() => {
    updateLastActivitySeenAtEffectFn({ token });
    dispatchAnalyticsEvent13(ANALYTICS_EVENTS.LINK_CLICKED, { featureName: "notification_menu" });
  }, [updateLastActivitySeenAtEffectFn, token]);
  return /* @__PURE__ */ jsx47(Fragment8, { children: /* @__PURE__ */ jsx47(
    NotificationMenu,
    {
      className: src_components_notificationsMenu_default.notificationMenu,
      notifications: notifications2,
      user,
      onOpen: onNotificationOpen,
      onNotificationClick,
      inverted
    }
  ) });
};
var notificationsMenu_default = NotificationsMenu;

// tmp_esbuild1736180049684/_src_components_navbar_items_notificationButton.module.css
var src_components_navbar_items_notificationButton_default = { "li": "core-3pLQaG-li" };

// src/components/navbar/items/notificationButton.jsx
import { jsx as jsx48 } from "react/jsx-runtime";
var NotificationButton = () => {
  return /* @__PURE__ */ jsx48("li", { className: src_components_navbar_items_notificationButton_default.li, children: /* @__PURE__ */ jsx48(notificationsMenu_default, {}) });
};
var notificationButton_default = NotificationButton;

// src/components/navbar/items/resourceButton.jsx
init_ui2();
init_route();
import { useCallback as useCallback20, useMemo as useMemo9 } from "react";
import { useSelector as useSelector25 } from "react-redux";
import { useHistory as useHistory11 } from "react-router-dom";
import { Button as Button25 } from "@lls/lls-kit";
import { openWindow as openWindow11 } from "@lls/utils";
import { jsx as jsx49, jsxs as jsxs34 } from "react/jsx-runtime";
var ItemComponent = ({ onClick, title, icon, disabled = false, others }) => /* @__PURE__ */ jsx49(Button25, { icon, disabled, onClick, accent: "floating", theme: "gray", ...others, children: title });
var ResourceButton = ({ canAccessLearningAssessment }) => {
  const history = useHistory11();
  const isStudentViewActivated = useSelector25(getUiIsStudentViewActivated);
  const goToResource = useCallback20(() => openWindow11(getPath("explorer")), []);
  const goToRevision = useCallback20(() => history.push(getPath("revision")), [history]);
  const goToLearningAssessment = useCallback20(() => history.push(getPath("learning_assessment")), [history]);
  const items = useMemo9(
    () => [
      {
        type: "component",
        content: /* @__PURE__ */ jsx49(ItemComponent, { onClick: goToResource, title: "Explorateur", icon: "explore", disabled: isStudentViewActivated })
      },
      {
        type: "component",
        content: /* @__PURE__ */ jsx49(
          ItemComponent,
          {
            onClick: goToRevision,
            title: "R\xE9visions",
            icon: "help",
            others: {
              "data-tour": "core-revision-button"
            }
          }
        )
      },
      ...canAccessLearningAssessment ? [
        {
          type: "component",
          content: /* @__PURE__ */ jsx49(ItemComponent, { onClick: goToLearningAssessment, title: "Suivi des acquis", icon: "gift" })
        }
      ] : []
    ],
    [goToResource, goToRevision, goToLearningAssessment, canAccessLearningAssessment, isStudentViewActivated]
  );
  return /* @__PURE__ */ jsxs34(StyledLi, { children: [
    /* @__PURE__ */ jsx49(
      StyledMenuButton,
      {
        alignment: "end",
        theme: "gray",
        accent: "floating",
        icon: "carretdown",
        iconPosition: "right",
        position: "bottom",
        fixed: true,
        listItems: items,
        children: "Outils"
      }
    ),
    /* @__PURE__ */ jsx49(
      StyledMobileMenuButton,
      {
        alignment: "end",
        theme: "gray",
        accent: "floating",
        icon: "tools",
        iconPosition: "right",
        position: "bottom",
        fixed: true,
        listItems: items
      }
    )
  ] });
};
var resourceButton_default = ResourceButton;

// src/components/navbar/items/revisionButton.jsx
init_route();
import { useHistory as useHistory12 } from "react-router-dom";
import { jsx as jsx50, jsxs as jsxs35 } from "react/jsx-runtime";
var RevisionButton = () => {
  const history = useHistory12();
  const goToRevision = () => history.push(getPath("revision"));
  return /* @__PURE__ */ jsxs35(StyledLi, { children: [
    /* @__PURE__ */ jsx50(
      StyledButton,
      {
        accent: "floating",
        theme: "gray",
        icon: "schoolbag",
        size: "big",
        onClick: goToRevision,
        "data-tour": "core-revision-button",
        children: "R\xE9visions"
      }
    ),
    /* @__PURE__ */ jsx50(StyledMobileButton, { accent: "floating", theme: "gray", icon: "schoolbag", size: "big", onClick: goToRevision })
  ] });
};
var revisionButton_default = RevisionButton;

// src/components/navbar/premiumNavbar.jsx
import { jsx as jsx51, jsxs as jsxs36 } from "react/jsx-runtime";
var PremiumNavbar = ({ user, token, canAccessLearningAssessment }) => {
  return /* @__PURE__ */ jsxs36(StyledNavItems, { children: [
    /* @__PURE__ */ jsx51(booksButton_default, {}),
    !config_default.feature_exploration && /* @__PURE__ */ jsx51(revisionButton_default, {}),
    !config_default.feature_exploration && canAccessLearningAssessment && /* @__PURE__ */ jsx51(learningAssessmentButton_default, {}),
    /* @__PURE__ */ jsx51(groupsButton_default, { user }),
    config_default.feature_exploration && /* @__PURE__ */ jsx51(resourceButton_default, { canAccessLearningAssessment }),
    /* @__PURE__ */ jsx51(notificationButton_default, {}),
    /* @__PURE__ */ jsx51(accountButton_default, { user, token })
  ] });
};
var premiumNavbar_default = PremiumNavbar;

// src/components/navbar/trialNavbar.jsx
init_user2();
init_useCustomEffect();
import { Button as Button26 } from "@lls/lls-kit";

// src/components/navbar/items/userTypeSelector.jsx
init_actions();
init_analytics4();
init_tour2();
init_trial2();
init_user2();
init_utils3();
init_useCustomEffect();
init_useTour();
init_book3();
init_ui2();
init_route();
import _48 from "lodash/fp.js";
import { useCallback as useCallback21 } from "react";
import { useDispatch as useDispatch17, useSelector as useSelector26 } from "react-redux";
import { useHistory as useHistory13, useLocation as useLocation9 } from "react-router-dom";
import { SelectField as SelectField3 } from "@lls/lls-kit";
import { getToken as getToken8 } from "@lls/store";
import { getPage as getPage2 } from "@lls/store";
import { getCurrentUser as getCurrentUser16 } from "@lls/store";
import { dispatchAnalyticsEvent as dispatchAnalyticsEvent14 } from "@lls/utils";

// tmp_esbuild1736180049684/_src_components_navbar_items_userTypeSelector.module.css
var src_components_navbar_items_userTypeSelector_default = { "selectFieldContainer": "core-HVKcNG-selectFieldContainer" };

// src/components/navbar/items/userTypeSelector.jsx
import { jsx as jsx52 } from "react/jsx-runtime";
var UserTypeSelector = () => {
  var _a2;
  const { sendEvent: sendEvent2 } = useTour_default();
  const dispatch = useDispatch17();
  const location = useLocation9();
  const history = useHistory13();
  const isStudentViewActivated = useSelector26(getUiIsStudentViewActivated);
  const currentUser = useSelector26(getCurrentUser16);
  const book = (_a2 = useSelector26(getBestMatchingBooksForUser)) == null ? void 0 : _a2[0];
  const page = useSelector26((state) => getPage2(state, book == null ? void 0 : book.firstValidPage));
  const token = useSelector26(getToken8);
  const updateTrialUserStatsEffectFn = useCustomEffect_default(updateTrialUserStatsEffect);
  const onClick = useCallback21(
    (value) => {
      var _a3;
      const isStudent = value === "student";
      dispatchAnalyticsEvent14(ANALYTICS_EVENTS.FAKE_PROFILE_CHANGED, {
        bookId: book == null ? void 0 : book.id,
        pageId: page == null ? void 0 : page.id,
        featureName: isStudent ? "view_student" : "view_teacher"
      });
      dispatch(setIsStudentViewActivated(isStudent));
      sendEvent2(TOUR_EVENTS.TEACHER_STUDENT_SWITCH);
      if (isStudent) {
        const shouldRedirect = _48.overSome(_48.map(_48.startsWith, STUDENT_VIEW_FORBIDDEN_ROUTES))(location == null ? void 0 : location.pathname);
        triggerNotification({ name: "change_view", dispatch, params: { isRedirect: shouldRedirect } });
        shouldRedirect && history.push(page ? getPath("page", { slug: page.slug }) : getPath("home"));
      }
      if (isStudent && !((_a3 = currentUser == null ? void 0 : currentUser.trialStats) == null ? void 0 : _a3.hasUsedTeacherStudentSwitch))
        updateTrialUserStatsEffectFn({ trialStats: { hasUsedTeacherStudentSwitch: true }, token });
    },
    [dispatch, sendEvent2, currentUser, token, updateTrialUserStatsEffectFn, location, history, page, book == null ? void 0 : book.id]
  );
  return /* @__PURE__ */ jsx52("div", { className: src_components_navbar_items_userTypeSelector_default.selectFieldContainer, "data-tour": "premium-switch-student-teacher", children: /* @__PURE__ */ jsx52(
    SelectField3,
    {
      onChange: onClick,
      icon: "personfilled",
      options: [
        { value: "teacher", label: "Professeur" },
        { value: "student", label: "\xC9l\xE8ve" }
      ],
      value: isStudentViewActivated ? "student" : "teacher"
    }
  ) });
};
var userTypeSelector_default = UserTypeSelector;

// tmp_esbuild1736180049684/_src_components_navbar_trialNavbar.module.css
var src_components_navbar_trialNavbar_default = { "button": "core-htyRba-button" };

// src/components/navbar/trialNavbar.jsx
import { jsx as jsx53, jsxs as jsxs37 } from "react/jsx-runtime";
var TrialNavbar = ({ user }) => {
  const logoutEffectFn = useCustomEffect_default(logoutEffect);
  return /* @__PURE__ */ jsxs37(StyledNavItems, { children: [
    /* @__PURE__ */ jsx53(booksButton_default, {}),
    /* @__PURE__ */ jsx53(groupsButton_default, { user }),
    /* @__PURE__ */ jsx53(userTypeSelector_default, {}),
    /* @__PURE__ */ jsx53("div", { className: src_components_navbar_trialNavbar_default.button, children: /* @__PURE__ */ jsx53(Button26, { onClick: () => logoutEffectFn({ user }), accent: "floating", theme: "gray", children: "D\xE9connexion" }) })
  ] });
};
var trialNavbar_default = TrialNavbar;

// src/components/navbar/navbarContent.tsx
import { jsx as jsx54, jsxs as jsxs38 } from "react/jsx-runtime";
var NavbarContent = () => {
  const user = useMySelector(getCurrentUser17);
  const auth2 = useMySelector(getAuth4);
  const token = _49.get("token", auth2);
  const schools = useSearchSchools({ ids: user == null ? void 0 : user.schools });
  const canAccessLearningAssessment = _49.flow(
    _49.flatMap("validLicenses"),
    _49.some({ isEnabledForLearningAssessment: true })
  )(schools);
  return /* @__PURE__ */ jsxs38("nav", { className: src_components_navbar_navbarContent_default.navbar, children: [
    /* @__PURE__ */ jsxs38("div", { className: src_components_navbar_navbarContent_default.flex, children: [
      /* @__PURE__ */ jsxs38(link_default, { className: src_components_navbar_navbarContent_default.logoLink, to: getPath("home"), children: [
        /* @__PURE__ */ jsx54("div", { className: src_components_navbar_navbarContent_default.img, "data-ischristmas": +config_default.feature_is_christmas }),
        (user == null ? void 0 : user.isTrial) && /* @__PURE__ */ jsx54(Tag, { theme: "premium", inverted: true, className: src_components_navbar_navbarContent_default.tag, children: "Espace D\xE9mo" })
      ] }),
      config_default.feature_is_christmas && /* @__PURE__ */ jsx54(SnowBall, {})
    ] }),
    (user == null ? void 0 : user.isTrial) ? /* @__PURE__ */ jsx54(trialNavbar_default, { user }) : /* @__PURE__ */ jsx54(premiumNavbar_default, { canAccessLearningAssessment, user, token })
  ] });
};
var navbarContent_default = NavbarContent;

// src/components/navbar/index.jsx
init_ui3();
init_route();
init_style();
import { getCurrentUser as getCurrentUser18 } from "@lls/store";

// tmp_esbuild1736180049684/_src_components_navbar_index.module.css
var src_components_navbar_index_default = { "navbar": "core-5xmeXW-navbar" };

// src/components/navbar/index.jsx
import { jsx as jsx55 } from "react/jsx-runtime";
var Navbar = () => {
  const { pathname } = useLocation10();
  const user = useSelector27(getCurrentUser18);
  return _50.isEmpty(user) || shouldHideNavbar(pathname) ? null : /* @__PURE__ */ jsx55(
    "div",
    {
      style: { "--cr-navbar-height": `${NAVBAR_HEIGHT}px`, "--cr-z-navbar": Z_NAVBAR },
      className: cx4(getDarkClassNames(), src_components_navbar_index_default.navbar),
      children: /* @__PURE__ */ jsx55(navbarContent_default, {})
    }
  );
};
var navbar_default = Navbar;

// src/components/notification/index.jsx
init_actions();

// src/components/notification/modalNotification.jsx
import { NotificationModal } from "@lls/superkit";
import _51 from "lodash/fp.js";

// tmp_esbuild1736180049684/_src_components_notification_modalNotification.module.css
var src_components_notification_modalNotification_default = { "subtitle": "core-WNpaMG-subtitle" };

// src/components/notification/modalNotification.jsx
import { jsx as jsx56, jsxs as jsxs39 } from "react/jsx-runtime";
var ModalNotificationComponent = ({ notification, onClose }) => /* @__PURE__ */ jsxs39(
  NotificationModal,
  {
    message: _51.get("message", notification),
    title: _51.get("params.title", notification),
    onClose,
    children: [
      " ",
      /* @__PURE__ */ jsx56("span", { className: src_components_notification_modalNotification_default.subtitle, children: _51.get("params.subtitle", notification) })
    ]
  }
);
var modalNotification_default = ModalNotificationComponent;

// src/components/notification/snackbarNotification.jsx
import { Snackbar } from "@lls/lls-kit";
import _52 from "lodash/fp.js";
import { useCallback as useCallback22 } from "react";
import { jsx as jsx57 } from "react/jsx-runtime";
var SnackbarNotification = ({ notification, onClose }) => {
  const handleClose = useCallback22(() => {
    onClose(notification);
  }, [notification, onClose]);
  const params = _52.get("params", notification);
  const message = _52.get("message", notification);
  const severity = _52.get("severity", notification);
  return /* @__PURE__ */ jsx57(Snackbar, { open: true, close: handleClose, severity, message, ...params });
};
var snackbarNotification_default = SnackbarNotification;

// src/components/notification/index.jsx
init_constants();

// src/selectors/notificationUi.ts
import { makeUseSearch } from "@lls/store";
import { createSearchSelector, filterEntitiesSimpleFieldByValues } from "@lls/utils";
import _53 from "lodash/fp.js";
var makeSearchNotifications = () => createSearchSelector(
  (state) => state == null ? void 0 : state.notifications,
  (_state, params) => params,
  (notifications2, { types }) => _53.flow(filterEntitiesSimpleFieldByValues("type", types))(notifications2)
);
var useSearchNotifications = makeUseSearch(makeSearchNotifications);

// src/components/notification/index.jsx
import _54 from "lodash/fp.js";
import { useCallback as useCallback23 } from "react";
import { useDispatch as useDispatch18 } from "react-redux";
import { Fragment as Fragment9, jsx as jsx58 } from "react/jsx-runtime";
var map2 = _54.map.convert({ cap: false });
var Notifications = () => {
  const notifications2 = useSearchNotifications({ types: [SNACKBAR_NOTIFICATION, MODAL_NOTIFICATION] });
  const dispatch = useDispatch18();
  const onClose = useCallback23(
    (notification) => {
      dispatch(removeNotification(notification));
    },
    [dispatch]
  );
  return /* @__PURE__ */ jsx58(Fragment9, { children: map2((notification, i) => {
    const Notification = _54.matches({ type: MODAL_NOTIFICATION }, notification) ? modalNotification_default : snackbarNotification_default;
    return /* @__PURE__ */ jsx58(Notification, { notification, onClose }, i);
  }, notifications2) });
};
var notification_default = Notifications;

// src/components/scrollToTop.jsx
init_route();
import { useEffect as useEffect14 } from "react";
import { useLocation as useLocation11 } from "react-router-dom";
function ScrollToTop() {
  const { pathname } = useLocation11();
  useEffect14(() => {
    shouldScrollToTop(pathname) && window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

// src/components/tour/index.jsx
import { useSelector as useSelector30 } from "react-redux";
import { useLocation as useLocation13 } from "react-router-dom";
import _60 from "lodash/fp.js";

// src/components/tour/tourComponent.tsx
import { useCallback as useCallback26, useEffect as useEffect19, useMemo as useMemo12, useRef as useRef11, useState as useState15 } from "react";

// ../../node_modules/.pnpm/@floating-ui+react@0.26.24_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@floating-ui/react/dist/floating-ui.react.mjs
import * as React7 from "react";
import { useLayoutEffect as useLayoutEffect3, useEffect as useEffect17, useRef as useRef9 } from "react";

// ../../node_modules/.pnpm/@floating-ui+utils@0.2.8/node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
function hasWindow() {
  return typeof window !== "undefined";
}
function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || "").toLowerCase();
  }
  return "#document";
}
function getWindow4(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Node || value instanceof getWindow4(value).Node;
}
function isElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Element || value instanceof getWindow4(value).Element;
}
function isHTMLElement2(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof HTMLElement || value instanceof getWindow4(value).HTMLElement;
}
function isShadowRoot(value) {
  if (!hasWindow() || typeof ShadowRoot === "undefined") {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow4(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !["inline", "contents"].includes(display);
}
function isTableElement(element) {
  return ["table", "td", "th"].includes(getNodeName(element));
}
function isTopLayer(element) {
  return [":popover-open", ":modal"].some((selector) => {
    try {
      return element.matches(selector);
    } catch (e) {
      return false;
    }
  });
}
function isContainingBlock(elementOrCss) {
  const webkit = isWebKit();
  const css = isElement(elementOrCss) ? getComputedStyle(elementOrCss) : elementOrCss;
  return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || ["transform", "perspective", "filter"].some((value) => (css.willChange || "").includes(value)) || ["paint", "layout", "strict", "content"].some((value) => (css.contain || "").includes(value));
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement2(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else if (isTopLayer(currentNode)) {
      return null;
    }
    currentNode = getParentNode(currentNode);
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === "undefined" || !CSS.supports) return false;
  return CSS.supports("-webkit-backdrop-filter", "none");
}
function isLastTraversableNode(node) {
  return ["html", "body", "#document"].includes(getNodeName(node));
}
function getComputedStyle(element) {
  return getWindow4(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.scrollX,
    scrollTop: element.scrollY
  };
}
function getParentNode(node) {
  if (getNodeName(node) === "html") {
    return node;
  }
  const result = (
    // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot(node) && node.host || // Fallback.
    getDocumentElement(node)
  );
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement2(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow4(scrollableAncestor);
  if (isBody) {
    const frameElement = getFrameElement(win);
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
  return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

// ../../node_modules/.pnpm/@floating-ui+utils@0.2.8/node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
var sides = ["top", "right", "bottom", "left"];
var min = Math.min;
var max = Math.max;
var round = Math.round;
var floor = Math.floor;
var createCoords = (v) => ({
  x: v,
  y: v
});
var oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
var oppositeAlignmentMap = {
  start: "end",
  end: "start"
};
function clamp(start, value, end) {
  return max(start, min(value, end));
}
function evaluate(value, param) {
  return typeof value === "function" ? value(param) : value;
}
function getSide(placement) {
  return placement.split("-")[0];
}
function getAlignment(placement) {
  return placement.split("-")[1];
}
function getOppositeAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function getAxisLength(axis) {
  return axis === "y" ? "height" : "width";
}
function getSideAxis(placement) {
  return ["top", "bottom"].includes(getSide(placement)) ? "y" : "x";
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, (alignment) => oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
  const lr = ["left", "right"];
  const rl = ["right", "left"];
  const tb = ["top", "bottom"];
  const bt = ["bottom", "top"];
  switch (side) {
    case "top":
    case "bottom":
      if (rtl) return isStart ? rl : lr;
      return isStart ? lr : rl;
    case "left":
    case "right":
      return isStart ? tb : bt;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide(placement), direction === "start", rtl);
  if (alignment) {
    list = list.map((side) => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, (side) => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getPaddingObject(padding) {
  return typeof padding !== "number" ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  const {
    x,
    y,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y,
    left: x,
    right: x + width,
    bottom: y + height,
    x,
    y
  };
}

// ../../node_modules/.pnpm/@floating-ui+react@0.26.24_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@floating-ui/react/dist/floating-ui.react.mjs
import * as ReactDOM2 from "react-dom";

// ../../node_modules/.pnpm/@floating-ui+core@1.6.8/node_modules/@floating-ui/core/dist/floating-ui.core.mjs
function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === "y";
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case "top":
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case "bottom":
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case "right":
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case "left":
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case "start":
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case "end":
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}
var computePosition = async (reference, floating, config2) => {
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware = [],
    platform: platform2
  } = config2;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(floating));
  let rects = await platform2.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x,
    y
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i = 0; i < validMiddleware.length; i++) {
    const {
      name,
      fn
    } = validMiddleware[i];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform: platform2,
      elements: {
        reference,
        floating
      }
    });
    x = nextX != null ? nextX : x;
    y = nextY != null ? nextY : y;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === "object") {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform2.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x,
          y
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
    }
  }
  return {
    x,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};
async function detectOverflow(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x,
    y,
    platform: platform2,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = "clippingAncestors",
    rootBoundary = "viewport",
    elementContext = "floating",
    altBoundary = false,
    padding = 0
  } = evaluate(options, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === "floating" ? "reference" : "floating";
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform2.getClippingRect({
    element: ((_await$platform$isEle = await (platform2.isElement == null ? void 0 : platform2.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform2.getDocumentElement == null ? void 0 : platform2.getDocumentElement(elements.floating)),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === "floating" ? {
    x,
    y,
    width: rects.floating.width,
    height: rects.floating.height
  } : rects.reference;
  const offsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(elements.floating));
  const offsetScale = await (platform2.isElement == null ? void 0 : platform2.isElement(offsetParent)) ? await (platform2.getScale == null ? void 0 : platform2.getScale(offsetParent)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform2.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform2.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}
var arrow = (options) => ({
  name: "arrow",
  options,
  async fn(state) {
    const {
      x,
      y,
      placement,
      rects,
      platform: platform2,
      elements,
      middlewareData
    } = state;
    const {
      element,
      padding = 0
    } = evaluate(options, state) || {};
    if (element == null) {
      return {};
    }
    const paddingObject = getPaddingObject(padding);
    const coords = {
      x,
      y
    };
    const axis = getAlignmentAxis(placement);
    const length = getAxisLength(axis);
    const arrowDimensions = await platform2.getDimensions(element);
    const isYAxis = axis === "y";
    const minProp = isYAxis ? "top" : "left";
    const maxProp = isYAxis ? "bottom" : "right";
    const clientProp = isYAxis ? "clientHeight" : "clientWidth";
    const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
    if (!clientSize || !await (platform2.isElement == null ? void 0 : platform2.isElement(arrowOffsetParent))) {
      clientSize = elements.floating[clientProp] || rects.floating[length];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
    const minPadding = min(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = min(paddingObject[maxProp], largestPossiblePadding);
    const min$1 = minPadding;
    const max2 = clientSize - arrowDimensions[length] - maxPadding;
    const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset4 = clamp(min$1, center, max2);
    const shouldAddOffset = !middlewareData.arrow && getAlignment(placement) != null && center !== offset4 && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max2 : 0;
    return {
      [axis]: coords[axis] + alignmentOffset,
      data: {
        [axis]: offset4,
        centerOffset: center - offset4 - alignmentOffset,
        ...shouldAddOffset && {
          alignmentOffset
        }
      },
      reset: shouldAddOffset
    };
  }
});
var flip = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "flip",
    options,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform: platform2,
        elements
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = "bestFit",
        fallbackAxisSideDirection = "none",
        flipAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = getSide(placement);
      const initialSideAxis = getSideAxis(initialPlacement);
      const isBasePlacement = getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
      if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements2 = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides2 = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides2[0]], overflow[sides2[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];
      if (!overflows.every((side2) => side2 <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements2[nextIndex];
        if (nextPlacement) {
          return {
            data: {
              index: nextIndex,
              overflows: overflowsData
            },
            reset: {
              placement: nextPlacement
            }
          };
        }
        let resetPlacement = (_overflowsData$filter = overflowsData.filter((d) => d.overflows[0] <= 0).sort((a, b) => a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case "bestFit": {
              var _overflowsData$filter2;
              const placement2 = (_overflowsData$filter2 = overflowsData.filter((d) => {
                if (hasFallbackAxisSideDirection) {
                  const currentSideAxis = getSideAxis(d.placement);
                  return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  currentSideAxis === "y";
                }
                return true;
              }).map((d) => [d.placement, d.overflows.filter((overflow2) => overflow2 > 0).reduce((acc, overflow2) => acc + overflow2, 0)]).sort((a, b) => a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
              if (placement2) {
                resetPlacement = placement2;
              }
              break;
            }
            case "initialPlacement":
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};
function getSideOffsets(overflow, rect) {
  return {
    top: overflow.top - rect.height,
    right: overflow.right - rect.width,
    bottom: overflow.bottom - rect.height,
    left: overflow.left - rect.width
  };
}
function isAnySideFullyClipped(overflow) {
  return sides.some((side) => overflow[side] >= 0);
}
var hide = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "hide",
    options,
    async fn(state) {
      const {
        rects
      } = state;
      const {
        strategy = "referenceHidden",
        ...detectOverflowOptions
      } = evaluate(options, state);
      switch (strategy) {
        case "referenceHidden": {
          const overflow = await detectOverflow(state, {
            ...detectOverflowOptions,
            elementContext: "reference"
          });
          const offsets = getSideOffsets(overflow, rects.reference);
          return {
            data: {
              referenceHiddenOffsets: offsets,
              referenceHidden: isAnySideFullyClipped(offsets)
            }
          };
        }
        case "escaped": {
          const overflow = await detectOverflow(state, {
            ...detectOverflowOptions,
            altBoundary: true
          });
          const offsets = getSideOffsets(overflow, rects.floating);
          return {
            data: {
              escapedOffsets: offsets,
              escaped: isAnySideFullyClipped(offsets)
            }
          };
        }
        default: {
          return {};
        }
      }
    }
  };
};
async function convertValueToCoords(state, options) {
  const {
    placement,
    platform: platform2,
    elements
  } = state;
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
  const side = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getSideAxis(placement) === "y";
  const mainAxisMulti = ["left", "top"].includes(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = evaluate(options, state);
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === "number" ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: rawValue.mainAxis || 0,
    crossAxis: rawValue.crossAxis || 0,
    alignmentAxis: rawValue.alignmentAxis
  };
  if (alignment && typeof alignmentAxis === "number") {
    crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}
var offset = function(options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: "offset",
    options,
    async fn(state) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x,
        y,
        placement,
        middlewareData
      } = state;
      const diffCoords = await convertValueToCoords(state, options);
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x + diffCoords.x,
        y: y + diffCoords.y,
        data: {
          ...diffCoords,
          placement
        }
      };
    }
  };
};
var shift = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "shift",
    options,
    async fn(state) {
      const {
        x,
        y,
        placement
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: (_ref) => {
            let {
              x: x2,
              y: y2
            } = _ref;
            return {
              x: x2,
              y: y2
            };
          }
        },
        ...detectOverflowOptions
      } = evaluate(options, state);
      const coords = {
        x,
        y
      };
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const crossAxis = getSideAxis(getSide(placement));
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === "y" ? "top" : "left";
        const maxSide = mainAxis === "y" ? "bottom" : "right";
        const min2 = mainAxisCoord + overflow[minSide];
        const max2 = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp(min2, mainAxisCoord, max2);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === "y" ? "top" : "left";
        const maxSide = crossAxis === "y" ? "bottom" : "right";
        const min2 = crossAxisCoord + overflow[minSide];
        const max2 = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp(min2, crossAxisCoord, max2);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x,
          y: limitedCoords.y - y,
          enabled: {
            [mainAxis]: checkMainAxis,
            [crossAxis]: checkCrossAxis
          }
        }
      };
    }
  };
};

// ../../node_modules/.pnpm/@floating-ui+dom@1.6.11/node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs
function getCssDimensions(element) {
  const css = getComputedStyle(element);
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement2(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}
function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}
function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement2(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x = ($ ? round(rect.width) : rect.width) / width;
  let y = ($ ? round(rect.height) : rect.height) / height;
  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x,
    y
  };
}
var noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow4(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow4(element)) {
    return false;
  }
  return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow4(domElement);
    const offsetWin = offsetParent && isElement(offsetParent) ? getWindow4(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = getFrameElement(currentWin);
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left;
      y += top;
      currentWin = getWindow4(currentIFrame);
      currentIFrame = getFrameElement(currentWin);
    }
  }
  return rectToClientRect({
    width,
    height,
    x,
    y
  });
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    elements,
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isFixed = strategy === "fixed";
  const documentElement = getDocumentElement(offsetParent);
  const topLayer = elements ? isTopLayer(elements.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = isHTMLElement2(offsetParent);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement2(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
  };
}
function getClientRects(element) {
  return Array.from(element.getClientRects());
}
function getWindowScrollBarX(element, rect) {
  const leftScroll = getNodeScroll(element).scrollLeft;
  if (!rect) {
    return getBoundingClientRect(getDocumentElement(element)).left + leftScroll;
  }
  return rect.left + leftScroll;
}
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y = -scroll.scrollTop;
  if (getComputedStyle(body).direction === "rtl") {
    x += max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}
function getViewportRect(element, strategy) {
  const win = getWindow4(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x = 0;
  let y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x,
    y
  };
}
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === "fixed");
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = isHTMLElement2(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x = left * scale.x;
  const y = top * scale.y;
  return {
    width,
    height,
    x,
    y
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === "viewport") {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === "document") {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      ...clippingAncestor,
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y
    };
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode(element);
  if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return getComputedStyle(parentNode).position === "fixed" || hasFixedPositionAncestor(parentNode, stopNode);
}
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element, [], false).filter((el) => isElement(el) && getNodeName(el) !== "body");
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle(element).position === "fixed";
  let currentNode = elementIsFixed ? getParentNode(element) : element;
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === "fixed") {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && ["absolute", "fixed"].includes(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      result = result.filter((ancestor) => ancestor !== currentNode);
    } else {
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result);
  return result;
}
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === "clippingAncestors" ? isTopLayer(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}
function getDimensions(element) {
  const {
    width,
    height
  } = getCssDimensions(element);
  return {
    width,
    height
  };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement2(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === "fixed";
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  let htmlX = 0;
  let htmlY = 0;
  if (documentElement && !isOffsetParentAnElement && !isFixed) {
    const htmlRect = documentElement.getBoundingClientRect();
    htmlY = htmlRect.top + scroll.scrollTop;
    htmlX = htmlRect.left + scroll.scrollLeft - // RTL <body> scrollbar.
    getWindowScrollBarX(documentElement, htmlRect);
  }
  const x = rect.left + scroll.scrollLeft - offsets.x - htmlX;
  const y = rect.top + scroll.scrollTop - offsets.y - htmlY;
  return {
    x,
    y,
    width: rect.width,
    height: rect.height
  };
}
function isStaticPositioned(element) {
  return getComputedStyle(element).position === "static";
}
function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement2(element) || getComputedStyle(element).position === "fixed") {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  let rawOffsetParent = element.offsetParent;
  if (getDocumentElement(element) === rawOffsetParent) {
    rawOffsetParent = rawOffsetParent.ownerDocument.body;
  }
  return rawOffsetParent;
}
function getOffsetParent(element, polyfill) {
  const win = getWindow4(element);
  if (isTopLayer(element)) {
    return win;
  }
  if (!isHTMLElement2(element)) {
    let svgOffsetParent = getParentNode(element);
    while (svgOffsetParent && !isLastTraversableNode(svgOffsetParent)) {
      if (isElement(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) {
        return svgOffsetParent;
      }
      svgOffsetParent = getParentNode(svgOffsetParent);
    }
    return win;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && isStaticPositioned(offsetParent)) {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && isLastTraversableNode(offsetParent) && isStaticPositioned(offsetParent) && !isContainingBlock(offsetParent)) {
    return win;
  }
  return offsetParent || getContainingBlock(element) || win;
}
var getElementRects = async function(data) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  const floatingDimensions = await getDimensionsFn(data.floating);
  return {
    reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
    floating: {
      x: 0,
      y: 0,
      width: floatingDimensions.width,
      height: floatingDimensions.height
    }
  };
};
function isRTL(element) {
  return getComputedStyle(element).direction === "rtl";
}
var platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement,
  isRTL
};
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root = getDocumentElement(element);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const {
      left,
      top,
      width,
      height
    } = element.getBoundingClientRect();
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root.clientWidth - (left + width));
    const insetBottom = floor(root.clientHeight - (top + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: max(0, min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 1e3);
        } else {
          refresh(false, ratio);
        }
      }
      isFirstUpdate = false;
    }
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        // Handle <iframe>s
        root: root.ownerDocument
      });
    } catch (e) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === "function",
    layoutShift = typeof IntersectionObserver === "function",
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...referenceEl ? getOverflowAncestors(referenceEl) : [], ...getOverflowAncestors(floating)] : [];
  ancestors.forEach((ancestor) => {
    ancestorScroll && ancestor.addEventListener("scroll", update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener("resize", update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver((_ref) => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach((ancestor) => {
      ancestorScroll && ancestor.removeEventListener("scroll", update);
      ancestorResize && ancestor.removeEventListener("resize", update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}
var detectOverflow2 = detectOverflow;
var offset2 = offset;
var shift2 = shift;
var flip2 = flip;
var hide2 = hide;
var arrow2 = arrow;
var computePosition2 = (reference, floating, options) => {
  const cache = /* @__PURE__ */ new Map();
  const mergedOptions = {
    platform,
    ...options
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};

// ../../node_modules/.pnpm/@floating-ui+react-dom@2.1.2_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.mjs
import * as React6 from "react";
import { useLayoutEffect as useLayoutEffect2, useEffect as useEffect15 } from "react";
import * as ReactDOM from "react-dom";
var index = typeof document !== "undefined" ? useLayoutEffect2 : useEffect15;
function deepEqual2(a, b) {
  if (a === b) {
    return true;
  }
  if (typeof a !== typeof b) {
    return false;
  }
  if (typeof a === "function" && a.toString() === b.toString()) {
    return true;
  }
  let length;
  let i;
  let keys;
  if (a && b && typeof a === "object") {
    if (Array.isArray(a)) {
      length = a.length;
      if (length !== b.length) return false;
      for (i = length; i-- !== 0; ) {
        if (!deepEqual2(a[i], b[i])) {
          return false;
        }
      }
      return true;
    }
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) {
      return false;
    }
    for (i = length; i-- !== 0; ) {
      if (!{}.hasOwnProperty.call(b, keys[i])) {
        return false;
      }
    }
    for (i = length; i-- !== 0; ) {
      const key = keys[i];
      if (key === "_owner" && a.$$typeof) {
        continue;
      }
      if (!deepEqual2(a[key], b[key])) {
        return false;
      }
    }
    return true;
  }
  return a !== a && b !== b;
}
function getDPR(element) {
  if (typeof window === "undefined") {
    return 1;
  }
  const win = element.ownerDocument.defaultView || window;
  return win.devicePixelRatio || 1;
}
function roundByDPR(element, value) {
  const dpr = getDPR(element);
  return Math.round(value * dpr) / dpr;
}
function useLatestRef(value) {
  const ref = React6.useRef(value);
  index(() => {
    ref.current = value;
  });
  return ref;
}
function useFloating(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware = [],
    platform: platform2,
    elements: {
      reference: externalReference,
      floating: externalFloating
    } = {},
    transform = true,
    whileElementsMounted,
    open
  } = options;
  const [data, setData] = React6.useState({
    x: 0,
    y: 0,
    strategy,
    placement,
    middlewareData: {},
    isPositioned: false
  });
  const [latestMiddleware, setLatestMiddleware] = React6.useState(middleware);
  if (!deepEqual2(latestMiddleware, middleware)) {
    setLatestMiddleware(middleware);
  }
  const [_reference, _setReference] = React6.useState(null);
  const [_floating, _setFloating] = React6.useState(null);
  const setReference = React6.useCallback((node) => {
    if (node !== referenceRef.current) {
      referenceRef.current = node;
      _setReference(node);
    }
  }, []);
  const setFloating = React6.useCallback((node) => {
    if (node !== floatingRef.current) {
      floatingRef.current = node;
      _setFloating(node);
    }
  }, []);
  const referenceEl = externalReference || _reference;
  const floatingEl = externalFloating || _floating;
  const referenceRef = React6.useRef(null);
  const floatingRef = React6.useRef(null);
  const dataRef = React6.useRef(data);
  const hasWhileElementsMounted = whileElementsMounted != null;
  const whileElementsMountedRef = useLatestRef(whileElementsMounted);
  const platformRef = useLatestRef(platform2);
  const openRef = useLatestRef(open);
  const update = React6.useCallback(() => {
    if (!referenceRef.current || !floatingRef.current) {
      return;
    }
    const config2 = {
      placement,
      strategy,
      middleware: latestMiddleware
    };
    if (platformRef.current) {
      config2.platform = platformRef.current;
    }
    computePosition2(referenceRef.current, floatingRef.current, config2).then((data2) => {
      const fullData = {
        ...data2,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: openRef.current !== false
      };
      if (isMountedRef.current && !deepEqual2(dataRef.current, fullData)) {
        dataRef.current = fullData;
        ReactDOM.flushSync(() => {
          setData(fullData);
        });
      }
    });
  }, [latestMiddleware, placement, strategy, platformRef, openRef]);
  index(() => {
    if (open === false && dataRef.current.isPositioned) {
      dataRef.current.isPositioned = false;
      setData((data2) => ({
        ...data2,
        isPositioned: false
      }));
    }
  }, [open]);
  const isMountedRef = React6.useRef(false);
  index(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  index(() => {
    if (referenceEl) referenceRef.current = referenceEl;
    if (floatingEl) floatingRef.current = floatingEl;
    if (referenceEl && floatingEl) {
      if (whileElementsMountedRef.current) {
        return whileElementsMountedRef.current(referenceEl, floatingEl, update);
      }
      update();
    }
  }, [referenceEl, floatingEl, update, whileElementsMountedRef, hasWhileElementsMounted]);
  const refs = React6.useMemo(() => ({
    reference: referenceRef,
    floating: floatingRef,
    setReference,
    setFloating
  }), [setReference, setFloating]);
  const elements = React6.useMemo(() => ({
    reference: referenceEl,
    floating: floatingEl
  }), [referenceEl, floatingEl]);
  const floatingStyles = React6.useMemo(() => {
    const initialStyles = {
      position: strategy,
      left: 0,
      top: 0
    };
    if (!elements.floating) {
      return initialStyles;
    }
    const x = roundByDPR(elements.floating, data.x);
    const y = roundByDPR(elements.floating, data.y);
    if (transform) {
      return {
        ...initialStyles,
        transform: "translate(" + x + "px, " + y + "px)",
        ...getDPR(elements.floating) >= 1.5 && {
          willChange: "transform"
        }
      };
    }
    return {
      position: strategy,
      left: x,
      top: y
    };
  }, [strategy, transform, elements.floating, data.x, data.y]);
  return React6.useMemo(() => ({
    ...data,
    update,
    refs,
    elements,
    floatingStyles
  }), [data, update, refs, elements, floatingStyles]);
}
var arrow$1 = (options) => {
  function isRef(value) {
    return {}.hasOwnProperty.call(value, "current");
  }
  return {
    name: "arrow",
    options,
    fn(state) {
      const {
        element,
        padding
      } = typeof options === "function" ? options(state) : options;
      if (element && isRef(element)) {
        if (element.current != null) {
          return arrow2({
            element: element.current,
            padding
          }).fn(state);
        }
        return {};
      }
      if (element) {
        return arrow2({
          element,
          padding
        }).fn(state);
      }
      return {};
    }
  };
};
var offset3 = (options, deps) => ({
  ...offset2(options),
  options: [options, deps]
});
var shift3 = (options, deps) => ({
  ...shift2(options),
  options: [options, deps]
});
var flip3 = (options, deps) => ({
  ...flip2(options),
  options: [options, deps]
});
var hide3 = (options, deps) => ({
  ...hide2(options),
  options: [options, deps]
});
var arrow3 = (options, deps) => ({
  ...arrow$1(options),
  options: [options, deps]
});

// ../../node_modules/.pnpm/@floating-ui+react@0.26.24_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@floating-ui/react/dist/floating-ui.react.mjs
var SafeReact = {
  ...React7
};
var useInsertionEffect = SafeReact.useInsertionEffect;
var useSafeInsertionEffect = useInsertionEffect || ((fn) => fn());
function useEffectEvent(callback) {
  const ref = React7.useRef(() => {
    if (false) {
      throw new Error("Cannot call an event handler while rendering.");
    }
  });
  useSafeInsertionEffect(() => {
    ref.current = callback;
  });
  return React7.useCallback(function() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return ref.current == null ? void 0 : ref.current(...args);
  }, []);
}
var ARROW_UP = "ArrowUp";
var ARROW_DOWN = "ArrowDown";
var ARROW_LEFT = "ArrowLeft";
var ARROW_RIGHT = "ArrowRight";
var index2 = typeof document !== "undefined" ? useLayoutEffect3 : useEffect17;
var horizontalKeys = [ARROW_LEFT, ARROW_RIGHT];
var verticalKeys = [ARROW_UP, ARROW_DOWN];
var allKeys = [...horizontalKeys, ...verticalKeys];
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var serverHandoffComplete = false;
var count = 0;
var genId = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + count++
);
function useFloatingId() {
  const [id, setId] = React7.useState(() => serverHandoffComplete ? genId() : void 0);
  index2(() => {
    if (id == null) {
      setId(genId());
    }
  }, []);
  React7.useEffect(() => {
    serverHandoffComplete = true;
  }, []);
  return id;
}
var useReactId = SafeReact.useId;
var useId = useReactId || useFloatingId;
if (false) {
  devMessageSet = /* @__PURE__ */ new Set();
}
var FloatingArrow = /* @__PURE__ */ React7.forwardRef(function FloatingArrow2(props, ref) {
  const {
    context: {
      placement,
      elements: {
        floating
      },
      middlewareData: {
        arrow: arrow4,
        shift: shift4
      }
    },
    width = 14,
    height = 7,
    tipRadius = 0,
    strokeWidth = 0,
    staticOffset,
    stroke,
    d,
    style: {
      transform,
      ...restStyle
    } = {},
    ...rest
  } = props;
  if (false) {
    if (!ref) {
      warn("The `ref` prop is required for `FloatingArrow`.");
    }
  }
  const clipPathId = useId();
  const [isRTL2, setIsRTL] = React7.useState(false);
  index2(() => {
    if (!floating) return;
    const isRTL3 = getComputedStyle(floating).direction === "rtl";
    if (isRTL3) {
      setIsRTL(true);
    }
  }, [floating]);
  if (!floating) {
    return null;
  }
  const [side, alignment] = placement.split("-");
  const isVerticalSide = side === "top" || side === "bottom";
  let computedStaticOffset = staticOffset;
  if (isVerticalSide && shift4 != null && shift4.x || !isVerticalSide && shift4 != null && shift4.y) {
    computedStaticOffset = null;
  }
  const computedStrokeWidth = strokeWidth * 2;
  const halfStrokeWidth = computedStrokeWidth / 2;
  const svgX = width / 2 * (tipRadius / -8 + 1);
  const svgY = height / 2 * tipRadius / 4;
  const isCustomShape = !!d;
  const yOffsetProp = computedStaticOffset && alignment === "end" ? "bottom" : "top";
  let xOffsetProp = computedStaticOffset && alignment === "end" ? "right" : "left";
  if (computedStaticOffset && isRTL2) {
    xOffsetProp = alignment === "end" ? "left" : "right";
  }
  const arrowX = (arrow4 == null ? void 0 : arrow4.x) != null ? computedStaticOffset || arrow4.x : "";
  const arrowY = (arrow4 == null ? void 0 : arrow4.y) != null ? computedStaticOffset || arrow4.y : "";
  const dValue = d || "M0,0" + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + " Z";
  const rotation = {
    top: isCustomShape ? "rotate(180deg)" : "",
    left: isCustomShape ? "rotate(90deg)" : "rotate(-90deg)",
    bottom: isCustomShape ? "" : "rotate(180deg)",
    right: isCustomShape ? "rotate(-90deg)" : "rotate(90deg)"
  }[side];
  return /* @__PURE__ */ React7.createElement("svg", _extends({}, rest, {
    "aria-hidden": true,
    ref,
    width: isCustomShape ? width : width + computedStrokeWidth,
    height: width,
    viewBox: "0 0 " + width + " " + (height > width ? height : width),
    style: {
      position: "absolute",
      pointerEvents: "none",
      [xOffsetProp]: arrowX,
      [yOffsetProp]: arrowY,
      [side]: isVerticalSide || isCustomShape ? "100%" : "calc(100% - " + computedStrokeWidth / 2 + "px)",
      transform: [rotation, transform].filter((t) => !!t).join(" "),
      ...restStyle
    }
  }), computedStrokeWidth > 0 && /* @__PURE__ */ React7.createElement("path", {
    clipPath: "url(#" + clipPathId + ")",
    fill: "none",
    stroke,
    strokeWidth: computedStrokeWidth + (d ? 0 : 1),
    d: dValue
  }), /* @__PURE__ */ React7.createElement("path", {
    stroke: computedStrokeWidth && !d ? rest.fill : "none",
    d: dValue
  }), /* @__PURE__ */ React7.createElement("clipPath", {
    id: clipPathId
  }, /* @__PURE__ */ React7.createElement("rect", {
    x: -halfStrokeWidth,
    y: halfStrokeWidth * (isCustomShape ? -1 : 1),
    width: width + computedStrokeWidth,
    height: width
  })));
});
function createPubSub() {
  const map3 = /* @__PURE__ */ new Map();
  return {
    emit(event, data) {
      var _map$get;
      (_map$get = map3.get(event)) == null || _map$get.forEach((handler) => handler(data));
    },
    on(event, listener) {
      map3.set(event, [...map3.get(event) || [], listener]);
    },
    off(event, listener) {
      var _map$get2;
      map3.set(event, ((_map$get2 = map3.get(event)) == null ? void 0 : _map$get2.filter((l) => l !== listener)) || []);
    }
  };
}
var FloatingNodeContext = /* @__PURE__ */ React7.createContext(null);
var FloatingTreeContext = /* @__PURE__ */ React7.createContext(null);
var useFloatingParentNodeId = () => {
  var _React$useContext;
  return ((_React$useContext = React7.useContext(FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
var useFloatingTree = () => React7.useContext(FloatingTreeContext);
function useFloatingRootContext(options) {
  const {
    open = false,
    onOpenChange: onOpenChangeProp,
    elements: elementsProp
  } = options;
  const floatingId = useId();
  const dataRef = React7.useRef({});
  const [events] = React7.useState(() => createPubSub());
  const nested = useFloatingParentNodeId() != null;
  if (false) {
    const optionDomReference = elementsProp.reference;
    if (optionDomReference && !isElement(optionDomReference)) {
      error("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
    }
  }
  const [positionReference, setPositionReference] = React7.useState(elementsProp.reference);
  const onOpenChange = useEffectEvent((open2, event, reason) => {
    dataRef.current.openEvent = open2 ? event : void 0;
    events.emit("openchange", {
      open: open2,
      event,
      reason,
      nested
    });
    onOpenChangeProp == null || onOpenChangeProp(open2, event, reason);
  });
  const refs = React7.useMemo(() => ({
    setPositionReference
  }), []);
  const elements = React7.useMemo(() => ({
    reference: positionReference || elementsProp.reference || null,
    floating: elementsProp.floating || null,
    domReference: elementsProp.reference
  }), [positionReference, elementsProp.reference, elementsProp.floating]);
  return React7.useMemo(() => ({
    dataRef,
    open,
    onOpenChange,
    elements,
    events,
    floatingId,
    refs
  }), [open, onOpenChange, elements, events, floatingId, refs]);
}
function useFloating2(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    nodeId
  } = options;
  const internalRootContext = useFloatingRootContext({
    ...options,
    elements: {
      reference: null,
      floating: null,
      ...options.elements
    }
  });
  const rootContext = options.rootContext || internalRootContext;
  const computedElements = rootContext.elements;
  const [_domReference, setDomReference] = React7.useState(null);
  const [positionReference, _setPositionReference] = React7.useState(null);
  const optionDomReference = computedElements == null ? void 0 : computedElements.reference;
  const domReference = optionDomReference || _domReference;
  const domReferenceRef = React7.useRef(null);
  const tree = useFloatingTree();
  index2(() => {
    if (domReference) {
      domReferenceRef.current = domReference;
    }
  }, [domReference]);
  const position = useFloating({
    ...options,
    elements: {
      ...computedElements,
      ...positionReference && {
        reference: positionReference
      }
    }
  });
  const setPositionReference = React7.useCallback((node) => {
    const computedPositionReference = isElement(node) ? {
      getBoundingClientRect: () => node.getBoundingClientRect(),
      contextElement: node
    } : node;
    _setPositionReference(computedPositionReference);
    position.refs.setReference(computedPositionReference);
  }, [position.refs]);
  const setReference = React7.useCallback((node) => {
    if (isElement(node) || node === null) {
      domReferenceRef.current = node;
      setDomReference(node);
    }
    if (isElement(position.refs.reference.current) || position.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    node !== null && !isElement(node)) {
      position.refs.setReference(node);
    }
  }, [position.refs]);
  const refs = React7.useMemo(() => ({
    ...position.refs,
    setReference,
    setPositionReference,
    domReference: domReferenceRef
  }), [position.refs, setReference, setPositionReference]);
  const elements = React7.useMemo(() => ({
    ...position.elements,
    domReference
  }), [position.elements, domReference]);
  const context = React7.useMemo(() => ({
    ...position,
    ...rootContext,
    refs,
    elements,
    nodeId
  }), [position, refs, elements, nodeId, rootContext]);
  index2(() => {
    rootContext.dataRef.current.floatingContext = context;
    const node = tree == null ? void 0 : tree.nodesRef.current.find((node2) => node2.id === nodeId);
    if (node) {
      node.context = context;
    }
  });
  return React7.useMemo(() => ({
    ...position,
    context,
    refs,
    elements
  }), [position, refs, elements, context]);
}

// src/components/tour/tourComponent.tsx
import _57 from "lodash/fp.js";
import { Portal, Z_TOUR as Z_TOUR4 } from "@lls/lls-kit";

// src/components/tour/tourBeacon.jsx
import { Z_TOUR } from "@lls/lls-kit";

// tmp_esbuild1736180049684/_src_components_tour_tourBeacon.module.css
var src_components_tour_tourBeacon_default = { "tour-beacon-outer": "core-8xjr0a-tour-beacon-outer", "tour-beacon-inner": "core-8xjr0a-tour-beacon-inner", "beacon": "core-8xjr0a-beacon", "tourBeaconOuter": "core-8xjr0a-tourBeaconOuter", "tourBeaconInner": "core-8xjr0a-tourBeaconInner" };

// src/components/tour/tourBeacon.jsx
import { jsx as jsx59, jsxs as jsxs40 } from "react/jsx-runtime";
var BEACON_OUTER_SIZE = 48;
var TourBeacon = ({ target = {} }) => {
  const rect = (target == null ? void 0 : target.getBoundingClientRect()) || {};
  const { x, y, width, height } = rect;
  return /* @__PURE__ */ jsxs40(
    "div",
    {
      className: src_components_tour_tourBeacon_default.beacon,
      style: {
        "--c-beacon-outer-size": `${BEACON_OUTER_SIZE}px`,
        "--c-z-tour": Z_TOUR,
        "--c-width": `${width}px`,
        "--c-height": `${height}px`,
        "--c-x": `${x}px`,
        "--c-y": `${y}px`
      },
      children: [
        /* @__PURE__ */ jsx59("div", { className: src_components_tour_tourBeacon_default.tourBeaconOuter }),
        /* @__PURE__ */ jsx59("div", { className: src_components_tour_tourBeacon_default.tourBeaconInner })
      ]
    }
  );
};
var tourBeacon_default = TourBeacon;

// tmp_esbuild1736180049684/_src_components_tour_tourComponent.module.css
var src_components_tour_tourComponent_default = { "tooltipContainer": "core-b_Ohda-tooltipContainer", "elementsContainer": "core-b_Ohda-elementsContainer", "floatingBoundary": "core-b_Ohda-floatingBoundary" };

// src/components/tour/tourMask.jsx
import { Z_TOUR as Z_TOUR2 } from "@lls/lls-kit";

// tmp_esbuild1736180049684/_src_components_tour_tourMask.module.css
var src_components_tour_tourMask_default = { "mask": "core-w-QY_W-mask" };

// src/components/tour/tourMask.jsx
import { jsx as jsx60 } from "react/jsx-runtime";
var TourMask = ({ visible = false }) => /* @__PURE__ */ jsx60("div", { className: src_components_tour_tourMask_default.mask, style: { "--c-z-tour": Z_TOUR2 }, "data-visible": +visible });
var tourMask_default = TourMask;

// src/components/tour/tourSpotlight.jsx
import { useEffect as useEffect18, useRef as useRef10 } from "react";
import { Z_TOUR as Z_TOUR3 } from "@lls/lls-kit";
import _55 from "lodash/fp.js";

// tmp_esbuild1736180049684/_src_components_tour_tourSpotlight.module.css
var src_components_tour_tourSpotlight_default = { "spotlight": "core-tJV7ia-spotlight", "mask": "core-tJV7ia-mask" };

// src/components/tour/tourSpotlight.jsx
import { Fragment as Fragment11, jsx as jsx61, jsxs as jsxs41 } from "react/jsx-runtime";
var formatRect = (spotlightType) => ({ width, height }) => {
  switch (spotlightType) {
    case "ellipsis": {
      if (width > height) {
        const ratio = height / width;
        const enhancedRatio = (ratio + 0.9) / 2;
        return { width, height: width * enhancedRatio };
      }
      if (height > width) {
        const ratio = width / height;
        const enhancedRatio = (ratio + 0.9) / 2;
        return { height, width: height * enhancedRatio };
      }
      break;
    }
    case "round": {
      return width > height ? { width, height: width } : { height, width: height };
    }
  }
  return { width, height };
};
var SPOTLIGHT_MARGIN = 40;
var TourSpotlight = ({
  target = {},
  spotlightType = "ellipsis",
  spotlightMargin = SPOTLIGHT_MARGIN,
  clickOutside = false,
  clickInside = true
}) => {
  const rect = (target == null ? void 0 : target.getBoundingClientRect()) || {};
  const { width, height } = _55.flow(
    _55.pick(["width", "height"]),
    formatRect(spotlightType),
    _55.mapValues(_55.flow(Math.round, _55.add(spotlightMargin)))
  )(rect);
  const { x, y, width: originalWidth, height: originalHeight } = rect;
  const widthOffset = width - originalWidth;
  const heightOffset = height - originalHeight;
  const maskRef = useRef10(null);
  const spotlightRef = useRef10(null);
  useEffect18(() => {
    if (clickInside) {
      const onMouseLeave = () => {
        spotlightRef.current.style.pointerEvents = "auto";
        if (!clickOutside) {
          maskRef.current.style.pointerEvents = "auto";
        }
      };
      const onMouseEnter = () => {
        spotlightRef.current.style.pointerEvents = "none";
        if (!clickOutside) {
          maskRef.current.style.pointerEvents = "none";
        }
      };
      const callback = (e) => {
        var _a2;
        const spotlightRect = (_a2 = spotlightRef == null ? void 0 : spotlightRef.current) == null ? void 0 : _a2.getBoundingClientRect();
        if (e.x > spotlightRect.left && e.x < spotlightRect.right && e.y < spotlightRect.bottom && e.y > spotlightRect.top) {
          onMouseEnter();
        } else {
          onMouseLeave();
        }
      };
      document.addEventListener("mousemove", callback);
      return () => document.removeEventListener("mousemove", callback);
    }
  }, [clickInside, clickOutside]);
  useEffect18(() => {
    _55.noop(target);
    if (spotlightRef.current) spotlightRef.current.style.pointerEvents = "auto";
    if (maskRef.current) maskRef.current.style.pointerEvents = "auto";
  }, [target]);
  return /* @__PURE__ */ jsxs41(Fragment11, { children: [
    /* @__PURE__ */ jsx61(
      "div",
      {
        className: src_components_tour_tourSpotlight_default.mask,
        style: { "--c-z-tour": Z_TOUR3 },
        ref: maskRef,
        "data-click-outside": +clickOutside
      }
    ),
    /* @__PURE__ */ jsx61(
      "div",
      {
        className: src_components_tour_tourSpotlight_default.spotlight,
        style: {
          "--c-width": `${width}px`,
          "--c-height": `${height}px`,
          "--c-margin": `${spotlightMargin}px`,
          "--c-x": `${x}px`,
          "--c-y": `${y}px`,
          "--c-offsetX": `${widthOffset ? widthOffset / 2 : 0}px`,
          "--c-offsetY": `${heightOffset ? heightOffset / 2 : 0}px`,
          "--c-z-tour": Z_TOUR3
        },
        ref: spotlightRef,
        "data-spotlight-type": spotlightType
      }
    )
  ] });
};
var tourSpotlight_default = TourSpotlight;

// src/components/tour/tourTooltip.jsx
init_trial2();
init_useTour();
import { Button as Button27 } from "@lls/lls-kit";
import { openWindow as openWindow12 } from "@lls/utils";
import _56 from "lodash/fp.js";

// tmp_esbuild1736180049684/_src_components_tour_tourTooltip.module.css
var src_components_tour_tourTooltip_default = { "step": "core-nxKRoq-step", "tourTooltip": "core-nxKRoq-tourTooltip", "tourTooltipTitleWrapper": "core-nxKRoq-tourTooltipTitleWrapper", "tooltipStepper": "core-nxKRoq-tooltipStepper", "tourTooltipContainer": "core-nxKRoq-tourTooltipContainer", "tour-tooltip-content": "core-nxKRoq-tour-tooltip-content", "tooltipFooter": "core-nxKRoq-tooltipFooter", "tourTooltipBody": "core-nxKRoq-tourTooltipBody" };

// src/components/tour/tourTooltip.jsx
import { jsx as jsx62, jsxs as jsxs42 } from "react/jsx-runtime";
var TooltipStepper = ({ size: size4, index: index3 }) => /* @__PURE__ */ jsx62("div", { className: src_components_tour_tourTooltip_default.tooltipStepper, children: _56.times(
  (i) => /* @__PURE__ */ jsx62("div", { className: src_components_tour_tourTooltip_default.step, "data-current": +(i === index3) }, i),
  size4
) });
var TourTooltip = ({ step, index: index3, size: size4 = 0 }) => {
  const isLastStep = index3 === size4 - 1;
  const isContactStep = step == null ? void 0 : step.isContactStep;
  const hasStepper = size4 > 1 && !isContactStep;
  const { resetTour: resetTour2 } = useTour_default();
  return /* @__PURE__ */ jsx62("div", { className: src_components_tour_tourTooltip_default.tourTooltip, width: size4 > 0 ? `${(index3 + 1) / size4 * 100}%` : "100%", children: /* @__PURE__ */ jsxs42("div", { className: src_components_tour_tourTooltip_default.tourTooltipContainer, children: [
    /* @__PURE__ */ jsxs42("div", { className: src_components_tour_tourTooltip_default.tourTooltipTitleWrapper, children: [
      /* @__PURE__ */ jsx62("span", { children: step == null ? void 0 : step.title }),
      /* @__PURE__ */ jsx62(Button27, { icon: "cancel", iconPosition: "right", theme: "gray", accent: "floating", inverted: true, onClick: resetTour2 })
    ] }),
    /* @__PURE__ */ jsxs42("div", { className: src_components_tour_tourTooltip_default.tourTooltipBody, children: [
      /* @__PURE__ */ jsxs42("div", { className: src_components_tour_tourTooltip_default.tourTooltipContent, children: [
        /* @__PURE__ */ jsx62("p", { children: step == null ? void 0 : step.content }),
        isContactStep && /* @__PURE__ */ jsxs42("p", { children: [
          "Vous pouvez continuer \xE0 explorer le Manuel Num\xE9rique ",
          /* @__PURE__ */ jsx62(Premium, {}),
          " au sein de cette plateforme de d\xE9monstration avec ou sans les parcours de d\xE9couverte ou bien contacter notre \xE9quipe pour tester la version ",
          /* @__PURE__ */ jsx62(Premium, {}),
          " avec votre classe."
        ] })
      ] }),
      /* @__PURE__ */ jsxs42("div", { className: src_components_tour_tourTooltip_default.tooltipFooter, "data-stepper": +hasStepper, children: [
        hasStepper && /* @__PURE__ */ jsx62(TooltipStepper, { size: size4, index: index3 }),
        isContactStep && /* @__PURE__ */ jsx62(
          Button27,
          {
            accent: "floating",
            href: CALENDLY_LINK,
            target: "_blank",
            onGoTo: ({ href, target }) => openWindow12(href, target),
            children: "Prendre rendez-vous"
          }
        ),
        (isLastStep || (step == null ? void 0 : step.withNextButton)) && /* @__PURE__ */ jsx62(Button27, { onClick: () => step.goToNextStep(), children: isContactStep ? "Continuer \xE0 explorer" : isLastStep ? "Terminer" : "Continuer" })
      ] })
    ] })
  ] }) });
};
var tourTooltip_default = TourTooltip;

// src/components/tour/tourComponent.tsx
import { jsx as jsx63, jsxs as jsxs43 } from "react/jsx-runtime";
var SCROLL_OFFSET = 250;
var ARROW_HEIGHT = 16;
var ARROW_WIDTH = 32;
var customOverflowMiddleware = {
  name: "customOverflowMiddleWare",
  async fn(state) {
    if (!state) return {};
    const boundaryElement = document.querySelector('[data-tour="boundary"]');
    if (!boundaryElement) return {};
    const overflow = await detectOverflow2(state, {
      boundary: boundaryElement
    });
    const offsetX = (overflow == null ? void 0 : overflow.right) > 0 ? state.x - overflow.right : state.x;
    return { x: offsetX };
  }
};
var getScrollParents = (node) => {
  var _a2;
  if (!node || node instanceof Document) {
    return [window];
  }
  const isScrollable = node.scrollHeight > node.clientHeight && !["visible", "hidden"].includes((_a2 = window.getComputedStyle(node)) == null ? void 0 : _a2.overflowY);
  return getScrollParents(node.parentNode).concat(isScrollable ? node : []);
};
var scrollParentToElement = (parent, element) => {
  if (parent && element) {
    const elementRect = element.getBoundingClientRect();
    const scrollToTop = ((elementRect == null ? void 0 : elementRect.top) || 0) - SCROLL_OFFSET + (parent.scrollTop || parent.scrollY || 0);
    parent.scrollTo({ top: scrollToTop, behavior: "smooth" });
  }
};
var getOffset = ({ distance }) => () => distance + ARROW_HEIGHT;
var Tour2 = ({ isTourOpen, setIsTourOpen, steps, stepIndex }) => {
  var _a2;
  const [isOpen, setIsOpen] = useState15(true);
  const [hasScrolled, setHasScrolled] = useState15(false);
  const timeoutRef = useRef11(null);
  const arrowRef = useRef11(null);
  const hasTour = (steps == null ? void 0 : steps.length) && _57.isNumber(stepIndex);
  const step = steps == null ? void 0 : steps[stepIndex];
  const [element, setElement] = useState15(null);
  const boundaryRef = useRef11(null);
  const distance = (step == null ? void 0 : step.distance) ?? 20;
  const { refs, floatingStyles, context, middlewareData, update, elements } = useFloating2({
    placement: (step == null ? void 0 : step.placement) === "center" ? void 0 : (step == null ? void 0 : step.placement) ?? "top",
    strategy: (step == null ? void 0 : step.fixed) ? "fixed" : "absolute",
    middleware: _57.compact([
      offset3(getOffset({ distance })),
      !(step == null ? void 0 : step.disableFlip) ? flip3() : null,
      shift3(),
      hide3(),
      customOverflowMiddleware,
      arrow3({
        element: arrowRef
      })
    ]),
    whileElementsMounted: autoUpdate,
    elements: {
      reference: element
    }
  });
  const onSuccess = useCallback26(
    (element2) => {
      setIsOpen(true);
      setElement(element2);
      setIsTourOpen(true);
      update == null ? void 0 : update();
    },
    [setIsTourOpen, update]
  );
  const onError = useCallback26(() => {
    setIsTourOpen(false);
    setElement(null);
    update == null ? void 0 : update();
  }, [setIsTourOpen, update]);
  const tryInitiatingElement = useMemo12(() => {
    const fn = (selector, trialsLeft = 1) => {
      if (trialsLeft <= 0) return onError();
      const element2 = document.querySelector(selector);
      if (element2) {
        return onSuccess(element2);
      }
      const newTimeout = setTimeout(() => fn(selector, trialsLeft - 1), 200);
      timeoutRef.current = newTimeout;
      return newTimeout;
    };
    return fn;
  }, [onSuccess, onError]);
  useEffect19(() => {
    if (!(step == null ? void 0 : step.target) && !(step == null ? void 0 : step.fixed)) return setElement(null);
    setIsTourOpen(false);
    setHasScrolled(false);
    update == null ? void 0 : update();
    if (hasTour) {
      if (!(step == null ? void 0 : step.fixed)) {
        tryInitiatingElement(step == null ? void 0 : step.target, 5);
      } else {
        setIsTourOpen(true);
        setElement(boundaryRef.current);
      }
      return () => {
        timeoutRef.current && clearTimeout(timeoutRef.current);
      };
    }
  }, [step == null ? void 0 : step.target, step == null ? void 0 : step.fixed, tryInitiatingElement, hasTour, update, setIsTourOpen]);
  const noScroll = !!(step == null ? void 0 : step.noScroll) || (step == null ? void 0 : step.fixed);
  useEffect19(() => {
    hasTour && !(step == null ? void 0 : step.fixed) && (step == null ? void 0 : step.target) && tryInitiatingElement(step == null ? void 0 : step.target, 5);
    if (element && hasTour && isTourOpen && !hasScrolled && !noScroll) {
      const elementScrollParents = getScrollParents(element);
      const timeout = setTimeout(() => scrollParentToElement(_57.last(elementScrollParents), element), 100);
      return () => clearTimeout(timeout);
    }
  }, [
    element,
    hasTour,
    isTourOpen,
    hasScrolled,
    noScroll,
    step == null ? void 0 : step.target,
    step == null ? void 0 : step.fixed,
    tryInitiatingElement
  ]);
  const finalFloatingStyles = {
    ...floatingStyles,
    ...(step == null ? void 0 : step.placement) === "center" ? { left: "50%", top: "50%", transform: "translate(-50%, -50%)" } : {}
  };
  const hidden = !!((_a2 = middlewareData == null ? void 0 : middlewareData.hide) == null ? void 0 : _a2.referenceHidden) || !element || !(elements == null ? void 0 : elements.reference) || !step;
  return /* @__PURE__ */ jsxs43(Portal, { shouldDisableScroll: false, children: [
    /* @__PURE__ */ jsx63("div", { ref: boundaryRef, "data-tour": "boundary", className: src_components_tour_tourComponent_default.floatingBoundary }),
    /* @__PURE__ */ jsxs43("div", { className: src_components_tour_tourComponent_default.elementsContainer, "data-open": +isTourOpen, "data-hidden": +hidden, children: [
      /* @__PURE__ */ jsxs43(
        "div",
        {
          className: src_components_tour_tourComponent_default.tooltipContainer,
          style: { ...finalFloatingStyles, "--c-z-tour": Z_TOUR4 },
          ref: refs.setFloating,
          children: [
            isOpen && /* @__PURE__ */ jsx63(tourTooltip_default, { step, index: stepIndex, size: steps == null ? void 0 : steps.length }),
            !(step == null ? void 0 : step.disableArrow) && isOpen && /* @__PURE__ */ jsx63(
              FloatingArrow,
              {
                className: "tour-arrow",
                ref: arrowRef,
                context,
                width: ARROW_WIDTH,
                height: ARROW_HEIGHT,
                fill: `var(--${(context == null ? void 0 : context.placement) === "top" ? "white" : "gray-80"}-color)`,
                tipRadius: 1
              }
            )
          ]
        }
      ),
      (elements == null ? void 0 : elements.reference) && /* @__PURE__ */ jsxs43("div", { className: "side-element-container", children: [
        !(step == null ? void 0 : step.disableBeacon) && /* @__PURE__ */ jsx63(tourBeacon_default, { ...step, target: elements == null ? void 0 : elements.reference }),
        (step == null ? void 0 : step.withSpotlight) && /* @__PURE__ */ jsx63(
          tourSpotlight_default,
          {
            target: elements == null ? void 0 : elements.reference,
            spotlightType: step == null ? void 0 : step.spotlightType,
            spotlightMargin: step == null ? void 0 : step.spotlightMargin,
            clickInside: step == null ? void 0 : step.clickInside,
            clickOutside: step == null ? void 0 : step.clickOutside
          }
        ),
        (step == null ? void 0 : step.withMask) && /* @__PURE__ */ jsx63(tourMask_default, { visible: step == null ? void 0 : step.visibleMask })
      ] })
    ] })
  ] });
};
var tourComponent_default = Tour2;

// src/components/tour/tourController.jsx
init_useTour();
init_loading3();
init_ui2();
init_tour3();
import { hasWindowObject as hasWindowObject6 } from "@lls/utils";
import _58 from "lodash/fp.js";
import { useEffect as useEffect20, useMemo as useMemo13, useState as useState16 } from "react";
import { useSelector as useSelector28 } from "react-redux";
import { useLocation as useLocation12 } from "react-router-dom";
import { jsx as jsx64 } from "react/jsx-runtime";
var TourController = () => {
  var _a2;
  const { tourId, tourStep, tourParams, goToNextStep, scenarioId } = useTour_default();
  const [isTourOpen, setIsTourOpen] = useState16(false);
  const [noScroll, setNoScroll] = useState16(false);
  const debouncedSetIsTourOpen = useMemo13(() => _58.debounce(100, setIsTourOpen), []);
  const tourData = useMemo13(() => {
    const tour2 = getTour(tourId, scenarioId);
    const steps = tour2 == null ? void 0 : tour2.steps;
    const currentStep = steps == null ? void 0 : steps[tourStep];
    return { tour: tour2, steps, currentStep };
  }, [tourId, tourStep, scenarioId]);
  const location = useLocation12();
  const isViewerReady = useSelector28((state) => {
    var _a3;
    return getUiIsViewerReady(state, (_a3 = tourData.currentStep) == null ? void 0 : _a3.neededViewer);
  });
  const drawerExpandedId = useSelector28(getDrawerExpandedId);
  const isDrawerOpen = useSelector28(getUiIsDrawerOpen);
  const isAppLoading = useSelector28(getIsAppLoading);
  useEffect20(() => {
    _58.noop(location, drawerExpandedId);
    const { currentStep } = tourData;
    setIsTourOpen(false);
    if (tourId && hasWindowObject6() && (!(currentStep == null ? void 0 : currentStep.neededViewer) || isViewerReady) && (!(currentStep == null ? void 0 : currentStep.needsDrawer) || isDrawerOpen) && !isAppLoading) {
      debouncedSetIsTourOpen(true);
    }
  }, [tourId, location, isViewerReady, tourData, drawerExpandedId, isAppLoading, isDrawerOpen, debouncedSetIsTourOpen]);
  useEffect20(() => {
    if (!tourId || tourStep !== 0) {
      setNoScroll(false);
    }
  }, [tourStep, tourId]);
  return /* @__PURE__ */ jsx64(
    tourComponent_default,
    {
      isTourOpen,
      setIsTourOpen,
      steps: (_a2 = tourData.steps) == null ? void 0 : _a2.map((step) => ({
        ...step,
        target: formatTourElementSelector(step == null ? void 0 : step.dataTour, _58.get(step == null ? void 0 : step.params, tourParams)),
        goToNextStep,
        offset: 15,
        noScroll: noScroll || (step == null ? void 0 : step.noScroll)
      })),
      stepIndex: tourStep
    }
  );
};
var tourController_default = TourController;

// src/components/tour/tourPanel.jsx
init_es62();
import _59 from "lodash/fp.js";
import { useCallback as useCallback28, useEffect as useEffect21, useState as useState19 } from "react";
import { useSelector as useSelector29 } from "react-redux";

// src/components/form/trialContactForm.jsx
import { Button as Button28 } from "@lls/lls-kit";
import { useCallback as useCallback27, useState as useState17 } from "react";
import { getFieldHint as getFieldHint2, hasFieldError as hasFieldError3 } from "@lls/utils";

// tmp_esbuild1736180049684/_src_components_form_trialContactForm.module.css
var src_components_form_trialContactForm_default = { "contactFormWrapper": "core-K7KFCG-contactFormWrapper", "title": "core-K7KFCG-title", "subTitle": "core-K7KFCG-subTitle", "form": "core-K7KFCG-form", "inputContainer": "core-K7KFCG-inputContainer" };

// src/components/form/trialContactForm.jsx
import { Fragment as Fragment12, jsx as jsx65, jsxs as jsxs44 } from "react/jsx-runtime";
var TrialContactForm = ({ onSubmit, onClose }) => {
  const [isCompleted, setIsCompleted] = useState17(false);
  const { handleSubmit, control, formState, setValue } = useForm({
    defaultValues: {
      phone: "",
      schools: ""
    }
  });
  const onSubmitCb = useCallback27(
    (data) => {
      onSubmit(data);
      setIsCompleted(true);
    },
    [onSubmit]
  );
  return /* @__PURE__ */ jsx65("div", { className: src_components_form_trialContactForm_default.contactFormWrapper, children: isCompleted ? /* @__PURE__ */ jsxs44(Fragment12, { children: [
    /* @__PURE__ */ jsx65("p", { className: src_components_form_trialContactForm_default.title, children: "Merci !" }),
    /* @__PURE__ */ jsx65("p", { className: src_components_form_trialContactForm_default.subTitle, children: "Nos \xE9quipes vous recontacteront sous peu \u{1F642}" }),
    /* @__PURE__ */ jsx65(Button28, { onClick: onClose, theme: "gray", children: "Revenir aux parcours de d\xE9couverte" })
  ] }) : /* @__PURE__ */ jsxs44("form", { className: src_components_form_trialContactForm_default.form, onSubmit: handleSubmit(onSubmitCb), children: [
    /* @__PURE__ */ jsx65("p", { className: src_components_form_trialContactForm_default.title, children: "Vous aimez le Manuel Num\xE9rique Premium\xA0?" }),
    /* @__PURE__ */ jsx65("p", { className: src_components_form_trialContactForm_default.subTitle, children: "Laissez-nous vos coordonn\xE9es et on vous recontactera \u{1F642}" }),
    /* @__PURE__ */ jsx65("div", { className: src_components_form_trialContactForm_default.inputContainer, children: /* @__PURE__ */ jsx65(
      Phone,
      {
        control,
        error: hasFieldError3("phone", formState),
        hint: getFieldHint2("phone", formState)
      }
    ) }),
    /* @__PURE__ */ jsx65("div", { className: src_components_form_trialContactForm_default.inputContainer, children: /* @__PURE__ */ jsx65(SchoolsSelector, { control, setValue, formState, schoolValue: "rne" }) }),
    /* @__PURE__ */ jsxs44("div", { children: [
      /* @__PURE__ */ jsx65(Button28, { onClick: onClose, theme: "gray", children: "Non merci" }),
      /* @__PURE__ */ jsx65(Button28, { type: "submit", children: "Contactez-moi !" })
    ] })
  ] }) });
};
var trialContactForm_default = TrialContactForm;

// src/components/tour/tourAccompanied.jsx
import { useState as useState18 } from "react";
init_analytics4();
init_trial3();
init_useCustomEffect();
import { Button as Button29, CheckBox } from "@lls/lls-kit";
import { Lastname } from "@lls/superkit";
import { dispatchAnalyticsEvent as dispatchAnalyticsEvent15, isValidAcademicMail, openWindow as openWindow13 } from "@lls/utils";
init_trial2();

// tmp_esbuild1736180049684/_src_components_tour_tourAccompanied.module.css
var src_components_tour_tourAccompanied_default = { "tourHeader": "core-ytvM4q-tourHeader", "closeButton": "core-ytvM4q-closeButton", "submitButton": "core-ytvM4q-submitButton", "newsletter": "core-ytvM4q-newsletter", "inputs": "core-ytvM4q-inputs", "completionMessage": "core-ytvM4q-completionMessage", "tourInput": "core-ytvM4q-tourInput", "accompaniedTour": "core-ytvM4q-accompaniedTour", "accompaniedButtons": "core-ytvM4q-accompaniedButtons", "accompaniedSuggestion": "core-ytvM4q-accompaniedSuggestion", "redAsterisk": "core-ytvM4q-redAsterisk", "exitButton": "core-ytvM4q-exitButton" };

// src/components/tour/tourAccompanied.jsx
import { Fragment as Fragment13, jsx as jsx66, jsxs as jsxs45 } from "react/jsx-runtime";
var RedAsterisk = () => /* @__PURE__ */ jsx66("span", { className: src_components_tour_tourAccompanied_default.redAsterisk, children: "*" });
var NUM_LLS_EMAIL = "numerique@lelivrescolaire.fr";
var MAIL_LINE_BREAK = "%0D%0A";
var getEmailBody = ({ email, firstname, lastname }) => `Bonjour,${MAIL_LINE_BREAK}
Je souhaiterais \xEAtre accompagn\xE9(e) par un accompagnateur num\xE9rique pour d\xE9couvrir le Manuel Num\xE9rique Premium.${MAIL_LINE_BREAK}
N'ayant pas d'adresse email acad\xE9mique, je ne peux pas prendre de rendez-vous directement en ligne.${MAIL_LINE_BREAK}
Pourriez-vous me recontacter pour planifier une d\xE9mo personnalis\xE9e ?${MAIL_LINE_BREAK}
Informations : ${MAIL_LINE_BREAK}
  - Pr\xE9nom : ${firstname}${MAIL_LINE_BREAK}
  - Nom : ${lastname}${MAIL_LINE_BREAK}
  - Adresse e-mail : ${email}${MAIL_LINE_BREAK} 
${MAIL_LINE_BREAK}
Merci d'avance,${MAIL_LINE_BREAK}`;
var TourAccompanied = ({ onCloseModal }) => {
  const { handleSubmit, control, formState } = useForm({
    defaultValues: {
      email: "",
      firstname: "",
      lastname: ""
    }
  });
  const [submitted, setSubmitted] = useState18(false);
  const [checked, setChecked] = useState18(false);
  const onSubscribe = useCustomEffect_default(subscribeToNewsletterEffect);
  const [windowUrl, setWindowUrl] = useState18("");
  const onSubmit = ({ email, firstname, lastname }) => {
    setWindowUrl(
      isValidAcademicMail(email) ? CALENDLY_LINK : `mailto:${NUM_LLS_EMAIL}?subject=D\xE9mo Premium - Prise de contact&body=${getEmailBody({ firstname, email, lastname })}`
    );
    if (!checked) {
      onSubscribe({ email, firstname, lastname });
    }
    dispatchAnalyticsEvent15(ANALYTICS_EVENTS.LINK_CLICKED, { featureName: "contact_support_step1" });
    setSubmitted(true);
  };
  const errors = formState == null ? void 0 : formState.errors;
  return /* @__PURE__ */ jsx66("form", { className: src_components_tour_tourAccompanied_default.tourHeader, "data-isaccompanied": 1, onSubmit: handleSubmit(onSubmit), children: submitted ? /* @__PURE__ */ jsxs45(Fragment13, { children: [
    /* @__PURE__ */ jsx66(
      Button29,
      {
        iconOnly: true,
        inverted: true,
        theme: "gray",
        size: "xsmall",
        icon: "cancel",
        accent: "floating",
        onClick: onCloseModal,
        className: src_components_tour_tourAccompanied_default.closeButton,
        iconProps: {
          width: 12,
          height: 12
        }
      }
    ),
    /* @__PURE__ */ jsx66("h4", { children: "Merci !" }),
    /* @__PURE__ */ jsxs45("span", { children: [
      "Vous pouvez prendre rendez-vous avec nos accompagnateurs num\xE9riques pour d\xE9couvrir le Manuel Num\xE9rique",
      " ",
      /* @__PURE__ */ jsx66(Premium, { children: "Premium" }),
      " et poser toutes vos questions !"
    ] }),
    /* @__PURE__ */ jsx66("div", { className: src_components_tour_tourAccompanied_default.submitButton, children: /* @__PURE__ */ jsx66(
      Button29,
      {
        onClick: () => {
          openWindow13(windowUrl);
          dispatchAnalyticsEvent15(ANALYTICS_EVENTS.LINK_CLICKED, { featureName: "contact_support_step2" });
        },
        children: "Suivant"
      }
    ) })
  ] }) : /* @__PURE__ */ jsxs45(Fragment13, { children: [
    /* @__PURE__ */ jsxs45("h4", { children: [
      "Vous souhaitez \xEAtre accompagn\xE9 pour d\xE9couvrir le Manuel Num\xE9rique ",
      /* @__PURE__ */ jsx66(Premium, { children: "Premium" }),
      " ?"
    ] }),
    /* @__PURE__ */ jsx66("span", { children: "Compl\xE9tez vos coordonn\xE9es pour r\xE9server un cr\xE9neau dans notre agenda. Privil\xE9giez votre adresse mail acad\xE9mique si vous en avez une ! \u{1F642}" }),
    /* @__PURE__ */ jsxs45("div", { className: src_components_tour_tourAccompanied_default.accompaniedTour, children: [
      /* @__PURE__ */ jsxs45("div", { className: src_components_tour_tourAccompanied_default.inputs, children: [
        /* @__PURE__ */ jsx66(Firstname, { label: "Pr\xE9nom *", control, error: errors.firstname, className: src_components_tour_tourAccompanied_default.tourInput }),
        /* @__PURE__ */ jsx66(
          Lastname,
          {
            required: true,
            label: "Nom *",
            control,
            error: errors.lastname,
            className: src_components_tour_tourAccompanied_default.tourInput
          }
        ),
        /* @__PURE__ */ jsx66(Email, { label: "Adresse e-mail *", control, error: errors.email, className: src_components_tour_tourAccompanied_default.tourInput })
      ] }),
      /* @__PURE__ */ jsx66("div", { className: src_components_tour_tourAccompanied_default.accompaniedSuggestion, children: /* @__PURE__ */ jsxs45("span", { children: [
        /* @__PURE__ */ jsx66(RedAsterisk, {}),
        " Ces champs sont obligatoires. Aussi, nous vous sugg\xE9rons d'utiliser votre adresse e-mail acad\xE9mique."
      ] }) }),
      /* @__PURE__ */ jsxs45("div", { className: src_components_tour_tourAccompanied_default.newsletter, children: [
        /* @__PURE__ */ jsx66(CheckBox, { inverted: true, onChange: setChecked }),
        "Je ne souhaite pas recevoir la newsletter pour \xEAtre inform\xE9(e) des nouveaut\xE9s"
      ] }),
      /* @__PURE__ */ jsxs45("div", { className: src_components_tour_tourAccompanied_default.accompaniedButtons, children: [
        /* @__PURE__ */ jsx66(Button29, { onClick: onCloseModal, theme: "gray", children: "Non merci" }),
        /* @__PURE__ */ jsx66(Button29, { type: "submit", children: "Suivant" })
      ] })
    ] })
  ] }) });
};
var tourAccompanied_default = TourAccompanied;

// src/components/tour/tourPanel.jsx
init_constants();
init_trial2();
init_user2();
init_useCustomEffect();
init_useTour();
init_tour6();
init_tour3();
import { Button as Button30, CircularProgressBar, Icon as Icon6, Z_TOUR as Z_TOUR5 } from "@lls/lls-kit";
import { getToken as getToken9 } from "@lls/store";
import { getCurrentUser as getCurrentUser19 } from "@lls/store";
import { cx as cx5, openWindow as openWindow14 } from "@lls/utils";

// tmp_esbuild1736180049684/_src_components_tour_tourPanel.module.css
var src_components_tour_tourPanel_default = { "accompaniedSuggestion": "core-PwhM2a-accompaniedSuggestion", "progressBar": "core-PwhM2a-progressBar", "closeTourPanel": "core-PwhM2a-closeTourPanel", "tourPanelWrapper": "core-PwhM2a-tourPanelWrapper", "progressDisplay": "core-PwhM2a-progressDisplay", "tourHeader": "core-PwhM2a-tourHeader", "exitButton": "core-PwhM2a-exitButton", "textPercentage": "core-PwhM2a-textPercentage", "progress": "core-PwhM2a-progress", "tours": "core-PwhM2a-tours", "accompaniedButtons": "core-PwhM2a-accompaniedButtons", "animatedExpandIcon": "core-PwhM2a-animatedExpandIcon", "smallPanelWrapper": "core-PwhM2a-smallPanelWrapper", "completionMessage": "core-PwhM2a-completionMessage", "tourInput": "core-PwhM2a-tourInput", "tour": "core-PwhM2a-tour", "openTourPanel": "core-PwhM2a-openTourPanel", "expandButton": "core-PwhM2a-expandButton", "subtitle": "core-PwhM2a-subtitle", "circularProgressBar": "core-PwhM2a-circularProgressBar", "divider": "core-PwhM2a-divider", "accompaniedTour": "core-PwhM2a-accompaniedTour", "progressBarWrapper": "core-PwhM2a-progressBarWrapper", "tourPanel": "core-PwhM2a-tourPanel" };

// src/components/tour/tourPanel.jsx
import { Fragment as Fragment14, jsx as jsx67, jsxs as jsxs46 } from "react/jsx-runtime";
var TourProgressBar = ({ progress = 0 }) => /* @__PURE__ */ jsxs46("div", { className: src_components_tour_tourPanel_default.progressBarWrapper, children: [
  /* @__PURE__ */ jsx67("div", { className: src_components_tour_tourPanel_default.progressBar, children: /* @__PURE__ */ jsx67("div", { className: src_components_tour_tourPanel_default.progress, style: { "--c-progress": `${progress}%` } }) }),
  /* @__PURE__ */ jsxs46("div", { className: src_components_tour_tourPanel_default.textPercentage, children: [
    progress,
    "%"
  ] })
] });
var Tour3 = ({ tour: tour2, isCompleted, onTourClick = _59.noop }) => {
  const onClick = () => onTourClick(tour2 == null ? void 0 : tour2.id);
  return /* @__PURE__ */ jsx67(
    Button30,
    {
      className: src_components_tour_tourPanel_default.tour,
      icon: isCompleted ? "circlecheckmark" : "circle",
      "data-completed": +isCompleted,
      theme: "gray",
      accent: "floating",
      onClick,
      children: tour2.title
    }
  );
};
var Tours = ({ availableTours, onTourClick, completedTours }) => /* @__PURE__ */ jsx67("div", { className: src_components_tour_tourPanel_default.tours, children: _59.map(
  (tour2) => /* @__PURE__ */ jsx67(
    Tour3,
    {
      tour: tour2,
      onTourClick,
      isCompleted: hasUserCompletedTour(tour2 == null ? void 0 : tour2.id, completedTours)
    },
    tour2.id
  ),
  availableTours
) });
var AnimatedExpandIcon = ({ isExpanded, className, ...props }) => /* @__PURE__ */ jsx67(
  Icon6,
  {
    className: cx5(className, src_components_tour_tourPanel_default.animatedExpandIcon),
    name: "arrowright",
    "data-expanded": +isExpanded,
    ...props
  }
);
var TourPanel = () => {
  var _a2;
  const [isContactFormDisplayed, setIsContactFormDisplayed] = useState19(false);
  const isTourPanelOpen = useSelector29(getIsTourPanelOpen);
  const tourPanelMode = useSelector29(getTourPanelMode);
  const currentUser = useSelector29(getCurrentUser19);
  const token = useSelector29(getToken9);
  const [cookies] = useCookies([COOKIE_DONE_TOURS, COOKIE_TRIAL_JOURNEY]);
  const isAccompanied = (cookies == null ? void 0 : cookies[COOKIE_TRIAL_JOURNEY]) === JOURNEY_ACCOMPANIED;
  const { startTour, setIsTourPanelOpen: setIsTourPanelOpen2, tourId, resetTour: resetTour2, hasSessionPage, availableTours, bonusTour } = useTour_default();
  const completedTours = getCompletedTours(currentUser, cookies);
  const nbDoneTours = getNbDoneTours(_59.map("id", availableTours), completedTours);
  const nbTours = availableTours == null ? void 0 : availableTours.length;
  const progress = Math.ceil(nbDoneTours / nbTours * 100);
  const isTrial = currentUser == null ? void 0 : currentUser.isTrial;
  const hasCompletedContactForm = (_a2 = currentUser == null ? void 0 : currentUser.trialStats) == null ? void 0 : _a2.hasCompletedContactForm;
  const updateTrialUserStatsEffectFn = useCustomEffect_default(updateTrialUserStatsEffect);
  const onSubmitContactForm = useCallback28(
    (data) => {
      updateTrialUserStatsEffectFn({ trialStats: { ...data, hasCompletedContactForm: true }, token });
    },
    [updateTrialUserStatsEffectFn, token]
  );
  const onCloseContactForm = useCallback28(() => {
    updateTrialUserStatsEffectFn({ trialStats: { hasCompletedContactForm: true }, token });
    setIsContactFormDisplayed(false);
  }, [updateTrialUserStatsEffectFn, token]);
  useEffect21(() => {
    const timeoutId = setTimeout(
      () => {
        if (!hasCompletedContactForm && !tourId) {
          if (!isTrial) {
            setIsContactFormDisplayed(true);
          }
          setIsTourPanelOpen2(true);
        }
      },
      2.5 * 60 * 1e3
    );
    return () => clearTimeout(timeoutId);
  }, [hasCompletedContactForm, setIsTourPanelOpen2, tourId, isTrial]);
  const onCloseModal = () => setIsTourPanelOpen2(false);
  return /* @__PURE__ */ jsx67(
    "div",
    {
      className: src_components_tour_tourPanel_default.tourPanel,
      style: { "--c-z-tour": Z_TOUR5, "--c-small-tour-height": isAccompanied ? "46px" : "92px" },
      "data-expanded": +isTourPanelOpen,
      "data-contact-form-displayed": +isContactFormDisplayed,
      children: isContactFormDisplayed ? /* @__PURE__ */ jsx67("div", { className: src_components_tour_tourPanel_default.tourPanelWrapper, children: /* @__PURE__ */ jsx67(trialContactForm_default, { onSubmit: onSubmitContactForm, onClose: onCloseContactForm }) }) : !tourId ? /* @__PURE__ */ jsxs46(Fragment14, { children: [
        /* @__PURE__ */ jsxs46("div", { className: src_components_tour_tourPanel_default.smallPanelWrapper, children: [
          (isAccompanied && !isTourPanelOpen || !isAccompanied) && /* @__PURE__ */ jsx67(
            Button30,
            {
              className: src_components_tour_tourPanel_default.expandButton,
              AnimatedIcon: AnimatedExpandIcon,
              animatedIconProps: { isExpanded: isTourPanelOpen },
              size: "small",
              theme: "gray",
              accent: "floating",
              onClick: () => setIsTourPanelOpen2(!isTourPanelOpen),
              inverted: true
            }
          ),
          !isAccompanied && /* @__PURE__ */ jsx67(
            CircularProgressBar,
            {
              className: src_components_tour_tourPanel_default.circularProgressBar,
              variant: "determinate",
              progress,
              radius: 13,
              strokeRatio: 0.35,
              progressColor: "var(--premium-50-color)",
              bgColor: "var(--gray-60-color)",
              fontSize: "11px",
              children: /* @__PURE__ */ jsxs46("div", { className: src_components_tour_tourPanel_default.progressDisplay, children: [
                nbDoneTours,
                "/",
                nbTours
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ jsx67("div", { className: src_components_tour_tourPanel_default.tourPanelWrapper, children: isAccompanied && isTrial ? /* @__PURE__ */ jsx67(tourAccompanied_default, { onCloseModal }) : /* @__PURE__ */ jsxs46(Fragment14, { children: [
          /* @__PURE__ */ jsxs46("div", { className: src_components_tour_tourPanel_default.tourHeader, children: [
            tourPanelMode === "completed" ? /* @__PURE__ */ jsxs46(Fragment14, { children: [
              /* @__PURE__ */ jsx67("h4", { children: "F\xE9licitations !" }),
              /* @__PURE__ */ jsx67("span", { className: src_components_tour_tourPanel_default.completionMessage, children: "Vous avez compl\xE9t\xE9 tous les parcours ! Prenez rendez-vous avec notre \xE9quipe pour aller plus loin dans la d\xE9couverte. \u{1F929}" })
            ] }) : /* @__PURE__ */ jsxs46(Fragment14, { children: [
              /* @__PURE__ */ jsx67("h4", { children: "Parcours de d\xE9couverte" }),
              isTrial && /* @__PURE__ */ jsx67("span", { className: src_components_tour_tourPanel_default.subtitle, children: 'Tous les parcours de d\xE9couverte doivent \xEAtre r\xE9alis\xE9s dans la vue "Professeur".' })
            ] }),
            /* @__PURE__ */ jsx67(TourProgressBar, { progress, nbDoneTours, nbTours })
          ] }),
          /* @__PURE__ */ jsx67(
            Tours,
            {
              onTourClick: startTour,
              hasSessionPage,
              availableTours,
              bonusTour,
              progress,
              completedTours
            }
          ),
          tourId && isTourPanelOpen && /* @__PURE__ */ jsx67(Button30, { className: src_components_tour_tourPanel_default.exitButton, onClick: () => resetTour2(), accent: "alt", children: "Arr\xEAter le parcours en cours" }),
          tourPanelMode === "completed" && /* @__PURE__ */ jsx67(
            Button30,
            {
              accent: "alt",
              className: src_components_tour_tourPanel_default.exitButton,
              href: CALENDLY_LINK,
              target: "_blanK",
              onGoTo: ({ href, target }) => openWindow14(href, target),
              children: "Prendre rendez-vous"
            }
          )
        ] }) })
      ] }) : null
    }
  );
};
var tourPanel_default = TourPanel;

// src/components/tour/index.jsx
init_constants();
init_constants();
init_modal();
init_tour6();
init_ui2();
init_store();
init_tour3();
init_es62();
import { getCurrentUser as getCurrentUser20 } from "@lls/store";

// tmp_esbuild1736180049684/_src_components_tour_index.module.css
var src_components_tour_index_default = { "container": "core-R86toq-container" };

// src/components/tour/index.jsx
import { jsx as jsx68, jsxs as jsxs47 } from "react/jsx-runtime";
var Tour4 = () => {
  const user = useSelector30(getCurrentUser20);
  const [cookies] = useCookies([COOKIE_TRIAL_JOURNEY]);
  const isStudentViewActivated = useSelector30(getUiIsStudentViewActivated);
  const { pathname } = useLocation13();
  const journeyCookie = cookies == null ? void 0 : cookies[COOKIE_TRIAL_JOURNEY];
  const scenarioId = useMySelector(getCurrentScenarioId);
  const isModalOpen = useSelector30(
    _60.flow(
      getOpenModal,
      _60.get("name"),
      (name) => _60.includes(name, [
        MODAL_ONBOARDING_CHOOSE_PROFILE,
        MODAL_ONBOARDING_CHOOSE_TOUR,
        MODAL_TOURS_COMPLETED,
        MODAL_ONBOARDING_END,
        MODAL_ONBOARDING_EXPERT,
        MODAL_ONBOARDING_ASK_FOR_TRAINING,
        MODAL_ONBOARDING_TRAINING_CONFIRMATION,
        MODAL_ONBOARDING_TRAINING_BOOKING
      ])
    )
  );
  return shouldDisplayTours({ user, pathname, isStudentViewActivated, journeyCookie, scenarioId, isModalOpen }) ? /* @__PURE__ */ jsxs47("div", { className: src_components_tour_index_default.container, children: [
    /* @__PURE__ */ jsx68(tourPanel_default, { user }),
    /* @__PURE__ */ jsx68(tourController_default, {})
  ] }) : null;
};
var tour_default2 = Tour4;

// src/app.jsx
init_constants();

// src/routes.js
init_constants();

// src/hocs/withFetcher.jsx
init_fetch();
init_loading3();
init_es62();
import { getScreenLoadingEventName as getScreenLoadingEventName4, hasWindowObject as hasWindowObject7 } from "@lls/utils";
import { Suspense as Suspense2, useCallback as useCallback29, useRef as useRef12 } from "react";
import { useDispatch as useDispatch20, useSelector as useSelector32 } from "react-redux";
import { jsx as jsx69 } from "react/jsx-runtime";
var wrap = (promise) => {
  let status = "pending";
  let response;
  const suspender = promise.then(
    (res) => {
      status = "success";
      response = res;
    },
    (err) => {
      status = "error";
      response = err;
    }
  );
  const read = () => {
    switch (status) {
      case "pending": {
        throw suspender;
      }
      case "error": {
        throw response;
      }
      default: {
        return response;
      }
    }
  };
  return { read };
};
var withFetcher = (Component2) => {
  if (hasWindowObject7()) {
    return (props) => /* @__PURE__ */ jsx69(Suspense2, { children: /* @__PURE__ */ jsx69(Component2, { ...props }) });
  }
  return (props) => {
    const dispatch = useDispatch20();
    const [cookies] = useCookies();
    const initialState5 = useSelector32((state) => state);
    const initialStateRef = useRef12(initialState5);
    const ref = useRef12();
    const ssrFetcher = useCallback29(
      (singleOrMultiFetchOptions) => {
        if (!ref.current) {
          const { screen, params, seq: seq5 } = singleOrMultiFetchOptions;
          const screenEvent = getScreenLoadingEventName4(screen, params);
          const initialState6 = initialStateRef.current;
          const loading2 = getLoadingStatus(initialState6, screen, params);
          ref.current = wrap(
            seq5 ? multiFetch({ dispatch, cookies, screenEvent, loading: loading2, initialState: initialState6, ...singleOrMultiFetchOptions }) : singleFetch({ loading: loading2, dispatch, ...singleOrMultiFetchOptions })
          );
        }
        ref.current.read();
      },
      [dispatch, cookies]
    );
    return /* @__PURE__ */ jsx69(Suspense2, { children: /* @__PURE__ */ jsx69(Component2, { ...props, ssrFetcher }) });
  };
};
var withFetcher_default = withFetcher;

// src/hocs/withRedirect.jsx
init_route();
import { getCurrentUser as getCurrentUser21, useSearchPages as useSearchPages4 } from "@lls/store";
import { getQueryParams as getQueryParams3, hasWindowObject as hasWindowObject8 } from "@lls/utils";
import _64 from "lodash/fp.js";
import { useSelector as useSelector33 } from "react-redux";
import { Redirect } from "react-router-dom";
import { jsx as jsx70 } from "react/jsx-runtime";
var withRedirect = (Component2) => {
  return process.env.CORE_MANAGED_AUTH === "1" ? Component2 : (props) => {
    var _a2;
    const match = _64.get("match.path", props);
    const user = useSelector33(getCurrentUser21);
    const pageId = _64.get("match.params.pageId", props);
    const slug = `page/${pageId}`;
    const query = getQueryParams3(props == null ? void 0 : props.location);
    const page = (_a2 = useSearchPages4({ slugs: [slug], hasNewDesign: true })) == null ? void 0 : _a2[0];
    if (hasWindowObject8() && _64.isEmpty(user)) {
      if (shouldRedirectToConnect({ page, match })) {
        return redirectToConnect();
      }
    }
    return _64.isEmpty(user) && _64.isEqual("/page/:pageId", match) ? /* @__PURE__ */ jsx70(Redirect, { to: getPath("readonly", { slug, query }) }) : /* @__PURE__ */ jsx70(Component2, { ...props });
  };
};
var withRedirect_default = withRedirect;

// src/routes.js
init_withRouterProvider();
init_route();
init_withRouterProvider();
import _161 from "lodash/fp.js";
import { createElement as createElement4, lazy, useEffect as useEffect59 } from "react";
var lazyload = (importFn) => {
  const wrap2 = (loadComponent) => {
    return lazy(async () => {
      const promise = loadComponent();
      const Component2 = promise instanceof Promise ? await promise : { default: promise };
      const RouteComponent = ({ isNextRoute, onReady, ...props }) => {
        useEffect59(() => {
          isNextRoute && onReady();
        }, [isNextRoute, onReady]);
        return createElement4(Component2.default, { ...props, isNextRoute });
      };
      return { default: RouteComponent };
    });
  };
  return wrap2(importFn);
};
var routes = [
  {
    path: "/",
    component: withPreviousLocation(lazyload(() => Promise.resolve().then(() => (init_home5(), home_exports)))),
    exact: true
  },
  {
    path: "/profil",
    component: lazyload(() => Promise.resolve().then(() => (init_profile3(), profile_exports))),
    exact: true
  },
  {
    path: "/mesmanuels",
    component: lazyload(() => Promise.resolve().then(() => (init_mybooks3(), mybooks_exports))),
    exact: true
  },
  {
    path: ["/manuels/:bookUri", "/manuel/:bookUri", "/books/:bookId", "/book/:bookId"],
    component: withPreviousLocation(lazyload(() => Promise.resolve().then(() => (init_book7(), book_exports)))),
    exact: true,
    redirect: redirectBookIdToUri
  },
  {
    path: ["/books/:bookId"],
    component: withPreviousLocation(lazyload(() => Promise.resolve().then(() => (init_book7(), book_exports)))),
    exact: true,
    redirect: redirectOldBooks
  },
  {
    path: ["/panorama/:bookId/:chapterId"],
    component: lazyload(() => Promise.resolve().then(() => (init_panorama4(), panorama_exports))),
    exact: true
  },
  {
    path: ["/manuels/:bookUri/page-creation"],
    component: lazyload(() => Promise.resolve().then(() => (init_createPage(), createPage_exports))),
    exact: true
  },
  {
    path: ["/page/:pageId"],
    component: withAppData(lazyload(() => Promise.resolve().then(() => (init_page5(), page_exports)))),
    exact: true,
    redirect: redirectOldBooks
  },
  {
    path: ["/page/:pageId/student/:studentId"],
    component: withAppData(lazyload(() => Promise.resolve().then(() => (init_workplanStudentPage(), workplanStudentPage_exports)))),
    exact: true
  },
  {
    path: ["/readonly/page/:pageId"],
    component: lazyload(() => Promise.resolve().then(() => (init_readonly2(), readonly_exports))),
    exact: true
  },
  {
    path: "/reponses/:parentId",
    component: lazyload(() => Promise.resolve().then(() => (init_copies2(), copies_exports))),
    exact: true
  },
  {
    path: "/mesclasses",
    component: lazyload(() => Promise.resolve().then(() => (init_classroom3(), classroom_exports))),
    exact: true
  },
  {
    path: "/mesclasses/add/:step",
    component: lazyload(() => Promise.resolve().then(() => (init_classroom3(), classroom_exports))),
    exact: true
  },
  {
    path: "/mesclasses/:classroomId",
    component: lazyload(() => Promise.resolve().then(() => (init_classroom3(), classroom_exports))),
    exact: true
  },
  {
    path: "/reponses/:parentId/reponse/:copyId",
    component: lazyload(() => Promise.resolve().then(() => (init_copy2(), copy_exports))),
    exact: true
  },
  {
    path: "/reponses/:parentId/groupe/:groupId",
    component: lazyload(() => Promise.resolve().then(() => (init_shareCorrections2(), shareCorrections_exports))),
    exact: true
  },
  {
    path: "/reponses/:parentId/students",
    component: lazyload(() => Promise.resolve().then(() => (init_shareCorrectionsStudents2(), shareCorrectionsStudents_exports))),
    exact: true
  },
  {
    path: [
      `/outils/:tool(${TOOL_PYTHON}|${TOOL_RECORDER}|${TOOL_ORAL}|${TOOL_ARDUINO}|${TOOL_WHO_FRENCH}|${TOOL_WHO_SPANISH}|${TOOL_WHO_HG}|${TOOL_WHO_ENGLISH}|${TOOL_WHO_SCIENCE})`
    ],
    component: lazyload(() => Promise.resolve().then(() => (init_marketingViewer2(), marketingViewer_exports))),
    exact: true
  },
  {
    path: ["/revision"],
    component: lazyload(() => Promise.resolve().then(() => (init_revision3(), revision_exports))),
    exact: true
  },
  {
    path: ["/revision/:bookUri"],
    component: lazyload(() => Promise.resolve().then(() => (init_revisionBook2(), revisionBook_exports))),
    exact: true
  },
  {
    path: ["/page-revision/page/:pageId"],
    component: lazyload(() => Promise.resolve().then(() => (init_revisionPage(), revisionPage_exports))),
    exact: true
  },
  {
    path: `/${TOOL_PYTHON}`,
    redirect: `/outils/${TOOL_PYTHON}`,
    exact: true
  },
  {
    path: `/${TOOL_RECORDER}`,
    redirect: `/outils/${TOOL_RECORDER}`,
    exact: true
  },
  {
    path: `/${TOOL_ORAL}`,
    redirect: `/outils/${TOOL_ORAL}`,
    exact: true
  },
  {
    path: `/${TOOL_ARDUINO}`,
    redirect: `/outils/${TOOL_ARDUINO}`,
    exact: true
  },
  {
    path: `/${TOOL_WHO_SCIENCE}`,
    redirect: `outils/${TOOL_WHO_SCIENCE}`,
    exact: true
  },
  {
    path: `/${TOOL_WHO_FRENCH}`,
    redirect: `outils/${TOOL_WHO_FRENCH}`,
    exact: true
  },
  {
    path: `/${TOOL_WHO_SPANISH}`,
    redirect: `outils/${TOOL_WHO_SPANISH}`,
    exact: true
  },
  {
    path: `/${TOOL_WHO_HG}`,
    redirect: `outils/${TOOL_WHO_HG}`,
    exact: true
  },
  {
    path: `/${TOOL_WHO_ENGLISH}`,
    redirect: `outils/${TOOL_WHO_ENGLISH}`,
    exact: true
  },
  {
    path: ["/applications"],
    redirect: redirectFrontApplications,
    exact: true
  },
  {
    path: ["/codes/:code/classroom"],
    component: lazyload(() => Promise.resolve().then(() => (init_codeClassroom(), codeClassroom_exports))),
    exact: true
  },
  {
    path: ["/suivi-des-acquis"],
    component: lazyload(() => Promise.resolve().then(() => (init_learningAssessment(), learningAssessment_exports))),
    exact: true
  },
  {
    path: ["/suivi-des-acquis/step/:step"],
    component: lazyload(() => Promise.resolve().then(() => (init_learningAssessment(), learningAssessment_exports))),
    exact: true
  },
  {
    path: ["/lien-externe"],
    component: lazyload(() => Promise.resolve().then(() => (init_externalLink2(), externalLink_exports))),
    exact: true
  },
  {
    path: ["*", "/notFound"],
    component: lazyload(() => Promise.resolve().then(() => (init_notfound(), notfound_exports))),
    exact: false
  }
];
var routes_default = _161.flow(
  _161.compact,
  _161.map(({ component, ...route }) => ({
    ...route,
    component: component ? withRedirect_default(withFetcher_default(component)) : component
  }))
)(routes);

// src/app.jsx
init_style();
init_es62();
import { styleThemeProps } from "@lls/lls-kit";
import { cx as cx9 } from "@lls/utils";
import _162 from "lodash/fp.js";

// tmp_esbuild1736180049684/_src_app.module.css
var src_app_default = { "accessibilityElement": "core-2J79SW-accessibilityElement kit-themecss" };

// src/app.jsx
import { jsx as jsx148, jsxs as jsxs106 } from "react/jsx-runtime";
var DEFAULT_APP_DATA = {
  enableNavbar: true,
  isOffline: false,
  licensedBookIds: void 0,
  // send empty array if you don't have license and still want license to be checked
  onUnlockApplication: _162.noop,
  teaserMode: false,
  isTouchable: false,
  fetchCustomPagesAfter: void 0
};
var App = ({ appData = DEFAULT_APP_DATA, cookies } = {}) => {
  return /* @__PURE__ */ jsx148(
    "div",
    {
      className: cx9(getLightClassNames(), src_app_default.accessibilityElement),
      style: styleThemeProps({ isDysMode: false, sizeIndex: 2 }),
      children: /* @__PURE__ */ jsx148(RouterProvider, { appData, children: /* @__PURE__ */ jsxs106(CookiesProvider_default, { cookies, children: [
        /* @__PURE__ */ jsx148(static_default, {}),
        /* @__PURE__ */ jsx148(ScrollToTop, {}),
        /* @__PURE__ */ jsx148(loading_default2, { screen: SCREEN_GLOBAL }),
        /* @__PURE__ */ jsx148(modal_default, {}),
        /* @__PURE__ */ jsx148(notification_default, {}),
        /* @__PURE__ */ jsx148(clarity_default, {}),
        appData.enableNavbar && /* @__PURE__ */ jsx148(navbar_default, {}),
        /* @__PURE__ */ jsx148(tour_default2, {}),
        /* @__PURE__ */ jsx148(lazySwitch_default, { routes: routes_default }),
        /* @__PURE__ */ jsx148(cookies_default, {}),
        /* @__PURE__ */ jsx148(trialWelcomeModal_default, {}),
        /* @__PURE__ */ jsx148(crisp_default, {}),
        /* @__PURE__ */ jsx148(Analytics, {}),
        process.env.CORE_MANAGED_ANALYTICS !== "1" && /* @__PURE__ */ jsx148(LlsAnalytics, {})
      ] }) })
    }
  );
};
App.displayName = "App";
var app_default = App;

// src/index.jsx
init_es62();

// src/hooks/useUserFromToken.ts
init_actions();
init_user();

// src/utils/auth.ts
import _163 from "lodash/fp.js";
var buildAuth = (user, token) => ({
  ..._163.pick(["id", "role", "isPremium", "username", "isStudent", "isTeacher"], user),
  token,
  userPages: _163.flow(_163.get("userPages"), _163.map("id"))(user)
});

// src/hooks/useUserFromToken.ts
import _164 from "lodash/fp.js";
import { useEffect as useEffect60, useState as useState45 } from "react";
import { useDispatch as useDispatch51 } from "react-redux";
var loadUser = async (dispatch, token) => {
  if (token === null) return dispatch(resetAuth());
  if (!token) return;
  const data = await fetchMobileUser({ token });
  const entities2 = _164.get("entities", data);
  const userId = _164.get("result.viewer.me", data);
  const user = _164.flow(_164.get("users"), _164.find({ id: userId }))(entities2);
  const auth2 = buildAuth(user, token);
  dispatch(setEntities(entities2));
  dispatch(setAuth(auth2));
  return user;
};
var useUserFromToken = (token) => {
  const dispatch = useDispatch51();
  const [ready, setReady] = useState45(false);
  useEffect60(() => {
    const fn = async () => {
      try {
        await loadUser(dispatch, token);
      } catch (_e) {
      } finally {
        setReady(true);
      }
    };
    fn();
  }, [dispatch, token]);
  return ready;
};
var useUserFromToken_default = useUserFromToken;

// src/hooks/useSyncDrafts.js
init_page2();
init_useCustomEffect();
var import_shallowequal = __toESM(require_shallowequal(), 1);
import _165 from "lodash/fp.js";
import { useEffect as useEffect61, useState as useState46 } from "react";
import { useSelector as useSelector77 } from "react-redux";
import { getAuth as getAuth26 } from "@lls/store";
import { useSearchDrafts as useSearchDrafts3 } from "@lls/store";
import { getCurrentUser as getCurrentUser46 } from "@lls/store";
var useSyncDrafts = ({ isOffline = false, ready } = {}) => {
  const [synced, setSynced] = useState46(false);
  const savePageEffectFn = useCustomEffect_default(savePageEffect);
  const drafts = useSearchDrafts3({ isCreatedFromScratch: false });
  const { currentUser, token } = useSelector77(
    (state) => {
      var _a2;
      return {
        currentUser: getCurrentUser46(state),
        token: (_a2 = getAuth26(state)) == null ? void 0 : _a2.token
      };
    },
    import_shallowequal.default
  );
  useEffect61(() => {
    if (synced || !ready) {
      return;
    }
    if (!token || isOffline) {
      setSynced(true);
      return;
    }
    const fn = async () => {
      for (const draftBulk of _165.chunk(5, drafts)) {
        await Promise.all(
          _165.map((page) => savePageEffectFn({ title: page == null ? void 0 : page.title, page, token, currentUser, background: true }), draftBulk)
        );
      }
      setSynced(true);
    };
    fn();
  }, [ready, synced, drafts, savePageEffectFn, token, currentUser, isOffline]);
  return synced;
};
var useSyncDrafts_default = useSyncDrafts;

// src/index.jsx
init_constants();

// src/utils/api.js
init_config();
import _166 from "lodash/fp.js";
var shouldDisableCache = (query) => _166.overSome([_166.hasIn("nocache"), () => _166.get("env", config_default) === "preprod"])(query);

// src/index.jsx
init_route();
init_config();
export {
  COOKIE_JWT_TOKEN,
  Cookies_default2 as Cookies,
  app_default as Core,
  config_default as config,
  loadUser,
  redirectBookIdToUri,
  redirectOldBooks,
  rootReducer_exports as reducers,
  routes_default as routes,
  serverRedirectUser,
  shouldDisableCache,
  useSyncDrafts_default as useSyncDrafts,
  useUserFromToken_default as useUserFromToken
};
/*! Bundled license information:

cookie/index.js:
  (*!
   * cookie
   * Copyright(c) 2012-2014 Roman Shtylman
   * Copyright(c) 2015 Douglas Christopher Wilson
   * MIT Licensed
   *)
*/
